/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const Cs = { ROTATE: 0, DOLLY: 1, PAN: 2 }, bs = { ROTATE: 0, PAN: 1, DOLLY_PAN: 2, DOLLY_ROTATE: 3 }, xd = 0, Sc = 1, vd = 2, gh = 1, yd = 2, oi = 3, gi = 0, an = 1, In = 2, Pi = 0, Ps = 1, Mc = 2, bc = 3, Ec = 4, Sd = 5, ji = 100, Md = 101, bd = 102, Ed = 103, Td = 104, Ad = 200, wd = 201, Rd = 202, Cd = 203, Fo = 204, Oo = 205, Pd = 206, Ld = 207, Id = 208, Dd = 209, Nd = 210, Ud = 211, Fd = 212, Od = 213, Bd = 214, Bo = 0, ko = 1, zo = 2, Ds = 3, Ho = 4, Vo = 5, Go = 6, Wo = 7, _h = 0, kd = 1, zd = 2, Li = 0, Hd = 1, Vd = 2, Gd = 3, xh = 4, Wd = 5, Xd = 6, qd = 7, Tc = "attached", Yd = "detached", vh = 300, Ns = 301, Us = 302, Sa = 303, Xo = 304, Pa = 306, Fs = 1e3, Vn = 1001, Ma = 1002, en = 1003, yh = 1004, ur = 1005, Vt = 1006, da = 1007, Gn = 1008, _i = 1009, Sh = 1010, Mh = 1011, _r = 1012, Dl = 1013, Ii = 1014, hn = 1015, Wn = 1016, Nl = 1017, Ul = 1018, xr = 1020, bh = 35902, Eh = 1021, Th = 1022, mn = 1023, Ah = 1024, wh = 1025, vr = 1026, yr = 1027, Fl = 1028, Ol = 1029, Rh = 1030, Bl = 1031, kl = 1033, fa = 33776, pa = 33777, ma = 33778, ga = 33779, qo = 35840, Yo = 35841, jo = 35842, Ko = 35843, Zo = 36196, $o = 37492, Jo = 37496, Qo = 37808, el = 37809, tl = 37810, nl = 37811, il = 37812, sl = 37813, rl = 37814, al = 37815, ol = 37816, ll = 37817, cl = 37818, ul = 37819, hl = 37820, dl = 37821, _a = 36492, fl = 36494, pl = 36495, Ch = 36283, ml = 36284, gl = 36285, _l = 36286, Ph = 2200, jd = 2201, Kd = 2202, Sr = 2300, Mr = 2301, Ba = 2302, Es = 2400, Ts = 2401, ba = 2402, zl = 2500, Zd = 2501, $d = 0, Lh = 1, xl = 2, Jd = 3200, Qd = 3201, Ih = 0, ef = 1, Ri = "", Dt = "srgb", Zt = "srgb-linear", Ea = "linear", vt = "srgb", ns = 7680, Ac = 519, tf = 512, nf = 513, sf = 514, Dh = 515, rf = 516, af = 517, of = 518, lf = 519, vl = 35044, wc = "300 es", ui = 2e3, Ta = 2001;
class Ui {
  /**
   * Adds the given event listener to the given event type.
   *
   * @param {string} type - The type of event to listen to.
   * @param {Function} listener - The function that gets called when the event is fired.
   */
  addEventListener(e, t) {
    this._listeners === void 0 && (this._listeners = {});
    const n = this._listeners;
    n[e] === void 0 && (n[e] = []), n[e].indexOf(t) === -1 && n[e].push(t);
  }
  /**
   * Returns `true` if the given event listener has been added to the given event type.
   *
   * @param {string} type - The type of event.
   * @param {Function} listener - The listener to check.
   * @return {boolean} Whether the given event listener has been added to the given event type.
   */
  hasEventListener(e, t) {
    const n = this._listeners;
    return n === void 0 ? !1 : n[e] !== void 0 && n[e].indexOf(t) !== -1;
  }
  /**
   * Removes the given event listener from the given event type.
   *
   * @param {string} type - The type of event.
   * @param {Function} listener - The listener to remove.
   */
  removeEventListener(e, t) {
    const n = this._listeners;
    if (n === void 0) return;
    const i = n[e];
    if (i !== void 0) {
      const r = i.indexOf(t);
      r !== -1 && i.splice(r, 1);
    }
  }
  /**
   * Dispatches an event object.
   *
   * @param {Object} event - The event that gets fired.
   */
  dispatchEvent(e) {
    const t = this._listeners;
    if (t === void 0) return;
    const n = t[e.type];
    if (n !== void 0) {
      e.target = this;
      const i = n.slice(0);
      for (let r = 0, a = i.length; r < a; r++)
        i[r].call(this, e);
      e.target = null;
    }
  }
}
const Jt = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "0a", "0b", "0c", "0d", "0e", "0f", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "1a", "1b", "1c", "1d", "1e", "1f", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "2a", "2b", "2c", "2d", "2e", "2f", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "3a", "3b", "3c", "3d", "3e", "3f", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "4a", "4b", "4c", "4d", "4e", "4f", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "5a", "5b", "5c", "5d", "5e", "5f", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "6a", "6b", "6c", "6d", "6e", "6f", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "7a", "7b", "7c", "7d", "7e", "7f", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "8a", "8b", "8c", "8d", "8e", "8f", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "9a", "9b", "9c", "9d", "9e", "9f", "a0", "a1", "a2", "a3", "a4", "a5", "a6", "a7", "a8", "a9", "aa", "ab", "ac", "ad", "ae", "af", "b0", "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8", "b9", "ba", "bb", "bc", "bd", "be", "bf", "c0", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "ca", "cb", "cc", "cd", "ce", "cf", "d0", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "da", "db", "dc", "dd", "de", "df", "e0", "e1", "e2", "e3", "e4", "e5", "e6", "e7", "e8", "e9", "ea", "eb", "ec", "ed", "ee", "ef", "f0", "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "fa", "fb", "fc", "fd", "fe", "ff"];
let Rc = 1234567;
const pr = Math.PI / 180, Os = 180 / Math.PI;
function Un() {
  const s = Math.random() * 4294967295 | 0, e = Math.random() * 4294967295 | 0, t = Math.random() * 4294967295 | 0, n = Math.random() * 4294967295 | 0;
  return (Jt[s & 255] + Jt[s >> 8 & 255] + Jt[s >> 16 & 255] + Jt[s >> 24 & 255] + "-" + Jt[e & 255] + Jt[e >> 8 & 255] + "-" + Jt[e >> 16 & 15 | 64] + Jt[e >> 24 & 255] + "-" + Jt[t & 63 | 128] + Jt[t >> 8 & 255] + "-" + Jt[t >> 16 & 255] + Jt[t >> 24 & 255] + Jt[n & 255] + Jt[n >> 8 & 255] + Jt[n >> 16 & 255] + Jt[n >> 24 & 255]).toLowerCase();
}
function Ze(s, e, t) {
  return Math.max(e, Math.min(t, s));
}
function Hl(s, e) {
  return (s % e + e) % e;
}
function cf(s, e, t, n, i) {
  return n + (s - e) * (i - n) / (t - e);
}
function uf(s, e, t) {
  return s !== e ? (t - s) / (e - s) : 0;
}
function mr(s, e, t) {
  return (1 - t) * s + t * e;
}
function hf(s, e, t, n) {
  return mr(s, e, 1 - Math.exp(-t * n));
}
function df(s, e = 1) {
  return e - Math.abs(Hl(s, e * 2) - e);
}
function ff(s, e, t) {
  return s <= e ? 0 : s >= t ? 1 : (s = (s - e) / (t - e), s * s * (3 - 2 * s));
}
function pf(s, e, t) {
  return s <= e ? 0 : s >= t ? 1 : (s = (s - e) / (t - e), s * s * s * (s * (s * 6 - 15) + 10));
}
function mf(s, e) {
  return s + Math.floor(Math.random() * (e - s + 1));
}
function gf(s, e) {
  return s + Math.random() * (e - s);
}
function _f(s) {
  return s * (0.5 - Math.random());
}
function xf(s) {
  s !== void 0 && (Rc = s);
  let e = Rc += 1831565813;
  return e = Math.imul(e ^ e >>> 15, e | 1), e ^= e + Math.imul(e ^ e >>> 7, e | 61), ((e ^ e >>> 14) >>> 0) / 4294967296;
}
function vf(s) {
  return s * pr;
}
function yf(s) {
  return s * Os;
}
function Sf(s) {
  return (s & s - 1) === 0 && s !== 0;
}
function Mf(s) {
  return Math.pow(2, Math.ceil(Math.log(s) / Math.LN2));
}
function bf(s) {
  return Math.pow(2, Math.floor(Math.log(s) / Math.LN2));
}
function Ef(s, e, t, n, i) {
  const r = Math.cos, a = Math.sin, o = r(t / 2), l = a(t / 2), c = r((e + n) / 2), u = a((e + n) / 2), h = r((e - n) / 2), d = a((e - n) / 2), f = r((n - e) / 2), m = a((n - e) / 2);
  switch (i) {
    case "XYX":
      s.set(o * u, l * h, l * d, o * c);
      break;
    case "YZY":
      s.set(l * d, o * u, l * h, o * c);
      break;
    case "ZXZ":
      s.set(l * h, l * d, o * u, o * c);
      break;
    case "XZX":
      s.set(o * u, l * m, l * f, o * c);
      break;
    case "YXY":
      s.set(l * f, o * u, l * m, o * c);
      break;
    case "ZYZ":
      s.set(l * m, l * f, o * u, o * c);
      break;
    default:
      console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + i);
  }
}
function Dn(s, e) {
  switch (e.constructor) {
    case Float32Array:
      return s;
    case Uint32Array:
      return s / 4294967295;
    case Uint16Array:
      return s / 65535;
    case Uint8Array:
      return s / 255;
    case Int32Array:
      return Math.max(s / 2147483647, -1);
    case Int16Array:
      return Math.max(s / 32767, -1);
    case Int8Array:
      return Math.max(s / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
function _t(s, e) {
  switch (e.constructor) {
    case Float32Array:
      return s;
    case Uint32Array:
      return Math.round(s * 4294967295);
    case Uint16Array:
      return Math.round(s * 65535);
    case Uint8Array:
      return Math.round(s * 255);
    case Int32Array:
      return Math.round(s * 2147483647);
    case Int16Array:
      return Math.round(s * 32767);
    case Int8Array:
      return Math.round(s * 127);
    default:
      throw new Error("Invalid component type.");
  }
}
const Vl = {
  DEG2RAD: pr,
  RAD2DEG: Os,
  /**
   * Generate a [UUID]{@link https://en.wikipedia.org/wiki/Universally_unique_identifier}
   * (universally unique identifier).
   *
   * @static
   * @method
   * @return {string} The UUID.
   */
  generateUUID: Un,
  /**
   * Clamps the given value between min and max.
   *
   * @static
   * @method
   * @param {number} value - The value to clamp.
   * @param {number} min - The min value.
   * @param {number} max - The max value.
   * @return {number} The clamped value.
   */
  clamp: Ze,
  /**
   * Computes the Euclidean modulo of the given parameters that
   * is `( ( n % m ) + m ) % m`.
   *
   * @static
   * @method
   * @param {number} n - The first parameter.
   * @param {number} m - The second parameter.
   * @return {number} The Euclidean modulo.
   */
  euclideanModulo: Hl,
  /**
   * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
   * for the given value.
   *
   * @static
   * @method
   * @param {number} x - The value to be mapped.
   * @param {number} a1 - Minimum value for range A.
   * @param {number} a2 - Maximum value for range A.
   * @param {number} b1 - Minimum value for range B.
   * @param {number} b2 - Maximum value for range B.
   * @return {number} The mapped value.
   */
  mapLinear: cf,
  /**
   * Returns the percentage in the closed interval `[0, 1]` of the given value
   * between the start and end point.
   *
   * @static
   * @method
   * @param {number} x - The start point
   * @param {number} y - The end point.
   * @param {number} value - A value between start and end.
   * @return {number} The interpolation factor.
   */
  inverseLerp: uf,
  /**
   * Returns a value linearly interpolated from two known points based on the given interval -
   * `t = 0` will return `x` and `t = 1` will return `y`.
   *
   * @static
   * @method
   * @param {number} x - The start point
   * @param {number} y - The end point.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {number} The interpolated value.
   */
  lerp: mr,
  /**
   * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
   * time to maintain frame rate independent movement. For details, see
   * [Frame rate independent damping using lerp]{@link http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/}.
   *
   * @static
   * @method
   * @param {number} x - The current point.
   * @param {number} y - The target point.
   * @param {number} lambda - A higher lambda value will make the movement more sudden,
   * and a lower value will make the movement more gradual.
   * @param {number} dt - Delta time in seconds.
   * @return {number} The interpolated value.
   */
  damp: hf,
  /**
   * Returns a value that alternates between `0` and the given `length` parameter.
   *
   * @static
   * @method
   * @param {number} x - The value to pingpong.
   * @param {number} [length=1] - The positive value the function will pingpong to.
   * @return {number} The alternated value.
   */
  pingpong: df,
  /**
   * Returns a value in the range `[0,1]` that represents the percentage that `x` has
   * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
   * the `min` and `max`.
   *
   * See [Smoothstep]{@link http://en.wikipedia.org/wiki/Smoothstep} for more details.
   *
   * @static
   * @method
   * @param {number} x - The value to evaluate based on its position between min and max.
   * @param {number} min - The min value. Any x value below min will be `0`.
   * @param {number} max - The max value. Any x value above max will be `1`.
   * @return {number} The alternated value.
   */
  smoothstep: ff,
  /**
   * A [variation on smoothstep]{@link https://en.wikipedia.org/wiki/Smoothstep#Variations}
   * that has zero 1st and 2nd order derivatives at x=0 and x=1.
   *
   * @static
   * @method
   * @param {number} x - The value to evaluate based on its position between min and max.
   * @param {number} min - The min value. Any x value below min will be `0`.
   * @param {number} max - The max value. Any x value above max will be `1`.
   * @return {number} The alternated value.
   */
  smootherstep: pf,
  /**
   * Returns a random integer from `<low, high>` interval.
   *
   * @static
   * @method
   * @param {number} low - The lower value boundary.
   * @param {number} high - The upper value boundary
   * @return {number} A random integer.
   */
  randInt: mf,
  /**
   * Returns a random float from `<low, high>` interval.
   *
   * @static
   * @method
   * @param {number} low - The lower value boundary.
   * @param {number} high - The upper value boundary
   * @return {number} A random float.
   */
  randFloat: gf,
  /**
   * Returns a random integer from `<-range/2, range/2>` interval.
   *
   * @static
   * @method
   * @param {number} range - Defines the value range.
   * @return {number} A random float.
   */
  randFloatSpread: _f,
  /**
   * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
   *
   * @static
   * @method
   * @param {number} [s] - The integer seed.
   * @return {number} A random float.
   */
  seededRandom: xf,
  /**
   * Converts degrees to radians.
   *
   * @static
   * @method
   * @param {number} degrees - A value in degrees.
   * @return {number} The converted value in radians.
   */
  degToRad: vf,
  /**
   * Converts radians to degrees.
   *
   * @static
   * @method
   * @param {number} radians - A value in radians.
   * @return {number} The converted value in degrees.
   */
  radToDeg: yf,
  /**
   * Returns `true` if the given number is a power of two.
   *
   * @static
   * @method
   * @param {number} value - The value to check.
   * @return {boolean} Whether the given number is a power of two or not.
   */
  isPowerOfTwo: Sf,
  /**
   * Returns the smallest power of two that is greater than or equal to the given number.
   *
   * @static
   * @method
   * @param {number} value - The value to find a POT for.
   * @return {number} The smallest power of two that is greater than or equal to the given number.
   */
  ceilPowerOfTwo: Mf,
  /**
   * Returns the largest power of two that is less than or equal to the given number.
   *
   * @static
   * @method
   * @param {number} value - The value to find a POT for.
   * @return {number} The largest power of two that is less than or equal to the given number.
   */
  floorPowerOfTwo: bf,
  /**
   * Sets the given quaternion from the [Intrinsic Proper Euler Angles]{@link https://en.wikipedia.org/wiki/Euler_angles}
   * defined by the given angles and order.
   *
   * Rotations are applied to the axes in the order specified by order:
   * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
   *
   * @static
   * @method
   * @param {Quaternion} q - The quaternion to set.
   * @param {number} a - The rotation applied to the first axis, in radians.
   * @param {number} b - The rotation applied to the second axis, in radians.
   * @param {number} c - The rotation applied to the third axis, in radians.
   * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
   */
  setQuaternionFromProperEuler: Ef,
  /**
   * Normalizes the given value according to the given typed array.
   *
   * @static
   * @method
   * @param {number} value - The float value in the range `[0,1]` to normalize.
   * @param {TypedArray} array - The typed array that defines the data type of the value.
   * @return {number} The normalize value.
   */
  normalize: _t,
  /**
   * Denormalizes the given value according to the given typed array.
   *
   * @static
   * @method
   * @param {number} value - The value to denormalize.
   * @param {TypedArray} array - The typed array that defines the data type of the value.
   * @return {number} The denormalize (float) value in the range `[0,1]`.
   */
  denormalize: Dn
};
class ze {
  /**
   * Constructs a new 2D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   */
  constructor(e = 0, t = 0) {
    ze.prototype.isVector2 = !0, this.x = e, this.y = t;
  }
  /**
   * Alias for {@link Vector2#x}.
   *
   * @type {number}
   */
  get width() {
    return this.x;
  }
  set width(e) {
    this.x = e;
  }
  /**
   * Alias for {@link Vector2#y}.
   *
   * @type {number}
   */
  get height() {
    return this.y;
  }
  set height(e) {
    this.y = e;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @return {Vector2} A reference to this vector.
   */
  set(e, t) {
    return this.x = e, this.y = t, this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector2} A reference to this vector.
   */
  setScalar(e) {
    return this.x = e, this.y = e, this;
  }
  /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setX(e) {
    return this.x = e, this;
  }
  /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setY(e) {
    return this.y = e, this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y.
   * @param {number} value - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y.
   * @return {number} A vector component value.
   */
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector2} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector2} v - The vector to copy.
   * @return {Vector2} A reference to this vector.
   */
  copy(e) {
    return this.x = e.x, this.y = e.y, this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector2} v - The vector to add.
   * @return {Vector2} A reference to this vector.
   */
  add(e) {
    return this.x += e.x, this.y += e.y, this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector2} A reference to this vector.
   */
  addScalar(e) {
    return this.x += e, this.y += e, this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector2} a - The first vector.
   * @param {Vector2} b - The second vector.
   * @return {Vector2} A reference to this vector.
   */
  addVectors(e, t) {
    return this.x = e.x + t.x, this.y = e.y + t.y, this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector2} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector2} A reference to this vector.
   */
  addScaledVector(e, t) {
    return this.x += e.x * t, this.y += e.y * t, this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector2} v - The vector to subtract.
   * @return {Vector2} A reference to this vector.
   */
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector2} A reference to this vector.
   */
  subScalar(e) {
    return this.x -= e, this.y -= e, this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector2} a - The first vector.
   * @param {Vector2} b - The second vector.
   * @return {Vector2} A reference to this vector.
   */
  subVectors(e, t) {
    return this.x = e.x - t.x, this.y = e.y - t.y, this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector2} v - The vector to multiply.
   * @return {Vector2} A reference to this vector.
   */
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector2} A reference to this vector.
   */
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this;
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector2} v - The vector to divide.
   * @return {Vector2} A reference to this vector.
   */
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector2} A reference to this vector.
   */
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  /**
   * Multiplies this vector (with an implicit 1 as the 3rd component) by
   * the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to apply.
   * @return {Vector2} A reference to this vector.
   */
  applyMatrix3(e) {
    const t = this.x, n = this.y, i = e.elements;
    return this.x = i[0] * t + i[3] * n + i[6], this.y = i[1] * t + i[4] * n + i[7], this;
  }
  /**
   * If this vector's x or y value is greater than the given vector's x or y
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector2} v - The vector.
   * @return {Vector2} A reference to this vector.
   */
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this;
  }
  /**
   * If this vector's x or y value is less than the given vector's x or y
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector2} v - The vector.
   * @return {Vector2} A reference to this vector.
   */
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this;
  }
  /**
   * If this vector's x or y value is greater than the max vector's x or y
   * value, it is replaced by the corresponding value.
   * If this vector's x or y value is less than the min vector's x or y value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector2} min - The minimum x and y values.
   * @param {Vector2} max - The maximum x and y values in the desired range.
   * @return {Vector2} A reference to this vector.
   */
  clamp(e, t) {
    return this.x = Ze(this.x, e.x, t.x), this.y = Ze(this.y, e.y, t.y), this;
  }
  /**
   * If this vector's x or y values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x or y values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector2} A reference to this vector.
   */
  clampScalar(e, t) {
    return this.x = Ze(this.x, e, t), this.y = Ze(this.y, e, t), this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector2} A reference to this vector.
   */
  clampLength(e, t) {
    const n = this.length();
    return this.divideScalar(n || 1).multiplyScalar(Ze(n, e, t));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector2} A reference to this vector.
   */
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x and y = -y.
   *
   * @return {Vector2} A reference to this vector.
   */
  negate() {
    return this.x = -this.x, this.y = -this.y, this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector2} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this.x * e.x + this.y * e.y;
  }
  /**
   * Calculates the cross product of the given vector with this instance.
   *
   * @param {Vector2} v - The vector to compute the cross product with.
   * @return {number} The result of the cross product.
   */
  cross(e) {
    return this.x * e.y - this.y * e.x;
  }
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0) to (x, y). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0) to (x, y).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector2} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Computes the angle in radians of this vector with respect to the positive x-axis.
   *
   * @return {number} The angle in radians.
   */
  angle() {
    return Math.atan2(-this.y, -this.x) + Math.PI;
  }
  /**
   * Returns the angle between the given vector and this instance in radians.
   *
   * @param {Vector2} v - The vector to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(e) {
    const t = Math.sqrt(this.lengthSq() * e.lengthSq());
    if (t === 0) return Math.PI / 2;
    const n = this.dot(e) / t;
    return Math.acos(Ze(n, -1, 1));
  }
  /**
   * Computes the distance from the given vector to this instance.
   *
   * @param {Vector2} v - The vector to compute the distance to.
   * @return {number} The distance.
   */
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  /**
   * Computes the squared distance from the given vector to this instance.
   * If you are just comparing the distance with another distance, you should compare
   * the distance squared instead as it is slightly more efficient to calculate.
   *
   * @param {Vector2} v - The vector to compute the squared distance to.
   * @return {number} The squared distance.
   */
  distanceToSquared(e) {
    const t = this.x - e.x, n = this.y - e.y;
    return t * t + n * n;
  }
  /**
   * Computes the Manhattan distance from the given vector to this instance.
   *
   * @param {Vector2} v - The vector to compute the Manhattan distance to.
   * @return {number} The Manhattan distance.
   */
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector2} A reference to this vector.
   */
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector2} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector2} A reference to this vector.
   */
  lerp(e, t) {
    return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector2} v1 - The first vector.
   * @param {Vector2} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector2} A reference to this vector.
   */
  lerpVectors(e, t, n) {
    return this.x = e.x + (t.x - e.x) * n, this.y = e.y + (t.y - e.y) * n, this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector2} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(e) {
    return e.x === this.x && e.y === this.y;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]` and y
   * value to be `array[ offset + 1 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector2} A reference to this vector.
   */
  fromArray(e, t = 0) {
    return this.x = e[t], this.y = e[t + 1], this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this.x, e[t + 1] = this.y, e;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector2} A reference to this vector.
   */
  fromBufferAttribute(e, t) {
    return this.x = e.getX(t), this.y = e.getY(t), this;
  }
  /**
   * Rotates this vector around the given center by the given angle.
   *
   * @param {Vector2} center - The point around which to rotate.
   * @param {number} angle - The angle to rotate, in radians.
   * @return {Vector2} A reference to this vector.
   */
  rotateAround(e, t) {
    const n = Math.cos(t), i = Math.sin(t), r = this.x - e.x, a = this.y - e.y;
    return this.x = r * n - a * i + e.x, this.y = r * i + a * n + e.y, this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector2} A reference to this vector.
   */
  random() {
    return this.x = Math.random(), this.y = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y;
  }
}
class Ke {
  /**
   * Constructs a new 3x3 matrix. The arguments are supposed to be
   * in row-major order. If no arguments are provided, the constructor
   * initializes the matrix as an identity matrix.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   */
  constructor(e, t, n, i, r, a, o, l, c) {
    Ke.prototype.isMatrix3 = !0, this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ], e !== void 0 && this.set(e, t, n, i, r, a, o, l, c);
  }
  /**
   * Sets the elements of the matrix.The arguments are supposed to be
   * in row-major order.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @return {Matrix3} A reference to this matrix.
   */
  set(e, t, n, i, r, a, o, l, c) {
    const u = this.elements;
    return u[0] = e, u[1] = i, u[2] = o, u[3] = t, u[4] = r, u[5] = l, u[6] = n, u[7] = a, u[8] = c, this;
  }
  /**
   * Sets this matrix to the 3x3 identity matrix.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Copies the values of the given matrix to this instance.
   *
   * @param {Matrix3} m - The matrix to copy.
   * @return {Matrix3} A reference to this matrix.
   */
  copy(e) {
    const t = this.elements, n = e.elements;
    return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], this;
  }
  /**
   * Extracts the basis of this matrix into the three axis vectors provided.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix3} A reference to this matrix.
   */
  extractBasis(e, t, n) {
    return e.setFromMatrix3Column(this, 0), t.setFromMatrix3Column(this, 1), n.setFromMatrix3Column(this, 2), this;
  }
  /**
   * Set this matrix to the upper 3x3 matrix of the given 4x4 matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  setFromMatrix4(e) {
    const t = e.elements;
    return this.set(
      t[0],
      t[4],
      t[8],
      t[1],
      t[5],
      t[9],
      t[2],
      t[6],
      t[10]
    ), this;
  }
  /**
   * Post-multiplies this matrix by the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to multiply with.
   * @return {Matrix3} A reference to this matrix.
   */
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  /**
   * Pre-multiplies this matrix by the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to multiply with.
   * @return {Matrix3} A reference to this matrix.
   */
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  /**
   * Multiples the given 3x3 matrices and stores the result
   * in this matrix.
   *
   * @param {Matrix3} a - The first matrix.
   * @param {Matrix3} b - The second matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  multiplyMatrices(e, t) {
    const n = e.elements, i = t.elements, r = this.elements, a = n[0], o = n[3], l = n[6], c = n[1], u = n[4], h = n[7], d = n[2], f = n[5], m = n[8], _ = i[0], g = i[3], p = i[6], M = i[1], S = i[4], x = i[7], R = i[2], w = i[5], C = i[8];
    return r[0] = a * _ + o * M + l * R, r[3] = a * g + o * S + l * w, r[6] = a * p + o * x + l * C, r[1] = c * _ + u * M + h * R, r[4] = c * g + u * S + h * w, r[7] = c * p + u * x + h * C, r[2] = d * _ + f * M + m * R, r[5] = d * g + f * S + m * w, r[8] = d * p + f * x + m * C, this;
  }
  /**
   * Multiplies every component of the matrix by the given scalar.
   *
   * @param {number} s - The scalar.
   * @return {Matrix3} A reference to this matrix.
   */
  multiplyScalar(e) {
    const t = this.elements;
    return t[0] *= e, t[3] *= e, t[6] *= e, t[1] *= e, t[4] *= e, t[7] *= e, t[2] *= e, t[5] *= e, t[8] *= e, this;
  }
  /**
   * Computes and returns the determinant of this matrix.
   *
   * @return {number} The determinant.
   */
  determinant() {
    const e = this.elements, t = e[0], n = e[1], i = e[2], r = e[3], a = e[4], o = e[5], l = e[6], c = e[7], u = e[8];
    return t * a * u - t * o * c - n * r * u + n * o * l + i * r * c - i * a * l;
  }
  /**
   * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
   * You can not invert with a determinant of zero. If you attempt this, the method produces
   * a zero matrix instead.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  invert() {
    const e = this.elements, t = e[0], n = e[1], i = e[2], r = e[3], a = e[4], o = e[5], l = e[6], c = e[7], u = e[8], h = u * a - o * c, d = o * l - u * r, f = c * r - a * l, m = t * h + n * d + i * f;
    if (m === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const _ = 1 / m;
    return e[0] = h * _, e[1] = (i * c - u * n) * _, e[2] = (o * n - i * a) * _, e[3] = d * _, e[4] = (u * t - i * l) * _, e[5] = (i * r - o * t) * _, e[6] = f * _, e[7] = (n * l - c * t) * _, e[8] = (a * t - n * r) * _, this;
  }
  /**
   * Transposes this matrix in place.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  transpose() {
    let e;
    const t = this.elements;
    return e = t[1], t[1] = t[3], t[3] = e, e = t[2], t[2] = t[6], t[6] = e, e = t[5], t[5] = t[7], t[7] = e, this;
  }
  /**
   * Computes the normal matrix which is the inverse transpose of the upper
   * left 3x3 portion of the given 4x4 matrix.
   *
   * @param {Matrix4} matrix4 - The 4x4 matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  getNormalMatrix(e) {
    return this.setFromMatrix4(e).invert().transpose();
  }
  /**
   * Transposes this matrix into the supplied array, and returns itself unchanged.
   *
   * @param {Array<number>} r - An array to store the transposed matrix elements.
   * @return {Matrix3} A reference to this matrix.
   */
  transposeIntoArray(e) {
    const t = this.elements;
    return e[0] = t[0], e[1] = t[3], e[2] = t[6], e[3] = t[1], e[4] = t[4], e[5] = t[7], e[6] = t[2], e[7] = t[5], e[8] = t[8], this;
  }
  /**
   * Sets the UV transform matrix from offset, repeat, rotation, and center.
   *
   * @param {number} tx - Offset x.
   * @param {number} ty - Offset y.
   * @param {number} sx - Repeat x.
   * @param {number} sy - Repeat y.
   * @param {number} rotation - Rotation, in radians. Positive values rotate counterclockwise.
   * @param {number} cx - Center x of rotation.
   * @param {number} cy - Center y of rotation
   * @return {Matrix3} A reference to this matrix.
   */
  setUvTransform(e, t, n, i, r, a, o) {
    const l = Math.cos(r), c = Math.sin(r);
    return this.set(
      n * l,
      n * c,
      -n * (l * a + c * o) + a + e,
      -i * c,
      i * l,
      -i * (-c * a + l * o) + o + t,
      0,
      0,
      1
    ), this;
  }
  /**
   * Scales this matrix with the given scalar values.
   *
   * @param {number} sx - The amount to scale in the X axis.
   * @param {number} sy - The amount to scale in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  scale(e, t) {
    return this.premultiply(ka.makeScale(e, t)), this;
  }
  /**
   * Rotates this matrix by the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix3} A reference to this matrix.
   */
  rotate(e) {
    return this.premultiply(ka.makeRotation(-e)), this;
  }
  /**
   * Translates this matrix by the given scalar values.
   *
   * @param {number} tx - The amount to translate in the X axis.
   * @param {number} ty - The amount to translate in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  translate(e, t) {
    return this.premultiply(ka.makeTranslation(e, t)), this;
  }
  // for 2D Transforms
  /**
   * Sets this matrix as a 2D translation transform.
   *
   * @param {number|Vector2} x - The amount to translate in the X axis or alternatively a translation vector.
   * @param {number} y - The amount to translate in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  makeTranslation(e, t) {
    return e.isVector2 ? this.set(
      1,
      0,
      e.x,
      0,
      1,
      e.y,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      e,
      0,
      1,
      t,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a 2D rotational transformation.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix3} A reference to this matrix.
   */
  makeRotation(e) {
    const t = Math.cos(e), n = Math.sin(e);
    return this.set(
      t,
      -n,
      0,
      n,
      t,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a 2D scale transform.
   *
   * @param {number} x - The amount to scale in the X axis.
   * @param {number} y - The amount to scale in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  makeScale(e, t) {
    return this.set(
      e,
      0,
      0,
      0,
      t,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Returns `true` if this matrix is equal with the given one.
   *
   * @param {Matrix3} matrix - The matrix to test for equality.
   * @return {boolean} Whether this matrix is equal with the given one.
   */
  equals(e) {
    const t = this.elements, n = e.elements;
    for (let i = 0; i < 9; i++)
      if (t[i] !== n[i]) return !1;
    return !0;
  }
  /**
   * Sets the elements of the matrix from the given array.
   *
   * @param {Array<number>} array - The matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Matrix3} A reference to this matrix.
   */
  fromArray(e, t = 0) {
    for (let n = 0; n < 9; n++)
      this.elements[n] = e[n + t];
    return this;
  }
  /**
   * Writes the elements of this matrix to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The matrix elements in column-major order.
   */
  toArray(e = [], t = 0) {
    const n = this.elements;
    return e[t] = n[0], e[t + 1] = n[1], e[t + 2] = n[2], e[t + 3] = n[3], e[t + 4] = n[4], e[t + 5] = n[5], e[t + 6] = n[6], e[t + 7] = n[7], e[t + 8] = n[8], e;
  }
  /**
   * Returns a matrix with copied values from this instance.
   *
   * @return {Matrix3} A clone of this instance.
   */
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
}
const ka = /* @__PURE__ */ new Ke();
function Nh(s) {
  for (let e = s.length - 1; e >= 0; --e)
    if (s[e] >= 65535) return !0;
  return !1;
}
function br(s) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", s);
}
function Tf() {
  const s = br("canvas");
  return s.style.display = "block", s;
}
const Cc = {};
function xa(s) {
  s in Cc || (Cc[s] = !0, console.warn(s));
}
function Af(s, e, t) {
  return new Promise(function(n, i) {
    function r() {
      switch (s.clientWaitSync(e, s.SYNC_FLUSH_COMMANDS_BIT, 0)) {
        case s.WAIT_FAILED:
          i();
          break;
        case s.TIMEOUT_EXPIRED:
          setTimeout(r, t);
          break;
        default:
          n();
      }
    }
    setTimeout(r, t);
  });
}
function wf(s) {
  const e = s.elements;
  e[2] = 0.5 * e[2] + 0.5 * e[3], e[6] = 0.5 * e[6] + 0.5 * e[7], e[10] = 0.5 * e[10] + 0.5 * e[11], e[14] = 0.5 * e[14] + 0.5 * e[15];
}
function Rf(s) {
  const e = s.elements;
  e[11] === -1 ? (e[10] = -e[10] - 1, e[14] = -e[14]) : (e[10] = -e[10], e[14] = -e[14] + 1);
}
const Pc = /* @__PURE__ */ new Ke().set(
  0.4123908,
  0.3575843,
  0.1804808,
  0.212639,
  0.7151687,
  0.0721923,
  0.0193308,
  0.1191948,
  0.9505322
), Lc = /* @__PURE__ */ new Ke().set(
  3.2409699,
  -1.5373832,
  -0.4986108,
  -0.9692436,
  1.8759675,
  0.0415551,
  0.0556301,
  -0.203977,
  1.0569715
);
function Cf() {
  const s = {
    enabled: !0,
    workingColorSpace: Zt,
    /**
     * Implementations of supported color spaces.
     *
     * Required:
     *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
     *	- whitePoint: reference white [ x y ]
     *	- transfer: transfer function (pre-defined)
     *	- toXYZ: Matrix3 RGB to XYZ transform
     *	- fromXYZ: Matrix3 XYZ to RGB transform
     *	- luminanceCoefficients: RGB luminance coefficients
     *
     * Optional:
     *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace }
     *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
     *
     * Reference:
     * - https://www.russellcottrell.com/photo/matrixCalculator.htm
     */
    spaces: {},
    convert: function(i, r, a) {
      return this.enabled === !1 || r === a || !r || !a || (this.spaces[r].transfer === vt && (i.r = fi(i.r), i.g = fi(i.g), i.b = fi(i.b)), this.spaces[r].primaries !== this.spaces[a].primaries && (i.applyMatrix3(this.spaces[r].toXYZ), i.applyMatrix3(this.spaces[a].fromXYZ)), this.spaces[a].transfer === vt && (i.r = Ls(i.r), i.g = Ls(i.g), i.b = Ls(i.b))), i;
    },
    fromWorkingColorSpace: function(i, r) {
      return this.convert(i, this.workingColorSpace, r);
    },
    toWorkingColorSpace: function(i, r) {
      return this.convert(i, r, this.workingColorSpace);
    },
    getPrimaries: function(i) {
      return this.spaces[i].primaries;
    },
    getTransfer: function(i) {
      return i === Ri ? Ea : this.spaces[i].transfer;
    },
    getLuminanceCoefficients: function(i, r = this.workingColorSpace) {
      return i.fromArray(this.spaces[r].luminanceCoefficients);
    },
    define: function(i) {
      Object.assign(this.spaces, i);
    },
    // Internal APIs
    _getMatrix: function(i, r, a) {
      return i.copy(this.spaces[r].toXYZ).multiply(this.spaces[a].fromXYZ);
    },
    _getDrawingBufferColorSpace: function(i) {
      return this.spaces[i].outputColorSpaceConfig.drawingBufferColorSpace;
    },
    _getUnpackColorSpace: function(i = this.workingColorSpace) {
      return this.spaces[i].workingColorSpaceConfig.unpackColorSpace;
    }
  }, e = [0.64, 0.33, 0.3, 0.6, 0.15, 0.06], t = [0.2126, 0.7152, 0.0722], n = [0.3127, 0.329];
  return s.define({
    [Zt]: {
      primaries: e,
      whitePoint: n,
      transfer: Ea,
      toXYZ: Pc,
      fromXYZ: Lc,
      luminanceCoefficients: t,
      workingColorSpaceConfig: { unpackColorSpace: Dt },
      outputColorSpaceConfig: { drawingBufferColorSpace: Dt }
    },
    [Dt]: {
      primaries: e,
      whitePoint: n,
      transfer: vt,
      toXYZ: Pc,
      fromXYZ: Lc,
      luminanceCoefficients: t,
      outputColorSpaceConfig: { drawingBufferColorSpace: Dt }
    }
  }), s;
}
const ot = /* @__PURE__ */ Cf();
function fi(s) {
  return s < 0.04045 ? s * 0.0773993808 : Math.pow(s * 0.9478672986 + 0.0521327014, 2.4);
}
function Ls(s) {
  return s < 31308e-7 ? s * 12.92 : 1.055 * Math.pow(s, 0.41666) - 0.055;
}
let is;
class Pf {
  /**
   * Returns a data URI containing a representation of the given image.
   *
   * @param {(HTMLImageElement|HTMLCanvasElement)} image - The image object.
   * @param {string} [type='image/png'] - Indicates the image format.
   * @return {string} The data URI.
   */
  static getDataURL(e, t = "image/png") {
    if (/^data:/i.test(e.src) || typeof HTMLCanvasElement > "u")
      return e.src;
    let n;
    if (e instanceof HTMLCanvasElement)
      n = e;
    else {
      is === void 0 && (is = br("canvas")), is.width = e.width, is.height = e.height;
      const i = is.getContext("2d");
      e instanceof ImageData ? i.putImageData(e, 0, 0) : i.drawImage(e, 0, 0, e.width, e.height), n = is;
    }
    return n.toDataURL(t);
  }
  /**
   * Converts the given sRGB image data to linear color space.
   *
   * @param {(HTMLImageElement|HTMLCanvasElement|ImageBitmap|Object)} image - The image object.
   * @return {HTMLCanvasElement|Object} The converted image.
   */
  static sRGBToLinear(e) {
    if (typeof HTMLImageElement < "u" && e instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && e instanceof ImageBitmap) {
      const t = br("canvas");
      t.width = e.width, t.height = e.height;
      const n = t.getContext("2d");
      n.drawImage(e, 0, 0, e.width, e.height);
      const i = n.getImageData(0, 0, e.width, e.height), r = i.data;
      for (let a = 0; a < r.length; a++)
        r[a] = fi(r[a] / 255) * 255;
      return n.putImageData(i, 0, 0), t;
    } else if (e.data) {
      const t = e.data.slice(0);
      for (let n = 0; n < t.length; n++)
        t instanceof Uint8Array || t instanceof Uint8ClampedArray ? t[n] = Math.floor(fi(t[n] / 255) * 255) : t[n] = fi(t[n]);
      return {
        data: t,
        width: e.width,
        height: e.height
      };
    } else
      return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e;
  }
}
let Lf = 0;
class Gl {
  /**
   * Constructs a new video texture.
   *
   * @param {any} [data=null] - The data definition of a texture.
   */
  constructor(e = null) {
    this.isSource = !0, Object.defineProperty(this, "id", { value: Lf++ }), this.uuid = Un(), this.data = e, this.dataReady = !0, this.version = 0;
  }
  /**
   * When the property is set to `true`, the engine allocates the memory
   * for the texture (if necessary) and triggers the actual texture upload
   * to the GPU next time the source is used.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  /**
   * Serializes the source into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized source.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    if (!t && e.images[this.uuid] !== void 0)
      return e.images[this.uuid];
    const n = {
      uuid: this.uuid,
      url: ""
    }, i = this.data;
    if (i !== null) {
      let r;
      if (Array.isArray(i)) {
        r = [];
        for (let a = 0, o = i.length; a < o; a++)
          i[a].isDataTexture ? r.push(za(i[a].image)) : r.push(za(i[a]));
      } else
        r = za(i);
      n.url = r;
    }
    return t || (e.images[this.uuid] = n), n;
  }
}
function za(s) {
  return typeof HTMLImageElement < "u" && s instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && s instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && s instanceof ImageBitmap ? Pf.getDataURL(s) : s.data ? {
    data: Array.from(s.data),
    width: s.width,
    height: s.height,
    type: s.data.constructor.name
  } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
}
let If = 0;
class Gt extends Ui {
  /**
   * Constructs a new texture.
   *
   * @param {?Object} [image=Texture.DEFAULT_IMAGE] - The image holding the texture data.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space.
   */
  constructor(e = Gt.DEFAULT_IMAGE, t = Gt.DEFAULT_MAPPING, n = Vn, i = Vn, r = Vt, a = Gn, o = mn, l = _i, c = Gt.DEFAULT_ANISOTROPY, u = Ri) {
    super(), this.isTexture = !0, Object.defineProperty(this, "id", { value: If++ }), this.uuid = Un(), this.name = "", this.source = new Gl(e), this.mipmaps = [], this.mapping = t, this.channel = 0, this.wrapS = n, this.wrapT = i, this.magFilter = r, this.minFilter = a, this.anisotropy = c, this.format = o, this.internalFormat = null, this.type = l, this.offset = new ze(0, 0), this.repeat = new ze(1, 1), this.center = new ze(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new Ke(), this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.colorSpace = u, this.userData = {}, this.version = 0, this.onUpdate = null, this.renderTarget = null, this.isRenderTargetTexture = !1, this.pmremVersion = 0;
  }
  /**
   * The image object holding the texture data.
   *
   * @type {?Object}
   */
  get image() {
    return this.source.data;
  }
  set image(e = null) {
    this.source.data = e;
  }
  /**
   * Updates the texture transformation matrix from the from the properties {@link Texture#offset},
   * {@link Texture#repeat}, {@link Texture#rotation}, and {@link Texture#center}.
   */
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  /**
   * Returns a new texture with copied values from this instance.
   *
   * @return {Texture} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given texture to this instance.
   *
   * @param {Texture} source - The texture to copy.
   * @return {Texture} A reference to this instance.
   */
  copy(e) {
    return this.name = e.name, this.source = e.source, this.mipmaps = e.mipmaps.slice(0), this.mapping = e.mapping, this.channel = e.channel, this.wrapS = e.wrapS, this.wrapT = e.wrapT, this.magFilter = e.magFilter, this.minFilter = e.minFilter, this.anisotropy = e.anisotropy, this.format = e.format, this.internalFormat = e.internalFormat, this.type = e.type, this.offset.copy(e.offset), this.repeat.copy(e.repeat), this.center.copy(e.center), this.rotation = e.rotation, this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrix.copy(e.matrix), this.generateMipmaps = e.generateMipmaps, this.premultiplyAlpha = e.premultiplyAlpha, this.flipY = e.flipY, this.unpackAlignment = e.unpackAlignment, this.colorSpace = e.colorSpace, this.renderTarget = e.renderTarget, this.isRenderTargetTexture = e.isRenderTargetTexture, this.userData = JSON.parse(JSON.stringify(e.userData)), this.needsUpdate = !0, this;
  }
  /**
   * Serializes the texture into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized texture.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    if (!t && e.textures[this.uuid] !== void 0)
      return e.textures[this.uuid];
    const n = {
      metadata: {
        version: 4.6,
        type: "Texture",
        generator: "Texture.toJSON"
      },
      uuid: this.uuid,
      name: this.name,
      image: this.source.toJSON(e).uuid,
      mapping: this.mapping,
      channel: this.channel,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      internalFormat: this.internalFormat,
      type: this.type,
      colorSpace: this.colorSpace,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      generateMipmaps: this.generateMipmaps,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    return Object.keys(this.userData).length > 0 && (n.userData = this.userData), t || (e.textures[this.uuid] = n), n;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires Texture#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  /**
   * Transforms the given uv vector with the textures uv transformation matrix.
   *
   * @param {Vector2} uv - The uv vector.
   * @return {Vector2} The transformed uv vector.
   */
  transformUv(e) {
    if (this.mapping !== vh) return e;
    if (e.applyMatrix3(this.matrix), e.x < 0 || e.x > 1)
      switch (this.wrapS) {
        case Fs:
          e.x = e.x - Math.floor(e.x);
          break;
        case Vn:
          e.x = e.x < 0 ? 0 : 1;
          break;
        case Ma:
          Math.abs(Math.floor(e.x) % 2) === 1 ? e.x = Math.ceil(e.x) - e.x : e.x = e.x - Math.floor(e.x);
          break;
      }
    if (e.y < 0 || e.y > 1)
      switch (this.wrapT) {
        case Fs:
          e.y = e.y - Math.floor(e.y);
          break;
        case Vn:
          e.y = e.y < 0 ? 0 : 1;
          break;
        case Ma:
          Math.abs(Math.floor(e.y) % 2) === 1 ? e.y = Math.ceil(e.y) - e.y : e.y = e.y - Math.floor(e.y);
          break;
      }
    return this.flipY && (e.y = 1 - e.y), e;
  }
  /**
   * Setting this property to `true` indicates the engine the texture
   * must be updated in the next render. This triggers a texture upload
   * to the GPU and ensures correct texture parameter configuration.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && (this.version++, this.source.needsUpdate = !0);
  }
  /**
   * Setting this property to `true` indicates the engine the PMREM
   * must be regenerated.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsPMREMUpdate(e) {
    e === !0 && this.pmremVersion++;
  }
}
Gt.DEFAULT_IMAGE = null;
Gt.DEFAULT_MAPPING = vh;
Gt.DEFAULT_ANISOTROPY = 1;
class at {
  /**
   * Constructs a new 4D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   * @param {number} [z=0] - The z value of this vector.
   * @param {number} [w=1] - The w value of this vector.
   */
  constructor(e = 0, t = 0, n = 0, i = 1) {
    at.prototype.isVector4 = !0, this.x = e, this.y = t, this.z = n, this.w = i;
  }
  /**
   * Alias for {@link Vector4#z}.
   *
   * @type {number}
   */
  get width() {
    return this.z;
  }
  set width(e) {
    this.z = e;
  }
  /**
   * Alias for {@link Vector4#w}.
   *
   * @type {number}
   */
  get height() {
    return this.w;
  }
  set height(e) {
    this.w = e;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @param {number} z - The value of the z component.
   * @param {number} w - The value of the w component.
   * @return {Vector4} A reference to this vector.
   */
  set(e, t, n, i) {
    return this.x = e, this.y = t, this.z = n, this.w = i, this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector4} A reference to this vector.
   */
  setScalar(e) {
    return this.x = e, this.y = e, this.z = e, this.w = e, this;
  }
  /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setX(e) {
    return this.x = e, this;
  }
  /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setY(e) {
    return this.y = e, this;
  }
  /**
   * Sets the vector's z component to the given value
   *
   * @param {number} z - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setZ(e) {
    return this.z = e, this;
  }
  /**
   * Sets the vector's w component to the given value
   *
   * @param {number} w - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setW(e) {
    return this.w = e, this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y,
   * `2` equals to z, `3` equals to w.
   * @param {number} value - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      case 2:
        this.z = t;
        break;
      case 3:
        this.w = t;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y,
   * `2` equals to z, `3` equals to w.
   * @return {number} A vector component value.
   */
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector4} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector3|Vector4} v - The vector to copy.
   * @return {Vector4} A reference to this vector.
   */
  copy(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this.w = e.w !== void 0 ? e.w : 1, this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector4} v - The vector to add.
   * @return {Vector4} A reference to this vector.
   */
  add(e) {
    return this.x += e.x, this.y += e.y, this.z += e.z, this.w += e.w, this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector4} A reference to this vector.
   */
  addScalar(e) {
    return this.x += e, this.y += e, this.z += e, this.w += e, this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector4} a - The first vector.
   * @param {Vector4} b - The second vector.
   * @return {Vector4} A reference to this vector.
   */
  addVectors(e, t) {
    return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this.w = e.w + t.w, this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector4} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector4} A reference to this vector.
   */
  addScaledVector(e, t) {
    return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this.w += e.w * t, this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector4} v - The vector to subtract.
   * @return {Vector4} A reference to this vector.
   */
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this.z -= e.z, this.w -= e.w, this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector4} A reference to this vector.
   */
  subScalar(e) {
    return this.x -= e, this.y -= e, this.z -= e, this.w -= e, this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector4} a - The first vector.
   * @param {Vector4} b - The second vector.
   * @return {Vector4} A reference to this vector.
   */
  subVectors(e, t) {
    return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this.w = e.w - t.w, this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector4} v - The vector to multiply.
   * @return {Vector4} A reference to this vector.
   */
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this.z *= e.z, this.w *= e.w, this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector4} A reference to this vector.
   */
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
  }
  /**
   * Multiplies this vector with the given 4x4 matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector4} A reference to this vector.
   */
  applyMatrix4(e) {
    const t = this.x, n = this.y, i = this.z, r = this.w, a = e.elements;
    return this.x = a[0] * t + a[4] * n + a[8] * i + a[12] * r, this.y = a[1] * t + a[5] * n + a[9] * i + a[13] * r, this.z = a[2] * t + a[6] * n + a[10] * i + a[14] * r, this.w = a[3] * t + a[7] * n + a[11] * i + a[15] * r, this;
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector4} v - The vector to divide.
   * @return {Vector4} A reference to this vector.
   */
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this.z /= e.z, this.w /= e.w, this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector4} A reference to this vector.
   */
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  /**
   * Sets the x, y and z components of this
   * vector to the quaternion's axis and w to the angle.
   *
   * @param {Quaternion} q - The Quaternion to set.
   * @return {Vector4} A reference to this vector.
   */
  setAxisAngleFromQuaternion(e) {
    this.w = 2 * Math.acos(e.w);
    const t = Math.sqrt(1 - e.w * e.w);
    return t < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e.x / t, this.y = e.y / t, this.z = e.z / t), this;
  }
  /**
   * Sets the x, y and z components of this
   * vector to the axis of rotation and w to the angle.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper left 3x3 matrix is a pure rotation matrix.
   * @return {Vector4} A reference to this vector.
   */
  setAxisAngleFromRotationMatrix(e) {
    let t, n, i, r;
    const l = e.elements, c = l[0], u = l[4], h = l[8], d = l[1], f = l[5], m = l[9], _ = l[2], g = l[6], p = l[10];
    if (Math.abs(u - d) < 0.01 && Math.abs(h - _) < 0.01 && Math.abs(m - g) < 0.01) {
      if (Math.abs(u + d) < 0.1 && Math.abs(h + _) < 0.1 && Math.abs(m + g) < 0.1 && Math.abs(c + f + p - 3) < 0.1)
        return this.set(1, 0, 0, 0), this;
      t = Math.PI;
      const S = (c + 1) / 2, x = (f + 1) / 2, R = (p + 1) / 2, w = (u + d) / 4, C = (h + _) / 4, P = (m + g) / 4;
      return S > x && S > R ? S < 0.01 ? (n = 0, i = 0.707106781, r = 0.707106781) : (n = Math.sqrt(S), i = w / n, r = C / n) : x > R ? x < 0.01 ? (n = 0.707106781, i = 0, r = 0.707106781) : (i = Math.sqrt(x), n = w / i, r = P / i) : R < 0.01 ? (n = 0.707106781, i = 0.707106781, r = 0) : (r = Math.sqrt(R), n = C / r, i = P / r), this.set(n, i, r, t), this;
    }
    let M = Math.sqrt((g - m) * (g - m) + (h - _) * (h - _) + (d - u) * (d - u));
    return Math.abs(M) < 1e-3 && (M = 1), this.x = (g - m) / M, this.y = (h - _) / M, this.z = (d - u) / M, this.w = Math.acos((c + f + p - 1) / 2), this;
  }
  /**
   * Sets the vector components to the position elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector4} A reference to this vector.
   */
  setFromMatrixPosition(e) {
    const t = e.elements;
    return this.x = t[12], this.y = t[13], this.z = t[14], this.w = t[15], this;
  }
  /**
   * If this vector's x, y, z or w value is greater than the given vector's x, y, z or w
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector4} v - The vector.
   * @return {Vector4} A reference to this vector.
   */
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this.w = Math.min(this.w, e.w), this;
  }
  /**
   * If this vector's x, y, z or w value is less than the given vector's x, y, z or w
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector4} v - The vector.
   * @return {Vector4} A reference to this vector.
   */
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this.w = Math.max(this.w, e.w), this;
  }
  /**
   * If this vector's x, y, z or w value is greater than the max vector's x, y, z or w
   * value, it is replaced by the corresponding value.
   * If this vector's x, y, z or w value is less than the min vector's x, y, z or w value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector4} min - The minimum x, y and z values.
   * @param {Vector4} max - The maximum x, y and z values in the desired range.
   * @return {Vector4} A reference to this vector.
   */
  clamp(e, t) {
    return this.x = Ze(this.x, e.x, t.x), this.y = Ze(this.y, e.y, t.y), this.z = Ze(this.z, e.z, t.z), this.w = Ze(this.w, e.w, t.w), this;
  }
  /**
   * If this vector's x, y, z or w values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x, y, z or w values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector4} A reference to this vector.
   */
  clampScalar(e, t) {
    return this.x = Ze(this.x, e, t), this.y = Ze(this.y, e, t), this.z = Ze(this.z, e, t), this.w = Ze(this.w, e, t), this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector4} A reference to this vector.
   */
  clampLength(e, t) {
    const n = this.length();
    return this.divideScalar(n || 1).multiplyScalar(Ze(n, e, t));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector4} A reference to this vector.
   */
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector4} A reference to this vector.
   */
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector4} A reference to this vector.
   */
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector4} A reference to this vector.
   */
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x, y = -y, z = -z, w = -w.
   *
   * @return {Vector4} A reference to this vector.
   */
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector4} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
  }
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0, 0, 0) to (x, y, z, w). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0, 0, 0) to (x, y, z, w).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector4} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector4} A reference to this vector.
   */
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector4} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector4} A reference to this vector.
   */
  lerp(e, t) {
    return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this.w += (e.w - this.w) * t, this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector4} v1 - The first vector.
   * @param {Vector4} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector4} A reference to this vector.
   */
  lerpVectors(e, t, n) {
    return this.x = e.x + (t.x - e.x) * n, this.y = e.y + (t.y - e.y) * n, this.z = e.z + (t.z - e.z) * n, this.w = e.w + (t.w - e.w) * n, this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector4} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`,
   * z value to be `array[ offset + 2 ]`, w value to be `array[ offset + 3 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector4} A reference to this vector.
   */
  fromArray(e, t = 0) {
    return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this.w = e[t + 3], this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e[t + 3] = this.w, e;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector4} A reference to this vector.
   */
  fromBufferAttribute(e, t) {
    return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this.w = e.getW(t), this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector4} A reference to this vector.
   */
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z, yield this.w;
  }
}
class Df extends Ui {
  /**
   * Render target options.
   *
   * @typedef {Object} RenderTarget~Options
   * @property {boolean} [generateMipmaps=false] - Whether to generate mipmaps or not.
   * @property {number} [magFilter=LinearFilter] - The mag filter.
   * @property {number} [minFilter=LinearFilter] - The min filter.
   * @property {number} [format=RGBAFormat] - The texture format.
   * @property {number} [type=UnsignedByteType] - The texture type.
   * @property {?string} [internalFormat=null] - The texture's internal format.
   * @property {number} [wrapS=ClampToEdgeWrapping] - The texture's uv wrapping mode.
   * @property {number} [wrapT=ClampToEdgeWrapping] - The texture's uv wrapping mode.
   * @property {number} [anisotropy=1] - The texture's anisotropy value.
   * @property {string} [colorSpace=NoColorSpace] - The texture's color space.
   * @property {boolean} [depthBuffer=true] - Whether to allocate a depth buffer or not.
   * @property {boolean} [stencilBuffer=false] - Whether to allocate a stencil buffer or not.
   * @property {boolean} [resolveDepthBuffer=true] - Whether to resolve the depth buffer or not.
   * @property {boolean} [resolveStencilBuffer=true] - Whether  to resolve the stencil buffer or not.
   * @property {?Texture} [depthTexture=null] - Reference to a depth texture.
   * @property {number} [samples=0] - The MSAA samples count.
   * @property {number} [count=1] - Defines the number of color attachments . Must be at least `1`.
   */
  /**
   * Constructs a new render target.
   *
   * @param {number} [width=1] - The width of the render target.
   * @param {number} [height=1] - The height of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */
  constructor(e = 1, t = 1, n = {}) {
    super(), this.isRenderTarget = !0, this.width = e, this.height = t, this.depth = 1, this.scissor = new at(0, 0, e, t), this.scissorTest = !1, this.viewport = new at(0, 0, e, t);
    const i = { width: e, height: t, depth: 1 };
    n = Object.assign({
      generateMipmaps: !1,
      internalFormat: null,
      minFilter: Vt,
      depthBuffer: !0,
      stencilBuffer: !1,
      resolveDepthBuffer: !0,
      resolveStencilBuffer: !0,
      depthTexture: null,
      samples: 0,
      count: 1
    }, n);
    const r = new Gt(i, n.mapping, n.wrapS, n.wrapT, n.magFilter, n.minFilter, n.format, n.type, n.anisotropy, n.colorSpace);
    r.flipY = !1, r.generateMipmaps = n.generateMipmaps, r.internalFormat = n.internalFormat, this.textures = [];
    const a = n.count;
    for (let o = 0; o < a; o++)
      this.textures[o] = r.clone(), this.textures[o].isRenderTargetTexture = !0, this.textures[o].renderTarget = this;
    this.depthBuffer = n.depthBuffer, this.stencilBuffer = n.stencilBuffer, this.resolveDepthBuffer = n.resolveDepthBuffer, this.resolveStencilBuffer = n.resolveStencilBuffer, this._depthTexture = n.depthTexture, this.samples = n.samples;
  }
  /**
   * The texture representing the default color attachment.
   *
   * @type {Texture}
   */
  get texture() {
    return this.textures[0];
  }
  set texture(e) {
    this.textures[0] = e;
  }
  set depthTexture(e) {
    this._depthTexture !== null && (this._depthTexture.renderTarget = null), e !== null && (e.renderTarget = this), this._depthTexture = e;
  }
  /**
   * Instead of saving the depth in a renderbuffer, a texture
   * can be used instead which is useful for further processing
   * e.g. in context of post-processing.
   *
   * @type {?DepthTexture}
   * @default null
   */
  get depthTexture() {
    return this._depthTexture;
  }
  /**
   * Sets the size of this render target.
   *
   * @param {number} width - The width.
   * @param {number} height - The height.
   * @param {number} [depth=1] - The depth.
   */
  setSize(e, t, n = 1) {
    if (this.width !== e || this.height !== t || this.depth !== n) {
      this.width = e, this.height = t, this.depth = n;
      for (let i = 0, r = this.textures.length; i < r; i++)
        this.textures[i].image.width = e, this.textures[i].image.height = t, this.textures[i].image.depth = n;
      this.dispose();
    }
    this.viewport.set(0, 0, e, t), this.scissor.set(0, 0, e, t);
  }
  /**
   * Returns a new render target with copied values from this instance.
   *
   * @return {RenderTarget} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the settings of the given render target. This is a structural copy so
   * no resources are shared between render targets after the copy. That includes
   * all MRT textures and the depth texture.
   *
   * @param {RenderTarget} source - The render target to copy.
   * @return {RenderTarget} A reference to this instance.
   */
  copy(e) {
    this.width = e.width, this.height = e.height, this.depth = e.depth, this.scissor.copy(e.scissor), this.scissorTest = e.scissorTest, this.viewport.copy(e.viewport), this.textures.length = 0;
    for (let t = 0, n = e.textures.length; t < n; t++) {
      this.textures[t] = e.textures[t].clone(), this.textures[t].isRenderTargetTexture = !0, this.textures[t].renderTarget = this;
      const i = Object.assign({}, e.textures[t].image);
      this.textures[t].source = new Gl(i);
    }
    return this.depthBuffer = e.depthBuffer, this.stencilBuffer = e.stencilBuffer, this.resolveDepthBuffer = e.resolveDepthBuffer, this.resolveStencilBuffer = e.resolveStencilBuffer, e.depthTexture !== null && (this.depthTexture = e.depthTexture.clone()), this.samples = e.samples, this;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires RenderTarget#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
class Di extends Df {
  /**
   * Constructs a new 3D render target.
   *
   * @param {number} [width=1] - The width of the render target.
   * @param {number} [height=1] - The height of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */
  constructor(e = 1, t = 1, n = {}) {
    super(e, t, n), this.isWebGLRenderTarget = !0;
  }
}
class Uh extends Gt {
  /**
   * Constructs a new data array texture.
   *
   * @param {?TypedArray} [data=null] - The buffer data.
   * @param {number} [width=1] - The width of the texture.
   * @param {number} [height=1] - The height of the texture.
   * @param {number} [depth=1] - The depth of the texture.
   */
  constructor(e = null, t = 1, n = 1, i = 1) {
    super(null), this.isDataArrayTexture = !0, this.image = { data: e, width: t, height: n, depth: i }, this.magFilter = en, this.minFilter = en, this.wrapR = Vn, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1, this.layerUpdates = /* @__PURE__ */ new Set();
  }
  /**
   * Describes that a specific layer of the texture needs to be updated.
   * Normally when {@link Texture#needsUpdate} is set to `true`, the
   * entire data texture array is sent to the GPU. Marking specific
   * layers will only transmit subsets of all mipmaps associated with a
   * specific depth in the array which is often much more performant.
   *
   * @param {number} layerIndex - The layer index that should be updated.
   */
  addLayerUpdate(e) {
    this.layerUpdates.add(e);
  }
  /**
   * Resets the layer updates registry.
   */
  clearLayerUpdates() {
    this.layerUpdates.clear();
  }
}
class Nf extends Gt {
  /**
   * Constructs a new data array texture.
   *
   * @param {?TypedArray} [data=null] - The buffer data.
   * @param {number} [width=1] - The width of the texture.
   * @param {number} [height=1] - The height of the texture.
   * @param {number} [depth=1] - The depth of the texture.
   */
  constructor(e = null, t = 1, n = 1, i = 1) {
    super(null), this.isData3DTexture = !0, this.image = { data: e, width: t, height: n, depth: i }, this.magFilter = en, this.minFilter = en, this.wrapR = Vn, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
class gn {
  /**
   * Constructs a new quaternion.
   *
   * @param {number} [x=0] - The x value of this quaternion.
   * @param {number} [y=0] - The y value of this quaternion.
   * @param {number} [z=0] - The z value of this quaternion.
   * @param {number} [w=1] - The w value of this quaternion.
   */
  constructor(e = 0, t = 0, n = 0, i = 1) {
    this.isQuaternion = !0, this._x = e, this._y = t, this._z = n, this._w = i;
  }
  /**
   * Interpolates between two quaternions via SLERP. This implementation assumes the
   * quaternion data are managed  in flat arrays.
   *
   * @param {Array<number>} dst - The destination array.
   * @param {number} dstOffset - An offset into the destination array.
   * @param {Array<number>} src0 - The source array of the first quaternion.
   * @param {number} srcOffset0 - An offset into the first source array.
   * @param {Array<number>} src1 -  The source array of the second quaternion.
   * @param {number} srcOffset1 - An offset into the second source array.
   * @param {number} t - The interpolation factor in the range `[0,1]`.
   * @see {@link Quaternion#slerp}
   */
  static slerpFlat(e, t, n, i, r, a, o) {
    let l = n[i + 0], c = n[i + 1], u = n[i + 2], h = n[i + 3];
    const d = r[a + 0], f = r[a + 1], m = r[a + 2], _ = r[a + 3];
    if (o === 0) {
      e[t + 0] = l, e[t + 1] = c, e[t + 2] = u, e[t + 3] = h;
      return;
    }
    if (o === 1) {
      e[t + 0] = d, e[t + 1] = f, e[t + 2] = m, e[t + 3] = _;
      return;
    }
    if (h !== _ || l !== d || c !== f || u !== m) {
      let g = 1 - o;
      const p = l * d + c * f + u * m + h * _, M = p >= 0 ? 1 : -1, S = 1 - p * p;
      if (S > Number.EPSILON) {
        const R = Math.sqrt(S), w = Math.atan2(R, p * M);
        g = Math.sin(g * w) / R, o = Math.sin(o * w) / R;
      }
      const x = o * M;
      if (l = l * g + d * x, c = c * g + f * x, u = u * g + m * x, h = h * g + _ * x, g === 1 - o) {
        const R = 1 / Math.sqrt(l * l + c * c + u * u + h * h);
        l *= R, c *= R, u *= R, h *= R;
      }
    }
    e[t] = l, e[t + 1] = c, e[t + 2] = u, e[t + 3] = h;
  }
  /**
   * Multiplies two quaternions. This implementation assumes the quaternion data are managed
   * in flat arrays.
   *
   * @param {Array<number>} dst - The destination array.
   * @param {number} dstOffset - An offset into the destination array.
   * @param {Array<number>} src0 - The source array of the first quaternion.
   * @param {number} srcOffset0 - An offset into the first source array.
   * @param {Array<number>} src1 -  The source array of the second quaternion.
   * @param {number} srcOffset1 - An offset into the second source array.
   * @return {Array<number>} The destination array.
   * @see {@link Quaternion#multiplyQuaternions}.
   */
  static multiplyQuaternionsFlat(e, t, n, i, r, a) {
    const o = n[i], l = n[i + 1], c = n[i + 2], u = n[i + 3], h = r[a], d = r[a + 1], f = r[a + 2], m = r[a + 3];
    return e[t] = o * m + u * h + l * f - c * d, e[t + 1] = l * m + u * d + c * h - o * f, e[t + 2] = c * m + u * f + o * d - l * h, e[t + 3] = u * m - o * h - l * d - c * f, e;
  }
  /**
   * The x value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._onChangeCallback();
  }
  /**
   * The y value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._onChangeCallback();
  }
  /**
   * The z value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._onChangeCallback();
  }
  /**
   * The w value of this quaternion.
   *
   * @type {number}
   * @default 1
   */
  get w() {
    return this._w;
  }
  set w(e) {
    this._w = e, this._onChangeCallback();
  }
  /**
   * Sets the quaternion components.
   *
   * @param {number} x - The x value of this quaternion.
   * @param {number} y - The y value of this quaternion.
   * @param {number} z - The z value of this quaternion.
   * @param {number} w - The w value of this quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  set(e, t, n, i) {
    return this._x = e, this._y = t, this._z = n, this._w = i, this._onChangeCallback(), this;
  }
  /**
   * Returns a new quaternion with copied values from this instance.
   *
   * @return {Quaternion} A clone of this instance.
   */
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  /**
   * Copies the values of the given quaternion to this instance.
   *
   * @param {Quaternion} quaternion - The quaternion to copy.
   * @return {Quaternion} A reference to this quaternion.
   */
  copy(e) {
    return this._x = e.x, this._y = e.y, this._z = e.z, this._w = e.w, this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion from the rotation specified by the given
   * Euler angles.
   *
   * @param {Euler} euler - The Euler angles.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromEuler(e, t = !0) {
    const n = e._x, i = e._y, r = e._z, a = e._order, o = Math.cos, l = Math.sin, c = o(n / 2), u = o(i / 2), h = o(r / 2), d = l(n / 2), f = l(i / 2), m = l(r / 2);
    switch (a) {
      case "XYZ":
        this._x = d * u * h + c * f * m, this._y = c * f * h - d * u * m, this._z = c * u * m + d * f * h, this._w = c * u * h - d * f * m;
        break;
      case "YXZ":
        this._x = d * u * h + c * f * m, this._y = c * f * h - d * u * m, this._z = c * u * m - d * f * h, this._w = c * u * h + d * f * m;
        break;
      case "ZXY":
        this._x = d * u * h - c * f * m, this._y = c * f * h + d * u * m, this._z = c * u * m + d * f * h, this._w = c * u * h - d * f * m;
        break;
      case "ZYX":
        this._x = d * u * h - c * f * m, this._y = c * f * h + d * u * m, this._z = c * u * m - d * f * h, this._w = c * u * h + d * f * m;
        break;
      case "YZX":
        this._x = d * u * h + c * f * m, this._y = c * f * h + d * u * m, this._z = c * u * m - d * f * h, this._w = c * u * h - d * f * m;
        break;
      case "XZY":
        this._x = d * u * h - c * f * m, this._y = c * f * h - d * u * m, this._z = c * u * m + d * f * h, this._w = c * u * h + d * f * m;
        break;
      default:
        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + a);
    }
    return t === !0 && this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion from the given axis and angle.
   *
   * @param {Vector3} axis - The normalized axis.
   * @param {number} angle - The angle in radians.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromAxisAngle(e, t) {
    const n = t / 2, i = Math.sin(n);
    return this._x = e.x * i, this._y = e.y * i, this._z = e.z * i, this._w = Math.cos(n), this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion from the given rotation matrix.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromRotationMatrix(e) {
    const t = e.elements, n = t[0], i = t[4], r = t[8], a = t[1], o = t[5], l = t[9], c = t[2], u = t[6], h = t[10], d = n + o + h;
    if (d > 0) {
      const f = 0.5 / Math.sqrt(d + 1);
      this._w = 0.25 / f, this._x = (u - l) * f, this._y = (r - c) * f, this._z = (a - i) * f;
    } else if (n > o && n > h) {
      const f = 2 * Math.sqrt(1 + n - o - h);
      this._w = (u - l) / f, this._x = 0.25 * f, this._y = (i + a) / f, this._z = (r + c) / f;
    } else if (o > h) {
      const f = 2 * Math.sqrt(1 + o - n - h);
      this._w = (r - c) / f, this._x = (i + a) / f, this._y = 0.25 * f, this._z = (l + u) / f;
    } else {
      const f = 2 * Math.sqrt(1 + h - n - o);
      this._w = (a - i) / f, this._x = (r + c) / f, this._y = (l + u) / f, this._z = 0.25 * f;
    }
    return this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion to the rotation required to rotate the direction vector
   * `vFrom` to the direction vector `vTo`.
   *
   * @param {Vector3} vFrom - The first (normalized) direction vector.
   * @param {Vector3} vTo - The second (normalized) direction vector.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromUnitVectors(e, t) {
    let n = e.dot(t) + 1;
    return n < Number.EPSILON ? (n = 0, Math.abs(e.x) > Math.abs(e.z) ? (this._x = -e.y, this._y = e.x, this._z = 0, this._w = n) : (this._x = 0, this._y = -e.z, this._z = e.y, this._w = n)) : (this._x = e.y * t.z - e.z * t.y, this._y = e.z * t.x - e.x * t.z, this._z = e.x * t.y - e.y * t.x, this._w = n), this.normalize();
  }
  /**
   * Returns the angle between this quaternion and the given one in radians.
   *
   * @param {Quaternion} q - The quaternion to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(e) {
    return 2 * Math.acos(Math.abs(Ze(this.dot(e), -1, 1)));
  }
  /**
   * Rotates this quaternion by a given angular step to the given quaternion.
   * The method ensures that the final quaternion will not overshoot `q`.
   *
   * @param {Quaternion} q - The target quaternion.
   * @param {number} step - The angular step in radians.
   * @return {Quaternion} A reference to this quaternion.
   */
  rotateTowards(e, t) {
    const n = this.angleTo(e);
    if (n === 0) return this;
    const i = Math.min(1, t / n);
    return this.slerp(e, i), this;
  }
  /**
   * Sets this quaternion to the identity quaternion; that is, to the
   * quaternion that represents "no rotation".
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  identity() {
    return this.set(0, 0, 0, 1);
  }
  /**
   * Inverts this quaternion via {@link Quaternion#conjugate}. The
   * quaternion is assumed to have unit length.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  invert() {
    return this.conjugate();
  }
  /**
   * Returns the rotational conjugate of this quaternion. The conjugate of a
   * quaternion represents the same rotation in the opposite direction about
   * the rotational axis.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  conjugate() {
    return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
  }
  /**
   * Calculates the dot product of this quaternion and the given one.
   *
   * @param {Quaternion} v - The quaternion to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w;
  }
  /**
   * Computes the squared Euclidean length (straight-line length) of this quaternion,
   * considered as a 4 dimensional vector. This can be useful if you are comparing the
   * lengths of two quaternions, as this is a slightly more efficient calculation than
   * {@link Quaternion#length}.
   *
   * @return {number} The squared Euclidean length.
   */
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  /**
   * Computes the Euclidean length (straight-line length) of this quaternion,
   * considered as a 4 dimensional vector.
   *
   * @return {number} The Euclidean length.
   */
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  /**
   * Normalizes this quaternion - that is, calculated the quaternion that performs
   * the same rotation as this one, but has a length equal to `1`.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  normalize() {
    let e = this.length();
    return e === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e = 1 / e, this._x = this._x * e, this._y = this._y * e, this._z = this._z * e, this._w = this._w * e), this._onChangeCallback(), this;
  }
  /**
   * Multiplies this quaternion by the given one.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  multiply(e) {
    return this.multiplyQuaternions(this, e);
  }
  /**
   * Pre-multiplies this quaternion by the given one.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  premultiply(e) {
    return this.multiplyQuaternions(e, this);
  }
  /**
   * Multiplies the given quaternions and stores the result in this instance.
   *
   * @param {Quaternion} a - The first quaternion.
   * @param {Quaternion} b - The second quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  multiplyQuaternions(e, t) {
    const n = e._x, i = e._y, r = e._z, a = e._w, o = t._x, l = t._y, c = t._z, u = t._w;
    return this._x = n * u + a * o + i * c - r * l, this._y = i * u + a * l + r * o - n * c, this._z = r * u + a * c + n * l - i * o, this._w = a * u - n * o - i * l - r * c, this._onChangeCallback(), this;
  }
  /**
   * Performs a spherical linear interpolation between quaternions.
   *
   * @param {Quaternion} qb - The target quaternion.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {Quaternion} A reference to this quaternion.
   */
  slerp(e, t) {
    if (t === 0) return this;
    if (t === 1) return this.copy(e);
    const n = this._x, i = this._y, r = this._z, a = this._w;
    let o = a * e._w + n * e._x + i * e._y + r * e._z;
    if (o < 0 ? (this._w = -e._w, this._x = -e._x, this._y = -e._y, this._z = -e._z, o = -o) : this.copy(e), o >= 1)
      return this._w = a, this._x = n, this._y = i, this._z = r, this;
    const l = 1 - o * o;
    if (l <= Number.EPSILON) {
      const f = 1 - t;
      return this._w = f * a + t * this._w, this._x = f * n + t * this._x, this._y = f * i + t * this._y, this._z = f * r + t * this._z, this.normalize(), this;
    }
    const c = Math.sqrt(l), u = Math.atan2(c, o), h = Math.sin((1 - t) * u) / c, d = Math.sin(t * u) / c;
    return this._w = a * h + this._w * d, this._x = n * h + this._x * d, this._y = i * h + this._y * d, this._z = r * h + this._z * d, this._onChangeCallback(), this;
  }
  /**
   * Performs a spherical linear interpolation between the given quaternions
   * and stores the result in this quaternion.
   *
   * @param {Quaternion} qa - The source quaternion.
   * @param {Quaternion} qb - The target quaternion.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {Quaternion} A reference to this quaternion.
   */
  slerpQuaternions(e, t, n) {
    return this.copy(e).slerp(t, n);
  }
  /**
   * Sets this quaternion to a uniformly random, normalized quaternion.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  random() {
    const e = 2 * Math.PI * Math.random(), t = 2 * Math.PI * Math.random(), n = Math.random(), i = Math.sqrt(1 - n), r = Math.sqrt(n);
    return this.set(
      i * Math.sin(e),
      i * Math.cos(e),
      r * Math.sin(t),
      r * Math.cos(t)
    );
  }
  /**
   * Returns `true` if this quaternion is equal with the given one.
   *
   * @param {Quaternion} quaternion - The quaternion to test for equality.
   * @return {boolean} Whether this quaternion is equal with the given one.
   */
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w;
  }
  /**
   * Sets this quaternion's components from the given array.
   *
   * @param {Array<number>} array - An array holding the quaternion component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Quaternion} A reference to this quaternion.
   */
  fromArray(e, t = 0) {
    return this._x = e[t], this._y = e[t + 1], this._z = e[t + 2], this._w = e[t + 3], this._onChangeCallback(), this;
  }
  /**
   * Writes the components of this quaternion to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the quaternion components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The quaternion components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._w, e;
  }
  /**
   * Sets the components of this quaternion from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding quaternion data.
   * @param {number} index - The index into the attribute.
   * @return {Quaternion} A reference to this quaternion.
   */
  fromBufferAttribute(e, t) {
    return this._x = e.getX(t), this._y = e.getY(t), this._z = e.getZ(t), this._w = e.getW(t), this._onChangeCallback(), this;
  }
  /**
   * This methods defines the serialization result of this class. Returns the
   * numerical elements of this quaternion in an array of format `[x, y, z, w]`.
   *
   * @return {Array<number>} The serialized quaternion.
   */
  toJSON() {
    return this.toArray();
  }
  _onChange(e) {
    return this._onChangeCallback = e, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._w;
  }
}
class T {
  /**
   * Constructs a new 3D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   * @param {number} [z=0] - The z value of this vector.
   */
  constructor(e = 0, t = 0, n = 0) {
    T.prototype.isVector3 = !0, this.x = e, this.y = t, this.z = n;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @param {number} z - The value of the z component.
   * @return {Vector3} A reference to this vector.
   */
  set(e, t, n) {
    return n === void 0 && (n = this.z), this.x = e, this.y = t, this.z = n, this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector3} A reference to this vector.
   */
  setScalar(e) {
    return this.x = e, this.y = e, this.z = e, this;
  }
  /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setX(e) {
    return this.x = e, this;
  }
  /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setY(e) {
    return this.y = e, this;
  }
  /**
   * Sets the vector's z component to the given value
   *
   * @param {number} z - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setZ(e) {
    return this.z = e, this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
   * @param {number} value - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      case 2:
        this.z = t;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
   * @return {number} A vector component value.
   */
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector3} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector3} v - The vector to copy.
   * @return {Vector3} A reference to this vector.
   */
  copy(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector3} v - The vector to add.
   * @return {Vector3} A reference to this vector.
   */
  add(e) {
    return this.x += e.x, this.y += e.y, this.z += e.z, this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector3} A reference to this vector.
   */
  addScalar(e) {
    return this.x += e, this.y += e, this.z += e, this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  addVectors(e, t) {
    return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector3|Vector4} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector3} A reference to this vector.
   */
  addScaledVector(e, t) {
    return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector3} v - The vector to subtract.
   * @return {Vector3} A reference to this vector.
   */
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this.z -= e.z, this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector3} A reference to this vector.
   */
  subScalar(e) {
    return this.x -= e, this.y -= e, this.z -= e, this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  subVectors(e, t) {
    return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector3} v - The vector to multiply.
   * @return {Vector3} A reference to this vector.
   */
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this.z *= e.z, this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector3} A reference to this vector.
   */
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this.z *= e, this;
  }
  /**
   * Multiplies the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  multiplyVectors(e, t) {
    return this.x = e.x * t.x, this.y = e.y * t.y, this.z = e.z * t.z, this;
  }
  /**
   * Applies the given Euler rotation to this vector.
   *
   * @param {Euler} euler - The Euler angles.
   * @return {Vector3} A reference to this vector.
   */
  applyEuler(e) {
    return this.applyQuaternion(Ic.setFromEuler(e));
  }
  /**
   * Applies a rotation specified by an axis and an angle to this vector.
   *
   * @param {Vector3} axis - A normalized vector representing the rotation axis.
   * @param {number} angle - The angle in radians.
   * @return {Vector3} A reference to this vector.
   */
  applyAxisAngle(e, t) {
    return this.applyQuaternion(Ic.setFromAxisAngle(e, t));
  }
  /**
   * Multiplies this vector with the given 3x3 matrix.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @return {Vector3} A reference to this vector.
   */
  applyMatrix3(e) {
    const t = this.x, n = this.y, i = this.z, r = e.elements;
    return this.x = r[0] * t + r[3] * n + r[6] * i, this.y = r[1] * t + r[4] * n + r[7] * i, this.z = r[2] * t + r[5] * n + r[8] * i, this;
  }
  /**
   * Multiplies this vector by the given normal matrix and normalizes
   * the result.
   *
   * @param {Matrix3} m - The normal matrix.
   * @return {Vector3} A reference to this vector.
   */
  applyNormalMatrix(e) {
    return this.applyMatrix3(e).normalize();
  }
  /**
   * Multiplies this vector (with an implicit 1 in the 4th dimension) by m, and
   * divides by perspective.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {Vector3} A reference to this vector.
   */
  applyMatrix4(e) {
    const t = this.x, n = this.y, i = this.z, r = e.elements, a = 1 / (r[3] * t + r[7] * n + r[11] * i + r[15]);
    return this.x = (r[0] * t + r[4] * n + r[8] * i + r[12]) * a, this.y = (r[1] * t + r[5] * n + r[9] * i + r[13]) * a, this.z = (r[2] * t + r[6] * n + r[10] * i + r[14]) * a, this;
  }
  /**
   * Applies the given Quaternion to this vector.
   *
   * @param {Quaternion} q - The Quaternion.
   * @return {Vector3} A reference to this vector.
   */
  applyQuaternion(e) {
    const t = this.x, n = this.y, i = this.z, r = e.x, a = e.y, o = e.z, l = e.w, c = 2 * (a * i - o * n), u = 2 * (o * t - r * i), h = 2 * (r * n - a * t);
    return this.x = t + l * c + a * h - o * u, this.y = n + l * u + o * c - r * h, this.z = i + l * h + r * u - a * c, this;
  }
  /**
   * Projects this vector from world space into the camera's normalized
   * device coordinate (NDC) space.
   *
   * @param {Camera} camera - The camera.
   * @return {Vector3} A reference to this vector.
   */
  project(e) {
    return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix);
  }
  /**
   * Unprojects this vector from the camera's normalized device coordinate (NDC)
   * space into world space.
   *
   * @param {Camera} camera - The camera.
   * @return {Vector3} A reference to this vector.
   */
  unproject(e) {
    return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld);
  }
  /**
   * Transforms the direction of this vector by a matrix (the upper left 3 x 3
   * subset of the given 4x4 matrix and then normalizes the result.
   *
   * @param {Matrix4} m - The matrix.
   * @return {Vector3} A reference to this vector.
   */
  transformDirection(e) {
    const t = this.x, n = this.y, i = this.z, r = e.elements;
    return this.x = r[0] * t + r[4] * n + r[8] * i, this.y = r[1] * t + r[5] * n + r[9] * i, this.z = r[2] * t + r[6] * n + r[10] * i, this.normalize();
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector3} v - The vector to divide.
   * @return {Vector3} A reference to this vector.
   */
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this.z /= e.z, this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector3} A reference to this vector.
   */
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  /**
   * If this vector's x, y or z value is greater than the given vector's x, y or z
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector3} v - The vector.
   * @return {Vector3} A reference to this vector.
   */
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this;
  }
  /**
   * If this vector's x, y or z value is less than the given vector's x, y or z
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector3} v - The vector.
   * @return {Vector3} A reference to this vector.
   */
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this;
  }
  /**
   * If this vector's x, y or z value is greater than the max vector's x, y or z
   * value, it is replaced by the corresponding value.
   * If this vector's x, y or z value is less than the min vector's x, y or z value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector3} min - The minimum x, y and z values.
   * @param {Vector3} max - The maximum x, y and z values in the desired range.
   * @return {Vector3} A reference to this vector.
   */
  clamp(e, t) {
    return this.x = Ze(this.x, e.x, t.x), this.y = Ze(this.y, e.y, t.y), this.z = Ze(this.z, e.z, t.z), this;
  }
  /**
   * If this vector's x, y or z values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x, y or z values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector3} A reference to this vector.
   */
  clampScalar(e, t) {
    return this.x = Ze(this.x, e, t), this.y = Ze(this.y, e, t), this.z = Ze(this.z, e, t), this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector3} A reference to this vector.
   */
  clampLength(e, t) {
    const n = this.length();
    return this.divideScalar(n || 1).multiplyScalar(Ze(n, e, t));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector3} A reference to this vector.
   */
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x, y = -y and z = -z.
   *
   * @return {Vector3} A reference to this vector.
   */
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector3} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z;
  }
  // TODO lengthSquared?
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0, 0) to (x, y, z). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0, 0) to (x, y, z).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector3} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector3} A reference to this vector.
   */
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector3} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector3} A reference to this vector.
   */
  lerp(e, t) {
    return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector3} v1 - The first vector.
   * @param {Vector3} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector3} A reference to this vector.
   */
  lerpVectors(e, t, n) {
    return this.x = e.x + (t.x - e.x) * n, this.y = e.y + (t.y - e.y) * n, this.z = e.z + (t.z - e.z) * n, this;
  }
  /**
   * Calculates the cross product of the given vector with this instance.
   *
   * @param {Vector3} v - The vector to compute the cross product with.
   * @return {Vector3} The result of the cross product.
   */
  cross(e) {
    return this.crossVectors(this, e);
  }
  /**
   * Calculates the cross product of the given vectors and stores the result
   * in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  crossVectors(e, t) {
    const n = e.x, i = e.y, r = e.z, a = t.x, o = t.y, l = t.z;
    return this.x = i * l - r * o, this.y = r * a - n * l, this.z = n * o - i * a, this;
  }
  /**
   * Projects this vector onto the given one.
   *
   * @param {Vector3} v - The vector to project to.
   * @return {Vector3} A reference to this vector.
   */
  projectOnVector(e) {
    const t = e.lengthSq();
    if (t === 0) return this.set(0, 0, 0);
    const n = e.dot(this) / t;
    return this.copy(e).multiplyScalar(n);
  }
  /**
   * Projects this vector onto a plane by subtracting this
   * vector projected onto the plane's normal from this vector.
   *
   * @param {Vector3} planeNormal - The plane normal.
   * @return {Vector3} A reference to this vector.
   */
  projectOnPlane(e) {
    return Ha.copy(this).projectOnVector(e), this.sub(Ha);
  }
  /**
   * Reflects this vector off a plane orthogonal to the given normal vector.
   *
   * @param {Vector3} normal - The (normalized) normal vector.
   * @return {Vector3} A reference to this vector.
   */
  reflect(e) {
    return this.sub(Ha.copy(e).multiplyScalar(2 * this.dot(e)));
  }
  /**
   * Returns the angle between the given vector and this instance in radians.
   *
   * @param {Vector3} v - The vector to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(e) {
    const t = Math.sqrt(this.lengthSq() * e.lengthSq());
    if (t === 0) return Math.PI / 2;
    const n = this.dot(e) / t;
    return Math.acos(Ze(n, -1, 1));
  }
  /**
   * Computes the distance from the given vector to this instance.
   *
   * @param {Vector3} v - The vector to compute the distance to.
   * @return {number} The distance.
   */
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  /**
   * Computes the squared distance from the given vector to this instance.
   * If you are just comparing the distance with another distance, you should compare
   * the distance squared instead as it is slightly more efficient to calculate.
   *
   * @param {Vector3} v - The vector to compute the squared distance to.
   * @return {number} The squared distance.
   */
  distanceToSquared(e) {
    const t = this.x - e.x, n = this.y - e.y, i = this.z - e.z;
    return t * t + n * n + i * i;
  }
  /**
   * Computes the Manhattan distance from the given vector to this instance.
   *
   * @param {Vector3} v - The vector to compute the Manhattan distance to.
   * @return {number} The Manhattan distance.
   */
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z);
  }
  /**
   * Sets the vector components from the given spherical coordinates.
   *
   * @param {Spherical} s - The spherical coordinates.
   * @return {Vector3} A reference to this vector.
   */
  setFromSpherical(e) {
    return this.setFromSphericalCoords(e.radius, e.phi, e.theta);
  }
  /**
   * Sets the vector components from the given spherical coordinates.
   *
   * @param {number} radius - The radius.
   * @param {number} phi - The phi angle in radians.
   * @param {number} theta - The theta angle in radians.
   * @return {Vector3} A reference to this vector.
   */
  setFromSphericalCoords(e, t, n) {
    const i = Math.sin(t) * e;
    return this.x = i * Math.sin(n), this.y = Math.cos(t) * e, this.z = i * Math.cos(n), this;
  }
  /**
   * Sets the vector components from the given cylindrical coordinates.
   *
   * @param {Cylindrical} c - The cylindrical coordinates.
   * @return {Vector3} A reference to this vector.
   */
  setFromCylindrical(e) {
    return this.setFromCylindricalCoords(e.radius, e.theta, e.y);
  }
  /**
   * Sets the vector components from the given cylindrical coordinates.
   *
   * @param {number} radius - The radius.
   * @param {number} theta - The theta angle in radians.
   * @param {number} y - The y value.
   * @return {Vector3} A reference to this vector.
   */
  setFromCylindricalCoords(e, t, n) {
    return this.x = e * Math.sin(t), this.y = n, this.z = e * Math.cos(t), this;
  }
  /**
   * Sets the vector components to the position elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixPosition(e) {
    const t = e.elements;
    return this.x = t[12], this.y = t[13], this.z = t[14], this;
  }
  /**
   * Sets the vector components to the scale elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixScale(e) {
    const t = this.setFromMatrixColumn(e, 0).length(), n = this.setFromMatrixColumn(e, 1).length(), i = this.setFromMatrixColumn(e, 2).length();
    return this.x = t, this.y = n, this.z = i, this;
  }
  /**
   * Sets the vector components from the specified matrix column.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @param {number} index - The column index.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixColumn(e, t) {
    return this.fromArray(e.elements, t * 4);
  }
  /**
   * Sets the vector components from the specified matrix column.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @param {number} index - The column index.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrix3Column(e, t) {
    return this.fromArray(e.elements, t * 3);
  }
  /**
   * Sets the vector components from the given Euler angles.
   *
   * @param {Euler} e - The Euler angles to set.
   * @return {Vector3} A reference to this vector.
   */
  setFromEuler(e) {
    return this.x = e._x, this.y = e._y, this.z = e._z, this;
  }
  /**
   * Sets the vector components from the RGB components of the
   * given color.
   *
   * @param {Color} c - The color to set.
   * @return {Vector3} A reference to this vector.
   */
  setFromColor(e) {
    return this.x = e.r, this.y = e.g, this.z = e.b, this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector3} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`
   * and z value to be `array[ offset + 2 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector3} A reference to this vector.
   */
  fromArray(e, t = 0) {
    return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector3} A reference to this vector.
   */
  fromBufferAttribute(e, t) {
    return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector3} A reference to this vector.
   */
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
  }
  /**
   * Sets this vector to a uniformly random point on a unit sphere.
   *
   * @return {Vector3} A reference to this vector.
   */
  randomDirection() {
    const e = Math.random() * Math.PI * 2, t = Math.random() * 2 - 1, n = Math.sqrt(1 - t * t);
    return this.x = n * Math.cos(e), this.y = t, this.z = n * Math.sin(e), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z;
  }
}
const Ha = /* @__PURE__ */ new T(), Ic = /* @__PURE__ */ new gn();
class Mt {
  /**
   * Constructs a new bounding box.
   *
   * @param {Vector3} [min=(Infinity,Infinity,Infinity)] - A vector representing the lower boundary of the box.
   * @param {Vector3} [max=(-Infinity,-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
   */
  constructor(e = new T(1 / 0, 1 / 0, 1 / 0), t = new T(-1 / 0, -1 / 0, -1 / 0)) {
    this.isBox3 = !0, this.min = e, this.max = t;
  }
  /**
   * Sets the lower and upper boundaries of this box.
   * Please note that this method only copies the values from the given objects.
   *
   * @param {Vector3} min - The lower boundary of the box.
   * @param {Vector3} max - The upper boundary of the box.
   * @return {Box3} A reference to this bounding box.
   */
  set(e, t) {
    return this.min.copy(e), this.max.copy(t), this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given array.
   *
   * @param {Array<number>} array - An array holding 3D position data.
   * @return {Box3} A reference to this bounding box.
   */
  setFromArray(e) {
    this.makeEmpty();
    for (let t = 0, n = e.length; t < n; t += 3)
      this.expandByPoint(wn.fromArray(e, t));
    return this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - A buffer attribute holding 3D position data.
   * @return {Box3} A reference to this bounding box.
   */
  setFromBufferAttribute(e) {
    this.makeEmpty();
    for (let t = 0, n = e.count; t < n; t++)
      this.expandByPoint(wn.fromBufferAttribute(e, t));
    return this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given array.
   *
   * @param {Array<Vector3>} points - An array holding 3D position data as instances of {@link Vector3}.
   * @return {Box3} A reference to this bounding box.
   */
  setFromPoints(e) {
    this.makeEmpty();
    for (let t = 0, n = e.length; t < n; t++)
      this.expandByPoint(e[t]);
    return this;
  }
  /**
   * Centers this box on the given center vector and sets this box's width, height and
   * depth to the given size values.
   *
   * @param {Vector3} center - The center of the box.
   * @param {Vector3} size - The x, y and z dimensions of the box.
   * @return {Box3} A reference to this bounding box.
   */
  setFromCenterAndSize(e, t) {
    const n = wn.copy(t).multiplyScalar(0.5);
    return this.min.copy(e).sub(n), this.max.copy(e).add(n), this;
  }
  /**
   * Computes the world-axis-aligned bounding box for the given 3D object
   * (including its children), accounting for the object's, and children's,
   * world transforms. The function may result in a larger box than strictly necessary.
   *
   * @param {Object3D} object - The 3D object to compute the bounding box for.
   * @param {boolean} [precise=false] - If set to `true`, the method computes the smallest
   * world-axis-aligned bounding box at the expense of more computation.
   * @return {Box3} A reference to this bounding box.
   */
  setFromObject(e, t = !1) {
    return this.makeEmpty(), this.expandByObject(e, t);
  }
  /**
   * Returns a new box with copied values from this instance.
   *
   * @return {Box3} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given box to this instance.
   *
   * @param {Box3} box - The box to copy.
   * @return {Box3} A reference to this bounding box.
   */
  copy(e) {
    return this.min.copy(e.min), this.max.copy(e.max), this;
  }
  /**
   * Makes this box empty which means in encloses a zero space in 3D.
   *
   * @return {Box3} A reference to this bounding box.
   */
  makeEmpty() {
    return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
  }
  /**
   * Returns true if this box includes zero points within its bounds.
   * Note that a box with equal lower and upper bounds still includes one
   * point, the one both bounds share.
   *
   * @return {boolean} Whether this box is empty or not.
   */
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  /**
   * Returns the center point of this box.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The center point.
   */
  getCenter(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  /**
   * Returns the dimensions of this box.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The size.
   */
  getSize(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.subVectors(this.max, this.min);
  }
  /**
   * Expands the boundaries of this box to include the given point.
   *
   * @param {Vector3} point - The point that should be included by the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByPoint(e) {
    return this.min.min(e), this.max.max(e), this;
  }
  /**
   * Expands this box equilaterally by the given vector. The width of this
   * box will be expanded by the x component of the vector in both
   * directions. The height of this box will be expanded by the y component of
   * the vector in both directions. The depth of this box will be
   * expanded by the z component of the vector in both directions.
   *
   * @param {Vector3} vector - The vector that should expand the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByVector(e) {
    return this.min.sub(e), this.max.add(e), this;
  }
  /**
   * Expands each dimension of the box by the given scalar. If negative, the
   * dimensions of the box will be contracted.
   *
   * @param {number} scalar - The scalar value that should expand the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByScalar(e) {
    return this.min.addScalar(-e), this.max.addScalar(e), this;
  }
  /**
   * Expands the boundaries of this box to include the given 3D object and
   * its children, accounting for the object's, and children's, world
   * transforms. The function may result in a larger box than strictly
   * necessary (unless the precise parameter is set to true).
   *
   * @param {Object3D} object - The 3D object that should expand the bounding box.
   * @param {boolean} precise - If set to `true`, the method expands the bounding box
   * as little as necessary at the expense of more computation.
   * @return {Box3} A reference to this bounding box.
   */
  expandByObject(e, t = !1) {
    e.updateWorldMatrix(!1, !1);
    const n = e.geometry;
    if (n !== void 0) {
      const r = n.getAttribute("position");
      if (t === !0 && r !== void 0 && e.isInstancedMesh !== !0)
        for (let a = 0, o = r.count; a < o; a++)
          e.isMesh === !0 ? e.getVertexPosition(a, wn) : wn.fromBufferAttribute(r, a), wn.applyMatrix4(e.matrixWorld), this.expandByPoint(wn);
      else
        e.boundingBox !== void 0 ? (e.boundingBox === null && e.computeBoundingBox(), Lr.copy(e.boundingBox)) : (n.boundingBox === null && n.computeBoundingBox(), Lr.copy(n.boundingBox)), Lr.applyMatrix4(e.matrixWorld), this.union(Lr);
    }
    const i = e.children;
    for (let r = 0, a = i.length; r < a; r++)
      this.expandByObject(i[r], t);
    return this;
  }
  /**
   * Returns `true` if the given point lies within or on the boundaries of this box.
   *
   * @param {Vector3} point - The point to test.
   * @return {boolean} Whether the bounding box contains the given point or not.
   */
  containsPoint(e) {
    return e.x >= this.min.x && e.x <= this.max.x && e.y >= this.min.y && e.y <= this.max.y && e.z >= this.min.z && e.z <= this.max.z;
  }
  /**
   * Returns `true` if this bounding box includes the entirety of the given bounding box.
   * If this box and the given one are identical, this function also returns `true`.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the bounding box contains the given bounding box or not.
   */
  containsBox(e) {
    return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y && this.min.z <= e.min.z && e.max.z <= this.max.z;
  }
  /**
   * Returns a point as a proportion of this box's width, height and depth.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} A point as a proportion of this box's width, height and depth.
   */
  getParameter(e, t) {
    return t.set(
      (e.x - this.min.x) / (this.max.x - this.min.x),
      (e.y - this.min.y) / (this.max.y - this.min.y),
      (e.z - this.min.z) / (this.max.z - this.min.z)
    );
  }
  /**
   * Returns `true` if the given bounding box intersects with this bounding box.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the given bounding box intersects with this bounding box.
   */
  intersectsBox(e) {
    return e.max.x >= this.min.x && e.min.x <= this.max.x && e.max.y >= this.min.y && e.min.y <= this.max.y && e.max.z >= this.min.z && e.min.z <= this.max.z;
  }
  /**
   * Returns `true` if the given bounding sphere intersects with this bounding box.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the given bounding sphere intersects with this bounding box.
   */
  intersectsSphere(e) {
    return this.clampPoint(e.center, wn), wn.distanceToSquared(e.center) <= e.radius * e.radius;
  }
  /**
   * Returns `true` if the given plane intersects with this bounding box.
   *
   * @param {Plane} plane - The plane to test.
   * @return {boolean} Whether the given plane intersects with this bounding box.
   */
  intersectsPlane(e) {
    let t, n;
    return e.normal.x > 0 ? (t = e.normal.x * this.min.x, n = e.normal.x * this.max.x) : (t = e.normal.x * this.max.x, n = e.normal.x * this.min.x), e.normal.y > 0 ? (t += e.normal.y * this.min.y, n += e.normal.y * this.max.y) : (t += e.normal.y * this.max.y, n += e.normal.y * this.min.y), e.normal.z > 0 ? (t += e.normal.z * this.min.z, n += e.normal.z * this.max.z) : (t += e.normal.z * this.max.z, n += e.normal.z * this.min.z), t <= -e.constant && n >= -e.constant;
  }
  /**
   * Returns `true` if the given triangle intersects with this bounding box.
   *
   * @param {Triangle} triangle - The triangle to test.
   * @return {boolean} Whether the given triangle intersects with this bounding box.
   */
  intersectsTriangle(e) {
    if (this.isEmpty())
      return !1;
    this.getCenter(Qs), Ir.subVectors(this.max, Qs), ss.subVectors(e.a, Qs), rs.subVectors(e.b, Qs), as.subVectors(e.c, Qs), vi.subVectors(rs, ss), yi.subVectors(as, rs), ki.subVectors(ss, as);
    let t = [
      0,
      -vi.z,
      vi.y,
      0,
      -yi.z,
      yi.y,
      0,
      -ki.z,
      ki.y,
      vi.z,
      0,
      -vi.x,
      yi.z,
      0,
      -yi.x,
      ki.z,
      0,
      -ki.x,
      -vi.y,
      vi.x,
      0,
      -yi.y,
      yi.x,
      0,
      -ki.y,
      ki.x,
      0
    ];
    return !Va(t, ss, rs, as, Ir) || (t = [1, 0, 0, 0, 1, 0, 0, 0, 1], !Va(t, ss, rs, as, Ir)) ? !1 : (Dr.crossVectors(vi, yi), t = [Dr.x, Dr.y, Dr.z], Va(t, ss, rs, as, Ir));
  }
  /**
   * Clamps the given point within the bounds of this box.
   *
   * @param {Vector3} point - The point to clamp.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The clamped point.
   */
  clampPoint(e, t) {
    return t.copy(e).clamp(this.min, this.max);
  }
  /**
   * Returns the euclidean distance from any edge of this box to the specified point. If
   * the given point lies inside of this box, the distance will be `0`.
   *
   * @param {Vector3} point - The point to compute the distance to.
   * @return {number} The euclidean distance.
   */
  distanceToPoint(e) {
    return this.clampPoint(e, wn).distanceTo(e);
  }
  /**
   * Returns a bounding sphere that encloses this bounding box.
   *
   * @param {Sphere} target - The target sphere that is used to store the method's result.
   * @return {Sphere} The bounding sphere that encloses this bounding box.
   */
  getBoundingSphere(e) {
    return this.isEmpty() ? e.makeEmpty() : (this.getCenter(e.center), e.radius = this.getSize(wn).length() * 0.5), e;
  }
  /**
   * Computes the intersection of this bounding box and the given one, setting the upper
   * bound of this box to the lesser of the two boxes' upper bounds and the
   * lower bound of this box to the greater of the two boxes' lower bounds. If
   * there's no overlap, makes this box empty.
   *
   * @param {Box3} box - The bounding box to intersect with.
   * @return {Box3} A reference to this bounding box.
   */
  intersect(e) {
    return this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this;
  }
  /**
   * Computes the union of this box and another and the given one, setting the upper
   * bound of this box to the greater of the two boxes' upper bounds and the
   * lower bound of this box to the lesser of the two boxes' lower bounds.
   *
   * @param {Box3} box - The bounding box that will be unioned with this instance.
   * @return {Box3} A reference to this bounding box.
   */
  union(e) {
    return this.min.min(e.min), this.max.max(e.max), this;
  }
  /**
   * Transforms this bounding box by the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @return {Box3} A reference to this bounding box.
   */
  applyMatrix4(e) {
    return this.isEmpty() ? this : (ti[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e), ti[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e), ti[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e), ti[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e), ti[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e), ti[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e), ti[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e), ti[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e), this.setFromPoints(ti), this);
  }
  /**
   * Adds the given offset to both the upper and lower bounds of this bounding box,
   * effectively moving it in 3D space.
   *
   * @param {Vector3} offset - The offset that should be used to translate the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  translate(e) {
    return this.min.add(e), this.max.add(e), this;
  }
  /**
   * Returns `true` if this bounding box is equal with the given one.
   *
   * @param {Box3} box - The box to test for equality.
   * @return {boolean} Whether this bounding box is equal with the given one.
   */
  equals(e) {
    return e.min.equals(this.min) && e.max.equals(this.max);
  }
}
const ti = [
  /* @__PURE__ */ new T(),
  /* @__PURE__ */ new T(),
  /* @__PURE__ */ new T(),
  /* @__PURE__ */ new T(),
  /* @__PURE__ */ new T(),
  /* @__PURE__ */ new T(),
  /* @__PURE__ */ new T(),
  /* @__PURE__ */ new T()
], wn = /* @__PURE__ */ new T(), Lr = /* @__PURE__ */ new Mt(), ss = /* @__PURE__ */ new T(), rs = /* @__PURE__ */ new T(), as = /* @__PURE__ */ new T(), vi = /* @__PURE__ */ new T(), yi = /* @__PURE__ */ new T(), ki = /* @__PURE__ */ new T(), Qs = /* @__PURE__ */ new T(), Ir = /* @__PURE__ */ new T(), Dr = /* @__PURE__ */ new T(), zi = /* @__PURE__ */ new T();
function Va(s, e, t, n, i) {
  for (let r = 0, a = s.length - 3; r <= a; r += 3) {
    zi.fromArray(s, r);
    const o = i.x * Math.abs(zi.x) + i.y * Math.abs(zi.y) + i.z * Math.abs(zi.z), l = e.dot(zi), c = t.dot(zi), u = n.dot(zi);
    if (Math.max(-Math.max(l, c, u), Math.min(l, c, u)) > o)
      return !1;
  }
  return !0;
}
const Uf = /* @__PURE__ */ new Mt(), er = /* @__PURE__ */ new T(), Ga = /* @__PURE__ */ new T();
class Mn {
  /**
   * Constructs a new sphere.
   *
   * @param {Vector3} [center=(0,0,0)] - The center of the sphere
   * @param {number} [radius=-1] - The radius of the sphere.
   */
  constructor(e = new T(), t = -1) {
    this.isSphere = !0, this.center = e, this.radius = t;
  }
  /**
   * Sets the sphere's components by copying the given values.
   *
   * @param {Vector3} center - The center.
   * @param {number} radius - The radius.
   * @return {Sphere} A reference to this sphere.
   */
  set(e, t) {
    return this.center.copy(e), this.radius = t, this;
  }
  /**
   * Computes the minimum bounding sphere for list of points.
   * If the optional center point is given, it is used as the sphere's
   * center. Otherwise, the center of the axis-aligned bounding box
   * encompassing the points is calculated.
   *
   * @param {Array<Vector3>} points - A list of points in 3D space.
   * @param {Vector3} [optionalCenter] - The center of the sphere.
   * @return {Sphere} A reference to this sphere.
   */
  setFromPoints(e, t) {
    const n = this.center;
    t !== void 0 ? n.copy(t) : Uf.setFromPoints(e).getCenter(n);
    let i = 0;
    for (let r = 0, a = e.length; r < a; r++)
      i = Math.max(i, n.distanceToSquared(e[r]));
    return this.radius = Math.sqrt(i), this;
  }
  /**
   * Copies the values of the given sphere to this instance.
   *
   * @param {Sphere} sphere - The sphere to copy.
   * @return {Sphere} A reference to this sphere.
   */
  copy(e) {
    return this.center.copy(e.center), this.radius = e.radius, this;
  }
  /**
   * Returns `true` if the sphere is empty (the radius set to a negative number).
   *
   * Spheres with a radius of `0` contain only their center point and are not
   * considered to be empty.
   *
   * @return {boolean} Whether this sphere is empty or not.
   */
  isEmpty() {
    return this.radius < 0;
  }
  /**
   * Makes this sphere empty which means in encloses a zero space in 3D.
   *
   * @return {Sphere} A reference to this sphere.
   */
  makeEmpty() {
    return this.center.set(0, 0, 0), this.radius = -1, this;
  }
  /**
   * Returns `true` if this sphere contains the given point inclusive of
   * the surface of the sphere.
   *
   * @param {Vector3} point - The point to check.
   * @return {boolean} Whether this sphere contains the given point or not.
   */
  containsPoint(e) {
    return e.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  /**
   * Returns the closest distance from the boundary of the sphere to the
   * given point. If the sphere contains the point, the distance will
   * be negative.
   *
   * @param {Vector3} point - The point to compute the distance to.
   * @return {number} The distance to the point.
   */
  distanceToPoint(e) {
    return e.distanceTo(this.center) - this.radius;
  }
  /**
   * Returns `true` if this sphere intersects with the given one.
   *
   * @param {Sphere} sphere - The sphere to test.
   * @return {boolean} Whether this sphere intersects with the given one or not.
   */
  intersectsSphere(e) {
    const t = this.radius + e.radius;
    return e.center.distanceToSquared(this.center) <= t * t;
  }
  /**
   * Returns `true` if this sphere intersects with the given box.
   *
   * @param {Box3} box - The box to test.
   * @return {boolean} Whether this sphere intersects with the given box or not.
   */
  intersectsBox(e) {
    return e.intersectsSphere(this);
  }
  /**
   * Returns `true` if this sphere intersects with the given plane.
   *
   * @param {Plane} plane - The plane to test.
   * @return {boolean} Whether this sphere intersects with the given plane or not.
   */
  intersectsPlane(e) {
    return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
  }
  /**
   * Clamps a point within the sphere. If the point is outside the sphere, it
   * will clamp it to the closest point on the edge of the sphere. Points
   * already inside the sphere will not be affected.
   *
   * @param {Vector3} point - The plane to clamp.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The clamped point.
   */
  clampPoint(e, t) {
    const n = this.center.distanceToSquared(e);
    return t.copy(e), n > this.radius * this.radius && (t.sub(this.center).normalize(), t.multiplyScalar(this.radius).add(this.center)), t;
  }
  /**
   * Returns a bounding box that encloses this sphere.
   *
   * @param {Box3} target - The target box that is used to store the method's result.
   * @return {Box3} The bounding box that encloses this sphere.
   */
  getBoundingBox(e) {
    return this.isEmpty() ? (e.makeEmpty(), e) : (e.set(this.center, this.center), e.expandByScalar(this.radius), e);
  }
  /**
   * Transforms this sphere with the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @return {Sphere} A reference to this sphere.
   */
  applyMatrix4(e) {
    return this.center.applyMatrix4(e), this.radius = this.radius * e.getMaxScaleOnAxis(), this;
  }
  /**
   * Translates the sphere's center by the given offset.
   *
   * @param {Vector3} offset - The offset.
   * @return {Sphere} A reference to this sphere.
   */
  translate(e) {
    return this.center.add(e), this;
  }
  /**
   * Expands the boundaries of this sphere to include the given point.
   *
   * @param {Vector3} point - The point to include.
   * @return {Sphere} A reference to this sphere.
   */
  expandByPoint(e) {
    if (this.isEmpty())
      return this.center.copy(e), this.radius = 0, this;
    er.subVectors(e, this.center);
    const t = er.lengthSq();
    if (t > this.radius * this.radius) {
      const n = Math.sqrt(t), i = (n - this.radius) * 0.5;
      this.center.addScaledVector(er, i / n), this.radius += i;
    }
    return this;
  }
  /**
   * Expands this sphere to enclose both the original sphere and the given sphere.
   *
   * @param {Sphere} sphere - The sphere to include.
   * @return {Sphere} A reference to this sphere.
   */
  union(e) {
    return e.isEmpty() ? this : this.isEmpty() ? (this.copy(e), this) : (this.center.equals(e.center) === !0 ? this.radius = Math.max(this.radius, e.radius) : (Ga.subVectors(e.center, this.center).setLength(e.radius), this.expandByPoint(er.copy(e.center).add(Ga)), this.expandByPoint(er.copy(e.center).sub(Ga))), this);
  }
  /**
   * Returns `true` if this sphere is equal with the given one.
   *
   * @param {Sphere} sphere - The sphere to test for equality.
   * @return {boolean} Whether this bounding sphere is equal with the given one.
   */
  equals(e) {
    return e.center.equals(this.center) && e.radius === this.radius;
  }
  /**
   * Returns a new sphere with copied values from this instance.
   *
   * @return {Sphere} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
const ni = /* @__PURE__ */ new T(), Wa = /* @__PURE__ */ new T(), Nr = /* @__PURE__ */ new T(), Si = /* @__PURE__ */ new T(), Xa = /* @__PURE__ */ new T(), Ur = /* @__PURE__ */ new T(), qa = /* @__PURE__ */ new T();
class Ar {
  /**
   * Constructs a new ray.
   *
   * @param {Vector3} [origin=(0,0,0)] - The origin of the ray.
   * @param {Vector3} [direction=(0,0,-1)] - The (normalized) direction of the ray.
   */
  constructor(e = new T(), t = new T(0, 0, -1)) {
    this.origin = e, this.direction = t;
  }
  /**
   * Sets the ray's components by copying the given values.
   *
   * @param {Vector3} origin - The origin.
   * @param {Vector3} direction - The direction.
   * @return {Ray} A reference to this ray.
   */
  set(e, t) {
    return this.origin.copy(e), this.direction.copy(t), this;
  }
  /**
   * Copies the values of the given ray to this instance.
   *
   * @param {Ray} ray - The ray to copy.
   * @return {Ray} A reference to this ray.
   */
  copy(e) {
    return this.origin.copy(e.origin), this.direction.copy(e.direction), this;
  }
  /**
   * Returns a vector that is located at a given distance along this ray.
   *
   * @param {number} t - The distance along the ray to retrieve a position for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} A position on the ray.
   */
  at(e, t) {
    return t.copy(this.origin).addScaledVector(this.direction, e);
  }
  /**
   * Adjusts the direction of the ray to point at the given vector in world space.
   *
   * @param {Vector3} v - The target position.
   * @return {Ray} A reference to this ray.
   */
  lookAt(e) {
    return this.direction.copy(e).sub(this.origin).normalize(), this;
  }
  /**
   * Shift the origin of this ray along its direction by the given distance.
   *
   * @param {number} t - The distance along the ray to interpolate.
   * @return {Ray} A reference to this ray.
   */
  recast(e) {
    return this.origin.copy(this.at(e, ni)), this;
  }
  /**
   * Returns the point along this ray that is closest to the given point.
   *
   * @param {Vector3} point - A point in 3D space to get the closet location on the ray for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The closest point on this ray.
   */
  closestPointToPoint(e, t) {
    t.subVectors(e, this.origin);
    const n = t.dot(this.direction);
    return n < 0 ? t.copy(this.origin) : t.copy(this.origin).addScaledVector(this.direction, n);
  }
  /**
   * Returns the distance of the closest approach between this ray and the given point.
   *
   * @param {Vector3} point - A point in 3D space to compute the distance to.
   * @return {number} The distance.
   */
  distanceToPoint(e) {
    return Math.sqrt(this.distanceSqToPoint(e));
  }
  /**
   * Returns the squared distance of the closest approach between this ray and the given point.
   *
   * @param {Vector3} point - A point in 3D space to compute the distance to.
   * @return {number} The squared distance.
   */
  distanceSqToPoint(e) {
    const t = ni.subVectors(e, this.origin).dot(this.direction);
    return t < 0 ? this.origin.distanceToSquared(e) : (ni.copy(this.origin).addScaledVector(this.direction, t), ni.distanceToSquared(e));
  }
  /**
   * Returns the squared distance between this ray and the given line segment.
   *
   * @param {Vector3} v0 - The start point of the line segment.
   * @param {Vector3} v1 - The end point of the line segment.
   * @param {Vector3} [optionalPointOnRay] - When provided, it receives the point on this ray that is closest to the segment.
   * @param {Vector3} [optionalPointOnSegment] - When provided, it receives the point on the line segment that is closest to this ray.
   * @return {number} The squared distance.
   */
  distanceSqToSegment(e, t, n, i) {
    Wa.copy(e).add(t).multiplyScalar(0.5), Nr.copy(t).sub(e).normalize(), Si.copy(this.origin).sub(Wa);
    const r = e.distanceTo(t) * 0.5, a = -this.direction.dot(Nr), o = Si.dot(this.direction), l = -Si.dot(Nr), c = Si.lengthSq(), u = Math.abs(1 - a * a);
    let h, d, f, m;
    if (u > 0)
      if (h = a * l - o, d = a * o - l, m = r * u, h >= 0)
        if (d >= -m)
          if (d <= m) {
            const _ = 1 / u;
            h *= _, d *= _, f = h * (h + a * d + 2 * o) + d * (a * h + d + 2 * l) + c;
          } else
            d = r, h = Math.max(0, -(a * d + o)), f = -h * h + d * (d + 2 * l) + c;
        else
          d = -r, h = Math.max(0, -(a * d + o)), f = -h * h + d * (d + 2 * l) + c;
      else
        d <= -m ? (h = Math.max(0, -(-a * r + o)), d = h > 0 ? -r : Math.min(Math.max(-r, -l), r), f = -h * h + d * (d + 2 * l) + c) : d <= m ? (h = 0, d = Math.min(Math.max(-r, -l), r), f = d * (d + 2 * l) + c) : (h = Math.max(0, -(a * r + o)), d = h > 0 ? r : Math.min(Math.max(-r, -l), r), f = -h * h + d * (d + 2 * l) + c);
    else
      d = a > 0 ? -r : r, h = Math.max(0, -(a * d + o)), f = -h * h + d * (d + 2 * l) + c;
    return n && n.copy(this.origin).addScaledVector(this.direction, h), i && i.copy(Wa).addScaledVector(Nr, d), f;
  }
  /**
   * Intersects this ray with the given sphere, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Sphere} sphere - The sphere to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectSphere(e, t) {
    ni.subVectors(e.center, this.origin);
    const n = ni.dot(this.direction), i = ni.dot(ni) - n * n, r = e.radius * e.radius;
    if (i > r) return null;
    const a = Math.sqrt(r - i), o = n - a, l = n + a;
    return l < 0 ? null : o < 0 ? this.at(l, t) : this.at(o, t);
  }
  /**
   * Returns `true` if this ray intersects with the given sphere.
   *
   * @param {Sphere} sphere - The sphere to intersect.
   * @return {boolean} Whether this ray intersects with the given sphere or not.
   */
  intersectsSphere(e) {
    return this.distanceSqToPoint(e.center) <= e.radius * e.radius;
  }
  /**
   * Computes the distance from the ray's origin to the given plane. Returns `null` if the ray
   * does not intersect with the plane.
   *
   * @param {Plane} plane - The plane to compute the distance to.
   * @return {?number} Whether this ray intersects with the given sphere or not.
   */
  distanceToPlane(e) {
    const t = e.normal.dot(this.direction);
    if (t === 0)
      return e.distanceToPoint(this.origin) === 0 ? 0 : null;
    const n = -(this.origin.dot(e.normal) + e.constant) / t;
    return n >= 0 ? n : null;
  }
  /**
   * Intersects this ray with the given plane, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Plane} plane - The plane to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectPlane(e, t) {
    const n = this.distanceToPlane(e);
    return n === null ? null : this.at(n, t);
  }
  /**
   * Returns `true` if this ray intersects with the given plane.
   *
   * @param {Plane} plane - The plane to intersect.
   * @return {boolean} Whether this ray intersects with the given plane or not.
   */
  intersectsPlane(e) {
    const t = e.distanceToPoint(this.origin);
    return t === 0 || e.normal.dot(this.direction) * t < 0;
  }
  /**
   * Intersects this ray with the given bounding box, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Box3} box - The box to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectBox(e, t) {
    let n, i, r, a, o, l;
    const c = 1 / this.direction.x, u = 1 / this.direction.y, h = 1 / this.direction.z, d = this.origin;
    return c >= 0 ? (n = (e.min.x - d.x) * c, i = (e.max.x - d.x) * c) : (n = (e.max.x - d.x) * c, i = (e.min.x - d.x) * c), u >= 0 ? (r = (e.min.y - d.y) * u, a = (e.max.y - d.y) * u) : (r = (e.max.y - d.y) * u, a = (e.min.y - d.y) * u), n > a || r > i || ((r > n || isNaN(n)) && (n = r), (a < i || isNaN(i)) && (i = a), h >= 0 ? (o = (e.min.z - d.z) * h, l = (e.max.z - d.z) * h) : (o = (e.max.z - d.z) * h, l = (e.min.z - d.z) * h), n > l || o > i) || ((o > n || n !== n) && (n = o), (l < i || i !== i) && (i = l), i < 0) ? null : this.at(n >= 0 ? n : i, t);
  }
  /**
   * Returns `true` if this ray intersects with the given box.
   *
   * @param {Box3} box - The box to intersect.
   * @return {boolean} Whether this ray intersects with the given box or not.
   */
  intersectsBox(e) {
    return this.intersectBox(e, ni) !== null;
  }
  /**
   * Intersects this ray with the given triangle, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Vector3} a - The first vertex of the triangle.
   * @param {Vector3} b - The second vertex of the triangle.
   * @param {Vector3} c - The third vertex of the triangle.
   * @param {boolean} backfaceCulling - Whether to use backface culling or not.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectTriangle(e, t, n, i, r) {
    Xa.subVectors(t, e), Ur.subVectors(n, e), qa.crossVectors(Xa, Ur);
    let a = this.direction.dot(qa), o;
    if (a > 0) {
      if (i) return null;
      o = 1;
    } else if (a < 0)
      o = -1, a = -a;
    else
      return null;
    Si.subVectors(this.origin, e);
    const l = o * this.direction.dot(Ur.crossVectors(Si, Ur));
    if (l < 0)
      return null;
    const c = o * this.direction.dot(Xa.cross(Si));
    if (c < 0 || l + c > a)
      return null;
    const u = -o * Si.dot(qa);
    return u < 0 ? null : this.at(u / a, r);
  }
  /**
   * Transforms this ray with the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix4 - The transformation matrix.
   * @return {Ray} A reference to this ray.
   */
  applyMatrix4(e) {
    return this.origin.applyMatrix4(e), this.direction.transformDirection(e), this;
  }
  /**
   * Returns `true` if this ray is equal with the given one.
   *
   * @param {Ray} ray - The ray to test for equality.
   * @return {boolean} Whether this ray is equal with the given one.
   */
  equals(e) {
    return e.origin.equals(this.origin) && e.direction.equals(this.direction);
  }
  /**
   * Returns a new ray with copied values from this instance.
   *
   * @return {Ray} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
class Ye {
  /**
   * Constructs a new 4x4 matrix. The arguments are supposed to be
   * in row-major order. If no arguments are provided, the constructor
   * initializes the matrix as an identity matrix.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n14] - 1-4 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n24] - 2-4 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @param {number} [n34] - 3-4 matrix element.
   * @param {number} [n41] - 4-1 matrix element.
   * @param {number} [n42] - 4-2 matrix element.
   * @param {number} [n43] - 4-3 matrix element.
   * @param {number} [n44] - 4-4 matrix element.
   */
  constructor(e, t, n, i, r, a, o, l, c, u, h, d, f, m, _, g) {
    Ye.prototype.isMatrix4 = !0, this.elements = [
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ], e !== void 0 && this.set(e, t, n, i, r, a, o, l, c, u, h, d, f, m, _, g);
  }
  /**
   * Sets the elements of the matrix.The arguments are supposed to be
   * in row-major order.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n14] - 1-4 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n24] - 2-4 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @param {number} [n34] - 3-4 matrix element.
   * @param {number} [n41] - 4-1 matrix element.
   * @param {number} [n42] - 4-2 matrix element.
   * @param {number} [n43] - 4-3 matrix element.
   * @param {number} [n44] - 4-4 matrix element.
   * @return {Matrix4} A reference to this matrix.
   */
  set(e, t, n, i, r, a, o, l, c, u, h, d, f, m, _, g) {
    const p = this.elements;
    return p[0] = e, p[4] = t, p[8] = n, p[12] = i, p[1] = r, p[5] = a, p[9] = o, p[13] = l, p[2] = c, p[6] = u, p[10] = h, p[14] = d, p[3] = f, p[7] = m, p[11] = _, p[15] = g, this;
  }
  /**
   * Sets this matrix to the 4x4 identity matrix.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Returns a matrix with copied values from this instance.
   *
   * @return {Matrix4} A clone of this instance.
   */
  clone() {
    return new Ye().fromArray(this.elements);
  }
  /**
   * Copies the values of the given matrix to this instance.
   *
   * @param {Matrix4} m - The matrix to copy.
   * @return {Matrix4} A reference to this matrix.
   */
  copy(e) {
    const t = this.elements, n = e.elements;
    return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], t[9] = n[9], t[10] = n[10], t[11] = n[11], t[12] = n[12], t[13] = n[13], t[14] = n[14], t[15] = n[15], this;
  }
  /**
   * Copies the translation component of the given matrix
   * into this matrix's translation component.
   *
   * @param {Matrix4} m - The matrix to copy the translation component.
   * @return {Matrix4} A reference to this matrix.
   */
  copyPosition(e) {
    const t = this.elements, n = e.elements;
    return t[12] = n[12], t[13] = n[13], t[14] = n[14], this;
  }
  /**
   * Set the upper 3x3 elements of this matrix to the values of given 3x3 matrix.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  setFromMatrix3(e) {
    const t = e.elements;
    return this.set(
      t[0],
      t[3],
      t[6],
      0,
      t[1],
      t[4],
      t[7],
      0,
      t[2],
      t[5],
      t[8],
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Extracts the basis of this matrix into the three axis vectors provided.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  extractBasis(e, t, n) {
    return e.setFromMatrixColumn(this, 0), t.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this;
  }
  /**
   * Sets the given basis vectors to this matrix.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeBasis(e, t, n) {
    return this.set(
      e.x,
      t.x,
      n.x,
      0,
      e.y,
      t.y,
      n.y,
      0,
      e.z,
      t.z,
      n.z,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Extracts the rotation component of the given matrix
   * into this matrix's rotation component.
   *
   * Note: This method does not support reflection matrices.
   *
   * @param {Matrix4} m - The matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  extractRotation(e) {
    const t = this.elements, n = e.elements, i = 1 / os.setFromMatrixColumn(e, 0).length(), r = 1 / os.setFromMatrixColumn(e, 1).length(), a = 1 / os.setFromMatrixColumn(e, 2).length();
    return t[0] = n[0] * i, t[1] = n[1] * i, t[2] = n[2] * i, t[3] = 0, t[4] = n[4] * r, t[5] = n[5] * r, t[6] = n[6] * r, t[7] = 0, t[8] = n[8] * a, t[9] = n[9] * a, t[10] = n[10] * a, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
  }
  /**
   * Sets the rotation component (the upper left 3x3 matrix) of this matrix to
   * the rotation specified by the given Euler angles. The rest of
   * the matrix is set to the identity. Depending on the {@link Euler#order},
   * there are six possible outcomes. See [this page]{@link https://en.wikipedia.org/wiki/Euler_angles#Rotation_matrix}
   * for a complete list.
   *
   * @param {Euler} euler - The Euler angles.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationFromEuler(e) {
    const t = this.elements, n = e.x, i = e.y, r = e.z, a = Math.cos(n), o = Math.sin(n), l = Math.cos(i), c = Math.sin(i), u = Math.cos(r), h = Math.sin(r);
    if (e.order === "XYZ") {
      const d = a * u, f = a * h, m = o * u, _ = o * h;
      t[0] = l * u, t[4] = -l * h, t[8] = c, t[1] = f + m * c, t[5] = d - _ * c, t[9] = -o * l, t[2] = _ - d * c, t[6] = m + f * c, t[10] = a * l;
    } else if (e.order === "YXZ") {
      const d = l * u, f = l * h, m = c * u, _ = c * h;
      t[0] = d + _ * o, t[4] = m * o - f, t[8] = a * c, t[1] = a * h, t[5] = a * u, t[9] = -o, t[2] = f * o - m, t[6] = _ + d * o, t[10] = a * l;
    } else if (e.order === "ZXY") {
      const d = l * u, f = l * h, m = c * u, _ = c * h;
      t[0] = d - _ * o, t[4] = -a * h, t[8] = m + f * o, t[1] = f + m * o, t[5] = a * u, t[9] = _ - d * o, t[2] = -a * c, t[6] = o, t[10] = a * l;
    } else if (e.order === "ZYX") {
      const d = a * u, f = a * h, m = o * u, _ = o * h;
      t[0] = l * u, t[4] = m * c - f, t[8] = d * c + _, t[1] = l * h, t[5] = _ * c + d, t[9] = f * c - m, t[2] = -c, t[6] = o * l, t[10] = a * l;
    } else if (e.order === "YZX") {
      const d = a * l, f = a * c, m = o * l, _ = o * c;
      t[0] = l * u, t[4] = _ - d * h, t[8] = m * h + f, t[1] = h, t[5] = a * u, t[9] = -o * u, t[2] = -c * u, t[6] = f * h + m, t[10] = d - _ * h;
    } else if (e.order === "XZY") {
      const d = a * l, f = a * c, m = o * l, _ = o * c;
      t[0] = l * u, t[4] = -h, t[8] = c * u, t[1] = d * h + _, t[5] = a * u, t[9] = f * h - m, t[2] = m * h - f, t[6] = o * u, t[10] = _ * h + d;
    }
    return t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
  }
  /**
   * Sets the rotation component of this matrix to the rotation specified by
   * the given Quaternion as outlined [here]{@link https://en.wikipedia.org/wiki/Rotation_matrix#Quaternion}
   * The rest of the matrix is set to the identity.
   *
   * @param {Quaternion} q - The Quaternion.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationFromQuaternion(e) {
    return this.compose(Ff, e, Of);
  }
  /**
   * Sets the rotation component of the transformation matrix, looking from `eye` towards
   * `target`, and oriented by the up-direction.
   *
   * @param {Vector3} eye - The eye vector.
   * @param {Vector3} target - The target vector.
   * @param {Vector3} up - The up vector.
   * @return {Matrix4} A reference to this matrix.
   */
  lookAt(e, t, n) {
    const i = this.elements;
    return fn.subVectors(e, t), fn.lengthSq() === 0 && (fn.z = 1), fn.normalize(), Mi.crossVectors(n, fn), Mi.lengthSq() === 0 && (Math.abs(n.z) === 1 ? fn.x += 1e-4 : fn.z += 1e-4, fn.normalize(), Mi.crossVectors(n, fn)), Mi.normalize(), Fr.crossVectors(fn, Mi), i[0] = Mi.x, i[4] = Fr.x, i[8] = fn.x, i[1] = Mi.y, i[5] = Fr.y, i[9] = fn.y, i[2] = Mi.z, i[6] = Fr.z, i[10] = fn.z, this;
  }
  /**
   * Post-multiplies this matrix by the given 4x4 matrix.
   *
   * @param {Matrix4} m - The matrix to multiply with.
   * @return {Matrix4} A reference to this matrix.
   */
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  /**
   * Pre-multiplies this matrix by the given 4x4 matrix.
   *
   * @param {Matrix4} m - The matrix to multiply with.
   * @return {Matrix4} A reference to this matrix.
   */
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  /**
   * Multiples the given 4x4 matrices and stores the result
   * in this matrix.
   *
   * @param {Matrix4} a - The first matrix.
   * @param {Matrix4} b - The second matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  multiplyMatrices(e, t) {
    const n = e.elements, i = t.elements, r = this.elements, a = n[0], o = n[4], l = n[8], c = n[12], u = n[1], h = n[5], d = n[9], f = n[13], m = n[2], _ = n[6], g = n[10], p = n[14], M = n[3], S = n[7], x = n[11], R = n[15], w = i[0], C = i[4], P = i[8], b = i[12], y = i[1], L = i[5], O = i[9], U = i[13], N = i[2], Y = i[6], G = i[10], ne = i[14], B = i[3], Z = i[7], Q = i[11], xe = i[15];
    return r[0] = a * w + o * y + l * N + c * B, r[4] = a * C + o * L + l * Y + c * Z, r[8] = a * P + o * O + l * G + c * Q, r[12] = a * b + o * U + l * ne + c * xe, r[1] = u * w + h * y + d * N + f * B, r[5] = u * C + h * L + d * Y + f * Z, r[9] = u * P + h * O + d * G + f * Q, r[13] = u * b + h * U + d * ne + f * xe, r[2] = m * w + _ * y + g * N + p * B, r[6] = m * C + _ * L + g * Y + p * Z, r[10] = m * P + _ * O + g * G + p * Q, r[14] = m * b + _ * U + g * ne + p * xe, r[3] = M * w + S * y + x * N + R * B, r[7] = M * C + S * L + x * Y + R * Z, r[11] = M * P + S * O + x * G + R * Q, r[15] = M * b + S * U + x * ne + R * xe, this;
  }
  /**
   * Multiplies every component of the matrix by the given scalar.
   *
   * @param {number} s - The scalar.
   * @return {Matrix4} A reference to this matrix.
   */
  multiplyScalar(e) {
    const t = this.elements;
    return t[0] *= e, t[4] *= e, t[8] *= e, t[12] *= e, t[1] *= e, t[5] *= e, t[9] *= e, t[13] *= e, t[2] *= e, t[6] *= e, t[10] *= e, t[14] *= e, t[3] *= e, t[7] *= e, t[11] *= e, t[15] *= e, this;
  }
  /**
   * Computes and returns the determinant of this matrix.
   *
   * Based on the method outlined [here]{@link http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.html}.
   *
   * @return {number} The determinant.
   */
  determinant() {
    const e = this.elements, t = e[0], n = e[4], i = e[8], r = e[12], a = e[1], o = e[5], l = e[9], c = e[13], u = e[2], h = e[6], d = e[10], f = e[14], m = e[3], _ = e[7], g = e[11], p = e[15];
    return m * (+r * l * h - i * c * h - r * o * d + n * c * d + i * o * f - n * l * f) + _ * (+t * l * f - t * c * d + r * a * d - i * a * f + i * c * u - r * l * u) + g * (+t * c * h - t * o * f - r * a * h + n * a * f + r * o * u - n * c * u) + p * (-i * o * u - t * l * h + t * o * d + i * a * h - n * a * d + n * l * u);
  }
  /**
   * Transposes this matrix in place.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  transpose() {
    const e = this.elements;
    let t;
    return t = e[1], e[1] = e[4], e[4] = t, t = e[2], e[2] = e[8], e[8] = t, t = e[6], e[6] = e[9], e[9] = t, t = e[3], e[3] = e[12], e[12] = t, t = e[7], e[7] = e[13], e[13] = t, t = e[11], e[11] = e[14], e[14] = t, this;
  }
  /**
   * Sets the position component for this matrix from the given vector,
   * without affecting the rest of the matrix.
   *
   * @param {number|Vector3} x - The x component of the vector or alternatively the vector object.
   * @param {number} y - The y component of the vector.
   * @param {number} z - The z component of the vector.
   * @return {Matrix4} A reference to this matrix.
   */
  setPosition(e, t, n) {
    const i = this.elements;
    return e.isVector3 ? (i[12] = e.x, i[13] = e.y, i[14] = e.z) : (i[12] = e, i[13] = t, i[14] = n), this;
  }
  /**
   * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
   * You can not invert with a determinant of zero. If you attempt this, the method produces
   * a zero matrix instead.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  invert() {
    const e = this.elements, t = e[0], n = e[1], i = e[2], r = e[3], a = e[4], o = e[5], l = e[6], c = e[7], u = e[8], h = e[9], d = e[10], f = e[11], m = e[12], _ = e[13], g = e[14], p = e[15], M = h * g * c - _ * d * c + _ * l * f - o * g * f - h * l * p + o * d * p, S = m * d * c - u * g * c - m * l * f + a * g * f + u * l * p - a * d * p, x = u * _ * c - m * h * c + m * o * f - a * _ * f - u * o * p + a * h * p, R = m * h * l - u * _ * l - m * o * d + a * _ * d + u * o * g - a * h * g, w = t * M + n * S + i * x + r * R;
    if (w === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const C = 1 / w;
    return e[0] = M * C, e[1] = (_ * d * r - h * g * r - _ * i * f + n * g * f + h * i * p - n * d * p) * C, e[2] = (o * g * r - _ * l * r + _ * i * c - n * g * c - o * i * p + n * l * p) * C, e[3] = (h * l * r - o * d * r - h * i * c + n * d * c + o * i * f - n * l * f) * C, e[4] = S * C, e[5] = (u * g * r - m * d * r + m * i * f - t * g * f - u * i * p + t * d * p) * C, e[6] = (m * l * r - a * g * r - m * i * c + t * g * c + a * i * p - t * l * p) * C, e[7] = (a * d * r - u * l * r + u * i * c - t * d * c - a * i * f + t * l * f) * C, e[8] = x * C, e[9] = (m * h * r - u * _ * r - m * n * f + t * _ * f + u * n * p - t * h * p) * C, e[10] = (a * _ * r - m * o * r + m * n * c - t * _ * c - a * n * p + t * o * p) * C, e[11] = (u * o * r - a * h * r - u * n * c + t * h * c + a * n * f - t * o * f) * C, e[12] = R * C, e[13] = (u * _ * i - m * h * i + m * n * d - t * _ * d - u * n * g + t * h * g) * C, e[14] = (m * o * i - a * _ * i - m * n * l + t * _ * l + a * n * g - t * o * g) * C, e[15] = (a * h * i - u * o * i + u * n * l - t * h * l - a * n * d + t * o * d) * C, this;
  }
  /**
   * Multiplies the columns of this matrix by the given vector.
   *
   * @param {Vector3} v - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  scale(e) {
    const t = this.elements, n = e.x, i = e.y, r = e.z;
    return t[0] *= n, t[4] *= i, t[8] *= r, t[1] *= n, t[5] *= i, t[9] *= r, t[2] *= n, t[6] *= i, t[10] *= r, t[3] *= n, t[7] *= i, t[11] *= r, this;
  }
  /**
   * Gets the maximum scale value of the three axes.
   *
   * @return {number} The maximum scale.
   */
  getMaxScaleOnAxis() {
    const e = this.elements, t = e[0] * e[0] + e[1] * e[1] + e[2] * e[2], n = e[4] * e[4] + e[5] * e[5] + e[6] * e[6], i = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
    return Math.sqrt(Math.max(t, n, i));
  }
  /**
   * Sets this matrix as a translation transform from the given vector.
   *
   * @param {number|Vector3} x - The amount to translate in the X axis or alternatively a translation vector.
   * @param {number} y - The amount to translate in the Y axis.
   * @param {number} z - The amount to translate in the z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeTranslation(e, t, n) {
    return e.isVector3 ? this.set(
      1,
      0,
      0,
      e.x,
      0,
      1,
      0,
      e.y,
      0,
      0,
      1,
      e.z,
      0,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      0,
      e,
      0,
      1,
      0,
      t,
      0,
      0,
      1,
      n,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the X axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationX(e) {
    const t = Math.cos(e), n = Math.sin(e);
    return this.set(
      1,
      0,
      0,
      0,
      0,
      t,
      -n,
      0,
      0,
      n,
      t,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the Y axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationY(e) {
    const t = Math.cos(e), n = Math.sin(e);
    return this.set(
      t,
      0,
      n,
      0,
      0,
      1,
      0,
      0,
      -n,
      0,
      t,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the Z axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationZ(e) {
    const t = Math.cos(e), n = Math.sin(e);
    return this.set(
      t,
      -n,
      0,
      0,
      n,
      t,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the given axis by
   * the given angle.
   *
   * This is a somewhat controversial but mathematically sound alternative to
   * rotating via Quaternions. See the discussion [here]{@link https://www.gamedev.net/articles/programming/math-and-physics/do-we-really-need-quaternions-r1199}.
   *
   * @param {Vector3} axis - The normalized rotation axis.
   * @param {number} angle - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationAxis(e, t) {
    const n = Math.cos(t), i = Math.sin(t), r = 1 - n, a = e.x, o = e.y, l = e.z, c = r * a, u = r * o;
    return this.set(
      c * a + n,
      c * o - i * l,
      c * l + i * o,
      0,
      c * o + i * l,
      u * o + n,
      u * l - i * a,
      0,
      c * l - i * o,
      u * l + i * a,
      r * l * l + n,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a scale transformation.
   *
   * @param {number} x - The amount to scale in the X axis.
   * @param {number} y - The amount to scale in the Y axis.
   * @param {number} z - The amount to scale in the Z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeScale(e, t, n) {
    return this.set(
      e,
      0,
      0,
      0,
      0,
      t,
      0,
      0,
      0,
      0,
      n,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a shear transformation.
   *
   * @param {number} xy - The amount to shear X by Y.
   * @param {number} xz - The amount to shear X by Z.
   * @param {number} yx - The amount to shear Y by X.
   * @param {number} yz - The amount to shear Y by Z.
   * @param {number} zx - The amount to shear Z by X.
   * @param {number} zy - The amount to shear Z by Y.
   * @return {Matrix4} A reference to this matrix.
   */
  makeShear(e, t, n, i, r, a) {
    return this.set(
      1,
      n,
      r,
      0,
      e,
      1,
      a,
      0,
      t,
      i,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix to the transformation composed of the given position,
   * rotation (Quaternion) and scale.
   *
   * @param {Vector3} position - The position vector.
   * @param {Quaternion} quaternion - The rotation as a Quaternion.
   * @param {Vector3} scale - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  compose(e, t, n) {
    const i = this.elements, r = t._x, a = t._y, o = t._z, l = t._w, c = r + r, u = a + a, h = o + o, d = r * c, f = r * u, m = r * h, _ = a * u, g = a * h, p = o * h, M = l * c, S = l * u, x = l * h, R = n.x, w = n.y, C = n.z;
    return i[0] = (1 - (_ + p)) * R, i[1] = (f + x) * R, i[2] = (m - S) * R, i[3] = 0, i[4] = (f - x) * w, i[5] = (1 - (d + p)) * w, i[6] = (g + M) * w, i[7] = 0, i[8] = (m + S) * C, i[9] = (g - M) * C, i[10] = (1 - (d + _)) * C, i[11] = 0, i[12] = e.x, i[13] = e.y, i[14] = e.z, i[15] = 1, this;
  }
  /**
   * Decomposes this matrix into its position, rotation and scale components
   * and provides the result in the given objects.
   *
   * Note: Not all matrices are decomposable in this way. For example, if an
   * object has a non-uniformly scaled parent, then the object's world matrix
   * may not be decomposable, and this method may not be appropriate.
   *
   * @param {Vector3} position - The position vector.
   * @param {Quaternion} quaternion - The rotation as a Quaternion.
   * @param {Vector3} scale - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  decompose(e, t, n) {
    const i = this.elements;
    let r = os.set(i[0], i[1], i[2]).length();
    const a = os.set(i[4], i[5], i[6]).length(), o = os.set(i[8], i[9], i[10]).length();
    this.determinant() < 0 && (r = -r), e.x = i[12], e.y = i[13], e.z = i[14], Rn.copy(this);
    const c = 1 / r, u = 1 / a, h = 1 / o;
    return Rn.elements[0] *= c, Rn.elements[1] *= c, Rn.elements[2] *= c, Rn.elements[4] *= u, Rn.elements[5] *= u, Rn.elements[6] *= u, Rn.elements[8] *= h, Rn.elements[9] *= h, Rn.elements[10] *= h, t.setFromRotationMatrix(Rn), n.x = r, n.y = a, n.z = o, this;
  }
  /**
  	 * Creates a perspective projection matrix. This is used internally by
  	 * {@link PerspectiveCamera#updateProjectionMatrix}.
  
  	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
  	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
  	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
  	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
  	 * @param {number} near - The distance from the camera to the near plane.
  	 * @param {number} far - The distance from the camera to the far plane.
  	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
  	 * @return {Matrix4} A reference to this matrix.
  	 */
  makePerspective(e, t, n, i, r, a, o = ui) {
    const l = this.elements, c = 2 * r / (t - e), u = 2 * r / (n - i), h = (t + e) / (t - e), d = (n + i) / (n - i);
    let f, m;
    if (o === ui)
      f = -(a + r) / (a - r), m = -2 * a * r / (a - r);
    else if (o === Ta)
      f = -a / (a - r), m = -a * r / (a - r);
    else
      throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + o);
    return l[0] = c, l[4] = 0, l[8] = h, l[12] = 0, l[1] = 0, l[5] = u, l[9] = d, l[13] = 0, l[2] = 0, l[6] = 0, l[10] = f, l[14] = m, l[3] = 0, l[7] = 0, l[11] = -1, l[15] = 0, this;
  }
  /**
  	 * Creates a orthographic projection matrix. This is used internally by
  	 * {@link OrthographicCamera#updateProjectionMatrix}.
  
  	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
  	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
  	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
  	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
  	 * @param {number} near - The distance from the camera to the near plane.
  	 * @param {number} far - The distance from the camera to the far plane.
  	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
  	 * @return {Matrix4} A reference to this matrix.
  	 */
  makeOrthographic(e, t, n, i, r, a, o = ui) {
    const l = this.elements, c = 1 / (t - e), u = 1 / (n - i), h = 1 / (a - r), d = (t + e) * c, f = (n + i) * u;
    let m, _;
    if (o === ui)
      m = (a + r) * h, _ = -2 * h;
    else if (o === Ta)
      m = r * h, _ = -1 * h;
    else
      throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + o);
    return l[0] = 2 * c, l[4] = 0, l[8] = 0, l[12] = -d, l[1] = 0, l[5] = 2 * u, l[9] = 0, l[13] = -f, l[2] = 0, l[6] = 0, l[10] = _, l[14] = -m, l[3] = 0, l[7] = 0, l[11] = 0, l[15] = 1, this;
  }
  /**
   * Returns `true` if this matrix is equal with the given one.
   *
   * @param {Matrix4} matrix - The matrix to test for equality.
   * @return {boolean} Whether this matrix is equal with the given one.
   */
  equals(e) {
    const t = this.elements, n = e.elements;
    for (let i = 0; i < 16; i++)
      if (t[i] !== n[i]) return !1;
    return !0;
  }
  /**
   * Sets the elements of the matrix from the given array.
   *
   * @param {Array<number>} array - The matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Matrix4} A reference to this matrix.
   */
  fromArray(e, t = 0) {
    for (let n = 0; n < 16; n++)
      this.elements[n] = e[n + t];
    return this;
  }
  /**
   * Writes the elements of this matrix to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The matrix elements in column-major order.
   */
  toArray(e = [], t = 0) {
    const n = this.elements;
    return e[t] = n[0], e[t + 1] = n[1], e[t + 2] = n[2], e[t + 3] = n[3], e[t + 4] = n[4], e[t + 5] = n[5], e[t + 6] = n[6], e[t + 7] = n[7], e[t + 8] = n[8], e[t + 9] = n[9], e[t + 10] = n[10], e[t + 11] = n[11], e[t + 12] = n[12], e[t + 13] = n[13], e[t + 14] = n[14], e[t + 15] = n[15], e;
  }
}
const os = /* @__PURE__ */ new T(), Rn = /* @__PURE__ */ new Ye(), Ff = /* @__PURE__ */ new T(0, 0, 0), Of = /* @__PURE__ */ new T(1, 1, 1), Mi = /* @__PURE__ */ new T(), Fr = /* @__PURE__ */ new T(), fn = /* @__PURE__ */ new T(), Dc = /* @__PURE__ */ new Ye(), Nc = /* @__PURE__ */ new gn();
class Yn {
  /**
   * Constructs a new euler instance.
   *
   * @param {number} [x=0] - The angle of the x axis in radians.
   * @param {number} [y=0] - The angle of the y axis in radians.
   * @param {number} [z=0] - The angle of the z axis in radians.
   * @param {string} [order=Euler.DEFAULT_ORDER] - A string representing the order that the rotations are applied.
   */
  constructor(e = 0, t = 0, n = 0, i = Yn.DEFAULT_ORDER) {
    this.isEuler = !0, this._x = e, this._y = t, this._z = n, this._order = i;
  }
  /**
   * The angle of the x axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._onChangeCallback();
  }
  /**
   * The angle of the y axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._onChangeCallback();
  }
  /**
   * The angle of the z axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._onChangeCallback();
  }
  /**
   * A string representing the order that the rotations are applied.
   *
   * @type {string}
   * @default 'XYZ'
   */
  get order() {
    return this._order;
  }
  set order(e) {
    this._order = e, this._onChangeCallback();
  }
  /**
   * Sets the Euler components.
   *
   * @param {number} x - The angle of the x axis in radians.
   * @param {number} y - The angle of the y axis in radians.
   * @param {number} z - The angle of the z axis in radians.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  set(e, t, n, i = this._order) {
    return this._x = e, this._y = t, this._z = n, this._order = i, this._onChangeCallback(), this;
  }
  /**
   * Returns a new Euler instance with copied values from this instance.
   *
   * @return {Euler} A clone of this instance.
   */
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order);
  }
  /**
   * Copies the values of the given Euler instance to this instance.
   *
   * @param {Euler} euler - The Euler instance to copy.
   * @return {Euler} A reference to this Euler instance.
   */
  copy(e) {
    return this._x = e._x, this._y = e._y, this._z = e._z, this._order = e._order, this._onChangeCallback(), this;
  }
  /**
   * Sets the angles of this Euler instance from a pure rotation matrix.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromRotationMatrix(e, t = this._order, n = !0) {
    const i = e.elements, r = i[0], a = i[4], o = i[8], l = i[1], c = i[5], u = i[9], h = i[2], d = i[6], f = i[10];
    switch (t) {
      case "XYZ":
        this._y = Math.asin(Ze(o, -1, 1)), Math.abs(o) < 0.9999999 ? (this._x = Math.atan2(-u, f), this._z = Math.atan2(-a, r)) : (this._x = Math.atan2(d, c), this._z = 0);
        break;
      case "YXZ":
        this._x = Math.asin(-Ze(u, -1, 1)), Math.abs(u) < 0.9999999 ? (this._y = Math.atan2(o, f), this._z = Math.atan2(l, c)) : (this._y = Math.atan2(-h, r), this._z = 0);
        break;
      case "ZXY":
        this._x = Math.asin(Ze(d, -1, 1)), Math.abs(d) < 0.9999999 ? (this._y = Math.atan2(-h, f), this._z = Math.atan2(-a, c)) : (this._y = 0, this._z = Math.atan2(l, r));
        break;
      case "ZYX":
        this._y = Math.asin(-Ze(h, -1, 1)), Math.abs(h) < 0.9999999 ? (this._x = Math.atan2(d, f), this._z = Math.atan2(l, r)) : (this._x = 0, this._z = Math.atan2(-a, c));
        break;
      case "YZX":
        this._z = Math.asin(Ze(l, -1, 1)), Math.abs(l) < 0.9999999 ? (this._x = Math.atan2(-u, c), this._y = Math.atan2(-h, r)) : (this._x = 0, this._y = Math.atan2(o, f));
        break;
      case "XZY":
        this._z = Math.asin(-Ze(a, -1, 1)), Math.abs(a) < 0.9999999 ? (this._x = Math.atan2(d, c), this._y = Math.atan2(o, r)) : (this._x = Math.atan2(-u, f), this._y = 0);
        break;
      default:
        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + t);
    }
    return this._order = t, n === !0 && this._onChangeCallback(), this;
  }
  /**
   * Sets the angles of this Euler instance from a normalized quaternion.
   *
   * @param {Quaternion} q - A normalized Quaternion.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromQuaternion(e, t, n) {
    return Dc.makeRotationFromQuaternion(e), this.setFromRotationMatrix(Dc, t, n);
  }
  /**
   * Sets the angles of this Euler instance from the given vector.
   *
   * @param {Vector3} v - The vector.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromVector3(e, t = this._order) {
    return this.set(e.x, e.y, e.z, t);
  }
  /**
   * Resets the euler angle with a new order by creating a quaternion from this
   * euler angle and then setting this euler angle with the quaternion and the
   * new order.
   *
   * Warning: This discards revolution information.
   *
   * @param {string} [newOrder] - A string representing the new order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  reorder(e) {
    return Nc.setFromEuler(this), this.setFromQuaternion(Nc, e);
  }
  /**
   * Returns `true` if this Euler instance is equal with the given one.
   *
   * @param {Euler} euler - The Euler instance to test for equality.
   * @return {boolean} Whether this Euler instance is equal with the given one.
   */
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._order === this._order;
  }
  /**
   * Sets this Euler instance's components to values from the given array. The first three
   * entries of the array are assign to the x,y and z components. An optional fourth entry
   * defines the Euler order.
   *
   * @param {Array<number,number,number,?string>} array - An array holding the Euler component values.
   * @return {Euler} A reference to this Euler instance.
   */
  fromArray(e) {
    return this._x = e[0], this._y = e[1], this._z = e[2], e[3] !== void 0 && (this._order = e[3]), this._onChangeCallback(), this;
  }
  /**
   * Writes the components of this Euler instance to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number,number,number,string>} [array=[]] - The target array holding the Euler components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number,number,number,string>} The Euler components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._order, e;
  }
  _onChange(e) {
    return this._onChangeCallback = e, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._order;
  }
}
Yn.DEFAULT_ORDER = "XYZ";
class Fh {
  /**
   * Constructs a new layers instance, with membership
   * initially set to layer `0`.
   */
  constructor() {
    this.mask = 1;
  }
  /**
   * Sets membership to the given layer, and remove membership all other layers.
   *
   * @param {number} layer - The layer to set.
   */
  set(e) {
    this.mask = (1 << e | 0) >>> 0;
  }
  /**
   * Adds membership of the given layer.
   *
   * @param {number} layer - The layer to enable.
   */
  enable(e) {
    this.mask |= 1 << e | 0;
  }
  /**
   * Adds membership to all layers.
   */
  enableAll() {
    this.mask = -1;
  }
  /**
   * Toggles the membership of the given layer.
   *
   * @param {number} layer - The layer to toggle.
   */
  toggle(e) {
    this.mask ^= 1 << e | 0;
  }
  /**
   * Removes membership of the given layer.
   *
   * @param {number} layer - The layer to enable.
   */
  disable(e) {
    this.mask &= ~(1 << e | 0);
  }
  /**
   * Removes the membership from all layers.
   */
  disableAll() {
    this.mask = 0;
  }
  /**
   * Returns `true` if this and the given layers object have at least one
   * layer in common.
   *
   * @param {Layers} layers - The layers to test.
   * @return {boolean } Whether this and the given layers object have at least one layer in common or not.
   */
  test(e) {
    return (this.mask & e.mask) !== 0;
  }
  /**
   * Returns `true` if the given layer is enabled.
   *
   * @param {number} layer - The layer to test.
   * @return {boolean } Whether the given layer is enabled or not.
   */
  isEnabled(e) {
    return (this.mask & (1 << e | 0)) !== 0;
  }
}
let Bf = 0;
const Uc = /* @__PURE__ */ new T(), ls = /* @__PURE__ */ new gn(), ii = /* @__PURE__ */ new Ye(), Or = /* @__PURE__ */ new T(), tr = /* @__PURE__ */ new T(), kf = /* @__PURE__ */ new T(), zf = /* @__PURE__ */ new gn(), Fc = /* @__PURE__ */ new T(1, 0, 0), Oc = /* @__PURE__ */ new T(0, 1, 0), Bc = /* @__PURE__ */ new T(0, 0, 1), kc = { type: "added" }, Hf = { type: "removed" }, cs = { type: "childadded", child: null }, Ya = { type: "childremoved", child: null };
class bt extends Ui {
  /**
   * Constructs a new 3D object.
   */
  constructor() {
    super(), this.isObject3D = !0, Object.defineProperty(this, "id", { value: Bf++ }), this.uuid = Un(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = bt.DEFAULT_UP.clone();
    const e = new T(), t = new Yn(), n = new gn(), i = new T(1, 1, 1);
    function r() {
      n.setFromEuler(t, !1);
    }
    function a() {
      t.setFromQuaternion(n, void 0, !1);
    }
    t._onChange(r), n._onChange(a), Object.defineProperties(this, {
      /**
       * Represents the object's local position.
       *
       * @name Object3D#position
       * @type {Vector3}
       * @default (0,0,0)
       */
      position: {
        configurable: !0,
        enumerable: !0,
        value: e
      },
      /**
       * Represents the object's local rotation as Euler angles, in radians.
       *
       * @name Object3D#rotation
       * @type {Euler}
       * @default (0,0,0)
       */
      rotation: {
        configurable: !0,
        enumerable: !0,
        value: t
      },
      /**
       * Represents the object's local rotation as Quaternions.
       *
       * @name Object3D#quaternion
       * @type {Quaternion}
       */
      quaternion: {
        configurable: !0,
        enumerable: !0,
        value: n
      },
      /**
       * Represents the object's local scale.
       *
       * @name Object3D#scale
       * @type {Vector3}
       * @default (1,1,1)
       */
      scale: {
        configurable: !0,
        enumerable: !0,
        value: i
      },
      /**
       * Represents the object's model-view matrix.
       *
       * @name Object3D#modelViewMatrix
       * @type {Matrix4}
       */
      modelViewMatrix: {
        value: new Ye()
      },
      /**
       * Represents the object's normal matrix.
       *
       * @name Object3D#normalMatrix
       * @type {Matrix3}
       */
      normalMatrix: {
        value: new Ke()
      }
    }), this.matrix = new Ye(), this.matrixWorld = new Ye(), this.matrixAutoUpdate = bt.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldAutoUpdate = bt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.layers = new Fh(), this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.customDepthMaterial = void 0, this.customDistanceMaterial = void 0, this.userData = {};
  }
  /**
   * A callback that is executed immediately before a 3D object is rendered to a shadow map.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {Camera} shadowCamera - The shadow camera.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} depthMaterial - The depth material.
   * @param {Object} group - The geometry group data.
   */
  onBeforeShadow() {
  }
  /**
   * A callback that is executed immediately after a 3D object is rendered to a shadow map.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {Camera} shadowCamera - The shadow camera.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} depthMaterial - The depth material.
   * @param {Object} group - The geometry group data.
   */
  onAfterShadow() {
  }
  /**
   * A callback that is executed immediately before a 3D object is rendered.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {Object} group - The geometry group data.
   */
  onBeforeRender() {
  }
  /**
   * A callback that is executed immediately after a 3D object is rendered.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {Object} group - The geometry group data.
   */
  onAfterRender() {
  }
  /**
   * Applies the given transformation matrix to the object and updates the object's position,
   * rotation and scale.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   */
  applyMatrix4(e) {
    this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(e), this.matrix.decompose(this.position, this.quaternion, this.scale);
  }
  /**
   * Applies a rotation represented by given the quaternion to the 3D object.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Object3D} A reference to this instance.
   */
  applyQuaternion(e) {
    return this.quaternion.premultiply(e), this;
  }
  /**
   * Sets the given rotation represented as an axis/angle couple to the 3D object.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   */
  setRotationFromAxisAngle(e, t) {
    this.quaternion.setFromAxisAngle(e, t);
  }
  /**
   * Sets the given rotation represented as Euler angles to the 3D object.
   *
   * @param {Euler} euler - The Euler angles.
   */
  setRotationFromEuler(e) {
    this.quaternion.setFromEuler(e, !0);
  }
  /**
   * Sets the given rotation represented as rotation matrix to the 3D object.
   *
   * @param {Matrix4} m - Although a 4x4 matrix is expected, the upper 3x3 portion must be
   * a pure rotation matrix (i.e, unscaled).
   */
  setRotationFromMatrix(e) {
    this.quaternion.setFromRotationMatrix(e);
  }
  /**
   * Sets the given rotation represented as a Quaternion to the 3D object.
   *
   * @param {Quaternion} q - The Quaternion
   */
  setRotationFromQuaternion(e) {
    this.quaternion.copy(e);
  }
  /**
   * Rotates the 3D object along an axis in local space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateOnAxis(e, t) {
    return ls.setFromAxisAngle(e, t), this.quaternion.multiply(ls), this;
  }
  /**
   * Rotates the 3D object along an axis in world space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateOnWorldAxis(e, t) {
    return ls.setFromAxisAngle(e, t), this.quaternion.premultiply(ls), this;
  }
  /**
   * Rotates the 3D object around its X axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateX(e) {
    return this.rotateOnAxis(Fc, e);
  }
  /**
   * Rotates the 3D object around its Y axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateY(e) {
    return this.rotateOnAxis(Oc, e);
  }
  /**
   * Rotates the 3D object around its Z axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateZ(e) {
    return this.rotateOnAxis(Bc, e);
  }
  /**
   * Translate the 3D object by a distance along the given axis in local space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateOnAxis(e, t) {
    return Uc.copy(e).applyQuaternion(this.quaternion), this.position.add(Uc.multiplyScalar(t)), this;
  }
  /**
   * Translate the 3D object by a distance along its X-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateX(e) {
    return this.translateOnAxis(Fc, e);
  }
  /**
   * Translate the 3D object by a distance along its Y-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateY(e) {
    return this.translateOnAxis(Oc, e);
  }
  /**
   * Translate the 3D object by a distance along its Z-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateZ(e) {
    return this.translateOnAxis(Bc, e);
  }
  /**
   * Converts the given vector from this 3D object's local space to world space.
   *
   * @param {Vector3} vector - The vector to convert.
   * @return {Vector3} The converted vector.
   */
  localToWorld(e) {
    return this.updateWorldMatrix(!0, !1), e.applyMatrix4(this.matrixWorld);
  }
  /**
   * Converts the given vector from this 3D object's word space to local space.
   *
   * @param {Vector3} vector - The vector to convert.
   * @return {Vector3} The converted vector.
   */
  worldToLocal(e) {
    return this.updateWorldMatrix(!0, !1), e.applyMatrix4(ii.copy(this.matrixWorld).invert());
  }
  /**
   * Rotates the object to face a point in world space.
   *
   * This method does not support objects having non-uniformly-scaled parent(s).
   *
   * @param {number|Vector3} x - The x coordinate in world space. Alternatively, a vector representing a position in world space
   * @param {number} [y] - The y coordinate in world space.
   * @param {number} [z] - The z coordinate in world space.
   */
  lookAt(e, t, n) {
    e.isVector3 ? Or.copy(e) : Or.set(e, t, n);
    const i = this.parent;
    this.updateWorldMatrix(!0, !1), tr.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? ii.lookAt(tr, Or, this.up) : ii.lookAt(Or, tr, this.up), this.quaternion.setFromRotationMatrix(ii), i && (ii.extractRotation(i.matrixWorld), ls.setFromRotationMatrix(ii), this.quaternion.premultiply(ls.invert()));
  }
  /**
   * Adds the given 3D object as a child to this 3D object. An arbitrary number of
   * objects may be added. Any current parent on an object passed in here will be
   * removed, since an object can have at most one parent.
   *
   * @fires Object3D#added
   * @fires Object3D#childadded
   * @param {Object3D} object - The 3D object to add.
   * @return {Object3D} A reference to this instance.
   */
  add(e) {
    if (arguments.length > 1) {
      for (let t = 0; t < arguments.length; t++)
        this.add(arguments[t]);
      return this;
    }
    return e === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", e), this) : (e && e.isObject3D ? (e.removeFromParent(), e.parent = this, this.children.push(e), e.dispatchEvent(kc), cs.child = e, this.dispatchEvent(cs), cs.child = null) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", e), this);
  }
  /**
   * Removes the given 3D object as child from this 3D object.
   * An arbitrary number of objects may be removed.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @param {Object3D} object - The 3D object to remove.
   * @return {Object3D} A reference to this instance.
   */
  remove(e) {
    if (arguments.length > 1) {
      for (let n = 0; n < arguments.length; n++)
        this.remove(arguments[n]);
      return this;
    }
    const t = this.children.indexOf(e);
    return t !== -1 && (e.parent = null, this.children.splice(t, 1), e.dispatchEvent(Hf), Ya.child = e, this.dispatchEvent(Ya), Ya.child = null), this;
  }
  /**
   * Removes this 3D object from its current parent.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @return {Object3D} A reference to this instance.
   */
  removeFromParent() {
    const e = this.parent;
    return e !== null && e.remove(this), this;
  }
  /**
   * Removes all child objects.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @return {Object3D} A reference to this instance.
   */
  clear() {
    return this.remove(...this.children);
  }
  /**
   * Adds the given 3D object as a child of this 3D object, while maintaining the object's world
   * transform. This method does not support scene graphs having non-uniformly-scaled nodes(s).
   *
   * @fires Object3D#added
   * @fires Object3D#childadded
   * @param {Object3D} object - The 3D object to attach.
   * @return {Object3D} A reference to this instance.
   */
  attach(e) {
    return this.updateWorldMatrix(!0, !1), ii.copy(this.matrixWorld).invert(), e.parent !== null && (e.parent.updateWorldMatrix(!0, !1), ii.multiply(e.parent.matrixWorld)), e.applyMatrix4(ii), e.removeFromParent(), e.parent = this, this.children.push(e), e.updateWorldMatrix(!1, !0), e.dispatchEvent(kc), cs.child = e, this.dispatchEvent(cs), cs.child = null, this;
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching ID.
   *
   * @param {number} id - The id.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectById(e) {
    return this.getObjectByProperty("id", e);
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching name.
   *
   * @param {string} name - The name.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectByName(e) {
    return this.getObjectByProperty("name", e);
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching property value.
   *
   * @param {string} name - The name of the property.
   * @param {any} value - The value.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectByProperty(e, t) {
    if (this[e] === t) return this;
    for (let n = 0, i = this.children.length; n < i; n++) {
      const a = this.children[n].getObjectByProperty(e, t);
      if (a !== void 0)
        return a;
    }
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns all 3D objects with a matching property value.
   *
   * @param {string} name - The name of the property.
   * @param {any} value - The value.
   * @param {Array<Object3D>} result - The method stores the result in this array.
   * @return {Array<Object3D>} The found 3D objects.
   */
  getObjectsByProperty(e, t, n = []) {
    this[e] === t && n.push(this);
    const i = this.children;
    for (let r = 0, a = i.length; r < a; r++)
      i[r].getObjectsByProperty(e, t, n);
    return n;
  }
  /**
   * Returns a vector representing the position of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's position in world space.
   */
  getWorldPosition(e) {
    return this.updateWorldMatrix(!0, !1), e.setFromMatrixPosition(this.matrixWorld);
  }
  /**
   * Returns a Quaternion representing the position of the 3D object in world space.
   *
   * @param {Quaternion} target - The target Quaternion the result is stored to.
   * @return {Quaternion} The 3D object's rotation in world space.
   */
  getWorldQuaternion(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(tr, e, kf), e;
  }
  /**
   * Returns a vector representing the scale of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's scale in world space.
   */
  getWorldScale(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(tr, zf, e), e;
  }
  /**
   * Returns a vector representing the ("look") direction of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's direction in world space.
   */
  getWorldDirection(e) {
    this.updateWorldMatrix(!0, !1);
    const t = this.matrixWorld.elements;
    return e.set(t[8], t[9], t[10]).normalize();
  }
  /**
   * Abstract method to get intersections between a casted ray and this
   * 3D object. Renderable 3D objects such as {@link Mesh}, {@link Line} or {@link Points}
   * implement this method in order to use raycasting.
   *
   * @abstract
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - An array holding the result of the method.
   */
  raycast() {
  }
  /**
   * Executes the callback on this 3D object and all descendants.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverse(e) {
    e(this);
    const t = this.children;
    for (let n = 0, i = t.length; n < i; n++)
      t[n].traverse(e);
  }
  /**
   * Like {@link Object3D#traverse}, but the callback will only be executed for visible 3D objects.
   * Descendants of invisible 3D objects are not traversed.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverseVisible(e) {
    if (this.visible === !1) return;
    e(this);
    const t = this.children;
    for (let n = 0, i = t.length; n < i; n++)
      t[n].traverseVisible(e);
  }
  /**
   * Like {@link Object3D#traverse}, but the callback will only be executed for all ancestors.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverseAncestors(e) {
    const t = this.parent;
    t !== null && (e(t), t.traverseAncestors(e));
  }
  /**
   * Updates the transformation matrix in local space by computing it from the current
   * position, rotation and scale values.
   */
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
  }
  /**
   * Updates the transformation matrix in world space of this 3D objects and its descendants.
   *
   * To ensure correct results, this method also recomputes the 3D object's transformation matrix in
   * local space. The computation of the local and world matrix can be controlled with the
   * {@link Object3D#matrixAutoUpdate} and {@link Object3D#matrixWorldAutoUpdate} flags which are both
   * `true` by default.  Set these flags to `false` if you need more control over the update matrix process.
   *
   * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
   * when {@link Object3D#matrixWorldAutoUpdate} is set to `false`.
   */
  updateMatrixWorld(e) {
    this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || e) && (this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, e = !0);
    const t = this.children;
    for (let n = 0, i = t.length; n < i; n++)
      t[n].updateMatrixWorld(e);
  }
  /**
   * An alternative version of {@link Object3D#updateMatrixWorld} with more control over the
   * update of ancestor and descendant nodes.
   *
   * @param {boolean} [updateParents=false] Whether ancestor nodes should be updated or not.
   * @param {boolean} [updateChildren=false] Whether descendant nodes should be updated or not.
   */
  updateWorldMatrix(e, t) {
    const n = this.parent;
    if (e === !0 && n !== null && n.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), t === !0) {
      const i = this.children;
      for (let r = 0, a = i.length; r < a; r++)
        i[r].updateWorldMatrix(!1, !0);
    }
  }
  /**
   * Serializes the 3D object into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized 3D object.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const t = e === void 0 || typeof e == "string", n = {};
    t && (e = {
      geometries: {},
      materials: {},
      textures: {},
      images: {},
      shapes: {},
      skeletons: {},
      animations: {},
      nodes: {}
    }, n.metadata = {
      version: 4.6,
      type: "Object",
      generator: "Object3D.toJSON"
    });
    const i = {};
    i.uuid = this.uuid, i.type = this.type, this.name !== "" && (i.name = this.name), this.castShadow === !0 && (i.castShadow = !0), this.receiveShadow === !0 && (i.receiveShadow = !0), this.visible === !1 && (i.visible = !1), this.frustumCulled === !1 && (i.frustumCulled = !1), this.renderOrder !== 0 && (i.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (i.userData = this.userData), i.layers = this.layers.mask, i.matrix = this.matrix.toArray(), i.up = this.up.toArray(), this.matrixAutoUpdate === !1 && (i.matrixAutoUpdate = !1), this.isInstancedMesh && (i.type = "InstancedMesh", i.count = this.count, i.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (i.instanceColor = this.instanceColor.toJSON())), this.isBatchedMesh && (i.type = "BatchedMesh", i.perObjectFrustumCulled = this.perObjectFrustumCulled, i.sortObjects = this.sortObjects, i.drawRanges = this._drawRanges, i.reservedRanges = this._reservedRanges, i.visibility = this._visibility, i.active = this._active, i.bounds = this._bounds.map((o) => ({
      boxInitialized: o.boxInitialized,
      boxMin: o.box.min.toArray(),
      boxMax: o.box.max.toArray(),
      sphereInitialized: o.sphereInitialized,
      sphereRadius: o.sphere.radius,
      sphereCenter: o.sphere.center.toArray()
    })), i.maxInstanceCount = this._maxInstanceCount, i.maxVertexCount = this._maxVertexCount, i.maxIndexCount = this._maxIndexCount, i.geometryInitialized = this._geometryInitialized, i.geometryCount = this._geometryCount, i.matricesTexture = this._matricesTexture.toJSON(e), this._colorsTexture !== null && (i.colorsTexture = this._colorsTexture.toJSON(e)), this.boundingSphere !== null && (i.boundingSphere = {
      center: i.boundingSphere.center.toArray(),
      radius: i.boundingSphere.radius
    }), this.boundingBox !== null && (i.boundingBox = {
      min: i.boundingBox.min.toArray(),
      max: i.boundingBox.max.toArray()
    }));
    function r(o, l) {
      return o[l.uuid] === void 0 && (o[l.uuid] = l.toJSON(e)), l.uuid;
    }
    if (this.isScene)
      this.background && (this.background.isColor ? i.background = this.background.toJSON() : this.background.isTexture && (i.background = this.background.toJSON(e).uuid)), this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== !0 && (i.environment = this.environment.toJSON(e).uuid);
    else if (this.isMesh || this.isLine || this.isPoints) {
      i.geometry = r(e.geometries, this.geometry);
      const o = this.geometry.parameters;
      if (o !== void 0 && o.shapes !== void 0) {
        const l = o.shapes;
        if (Array.isArray(l))
          for (let c = 0, u = l.length; c < u; c++) {
            const h = l[c];
            r(e.shapes, h);
          }
        else
          r(e.shapes, l);
      }
    }
    if (this.isSkinnedMesh && (i.bindMode = this.bindMode, i.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (r(e.skeletons, this.skeleton), i.skeleton = this.skeleton.uuid)), this.material !== void 0)
      if (Array.isArray(this.material)) {
        const o = [];
        for (let l = 0, c = this.material.length; l < c; l++)
          o.push(r(e.materials, this.material[l]));
        i.material = o;
      } else
        i.material = r(e.materials, this.material);
    if (this.children.length > 0) {
      i.children = [];
      for (let o = 0; o < this.children.length; o++)
        i.children.push(this.children[o].toJSON(e).object);
    }
    if (this.animations.length > 0) {
      i.animations = [];
      for (let o = 0; o < this.animations.length; o++) {
        const l = this.animations[o];
        i.animations.push(r(e.animations, l));
      }
    }
    if (t) {
      const o = a(e.geometries), l = a(e.materials), c = a(e.textures), u = a(e.images), h = a(e.shapes), d = a(e.skeletons), f = a(e.animations), m = a(e.nodes);
      o.length > 0 && (n.geometries = o), l.length > 0 && (n.materials = l), c.length > 0 && (n.textures = c), u.length > 0 && (n.images = u), h.length > 0 && (n.shapes = h), d.length > 0 && (n.skeletons = d), f.length > 0 && (n.animations = f), m.length > 0 && (n.nodes = m);
    }
    return n.object = i, n;
    function a(o) {
      const l = [];
      for (const c in o) {
        const u = o[c];
        delete u.metadata, l.push(u);
      }
      return l;
    }
  }
  /**
   * Returns a new 3D object with copied values from this instance.
   *
   * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are also cloned.
   * @return {Object3D} A clone of this instance.
   */
  clone(e) {
    return new this.constructor().copy(this, e);
  }
  /**
   * Copies the values of the given 3D object to this instance.
   *
   * @param {Object3D} source - The 3D object to copy.
   * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are cloned.
   * @return {Object3D} A reference to this instance.
   */
  copy(e, t = !0) {
    if (this.name = e.name, this.up.copy(e.up), this.position.copy(e.position), this.rotation.order = e.rotation.order, this.quaternion.copy(e.quaternion), this.scale.copy(e.scale), this.matrix.copy(e.matrix), this.matrixWorld.copy(e.matrixWorld), this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrixWorldAutoUpdate = e.matrixWorldAutoUpdate, this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate, this.layers.mask = e.layers.mask, this.visible = e.visible, this.castShadow = e.castShadow, this.receiveShadow = e.receiveShadow, this.frustumCulled = e.frustumCulled, this.renderOrder = e.renderOrder, this.animations = e.animations.slice(), this.userData = JSON.parse(JSON.stringify(e.userData)), t === !0)
      for (let n = 0; n < e.children.length; n++) {
        const i = e.children[n];
        this.add(i.clone());
      }
    return this;
  }
}
bt.DEFAULT_UP = /* @__PURE__ */ new T(0, 1, 0);
bt.DEFAULT_MATRIX_AUTO_UPDATE = !0;
bt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
const Cn = /* @__PURE__ */ new T(), si = /* @__PURE__ */ new T(), ja = /* @__PURE__ */ new T(), ri = /* @__PURE__ */ new T(), us = /* @__PURE__ */ new T(), hs = /* @__PURE__ */ new T(), zc = /* @__PURE__ */ new T(), Ka = /* @__PURE__ */ new T(), Za = /* @__PURE__ */ new T(), $a = /* @__PURE__ */ new T(), Ja = /* @__PURE__ */ new at(), Qa = /* @__PURE__ */ new at(), eo = /* @__PURE__ */ new at();
class Nn {
  /**
   * Constructs a new triangle.
   *
   * @param {Vector3} [a=(0,0,0)] - The first corner of the triangle.
   * @param {Vector3} [b=(0,0,0)] - The second corner of the triangle.
   * @param {Vector3} [c=(0,0,0)] - The third corner of the triangle.
   */
  constructor(e = new T(), t = new T(), n = new T()) {
    this.a = e, this.b = t, this.c = n;
  }
  /**
   * Computes the normal vector of a triangle.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's normal.
   */
  static getNormal(e, t, n, i) {
    i.subVectors(n, t), Cn.subVectors(e, t), i.cross(Cn);
    const r = i.lengthSq();
    return r > 0 ? i.multiplyScalar(1 / Math.sqrt(r)) : i.set(0, 0, 0);
  }
  /**
   * Computes a barycentric coordinates from the given vector.
   * Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The barycentric coordinates for the given point
   */
  static getBarycoord(e, t, n, i, r) {
    Cn.subVectors(i, t), si.subVectors(n, t), ja.subVectors(e, t);
    const a = Cn.dot(Cn), o = Cn.dot(si), l = Cn.dot(ja), c = si.dot(si), u = si.dot(ja), h = a * c - o * o;
    if (h === 0)
      return r.set(0, 0, 0), null;
    const d = 1 / h, f = (c * l - o * u) * d, m = (a * u - o * l) * d;
    return r.set(1 - f - m, m, f);
  }
  /**
   * Returns `true` if the given point, when projected onto the plane of the
   * triangle, lies within the triangle.
   *
   * @param {Vector3} point - The point in 3D space to test.
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @return {boolean} Whether the given point, when projected onto the plane of the
   * triangle, lies within the triangle or not.
   */
  static containsPoint(e, t, n, i) {
    return this.getBarycoord(e, t, n, i, ri) === null ? !1 : ri.x >= 0 && ri.y >= 0 && ri.x + ri.y <= 1;
  }
  /**
   * Computes the value barycentrically interpolated for the given point on the
   * triangle. Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - Position of interpolated point.
   * @param {Vector3} p1 - The first corner of the triangle.
   * @param {Vector3} p2 - The second corner of the triangle.
   * @param {Vector3} p3 - The third corner of the triangle.
   * @param {Vector3} v1 - Value to interpolate of first vertex.
   * @param {Vector3} v2 - Value to interpolate of second vertex.
   * @param {Vector3} v3 - Value to interpolate of third vertex.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The interpolated value.
   */
  static getInterpolation(e, t, n, i, r, a, o, l) {
    return this.getBarycoord(e, t, n, i, ri) === null ? (l.x = 0, l.y = 0, "z" in l && (l.z = 0), "w" in l && (l.w = 0), null) : (l.setScalar(0), l.addScaledVector(r, ri.x), l.addScaledVector(a, ri.y), l.addScaledVector(o, ri.z), l);
  }
  /**
   * Computes the value barycentrically interpolated for the given attribute and indices.
   *
   * @param {BufferAttribute} attr - The attribute to interpolate.
   * @param {number} i1 - Index of first vertex.
   * @param {number} i2 - Index of second vertex.
   * @param {number} i3 - Index of third vertex.
   * @param {Vector3} barycoord - The barycoordinate value to use to interpolate.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The interpolated attribute value.
   */
  static getInterpolatedAttribute(e, t, n, i, r, a) {
    return Ja.setScalar(0), Qa.setScalar(0), eo.setScalar(0), Ja.fromBufferAttribute(e, t), Qa.fromBufferAttribute(e, n), eo.fromBufferAttribute(e, i), a.setScalar(0), a.addScaledVector(Ja, r.x), a.addScaledVector(Qa, r.y), a.addScaledVector(eo, r.z), a;
  }
  /**
   * Returns `true` if the triangle is oriented towards the given direction.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} direction - The (normalized) direction vector.
   * @return {boolean} Whether the triangle is oriented towards the given direction or not.
   */
  static isFrontFacing(e, t, n, i) {
    return Cn.subVectors(n, t), si.subVectors(e, t), Cn.cross(si).dot(i) < 0;
  }
  /**
   * Sets the triangle's vertices by copying the given values.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */
  set(e, t, n) {
    return this.a.copy(e), this.b.copy(t), this.c.copy(n), this;
  }
  /**
   * Sets the triangle's vertices by copying the given array values.
   *
   * @param {Array<Vector3>} points - An array with 3D points.
   * @param {number} i0 - The array index representing the first corner of the triangle.
   * @param {number} i1 - The array index representing the second corner of the triangle.
   * @param {number} i2 - The array index representing the third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */
  setFromPointsAndIndices(e, t, n, i) {
    return this.a.copy(e[t]), this.b.copy(e[n]), this.c.copy(e[i]), this;
  }
  /**
   * Sets the triangle's vertices by copying the given attribute values.
   *
   * @param {BufferAttribute} attribute - A buffer attribute with 3D points data.
   * @param {number} i0 - The attribute index representing the first corner of the triangle.
   * @param {number} i1 - The attribute index representing the second corner of the triangle.
   * @param {number} i2 - The attribute index representing the third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */
  setFromAttributeAndIndices(e, t, n, i) {
    return this.a.fromBufferAttribute(e, t), this.b.fromBufferAttribute(e, n), this.c.fromBufferAttribute(e, i), this;
  }
  /**
   * Returns a new triangle with copied values from this instance.
   *
   * @return {Triangle} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given triangle to this instance.
   *
   * @param {Triangle} triangle - The triangle to copy.
   * @return {Triangle} A reference to this triangle.
   */
  copy(e) {
    return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this;
  }
  /**
   * Computes the area of the triangle.
   *
   * @return {number} The triangle's area.
   */
  getArea() {
    return Cn.subVectors(this.c, this.b), si.subVectors(this.a, this.b), Cn.cross(si).length() * 0.5;
  }
  /**
   * Computes the midpoint of the triangle.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's midpoint.
   */
  getMidpoint(e) {
    return e.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
  }
  /**
   * Computes the normal of the triangle.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's normal.
   */
  getNormal(e) {
    return Nn.getNormal(this.a, this.b, this.c, e);
  }
  /**
   * Computes a plane the triangle lies within.
   *
   * @param {Plane} target - The target vector that is used to store the method's result.
   * @return {Plane} The plane the triangle lies within.
   */
  getPlane(e) {
    return e.setFromCoplanarPoints(this.a, this.b, this.c);
  }
  /**
   * Computes a barycentric coordinates from the given vector.
   * Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The barycentric coordinates for the given point
   */
  getBarycoord(e, t) {
    return Nn.getBarycoord(e, this.a, this.b, this.c, t);
  }
  /**
   * Computes the value barycentrically interpolated for the given point on the
   * triangle. Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - Position of interpolated point.
   * @param {Vector3} v1 - Value to interpolate of first vertex.
   * @param {Vector3} v2 - Value to interpolate of second vertex.
   * @param {Vector3} v3 - Value to interpolate of third vertex.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The interpolated value.
   */
  getInterpolation(e, t, n, i, r) {
    return Nn.getInterpolation(e, this.a, this.b, this.c, t, n, i, r);
  }
  /**
   * Returns `true` if the given point, when projected onto the plane of the
   * triangle, lies within the triangle.
   *
   * @param {Vector3} point - The point in 3D space to test.
   * @return {boolean} Whether the given point, when projected onto the plane of the
   * triangle, lies within the triangle or not.
   */
  containsPoint(e) {
    return Nn.containsPoint(e, this.a, this.b, this.c);
  }
  /**
   * Returns `true` if the triangle is oriented towards the given direction.
   *
   * @param {Vector3} direction - The (normalized) direction vector.
   * @return {boolean} Whether the triangle is oriented towards the given direction or not.
   */
  isFrontFacing(e) {
    return Nn.isFrontFacing(this.a, this.b, this.c, e);
  }
  /**
   * Returns `true` if this triangle intersects with the given box.
   *
   * @param {Box3} box - The box to intersect.
   * @return {boolean} Whether this triangle intersects with the given box or not.
   */
  intersectsBox(e) {
    return e.intersectsTriangle(this);
  }
  /**
   * Returns the closest point on the triangle to the given point.
   *
   * @param {Vector3} p - The point to compute the closest point for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The closest point on the triangle.
   */
  closestPointToPoint(e, t) {
    const n = this.a, i = this.b, r = this.c;
    let a, o;
    us.subVectors(i, n), hs.subVectors(r, n), Ka.subVectors(e, n);
    const l = us.dot(Ka), c = hs.dot(Ka);
    if (l <= 0 && c <= 0)
      return t.copy(n);
    Za.subVectors(e, i);
    const u = us.dot(Za), h = hs.dot(Za);
    if (u >= 0 && h <= u)
      return t.copy(i);
    const d = l * h - u * c;
    if (d <= 0 && l >= 0 && u <= 0)
      return a = l / (l - u), t.copy(n).addScaledVector(us, a);
    $a.subVectors(e, r);
    const f = us.dot($a), m = hs.dot($a);
    if (m >= 0 && f <= m)
      return t.copy(r);
    const _ = f * c - l * m;
    if (_ <= 0 && c >= 0 && m <= 0)
      return o = c / (c - m), t.copy(n).addScaledVector(hs, o);
    const g = u * m - f * h;
    if (g <= 0 && h - u >= 0 && f - m >= 0)
      return zc.subVectors(r, i), o = (h - u) / (h - u + (f - m)), t.copy(i).addScaledVector(zc, o);
    const p = 1 / (g + _ + d);
    return a = _ * p, o = d * p, t.copy(n).addScaledVector(us, a).addScaledVector(hs, o);
  }
  /**
   * Returns `true` if this triangle is equal with the given one.
   *
   * @param {Triangle} triangle - The triangle to test for equality.
   * @return {boolean} Whether this triangle is equal with the given one.
   */
  equals(e) {
    return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
  }
}
const Oh = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
}, bi = { h: 0, s: 0, l: 0 }, Br = { h: 0, s: 0, l: 0 };
function to(s, e, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? s + (e - s) * 6 * t : t < 1 / 2 ? e : t < 2 / 3 ? s + (e - s) * 6 * (2 / 3 - t) : s;
}
class He {
  /**
   * Constructs a new color.
   *
   * Note that standard method of specifying color in three.js is with a hexadecimal triplet,
   * and that method is used throughout the rest of the documentation.
   *
   * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
   * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
   * @param {number} [g] - The green component.
   * @param {number} [b] - The blue component.
   */
  constructor(e, t, n) {
    return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(e, t, n);
  }
  /**
   * Sets the colors's components from the given values.
   *
   * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
   * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
   * @param {number} [g] - The green component.
   * @param {number} [b] - The blue component.
   * @return {Color} A reference to this color.
   */
  set(e, t, n) {
    if (t === void 0 && n === void 0) {
      const i = e;
      i && i.isColor ? this.copy(i) : typeof i == "number" ? this.setHex(i) : typeof i == "string" && this.setStyle(i);
    } else
      this.setRGB(e, t, n);
    return this;
  }
  /**
   * Sets the colors's components to the given scalar value.
   *
   * @param {number} scalar - The scalar value.
   * @return {Color} A reference to this color.
   */
  setScalar(e) {
    return this.r = e, this.g = e, this.b = e, this;
  }
  /**
   * Sets this color from a hexadecimal value.
   *
   * @param {number} hex - The hexadecimal value.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setHex(e, t = Dt) {
    return e = Math.floor(e), this.r = (e >> 16 & 255) / 255, this.g = (e >> 8 & 255) / 255, this.b = (e & 255) / 255, ot.toWorkingColorSpace(this, t), this;
  }
  /**
   * Sets this color from RGB values.
   *
   * @param {number} r - Red channel value between `0.0` and `1.0`.
   * @param {number} g - Green channel value between `0.0` and `1.0`.
   * @param {number} b - Blue channel value between `0.0` and `1.0`.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setRGB(e, t, n, i = ot.workingColorSpace) {
    return this.r = e, this.g = t, this.b = n, ot.toWorkingColorSpace(this, i), this;
  }
  /**
   * Sets this color from RGB values.
   *
   * @param {number} h - Hue value between `0.0` and `1.0`.
   * @param {number} s - Saturation value between `0.0` and `1.0`.
   * @param {number} l - Lightness value between `0.0` and `1.0`.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setHSL(e, t, n, i = ot.workingColorSpace) {
    if (e = Hl(e, 1), t = Ze(t, 0, 1), n = Ze(n, 0, 1), t === 0)
      this.r = this.g = this.b = n;
    else {
      const r = n <= 0.5 ? n * (1 + t) : n + t - n * t, a = 2 * n - r;
      this.r = to(a, r, e + 1 / 3), this.g = to(a, r, e), this.b = to(a, r, e - 1 / 3);
    }
    return ot.toWorkingColorSpace(this, i), this;
  }
  /**
   * Sets this color from a CSS-style string. For example, `rgb(250, 0,0)`,
   * `rgb(100%, 0%, 0%)`, `hsl(0, 100%, 50%)`, `#ff0000`, `#f00`, or `red` ( or
   * any [X11 color name]{@link https://en.wikipedia.org/wiki/X11_color_names#Color_name_chart} -
   * all 140 color names are supported).
   *
   * @param {string} style - Color as a CSS-style string.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setStyle(e, t = Dt) {
    function n(r) {
      r !== void 0 && parseFloat(r) < 1 && console.warn("THREE.Color: Alpha component of " + e + " will be ignored.");
    }
    let i;
    if (i = /^(\w+)\(([^\)]*)\)/.exec(e)) {
      let r;
      const a = i[1], o = i[2];
      switch (a) {
        case "rgb":
        case "rgba":
          if (r = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o))
            return n(r[4]), this.setRGB(
              Math.min(255, parseInt(r[1], 10)) / 255,
              Math.min(255, parseInt(r[2], 10)) / 255,
              Math.min(255, parseInt(r[3], 10)) / 255,
              t
            );
          if (r = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o))
            return n(r[4]), this.setRGB(
              Math.min(100, parseInt(r[1], 10)) / 100,
              Math.min(100, parseInt(r[2], 10)) / 100,
              Math.min(100, parseInt(r[3], 10)) / 100,
              t
            );
          break;
        case "hsl":
        case "hsla":
          if (r = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o))
            return n(r[4]), this.setHSL(
              parseFloat(r[1]) / 360,
              parseFloat(r[2]) / 100,
              parseFloat(r[3]) / 100,
              t
            );
          break;
        default:
          console.warn("THREE.Color: Unknown color model " + e);
      }
    } else if (i = /^\#([A-Fa-f\d]+)$/.exec(e)) {
      const r = i[1], a = r.length;
      if (a === 3)
        return this.setRGB(
          parseInt(r.charAt(0), 16) / 15,
          parseInt(r.charAt(1), 16) / 15,
          parseInt(r.charAt(2), 16) / 15,
          t
        );
      if (a === 6)
        return this.setHex(parseInt(r, 16), t);
      console.warn("THREE.Color: Invalid hex color " + e);
    } else if (e && e.length > 0)
      return this.setColorName(e, t);
    return this;
  }
  /**
   * Sets this color from a color name. Faster than {@link Color#setStyle} if
   * you don't need the other CSS-style formats.
   *
   * For convenience, the list of names is exposed in `Color.NAMES` as a hash.
   * ```js
   * Color.NAMES.aliceblue // returns 0xF0F8FF
   * ```
   *
   * @param {string} style - The color name.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setColorName(e, t = Dt) {
    const n = Oh[e.toLowerCase()];
    return n !== void 0 ? this.setHex(n, t) : console.warn("THREE.Color: Unknown color " + e), this;
  }
  /**
   * Returns a new color with copied values from this instance.
   *
   * @return {Color} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  /**
   * Copies the values of the given color to this instance.
   *
   * @param {Color} color - The color to copy.
   * @return {Color} A reference to this color.
   */
  copy(e) {
    return this.r = e.r, this.g = e.g, this.b = e.b, this;
  }
  /**
   * Copies the given color into this color, and then converts this color from
   * `SRGBColorSpace` to `LinearSRGBColorSpace`.
   *
   * @param {Color} color - The color to copy/convert.
   * @return {Color} A reference to this color.
   */
  copySRGBToLinear(e) {
    return this.r = fi(e.r), this.g = fi(e.g), this.b = fi(e.b), this;
  }
  /**
   * Copies the given color into this color, and then converts this color from
   * `LinearSRGBColorSpace` to `SRGBColorSpace`.
   *
   * @param {Color} color - The color to copy/convert.
   * @return {Color} A reference to this color.
   */
  copyLinearToSRGB(e) {
    return this.r = Ls(e.r), this.g = Ls(e.g), this.b = Ls(e.b), this;
  }
  /**
   * Converts this color from `SRGBColorSpace` to `LinearSRGBColorSpace`.
   *
   * @return {Color} A reference to this color.
   */
  convertSRGBToLinear() {
    return this.copySRGBToLinear(this), this;
  }
  /**
   * Converts this color from `LinearSRGBColorSpace` to `SRGBColorSpace`.
   *
   * @return {Color} A reference to this color.
   */
  convertLinearToSRGB() {
    return this.copyLinearToSRGB(this), this;
  }
  /**
   * Returns the hexadecimal value of this color.
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {number} The hexadecimal value.
   */
  getHex(e = Dt) {
    return ot.fromWorkingColorSpace(Qt.copy(this), e), Math.round(Ze(Qt.r * 255, 0, 255)) * 65536 + Math.round(Ze(Qt.g * 255, 0, 255)) * 256 + Math.round(Ze(Qt.b * 255, 0, 255));
  }
  /**
   * Returns the hexadecimal value of this color as a string (for example, 'FFFFFF').
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {string} The hexadecimal value as a string.
   */
  getHexString(e = Dt) {
    return ("000000" + this.getHex(e).toString(16)).slice(-6);
  }
  /**
   * Converts the colors RGB values into the HSL format and stores them into the
   * given target object.
   *
   * @param {{h:number,s:number,l:number}} target - The target object that is used to store the method's result.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {{h:number,s:number,l:number}} The HSL representation of this color.
   */
  getHSL(e, t = ot.workingColorSpace) {
    ot.fromWorkingColorSpace(Qt.copy(this), t);
    const n = Qt.r, i = Qt.g, r = Qt.b, a = Math.max(n, i, r), o = Math.min(n, i, r);
    let l, c;
    const u = (o + a) / 2;
    if (o === a)
      l = 0, c = 0;
    else {
      const h = a - o;
      switch (c = u <= 0.5 ? h / (a + o) : h / (2 - a - o), a) {
        case n:
          l = (i - r) / h + (i < r ? 6 : 0);
          break;
        case i:
          l = (r - n) / h + 2;
          break;
        case r:
          l = (n - i) / h + 4;
          break;
      }
      l /= 6;
    }
    return e.h = l, e.s = c, e.l = u, e;
  }
  /**
   * Returns the RGB values of this color and stores them into the given target object.
   *
   * @param {Color} target - The target color that is used to store the method's result.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} The RGB representation of this color.
   */
  getRGB(e, t = ot.workingColorSpace) {
    return ot.fromWorkingColorSpace(Qt.copy(this), t), e.r = Qt.r, e.g = Qt.g, e.b = Qt.b, e;
  }
  /**
   * Returns the value of this color as a CSS style string. Example: `rgb(255,0,0)`.
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {string} The CSS representation of this color.
   */
  getStyle(e = Dt) {
    ot.fromWorkingColorSpace(Qt.copy(this), e);
    const t = Qt.r, n = Qt.g, i = Qt.b;
    return e !== Dt ? `color(${e} ${t.toFixed(3)} ${n.toFixed(3)} ${i.toFixed(3)})` : `rgb(${Math.round(t * 255)},${Math.round(n * 255)},${Math.round(i * 255)})`;
  }
  /**
   * Adds the given HSL values to this color's values.
   * Internally, this converts the color's RGB values to HSL, adds HSL
   * and then converts the color back to RGB.
   *
   * @param {number} h - Hue value between `0.0` and `1.0`.
   * @param {number} s - Saturation value between `0.0` and `1.0`.
   * @param {number} l - Lightness value between `0.0` and `1.0`.
   * @return {Color} A reference to this color.
   */
  offsetHSL(e, t, n) {
    return this.getHSL(bi), this.setHSL(bi.h + e, bi.s + t, bi.l + n);
  }
  /**
   * Adds the RGB values of the given color to the RGB values of this color.
   *
   * @param {Color} color - The color to add.
   * @return {Color} A reference to this color.
   */
  add(e) {
    return this.r += e.r, this.g += e.g, this.b += e.b, this;
  }
  /**
   * Adds the RGB values of the given colors and stores the result in this instance.
   *
   * @param {Color} color1 - The first color.
   * @param {Color} color2 - The second color.
   * @return {Color} A reference to this color.
   */
  addColors(e, t) {
    return this.r = e.r + t.r, this.g = e.g + t.g, this.b = e.b + t.b, this;
  }
  /**
   * Adds the given scalar value to the RGB values of this color.
   *
   * @param {number} s - The scalar to add.
   * @return {Color} A reference to this color.
   */
  addScalar(e) {
    return this.r += e, this.g += e, this.b += e, this;
  }
  /**
   * Subtracts the RGB values of the given color from the RGB values of this color.
   *
   * @param {Color} color - The color to subtract.
   * @return {Color} A reference to this color.
   */
  sub(e) {
    return this.r = Math.max(0, this.r - e.r), this.g = Math.max(0, this.g - e.g), this.b = Math.max(0, this.b - e.b), this;
  }
  /**
   * Multiplies the RGB values of the given color with the RGB values of this color.
   *
   * @param {Color} color - The color to multiply.
   * @return {Color} A reference to this color.
   */
  multiply(e) {
    return this.r *= e.r, this.g *= e.g, this.b *= e.b, this;
  }
  /**
   * Multiplies the given scalar value with the RGB values of this color.
   *
   * @param {number} s - The scalar to multiply.
   * @return {Color} A reference to this color.
   */
  multiplyScalar(e) {
    return this.r *= e, this.g *= e, this.b *= e, this;
  }
  /**
   * Linearly interpolates this color's RGB values toward the RGB values of the
   * given color. The alpha argument can be thought of as the ratio between
   * the two colors, where `0.0` is this color and `1.0` is the first argument.
   *
   * @param {Color} color - The color to converge on.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerp(e, t) {
    return this.r += (e.r - this.r) * t, this.g += (e.g - this.g) * t, this.b += (e.b - this.b) * t, this;
  }
  /**
   * Linearly interpolates between the given colors and stores the result in this instance.
   * The alpha argument can be thought of as the ratio between the two colors, where `0.0`
   * is the first and `1.0` is the second color.
   *
   * @param {Color} color1 - The first color.
   * @param {Color} color2 - The second color.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerpColors(e, t, n) {
    return this.r = e.r + (t.r - e.r) * n, this.g = e.g + (t.g - e.g) * n, this.b = e.b + (t.b - e.b) * n, this;
  }
  /**
   * Linearly interpolates this color's HSL values toward the HSL values of the
   * given color. It differs from {@link Color#lerp} by not interpolating straight
   * from one color to the other, but instead going through all the hues in between
   * those two colors. The alpha argument can be thought of as the ratio between
   * the two colors, where 0.0 is this color and 1.0 is the first argument.
   *
   * @param {Color} color - The color to converge on.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerpHSL(e, t) {
    this.getHSL(bi), e.getHSL(Br);
    const n = mr(bi.h, Br.h, t), i = mr(bi.s, Br.s, t), r = mr(bi.l, Br.l, t);
    return this.setHSL(n, i, r), this;
  }
  /**
   * Sets the color's RGB components from the given 3D vector.
   *
   * @param {Vector3} v - The vector to set.
   * @return {Color} A reference to this color.
   */
  setFromVector3(e) {
    return this.r = e.x, this.g = e.y, this.b = e.z, this;
  }
  /**
   * Transforms this color with the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix.
   * @return {Color} A reference to this color.
   */
  applyMatrix3(e) {
    const t = this.r, n = this.g, i = this.b, r = e.elements;
    return this.r = r[0] * t + r[3] * n + r[6] * i, this.g = r[1] * t + r[4] * n + r[7] * i, this.b = r[2] * t + r[5] * n + r[8] * i, this;
  }
  /**
   * Returns `true` if this color is equal with the given one.
   *
   * @param {Color} c - The color to test for equality.
   * @return {boolean} Whether this bounding color is equal with the given one.
   */
  equals(e) {
    return e.r === this.r && e.g === this.g && e.b === this.b;
  }
  /**
   * Sets this color's RGB components from the given array.
   *
   * @param {Array<number>} array - An array holding the RGB values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Color} A reference to this color.
   */
  fromArray(e, t = 0) {
    return this.r = e[t], this.g = e[t + 1], this.b = e[t + 2], this;
  }
  /**
   * Writes the RGB components of this color to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the color components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The color components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this.r, e[t + 1] = this.g, e[t + 2] = this.b, e;
  }
  /**
   * Sets the components of this color from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding color data.
   * @param {number} index - The index into the attribute.
   * @return {Color} A reference to this color.
   */
  fromBufferAttribute(e, t) {
    return this.r = e.getX(t), this.g = e.getY(t), this.b = e.getZ(t), this;
  }
  /**
   * This methods defines the serialization result of this class. Returns the color
   * as a hexadecimal value.
   *
   * @return {number} The hexadecimal value.
   */
  toJSON() {
    return this.getHex();
  }
  *[Symbol.iterator]() {
    yield this.r, yield this.g, yield this.b;
  }
}
const Qt = /* @__PURE__ */ new He();
He.NAMES = Oh;
let Vf = 0;
class qn extends Ui {
  /**
   * Constructs a new material.
   */
  constructor() {
    super(), this.isMaterial = !0, Object.defineProperty(this, "id", { value: Vf++ }), this.uuid = Un(), this.name = "", this.type = "Material", this.blending = Ps, this.side = gi, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = Fo, this.blendDst = Oo, this.blendEquation = ji, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new He(0, 0, 0), this.blendAlpha = 0, this.depthFunc = Ds, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = Ac, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = ns, this.stencilZFail = ns, this.stencilZPass = ns, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.allowOverride = !0, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
  }
  /**
   * Sets the alpha value to be used when running an alpha test. The material
   * will not be rendered if the opacity is lower than this value.
   *
   * @type {number}
   * @readonly
   * @default 0
   */
  get alphaTest() {
    return this._alphaTest;
  }
  set alphaTest(e) {
    this._alphaTest > 0 != e > 0 && this.version++, this._alphaTest = e;
  }
  /**
   * An optional callback that is executed immediately before the material is used to render a 3D object.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Scene} scene - The scene.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Object3D} object - The 3D object.
   * @param {Object} group - The geometry group data.
   */
  onBeforeRender() {
  }
  /**
   * An optional callback that is executed immediately before the shader
   * program is compiled. This function is called with the shader source code
   * as a parameter. Useful for the modification of built-in materials.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}. The
   * recommended approach when customizing materials is to use `WebGPURenderer` with the new
   * Node Material system and [TSL]{@link https://github.com/mrdoob/three.js/wiki/Three.js-Shading-Language}.
   *
   * @param {{vertexShader:string,fragmentShader:string,uniforms:Object}} shaderobject - The object holds the uniforms and the vertex and fragment shader source.
   * @param {WebGLRenderer} renderer - A reference to the renderer.
   */
  onBeforeCompile() {
  }
  /**
   * In case {@link Material#onBeforeCompile} is used, this callback can be used to identify
   * values of settings used in `onBeforeCompile()`, so three.js can reuse a cached
   * shader or recompile the shader for this material as needed.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}.
   *
   * @return {string} The custom program cache key.
   */
  customProgramCacheKey() {
    return this.onBeforeCompile.toString();
  }
  /**
   * This method can be used to set default values from parameter objects.
   * It is a generic implementation so it can be used with different types
   * of materials.
   *
   * @param {Object} [values] - The material values to set.
   */
  setValues(e) {
    if (e !== void 0)
      for (const t in e) {
        const n = e[t];
        if (n === void 0) {
          console.warn(`THREE.Material: parameter '${t}' has value of undefined.`);
          continue;
        }
        const i = this[t];
        if (i === void 0) {
          console.warn(`THREE.Material: '${t}' is not a property of THREE.${this.type}.`);
          continue;
        }
        i && i.isColor ? i.set(n) : i && i.isVector3 && n && n.isVector3 ? i.copy(n) : this[t] = n;
      }
  }
  /**
   * Serializes the material into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized material.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    t && (e = {
      textures: {},
      images: {}
    });
    const n = {
      metadata: {
        version: 4.6,
        type: "Material",
        generator: "Material.toJSON"
      }
    };
    n.uuid = this.uuid, n.type = this.type, this.name !== "" && (n.name = this.name), this.color && this.color.isColor && (n.color = this.color.getHex()), this.roughness !== void 0 && (n.roughness = this.roughness), this.metalness !== void 0 && (n.metalness = this.metalness), this.sheen !== void 0 && (n.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (n.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (n.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()), this.emissiveIntensity !== void 0 && this.emissiveIntensity !== 1 && (n.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (n.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (n.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (n.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (n.shininess = this.shininess), this.clearcoat !== void 0 && (n.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (n.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (n.clearcoatMap = this.clearcoatMap.toJSON(e).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (n.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid, n.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.dispersion !== void 0 && (n.dispersion = this.dispersion), this.iridescence !== void 0 && (n.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (n.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (n.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (n.iridescenceMap = this.iridescenceMap.toJSON(e).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (n.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e).uuid), this.anisotropy !== void 0 && (n.anisotropy = this.anisotropy), this.anisotropyRotation !== void 0 && (n.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (n.anisotropyMap = this.anisotropyMap.toJSON(e).uuid), this.map && this.map.isTexture && (n.map = this.map.toJSON(e).uuid), this.matcap && this.matcap.isTexture && (n.matcap = this.matcap.toJSON(e).uuid), this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(e).uuid), this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(e).uuid, n.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (n.aoMap = this.aoMap.toJSON(e).uuid, n.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(e).uuid, n.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(e).uuid, n.normalMapType = this.normalMapType, n.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(e).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(e).uuid), this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(e).uuid), this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(e).uuid), this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(e).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (n.specularIntensityMap = this.specularIntensityMap.toJSON(e).uuid), this.specularColorMap && this.specularColorMap.isTexture && (n.specularColorMap = this.specularColorMap.toJSON(e).uuid), this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(e).uuid, this.combine !== void 0 && (n.combine = this.combine)), this.envMapRotation !== void 0 && (n.envMapRotation = this.envMapRotation.toArray()), this.envMapIntensity !== void 0 && (n.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (n.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (n.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(e).uuid), this.transmission !== void 0 && (n.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (n.transmissionMap = this.transmissionMap.toJSON(e).uuid), this.thickness !== void 0 && (n.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (n.thicknessMap = this.thicknessMap.toJSON(e).uuid), this.attenuationDistance !== void 0 && this.attenuationDistance !== 1 / 0 && (n.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (n.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (n.size = this.size), this.shadowSide !== null && (n.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (n.sizeAttenuation = this.sizeAttenuation), this.blending !== Ps && (n.blending = this.blending), this.side !== gi && (n.side = this.side), this.vertexColors === !0 && (n.vertexColors = !0), this.opacity < 1 && (n.opacity = this.opacity), this.transparent === !0 && (n.transparent = !0), this.blendSrc !== Fo && (n.blendSrc = this.blendSrc), this.blendDst !== Oo && (n.blendDst = this.blendDst), this.blendEquation !== ji && (n.blendEquation = this.blendEquation), this.blendSrcAlpha !== null && (n.blendSrcAlpha = this.blendSrcAlpha), this.blendDstAlpha !== null && (n.blendDstAlpha = this.blendDstAlpha), this.blendEquationAlpha !== null && (n.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (n.blendColor = this.blendColor.getHex()), this.blendAlpha !== 0 && (n.blendAlpha = this.blendAlpha), this.depthFunc !== Ds && (n.depthFunc = this.depthFunc), this.depthTest === !1 && (n.depthTest = this.depthTest), this.depthWrite === !1 && (n.depthWrite = this.depthWrite), this.colorWrite === !1 && (n.colorWrite = this.colorWrite), this.stencilWriteMask !== 255 && (n.stencilWriteMask = this.stencilWriteMask), this.stencilFunc !== Ac && (n.stencilFunc = this.stencilFunc), this.stencilRef !== 0 && (n.stencilRef = this.stencilRef), this.stencilFuncMask !== 255 && (n.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== ns && (n.stencilFail = this.stencilFail), this.stencilZFail !== ns && (n.stencilZFail = this.stencilZFail), this.stencilZPass !== ns && (n.stencilZPass = this.stencilZPass), this.stencilWrite === !0 && (n.stencilWrite = this.stencilWrite), this.rotation !== void 0 && this.rotation !== 0 && (n.rotation = this.rotation), this.polygonOffset === !0 && (n.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (n.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (n.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (n.linewidth = this.linewidth), this.dashSize !== void 0 && (n.dashSize = this.dashSize), this.gapSize !== void 0 && (n.gapSize = this.gapSize), this.scale !== void 0 && (n.scale = this.scale), this.dithering === !0 && (n.dithering = !0), this.alphaTest > 0 && (n.alphaTest = this.alphaTest), this.alphaHash === !0 && (n.alphaHash = !0), this.alphaToCoverage === !0 && (n.alphaToCoverage = !0), this.premultipliedAlpha === !0 && (n.premultipliedAlpha = !0), this.forceSinglePass === !0 && (n.forceSinglePass = !0), this.wireframe === !0 && (n.wireframe = !0), this.wireframeLinewidth > 1 && (n.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (n.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (n.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (n.flatShading = !0), this.visible === !1 && (n.visible = !1), this.toneMapped === !1 && (n.toneMapped = !1), this.fog === !1 && (n.fog = !1), Object.keys(this.userData).length > 0 && (n.userData = this.userData);
    function i(r) {
      const a = [];
      for (const o in r) {
        const l = r[o];
        delete l.metadata, a.push(l);
      }
      return a;
    }
    if (t) {
      const r = i(e.textures), a = i(e.images);
      r.length > 0 && (n.textures = r), a.length > 0 && (n.images = a);
    }
    return n;
  }
  /**
   * Returns a new material with copied values from this instance.
   *
   * @return {Material} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given material to this instance.
   *
   * @param {Material} source - The material to copy.
   * @return {Material} A reference to this instance.
   */
  copy(e) {
    this.name = e.name, this.blending = e.blending, this.side = e.side, this.vertexColors = e.vertexColors, this.opacity = e.opacity, this.transparent = e.transparent, this.blendSrc = e.blendSrc, this.blendDst = e.blendDst, this.blendEquation = e.blendEquation, this.blendSrcAlpha = e.blendSrcAlpha, this.blendDstAlpha = e.blendDstAlpha, this.blendEquationAlpha = e.blendEquationAlpha, this.blendColor.copy(e.blendColor), this.blendAlpha = e.blendAlpha, this.depthFunc = e.depthFunc, this.depthTest = e.depthTest, this.depthWrite = e.depthWrite, this.stencilWriteMask = e.stencilWriteMask, this.stencilFunc = e.stencilFunc, this.stencilRef = e.stencilRef, this.stencilFuncMask = e.stencilFuncMask, this.stencilFail = e.stencilFail, this.stencilZFail = e.stencilZFail, this.stencilZPass = e.stencilZPass, this.stencilWrite = e.stencilWrite;
    const t = e.clippingPlanes;
    let n = null;
    if (t !== null) {
      const i = t.length;
      n = new Array(i);
      for (let r = 0; r !== i; ++r)
        n[r] = t[r].clone();
    }
    return this.clippingPlanes = n, this.clipIntersection = e.clipIntersection, this.clipShadows = e.clipShadows, this.shadowSide = e.shadowSide, this.colorWrite = e.colorWrite, this.precision = e.precision, this.polygonOffset = e.polygonOffset, this.polygonOffsetFactor = e.polygonOffsetFactor, this.polygonOffsetUnits = e.polygonOffsetUnits, this.dithering = e.dithering, this.alphaTest = e.alphaTest, this.alphaHash = e.alphaHash, this.alphaToCoverage = e.alphaToCoverage, this.premultipliedAlpha = e.premultipliedAlpha, this.forceSinglePass = e.forceSinglePass, this.visible = e.visible, this.toneMapped = e.toneMapped, this.userData = JSON.parse(JSON.stringify(e.userData)), this;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires Material#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  /**
   * Setting this property to `true` indicates the engine the material
   * needs to be recompiled.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  onBuild() {
    console.warn("Material: onBuild() has been removed.");
  }
}
class hi extends qn {
  /**
   * Constructs a new mesh basic material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new He(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new Yn(), this.combine = _h, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapRotation.copy(e.envMapRotation), this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.fog = e.fog, this;
  }
}
const ci = /* @__PURE__ */ Gf();
function Gf() {
  const s = new ArrayBuffer(4), e = new Float32Array(s), t = new Uint32Array(s), n = new Uint32Array(512), i = new Uint32Array(512);
  for (let l = 0; l < 256; ++l) {
    const c = l - 127;
    c < -27 ? (n[l] = 0, n[l | 256] = 32768, i[l] = 24, i[l | 256] = 24) : c < -14 ? (n[l] = 1024 >> -c - 14, n[l | 256] = 1024 >> -c - 14 | 32768, i[l] = -c - 1, i[l | 256] = -c - 1) : c <= 15 ? (n[l] = c + 15 << 10, n[l | 256] = c + 15 << 10 | 32768, i[l] = 13, i[l | 256] = 13) : c < 128 ? (n[l] = 31744, n[l | 256] = 64512, i[l] = 24, i[l | 256] = 24) : (n[l] = 31744, n[l | 256] = 64512, i[l] = 13, i[l | 256] = 13);
  }
  const r = new Uint32Array(2048), a = new Uint32Array(64), o = new Uint32Array(64);
  for (let l = 1; l < 1024; ++l) {
    let c = l << 13, u = 0;
    for (; (c & 8388608) === 0; )
      c <<= 1, u -= 8388608;
    c &= -8388609, u += 947912704, r[l] = c | u;
  }
  for (let l = 1024; l < 2048; ++l)
    r[l] = 939524096 + (l - 1024 << 13);
  for (let l = 1; l < 31; ++l)
    a[l] = l << 23;
  a[31] = 1199570944, a[32] = 2147483648;
  for (let l = 33; l < 63; ++l)
    a[l] = 2147483648 + (l - 32 << 23);
  a[63] = 3347054592;
  for (let l = 1; l < 64; ++l)
    l !== 32 && (o[l] = 1024);
  return {
    floatView: e,
    uint32View: t,
    baseTable: n,
    shiftTable: i,
    mantissaTable: r,
    exponentTable: a,
    offsetTable: o
  };
}
function Wf(s) {
  Math.abs(s) > 65504 && console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."), s = Ze(s, -65504, 65504), ci.floatView[0] = s;
  const e = ci.uint32View[0], t = e >> 23 & 511;
  return ci.baseTable[t] + ((e & 8388607) >> ci.shiftTable[t]);
}
function Xf(s) {
  const e = s >> 10;
  return ci.uint32View[0] = ci.mantissaTable[ci.offsetTable[e] + (s & 1023)] + ci.exponentTable[e], ci.floatView[0];
}
class kr {
  /**
   * Returns a half precision floating point value (FP16) from the given single
   * precision floating point value (FP32).
   *
   * @param {number} val - A single precision floating point value.
   * @return {number} The FP16 value.
   */
  static toHalfFloat(e) {
    return Wf(e);
  }
  /**
   * Returns a single precision floating point value (FP32) from the given half
   * precision floating point value (FP16).
   *
   * @param {number} val - A half precision floating point value.
   * @return {number} The FP32 value.
   */
  static fromHalfFloat(e) {
    return Xf(e);
  }
}
const Ot = /* @__PURE__ */ new T(), zr = /* @__PURE__ */ new ze();
let qf = 0;
class Kt {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {TypedArray} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, n = !1) {
    if (Array.isArray(e))
      throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
    this.isBufferAttribute = !0, Object.defineProperty(this, "id", { value: qf++ }), this.name = "", this.array = e, this.itemSize = t, this.count = e !== void 0 ? e.length / t : 0, this.normalized = n, this.usage = vl, this.updateRanges = [], this.gpuType = hn, this.version = 0;
  }
  /**
   * A callback function that is executed after the renderer has transferred the attribute
   * array data to the GPU.
   */
  onUploadCallback() {
  }
  /**
   * Flag to indicate that this attribute has changed and should be re-sent to
   * the GPU. Set this to `true` when you modify the value of the array.
   *
   * @type {number}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  /**
   * Sets the usage of this buffer attribute.
   *
   * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
   * @return {BufferAttribute} A reference to this buffer attribute.
   */
  setUsage(e) {
    return this.usage = e, this;
  }
  /**
   * Adds a range of data in the data array to be updated on the GPU.
   *
   * @param {number} start - Position at which to start update.
   * @param {number} count - The number of components to update.
   */
  addUpdateRange(e, t) {
    this.updateRanges.push({ start: e, count: t });
  }
  /**
   * Clears the update ranges.
   */
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  /**
   * Copies the values of the given buffer attribute to this instance.
   *
   * @param {BufferAttribute} source - The buffer attribute to copy.
   * @return {BufferAttribute} A reference to this instance.
   */
  copy(e) {
    return this.name = e.name, this.array = new e.array.constructor(e.array), this.itemSize = e.itemSize, this.count = e.count, this.normalized = e.normalized, this.usage = e.usage, this.gpuType = e.gpuType, this;
  }
  /**
   * Copies a vector from the given buffer attribute to this one. The start
   * and destination position in the attribute buffers are represented by the
   * given indices.
   *
   * @param {number} index1 - The destination index into this buffer attribute.
   * @param {BufferAttribute} attribute - The buffer attribute to copy from.
   * @param {number} index2 - The source index into the given buffer attribute.
   * @return {BufferAttribute} A reference to this instance.
   */
  copyAt(e, t, n) {
    e *= this.itemSize, n *= t.itemSize;
    for (let i = 0, r = this.itemSize; i < r; i++)
      this.array[e + i] = t.array[n + i];
    return this;
  }
  /**
   * Copies the given array data into this buffer attribute.
   *
   * @param {(TypedArray|Array)} array - The array to copy.
   * @return {BufferAttribute} A reference to this instance.
   */
  copyArray(e) {
    return this.array.set(e), this;
  }
  /**
   * Applies the given 3x3 matrix to the given attribute. Works with
   * item size `2` and `3`.
   *
   * @param {Matrix3} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  applyMatrix3(e) {
    if (this.itemSize === 2)
      for (let t = 0, n = this.count; t < n; t++)
        zr.fromBufferAttribute(this, t), zr.applyMatrix3(e), this.setXY(t, zr.x, zr.y);
    else if (this.itemSize === 3)
      for (let t = 0, n = this.count; t < n; t++)
        Ot.fromBufferAttribute(this, t), Ot.applyMatrix3(e), this.setXYZ(t, Ot.x, Ot.y, Ot.z);
    return this;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  applyMatrix4(e) {
    for (let t = 0, n = this.count; t < n; t++)
      Ot.fromBufferAttribute(this, t), Ot.applyMatrix4(e), this.setXYZ(t, Ot.x, Ot.y, Ot.z);
    return this;
  }
  /**
   * Applies the given 3x3 normal matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix3} m - The normal matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  applyNormalMatrix(e) {
    for (let t = 0, n = this.count; t < n; t++)
      Ot.fromBufferAttribute(this, t), Ot.applyNormalMatrix(e), this.setXYZ(t, Ot.x, Ot.y, Ot.z);
    return this;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3` and with direction vectors.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  transformDirection(e) {
    for (let t = 0, n = this.count; t < n; t++)
      Ot.fromBufferAttribute(this, t), Ot.transformDirection(e), this.setXYZ(t, Ot.x, Ot.y, Ot.z);
    return this;
  }
  /**
   * Sets the given array data in the buffer attribute.
   *
   * @param {(TypedArray|Array)} value - The array data to set.
   * @param {number} [offset=0] - The offset in this buffer attribute's array.
   * @return {BufferAttribute} A reference to this instance.
   */
  set(e, t = 0) {
    return this.array.set(e, t), this;
  }
  /**
   * Returns the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @return {number} The returned value.
   */
  getComponent(e, t) {
    let n = this.array[e * this.itemSize + t];
    return this.normalized && (n = Dn(n, this.array)), n;
  }
  /**
   * Sets the given value to the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @param {number} value - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setComponent(e, t, n) {
    return this.normalized && (n = _t(n, this.array)), this.array[e * this.itemSize + t] = n, this;
  }
  /**
   * Returns the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The x component.
   */
  getX(e) {
    let t = this.array[e * this.itemSize];
    return this.normalized && (t = Dn(t, this.array)), t;
  }
  /**
   * Sets the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setX(e, t) {
    return this.normalized && (t = _t(t, this.array)), this.array[e * this.itemSize] = t, this;
  }
  /**
   * Returns the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The y component.
   */
  getY(e) {
    let t = this.array[e * this.itemSize + 1];
    return this.normalized && (t = Dn(t, this.array)), t;
  }
  /**
   * Sets the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} y - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setY(e, t) {
    return this.normalized && (t = _t(t, this.array)), this.array[e * this.itemSize + 1] = t, this;
  }
  /**
   * Returns the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The z component.
   */
  getZ(e) {
    let t = this.array[e * this.itemSize + 2];
    return this.normalized && (t = Dn(t, this.array)), t;
  }
  /**
   * Sets the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} z - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setZ(e, t) {
    return this.normalized && (t = _t(t, this.array)), this.array[e * this.itemSize + 2] = t, this;
  }
  /**
   * Returns the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The w component.
   */
  getW(e) {
    let t = this.array[e * this.itemSize + 3];
    return this.normalized && (t = Dn(t, this.array)), t;
  }
  /**
   * Sets the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} w - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setW(e, t) {
    return this.normalized && (t = _t(t, this.array)), this.array[e * this.itemSize + 3] = t, this;
  }
  /**
   * Sets the x and y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setXY(e, t, n) {
    return e *= this.itemSize, this.normalized && (t = _t(t, this.array), n = _t(n, this.array)), this.array[e + 0] = t, this.array[e + 1] = n, this;
  }
  /**
   * Sets the x, y and z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setXYZ(e, t, n, i) {
    return e *= this.itemSize, this.normalized && (t = _t(t, this.array), n = _t(n, this.array), i = _t(i, this.array)), this.array[e + 0] = t, this.array[e + 1] = n, this.array[e + 2] = i, this;
  }
  /**
   * Sets the x, y, z and w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @param {number} w - The value for the w component to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setXYZW(e, t, n, i, r) {
    return e *= this.itemSize, this.normalized && (t = _t(t, this.array), n = _t(n, this.array), i = _t(i, this.array), r = _t(r, this.array)), this.array[e + 0] = t, this.array[e + 1] = n, this.array[e + 2] = i, this.array[e + 3] = r, this;
  }
  /**
   * Sets the given callback function that is executed after the Renderer has transferred
   * the attribute array data to the GPU. Can be used to perform clean-up operations after
   * the upload when attribute data are not needed anymore on the CPU side.
   *
   * @param {Function} callback - The `onUpload()` callback.
   * @return {BufferAttribute} A reference to this instance.
   */
  onUpload(e) {
    return this.onUploadCallback = e, this;
  }
  /**
   * Returns a new buffer attribute with copied values from this instance.
   *
   * @return {BufferAttribute} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this);
  }
  /**
   * Serializes the buffer attribute into JSON.
   *
   * @return {Object} A JSON object representing the serialized buffer attribute.
   */
  toJSON() {
    const e = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.from(this.array),
      normalized: this.normalized
    };
    return this.name !== "" && (e.name = this.name), this.usage !== vl && (e.usage = this.usage), e;
  }
}
class Bh extends Kt {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, n) {
    super(new Uint16Array(e), t, n);
  }
}
class kh extends Kt {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Uint32Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, n) {
    super(new Uint32Array(e), t, n);
  }
}
class Sn extends Kt {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Float32Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, n) {
    super(new Float32Array(e), t, n);
  }
}
let Yf = 0;
const vn = /* @__PURE__ */ new Ye(), no = /* @__PURE__ */ new bt(), ds = /* @__PURE__ */ new T(), pn = /* @__PURE__ */ new Mt(), nr = /* @__PURE__ */ new Mt(), Ht = /* @__PURE__ */ new T();
class _n extends Ui {
  /**
   * Constructs a new geometry.
   */
  constructor() {
    super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", { value: Yf++ }), this.uuid = Un(), this.name = "", this.type = "BufferGeometry", this.index = null, this.indirect = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = { start: 0, count: 1 / 0 }, this.userData = {};
  }
  /**
   * Returns the index of this geometry.
   *
   * @return {?BufferAttribute} The index. Returns `null` if no index is defined.
   */
  getIndex() {
    return this.index;
  }
  /**
   * Sets the given index to this geometry.
   *
   * @param {Array<number>|BufferAttribute} index - The index to set.
   * @return {BufferGeometry} A reference to this instance.
   */
  setIndex(e) {
    return Array.isArray(e) ? this.index = new (Nh(e) ? kh : Bh)(e, 1) : this.index = e, this;
  }
  /**
   * Sets the given indirect attribute to this geometry.
   *
   * @param {BufferAttribute} indirect - The attribute holding indirect draw calls.
   * @return {BufferGeometry} A reference to this instance.
   */
  setIndirect(e) {
    return this.indirect = e, this;
  }
  /**
   * Returns the indirect attribute of this geometry.
   *
   * @return {?BufferAttribute} The indirect attribute. Returns `null` if no indirect attribute is defined.
   */
  getIndirect() {
    return this.indirect;
  }
  /**
   * Returns the buffer attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @return {BufferAttribute|InterleavedBufferAttribute|undefined} The buffer attribute.
   * Returns `undefined` if not attribute has been found.
   */
  getAttribute(e) {
    return this.attributes[e];
  }
  /**
   * Sets the given attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @param {BufferAttribute|InterleavedBufferAttribute} attribute - The attribute to set.
   * @return {BufferGeometry} A reference to this instance.
   */
  setAttribute(e, t) {
    return this.attributes[e] = t, this;
  }
  /**
   * Deletes the attribute for the given name.
   *
   * @param {string} name - The attribute name to delete.
   * @return {BufferGeometry} A reference to this instance.
   */
  deleteAttribute(e) {
    return delete this.attributes[e], this;
  }
  /**
   * Returns `true` if this geometry has an attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @return {boolean} Whether this geometry has an attribute for the given name or not.
   */
  hasAttribute(e) {
    return this.attributes[e] !== void 0;
  }
  /**
   * Adds a group to this geometry.
   *
   * @param {number} start - The first element in this draw call. That is the first
   * vertex for non-indexed geometry, otherwise the first triangle index.
   * @param {number} count - Specifies how many vertices (or indices) are part of this group.
   * @param {number} [materialIndex=0] - The material array index to use.
   */
  addGroup(e, t, n = 0) {
    this.groups.push({
      start: e,
      count: t,
      materialIndex: n
    });
  }
  /**
   * Clears all groups.
   */
  clearGroups() {
    this.groups = [];
  }
  /**
   * Sets the draw range for this geometry.
   *
   * @param {number} start - The first vertex for non-indexed geometry, otherwise the first triangle index.
   * @param {number} count - For non-indexed BufferGeometry, `count` is the number of vertices to render.
   * For indexed BufferGeometry, `count` is the number of indices to render.
   */
  setDrawRange(e, t) {
    this.drawRange.start = e, this.drawRange.count = t;
  }
  /**
   * Applies the given 4x4 transformation matrix to the geometry.
   *
   * @param {Matrix4} matrix - The matrix to apply.
   * @return {BufferGeometry} A reference to this instance.
   */
  applyMatrix4(e) {
    const t = this.attributes.position;
    t !== void 0 && (t.applyMatrix4(e), t.needsUpdate = !0);
    const n = this.attributes.normal;
    if (n !== void 0) {
      const r = new Ke().getNormalMatrix(e);
      n.applyNormalMatrix(r), n.needsUpdate = !0;
    }
    const i = this.attributes.tangent;
    return i !== void 0 && (i.transformDirection(e), i.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
  }
  /**
   * Applies the rotation represented by the Quaternion to the geometry.
   *
   * @param {Quaternion} q - The Quaternion to apply.
   * @return {BufferGeometry} A reference to this instance.
   */
  applyQuaternion(e) {
    return vn.makeRotationFromQuaternion(e), this.applyMatrix4(vn), this;
  }
  /**
   * Rotates the geometry about the X axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */
  rotateX(e) {
    return vn.makeRotationX(e), this.applyMatrix4(vn), this;
  }
  /**
   * Rotates the geometry about the Y axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */
  rotateY(e) {
    return vn.makeRotationY(e), this.applyMatrix4(vn), this;
  }
  /**
   * Rotates the geometry about the Z axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */
  rotateZ(e) {
    return vn.makeRotationZ(e), this.applyMatrix4(vn), this;
  }
  /**
   * Translates the geometry. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#position} for typical
   * real-time mesh rotation.
   *
   * @param {number} x - The x offset.
   * @param {number} y - The y offset.
   * @param {number} z - The z offset.
   * @return {BufferGeometry} A reference to this instance.
   */
  translate(e, t, n) {
    return vn.makeTranslation(e, t, n), this.applyMatrix4(vn), this;
  }
  /**
   * Scales the geometry. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#scale} for typical
   * real-time mesh rotation.
   *
   * @param {number} x - The x scale.
   * @param {number} y - The y scale.
   * @param {number} z - The z scale.
   * @return {BufferGeometry} A reference to this instance.
   */
  scale(e, t, n) {
    return vn.makeScale(e, t, n), this.applyMatrix4(vn), this;
  }
  /**
   * Rotates the geometry to face a point in 3D space. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#lookAt} for typical
   * real-time mesh rotation.
   *
   * @param {Vector3} vector - The target point.
   * @return {BufferGeometry} A reference to this instance.
   */
  lookAt(e) {
    return no.lookAt(e), no.updateMatrix(), this.applyMatrix4(no.matrix), this;
  }
  /**
   * Center the geometry based on its bounding box.
   *
   * @return {BufferGeometry} A reference to this instance.
   */
  center() {
    return this.computeBoundingBox(), this.boundingBox.getCenter(ds).negate(), this.translate(ds.x, ds.y, ds.z), this;
  }
  /**
   * Defines a geometry by creating a `position` attribute based on the given array of points. The array
   * can hold 2D or 3D vectors. When using two-dimensional data, the `z` coordinate for all vertices is
   * set to `0`.
   *
   * If the method is used with an existing `position` attribute, the vertex data are overwritten with the
   * data from the array. The length of the array must match the vertex count.
   *
   * @param {Array<Vector2>|Array<Vector3>} points - The points.
   * @return {BufferGeometry} A reference to this instance.
   */
  setFromPoints(e) {
    const t = this.getAttribute("position");
    if (t === void 0) {
      const n = [];
      for (let i = 0, r = e.length; i < r; i++) {
        const a = e[i];
        n.push(a.x, a.y, a.z || 0);
      }
      this.setAttribute("position", new Sn(n, 3));
    } else {
      const n = Math.min(e.length, t.count);
      for (let i = 0; i < n; i++) {
        const r = e[i];
        t.setXYZ(i, r.x, r.y, r.z || 0);
      }
      e.length > t.count && console.warn("THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry."), t.needsUpdate = !0;
    }
    return this;
  }
  /**
   * Computes the bounding box of the geometry, and updates the `boundingBox` member.
   * The bounding box is not computed by the engine; it must be computed by your app.
   * You may need to recompute the bounding box if the geometry vertices are modified.
   */
  computeBoundingBox() {
    this.boundingBox === null && (this.boundingBox = new Mt());
    const e = this.attributes.position, t = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      console.error("THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this), this.boundingBox.set(
        new T(-1 / 0, -1 / 0, -1 / 0),
        new T(1 / 0, 1 / 0, 1 / 0)
      );
      return;
    }
    if (e !== void 0) {
      if (this.boundingBox.setFromBufferAttribute(e), t)
        for (let n = 0, i = t.length; n < i; n++) {
          const r = t[n];
          pn.setFromBufferAttribute(r), this.morphTargetsRelative ? (Ht.addVectors(this.boundingBox.min, pn.min), this.boundingBox.expandByPoint(Ht), Ht.addVectors(this.boundingBox.max, pn.max), this.boundingBox.expandByPoint(Ht)) : (this.boundingBox.expandByPoint(pn.min), this.boundingBox.expandByPoint(pn.max));
        }
    } else
      this.boundingBox.makeEmpty();
    (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
  }
  /**
   * Computes the bounding sphere of the geometry, and updates the `boundingSphere` member.
   * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
   * You may need to recompute the bounding sphere if the geometry vertices are modified.
   */
  computeBoundingSphere() {
    this.boundingSphere === null && (this.boundingSphere = new Mn());
    const e = this.attributes.position, t = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      console.error("THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this), this.boundingSphere.set(new T(), 1 / 0);
      return;
    }
    if (e) {
      const n = this.boundingSphere.center;
      if (pn.setFromBufferAttribute(e), t)
        for (let r = 0, a = t.length; r < a; r++) {
          const o = t[r];
          nr.setFromBufferAttribute(o), this.morphTargetsRelative ? (Ht.addVectors(pn.min, nr.min), pn.expandByPoint(Ht), Ht.addVectors(pn.max, nr.max), pn.expandByPoint(Ht)) : (pn.expandByPoint(nr.min), pn.expandByPoint(nr.max));
        }
      pn.getCenter(n);
      let i = 0;
      for (let r = 0, a = e.count; r < a; r++)
        Ht.fromBufferAttribute(e, r), i = Math.max(i, n.distanceToSquared(Ht));
      if (t)
        for (let r = 0, a = t.length; r < a; r++) {
          const o = t[r], l = this.morphTargetsRelative;
          for (let c = 0, u = o.count; c < u; c++)
            Ht.fromBufferAttribute(o, c), l && (ds.fromBufferAttribute(e, c), Ht.add(ds)), i = Math.max(i, n.distanceToSquared(Ht));
        }
      this.boundingSphere.radius = Math.sqrt(i), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
    }
  }
  /**
   * Calculates and adds a tangent attribute to this geometry.
   *
   * The computation is only supported for indexed geometries and if position, normal, and uv attributes
   * are defined. When using a tangent space normal map, prefer the MikkTSpace algorithm provided by
   * {@link BufferGeometryUtils#computeMikkTSpaceTangents} instead.
   */
  computeTangents() {
    const e = this.index, t = this.attributes;
    if (e === null || t.position === void 0 || t.normal === void 0 || t.uv === void 0) {
      console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      return;
    }
    const n = t.position, i = t.normal, r = t.uv;
    this.hasAttribute("tangent") === !1 && this.setAttribute("tangent", new Kt(new Float32Array(4 * n.count), 4));
    const a = this.getAttribute("tangent"), o = [], l = [];
    for (let P = 0; P < n.count; P++)
      o[P] = new T(), l[P] = new T();
    const c = new T(), u = new T(), h = new T(), d = new ze(), f = new ze(), m = new ze(), _ = new T(), g = new T();
    function p(P, b, y) {
      c.fromBufferAttribute(n, P), u.fromBufferAttribute(n, b), h.fromBufferAttribute(n, y), d.fromBufferAttribute(r, P), f.fromBufferAttribute(r, b), m.fromBufferAttribute(r, y), u.sub(c), h.sub(c), f.sub(d), m.sub(d);
      const L = 1 / (f.x * m.y - m.x * f.y);
      isFinite(L) && (_.copy(u).multiplyScalar(m.y).addScaledVector(h, -f.y).multiplyScalar(L), g.copy(h).multiplyScalar(f.x).addScaledVector(u, -m.x).multiplyScalar(L), o[P].add(_), o[b].add(_), o[y].add(_), l[P].add(g), l[b].add(g), l[y].add(g));
    }
    let M = this.groups;
    M.length === 0 && (M = [{
      start: 0,
      count: e.count
    }]);
    for (let P = 0, b = M.length; P < b; ++P) {
      const y = M[P], L = y.start, O = y.count;
      for (let U = L, N = L + O; U < N; U += 3)
        p(
          e.getX(U + 0),
          e.getX(U + 1),
          e.getX(U + 2)
        );
    }
    const S = new T(), x = new T(), R = new T(), w = new T();
    function C(P) {
      R.fromBufferAttribute(i, P), w.copy(R);
      const b = o[P];
      S.copy(b), S.sub(R.multiplyScalar(R.dot(b))).normalize(), x.crossVectors(w, b);
      const L = x.dot(l[P]) < 0 ? -1 : 1;
      a.setXYZW(P, S.x, S.y, S.z, L);
    }
    for (let P = 0, b = M.length; P < b; ++P) {
      const y = M[P], L = y.start, O = y.count;
      for (let U = L, N = L + O; U < N; U += 3)
        C(e.getX(U + 0)), C(e.getX(U + 1)), C(e.getX(U + 2));
    }
  }
  /**
   * Computes vertex normals for the given vertex data. For indexed geometries, the method sets
   * each vertex normal to be the average of the face normals of the faces that share that vertex.
   * For non-indexed geometries, vertices are not shared, and the method sets each vertex normal
   * to be the same as the face normal.
   */
  computeVertexNormals() {
    const e = this.index, t = this.getAttribute("position");
    if (t !== void 0) {
      let n = this.getAttribute("normal");
      if (n === void 0)
        n = new Kt(new Float32Array(t.count * 3), 3), this.setAttribute("normal", n);
      else
        for (let d = 0, f = n.count; d < f; d++)
          n.setXYZ(d, 0, 0, 0);
      const i = new T(), r = new T(), a = new T(), o = new T(), l = new T(), c = new T(), u = new T(), h = new T();
      if (e)
        for (let d = 0, f = e.count; d < f; d += 3) {
          const m = e.getX(d + 0), _ = e.getX(d + 1), g = e.getX(d + 2);
          i.fromBufferAttribute(t, m), r.fromBufferAttribute(t, _), a.fromBufferAttribute(t, g), u.subVectors(a, r), h.subVectors(i, r), u.cross(h), o.fromBufferAttribute(n, m), l.fromBufferAttribute(n, _), c.fromBufferAttribute(n, g), o.add(u), l.add(u), c.add(u), n.setXYZ(m, o.x, o.y, o.z), n.setXYZ(_, l.x, l.y, l.z), n.setXYZ(g, c.x, c.y, c.z);
        }
      else
        for (let d = 0, f = t.count; d < f; d += 3)
          i.fromBufferAttribute(t, d + 0), r.fromBufferAttribute(t, d + 1), a.fromBufferAttribute(t, d + 2), u.subVectors(a, r), h.subVectors(i, r), u.cross(h), n.setXYZ(d + 0, u.x, u.y, u.z), n.setXYZ(d + 1, u.x, u.y, u.z), n.setXYZ(d + 2, u.x, u.y, u.z);
      this.normalizeNormals(), n.needsUpdate = !0;
    }
  }
  /**
   * Ensures every normal vector in a geometry will have a magnitude of `1`. This will
   * correct lighting on the geometry surfaces.
   */
  normalizeNormals() {
    const e = this.attributes.normal;
    for (let t = 0, n = e.count; t < n; t++)
      Ht.fromBufferAttribute(e, t), Ht.normalize(), e.setXYZ(t, Ht.x, Ht.y, Ht.z);
  }
  /**
   * Return a new non-index version of this indexed geometry. If the geometry
   * is already non-indexed, the method is a NOOP.
   *
   * @return {BufferGeometry} The non-indexed version of this indexed geometry.
   */
  toNonIndexed() {
    function e(o, l) {
      const c = o.array, u = o.itemSize, h = o.normalized, d = new c.constructor(l.length * u);
      let f = 0, m = 0;
      for (let _ = 0, g = l.length; _ < g; _++) {
        o.isInterleavedBufferAttribute ? f = l[_] * o.data.stride + o.offset : f = l[_] * u;
        for (let p = 0; p < u; p++)
          d[m++] = c[f++];
      }
      return new Kt(d, u, h);
    }
    if (this.index === null)
      return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
    const t = new _n(), n = this.index.array, i = this.attributes;
    for (const o in i) {
      const l = i[o], c = e(l, n);
      t.setAttribute(o, c);
    }
    const r = this.morphAttributes;
    for (const o in r) {
      const l = [], c = r[o];
      for (let u = 0, h = c.length; u < h; u++) {
        const d = c[u], f = e(d, n);
        l.push(f);
      }
      t.morphAttributes[o] = l;
    }
    t.morphTargetsRelative = this.morphTargetsRelative;
    const a = this.groups;
    for (let o = 0, l = a.length; o < l; o++) {
      const c = a[o];
      t.addGroup(c.start, c.count, c.materialIndex);
    }
    return t;
  }
  /**
   * Serializes the geometry into JSON.
   *
   * @return {Object} A JSON object representing the serialized geometry.
   */
  toJSON() {
    const e = {
      metadata: {
        version: 4.6,
        type: "BufferGeometry",
        generator: "BufferGeometry.toJSON"
      }
    };
    if (e.uuid = this.uuid, e.type = this.type, this.name !== "" && (e.name = this.name), Object.keys(this.userData).length > 0 && (e.userData = this.userData), this.parameters !== void 0) {
      const l = this.parameters;
      for (const c in l)
        l[c] !== void 0 && (e[c] = l[c]);
      return e;
    }
    e.data = { attributes: {} };
    const t = this.index;
    t !== null && (e.data.index = {
      type: t.array.constructor.name,
      array: Array.prototype.slice.call(t.array)
    });
    const n = this.attributes;
    for (const l in n) {
      const c = n[l];
      e.data.attributes[l] = c.toJSON(e.data);
    }
    const i = {};
    let r = !1;
    for (const l in this.morphAttributes) {
      const c = this.morphAttributes[l], u = [];
      for (let h = 0, d = c.length; h < d; h++) {
        const f = c[h];
        u.push(f.toJSON(e.data));
      }
      u.length > 0 && (i[l] = u, r = !0);
    }
    r && (e.data.morphAttributes = i, e.data.morphTargetsRelative = this.morphTargetsRelative);
    const a = this.groups;
    a.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(a)));
    const o = this.boundingSphere;
    return o !== null && (e.data.boundingSphere = {
      center: o.center.toArray(),
      radius: o.radius
    }), e;
  }
  /**
   * Returns a new geometry with copied values from this instance.
   *
   * @return {BufferGeometry} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given geometry to this instance.
   *
   * @param {BufferGeometry} source - The geometry to copy.
   * @return {BufferGeometry} A reference to this instance.
   */
  copy(e) {
    this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
    const t = {};
    this.name = e.name;
    const n = e.index;
    n !== null && this.setIndex(n.clone());
    const i = e.attributes;
    for (const c in i) {
      const u = i[c];
      this.setAttribute(c, u.clone(t));
    }
    const r = e.morphAttributes;
    for (const c in r) {
      const u = [], h = r[c];
      for (let d = 0, f = h.length; d < f; d++)
        u.push(h[d].clone(t));
      this.morphAttributes[c] = u;
    }
    this.morphTargetsRelative = e.morphTargetsRelative;
    const a = e.groups;
    for (let c = 0, u = a.length; c < u; c++) {
      const h = a[c];
      this.addGroup(h.start, h.count, h.materialIndex);
    }
    const o = e.boundingBox;
    o !== null && (this.boundingBox = o.clone());
    const l = e.boundingSphere;
    return l !== null && (this.boundingSphere = l.clone()), this.drawRange.start = e.drawRange.start, this.drawRange.count = e.drawRange.count, this.userData = e.userData, this;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires BufferGeometry#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
const Hc = /* @__PURE__ */ new Ye(), Hi = /* @__PURE__ */ new Ar(), Hr = /* @__PURE__ */ new Mn(), Vc = /* @__PURE__ */ new T(), Vr = /* @__PURE__ */ new T(), Gr = /* @__PURE__ */ new T(), Wr = /* @__PURE__ */ new T(), io = /* @__PURE__ */ new T(), Xr = /* @__PURE__ */ new T(), Gc = /* @__PURE__ */ new T(), qr = /* @__PURE__ */ new T();
class xt extends bt {
  /**
   * Constructs a new mesh.
   *
   * @param {BufferGeometry} [geometry] - The mesh geometry.
   * @param {Material|Array<Material>} [material] - The mesh material.
   */
  constructor(e = new _n(), t = new hi()) {
    super(), this.isMesh = !0, this.type = "Mesh", this.geometry = e, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.updateMorphTargets();
  }
  copy(e, t) {
    return super.copy(e, t), e.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = e.morphTargetInfluences.slice()), e.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, e.morphTargetDictionary)), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
  }
  /**
   * Sets the values of {@link Mesh#morphTargetDictionary} and {@link Mesh#morphTargetInfluences}
   * to make sure existing morph targets can influence this 3D object.
   */
  updateMorphTargets() {
    const t = this.geometry.morphAttributes, n = Object.keys(t);
    if (n.length > 0) {
      const i = t[n[0]];
      if (i !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let r = 0, a = i.length; r < a; r++) {
          const o = i[r].name || String(r);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[o] = r;
        }
      }
    }
  }
  /**
   * Returns the local-space position of the vertex at the given index, taking into
   * account the current animation state of both morph targets and skinning.
   *
   * @param {number} index - The vertex index.
   * @param {Vector3} target - The target object that is used to store the method's result.
   * @return {Vector3} The vertex position in local space.
   */
  getVertexPosition(e, t) {
    const n = this.geometry, i = n.attributes.position, r = n.morphAttributes.position, a = n.morphTargetsRelative;
    t.fromBufferAttribute(i, e);
    const o = this.morphTargetInfluences;
    if (r && o) {
      Xr.set(0, 0, 0);
      for (let l = 0, c = r.length; l < c; l++) {
        const u = o[l], h = r[l];
        u !== 0 && (io.fromBufferAttribute(h, e), a ? Xr.addScaledVector(io, u) : Xr.addScaledVector(io.sub(t), u));
      }
      t.add(Xr);
    }
    return t;
  }
  /**
   * Computes intersection points between a casted ray and this line.
   *
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - The target array that holds the intersection points.
   */
  raycast(e, t) {
    const n = this.geometry, i = this.material, r = this.matrixWorld;
    i !== void 0 && (n.boundingSphere === null && n.computeBoundingSphere(), Hr.copy(n.boundingSphere), Hr.applyMatrix4(r), Hi.copy(e.ray).recast(e.near), !(Hr.containsPoint(Hi.origin) === !1 && (Hi.intersectSphere(Hr, Vc) === null || Hi.origin.distanceToSquared(Vc) > (e.far - e.near) ** 2)) && (Hc.copy(r).invert(), Hi.copy(e.ray).applyMatrix4(Hc), !(n.boundingBox !== null && Hi.intersectsBox(n.boundingBox) === !1) && this._computeIntersections(e, t, Hi)));
  }
  _computeIntersections(e, t, n) {
    let i;
    const r = this.geometry, a = this.material, o = r.index, l = r.attributes.position, c = r.attributes.uv, u = r.attributes.uv1, h = r.attributes.normal, d = r.groups, f = r.drawRange;
    if (o !== null)
      if (Array.isArray(a))
        for (let m = 0, _ = d.length; m < _; m++) {
          const g = d[m], p = a[g.materialIndex], M = Math.max(g.start, f.start), S = Math.min(o.count, Math.min(g.start + g.count, f.start + f.count));
          for (let x = M, R = S; x < R; x += 3) {
            const w = o.getX(x), C = o.getX(x + 1), P = o.getX(x + 2);
            i = Yr(this, p, e, n, c, u, h, w, C, P), i && (i.faceIndex = Math.floor(x / 3), i.face.materialIndex = g.materialIndex, t.push(i));
          }
        }
      else {
        const m = Math.max(0, f.start), _ = Math.min(o.count, f.start + f.count);
        for (let g = m, p = _; g < p; g += 3) {
          const M = o.getX(g), S = o.getX(g + 1), x = o.getX(g + 2);
          i = Yr(this, a, e, n, c, u, h, M, S, x), i && (i.faceIndex = Math.floor(g / 3), t.push(i));
        }
      }
    else if (l !== void 0)
      if (Array.isArray(a))
        for (let m = 0, _ = d.length; m < _; m++) {
          const g = d[m], p = a[g.materialIndex], M = Math.max(g.start, f.start), S = Math.min(l.count, Math.min(g.start + g.count, f.start + f.count));
          for (let x = M, R = S; x < R; x += 3) {
            const w = x, C = x + 1, P = x + 2;
            i = Yr(this, p, e, n, c, u, h, w, C, P), i && (i.faceIndex = Math.floor(x / 3), i.face.materialIndex = g.materialIndex, t.push(i));
          }
        }
      else {
        const m = Math.max(0, f.start), _ = Math.min(l.count, f.start + f.count);
        for (let g = m, p = _; g < p; g += 3) {
          const M = g, S = g + 1, x = g + 2;
          i = Yr(this, a, e, n, c, u, h, M, S, x), i && (i.faceIndex = Math.floor(g / 3), t.push(i));
        }
      }
  }
}
function jf(s, e, t, n, i, r, a, o) {
  let l;
  if (e.side === an ? l = n.intersectTriangle(a, r, i, !0, o) : l = n.intersectTriangle(i, r, a, e.side === gi, o), l === null) return null;
  qr.copy(o), qr.applyMatrix4(s.matrixWorld);
  const c = t.ray.origin.distanceTo(qr);
  return c < t.near || c > t.far ? null : {
    distance: c,
    point: qr.clone(),
    object: s
  };
}
function Yr(s, e, t, n, i, r, a, o, l, c) {
  s.getVertexPosition(o, Vr), s.getVertexPosition(l, Gr), s.getVertexPosition(c, Wr);
  const u = jf(s, e, t, n, Vr, Gr, Wr, Gc);
  if (u) {
    const h = new T();
    Nn.getBarycoord(Gc, Vr, Gr, Wr, h), i && (u.uv = Nn.getInterpolatedAttribute(i, o, l, c, h, new ze())), r && (u.uv1 = Nn.getInterpolatedAttribute(r, o, l, c, h, new ze())), a && (u.normal = Nn.getInterpolatedAttribute(a, o, l, c, h, new T()), u.normal.dot(n.direction) > 0 && u.normal.multiplyScalar(-1));
    const d = {
      a: o,
      b: l,
      c,
      normal: new T(),
      materialIndex: 0
    };
    Nn.getNormal(Vr, Gr, Wr, d.normal), u.face = d, u.barycoord = h;
  }
  return u;
}
class Vs extends _n {
  /**
   * Constructs a new box geometry.
   *
   * @param {number} [width=1] - The width. That is, the length of the edges parallel to the X axis.
   * @param {number} [height=1] - The height. That is, the length of the edges parallel to the Y axis.
   * @param {number} [depth=1] - The depth. That is, the length of the edges parallel to the Z axis.
   * @param {number} [widthSegments=1] - Number of segmented rectangular faces along the width of the sides.
   * @param {number} [heightSegments=1] - Number of segmented rectangular faces along the height of the sides.
   * @param {number} [depthSegments=1] - Number of segmented rectangular faces along the depth of the sides.
   */
  constructor(e = 1, t = 1, n = 1, i = 1, r = 1, a = 1) {
    super(), this.type = "BoxGeometry", this.parameters = {
      width: e,
      height: t,
      depth: n,
      widthSegments: i,
      heightSegments: r,
      depthSegments: a
    };
    const o = this;
    i = Math.floor(i), r = Math.floor(r), a = Math.floor(a);
    const l = [], c = [], u = [], h = [];
    let d = 0, f = 0;
    m("z", "y", "x", -1, -1, n, t, e, a, r, 0), m("z", "y", "x", 1, -1, n, t, -e, a, r, 1), m("x", "z", "y", 1, 1, e, n, t, i, a, 2), m("x", "z", "y", 1, -1, e, n, -t, i, a, 3), m("x", "y", "z", 1, -1, e, t, n, i, r, 4), m("x", "y", "z", -1, -1, e, t, -n, i, r, 5), this.setIndex(l), this.setAttribute("position", new Sn(c, 3)), this.setAttribute("normal", new Sn(u, 3)), this.setAttribute("uv", new Sn(h, 2));
    function m(_, g, p, M, S, x, R, w, C, P, b) {
      const y = x / C, L = R / P, O = x / 2, U = R / 2, N = w / 2, Y = C + 1, G = P + 1;
      let ne = 0, B = 0;
      const Z = new T();
      for (let Q = 0; Q < G; Q++) {
        const xe = Q * L - U;
        for (let ye = 0; ye < Y; ye++) {
          const ce = ye * y - O;
          Z[_] = ce * M, Z[g] = xe * S, Z[p] = N, c.push(Z.x, Z.y, Z.z), Z[_] = 0, Z[g] = 0, Z[p] = w > 0 ? 1 : -1, u.push(Z.x, Z.y, Z.z), h.push(ye / C), h.push(1 - Q / P), ne += 1;
        }
      }
      for (let Q = 0; Q < P; Q++)
        for (let xe = 0; xe < C; xe++) {
          const ye = d + xe + Y * Q, ce = d + xe + Y * (Q + 1), V = d + (xe + 1) + Y * (Q + 1), se = d + (xe + 1) + Y * Q;
          l.push(ye, ce, se), l.push(ce, V, se), B += 6;
        }
      o.addGroup(f, B, b), f += B, d += ne;
    }
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {BoxGeometry} A new instance.
   */
  static fromJSON(e) {
    return new Vs(e.width, e.height, e.depth, e.widthSegments, e.heightSegments, e.depthSegments);
  }
}
function Bs(s) {
  const e = {};
  for (const t in s) {
    e[t] = {};
    for (const n in s[t]) {
      const i = s[t][n];
      i && (i.isColor || i.isMatrix3 || i.isMatrix4 || i.isVector2 || i.isVector3 || i.isVector4 || i.isTexture || i.isQuaternion) ? i.isRenderTargetTexture ? (console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), e[t][n] = null) : e[t][n] = i.clone() : Array.isArray(i) ? e[t][n] = i.slice() : e[t][n] = i;
    }
  }
  return e;
}
function sn(s) {
  const e = {};
  for (let t = 0; t < s.length; t++) {
    const n = Bs(s[t]);
    for (const i in n)
      e[i] = n[i];
  }
  return e;
}
function Kf(s) {
  const e = [];
  for (let t = 0; t < s.length; t++)
    e.push(s[t].clone());
  return e;
}
function zh(s) {
  const e = s.getRenderTarget();
  return e === null ? s.outputColorSpace : e.isXRRenderTarget === !0 ? e.texture.colorSpace : ot.workingColorSpace;
}
const Wl = { clone: Bs, merge: sn };
var Zf = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, $f = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`;
class jn extends qn {
  /**
   * Constructs a new shader material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = Zf, this.fragmentShader = $f, this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
      clipCullDistance: !1,
      // set to use vertex shader clipping
      multiDraw: !1
      // set to use vertex shader multi_draw / enable gl_DrawID
    }, this.defaultAttributeValues = {
      color: [1, 1, 1],
      uv: [0, 0],
      uv1: [0, 0]
    }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, e !== void 0 && this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.fragmentShader = e.fragmentShader, this.vertexShader = e.vertexShader, this.uniforms = Bs(e.uniforms), this.uniformsGroups = Kf(e.uniformsGroups), this.defines = Object.assign({}, e.defines), this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.fog = e.fog, this.lights = e.lights, this.clipping = e.clipping, this.extensions = Object.assign({}, e.extensions), this.glslVersion = e.glslVersion, this;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    t.glslVersion = this.glslVersion, t.uniforms = {};
    for (const i in this.uniforms) {
      const a = this.uniforms[i].value;
      a && a.isTexture ? t.uniforms[i] = {
        type: "t",
        value: a.toJSON(e).uuid
      } : a && a.isColor ? t.uniforms[i] = {
        type: "c",
        value: a.getHex()
      } : a && a.isVector2 ? t.uniforms[i] = {
        type: "v2",
        value: a.toArray()
      } : a && a.isVector3 ? t.uniforms[i] = {
        type: "v3",
        value: a.toArray()
      } : a && a.isVector4 ? t.uniforms[i] = {
        type: "v4",
        value: a.toArray()
      } : a && a.isMatrix3 ? t.uniforms[i] = {
        type: "m3",
        value: a.toArray()
      } : a && a.isMatrix4 ? t.uniforms[i] = {
        type: "m4",
        value: a.toArray()
      } : t.uniforms[i] = {
        value: a
      };
    }
    Object.keys(this.defines).length > 0 && (t.defines = this.defines), t.vertexShader = this.vertexShader, t.fragmentShader = this.fragmentShader, t.lights = this.lights, t.clipping = this.clipping;
    const n = {};
    for (const i in this.extensions)
      this.extensions[i] === !0 && (n[i] = !0);
    return Object.keys(n).length > 0 && (t.extensions = n), t;
  }
}
class Hh extends bt {
  /**
   * Constructs a new camera.
   */
  constructor() {
    super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new Ye(), this.projectionMatrix = new Ye(), this.projectionMatrixInverse = new Ye(), this.coordinateSystem = ui;
  }
  copy(e, t) {
    return super.copy(e, t), this.matrixWorldInverse.copy(e.matrixWorldInverse), this.projectionMatrix.copy(e.projectionMatrix), this.projectionMatrixInverse.copy(e.projectionMatrixInverse), this.coordinateSystem = e.coordinateSystem, this;
  }
  /**
   * Returns a vector representing the ("look") direction of the 3D object in world space.
   *
   * This method is overwritten since cameras have a different forward vector compared to other
   * 3D objects. A camera looks down its local, negative z-axis by default.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's direction in world space.
   */
  getWorldDirection(e) {
    return super.getWorldDirection(e).negate();
  }
  updateMatrixWorld(e) {
    super.updateMatrixWorld(e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  updateWorldMatrix(e, t) {
    super.updateWorldMatrix(e, t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const Ei = /* @__PURE__ */ new T(), Wc = /* @__PURE__ */ new ze(), Xc = /* @__PURE__ */ new ze();
class rn extends Hh {
  /**
   * Constructs a new perspective camera.
   *
   * @param {number} [fov=50] - The vertical field of view.
   * @param {number} [aspect=1] - The aspect ratio.
   * @param {number} [near=0.1] - The camera's near plane.
   * @param {number} [far=2000] - The camera's far plane.
   */
  constructor(e = 50, t = 1, n = 0.1, i = 2e3) {
    super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = e, this.zoom = 1, this.near = n, this.far = i, this.focus = 10, this.aspect = t, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
  }
  copy(e, t) {
    return super.copy(e, t), this.fov = e.fov, this.zoom = e.zoom, this.near = e.near, this.far = e.far, this.focus = e.focus, this.aspect = e.aspect, this.view = e.view === null ? null : Object.assign({}, e.view), this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this;
  }
  /**
   * Sets the FOV by focal length in respect to the current {@link PerspectiveCamera#filmGauge}.
   *
   * The default film gauge is 35, so that the focal length can be specified for
   * a 35mm (full frame) camera.
   *
   * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
   */
  setFocalLength(e) {
    const t = 0.5 * this.getFilmHeight() / e;
    this.fov = Os * 2 * Math.atan(t), this.updateProjectionMatrix();
  }
  /**
   * Returns the focal length from the current {@link PerspectiveCamera#fov} and
   * {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The computed focal length.
   */
  getFocalLength() {
    const e = Math.tan(pr * 0.5 * this.fov);
    return 0.5 * this.getFilmHeight() / e;
  }
  /**
   * Returns the current vertical field of view angle in degrees considering {@link PerspectiveCamera#zoom}.
   *
   * @return {number} The effective FOV.
   */
  getEffectiveFOV() {
    return Os * 2 * Math.atan(
      Math.tan(pr * 0.5 * this.fov) / this.zoom
    );
  }
  /**
   * Returns the width of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
   * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The film width.
   */
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1);
  }
  /**
   * Returns the height of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
   * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The film width.
   */
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1);
  }
  /**
   * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
   * Sets `minTarget` and `maxTarget` to the coordinates of the lower-left and upper-right corners of the view rectangle.
   *
   * @param {number} distance - The viewing distance.
   * @param {Vector2} minTarget - The lower-left corner of the view rectangle is written into this vector.
   * @param {Vector2} maxTarget - The upper-right corner of the view rectangle is written into this vector.
   */
  getViewBounds(e, t, n) {
    Ei.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse), t.set(Ei.x, Ei.y).multiplyScalar(-e / Ei.z), Ei.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse), n.set(Ei.x, Ei.y).multiplyScalar(-e / Ei.z);
  }
  /**
   * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
   *
   * @param {number} distance - The viewing distance.
   * @param {Vector2} target - The target vector that is used to store result where x is width and y is height.
   * @returns {Vector2} The view size.
   */
  getViewSize(e, t) {
    return this.getViewBounds(e, Wc, Xc), t.subVectors(Xc, Wc);
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
   * the monitors are in grid like this
   *```
   *   +---+---+---+
   *   | A | B | C |
   *   +---+---+---+
   *   | D | E | F |
   *   +---+---+---+
   *```
   * then for each monitor you would call it like this:
   *```js
   * const w = 1920;
   * const h = 1080;
   * const fullWidth = w * 3;
   * const fullHeight = h * 2;
   *
   * // --A--
   * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
   * // --B--
   * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
   * // --C--
   * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
   * // --D--
   * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
   * // --E--
   * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
   * // --F--
   * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
   * ```
   *
   * Note there is no reason monitors have to be the same size or in a grid.
   *
   * @param {number} fullWidth - The full width of multiview setup.
   * @param {number} fullHeight - The full height of multiview setup.
   * @param {number} x - The horizontal offset of the subcamera.
   * @param {number} y - The vertical offset of the subcamera.
   * @param {number} width - The width of subcamera.
   * @param {number} height - The height of subcamera.
   */
  setViewOffset(e, t, n, i, r, a) {
    this.aspect = e / t, this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = a, this.updateProjectionMatrix();
  }
  /**
   * Removes the view offset from the projection matrix.
   */
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  /**
   * Updates the camera's projection matrix. Must be called after any change of
   * camera properties.
   */
  updateProjectionMatrix() {
    const e = this.near;
    let t = e * Math.tan(pr * 0.5 * this.fov) / this.zoom, n = 2 * t, i = this.aspect * n, r = -0.5 * i;
    const a = this.view;
    if (this.view !== null && this.view.enabled) {
      const l = a.fullWidth, c = a.fullHeight;
      r += a.offsetX * i / l, t -= a.offsetY * n / c, i *= a.width / l, n *= a.height / c;
    }
    const o = this.filmOffset;
    o !== 0 && (r += e * o / this.getFilmWidth()), this.projectionMatrix.makePerspective(r, r + i, t, t - n, e, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.object.fov = this.fov, t.object.zoom = this.zoom, t.object.near = this.near, t.object.far = this.far, t.object.focus = this.focus, t.object.aspect = this.aspect, this.view !== null && (t.object.view = Object.assign({}, this.view)), t.object.filmGauge = this.filmGauge, t.object.filmOffset = this.filmOffset, t;
  }
}
const fs = -90, ps = 1;
class Jf extends bt {
  /**
   * Constructs a new cube camera.
   *
   * @param {number} near - The camera's near plane.
   * @param {number} far - The camera's far plane.
   * @param {WebGLCubeRenderTarget} renderTarget - The cube render target.
   */
  constructor(e, t, n) {
    super(), this.type = "CubeCamera", this.renderTarget = n, this.coordinateSystem = null, this.activeMipmapLevel = 0;
    const i = new rn(fs, ps, e, t);
    i.layers = this.layers, this.add(i);
    const r = new rn(fs, ps, e, t);
    r.layers = this.layers, this.add(r);
    const a = new rn(fs, ps, e, t);
    a.layers = this.layers, this.add(a);
    const o = new rn(fs, ps, e, t);
    o.layers = this.layers, this.add(o);
    const l = new rn(fs, ps, e, t);
    l.layers = this.layers, this.add(l);
    const c = new rn(fs, ps, e, t);
    c.layers = this.layers, this.add(c);
  }
  /**
   * Must be called when the coordinate system of the cube camera is changed.
   */
  updateCoordinateSystem() {
    const e = this.coordinateSystem, t = this.children.concat(), [n, i, r, a, o, l] = t;
    for (const c of t) this.remove(c);
    if (e === ui)
      n.up.set(0, 1, 0), n.lookAt(1, 0, 0), i.up.set(0, 1, 0), i.lookAt(-1, 0, 0), r.up.set(0, 0, -1), r.lookAt(0, 1, 0), a.up.set(0, 0, 1), a.lookAt(0, -1, 0), o.up.set(0, 1, 0), o.lookAt(0, 0, 1), l.up.set(0, 1, 0), l.lookAt(0, 0, -1);
    else if (e === Ta)
      n.up.set(0, -1, 0), n.lookAt(-1, 0, 0), i.up.set(0, -1, 0), i.lookAt(1, 0, 0), r.up.set(0, 0, 1), r.lookAt(0, 1, 0), a.up.set(0, 0, -1), a.lookAt(0, -1, 0), o.up.set(0, -1, 0), o.lookAt(0, 0, 1), l.up.set(0, -1, 0), l.lookAt(0, 0, -1);
    else
      throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + e);
    for (const c of t)
      this.add(c), c.updateMatrixWorld();
  }
  /**
   * Calling this method will render the given scene with the given renderer
   * into the cube render target of the camera.
   *
   * @param {(Renderer|WebGLRenderer)} renderer - The renderer.
   * @param {Scene} scene - The scene to render.
   */
  update(e, t) {
    this.parent === null && this.updateMatrixWorld();
    const { renderTarget: n, activeMipmapLevel: i } = this;
    this.coordinateSystem !== e.coordinateSystem && (this.coordinateSystem = e.coordinateSystem, this.updateCoordinateSystem());
    const [r, a, o, l, c, u] = this.children, h = e.getRenderTarget(), d = e.getActiveCubeFace(), f = e.getActiveMipmapLevel(), m = e.xr.enabled;
    e.xr.enabled = !1;
    const _ = n.texture.generateMipmaps;
    n.texture.generateMipmaps = !1, e.setRenderTarget(n, 0, i), e.render(t, r), e.setRenderTarget(n, 1, i), e.render(t, a), e.setRenderTarget(n, 2, i), e.render(t, o), e.setRenderTarget(n, 3, i), e.render(t, l), e.setRenderTarget(n, 4, i), e.render(t, c), n.texture.generateMipmaps = _, e.setRenderTarget(n, 5, i), e.render(t, u), e.setRenderTarget(h, d, f), e.xr.enabled = m, n.texture.needsPMREMUpdate = !0;
  }
}
class Vh extends Gt {
  /**
   * Constructs a new cube texture.
   *
   * @param {Array<Image>} [images=[]] - An array holding a image for each side of a cube.
   * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space value.
   */
  constructor(e = [], t = Ns, n, i, r, a, o, l, c, u) {
    super(e, t, n, i, r, a, o, l, c, u), this.isCubeTexture = !0, this.flipY = !1;
  }
  /**
   * Alias for {@link CubeTexture#image}.
   *
   * @type {Array<Image>}
   */
  get images() {
    return this.image;
  }
  set images(e) {
    this.image = e;
  }
}
class Qf extends Di {
  /**
   * Constructs a new cube render target.
   *
   * @param {number} [size=1] - The size of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */
  constructor(e = 1, t = {}) {
    super(e, e, t), this.isWebGLCubeRenderTarget = !0;
    const n = { width: e, height: e, depth: 1 }, i = [n, n, n, n, n, n];
    this.texture = new Vh(i, t.mapping, t.wrapS, t.wrapT, t.magFilter, t.minFilter, t.format, t.type, t.anisotropy, t.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.generateMipmaps = t.generateMipmaps !== void 0 ? t.generateMipmaps : !1, this.texture.minFilter = t.minFilter !== void 0 ? t.minFilter : Vt;
  }
  /**
   * Converts the given equirectangular texture to a cube map.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Texture} texture - The equirectangular texture.
   * @return {WebGLCubeRenderTarget} A reference to this cube render target.
   */
  fromEquirectangularTexture(e, t) {
    this.texture.type = t.type, this.texture.colorSpace = t.colorSpace, this.texture.generateMipmaps = t.generateMipmaps, this.texture.minFilter = t.minFilter, this.texture.magFilter = t.magFilter;
    const n = {
      uniforms: {
        tEquirect: { value: null }
      },
      vertexShader: (
        /* glsl */
        `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`
      ),
      fragmentShader: (
        /* glsl */
        `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
      )
    }, i = new Vs(5, 5, 5), r = new jn({
      name: "CubemapFromEquirect",
      uniforms: Bs(n.uniforms),
      vertexShader: n.vertexShader,
      fragmentShader: n.fragmentShader,
      side: an,
      blending: Pi
    });
    r.uniforms.tEquirect.value = t;
    const a = new xt(i, r), o = t.minFilter;
    return t.minFilter === Gn && (t.minFilter = Vt), new Jf(1, 10, this).update(e, a), t.minFilter = o, a.geometry.dispose(), a.material.dispose(), this;
  }
  /**
   * Clears this cube render target.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
   * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
   * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
   */
  clear(e, t = !0, n = !0, i = !0) {
    const r = e.getRenderTarget();
    for (let a = 0; a < 6; a++)
      e.setRenderTarget(this, a), e.clear(t, n, i);
    e.setRenderTarget(r);
  }
}
class Xn extends bt {
  constructor() {
    super(), this.isGroup = !0, this.type = "Group";
  }
}
const ep = { type: "move" };
class so {
  /**
   * Constructs a new XR controller.
   */
  constructor() {
    this._targetRay = null, this._grip = null, this._hand = null;
  }
  /**
   * Returns a group representing the hand space of the XR controller.
   *
   * @return {Group} A group representing the hand space of the XR controller.
   */
  getHandSpace() {
    return this._hand === null && (this._hand = new Xn(), this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = { pinching: !1 }), this._hand;
  }
  /**
   * Returns a group representing the target ray space of the XR controller.
   *
   * @return {Group} A group representing the target ray space of the XR controller.
   */
  getTargetRaySpace() {
    return this._targetRay === null && (this._targetRay = new Xn(), this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new T(), this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new T()), this._targetRay;
  }
  /**
   * Returns a group representing the grip space of the XR controller.
   *
   * @return {Group} A group representing the grip space of the XR controller.
   */
  getGripSpace() {
    return this._grip === null && (this._grip = new Xn(), this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new T(), this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new T()), this._grip;
  }
  /**
   * Dispatches the given event to the groups representing
   * the different coordinate spaces of the XR controller.
   *
   * @param {Object} event - The event to dispatch.
   * @return {WebXRController} A reference to this instance.
   */
  dispatchEvent(e) {
    return this._targetRay !== null && this._targetRay.dispatchEvent(e), this._grip !== null && this._grip.dispatchEvent(e), this._hand !== null && this._hand.dispatchEvent(e), this;
  }
  /**
   * Connects the controller with the given XR input source.
   *
   * @param {XRInputSource} inputSource - The input source.
   * @return {WebXRController} A reference to this instance.
   */
  connect(e) {
    if (e && e.hand) {
      const t = this._hand;
      if (t)
        for (const n of e.hand.values())
          this._getHandJoint(t, n);
    }
    return this.dispatchEvent({ type: "connected", data: e }), this;
  }
  /**
   * Disconnects the controller from the given XR input source.
   *
   * @param {XRInputSource} inputSource - The input source.
   * @return {WebXRController} A reference to this instance.
   */
  disconnect(e) {
    return this.dispatchEvent({ type: "disconnected", data: e }), this._targetRay !== null && (this._targetRay.visible = !1), this._grip !== null && (this._grip.visible = !1), this._hand !== null && (this._hand.visible = !1), this;
  }
  /**
   * Updates the controller with the given input source, XR frame and reference space.
   * This updates the transformations of the groups that represent the different
   * coordinate systems of the controller.
   *
   * @param {XRInputSource} inputSource - The input source.
   * @param {XRFrame} frame - The XR frame.
   * @param {XRReferenceSpace} referenceSpace - The reference space.
   * @return {WebXRController} A reference to this instance.
   */
  update(e, t, n) {
    let i = null, r = null, a = null;
    const o = this._targetRay, l = this._grip, c = this._hand;
    if (e && t.session.visibilityState !== "visible-blurred") {
      if (c && e.hand) {
        a = !0;
        for (const _ of e.hand.values()) {
          const g = t.getJointPose(_, n), p = this._getHandJoint(c, _);
          g !== null && (p.matrix.fromArray(g.transform.matrix), p.matrix.decompose(p.position, p.rotation, p.scale), p.matrixWorldNeedsUpdate = !0, p.jointRadius = g.radius), p.visible = g !== null;
        }
        const u = c.joints["index-finger-tip"], h = c.joints["thumb-tip"], d = u.position.distanceTo(h.position), f = 0.02, m = 5e-3;
        c.inputState.pinching && d > f + m ? (c.inputState.pinching = !1, this.dispatchEvent({
          type: "pinchend",
          handedness: e.handedness,
          target: this
        })) : !c.inputState.pinching && d <= f - m && (c.inputState.pinching = !0, this.dispatchEvent({
          type: "pinchstart",
          handedness: e.handedness,
          target: this
        }));
      } else
        l !== null && e.gripSpace && (r = t.getPose(e.gripSpace, n), r !== null && (l.matrix.fromArray(r.transform.matrix), l.matrix.decompose(l.position, l.rotation, l.scale), l.matrixWorldNeedsUpdate = !0, r.linearVelocity ? (l.hasLinearVelocity = !0, l.linearVelocity.copy(r.linearVelocity)) : l.hasLinearVelocity = !1, r.angularVelocity ? (l.hasAngularVelocity = !0, l.angularVelocity.copy(r.angularVelocity)) : l.hasAngularVelocity = !1));
      o !== null && (i = t.getPose(e.targetRaySpace, n), i === null && r !== null && (i = r), i !== null && (o.matrix.fromArray(i.transform.matrix), o.matrix.decompose(o.position, o.rotation, o.scale), o.matrixWorldNeedsUpdate = !0, i.linearVelocity ? (o.hasLinearVelocity = !0, o.linearVelocity.copy(i.linearVelocity)) : o.hasLinearVelocity = !1, i.angularVelocity ? (o.hasAngularVelocity = !0, o.angularVelocity.copy(i.angularVelocity)) : o.hasAngularVelocity = !1, this.dispatchEvent(ep)));
    }
    return o !== null && (o.visible = i !== null), l !== null && (l.visible = r !== null), c !== null && (c.visible = a !== null), this;
  }
  /**
   * Returns a group representing the hand joint for the given input joint.
   *
   * @private
   * @param {Group} hand - The group representing the hand space.
   * @param {XRHandJoint} inputjoint - The XR frame.
   * @return {Group} A group representing the hand joint for the given input joint.
   */
  _getHandJoint(e, t) {
    if (e.joints[t.jointName] === void 0) {
      const n = new Xn();
      n.matrixAutoUpdate = !1, n.visible = !1, e.joints[t.jointName] = n, e.add(n);
    }
    return e.joints[t.jointName];
  }
}
class Xl extends bt {
  /**
   * Constructs a new scene.
   */
  constructor() {
    super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.backgroundRotation = new Yn(), this.environmentIntensity = 1, this.environmentRotation = new Yn(), this.overrideMaterial = null, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
  }
  copy(e, t) {
    return super.copy(e, t), e.background !== null && (this.background = e.background.clone()), e.environment !== null && (this.environment = e.environment.clone()), e.fog !== null && (this.fog = e.fog.clone()), this.backgroundBlurriness = e.backgroundBlurriness, this.backgroundIntensity = e.backgroundIntensity, this.backgroundRotation.copy(e.backgroundRotation), this.environmentIntensity = e.environmentIntensity, this.environmentRotation.copy(e.environmentRotation), e.overrideMaterial !== null && (this.overrideMaterial = e.overrideMaterial.clone()), this.matrixAutoUpdate = e.matrixAutoUpdate, this;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return this.fog !== null && (t.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (t.object.backgroundBlurriness = this.backgroundBlurriness), this.backgroundIntensity !== 1 && (t.object.backgroundIntensity = this.backgroundIntensity), t.object.backgroundRotation = this.backgroundRotation.toArray(), this.environmentIntensity !== 1 && (t.object.environmentIntensity = this.environmentIntensity), t.object.environmentRotation = this.environmentRotation.toArray(), t;
  }
}
class Gh {
  /**
   * Constructs a new interleaved buffer.
   *
   * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
   * @param {number} stride - The number of typed-array elements per vertex.
   */
  constructor(e, t) {
    this.isInterleavedBuffer = !0, this.array = e, this.stride = t, this.count = e !== void 0 ? e.length / t : 0, this.usage = vl, this.updateRanges = [], this.version = 0, this.uuid = Un();
  }
  /**
   * A callback function that is executed after the renderer has transferred the attribute array
   * data to the GPU.
   */
  onUploadCallback() {
  }
  /**
   * Flag to indicate that this attribute has changed and should be re-sent to
   * the GPU. Set this to `true` when you modify the value of the array.
   *
   * @type {number}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  /**
   * Sets the usage of this interleaved buffer.
   *
   * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
   * @return {InterleavedBuffer} A reference to this interleaved buffer.
   */
  setUsage(e) {
    return this.usage = e, this;
  }
  /**
   * Adds a range of data in the data array to be updated on the GPU.
   *
   * @param {number} start - Position at which to start update.
   * @param {number} count - The number of components to update.
   */
  addUpdateRange(e, t) {
    this.updateRanges.push({ start: e, count: t });
  }
  /**
   * Clears the update ranges.
   */
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  /**
   * Copies the values of the given interleaved buffer to this instance.
   *
   * @param {InterleavedBuffer} source - The interleaved buffer to copy.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  copy(e) {
    return this.array = new e.array.constructor(e.array), this.count = e.count, this.stride = e.stride, this.usage = e.usage, this;
  }
  /**
   * Copies a vector from the given interleaved buffer to this one. The start
   * and destination position in the attribute buffers are represented by the
   * given indices.
   *
   * @param {number} index1 - The destination index into this interleaved buffer.
   * @param {InterleavedBuffer} interleavedBuffer - The interleaved buffer to copy from.
   * @param {number} index2 - The source index into the given interleaved buffer.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  copyAt(e, t, n) {
    e *= this.stride, n *= t.stride;
    for (let i = 0, r = this.stride; i < r; i++)
      this.array[e + i] = t.array[n + i];
    return this;
  }
  /**
   * Sets the given array data in the interleaved buffer.
   *
   * @param {(TypedArray|Array)} value - The array data to set.
   * @param {number} [offset=0] - The offset in this interleaved buffer's array.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  set(e, t = 0) {
    return this.array.set(e, t), this;
  }
  /**
   * Returns a new interleaved buffer with copied values from this instance.
   *
   * @param {Object} [data] - An object with shared array buffers that allows to retain shared structures.
   * @return {InterleavedBuffer} A clone of this instance.
   */
  clone(e) {
    e.arrayBuffers === void 0 && (e.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = Un()), e.arrayBuffers[this.array.buffer._uuid] === void 0 && (e.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
    const t = new this.array.constructor(e.arrayBuffers[this.array.buffer._uuid]), n = new this.constructor(t, this.stride);
    return n.setUsage(this.usage), n;
  }
  /**
   * Sets the given callback function that is executed after the Renderer has transferred
   * the array data to the GPU. Can be used to perform clean-up operations after
   * the upload when data are not needed anymore on the CPU side.
   *
   * @param {Function} callback - The `onUpload()` callback.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  onUpload(e) {
    return this.onUploadCallback = e, this;
  }
  /**
   * Serializes the interleaved buffer into JSON.
   *
   * @param {Object} [data] - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized interleaved buffer.
   */
  toJSON(e) {
    return e.arrayBuffers === void 0 && (e.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = Un()), e.arrayBuffers[this.array.buffer._uuid] === void 0 && (e.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
      uuid: this.uuid,
      buffer: this.array.buffer._uuid,
      type: this.array.constructor.name,
      stride: this.stride
    };
  }
}
const nn = /* @__PURE__ */ new T();
class di {
  /**
   * Constructs a new interleaved buffer attribute.
   *
   * @param {InterleavedBuffer} interleavedBuffer - The buffer holding the interleaved data.
   * @param {number} itemSize - The item size.
   * @param {number} offset - The attribute offset into the buffer.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, n, i = !1) {
    this.isInterleavedBufferAttribute = !0, this.name = "", this.data = e, this.itemSize = t, this.offset = n, this.normalized = i;
  }
  /**
   * The item count of this buffer attribute.
   *
   * @type {number}
   * @readonly
   */
  get count() {
    return this.data.count;
  }
  /**
   * The array holding the interleaved buffer attribute data.
   *
   * @type {TypedArray}
   */
  get array() {
    return this.data.array;
  }
  /**
   * Flag to indicate that this attribute has changed and should be re-sent to
   * the GPU. Set this to `true` when you modify the value of the array.
   *
   * @type {number}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    this.data.needsUpdate = e;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  applyMatrix4(e) {
    for (let t = 0, n = this.data.count; t < n; t++)
      nn.fromBufferAttribute(this, t), nn.applyMatrix4(e), this.setXYZ(t, nn.x, nn.y, nn.z);
    return this;
  }
  /**
   * Applies the given 3x3 normal matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix3} m - The normal matrix to apply.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  applyNormalMatrix(e) {
    for (let t = 0, n = this.count; t < n; t++)
      nn.fromBufferAttribute(this, t), nn.applyNormalMatrix(e), this.setXYZ(t, nn.x, nn.y, nn.z);
    return this;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3` and with direction vectors.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  transformDirection(e) {
    for (let t = 0, n = this.count; t < n; t++)
      nn.fromBufferAttribute(this, t), nn.transformDirection(e), this.setXYZ(t, nn.x, nn.y, nn.z);
    return this;
  }
  /**
   * Returns the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @return {number} The returned value.
   */
  getComponent(e, t) {
    let n = this.array[e * this.data.stride + this.offset + t];
    return this.normalized && (n = Dn(n, this.array)), n;
  }
  /**
   * Sets the given value to the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @param {number} value - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setComponent(e, t, n) {
    return this.normalized && (n = _t(n, this.array)), this.data.array[e * this.data.stride + this.offset + t] = n, this;
  }
  /**
   * Sets the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setX(e, t) {
    return this.normalized && (t = _t(t, this.array)), this.data.array[e * this.data.stride + this.offset] = t, this;
  }
  /**
   * Sets the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} y - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setY(e, t) {
    return this.normalized && (t = _t(t, this.array)), this.data.array[e * this.data.stride + this.offset + 1] = t, this;
  }
  /**
   * Sets the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} z - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setZ(e, t) {
    return this.normalized && (t = _t(t, this.array)), this.data.array[e * this.data.stride + this.offset + 2] = t, this;
  }
  /**
   * Sets the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} w - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setW(e, t) {
    return this.normalized && (t = _t(t, this.array)), this.data.array[e * this.data.stride + this.offset + 3] = t, this;
  }
  /**
   * Returns the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The x component.
   */
  getX(e) {
    let t = this.data.array[e * this.data.stride + this.offset];
    return this.normalized && (t = Dn(t, this.array)), t;
  }
  /**
   * Returns the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The y component.
   */
  getY(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 1];
    return this.normalized && (t = Dn(t, this.array)), t;
  }
  /**
   * Returns the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The z component.
   */
  getZ(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 2];
    return this.normalized && (t = Dn(t, this.array)), t;
  }
  /**
   * Returns the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The w component.
   */
  getW(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 3];
    return this.normalized && (t = Dn(t, this.array)), t;
  }
  /**
   * Sets the x and y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setXY(e, t, n) {
    return e = e * this.data.stride + this.offset, this.normalized && (t = _t(t, this.array), n = _t(n, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = n, this;
  }
  /**
   * Sets the x, y and z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setXYZ(e, t, n, i) {
    return e = e * this.data.stride + this.offset, this.normalized && (t = _t(t, this.array), n = _t(n, this.array), i = _t(i, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = n, this.data.array[e + 2] = i, this;
  }
  /**
   * Sets the x, y, z and w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @param {number} w - The value for the w component to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setXYZW(e, t, n, i, r) {
    return e = e * this.data.stride + this.offset, this.normalized && (t = _t(t, this.array), n = _t(n, this.array), i = _t(i, this.array), r = _t(r, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = n, this.data.array[e + 2] = i, this.data.array[e + 3] = r, this;
  }
  /**
   * Returns a new buffer attribute with copied values from this instance.
   *
   * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
   *
   * @param {Object} [data] - An object with interleaved buffers that allows to retain the interleaved property.
   * @return {BufferAttribute|InterleavedBufferAttribute} A clone of this instance.
   */
  clone(e) {
    if (e === void 0) {
      console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
      const t = [];
      for (let n = 0; n < this.count; n++) {
        const i = n * this.data.stride + this.offset;
        for (let r = 0; r < this.itemSize; r++)
          t.push(this.data.array[i + r]);
      }
      return new Kt(new this.array.constructor(t), this.itemSize, this.normalized);
    } else
      return e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}), e.interleavedBuffers[this.data.uuid] === void 0 && (e.interleavedBuffers[this.data.uuid] = this.data.clone(e)), new di(e.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
  }
  /**
   * Serializes the buffer attribute into JSON.
   *
   * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
   *
   * @param {Object} [data] - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized buffer attribute.
   */
  toJSON(e) {
    if (e === void 0) {
      console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
      const t = [];
      for (let n = 0; n < this.count; n++) {
        const i = n * this.data.stride + this.offset;
        for (let r = 0; r < this.itemSize; r++)
          t.push(this.data.array[i + r]);
      }
      return {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array: t,
        normalized: this.normalized
      };
    } else
      return e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}), e.interleavedBuffers[this.data.uuid] === void 0 && (e.interleavedBuffers[this.data.uuid] = this.data.toJSON(e)), {
        isInterleavedBufferAttribute: !0,
        itemSize: this.itemSize,
        data: this.data.uuid,
        offset: this.offset,
        normalized: this.normalized
      };
  }
}
const qc = /* @__PURE__ */ new T(), Yc = /* @__PURE__ */ new at(), jc = /* @__PURE__ */ new at(), tp = /* @__PURE__ */ new T(), Kc = /* @__PURE__ */ new Ye(), jr = /* @__PURE__ */ new T(), ro = /* @__PURE__ */ new Mn(), Zc = /* @__PURE__ */ new Ye(), ao = /* @__PURE__ */ new Ar();
class np extends xt {
  /**
   * Constructs a new skinned mesh.
   *
   * @param {BufferGeometry} [geometry] - The mesh geometry.
   * @param {Material|Array<Material>} [material] - The mesh material.
   */
  constructor(e, t) {
    super(e, t), this.isSkinnedMesh = !0, this.type = "SkinnedMesh", this.bindMode = Tc, this.bindMatrix = new Ye(), this.bindMatrixInverse = new Ye(), this.boundingBox = null, this.boundingSphere = null;
  }
  /**
   * Computes the bounding box of the skinned mesh, and updates {@link SkinnedMesh#boundingBox}.
   * The bounding box is not automatically computed by the engine; this method must be called by your app.
   * If the skinned mesh is animated, the bounding box should be recomputed per frame in order to reflect
   * the current animation state.
   */
  computeBoundingBox() {
    const e = this.geometry;
    this.boundingBox === null && (this.boundingBox = new Mt()), this.boundingBox.makeEmpty();
    const t = e.getAttribute("position");
    for (let n = 0; n < t.count; n++)
      this.getVertexPosition(n, jr), this.boundingBox.expandByPoint(jr);
  }
  /**
   * Computes the bounding sphere of the skinned mesh, and updates {@link SkinnedMesh#boundingSphere}.
   * The bounding sphere is automatically computed by the engine once when it is needed, e.g., for ray casting
   * and view frustum culling. If the skinned mesh is animated, the bounding sphere should be recomputed
   * per frame in order to reflect the current animation state.
   */
  computeBoundingSphere() {
    const e = this.geometry;
    this.boundingSphere === null && (this.boundingSphere = new Mn()), this.boundingSphere.makeEmpty();
    const t = e.getAttribute("position");
    for (let n = 0; n < t.count; n++)
      this.getVertexPosition(n, jr), this.boundingSphere.expandByPoint(jr);
  }
  copy(e, t) {
    return super.copy(e, t), this.bindMode = e.bindMode, this.bindMatrix.copy(e.bindMatrix), this.bindMatrixInverse.copy(e.bindMatrixInverse), this.skeleton = e.skeleton, e.boundingBox !== null && (this.boundingBox = e.boundingBox.clone()), e.boundingSphere !== null && (this.boundingSphere = e.boundingSphere.clone()), this;
  }
  raycast(e, t) {
    const n = this.material, i = this.matrixWorld;
    n !== void 0 && (this.boundingSphere === null && this.computeBoundingSphere(), ro.copy(this.boundingSphere), ro.applyMatrix4(i), e.ray.intersectsSphere(ro) !== !1 && (Zc.copy(i).invert(), ao.copy(e.ray).applyMatrix4(Zc), !(this.boundingBox !== null && ao.intersectsBox(this.boundingBox) === !1) && this._computeIntersections(e, t, ao)));
  }
  getVertexPosition(e, t) {
    return super.getVertexPosition(e, t), this.applyBoneTransform(e, t), t;
  }
  /**
   * Binds the given skeleton to the skinned mesh.
   *
   * @param {Skeleton} skeleton - The skeleton to bind.
   * @param {Matrix4} [bindMatrix] - The bind matrix. If no bind matrix is provided,
   * the skinned mesh's world matrix will be used instead.
   */
  bind(e, t) {
    this.skeleton = e, t === void 0 && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), t = this.matrixWorld), this.bindMatrix.copy(t), this.bindMatrixInverse.copy(t).invert();
  }
  /**
   * This method sets the skinned mesh in the rest pose).
   */
  pose() {
    this.skeleton.pose();
  }
  /**
   * Normalizes the skin weights which are defined as a buffer attribute
   * in the skinned mesh's geometry.
   */
  normalizeSkinWeights() {
    const e = new at(), t = this.geometry.attributes.skinWeight;
    for (let n = 0, i = t.count; n < i; n++) {
      e.fromBufferAttribute(t, n);
      const r = 1 / e.manhattanLength();
      r !== 1 / 0 ? e.multiplyScalar(r) : e.set(1, 0, 0, 0), t.setXYZW(n, e.x, e.y, e.z, e.w);
    }
  }
  updateMatrixWorld(e) {
    super.updateMatrixWorld(e), this.bindMode === Tc ? this.bindMatrixInverse.copy(this.matrixWorld).invert() : this.bindMode === Yd ? this.bindMatrixInverse.copy(this.bindMatrix).invert() : console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
  }
  /**
   * Applies the bone transform associated with the given index to the given
   * vertex position. Returns the updated vector.
   *
   * @param {number} index - The vertex index.
   * @param {Vector3} target - The target object that is used to store the method's result.
   * the skinned mesh's world matrix will be used instead.
   * @return {Vector3} The updated vertex position.
   */
  applyBoneTransform(e, t) {
    const n = this.skeleton, i = this.geometry;
    Yc.fromBufferAttribute(i.attributes.skinIndex, e), jc.fromBufferAttribute(i.attributes.skinWeight, e), qc.copy(t).applyMatrix4(this.bindMatrix), t.set(0, 0, 0);
    for (let r = 0; r < 4; r++) {
      const a = jc.getComponent(r);
      if (a !== 0) {
        const o = Yc.getComponent(r);
        Kc.multiplyMatrices(n.bones[o].matrixWorld, n.boneInverses[o]), t.addScaledVector(tp.copy(qc).applyMatrix4(Kc), a);
      }
    }
    return t.applyMatrix4(this.bindMatrixInverse);
  }
}
class Wh extends bt {
  /**
   * Constructs a new bone.
   */
  constructor() {
    super(), this.isBone = !0, this.type = "Bone";
  }
}
class ql extends Gt {
  /**
   * Constructs a new data texture.
   *
   * @param {?TypedArray} [data=null] - The buffer data.
   * @param {number} [width=1] - The width of the texture.
   * @param {number} [height=1] - The height of the texture.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=NearestFilter] - The mag filter value.
   * @param {number} [minFilter=NearestFilter] - The min filter value.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space.
   */
  constructor(e = null, t = 1, n = 1, i, r, a, o, l, c = en, u = en, h, d) {
    super(null, a, o, l, c, u, i, r, h, d), this.isDataTexture = !0, this.image = { data: e, width: t, height: n }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
const $c = /* @__PURE__ */ new Ye(), ip = /* @__PURE__ */ new Ye();
class Yl {
  /**
   * Constructs a new skeleton.
   *
   * @param {Array<Bone>} [bones] - An array of bones.
   * @param {Array<Matrix4>} [boneInverses] - An array of bone inverse matrices.
   * If not provided, these matrices will be computed automatically via {@link Skeleton#calculateInverses}.
   */
  constructor(e = [], t = []) {
    this.uuid = Un(), this.bones = e.slice(0), this.boneInverses = t, this.boneMatrices = null, this.boneTexture = null, this.init();
  }
  /**
   * Initializes the skeleton. This method gets automatically called by the constructor
   * but depending on how the skeleton is created it might be necessary to call this method
   * manually.
   */
  init() {
    const e = this.bones, t = this.boneInverses;
    if (this.boneMatrices = new Float32Array(e.length * 16), t.length === 0)
      this.calculateInverses();
    else if (e.length !== t.length) {
      console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones."), this.boneInverses = [];
      for (let n = 0, i = this.bones.length; n < i; n++)
        this.boneInverses.push(new Ye());
    }
  }
  /**
   * Computes the bone inverse matrices. This method resets {@link Skeleton#boneInverses}
   * and fills it with new matrices.
   */
  calculateInverses() {
    this.boneInverses.length = 0;
    for (let e = 0, t = this.bones.length; e < t; e++) {
      const n = new Ye();
      this.bones[e] && n.copy(this.bones[e].matrixWorld).invert(), this.boneInverses.push(n);
    }
  }
  /**
   * Resets the skeleton to the base pose.
   */
  pose() {
    for (let e = 0, t = this.bones.length; e < t; e++) {
      const n = this.bones[e];
      n && n.matrixWorld.copy(this.boneInverses[e]).invert();
    }
    for (let e = 0, t = this.bones.length; e < t; e++) {
      const n = this.bones[e];
      n && (n.parent && n.parent.isBone ? (n.matrix.copy(n.parent.matrixWorld).invert(), n.matrix.multiply(n.matrixWorld)) : n.matrix.copy(n.matrixWorld), n.matrix.decompose(n.position, n.quaternion, n.scale));
    }
  }
  /**
   * Resets the skeleton to the base pose.
   */
  update() {
    const e = this.bones, t = this.boneInverses, n = this.boneMatrices, i = this.boneTexture;
    for (let r = 0, a = e.length; r < a; r++) {
      const o = e[r] ? e[r].matrixWorld : ip;
      $c.multiplyMatrices(o, t[r]), $c.toArray(n, r * 16);
    }
    i !== null && (i.needsUpdate = !0);
  }
  /**
   * Returns a new skeleton with copied values from this instance.
   *
   * @return {Skeleton} A clone of this instance.
   */
  clone() {
    return new Yl(this.bones, this.boneInverses);
  }
  /**
   * Computes a data texture for passing bone data to the vertex shader.
   *
   * @return {Skeleton} A reference of this instance.
   */
  computeBoneTexture() {
    let e = Math.sqrt(this.bones.length * 4);
    e = Math.ceil(e / 4) * 4, e = Math.max(e, 4);
    const t = new Float32Array(e * e * 4);
    t.set(this.boneMatrices);
    const n = new ql(t, e, e, mn, hn);
    return n.needsUpdate = !0, this.boneMatrices = t, this.boneTexture = n, this;
  }
  /**
   * Searches through the skeleton's bone array and returns the first with a
   * matching name.
   *
   * @param {string} name - The name of the bone.
   * @return {Bone|undefined} The found bone. `undefined` if no bone has been found.
   */
  getBoneByName(e) {
    for (let t = 0, n = this.bones.length; t < n; t++) {
      const i = this.bones[t];
      if (i.name === e)
        return i;
    }
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   */
  dispose() {
    this.boneTexture !== null && (this.boneTexture.dispose(), this.boneTexture = null);
  }
  /**
   * Setups the skeleton by the given JSON and bones.
   *
   * @param {Object} json - The skeleton as serialized JSON.
   * @param {Object<string, Bone>} bones - An array of bones.
   * @return {Skeleton} A reference of this instance.
   */
  fromJSON(e, t) {
    this.uuid = e.uuid;
    for (let n = 0, i = e.bones.length; n < i; n++) {
      const r = e.bones[n];
      let a = t[r];
      a === void 0 && (console.warn("THREE.Skeleton: No bone found with UUID:", r), a = new Wh()), this.bones.push(a), this.boneInverses.push(new Ye().fromArray(e.boneInverses[n]));
    }
    return this.init(), this;
  }
  /**
   * Serializes the skeleton into JSON.
   *
   * @return {Object} A JSON object representing the serialized skeleton.
   * @see {@link ObjectLoader#parse}
   */
  toJSON() {
    const e = {
      metadata: {
        version: 4.6,
        type: "Skeleton",
        generator: "Skeleton.toJSON"
      },
      bones: [],
      boneInverses: []
    };
    e.uuid = this.uuid;
    const t = this.bones, n = this.boneInverses;
    for (let i = 0, r = t.length; i < r; i++) {
      const a = t[i];
      e.bones.push(a.uuid);
      const o = n[i];
      e.boneInverses.push(o.toArray());
    }
    return e;
  }
}
class yl extends Kt {
  /**
   * Constructs a new instanced buffer attribute.
   *
   * @param {TypedArray} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   * @param {number} [meshPerAttribute=1] - How often a value of this buffer attribute should be repeated.
   */
  constructor(e, t, n, i = 1) {
    super(e, t, n), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = i;
  }
  copy(e) {
    return super.copy(e), this.meshPerAttribute = e.meshPerAttribute, this;
  }
  toJSON() {
    const e = super.toJSON();
    return e.meshPerAttribute = this.meshPerAttribute, e.isInstancedBufferAttribute = !0, e;
  }
}
const ms = /* @__PURE__ */ new Ye(), Jc = /* @__PURE__ */ new Ye(), Kr = [], Qc = /* @__PURE__ */ new Mt(), sp = /* @__PURE__ */ new Ye(), ir = /* @__PURE__ */ new xt(), sr = /* @__PURE__ */ new Mn();
class rp extends xt {
  /**
   * Constructs a new instanced mesh.
   *
   * @param {BufferGeometry} [geometry] - The mesh geometry.
   * @param {Material|Array<Material>} [material] - The mesh material.
   * @param {number} count - The number of instances.
   */
  constructor(e, t, n) {
    super(e, t), this.isInstancedMesh = !0, this.instanceMatrix = new yl(new Float32Array(n * 16), 16), this.instanceColor = null, this.morphTexture = null, this.count = n, this.boundingBox = null, this.boundingSphere = null;
    for (let i = 0; i < n; i++)
      this.setMatrixAt(i, sp);
  }
  /**
   * Computes the bounding box of the instanced mesh, and updates {@link InstancedMesh#boundingBox}.
   * The bounding box is not automatically computed by the engine; this method must be called by your app.
   * You may need to recompute the bounding box if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
   */
  computeBoundingBox() {
    const e = this.geometry, t = this.count;
    this.boundingBox === null && (this.boundingBox = new Mt()), e.boundingBox === null && e.computeBoundingBox(), this.boundingBox.makeEmpty();
    for (let n = 0; n < t; n++)
      this.getMatrixAt(n, ms), Qc.copy(e.boundingBox).applyMatrix4(ms), this.boundingBox.union(Qc);
  }
  /**
   * Computes the bounding sphere of the instanced mesh, and updates {@link InstancedMesh#boundingSphere}
   * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
   * You may need to recompute the bounding sphere if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
   */
  computeBoundingSphere() {
    const e = this.geometry, t = this.count;
    this.boundingSphere === null && (this.boundingSphere = new Mn()), e.boundingSphere === null && e.computeBoundingSphere(), this.boundingSphere.makeEmpty();
    for (let n = 0; n < t; n++)
      this.getMatrixAt(n, ms), sr.copy(e.boundingSphere).applyMatrix4(ms), this.boundingSphere.union(sr);
  }
  copy(e, t) {
    return super.copy(e, t), this.instanceMatrix.copy(e.instanceMatrix), e.morphTexture !== null && (this.morphTexture = e.morphTexture.clone()), e.instanceColor !== null && (this.instanceColor = e.instanceColor.clone()), this.count = e.count, e.boundingBox !== null && (this.boundingBox = e.boundingBox.clone()), e.boundingSphere !== null && (this.boundingSphere = e.boundingSphere.clone()), this;
  }
  /**
   * Gets the color of the defined instance.
   *
   * @param {number} index - The instance index.
   * @param {Color} color - The target object that is used to store the method's result.
   */
  getColorAt(e, t) {
    t.fromArray(this.instanceColor.array, e * 3);
  }
  /**
   * Gets the local transformation matrix of the defined instance.
   *
   * @param {number} index - The instance index.
   * @param {Matrix4} matrix - The target object that is used to store the method's result.
   */
  getMatrixAt(e, t) {
    t.fromArray(this.instanceMatrix.array, e * 16);
  }
  /**
   * Gets the morph target weights of the defined instance.
   *
   * @param {number} index - The instance index.
   * @param {Mesh} object - The target object that is used to store the method's result.
   */
  getMorphAt(e, t) {
    const n = t.morphTargetInfluences, i = this.morphTexture.source.data.data, r = n.length + 1, a = e * r + 1;
    for (let o = 0; o < n.length; o++)
      n[o] = i[a + o];
  }
  raycast(e, t) {
    const n = this.matrixWorld, i = this.count;
    if (ir.geometry = this.geometry, ir.material = this.material, ir.material !== void 0 && (this.boundingSphere === null && this.computeBoundingSphere(), sr.copy(this.boundingSphere), sr.applyMatrix4(n), e.ray.intersectsSphere(sr) !== !1))
      for (let r = 0; r < i; r++) {
        this.getMatrixAt(r, ms), Jc.multiplyMatrices(n, ms), ir.matrixWorld = Jc, ir.raycast(e, Kr);
        for (let a = 0, o = Kr.length; a < o; a++) {
          const l = Kr[a];
          l.instanceId = r, l.object = this, t.push(l);
        }
        Kr.length = 0;
      }
  }
  /**
   * Sets the given color to the defined instance. Make sure you set the `needsUpdate` flag of
   * {@link InstancedMesh#instanceColor} to `true` after updating all the colors.
   *
   * @param {number} index - The instance index.
   * @param {Color} color - The instance color.
   */
  setColorAt(e, t) {
    this.instanceColor === null && (this.instanceColor = new yl(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3)), t.toArray(this.instanceColor.array, e * 3);
  }
  /**
   * Sets the given local transformation matrix to the defined instance. Make sure you set the `needsUpdate` flag of
   * {@link InstancedMesh#instanceMatrix} to `true` after updating all the colors.
   *
   * @param {number} index - The instance index.
   * @param {Matrix4} matrix - The local transformation.
   */
  setMatrixAt(e, t) {
    t.toArray(this.instanceMatrix.array, e * 16);
  }
  /**
   * Sets the morph target weights to the defined instance. Make sure you set the `needsUpdate` flag of
   * {@link InstancedMesh#morphTexture} to `true` after updating all the influences.
   *
   * @param {number} index - The instance index.
   * @param {Mesh} object -  A mesh which `morphTargetInfluences` property containing the morph target weights
   * of a single instance.
   */
  setMorphAt(e, t) {
    const n = t.morphTargetInfluences, i = n.length + 1;
    this.morphTexture === null && (this.morphTexture = new ql(new Float32Array(i * this.count), i, this.count, Fl, hn));
    const r = this.morphTexture.source.data.data;
    let a = 0;
    for (let c = 0; c < n.length; c++)
      a += n[c];
    const o = this.geometry.morphTargetsRelative ? 1 : 1 - a, l = i * e;
    r[l] = o, r.set(n, l + 1);
  }
  updateMorphTargets() {
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" }), this.morphTexture !== null && (this.morphTexture.dispose(), this.morphTexture = null);
  }
}
const oo = /* @__PURE__ */ new T(), ap = /* @__PURE__ */ new T(), op = /* @__PURE__ */ new Ke();
class wi {
  /**
   * Constructs a new plane.
   *
   * @param {Vector3} [normal=(1,0,0)] - A unit length vector defining the normal of the plane.
   * @param {number} [constant=0] - The signed distance from the origin to the plane.
   */
  constructor(e = new T(1, 0, 0), t = 0) {
    this.isPlane = !0, this.normal = e, this.constant = t;
  }
  /**
   * Sets the plane components by copying the given values.
   *
   * @param {Vector3} normal - The normal.
   * @param {number} constant - The constant.
   * @return {Plane} A reference to this plane.
   */
  set(e, t) {
    return this.normal.copy(e), this.constant = t, this;
  }
  /**
   * Sets the plane components by defining `x`, `y`, `z` as the
   * plane normal and `w` as the constant.
   *
   * @param {number} x - The value for the normal's x component.
   * @param {number} y - The value for the normal's y component.
   * @param {number} z - The value for the normal's z component.
   * @param {number} w - The constant value.
   * @return {Plane} A reference to this plane.
   */
  setComponents(e, t, n, i) {
    return this.normal.set(e, t, n), this.constant = i, this;
  }
  /**
   * Sets the plane from the given normal and coplanar point (that is a point
   * that lies onto the plane).
   *
   * @param {Vector3} normal - The normal.
   * @param {Vector3} point - A coplanar point.
   * @return {Plane} A reference to this plane.
   */
  setFromNormalAndCoplanarPoint(e, t) {
    return this.normal.copy(e), this.constant = -t.dot(this.normal), this;
  }
  /**
   * Sets the plane from three coplanar points. The winding order is
   * assumed to be counter-clockwise, and determines the direction of
   * the plane normal.
   *
   * @param {Vector3} a - The first coplanar point.
   * @param {Vector3} b - The second coplanar point.
   * @param {Vector3} c - The third coplanar point.
   * @return {Plane} A reference to this plane.
   */
  setFromCoplanarPoints(e, t, n) {
    const i = oo.subVectors(n, t).cross(ap.subVectors(e, t)).normalize();
    return this.setFromNormalAndCoplanarPoint(i, e), this;
  }
  /**
   * Copies the values of the given plane to this instance.
   *
   * @param {Plane} plane - The plane to copy.
   * @return {Plane} A reference to this plane.
   */
  copy(e) {
    return this.normal.copy(e.normal), this.constant = e.constant, this;
  }
  /**
   * Normalizes the plane normal and adjusts the constant accordingly.
   *
   * @return {Plane} A reference to this plane.
   */
  normalize() {
    const e = 1 / this.normal.length();
    return this.normal.multiplyScalar(e), this.constant *= e, this;
  }
  /**
   * Negates both the plane normal and the constant.
   *
   * @return {Plane} A reference to this plane.
   */
  negate() {
    return this.constant *= -1, this.normal.negate(), this;
  }
  /**
   * Returns the signed distance from the given point to this plane.
   *
   * @param {Vector3} point - The point to compute the distance for.
   * @return {number} The signed distance.
   */
  distanceToPoint(e) {
    return this.normal.dot(e) + this.constant;
  }
  /**
   * Returns the signed distance from the given sphere to this plane.
   *
   * @param {Sphere} sphere - The sphere to compute the distance for.
   * @return {number} The signed distance.
   */
  distanceToSphere(e) {
    return this.distanceToPoint(e.center) - e.radius;
  }
  /**
   * Projects a the given point onto the plane.
   *
   * @param {Vector3} point - The point to project.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The projected point on the plane.
   */
  projectPoint(e, t) {
    return t.copy(e).addScaledVector(this.normal, -this.distanceToPoint(e));
  }
  /**
   * Returns the intersection point of the passed line and the plane. Returns
   * `null` if the line does not intersect. Returns the line's starting point if
   * the line is coplanar with the plane.
   *
   * @param {Line3} line - The line to compute the intersection for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectLine(e, t) {
    const n = e.delta(oo), i = this.normal.dot(n);
    if (i === 0)
      return this.distanceToPoint(e.start) === 0 ? t.copy(e.start) : null;
    const r = -(e.start.dot(this.normal) + this.constant) / i;
    return r < 0 || r > 1 ? null : t.copy(e.start).addScaledVector(n, r);
  }
  /**
   * Returns `true` if the given line segment intersects with (passes through) the plane.
   *
   * @param {Line3} line - The line to test.
   * @return {boolean} Whether the given line segment intersects with the plane or not.
   */
  intersectsLine(e) {
    const t = this.distanceToPoint(e.start), n = this.distanceToPoint(e.end);
    return t < 0 && n > 0 || n < 0 && t > 0;
  }
  /**
   * Returns `true` if the given bounding box intersects with the plane.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the given bounding box intersects with the plane or not.
   */
  intersectsBox(e) {
    return e.intersectsPlane(this);
  }
  /**
   * Returns `true` if the given bounding sphere intersects with the plane.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the given bounding sphere intersects with the plane or not.
   */
  intersectsSphere(e) {
    return e.intersectsPlane(this);
  }
  /**
   * Returns a coplanar vector to the plane, by calculating the
   * projection of the normal at the origin onto the plane.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The coplanar point.
   */
  coplanarPoint(e) {
    return e.copy(this.normal).multiplyScalar(-this.constant);
  }
  /**
   * Apply a 4x4 matrix to the plane. The matrix must be an affine, homogeneous transform.
   *
   * The optional normal matrix can be pre-computed like so:
   * ```js
   * const optionalNormalMatrix = new THREE.Matrix3().getNormalMatrix( matrix );
   * ```
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @param {Matrix4} [optionalNormalMatrix] - A pre-computed normal matrix.
   * @return {Plane} A reference to this plane.
   */
  applyMatrix4(e, t) {
    const n = t || op.getNormalMatrix(e), i = this.coplanarPoint(oo).applyMatrix4(e), r = this.normal.applyMatrix3(n).normalize();
    return this.constant = -i.dot(r), this;
  }
  /**
   * Translates the plane by the distance defined by the given offset vector.
   * Note that this only affects the plane constant and will not affect the normal vector.
   *
   * @param {Vector3} offset - The offset vector.
   * @return {Plane} A reference to this plane.
   */
  translate(e) {
    return this.constant -= e.dot(this.normal), this;
  }
  /**
   * Returns `true` if this plane is equal with the given one.
   *
   * @param {Plane} plane - The plane to test for equality.
   * @return {boolean} Whether this plane is equal with the given one.
   */
  equals(e) {
    return e.normal.equals(this.normal) && e.constant === this.constant;
  }
  /**
   * Returns a new plane with copied values from this instance.
   *
   * @return {Plane} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
const Vi = /* @__PURE__ */ new Mn(), Zr = /* @__PURE__ */ new T();
class jl {
  /**
   * Constructs a new frustum.
   *
   * @param {Plane} [p0] - The first plane that encloses the frustum.
   * @param {Plane} [p1] - The second plane that encloses the frustum.
   * @param {Plane} [p2] - The third plane that encloses the frustum.
   * @param {Plane} [p3] - The fourth plane that encloses the frustum.
   * @param {Plane} [p4] - The fifth plane that encloses the frustum.
   * @param {Plane} [p5] - The sixth plane that encloses the frustum.
   */
  constructor(e = new wi(), t = new wi(), n = new wi(), i = new wi(), r = new wi(), a = new wi()) {
    this.planes = [e, t, n, i, r, a];
  }
  /**
   * Sets the frustum planes by copying the given planes.
   *
   * @param {Plane} [p0] - The first plane that encloses the frustum.
   * @param {Plane} [p1] - The second plane that encloses the frustum.
   * @param {Plane} [p2] - The third plane that encloses the frustum.
   * @param {Plane} [p3] - The fourth plane that encloses the frustum.
   * @param {Plane} [p4] - The fifth plane that encloses the frustum.
   * @param {Plane} [p5] - The sixth plane that encloses the frustum.
   * @return {Frustum} A reference to this frustum.
   */
  set(e, t, n, i, r, a) {
    const o = this.planes;
    return o[0].copy(e), o[1].copy(t), o[2].copy(n), o[3].copy(i), o[4].copy(r), o[5].copy(a), this;
  }
  /**
   * Copies the values of the given frustum to this instance.
   *
   * @param {Frustum} frustum - The frustum to copy.
   * @return {Frustum} A reference to this frustum.
   */
  copy(e) {
    const t = this.planes;
    for (let n = 0; n < 6; n++)
      t[n].copy(e.planes[n]);
    return this;
  }
  /**
   * Sets the frustum planes from the given projection matrix.
   *
   * @param {Matrix4} m - The projection matrix.
   * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} coordinateSystem - The coordinate system.
   * @return {Frustum} A reference to this frustum.
   */
  setFromProjectionMatrix(e, t = ui) {
    const n = this.planes, i = e.elements, r = i[0], a = i[1], o = i[2], l = i[3], c = i[4], u = i[5], h = i[6], d = i[7], f = i[8], m = i[9], _ = i[10], g = i[11], p = i[12], M = i[13], S = i[14], x = i[15];
    if (n[0].setComponents(l - r, d - c, g - f, x - p).normalize(), n[1].setComponents(l + r, d + c, g + f, x + p).normalize(), n[2].setComponents(l + a, d + u, g + m, x + M).normalize(), n[3].setComponents(l - a, d - u, g - m, x - M).normalize(), n[4].setComponents(l - o, d - h, g - _, x - S).normalize(), t === ui)
      n[5].setComponents(l + o, d + h, g + _, x + S).normalize();
    else if (t === Ta)
      n[5].setComponents(o, h, _, S).normalize();
    else
      throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + t);
    return this;
  }
  /**
   * Returns `true` if the 3D object's bounding sphere is intersecting this frustum.
   *
   * Note that the 3D object must have a geometry so that the bounding sphere can be calculated.
   *
   * @param {Object3D} object - The 3D object to test.
   * @return {boolean} Whether the 3D object's bounding sphere is intersecting this frustum or not.
   */
  intersectsObject(e) {
    if (e.boundingSphere !== void 0)
      e.boundingSphere === null && e.computeBoundingSphere(), Vi.copy(e.boundingSphere).applyMatrix4(e.matrixWorld);
    else {
      const t = e.geometry;
      t.boundingSphere === null && t.computeBoundingSphere(), Vi.copy(t.boundingSphere).applyMatrix4(e.matrixWorld);
    }
    return this.intersectsSphere(Vi);
  }
  /**
   * Returns `true` if the given sprite is intersecting this frustum.
   *
   * @param {Sprite} sprite - The sprite to test.
   * @return {boolean} Whether the sprite is intersecting this frustum or not.
   */
  intersectsSprite(e) {
    return Vi.center.set(0, 0, 0), Vi.radius = 0.7071067811865476, Vi.applyMatrix4(e.matrixWorld), this.intersectsSphere(Vi);
  }
  /**
   * Returns `true` if the given bounding sphere is intersecting this frustum.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the bounding sphere is intersecting this frustum or not.
   */
  intersectsSphere(e) {
    const t = this.planes, n = e.center, i = -e.radius;
    for (let r = 0; r < 6; r++)
      if (t[r].distanceToPoint(n) < i)
        return !1;
    return !0;
  }
  /**
   * Returns `true` if the given bounding box is intersecting this frustum.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the bounding box is intersecting this frustum or not.
   */
  intersectsBox(e) {
    const t = this.planes;
    for (let n = 0; n < 6; n++) {
      const i = t[n];
      if (Zr.x = i.normal.x > 0 ? e.max.x : e.min.x, Zr.y = i.normal.y > 0 ? e.max.y : e.min.y, Zr.z = i.normal.z > 0 ? e.max.z : e.min.z, i.distanceToPoint(Zr) < 0)
        return !1;
    }
    return !0;
  }
  /**
   * Returns `true` if the given point lies within the frustum.
   *
   * @param {Vector3} point - The point to test.
   * @return {boolean} Whether the point lies within this frustum or not.
   */
  containsPoint(e) {
    const t = this.planes;
    for (let n = 0; n < 6; n++)
      if (t[n].distanceToPoint(e) < 0)
        return !1;
    return !0;
  }
  /**
   * Returns a new frustum with copied values from this instance.
   *
   * @return {Frustum} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
class Xh extends qn {
  /**
   * Constructs a new line basic material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new He(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.linewidth = e.linewidth, this.linecap = e.linecap, this.linejoin = e.linejoin, this.fog = e.fog, this;
  }
}
const Aa = /* @__PURE__ */ new T(), wa = /* @__PURE__ */ new T(), eu = /* @__PURE__ */ new Ye(), rr = /* @__PURE__ */ new Ar(), $r = /* @__PURE__ */ new Mn(), lo = /* @__PURE__ */ new T(), tu = /* @__PURE__ */ new T();
class Kl extends bt {
  /**
   * Constructs a new line.
   *
   * @param {BufferGeometry} [geometry] - The line geometry.
   * @param {Material|Array<Material>} [material] - The line material.
   */
  constructor(e = new _n(), t = new Xh()) {
    super(), this.isLine = !0, this.type = "Line", this.geometry = e, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.updateMorphTargets();
  }
  copy(e, t) {
    return super.copy(e, t), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
  }
  /**
   * Computes an array of distance values which are necessary for rendering dashed lines.
   * For each vertex in the geometry, the method calculates the cumulative length from the
   * current point to the very beginning of the line.
   *
   * @return {Line} A reference to this line.
   */
  computeLineDistances() {
    const e = this.geometry;
    if (e.index === null) {
      const t = e.attributes.position, n = [0];
      for (let i = 1, r = t.count; i < r; i++)
        Aa.fromBufferAttribute(t, i - 1), wa.fromBufferAttribute(t, i), n[i] = n[i - 1], n[i] += Aa.distanceTo(wa);
      e.setAttribute("lineDistance", new Sn(n, 1));
    } else
      console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
    return this;
  }
  /**
   * Computes intersection points between a casted ray and this line.
   *
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - The target array that holds the intersection points.
   */
  raycast(e, t) {
    const n = this.geometry, i = this.matrixWorld, r = e.params.Line.threshold, a = n.drawRange;
    if (n.boundingSphere === null && n.computeBoundingSphere(), $r.copy(n.boundingSphere), $r.applyMatrix4(i), $r.radius += r, e.ray.intersectsSphere($r) === !1) return;
    eu.copy(i).invert(), rr.copy(e.ray).applyMatrix4(eu);
    const o = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), l = o * o, c = this.isLineSegments ? 2 : 1, u = n.index, d = n.attributes.position;
    if (u !== null) {
      const f = Math.max(0, a.start), m = Math.min(u.count, a.start + a.count);
      for (let _ = f, g = m - 1; _ < g; _ += c) {
        const p = u.getX(_), M = u.getX(_ + 1), S = Jr(this, e, rr, l, p, M, _);
        S && t.push(S);
      }
      if (this.isLineLoop) {
        const _ = u.getX(m - 1), g = u.getX(f), p = Jr(this, e, rr, l, _, g, m - 1);
        p && t.push(p);
      }
    } else {
      const f = Math.max(0, a.start), m = Math.min(d.count, a.start + a.count);
      for (let _ = f, g = m - 1; _ < g; _ += c) {
        const p = Jr(this, e, rr, l, _, _ + 1, _);
        p && t.push(p);
      }
      if (this.isLineLoop) {
        const _ = Jr(this, e, rr, l, m - 1, f, m - 1);
        _ && t.push(_);
      }
    }
  }
  /**
   * Sets the values of {@link Line#morphTargetDictionary} and {@link Line#morphTargetInfluences}
   * to make sure existing morph targets can influence this 3D object.
   */
  updateMorphTargets() {
    const t = this.geometry.morphAttributes, n = Object.keys(t);
    if (n.length > 0) {
      const i = t[n[0]];
      if (i !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let r = 0, a = i.length; r < a; r++) {
          const o = i[r].name || String(r);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[o] = r;
        }
      }
    }
  }
}
function Jr(s, e, t, n, i, r, a) {
  const o = s.geometry.attributes.position;
  if (Aa.fromBufferAttribute(o, i), wa.fromBufferAttribute(o, r), t.distanceSqToSegment(Aa, wa, lo, tu) > n) return;
  lo.applyMatrix4(s.matrixWorld);
  const c = e.ray.origin.distanceTo(lo);
  if (!(c < e.near || c > e.far))
    return {
      distance: c,
      // What do we want? intersection point on the ray or on the segment??
      // point: raycaster.ray.at( distance ),
      point: tu.clone().applyMatrix4(s.matrixWorld),
      index: a,
      face: null,
      faceIndex: null,
      barycoord: null,
      object: s
    };
}
const nu = /* @__PURE__ */ new T(), iu = /* @__PURE__ */ new T();
class lp extends Kl {
  /**
   * Constructs a new line segments.
   *
   * @param {BufferGeometry} [geometry] - The line geometry.
   * @param {Material|Array<Material>} [material] - The line material.
   */
  constructor(e, t) {
    super(e, t), this.isLineSegments = !0, this.type = "LineSegments";
  }
  computeLineDistances() {
    const e = this.geometry;
    if (e.index === null) {
      const t = e.attributes.position, n = [];
      for (let i = 0, r = t.count; i < r; i += 2)
        nu.fromBufferAttribute(t, i), iu.fromBufferAttribute(t, i + 1), n[i] = i === 0 ? 0 : n[i - 1], n[i + 1] = n[i] + nu.distanceTo(iu);
      e.setAttribute("lineDistance", new Sn(n, 1));
    } else
      console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
    return this;
  }
}
class cp extends Kl {
  /**
   * Constructs a new line loop.
   *
   * @param {BufferGeometry} [geometry] - The line geometry.
   * @param {Material|Array<Material>} [material] - The line material.
   */
  constructor(e, t) {
    super(e, t), this.isLineLoop = !0, this.type = "LineLoop";
  }
}
class qh extends qn {
  /**
   * Constructs a new points material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isPointsMaterial = !0, this.type = "PointsMaterial", this.color = new He(16777215), this.map = null, this.alphaMap = null, this.size = 1, this.sizeAttenuation = !0, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.alphaMap = e.alphaMap, this.size = e.size, this.sizeAttenuation = e.sizeAttenuation, this.fog = e.fog, this;
  }
}
const su = /* @__PURE__ */ new Ye(), Sl = /* @__PURE__ */ new Ar(), Qr = /* @__PURE__ */ new Mn(), ea = /* @__PURE__ */ new T();
class up extends bt {
  /**
   * Constructs a new point cloud.
   *
   * @param {BufferGeometry} [geometry] - The points geometry.
   * @param {Material|Array<Material>} [material] - The points material.
   */
  constructor(e = new _n(), t = new qh()) {
    super(), this.isPoints = !0, this.type = "Points", this.geometry = e, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.updateMorphTargets();
  }
  copy(e, t) {
    return super.copy(e, t), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
  }
  /**
   * Computes intersection points between a casted ray and this point cloud.
   *
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - The target array that holds the intersection points.
   */
  raycast(e, t) {
    const n = this.geometry, i = this.matrixWorld, r = e.params.Points.threshold, a = n.drawRange;
    if (n.boundingSphere === null && n.computeBoundingSphere(), Qr.copy(n.boundingSphere), Qr.applyMatrix4(i), Qr.radius += r, e.ray.intersectsSphere(Qr) === !1) return;
    su.copy(i).invert(), Sl.copy(e.ray).applyMatrix4(su);
    const o = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), l = o * o, c = n.index, h = n.attributes.position;
    if (c !== null) {
      const d = Math.max(0, a.start), f = Math.min(c.count, a.start + a.count);
      for (let m = d, _ = f; m < _; m++) {
        const g = c.getX(m);
        ea.fromBufferAttribute(h, g), ru(ea, g, l, i, e, t, this);
      }
    } else {
      const d = Math.max(0, a.start), f = Math.min(h.count, a.start + a.count);
      for (let m = d, _ = f; m < _; m++)
        ea.fromBufferAttribute(h, m), ru(ea, m, l, i, e, t, this);
    }
  }
  /**
   * Sets the values of {@link Points#morphTargetDictionary} and {@link Points#morphTargetInfluences}
   * to make sure existing morph targets can influence this 3D object.
   */
  updateMorphTargets() {
    const t = this.geometry.morphAttributes, n = Object.keys(t);
    if (n.length > 0) {
      const i = t[n[0]];
      if (i !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let r = 0, a = i.length; r < a; r++) {
          const o = i[r].name || String(r);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[o] = r;
        }
      }
    }
  }
}
function ru(s, e, t, n, i, r, a) {
  const o = Sl.distanceSqToPoint(s);
  if (o < t) {
    const l = new T();
    Sl.closestPointToPoint(s, l), l.applyMatrix4(n);
    const c = i.ray.origin.distanceTo(l);
    if (c < i.near || c > i.far) return;
    r.push({
      distance: c,
      distanceToRay: Math.sqrt(o),
      point: l,
      index: e,
      face: null,
      faceIndex: null,
      barycoord: null,
      object: a
    });
  }
}
class Zl extends Gt {
  /**
   * Constructs a new depth texture.
   *
   * @param {number} width - The width of the texture.
   * @param {number} height - The height of the texture.
   * @param {number} [type=UnsignedIntType] - The texture type.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearFilter] - The min filter value.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {number} [format=DepthFormat] - The texture format.
   */
  constructor(e, t, n = Ii, i, r, a, o = en, l = en, c, u = vr) {
    if (u !== vr && u !== yr)
      throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
    super(null, i, r, a, o, l, u, n, c), this.isDepthTexture = !0, this.image = { width: e, height: t }, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
  }
  copy(e) {
    return super.copy(e), this.source = new Gl(Object.assign({}, e.image)), this.compareFunction = e.compareFunction, this;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return this.compareFunction !== null && (t.compareFunction = this.compareFunction), t;
  }
}
class Gs extends _n {
  /**
   * Constructs a new plane geometry.
   *
   * @param {number} [width=1] - The width along the X axis.
   * @param {number} [height=1] - The height along the Y axis
   * @param {number} [widthSegments=1] - The number of segments along the X axis.
   * @param {number} [heightSegments=1] - The number of segments along the Y axis.
   */
  constructor(e = 1, t = 1, n = 1, i = 1) {
    super(), this.type = "PlaneGeometry", this.parameters = {
      width: e,
      height: t,
      widthSegments: n,
      heightSegments: i
    };
    const r = e / 2, a = t / 2, o = Math.floor(n), l = Math.floor(i), c = o + 1, u = l + 1, h = e / o, d = t / l, f = [], m = [], _ = [], g = [];
    for (let p = 0; p < u; p++) {
      const M = p * d - a;
      for (let S = 0; S < c; S++) {
        const x = S * h - r;
        m.push(x, -M, 0), _.push(0, 0, 1), g.push(S / o), g.push(1 - p / l);
      }
    }
    for (let p = 0; p < l; p++)
      for (let M = 0; M < o; M++) {
        const S = M + c * p, x = M + c * (p + 1), R = M + 1 + c * (p + 1), w = M + 1 + c * p;
        f.push(S, x, w), f.push(x, R, w);
      }
    this.setIndex(f), this.setAttribute("position", new Sn(m, 3)), this.setAttribute("normal", new Sn(_, 3)), this.setAttribute("uv", new Sn(g, 2));
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {PlaneGeometry} A new instance.
   */
  static fromJSON(e) {
    return new Gs(e.width, e.height, e.widthSegments, e.heightSegments);
  }
}
class hp extends _n {
  /**
   * Constructs a new wireframe geometry.
   *
   * @param {?BufferGeometry} [geometry=null] - The geometry.
   */
  constructor(e = null) {
    if (super(), this.type = "WireframeGeometry", this.parameters = {
      geometry: e
    }, e !== null) {
      const t = [], n = /* @__PURE__ */ new Set(), i = new T(), r = new T();
      if (e.index !== null) {
        const a = e.attributes.position, o = e.index;
        let l = e.groups;
        l.length === 0 && (l = [{ start: 0, count: o.count, materialIndex: 0 }]);
        for (let c = 0, u = l.length; c < u; ++c) {
          const h = l[c], d = h.start, f = h.count;
          for (let m = d, _ = d + f; m < _; m += 3)
            for (let g = 0; g < 3; g++) {
              const p = o.getX(m + g), M = o.getX(m + (g + 1) % 3);
              i.fromBufferAttribute(a, p), r.fromBufferAttribute(a, M), au(i, r, n) === !0 && (t.push(i.x, i.y, i.z), t.push(r.x, r.y, r.z));
            }
        }
      } else {
        const a = e.attributes.position;
        for (let o = 0, l = a.count / 3; o < l; o++)
          for (let c = 0; c < 3; c++) {
            const u = 3 * o + c, h = 3 * o + (c + 1) % 3;
            i.fromBufferAttribute(a, u), r.fromBufferAttribute(a, h), au(i, r, n) === !0 && (t.push(i.x, i.y, i.z), t.push(r.x, r.y, r.z));
          }
      }
      this.setAttribute("position", new Sn(t, 3));
    }
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
}
function au(s, e, t) {
  const n = `${s.x},${s.y},${s.z}-${e.x},${e.y},${e.z}`, i = `${e.x},${e.y},${e.z}-${s.x},${s.y},${s.z}`;
  return t.has(n) === !0 || t.has(i) === !0 ? !1 : (t.add(n), t.add(i), !0);
}
class Kn extends qn {
  /**
   * Constructs a new mesh standard material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isMeshStandardMaterial = !0, this.type = "MeshStandardMaterial", this.defines = { STANDARD: "" }, this.color = new He(16777215), this.roughness = 1, this.metalness = 0, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new He(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Ih, this.normalScale = new ze(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.roughnessMap = null, this.metalnessMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new Yn(), this.envMapIntensity = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.defines = { STANDARD: "" }, this.color.copy(e.color), this.roughness = e.roughness, this.metalness = e.metalness, this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.roughnessMap = e.roughnessMap, this.metalnessMap = e.metalnessMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapRotation.copy(e.envMapRotation), this.envMapIntensity = e.envMapIntensity, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.flatShading = e.flatShading, this.fog = e.fog, this;
  }
}
class Zn extends Kn {
  /**
   * Constructs a new mesh physical material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isMeshPhysicalMaterial = !0, this.defines = {
      STANDARD: "",
      PHYSICAL: ""
    }, this.type = "MeshPhysicalMaterial", this.anisotropyRotation = 0, this.anisotropyMap = null, this.clearcoatMap = null, this.clearcoatRoughness = 0, this.clearcoatRoughnessMap = null, this.clearcoatNormalScale = new ze(1, 1), this.clearcoatNormalMap = null, this.ior = 1.5, Object.defineProperty(this, "reflectivity", {
      get: function() {
        return Ze(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
      },
      set: function(t) {
        this.ior = (1 + 0.4 * t) / (1 - 0.4 * t);
      }
    }), this.iridescenceMap = null, this.iridescenceIOR = 1.3, this.iridescenceThicknessRange = [100, 400], this.iridescenceThicknessMap = null, this.sheenColor = new He(0), this.sheenColorMap = null, this.sheenRoughness = 1, this.sheenRoughnessMap = null, this.transmissionMap = null, this.thickness = 0, this.thicknessMap = null, this.attenuationDistance = 1 / 0, this.attenuationColor = new He(1, 1, 1), this.specularIntensity = 1, this.specularIntensityMap = null, this.specularColor = new He(1, 1, 1), this.specularColorMap = null, this._anisotropy = 0, this._clearcoat = 0, this._dispersion = 0, this._iridescence = 0, this._sheen = 0, this._transmission = 0, this.setValues(e);
  }
  /**
   * The anisotropy strength.
   *
   * @type {number}
   * @default 0
   */
  get anisotropy() {
    return this._anisotropy;
  }
  set anisotropy(e) {
    this._anisotropy > 0 != e > 0 && this.version++, this._anisotropy = e;
  }
  /**
   * Represents the intensity of the clear coat layer, from `0.0` to `1.0`. Use
   * clear coat related properties to enable multilayer materials that have a
   * thin translucent layer over the base layer.
   *
   * @type {number}
   * @default 0
   */
  get clearcoat() {
    return this._clearcoat;
  }
  set clearcoat(e) {
    this._clearcoat > 0 != e > 0 && this.version++, this._clearcoat = e;
  }
  /**
   * The intensity of the iridescence layer, simulating RGB color shift based on the angle between
   * the surface and the viewer, from `0.0` to `1.0`.
   *
   * @type {number}
   * @default 0
   */
  get iridescence() {
    return this._iridescence;
  }
  set iridescence(e) {
    this._iridescence > 0 != e > 0 && this.version++, this._iridescence = e;
  }
  /**
   * Defines the strength of the angular separation of colors (chromatic aberration) transmitting
   * through a relatively clear volume. Any value zero or larger is valid, the typical range of
   * realistic values is `[0, 1]`. This property can be only be used with transmissive objects.
   *
   * @type {number}
   * @default 0
   */
  get dispersion() {
    return this._dispersion;
  }
  set dispersion(e) {
    this._dispersion > 0 != e > 0 && this.version++, this._dispersion = e;
  }
  /**
   * The intensity of the sheen layer, from `0.0` to `1.0`.
   *
   * @type {number}
   * @default 0
   */
  get sheen() {
    return this._sheen;
  }
  set sheen(e) {
    this._sheen > 0 != e > 0 && this.version++, this._sheen = e;
  }
  /**
   * Degree of transmission (or optical transparency), from `0.0` to `1.0`.
   *
   * Thin, transparent or semitransparent, plastic or glass materials remain
   * largely reflective even if they are fully transmissive. The transmission
   * property can be used to model these materials.
   *
   * When transmission is non-zero, `opacity` should be  set to `1`.
   *
   * @type {number}
   * @default 0
   */
  get transmission() {
    return this._transmission;
  }
  set transmission(e) {
    this._transmission > 0 != e > 0 && this.version++, this._transmission = e;
  }
  copy(e) {
    return super.copy(e), this.defines = {
      STANDARD: "",
      PHYSICAL: ""
    }, this.anisotropy = e.anisotropy, this.anisotropyRotation = e.anisotropyRotation, this.anisotropyMap = e.anisotropyMap, this.clearcoat = e.clearcoat, this.clearcoatMap = e.clearcoatMap, this.clearcoatRoughness = e.clearcoatRoughness, this.clearcoatRoughnessMap = e.clearcoatRoughnessMap, this.clearcoatNormalMap = e.clearcoatNormalMap, this.clearcoatNormalScale.copy(e.clearcoatNormalScale), this.dispersion = e.dispersion, this.ior = e.ior, this.iridescence = e.iridescence, this.iridescenceMap = e.iridescenceMap, this.iridescenceIOR = e.iridescenceIOR, this.iridescenceThicknessRange = [...e.iridescenceThicknessRange], this.iridescenceThicknessMap = e.iridescenceThicknessMap, this.sheen = e.sheen, this.sheenColor.copy(e.sheenColor), this.sheenColorMap = e.sheenColorMap, this.sheenRoughness = e.sheenRoughness, this.sheenRoughnessMap = e.sheenRoughnessMap, this.transmission = e.transmission, this.transmissionMap = e.transmissionMap, this.thickness = e.thickness, this.thicknessMap = e.thicknessMap, this.attenuationDistance = e.attenuationDistance, this.attenuationColor.copy(e.attenuationColor), this.specularIntensity = e.specularIntensity, this.specularIntensityMap = e.specularIntensityMap, this.specularColor.copy(e.specularColor), this.specularColorMap = e.specularColorMap, this;
  }
}
class dp extends qn {
  /**
   * Constructs a new mesh depth material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = Jd, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.depthPacking = e.depthPacking, this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this;
  }
}
class fp extends qn {
  /**
   * Constructs a new mesh distance material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this;
  }
}
function ta(s, e) {
  return !s || s.constructor === e ? s : typeof e.BYTES_PER_ELEMENT == "number" ? new e(s) : Array.prototype.slice.call(s);
}
function pp(s) {
  return ArrayBuffer.isView(s) && !(s instanceof DataView);
}
function mp(s) {
  function e(i, r) {
    return s[i] - s[r];
  }
  const t = s.length, n = new Array(t);
  for (let i = 0; i !== t; ++i) n[i] = i;
  return n.sort(e), n;
}
function ou(s, e, t) {
  const n = s.length, i = new s.constructor(n);
  for (let r = 0, a = 0; a !== n; ++r) {
    const o = t[r] * e;
    for (let l = 0; l !== e; ++l)
      i[a++] = s[o + l];
  }
  return i;
}
function Yh(s, e, t, n) {
  let i = 1, r = s[0];
  for (; r !== void 0 && r[n] === void 0; )
    r = s[i++];
  if (r === void 0) return;
  let a = r[n];
  if (a !== void 0)
    if (Array.isArray(a))
      do
        a = r[n], a !== void 0 && (e.push(r.time), t.push(...a)), r = s[i++];
      while (r !== void 0);
    else if (a.toArray !== void 0)
      do
        a = r[n], a !== void 0 && (e.push(r.time), a.toArray(t, t.length)), r = s[i++];
      while (r !== void 0);
    else
      do
        a = r[n], a !== void 0 && (e.push(r.time), t.push(a)), r = s[i++];
      while (r !== void 0);
}
class wr {
  /**
   * Constructs a new interpolant.
   *
   * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
   * @param {TypedArray} sampleValues - The sample values.
   * @param {number} sampleSize - The sample size
   * @param {TypedArray} [resultBuffer] - The result buffer.
   */
  constructor(e, t, n, i) {
    this.parameterPositions = e, this._cachedIndex = 0, this.resultBuffer = i !== void 0 ? i : new t.constructor(n), this.sampleValues = t, this.valueSize = n, this.settings = null, this.DefaultSettings_ = {};
  }
  /**
   * Evaluate the interpolant at position `t`.
   *
   * @param {number} t - The interpolation factor.
   * @return {TypedArray} The result buffer.
   */
  evaluate(e) {
    const t = this.parameterPositions;
    let n = this._cachedIndex, i = t[n], r = t[n - 1];
    e: {
      t: {
        let a;
        n: {
          i: if (!(e < i)) {
            for (let o = n + 2; ; ) {
              if (i === void 0) {
                if (e < r) break i;
                return n = t.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
              }
              if (n === o) break;
              if (r = i, i = t[++n], e < i)
                break t;
            }
            a = t.length;
            break n;
          }
          if (!(e >= r)) {
            const o = t[1];
            e < o && (n = 2, r = o);
            for (let l = n - 2; ; ) {
              if (r === void 0)
                return this._cachedIndex = 0, this.copySampleValue_(0);
              if (n === l) break;
              if (i = r, r = t[--n - 1], e >= r)
                break t;
            }
            a = n, n = 0;
            break n;
          }
          break e;
        }
        for (; n < a; ) {
          const o = n + a >>> 1;
          e < t[o] ? a = o : n = o + 1;
        }
        if (i = t[n], r = t[n - 1], r === void 0)
          return this._cachedIndex = 0, this.copySampleValue_(0);
        if (i === void 0)
          return n = t.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
      }
      this._cachedIndex = n, this.intervalChanged_(n, r, i);
    }
    return this.interpolate_(n, r, e, i);
  }
  /**
   * Returns the interpolation settings.
   *
   * @return {Object} The interpolation settings.
   */
  getSettings_() {
    return this.settings || this.DefaultSettings_;
  }
  /**
   * Copies a sample value to the result buffer.
   *
   * @param {number} index - An index into the sample value buffer.
   * @return {TypedArray} The result buffer.
   */
  copySampleValue_(e) {
    const t = this.resultBuffer, n = this.sampleValues, i = this.valueSize, r = e * i;
    for (let a = 0; a !== i; ++a)
      t[a] = n[r + a];
    return t;
  }
  /**
   * Copies a sample value to the result buffer.
   *
   * @abstract
   * @param {number} i1 - An index into the sample value buffer.
   * @param {number} t0 - The previous interpolation factor.
   * @param {number} t - The current interpolation factor.
   * @param {number} t1 - The next interpolation factor.
   * @return {TypedArray} The result buffer.
   */
  interpolate_() {
    throw new Error("call to abstract method");
  }
  /**
   * Optional method that is executed when the interval has changed.
   *
   * @param {number} i1 - An index into the sample value buffer.
   * @param {number} t0 - The previous interpolation factor.
   * @param {number} t - The current interpolation factor.
   */
  intervalChanged_() {
  }
}
class gp extends wr {
  /**
   * Constructs a new cubic interpolant.
   *
   * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
   * @param {TypedArray} sampleValues - The sample values.
   * @param {number} sampleSize - The sample size
   * @param {TypedArray} [resultBuffer] - The result buffer.
   */
  constructor(e, t, n, i) {
    super(e, t, n, i), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
      endingStart: Es,
      endingEnd: Es
    };
  }
  intervalChanged_(e, t, n) {
    const i = this.parameterPositions;
    let r = e - 2, a = e + 1, o = i[r], l = i[a];
    if (o === void 0)
      switch (this.getSettings_().endingStart) {
        case Ts:
          r = e, o = 2 * t - n;
          break;
        case ba:
          r = i.length - 2, o = t + i[r] - i[r + 1];
          break;
        default:
          r = e, o = n;
      }
    if (l === void 0)
      switch (this.getSettings_().endingEnd) {
        case Ts:
          a = e, l = 2 * n - t;
          break;
        case ba:
          a = 1, l = n + i[1] - i[0];
          break;
        default:
          a = e - 1, l = t;
      }
    const c = (n - t) * 0.5, u = this.valueSize;
    this._weightPrev = c / (t - o), this._weightNext = c / (l - n), this._offsetPrev = r * u, this._offsetNext = a * u;
  }
  interpolate_(e, t, n, i) {
    const r = this.resultBuffer, a = this.sampleValues, o = this.valueSize, l = e * o, c = l - o, u = this._offsetPrev, h = this._offsetNext, d = this._weightPrev, f = this._weightNext, m = (n - t) / (i - t), _ = m * m, g = _ * m, p = -d * g + 2 * d * _ - d * m, M = (1 + d) * g + (-1.5 - 2 * d) * _ + (-0.5 + d) * m + 1, S = (-1 - f) * g + (1.5 + f) * _ + 0.5 * m, x = f * g - f * _;
    for (let R = 0; R !== o; ++R)
      r[R] = p * a[u + R] + M * a[c + R] + S * a[l + R] + x * a[h + R];
    return r;
  }
}
class jh extends wr {
  /**
   * Constructs a new linear interpolant.
   *
   * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
   * @param {TypedArray} sampleValues - The sample values.
   * @param {number} sampleSize - The sample size
   * @param {TypedArray} [resultBuffer] - The result buffer.
   */
  constructor(e, t, n, i) {
    super(e, t, n, i);
  }
  interpolate_(e, t, n, i) {
    const r = this.resultBuffer, a = this.sampleValues, o = this.valueSize, l = e * o, c = l - o, u = (n - t) / (i - t), h = 1 - u;
    for (let d = 0; d !== o; ++d)
      r[d] = a[c + d] * h + a[l + d] * u;
    return r;
  }
}
class _p extends wr {
  /**
   * Constructs a new discrete interpolant.
   *
   * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
   * @param {TypedArray} sampleValues - The sample values.
   * @param {number} sampleSize - The sample size
   * @param {TypedArray} [resultBuffer] - The result buffer.
   */
  constructor(e, t, n, i) {
    super(e, t, n, i);
  }
  interpolate_(e) {
    return this.copySampleValue_(e - 1);
  }
}
class Fn {
  /**
   * Constructs a new keyframe track.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<number>} values - A list of keyframe values.
   * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
   */
  constructor(e, t, n, i) {
    if (e === void 0) throw new Error("THREE.KeyframeTrack: track name is undefined");
    if (t === void 0 || t.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + e);
    this.name = e, this.times = ta(t, this.TimeBufferType), this.values = ta(n, this.ValueBufferType), this.setInterpolation(i || this.DefaultInterpolation);
  }
  /**
   * Converts the keyframe track to JSON.
   *
   * @static
   * @param {KeyframeTrack} track - The keyframe track to serialize.
   * @return {Object} The serialized keyframe track as JSON.
   */
  static toJSON(e) {
    const t = e.constructor;
    let n;
    if (t.toJSON !== this.toJSON)
      n = t.toJSON(e);
    else {
      n = {
        name: e.name,
        times: ta(e.times, Array),
        values: ta(e.values, Array)
      };
      const i = e.getInterpolation();
      i !== e.DefaultInterpolation && (n.interpolation = i);
    }
    return n.type = e.ValueTypeName, n;
  }
  /**
   * Factory method for creating a new discrete interpolant.
   *
   * @static
   * @param {TypedArray} [result] - The result buffer.
   * @return {DiscreteInterpolant} The new interpolant.
   */
  InterpolantFactoryMethodDiscrete(e) {
    return new _p(this.times, this.values, this.getValueSize(), e);
  }
  /**
   * Factory method for creating a new linear interpolant.
   *
   * @static
   * @param {TypedArray} [result] - The result buffer.
   * @return {LinearInterpolant} The new interpolant.
   */
  InterpolantFactoryMethodLinear(e) {
    return new jh(this.times, this.values, this.getValueSize(), e);
  }
  /**
   * Factory method for creating a new smooth interpolant.
   *
   * @static
   * @param {TypedArray} [result] - The result buffer.
   * @return {CubicInterpolant} The new interpolant.
   */
  InterpolantFactoryMethodSmooth(e) {
    return new gp(this.times, this.values, this.getValueSize(), e);
  }
  /**
   * Defines the interpolation factor method for this keyframe track.
   *
   * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} interpolation - The interpolation type.
   * @return {KeyframeTrack} A reference to this keyframe track.
   */
  setInterpolation(e) {
    let t;
    switch (e) {
      case Sr:
        t = this.InterpolantFactoryMethodDiscrete;
        break;
      case Mr:
        t = this.InterpolantFactoryMethodLinear;
        break;
      case Ba:
        t = this.InterpolantFactoryMethodSmooth;
        break;
    }
    if (t === void 0) {
      const n = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
      if (this.createInterpolant === void 0)
        if (e !== this.DefaultInterpolation)
          this.setInterpolation(this.DefaultInterpolation);
        else
          throw new Error(n);
      return console.warn("THREE.KeyframeTrack:", n), this;
    }
    return this.createInterpolant = t, this;
  }
  /**
   * Returns the current interpolation type.
   *
   * @return {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} The interpolation type.
   */
  getInterpolation() {
    switch (this.createInterpolant) {
      case this.InterpolantFactoryMethodDiscrete:
        return Sr;
      case this.InterpolantFactoryMethodLinear:
        return Mr;
      case this.InterpolantFactoryMethodSmooth:
        return Ba;
    }
  }
  /**
   * Returns the value size.
   *
   * @return {number} The value size.
   */
  getValueSize() {
    return this.values.length / this.times.length;
  }
  /**
   * Moves all keyframes either forward or backward in time.
   *
   * @param {number} timeOffset - The offset to move the time values.
   * @return {KeyframeTrack} A reference to this keyframe track.
   */
  shift(e) {
    if (e !== 0) {
      const t = this.times;
      for (let n = 0, i = t.length; n !== i; ++n)
        t[n] += e;
    }
    return this;
  }
  /**
   * Scale all keyframe times by a factor (useful for frame - seconds conversions).
   *
   * @param {number} timeScale - The time scale.
   * @return {KeyframeTrack} A reference to this keyframe track.
   */
  scale(e) {
    if (e !== 1) {
      const t = this.times;
      for (let n = 0, i = t.length; n !== i; ++n)
        t[n] *= e;
    }
    return this;
  }
  /**
   * Removes keyframes before and after animation without changing any values within the defined time range.
   *
   * Note: The method does not shift around keys to the start of the track time, because for interpolated
   * keys this will change their values
   *
   * @param {number} startTime - The start time.
   * @param {number} endTime - The end time.
   * @return {KeyframeTrack} A reference to this keyframe track.
   */
  trim(e, t) {
    const n = this.times, i = n.length;
    let r = 0, a = i - 1;
    for (; r !== i && n[r] < e; )
      ++r;
    for (; a !== -1 && n[a] > t; )
      --a;
    if (++a, r !== 0 || a !== i) {
      r >= a && (a = Math.max(a, 1), r = a - 1);
      const o = this.getValueSize();
      this.times = n.slice(r, a), this.values = this.values.slice(r * o, a * o);
    }
    return this;
  }
  /**
   * Performs minimal validation on the keyframe track. Returns `true` if the values
   * are valid.
   *
   * @return {boolean} Whether the keyframes are valid or not.
   */
  validate() {
    let e = !0;
    const t = this.getValueSize();
    t - Math.floor(t) !== 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), e = !1);
    const n = this.times, i = this.values, r = n.length;
    r === 0 && (console.error("THREE.KeyframeTrack: Track is empty.", this), e = !1);
    let a = null;
    for (let o = 0; o !== r; o++) {
      const l = n[o];
      if (typeof l == "number" && isNaN(l)) {
        console.error("THREE.KeyframeTrack: Time is not a valid number.", this, o, l), e = !1;
        break;
      }
      if (a !== null && a > l) {
        console.error("THREE.KeyframeTrack: Out of order keys.", this, o, l, a), e = !1;
        break;
      }
      a = l;
    }
    if (i !== void 0 && pp(i))
      for (let o = 0, l = i.length; o !== l; ++o) {
        const c = i[o];
        if (isNaN(c)) {
          console.error("THREE.KeyframeTrack: Value is not a valid number.", this, o, c), e = !1;
          break;
        }
      }
    return e;
  }
  /**
   * Optimizes this keyframe track by removing equivalent sequential keys (which are
   * common in morph target sequences).
   *
   * @return {AnimationClip} A reference to this animation clip.
   */
  optimize() {
    const e = this.times.slice(), t = this.values.slice(), n = this.getValueSize(), i = this.getInterpolation() === Ba, r = e.length - 1;
    let a = 1;
    for (let o = 1; o < r; ++o) {
      let l = !1;
      const c = e[o], u = e[o + 1];
      if (c !== u && (o !== 1 || c !== e[0]))
        if (i)
          l = !0;
        else {
          const h = o * n, d = h - n, f = h + n;
          for (let m = 0; m !== n; ++m) {
            const _ = t[h + m];
            if (_ !== t[d + m] || _ !== t[f + m]) {
              l = !0;
              break;
            }
          }
        }
      if (l) {
        if (o !== a) {
          e[a] = e[o];
          const h = o * n, d = a * n;
          for (let f = 0; f !== n; ++f)
            t[d + f] = t[h + f];
        }
        ++a;
      }
    }
    if (r > 0) {
      e[a] = e[r];
      for (let o = r * n, l = a * n, c = 0; c !== n; ++c)
        t[l + c] = t[o + c];
      ++a;
    }
    return a !== e.length ? (this.times = e.slice(0, a), this.values = t.slice(0, a * n)) : (this.times = e, this.values = t), this;
  }
  /**
   * Returns a new keyframe track with copied values from this instance.
   *
   * @return {KeyframeTrack} A clone of this instance.
   */
  clone() {
    const e = this.times.slice(), t = this.values.slice(), n = this.constructor, i = new n(this.name, e, t);
    return i.createInterpolant = this.createInterpolant, i;
  }
}
Fn.prototype.ValueTypeName = "";
Fn.prototype.TimeBufferType = Float32Array;
Fn.prototype.ValueBufferType = Float32Array;
Fn.prototype.DefaultInterpolation = Mr;
class Ws extends Fn {
  /**
   * Constructs a new boolean keyframe track.
   *
   * This keyframe track type has no `interpolation` parameter because the
   * interpolation is always discrete.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<number>} values - A list of keyframe values.
   */
  constructor(e, t, n) {
    super(e, t, n);
  }
}
Ws.prototype.ValueTypeName = "bool";
Ws.prototype.ValueBufferType = Array;
Ws.prototype.DefaultInterpolation = Sr;
Ws.prototype.InterpolantFactoryMethodLinear = void 0;
Ws.prototype.InterpolantFactoryMethodSmooth = void 0;
class Kh extends Fn {
  /**
   * Constructs a new color keyframe track.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<number>} values - A list of keyframe values.
   * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
   */
  constructor(e, t, n, i) {
    super(e, t, n, i);
  }
}
Kh.prototype.ValueTypeName = "color";
class ks extends Fn {
  /**
   * Constructs a new number keyframe track.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<number>} values - A list of keyframe values.
   * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
   */
  constructor(e, t, n, i) {
    super(e, t, n, i);
  }
}
ks.prototype.ValueTypeName = "number";
class xp extends wr {
  /**
   * Constructs a new SLERP interpolant.
   *
   * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
   * @param {TypedArray} sampleValues - The sample values.
   * @param {number} sampleSize - The sample size
   * @param {TypedArray} [resultBuffer] - The result buffer.
   */
  constructor(e, t, n, i) {
    super(e, t, n, i);
  }
  interpolate_(e, t, n, i) {
    const r = this.resultBuffer, a = this.sampleValues, o = this.valueSize, l = (n - t) / (i - t);
    let c = e * o;
    for (let u = c + o; c !== u; c += 4)
      gn.slerpFlat(r, 0, a, c - o, a, c, l);
    return r;
  }
}
class zs extends Fn {
  /**
   * Constructs a new Quaternion keyframe track.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<number>} values - A list of keyframe values.
   * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
   */
  constructor(e, t, n, i) {
    super(e, t, n, i);
  }
  /**
   * Overwritten so the method returns Quaternion based interpolant.
   *
   * @static
   * @param {TypedArray} [result] - The result buffer.
   * @return {QuaternionLinearInterpolant} The new interpolant.
   */
  InterpolantFactoryMethodLinear(e) {
    return new xp(this.times, this.values, this.getValueSize(), e);
  }
}
zs.prototype.ValueTypeName = "quaternion";
zs.prototype.InterpolantFactoryMethodSmooth = void 0;
class Xs extends Fn {
  /**
   * Constructs a new string keyframe track.
   *
   * This keyframe track type has no `interpolation` parameter because the
   * interpolation is always discrete.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<number>} values - A list of keyframe values.
   */
  constructor(e, t, n) {
    super(e, t, n);
  }
}
Xs.prototype.ValueTypeName = "string";
Xs.prototype.ValueBufferType = Array;
Xs.prototype.DefaultInterpolation = Sr;
Xs.prototype.InterpolantFactoryMethodLinear = void 0;
Xs.prototype.InterpolantFactoryMethodSmooth = void 0;
class Hs extends Fn {
  /**
   * Constructs a new vector keyframe track.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<number>} values - A list of keyframe values.
   * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
   */
  constructor(e, t, n, i) {
    super(e, t, n, i);
  }
}
Hs.prototype.ValueTypeName = "vector";
class Ra {
  /**
   * Constructs a new animation clip.
   *
   * Note: Instead of instantiating an AnimationClip directly with the constructor, you can
   * use the static interface of this class for creating clips. In most cases though, animation clips
   * will automatically be created by loaders when importing animated 3D assets.
   *
   * @param {string} [name=''] - The clip's name.
   * @param {number} [duration=-1] - The clip's duration in seconds. If a negative value is passed,
   * the duration will be calculated from the passed keyframes.
   * @param {Array<KeyframeTrack>} tracks - An array of keyframe tracks.
   * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode=NormalAnimationBlendMode] - Defines how the animation
   * is blended/combined when two or more animations are simultaneously played.
   */
  constructor(e = "", t = -1, n = [], i = zl) {
    this.name = e, this.tracks = n, this.duration = t, this.blendMode = i, this.uuid = Un(), this.duration < 0 && this.resetDuration();
  }
  /**
   * Factory method for creating an animation clip from the given JSON.
   *
   * @static
   * @param {Object} json - The serialized animation clip.
   * @return {AnimationClip} The new animation clip.
   */
  static parse(e) {
    const t = [], n = e.tracks, i = 1 / (e.fps || 1);
    for (let a = 0, o = n.length; a !== o; ++a)
      t.push(yp(n[a]).scale(i));
    const r = new this(e.name, e.duration, t, e.blendMode);
    return r.uuid = e.uuid, r;
  }
  /**
   * Serializes the given animation clip into JSON.
   *
   * @static
   * @param {AnimationClip} clip - The animation clip to serialize.
   * @return {Object} The JSON object.
   */
  static toJSON(e) {
    const t = [], n = e.tracks, i = {
      name: e.name,
      duration: e.duration,
      tracks: t,
      uuid: e.uuid,
      blendMode: e.blendMode
    };
    for (let r = 0, a = n.length; r !== a; ++r)
      t.push(Fn.toJSON(n[r]));
    return i;
  }
  /**
   * Returns a new animation clip from the passed morph targets array of a
   * geometry, taking a name and the number of frames per second.
   *
   * Note: The fps parameter is required, but the animation speed can be
   * overridden via {@link AnimationAction#setDuration}.
   *
   * @static
   * @param {string} name - The name of the animation clip.
   * @param {Array<Object>} morphTargetSequence - A sequence of morph targets.
   * @param {number} fps - The Frames-Per-Second value.
   * @param {boolean} noLoop - Whether the clip should be no loop or not.
   * @return {AnimationClip} The new animation clip.
   */
  static CreateFromMorphTargetSequence(e, t, n, i) {
    const r = t.length, a = [];
    for (let o = 0; o < r; o++) {
      let l = [], c = [];
      l.push(
        (o + r - 1) % r,
        o,
        (o + 1) % r
      ), c.push(0, 1, 0);
      const u = mp(l);
      l = ou(l, 1, u), c = ou(c, 1, u), !i && l[0] === 0 && (l.push(r), c.push(c[0])), a.push(
        new ks(
          ".morphTargetInfluences[" + t[o].name + "]",
          l,
          c
        ).scale(1 / n)
      );
    }
    return new this(e, -1, a);
  }
  /**
   * Searches for an animation clip by name, taking as its first parameter
   * either an array of clips, or a mesh or geometry that contains an
   * array named "animations" property.
   *
   * @static
   * @param {(Array<AnimationClip>|Object3D)} objectOrClipArray - The array or object to search through.
   * @param {string} name - The name to search for.
   * @return {?AnimationClip} The found animation clip. Returns `null` if no clip has been found.
   */
  static findByName(e, t) {
    let n = e;
    if (!Array.isArray(e)) {
      const i = e;
      n = i.geometry && i.geometry.animations || i.animations;
    }
    for (let i = 0; i < n.length; i++)
      if (n[i].name === t)
        return n[i];
    return null;
  }
  /**
   * Returns an array of new AnimationClips created from the morph target
   * sequences of a geometry, trying to sort morph target names into
   * animation-group-based patterns like "Walk_001, Walk_002, Run_001, Run_002...".
   *
   * See {@link MD2Loader#parse} as an example for how the method should be used.
   *
   * @static
   * @param {Array<Object>} morphTargets - A sequence of morph targets.
   * @param {number} fps - The Frames-Per-Second value.
   * @param {boolean} noLoop - Whether the clip should be no loop or not.
   * @return {Array<AnimationClip>} An array of new animation clips.
   */
  static CreateClipsFromMorphTargetSequences(e, t, n) {
    const i = {}, r = /^([\w-]*?)([\d]+)$/;
    for (let o = 0, l = e.length; o < l; o++) {
      const c = e[o], u = c.name.match(r);
      if (u && u.length > 1) {
        const h = u[1];
        let d = i[h];
        d || (i[h] = d = []), d.push(c);
      }
    }
    const a = [];
    for (const o in i)
      a.push(this.CreateFromMorphTargetSequence(o, i[o], t, n));
    return a;
  }
  /**
   * Parses the `animation.hierarchy` format and returns a new animation clip.
   *
   * @static
   * @deprecated since r175.
   * @param {Object} animation - A serialized animation clip as JSON.
   * @param {Array<Bones>} bones - An array of bones.
   * @return {?AnimationClip} The new animation clip.
   */
  static parseAnimation(e, t) {
    if (console.warn("THREE.AnimationClip: parseAnimation() is deprecated and will be removed with r185"), !e)
      return console.error("THREE.AnimationClip: No animation in JSONLoader data."), null;
    const n = function(h, d, f, m, _) {
      if (f.length !== 0) {
        const g = [], p = [];
        Yh(f, g, p, m), g.length !== 0 && _.push(new h(d, g, p));
      }
    }, i = [], r = e.name || "default", a = e.fps || 30, o = e.blendMode;
    let l = e.length || -1;
    const c = e.hierarchy || [];
    for (let h = 0; h < c.length; h++) {
      const d = c[h].keys;
      if (!(!d || d.length === 0))
        if (d[0].morphTargets) {
          const f = {};
          let m;
          for (m = 0; m < d.length; m++)
            if (d[m].morphTargets)
              for (let _ = 0; _ < d[m].morphTargets.length; _++)
                f[d[m].morphTargets[_]] = -1;
          for (const _ in f) {
            const g = [], p = [];
            for (let M = 0; M !== d[m].morphTargets.length; ++M) {
              const S = d[m];
              g.push(S.time), p.push(S.morphTarget === _ ? 1 : 0);
            }
            i.push(new ks(".morphTargetInfluence[" + _ + "]", g, p));
          }
          l = f.length * a;
        } else {
          const f = ".bones[" + t[h].name + "]";
          n(
            Hs,
            f + ".position",
            d,
            "pos",
            i
          ), n(
            zs,
            f + ".quaternion",
            d,
            "rot",
            i
          ), n(
            Hs,
            f + ".scale",
            d,
            "scl",
            i
          );
        }
    }
    return i.length === 0 ? null : new this(r, l, i, o);
  }
  /**
   * Sets the duration of this clip to the duration of its longest keyframe track.
   *
   * @return {AnimationClip} A reference to this animation clip.
   */
  resetDuration() {
    const e = this.tracks;
    let t = 0;
    for (let n = 0, i = e.length; n !== i; ++n) {
      const r = this.tracks[n];
      t = Math.max(t, r.times[r.times.length - 1]);
    }
    return this.duration = t, this;
  }
  /**
   * Trims all tracks to the clip's duration.
   *
   * @return {AnimationClip} A reference to this animation clip.
   */
  trim() {
    for (let e = 0; e < this.tracks.length; e++)
      this.tracks[e].trim(0, this.duration);
    return this;
  }
  /**
   * Performs minimal validation on each track in the clip. Returns `true` if all
   * tracks are valid.
   *
   * @return {boolean} Whether the clip's keyframes are valid or not.
   */
  validate() {
    let e = !0;
    for (let t = 0; t < this.tracks.length; t++)
      e = e && this.tracks[t].validate();
    return e;
  }
  /**
   * Optimizes each track by removing equivalent sequential keys (which are
   * common in morph target sequences).
   *
   * @return {AnimationClip} A reference to this animation clip.
   */
  optimize() {
    for (let e = 0; e < this.tracks.length; e++)
      this.tracks[e].optimize();
    return this;
  }
  /**
   * Returns a new animation clip with copied values from this instance.
   *
   * @return {AnimationClip} A clone of this instance.
   */
  clone() {
    const e = [];
    for (let t = 0; t < this.tracks.length; t++)
      e.push(this.tracks[t].clone());
    return new this.constructor(this.name, this.duration, e, this.blendMode);
  }
  /**
   * Serializes this animation clip into JSON.
   *
   * @return {Object} The JSON object.
   */
  toJSON() {
    return this.constructor.toJSON(this);
  }
}
function vp(s) {
  switch (s.toLowerCase()) {
    case "scalar":
    case "double":
    case "float":
    case "number":
    case "integer":
      return ks;
    case "vector":
    case "vector2":
    case "vector3":
    case "vector4":
      return Hs;
    case "color":
      return Kh;
    case "quaternion":
      return zs;
    case "bool":
    case "boolean":
      return Ws;
    case "string":
      return Xs;
  }
  throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + s);
}
function yp(s) {
  if (s.type === void 0)
    throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
  const e = vp(s.type);
  if (s.times === void 0) {
    const t = [], n = [];
    Yh(s.keys, t, n, "value"), s.times = t, s.values = n;
  }
  return e.parse !== void 0 ? e.parse(s) : new e(s.name, s.times, s.values, s.interpolation);
}
const Ci = {
  /**
   * Whether caching is enabled or not.
   *
   * @static
   * @type {boolean}
   * @default false
   */
  enabled: !1,
  /**
   * A dictionary that holds cached files.
   *
   * @static
   * @type {Object<string,Object>}
   */
  files: {},
  /**
   * Adds a cache entry with a key to reference the file. If this key already
   * holds a file, it is overwritten.
   *
   * @static
   * @param {string} key - The key to reference the cached file.
   * @param {Object} file -  The file to be cached.
   */
  add: function(s, e) {
    this.enabled !== !1 && (this.files[s] = e);
  },
  /**
   * Gets the cached value for the given key.
   *
   * @static
   * @param {string} key - The key to reference the cached file.
   * @return {Object|undefined} The cached file. If the key does not exist `undefined` is returned.
   */
  get: function(s) {
    if (this.enabled !== !1)
      return this.files[s];
  },
  /**
   * Removes the cached file associated with the given key.
   *
   * @static
   * @param {string} key - The key to reference the cached file.
   */
  remove: function(s) {
    delete this.files[s];
  },
  /**
   * Remove all values from the cache.
   *
   * @static
   */
  clear: function() {
    this.files = {};
  }
};
class Sp {
  /**
   * Constructs a new loading manager.
   *
   * @param {Function} [onLoad] - Executes when all items have been loaded.
   * @param {Function} [onProgress] - Executes when single items have been loaded.
   * @param {Function} [onError] - Executes when an error occurs.
   */
  constructor(e, t, n) {
    const i = this;
    let r = !1, a = 0, o = 0, l;
    const c = [];
    this.onStart = void 0, this.onLoad = e, this.onProgress = t, this.onError = n, this.itemStart = function(u) {
      o++, r === !1 && i.onStart !== void 0 && i.onStart(u, a, o), r = !0;
    }, this.itemEnd = function(u) {
      a++, i.onProgress !== void 0 && i.onProgress(u, a, o), a === o && (r = !1, i.onLoad !== void 0 && i.onLoad());
    }, this.itemError = function(u) {
      i.onError !== void 0 && i.onError(u);
    }, this.resolveURL = function(u) {
      return l ? l(u) : u;
    }, this.setURLModifier = function(u) {
      return l = u, this;
    }, this.addHandler = function(u, h) {
      return c.push(u, h), this;
    }, this.removeHandler = function(u) {
      const h = c.indexOf(u);
      return h !== -1 && c.splice(h, 2), this;
    }, this.getHandler = function(u) {
      for (let h = 0, d = c.length; h < d; h += 2) {
        const f = c[h], m = c[h + 1];
        if (f.global && (f.lastIndex = 0), f.test(u))
          return m;
      }
      return null;
    };
  }
}
const Mp = /* @__PURE__ */ new Sp();
class Fi {
  /**
   * Constructs a new loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(e) {
    this.manager = e !== void 0 ? e : Mp, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
  }
  /**
   * This method needs to be implemented by all concrete loaders. It holds the
   * logic for loading assets from the backend.
   *
   * @param {string} url - The path/URL of the file to be loaded.
   * @param {Function} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
   * @param {onErrorCallback} [onError] - Executed when errors occur.
   */
  load() {
  }
  /**
   * A async version of {@link Loader#load}.
   *
   * @param {string} url - The path/URL of the file to be loaded.
   * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
   * @return {Promise} A Promise that resolves when the asset has been loaded.
   */
  loadAsync(e, t) {
    const n = this;
    return new Promise(function(i, r) {
      n.load(e, i, t, r);
    });
  }
  /**
   * This method needs to be implemented by all concrete loaders. It holds the
   * logic for parsing the asset into three.js entities.
   *
   * @param {any} data - The data to parse.
   */
  parse() {
  }
  /**
   * Sets the `crossOrigin` String to implement CORS for loading the URL
   * from a different domain that allows CORS.
   *
   * @param {string} crossOrigin - The `crossOrigin` value.
   * @return {Loader} A reference to this instance.
   */
  setCrossOrigin(e) {
    return this.crossOrigin = e, this;
  }
  /**
   * Whether the XMLHttpRequest uses credentials such as cookies, authorization
   * headers or TLS client certificates, see [XMLHttpRequest.withCredentials]{@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials}.
   *
   * Note: This setting has no effect if you are loading files locally or from the same domain.
   *
   * @param {boolean} value - The `withCredentials` value.
   * @return {Loader} A reference to this instance.
   */
  setWithCredentials(e) {
    return this.withCredentials = e, this;
  }
  /**
   * Sets the base path for the asset.
   *
   * @param {string} path - The base path.
   * @return {Loader} A reference to this instance.
   */
  setPath(e) {
    return this.path = e, this;
  }
  /**
   * Sets the base path for dependent resources like textures.
   *
   * @param {string} resourcePath - The resource path.
   * @return {Loader} A reference to this instance.
   */
  setResourcePath(e) {
    return this.resourcePath = e, this;
  }
  /**
   * Sets the given request header.
   *
   * @param {Object} requestHeader - A [request header]{@link https://developer.mozilla.org/en-US/docs/Glossary/Request_header}
   * for configuring the HTTP request.
   * @return {Loader} A reference to this instance.
   */
  setRequestHeader(e) {
    return this.requestHeader = e, this;
  }
}
Fi.DEFAULT_MATERIAL_NAME = "__DEFAULT";
const ai = {};
class bp extends Error {
  constructor(e, t) {
    super(e), this.response = t;
  }
}
class Er extends Fi {
  /**
   * Constructs a new file loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(e) {
    super(e), this.mimeType = "", this.responseType = "";
  }
  /**
   * Starts loading from the given URL and pass the loaded response to the `onLoad()` callback.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(any)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
   * @param {onErrorCallback} [onError] - Executed when errors occur.
   * @return {any|undefined} The cached resource if available.
   */
  load(e, t, n, i) {
    e === void 0 && (e = ""), this.path !== void 0 && (e = this.path + e), e = this.manager.resolveURL(e);
    const r = Ci.get(e);
    if (r !== void 0)
      return this.manager.itemStart(e), setTimeout(() => {
        t && t(r), this.manager.itemEnd(e);
      }, 0), r;
    if (ai[e] !== void 0) {
      ai[e].push({
        onLoad: t,
        onProgress: n,
        onError: i
      });
      return;
    }
    ai[e] = [], ai[e].push({
      onLoad: t,
      onProgress: n,
      onError: i
    });
    const a = new Request(e, {
      headers: new Headers(this.requestHeader),
      credentials: this.withCredentials ? "include" : "same-origin"
      // An abort controller could be added within a future PR
    }), o = this.mimeType, l = this.responseType;
    fetch(a).then((c) => {
      if (c.status === 200 || c.status === 0) {
        if (c.status === 0 && console.warn("THREE.FileLoader: HTTP Status 0 received."), typeof ReadableStream > "u" || c.body === void 0 || c.body.getReader === void 0)
          return c;
        const u = ai[e], h = c.body.getReader(), d = c.headers.get("X-File-Size") || c.headers.get("Content-Length"), f = d ? parseInt(d) : 0, m = f !== 0;
        let _ = 0;
        const g = new ReadableStream({
          start(p) {
            M();
            function M() {
              h.read().then(({ done: S, value: x }) => {
                if (S)
                  p.close();
                else {
                  _ += x.byteLength;
                  const R = new ProgressEvent("progress", { lengthComputable: m, loaded: _, total: f });
                  for (let w = 0, C = u.length; w < C; w++) {
                    const P = u[w];
                    P.onProgress && P.onProgress(R);
                  }
                  p.enqueue(x), M();
                }
              }, (S) => {
                p.error(S);
              });
            }
          }
        });
        return new Response(g);
      } else
        throw new bp(`fetch for "${c.url}" responded with ${c.status}: ${c.statusText}`, c);
    }).then((c) => {
      switch (l) {
        case "arraybuffer":
          return c.arrayBuffer();
        case "blob":
          return c.blob();
        case "document":
          return c.text().then((u) => new DOMParser().parseFromString(u, o));
        case "json":
          return c.json();
        default:
          if (o === "")
            return c.text();
          {
            const h = /charset="?([^;"\s]*)"?/i.exec(o), d = h && h[1] ? h[1].toLowerCase() : void 0, f = new TextDecoder(d);
            return c.arrayBuffer().then((m) => f.decode(m));
          }
      }
    }).then((c) => {
      Ci.add(e, c);
      const u = ai[e];
      delete ai[e];
      for (let h = 0, d = u.length; h < d; h++) {
        const f = u[h];
        f.onLoad && f.onLoad(c);
      }
    }).catch((c) => {
      const u = ai[e];
      if (u === void 0)
        throw this.manager.itemError(e), c;
      delete ai[e];
      for (let h = 0, d = u.length; h < d; h++) {
        const f = u[h];
        f.onError && f.onError(c);
      }
      this.manager.itemError(e);
    }).finally(() => {
      this.manager.itemEnd(e);
    }), this.manager.itemStart(e);
  }
  /**
   * Sets the expected response type.
   *
   * @param {('arraybuffer'|'blob'|'document'|'json'|'')} value - The response type.
   * @return {FileLoader} A reference to this file loader.
   */
  setResponseType(e) {
    return this.responseType = e, this;
  }
  /**
   * Sets the expected mime type of the loaded file.
   *
   * @param {string} value - The mime type.
   * @return {FileLoader} A reference to this file loader.
   */
  setMimeType(e) {
    return this.mimeType = e, this;
  }
}
class Ep extends Fi {
  /**
   * Constructs a new image loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(e) {
    super(e);
  }
  /**
   * Starts loading from the given URL and passes the loaded image
   * to the `onLoad()` callback. The method also returns a new `Image` object which can
   * directly be used for texture creation. If you do it this way, the texture
   * may pop up in your scene once the respective loading process is finished.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(Image)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} onProgress - Unsupported in this loader.
   * @param {onErrorCallback} onError - Executed when errors occur.
   * @return {Image} The image.
   */
  load(e, t, n, i) {
    this.path !== void 0 && (e = this.path + e), e = this.manager.resolveURL(e);
    const r = this, a = Ci.get(e);
    if (a !== void 0)
      return r.manager.itemStart(e), setTimeout(function() {
        t && t(a), r.manager.itemEnd(e);
      }, 0), a;
    const o = br("img");
    function l() {
      u(), Ci.add(e, this), t && t(this), r.manager.itemEnd(e);
    }
    function c(h) {
      u(), i && i(h), r.manager.itemError(e), r.manager.itemEnd(e);
    }
    function u() {
      o.removeEventListener("load", l, !1), o.removeEventListener("error", c, !1);
    }
    return o.addEventListener("load", l, !1), o.addEventListener("error", c, !1), e.slice(0, 5) !== "data:" && this.crossOrigin !== void 0 && (o.crossOrigin = this.crossOrigin), r.manager.itemStart(e), o.src = e, o;
  }
}
class Tp extends Fi {
  /**
   * Constructs a new data texture loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(e) {
    super(e);
  }
  /**
   * Starts loading from the given URL and passes the loaded data texture
   * to the `onLoad()` callback. The method also returns a new texture object which can
   * directly be used for material creation. If you do it this way, the texture
   * may pop up in your scene once the respective loading process is finished.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(DataTexture)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
   * @param {onErrorCallback} onError - Executed when errors occur.
   * @return {DataTexture} The data texture.
   */
  load(e, t, n, i) {
    const r = this, a = new ql(), o = new Er(this.manager);
    return o.setResponseType("arraybuffer"), o.setRequestHeader(this.requestHeader), o.setPath(this.path), o.setWithCredentials(r.withCredentials), o.load(e, function(l) {
      let c;
      try {
        c = r.parse(l);
      } catch (u) {
        if (i !== void 0)
          i(u);
        else {
          console.error(u);
          return;
        }
      }
      c.image !== void 0 ? a.image = c.image : c.data !== void 0 && (a.image.width = c.width, a.image.height = c.height, a.image.data = c.data), a.wrapS = c.wrapS !== void 0 ? c.wrapS : Vn, a.wrapT = c.wrapT !== void 0 ? c.wrapT : Vn, a.magFilter = c.magFilter !== void 0 ? c.magFilter : Vt, a.minFilter = c.minFilter !== void 0 ? c.minFilter : Vt, a.anisotropy = c.anisotropy !== void 0 ? c.anisotropy : 1, c.colorSpace !== void 0 && (a.colorSpace = c.colorSpace), c.flipY !== void 0 && (a.flipY = c.flipY), c.format !== void 0 && (a.format = c.format), c.type !== void 0 && (a.type = c.type), c.mipmaps !== void 0 && (a.mipmaps = c.mipmaps, a.minFilter = Gn), c.mipmapCount === 1 && (a.minFilter = Vt), c.generateMipmaps !== void 0 && (a.generateMipmaps = c.generateMipmaps), a.needsUpdate = !0, t && t(a, c);
    }, n, i), a;
  }
}
class Ap extends Fi {
  /**
   * Constructs a new texture loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(e) {
    super(e);
  }
  /**
   * Starts loading from the given URL and pass the fully loaded texture
   * to the `onLoad()` callback. The method also returns a new texture object which can
   * directly be used for material creation. If you do it this way, the texture
   * may pop up in your scene once the respective loading process is finished.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(Texture)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} onProgress - Unsupported in this loader.
   * @param {onErrorCallback} onError - Executed when errors occur.
   * @return {Texture} The texture.
   */
  load(e, t, n, i) {
    const r = new Gt(), a = new Ep(this.manager);
    return a.setCrossOrigin(this.crossOrigin), a.setPath(this.path), a.load(e, function(o) {
      r.image = o, r.needsUpdate = !0, t !== void 0 && t(r);
    }, n, i), r;
  }
}
class La extends bt {
  /**
   * Constructs a new light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity.
   */
  constructor(e, t = 1) {
    super(), this.isLight = !0, this.type = "Light", this.color = new He(e), this.intensity = t;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   */
  dispose() {
  }
  copy(e, t) {
    return super.copy(e, t), this.color.copy(e.color), this.intensity = e.intensity, this;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.object.color = this.color.getHex(), t.object.intensity = this.intensity, this.groundColor !== void 0 && (t.object.groundColor = this.groundColor.getHex()), this.distance !== void 0 && (t.object.distance = this.distance), this.angle !== void 0 && (t.object.angle = this.angle), this.decay !== void 0 && (t.object.decay = this.decay), this.penumbra !== void 0 && (t.object.penumbra = this.penumbra), this.shadow !== void 0 && (t.object.shadow = this.shadow.toJSON()), this.target !== void 0 && (t.object.target = this.target.uuid), t;
  }
}
class wp extends La {
  /**
   * Constructs a new hemisphere light.
   *
   * @param {(number|Color|string)} [skyColor=0xffffff] - The light's sky color.
   * @param {(number|Color|string)} [groundColor=0xffffff] - The light's ground color.
   * @param {number} [intensity=1] - The light's strength/intensity.
   */
  constructor(e, t, n) {
    super(e, n), this.isHemisphereLight = !0, this.type = "HemisphereLight", this.position.copy(bt.DEFAULT_UP), this.updateMatrix(), this.groundColor = new He(t);
  }
  copy(e, t) {
    return super.copy(e, t), this.groundColor.copy(e.groundColor), this;
  }
}
const co = /* @__PURE__ */ new Ye(), lu = /* @__PURE__ */ new T(), cu = /* @__PURE__ */ new T();
class $l {
  /**
   * Constructs a new light shadow.
   *
   * @param {Camera} camera - The light's view of the world.
   */
  constructor(e) {
    this.camera = e, this.intensity = 1, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new ze(512, 512), this.map = null, this.mapPass = null, this.matrix = new Ye(), this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new jl(), this._frameExtents = new ze(1, 1), this._viewportCount = 1, this._viewports = [
      new at(0, 0, 1, 1)
    ];
  }
  /**
   * Used internally by the renderer to get the number of viewports that need
   * to be rendered for this shadow.
   *
   * @return {number} The viewport count.
   */
  getViewportCount() {
    return this._viewportCount;
  }
  /**
   * Gets the shadow cameras frustum. Used internally by the renderer to cull objects.
   *
   * @return {Frustum} The shadow camera frustum.
   */
  getFrustum() {
    return this._frustum;
  }
  /**
   * Update the matrices for the camera and shadow, used internally by the renderer.
   *
   * @param {Light} light - The light for which the shadow is being rendered.
   */
  updateMatrices(e) {
    const t = this.camera, n = this.matrix;
    lu.setFromMatrixPosition(e.matrixWorld), t.position.copy(lu), cu.setFromMatrixPosition(e.target.matrixWorld), t.lookAt(cu), t.updateMatrixWorld(), co.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), this._frustum.setFromProjectionMatrix(co), n.set(
      0.5,
      0,
      0,
      0.5,
      0,
      0.5,
      0,
      0.5,
      0,
      0,
      0.5,
      0.5,
      0,
      0,
      0,
      1
    ), n.multiply(co);
  }
  /**
   * Returns a viewport definition for the given viewport index.
   *
   * @param {number} viewportIndex - The viewport index.
   * @return {Vector4} The viewport.
   */
  getViewport(e) {
    return this._viewports[e];
  }
  /**
   * Returns the frame extends.
   *
   * @return {Vector2} The frame extends.
   */
  getFrameExtents() {
    return this._frameExtents;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   */
  dispose() {
    this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
  }
  /**
   * Copies the values of the given light shadow instance to this instance.
   *
   * @param {LightShadow} source - The light shadow to copy.
   * @return {LightShadow} A reference to this light shadow instance.
   */
  copy(e) {
    return this.camera = e.camera.clone(), this.intensity = e.intensity, this.bias = e.bias, this.radius = e.radius, this.mapSize.copy(e.mapSize), this;
  }
  /**
   * Returns a new light shadow instance with copied values from this instance.
   *
   * @return {LightShadow} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Serializes the light shadow into JSON.
   *
   * @return {Object} A JSON object representing the serialized light shadow.
   * @see {@link ObjectLoader#parse}
   */
  toJSON() {
    const e = {};
    return this.intensity !== 1 && (e.intensity = this.intensity), this.bias !== 0 && (e.bias = this.bias), this.normalBias !== 0 && (e.normalBias = this.normalBias), this.radius !== 1 && (e.radius = this.radius), (this.mapSize.x !== 512 || this.mapSize.y !== 512) && (e.mapSize = this.mapSize.toArray()), e.camera = this.camera.toJSON(!1).object, delete e.camera.matrix, e;
  }
}
class Rp extends $l {
  /**
   * Constructs a new spot light shadow.
   */
  constructor() {
    super(new rn(50, 1, 0.5, 500)), this.isSpotLightShadow = !0, this.focus = 1;
  }
  updateMatrices(e) {
    const t = this.camera, n = Os * 2 * e.angle * this.focus, i = this.mapSize.width / this.mapSize.height, r = e.distance || t.far;
    (n !== t.fov || i !== t.aspect || r !== t.far) && (t.fov = n, t.aspect = i, t.far = r, t.updateProjectionMatrix()), super.updateMatrices(e);
  }
  copy(e) {
    return super.copy(e), this.focus = e.focus, this;
  }
}
class Cp extends La {
  /**
   * Constructs a new spot light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
   * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
   * @param {number} [angle=Math.PI/3] - Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
   * @param {number} [penumbra=0] - Percent of the spotlight cone that is attenuated due to penumbra. Value range is `[0,1]`.
   * @param {number} [decay=2] - The amount the light dims along the distance of the light.
   */
  constructor(e, t, n = 0, i = Math.PI / 3, r = 0, a = 2) {
    super(e, t), this.isSpotLight = !0, this.type = "SpotLight", this.position.copy(bt.DEFAULT_UP), this.updateMatrix(), this.target = new bt(), this.distance = n, this.angle = i, this.penumbra = r, this.decay = a, this.map = null, this.shadow = new Rp();
  }
  /**
   * The light's power. Power is the luminous power of the light measured in lumens (lm).
   *  Changing the power will also change the light's intensity.
   *
   * @type {number}
   */
  get power() {
    return this.intensity * Math.PI;
  }
  set power(e) {
    this.intensity = e / Math.PI;
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(e, t) {
    return super.copy(e, t), this.distance = e.distance, this.angle = e.angle, this.penumbra = e.penumbra, this.decay = e.decay, this.target = e.target.clone(), this.shadow = e.shadow.clone(), this;
  }
}
const uu = /* @__PURE__ */ new Ye(), ar = /* @__PURE__ */ new T(), uo = /* @__PURE__ */ new T();
class Pp extends $l {
  /**
   * Constructs a new point light shadow.
   */
  constructor() {
    super(new rn(90, 1, 0.5, 500)), this.isPointLightShadow = !0, this._frameExtents = new ze(4, 2), this._viewportCount = 6, this._viewports = [
      // These viewports map a cube-map onto a 2D texture with the
      // following orientation:
      //
      //  xzXZ
      //   y Y
      //
      // X - Positive x direction
      // x - Negative x direction
      // Y - Positive y direction
      // y - Negative y direction
      // Z - Positive z direction
      // z - Negative z direction
      // positive X
      new at(2, 1, 1, 1),
      // negative X
      new at(0, 1, 1, 1),
      // positive Z
      new at(3, 1, 1, 1),
      // negative Z
      new at(1, 1, 1, 1),
      // positive Y
      new at(3, 0, 1, 1),
      // negative Y
      new at(1, 0, 1, 1)
    ], this._cubeDirections = [
      new T(1, 0, 0),
      new T(-1, 0, 0),
      new T(0, 0, 1),
      new T(0, 0, -1),
      new T(0, 1, 0),
      new T(0, -1, 0)
    ], this._cubeUps = [
      new T(0, 1, 0),
      new T(0, 1, 0),
      new T(0, 1, 0),
      new T(0, 1, 0),
      new T(0, 0, 1),
      new T(0, 0, -1)
    ];
  }
  /**
   * Update the matrices for the camera and shadow, used internally by the renderer.
   *
   * @param {Light} light - The light for which the shadow is being rendered.
   * @param {number} [viewportIndex=0] - The viewport index.
   */
  updateMatrices(e, t = 0) {
    const n = this.camera, i = this.matrix, r = e.distance || n.far;
    r !== n.far && (n.far = r, n.updateProjectionMatrix()), ar.setFromMatrixPosition(e.matrixWorld), n.position.copy(ar), uo.copy(n.position), uo.add(this._cubeDirections[t]), n.up.copy(this._cubeUps[t]), n.lookAt(uo), n.updateMatrixWorld(), i.makeTranslation(-ar.x, -ar.y, -ar.z), uu.multiplyMatrices(n.projectionMatrix, n.matrixWorldInverse), this._frustum.setFromProjectionMatrix(uu);
  }
}
class Zh extends La {
  /**
   * Constructs a new point light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
   * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
   * @param {number} [decay=2] - The amount the light dims along the distance of the light.
   */
  constructor(e, t, n = 0, i = 2) {
    super(e, t), this.isPointLight = !0, this.type = "PointLight", this.distance = n, this.decay = i, this.shadow = new Pp();
  }
  /**
   * The light's power. Power is the luminous power of the light measured in lumens (lm).
   * Changing the power will also change the light's intensity.
   *
   * @type {number}
   */
  get power() {
    return this.intensity * 4 * Math.PI;
  }
  set power(e) {
    this.intensity = e / (4 * Math.PI);
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(e, t) {
    return super.copy(e, t), this.distance = e.distance, this.decay = e.decay, this.shadow = e.shadow.clone(), this;
  }
}
class Ia extends Hh {
  /**
   * Constructs a new orthographic camera.
   *
   * @param {number} [left=-1] - The left plane of the camera's frustum.
   * @param {number} [right=1] - The right plane of the camera's frustum.
   * @param {number} [top=1] - The top plane of the camera's frustum.
   * @param {number} [bottom=-1] - The bottom plane of the camera's frustum.
   * @param {number} [near=0.1] - The camera's near plane.
   * @param {number} [far=2000] - The camera's far plane.
   */
  constructor(e = -1, t = 1, n = 1, i = -1, r = 0.1, a = 2e3) {
    super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = e, this.right = t, this.top = n, this.bottom = i, this.near = r, this.far = a, this.updateProjectionMatrix();
  }
  copy(e, t) {
    return super.copy(e, t), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.near = e.near, this.far = e.far, this.zoom = e.zoom, this.view = e.view === null ? null : Object.assign({}, e.view), this;
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * @param {number} fullWidth - The full width of multiview setup.
   * @param {number} fullHeight - The full height of multiview setup.
   * @param {number} x - The horizontal offset of the subcamera.
   * @param {number} y - The vertical offset of the subcamera.
   * @param {number} width - The width of subcamera.
   * @param {number} height - The height of subcamera.
   * @see {@link PerspectiveCamera#setViewOffset}
   */
  setViewOffset(e, t, n, i, r, a) {
    this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = a, this.updateProjectionMatrix();
  }
  /**
   * Removes the view offset from the projection matrix.
   */
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  /**
   * Updates the camera's projection matrix. Must be called after any change of
   * camera properties.
   */
  updateProjectionMatrix() {
    const e = (this.right - this.left) / (2 * this.zoom), t = (this.top - this.bottom) / (2 * this.zoom), n = (this.right + this.left) / 2, i = (this.top + this.bottom) / 2;
    let r = n - e, a = n + e, o = i + t, l = i - t;
    if (this.view !== null && this.view.enabled) {
      const c = (this.right - this.left) / this.view.fullWidth / this.zoom, u = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
      r += c * this.view.offsetX, a = r + c * this.view.width, o -= u * this.view.offsetY, l = o - u * this.view.height;
    }
    this.projectionMatrix.makeOrthographic(r, a, o, l, this.near, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.object.zoom = this.zoom, t.object.left = this.left, t.object.right = this.right, t.object.top = this.top, t.object.bottom = this.bottom, t.object.near = this.near, t.object.far = this.far, this.view !== null && (t.object.view = Object.assign({}, this.view)), t;
  }
}
class Lp extends $l {
  /**
   * Constructs a new directional light shadow.
   */
  constructor() {
    super(new Ia(-5, 5, 5, -5, 0.5, 500)), this.isDirectionalLightShadow = !0;
  }
}
class Ml extends La {
  /**
   * Constructs a new directional light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity.
   */
  constructor(e, t) {
    super(e, t), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy(bt.DEFAULT_UP), this.updateMatrix(), this.target = new bt(), this.shadow = new Lp();
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(e) {
    return super.copy(e), this.target = e.target.clone(), this.shadow = e.shadow.clone(), this;
  }
}
class gr {
  /**
   * Extracts the base URL from the given URL.
   *
   * @param {string} url -The URL to extract the base URL from.
   * @return {string} The extracted base URL.
   */
  static extractUrlBase(e) {
    const t = e.lastIndexOf("/");
    return t === -1 ? "./" : e.slice(0, t + 1);
  }
  /**
   * Resolves relative URLs against the given path. Absolute paths, data urls,
   * and blob URLs will be returned as is. Invalid URLs will return an empty
   * string.
   *
   * @param {string} url -The URL to resolve.
   * @param {string} path - The base path for relative URLs to be resolved against.
   * @return {string} The resolved URL.
   */
  static resolveURL(e, t) {
    return typeof e != "string" || e === "" ? "" : (/^https?:\/\//i.test(t) && /^\//.test(e) && (t = t.replace(/(^https?:\/\/[^\/]+).*/i, "$1")), /^(https?:)?\/\//i.test(e) || /^data:.*,.*$/i.test(e) || /^blob:.*$/i.test(e) ? e : t + e);
  }
}
class Ip extends _n {
  /**
   * Constructs a new instanced buffer geometry.
   */
  constructor() {
    super(), this.isInstancedBufferGeometry = !0, this.type = "InstancedBufferGeometry", this.instanceCount = 1 / 0;
  }
  copy(e) {
    return super.copy(e), this.instanceCount = e.instanceCount, this;
  }
  toJSON() {
    const e = super.toJSON();
    return e.instanceCount = this.instanceCount, e.isInstancedBufferGeometry = !0, e;
  }
}
class Dp extends Fi {
  /**
   * Constructs a new image bitmap loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(e) {
    super(e), this.isImageBitmapLoader = !0, typeof createImageBitmap > "u" && console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported."), typeof fetch > "u" && console.warn("THREE.ImageBitmapLoader: fetch() not supported."), this.options = { premultiplyAlpha: "none" };
  }
  /**
   * Sets the given loader options. The structure of the object must match the `options` parameter of
   * [createImageBitmap]{@link https://developer.mozilla.org/en-US/docs/Web/API/Window/createImageBitmap}.
   *
   * @param {Object} options - The loader options to set.
   * @return {ImageBitmapLoader} A reference to this image bitmap loader.
   */
  setOptions(e) {
    return this.options = e, this;
  }
  /**
   * Starts loading from the given URL and pass the loaded image bitmap to the `onLoad()` callback.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(ImageBitmap)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} onProgress - Unsupported in this loader.
   * @param {onErrorCallback} onError - Executed when errors occur.
   * @return {ImageBitmap|undefined} The image bitmap.
   */
  load(e, t, n, i) {
    e === void 0 && (e = ""), this.path !== void 0 && (e = this.path + e), e = this.manager.resolveURL(e);
    const r = this, a = Ci.get(e);
    if (a !== void 0) {
      if (r.manager.itemStart(e), a.then) {
        a.then((c) => {
          t && t(c), r.manager.itemEnd(e);
        }).catch((c) => {
          i && i(c);
        });
        return;
      }
      return setTimeout(function() {
        t && t(a), r.manager.itemEnd(e);
      }, 0), a;
    }
    const o = {};
    o.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include", o.headers = this.requestHeader;
    const l = fetch(e, o).then(function(c) {
      return c.blob();
    }).then(function(c) {
      return createImageBitmap(c, Object.assign(r.options, { colorSpaceConversion: "none" }));
    }).then(function(c) {
      return Ci.add(e, c), t && t(c), r.manager.itemEnd(e), c;
    }).catch(function(c) {
      i && i(c), Ci.remove(e), r.manager.itemError(e), r.manager.itemEnd(e);
    });
    Ci.add(e, l), r.manager.itemStart(e);
  }
}
class Np extends rn {
  /**
   * Constructs a new array camera.
   *
   * @param {Array<PerspectiveCamera>} [array=[]] - An array of perspective sub cameras.
   */
  constructor(e = []) {
    super(), this.isArrayCamera = !0, this.cameras = e, this.index = 0;
  }
}
class Up {
  /**
   * Constructs a new clock.
   *
   * @param {boolean} [autoStart=true] - Whether to automatically start the clock when
   * `getDelta()` is called for the first time.
   */
  constructor(e = !0) {
    this.autoStart = e, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
  }
  /**
   * Starts the clock. When `autoStart` is set to `true`, the method is automatically
   * called by the class.
   */
  start() {
    this.startTime = hu(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
  }
  /**
   * Stops the clock.
   */
  stop() {
    this.getElapsedTime(), this.running = !1, this.autoStart = !1;
  }
  /**
   * Returns the elapsed time in seconds.
   *
   * @return {number} The elapsed time.
   */
  getElapsedTime() {
    return this.getDelta(), this.elapsedTime;
  }
  /**
   * Returns the delta time in seconds.
   *
   * @return {number} The delta time.
   */
  getDelta() {
    let e = 0;
    if (this.autoStart && !this.running)
      return this.start(), 0;
    if (this.running) {
      const t = hu();
      e = (t - this.oldTime) / 1e3, this.oldTime = t, this.elapsedTime += e;
    }
    return e;
  }
}
function hu() {
  return performance.now();
}
class Fp {
  /**
   * Constructs a new property mixer.
   *
   * @param {PropertyBinding} binding - The property binding.
   * @param {string} typeName - The keyframe track type name.
   * @param {number} valueSize - The keyframe track value size.
   */
  constructor(e, t, n) {
    this.binding = e, this.valueSize = n;
    let i, r, a;
    switch (t) {
      case "quaternion":
        i = this._slerp, r = this._slerpAdditive, a = this._setAdditiveIdentityQuaternion, this.buffer = new Float64Array(n * 6), this._workIndex = 5;
        break;
      case "string":
      case "bool":
        i = this._select, r = this._select, a = this._setAdditiveIdentityOther, this.buffer = new Array(n * 5);
        break;
      default:
        i = this._lerp, r = this._lerpAdditive, a = this._setAdditiveIdentityNumeric, this.buffer = new Float64Array(n * 5);
    }
    this._mixBufferRegion = i, this._mixBufferRegionAdditive = r, this._setIdentity = a, this._origIndex = 3, this._addIndex = 4, this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, this.useCount = 0, this.referenceCount = 0;
  }
  /**
   * Accumulates data in the `incoming` region into `accu<i>`.
   *
   * @param {number} accuIndex - The accumulation index.
   * @param {number} weight - The weight.
   */
  accumulate(e, t) {
    const n = this.buffer, i = this.valueSize, r = e * i + i;
    let a = this.cumulativeWeight;
    if (a === 0) {
      for (let o = 0; o !== i; ++o)
        n[r + o] = n[o];
      a = t;
    } else {
      a += t;
      const o = t / a;
      this._mixBufferRegion(n, r, 0, o, i);
    }
    this.cumulativeWeight = a;
  }
  /**
   * Accumulates data in the `incoming` region into `add`.
   *
   * @param {number} weight - The weight.
   */
  accumulateAdditive(e) {
    const t = this.buffer, n = this.valueSize, i = n * this._addIndex;
    this.cumulativeWeightAdditive === 0 && this._setIdentity(), this._mixBufferRegionAdditive(t, i, 0, e, n), this.cumulativeWeightAdditive += e;
  }
  /**
   * Applies the state of `accu<i>` to the binding when accus differ.
   *
   * @param {number} accuIndex - The accumulation index.
   */
  apply(e) {
    const t = this.valueSize, n = this.buffer, i = e * t + t, r = this.cumulativeWeight, a = this.cumulativeWeightAdditive, o = this.binding;
    if (this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, r < 1) {
      const l = t * this._origIndex;
      this._mixBufferRegion(
        n,
        i,
        l,
        1 - r,
        t
      );
    }
    a > 0 && this._mixBufferRegionAdditive(n, i, this._addIndex * t, 1, t);
    for (let l = t, c = t + t; l !== c; ++l)
      if (n[l] !== n[l + t]) {
        o.setValue(n, i);
        break;
      }
  }
  /**
   * Remembers the state of the bound property and copy it to both accus.
   */
  saveOriginalState() {
    const e = this.binding, t = this.buffer, n = this.valueSize, i = n * this._origIndex;
    e.getValue(t, i);
    for (let r = n, a = i; r !== a; ++r)
      t[r] = t[i + r % n];
    this._setIdentity(), this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0;
  }
  /**
   * Applies the state previously taken via {@link PropertyMixer#saveOriginalState} to the binding.
   */
  restoreOriginalState() {
    const e = this.valueSize * 3;
    this.binding.setValue(this.buffer, e);
  }
  // internals
  _setAdditiveIdentityNumeric() {
    const e = this._addIndex * this.valueSize, t = e + this.valueSize;
    for (let n = e; n < t; n++)
      this.buffer[n] = 0;
  }
  _setAdditiveIdentityQuaternion() {
    this._setAdditiveIdentityNumeric(), this.buffer[this._addIndex * this.valueSize + 3] = 1;
  }
  _setAdditiveIdentityOther() {
    const e = this._origIndex * this.valueSize, t = this._addIndex * this.valueSize;
    for (let n = 0; n < this.valueSize; n++)
      this.buffer[t + n] = this.buffer[e + n];
  }
  // mix functions
  _select(e, t, n, i, r) {
    if (i >= 0.5)
      for (let a = 0; a !== r; ++a)
        e[t + a] = e[n + a];
  }
  _slerp(e, t, n, i) {
    gn.slerpFlat(e, t, e, t, e, n, i);
  }
  _slerpAdditive(e, t, n, i, r) {
    const a = this._workIndex * r;
    gn.multiplyQuaternionsFlat(e, a, e, t, e, n), gn.slerpFlat(e, t, e, t, e, a, i);
  }
  _lerp(e, t, n, i, r) {
    const a = 1 - i;
    for (let o = 0; o !== r; ++o) {
      const l = t + o;
      e[l] = e[l] * a + e[n + o] * i;
    }
  }
  _lerpAdditive(e, t, n, i, r) {
    for (let a = 0; a !== r; ++a) {
      const o = t + a;
      e[o] = e[o] + e[n + a] * i;
    }
  }
}
const Jl = "\\[\\]\\.:\\/", Op = new RegExp("[" + Jl + "]", "g"), Ql = "[^" + Jl + "]", Bp = "[^" + Jl.replace("\\.", "") + "]", kp = /* @__PURE__ */ /((?:WC+[\/:])*)/.source.replace("WC", Ql), zp = /* @__PURE__ */ /(WCOD+)?/.source.replace("WCOD", Bp), Hp = /* @__PURE__ */ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", Ql), Vp = /* @__PURE__ */ /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", Ql), Gp = new RegExp(
  "^" + kp + zp + Hp + Vp + "$"
), Wp = ["material", "materials", "bones", "map"];
class Xp {
  constructor(e, t, n) {
    const i = n || gt.parseTrackName(t);
    this._targetGroup = e, this._bindings = e.subscribe_(t, i);
  }
  getValue(e, t) {
    this.bind();
    const n = this._targetGroup.nCachedObjects_, i = this._bindings[n];
    i !== void 0 && i.getValue(e, t);
  }
  setValue(e, t) {
    const n = this._bindings;
    for (let i = this._targetGroup.nCachedObjects_, r = n.length; i !== r; ++i)
      n[i].setValue(e, t);
  }
  bind() {
    const e = this._bindings;
    for (let t = this._targetGroup.nCachedObjects_, n = e.length; t !== n; ++t)
      e[t].bind();
  }
  unbind() {
    const e = this._bindings;
    for (let t = this._targetGroup.nCachedObjects_, n = e.length; t !== n; ++t)
      e[t].unbind();
  }
}
class gt {
  /**
   * Constructs a new property binding.
   *
   * @param {Object} rootNode - The root node.
   * @param {string} path - The path.
   * @param {?Object} [parsedPath] - The parsed path.
   */
  constructor(e, t, n) {
    this.path = t, this.parsedPath = n || gt.parseTrackName(t), this.node = gt.findNode(e, this.parsedPath.nodeName), this.rootNode = e, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
  }
  /**
   * Factory method for creating a property binding from the given parameters.
   *
   * @static
   * @param {Object} root - The root node.
   * @param {string} path - The path.
   * @param {?Object} [parsedPath] - The parsed path.
   * @return {PropertyBinding|Composite} The created property binding or composite.
   */
  static create(e, t, n) {
    return e && e.isAnimationObjectGroup ? new gt.Composite(e, t, n) : new gt(e, t, n);
  }
  /**
   * Replaces spaces with underscores and removes unsupported characters from
   * node names, to ensure compatibility with parseTrackName().
   *
   * @param {string} name - Node name to be sanitized.
   * @return {string} The sanitized node name.
   */
  static sanitizeNodeName(e) {
    return e.replace(/\s/g, "_").replace(Op, "");
  }
  /**
   * Parses the given track name (an object path to an animated property) and
   * returns an object with information about the path. Matches strings in the following forms:
   *
   * - nodeName.property
   * - nodeName.property[accessor]
   * - nodeName.material.property[accessor]
   * - uuid.property[accessor]
   * - uuid.objectName[objectIndex].propertyName[propertyIndex]
   * - parentName/nodeName.property
   * - parentName/parentName/nodeName.property[index]
   * - .bone[Armature.DEF_cog].position
   * - scene:helium_balloon_model:helium_balloon_model.position
   *
   * @static
   * @param {string} trackName - The track name to parse.
   * @return {Object} The parsed track name as an object.
   */
  static parseTrackName(e) {
    const t = Gp.exec(e);
    if (t === null)
      throw new Error("PropertyBinding: Cannot parse trackName: " + e);
    const n = {
      // directoryName: matches[ 1 ], // (tschw) currently unused
      nodeName: t[2],
      objectName: t[3],
      objectIndex: t[4],
      propertyName: t[5],
      // required
      propertyIndex: t[6]
    }, i = n.nodeName && n.nodeName.lastIndexOf(".");
    if (i !== void 0 && i !== -1) {
      const r = n.nodeName.substring(i + 1);
      Wp.indexOf(r) !== -1 && (n.nodeName = n.nodeName.substring(0, i), n.objectName = r);
    }
    if (n.propertyName === null || n.propertyName.length === 0)
      throw new Error("PropertyBinding: can not parse propertyName from trackName: " + e);
    return n;
  }
  /**
   * Searches for a node in the hierarchy of the given root object by the given
   * node name.
   *
   * @static
   * @param {Object} root - The root object.
   * @param {string|number} nodeName - The name of the node.
   * @return {?Object} The found node. Returns `null` if no object was found.
   */
  static findNode(e, t) {
    if (t === void 0 || t === "" || t === "." || t === -1 || t === e.name || t === e.uuid)
      return e;
    if (e.skeleton) {
      const n = e.skeleton.getBoneByName(t);
      if (n !== void 0)
        return n;
    }
    if (e.children) {
      const n = function(r) {
        for (let a = 0; a < r.length; a++) {
          const o = r[a];
          if (o.name === t || o.uuid === t)
            return o;
          const l = n(o.children);
          if (l) return l;
        }
        return null;
      }, i = n(e.children);
      if (i)
        return i;
    }
    return null;
  }
  // these are used to "bind" a nonexistent property
  _getValue_unavailable() {
  }
  _setValue_unavailable() {
  }
  // Getters
  _getValue_direct(e, t) {
    e[t] = this.targetObject[this.propertyName];
  }
  _getValue_array(e, t) {
    const n = this.resolvedProperty;
    for (let i = 0, r = n.length; i !== r; ++i)
      e[t++] = n[i];
  }
  _getValue_arrayElement(e, t) {
    e[t] = this.resolvedProperty[this.propertyIndex];
  }
  _getValue_toArray(e, t) {
    this.resolvedProperty.toArray(e, t);
  }
  // Direct
  _setValue_direct(e, t) {
    this.targetObject[this.propertyName] = e[t];
  }
  _setValue_direct_setNeedsUpdate(e, t) {
    this.targetObject[this.propertyName] = e[t], this.targetObject.needsUpdate = !0;
  }
  _setValue_direct_setMatrixWorldNeedsUpdate(e, t) {
    this.targetObject[this.propertyName] = e[t], this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  // EntireArray
  _setValue_array(e, t) {
    const n = this.resolvedProperty;
    for (let i = 0, r = n.length; i !== r; ++i)
      n[i] = e[t++];
  }
  _setValue_array_setNeedsUpdate(e, t) {
    const n = this.resolvedProperty;
    for (let i = 0, r = n.length; i !== r; ++i)
      n[i] = e[t++];
    this.targetObject.needsUpdate = !0;
  }
  _setValue_array_setMatrixWorldNeedsUpdate(e, t) {
    const n = this.resolvedProperty;
    for (let i = 0, r = n.length; i !== r; ++i)
      n[i] = e[t++];
    this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  // ArrayElement
  _setValue_arrayElement(e, t) {
    this.resolvedProperty[this.propertyIndex] = e[t];
  }
  _setValue_arrayElement_setNeedsUpdate(e, t) {
    this.resolvedProperty[this.propertyIndex] = e[t], this.targetObject.needsUpdate = !0;
  }
  _setValue_arrayElement_setMatrixWorldNeedsUpdate(e, t) {
    this.resolvedProperty[this.propertyIndex] = e[t], this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  // HasToFromArray
  _setValue_fromArray(e, t) {
    this.resolvedProperty.fromArray(e, t);
  }
  _setValue_fromArray_setNeedsUpdate(e, t) {
    this.resolvedProperty.fromArray(e, t), this.targetObject.needsUpdate = !0;
  }
  _setValue_fromArray_setMatrixWorldNeedsUpdate(e, t) {
    this.resolvedProperty.fromArray(e, t), this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  _getValue_unbound(e, t) {
    this.bind(), this.getValue(e, t);
  }
  _setValue_unbound(e, t) {
    this.bind(), this.setValue(e, t);
  }
  /**
   * Creates a getter / setter pair for the property tracked by this binding.
   */
  bind() {
    let e = this.node;
    const t = this.parsedPath, n = t.objectName, i = t.propertyName;
    let r = t.propertyIndex;
    if (e || (e = gt.findNode(this.rootNode, t.nodeName), this.node = e), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !e) {
      console.warn("THREE.PropertyBinding: No target node found for track: " + this.path + ".");
      return;
    }
    if (n) {
      let c = t.objectIndex;
      switch (n) {
        case "materials":
          if (!e.material) {
            console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
            return;
          }
          if (!e.material.materials) {
            console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
            return;
          }
          e = e.material.materials;
          break;
        case "bones":
          if (!e.skeleton) {
            console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
            return;
          }
          e = e.skeleton.bones;
          for (let u = 0; u < e.length; u++)
            if (e[u].name === c) {
              c = u;
              break;
            }
          break;
        case "map":
          if ("map" in e) {
            e = e.map;
            break;
          }
          if (!e.material) {
            console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
            return;
          }
          if (!e.material.map) {
            console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
            return;
          }
          e = e.material.map;
          break;
        default:
          if (e[n] === void 0) {
            console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
            return;
          }
          e = e[n];
      }
      if (c !== void 0) {
        if (e[c] === void 0) {
          console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, e);
          return;
        }
        e = e[c];
      }
    }
    const a = e[i];
    if (a === void 0) {
      const c = t.nodeName;
      console.error("THREE.PropertyBinding: Trying to update property for track: " + c + "." + i + " but it wasn't found.", e);
      return;
    }
    let o = this.Versioning.None;
    this.targetObject = e, e.isMaterial === !0 ? o = this.Versioning.NeedsUpdate : e.isObject3D === !0 && (o = this.Versioning.MatrixWorldNeedsUpdate);
    let l = this.BindingType.Direct;
    if (r !== void 0) {
      if (i === "morphTargetInfluences") {
        if (!e.geometry) {
          console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
          return;
        }
        if (!e.geometry.morphAttributes) {
          console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
          return;
        }
        e.morphTargetDictionary[r] !== void 0 && (r = e.morphTargetDictionary[r]);
      }
      l = this.BindingType.ArrayElement, this.resolvedProperty = a, this.propertyIndex = r;
    } else a.fromArray !== void 0 && a.toArray !== void 0 ? (l = this.BindingType.HasFromToArray, this.resolvedProperty = a) : Array.isArray(a) ? (l = this.BindingType.EntireArray, this.resolvedProperty = a) : this.propertyName = i;
    this.getValue = this.GetterByBindingType[l], this.setValue = this.SetterByBindingTypeAndVersioning[l][o];
  }
  /**
   * Unbinds the property.
   */
  unbind() {
    this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
  }
}
gt.Composite = Xp;
gt.prototype.BindingType = {
  Direct: 0,
  EntireArray: 1,
  ArrayElement: 2,
  HasFromToArray: 3
};
gt.prototype.Versioning = {
  None: 0,
  NeedsUpdate: 1,
  MatrixWorldNeedsUpdate: 2
};
gt.prototype.GetterByBindingType = [
  gt.prototype._getValue_direct,
  gt.prototype._getValue_array,
  gt.prototype._getValue_arrayElement,
  gt.prototype._getValue_toArray
];
gt.prototype.SetterByBindingTypeAndVersioning = [
  [
    // Direct
    gt.prototype._setValue_direct,
    gt.prototype._setValue_direct_setNeedsUpdate,
    gt.prototype._setValue_direct_setMatrixWorldNeedsUpdate
  ],
  [
    // EntireArray
    gt.prototype._setValue_array,
    gt.prototype._setValue_array_setNeedsUpdate,
    gt.prototype._setValue_array_setMatrixWorldNeedsUpdate
  ],
  [
    // ArrayElement
    gt.prototype._setValue_arrayElement,
    gt.prototype._setValue_arrayElement_setNeedsUpdate,
    gt.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
  ],
  [
    // HasToFromArray
    gt.prototype._setValue_fromArray,
    gt.prototype._setValue_fromArray_setNeedsUpdate,
    gt.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
  ]
];
class qp {
  /**
   * Constructs a new animation action.
   *
   * @param {AnimationMixer} mixer - The mixer that is controlled by this action.
   * @param {AnimationClip} clip - The animation clip that holds the actual keyframes.
   * @param {?Object3D} [localRoot=null] - The root object on which this action is performed.
   * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
   */
  constructor(e, t, n = null, i = t.blendMode) {
    this._mixer = e, this._clip = t, this._localRoot = n, this.blendMode = i;
    const r = t.tracks, a = r.length, o = new Array(a), l = {
      endingStart: Es,
      endingEnd: Es
    };
    for (let c = 0; c !== a; ++c) {
      const u = r[c].createInterpolant(null);
      o[c] = u, u.settings = l;
    }
    this._interpolantSettings = l, this._interpolants = o, this._propertyBindings = new Array(a), this._cacheIndex = null, this._byClipCacheIndex = null, this._timeScaleInterpolant = null, this._weightInterpolant = null, this.loop = jd, this._loopCount = -1, this._startTime = null, this.time = 0, this.timeScale = 1, this._effectiveTimeScale = 1, this.weight = 1, this._effectiveWeight = 1, this.repetitions = 1 / 0, this.paused = !1, this.enabled = !0, this.clampWhenFinished = !1, this.zeroSlopeAtStart = !0, this.zeroSlopeAtEnd = !0;
  }
  /**
   * Starts the playback of the animation.
   *
   * @return {AnimationAction} A reference to this animation action.
   */
  play() {
    return this._mixer._activateAction(this), this;
  }
  /**
   * Stops the playback of the animation.
   *
   * @return {AnimationAction} A reference to this animation action.
   */
  stop() {
    return this._mixer._deactivateAction(this), this.reset();
  }
  /**
   * Resets the playback of the animation.
   *
   * @return {AnimationAction} A reference to this animation action.
   */
  reset() {
    return this.paused = !1, this.enabled = !0, this.time = 0, this._loopCount = -1, this._startTime = null, this.stopFading().stopWarping();
  }
  /**
   * Returns `true` if the animation is running.
   *
   * @return {boolean} Whether the animation is running or not.
   */
  isRunning() {
    return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
  }
  /**
   * Returns `true` when {@link AnimationAction#play} has been called.
   *
   * @return {boolean} Whether the animation is scheduled or not.
   */
  isScheduled() {
    return this._mixer._isActiveAction(this);
  }
  /**
   * Defines the time when the animation should start.
   *
   * @param {number} time - The start time in seconds.
   * @return {AnimationAction} A reference to this animation action.
   */
  startAt(e) {
    return this._startTime = e, this;
  }
  /**
   * Configures the loop settings for this action.
   *
   * @param {(LoopRepeat|LoopOnce|LoopPingPong)} mode - The loop mode.
   * @param {number} repetitions - The number of repetitions.
   * @return {AnimationAction} A reference to this animation action.
   */
  setLoop(e, t) {
    return this.loop = e, this.repetitions = t, this;
  }
  /**
   * Sets the effective weight of this action.
   *
   * An action has no effect and thus an effective weight of zero when the
   * action is disabled.
   *
   * @param {number} weight - The weight to set.
   * @return {AnimationAction} A reference to this animation action.
   */
  setEffectiveWeight(e) {
    return this.weight = e, this._effectiveWeight = this.enabled ? e : 0, this.stopFading();
  }
  /**
   * Returns the effective weight of this action.
   *
   * @return {number} The effective weight.
   */
  getEffectiveWeight() {
    return this._effectiveWeight;
  }
  /**
   * Fades the animation in by increasing its weight gradually from `0` to `1`,
   * within the passed time interval.
   *
   * @param {number} duration - The duration of the fade.
   * @return {AnimationAction} A reference to this animation action.
   */
  fadeIn(e) {
    return this._scheduleFading(e, 0, 1);
  }
  /**
   * Fades the animation out by decreasing its weight gradually from `1` to `0`,
   * within the passed time interval.
   *
   * @param {number} duration - The duration of the fade.
   * @return {AnimationAction} A reference to this animation action.
   */
  fadeOut(e) {
    return this._scheduleFading(e, 1, 0);
  }
  /**
   * Causes this action to fade in and the given action to fade out,
   * within the passed time interval.
   *
   * @param {AnimationAction} fadeOutAction - The animation action to fade out.
   * @param {number} duration - The duration of the fade.
   * @param {boolean} [warp=false] - Whether warping should be used or not.
   * @return {AnimationAction} A reference to this animation action.
   */
  crossFadeFrom(e, t, n = !1) {
    if (e.fadeOut(t), this.fadeIn(t), n === !0) {
      const i = this._clip.duration, r = e._clip.duration, a = r / i, o = i / r;
      e.warp(1, a, t), this.warp(o, 1, t);
    }
    return this;
  }
  /**
   * Causes this action to fade out and the given action to fade in,
   * within the passed time interval.
   *
   * @param {AnimationAction} fadeInAction - The animation action to fade in.
   * @param {number} duration - The duration of the fade.
   * @param {boolean} [warp=false] - Whether warping should be used or not.
   * @return {AnimationAction} A reference to this animation action.
   */
  crossFadeTo(e, t, n = !1) {
    return e.crossFadeFrom(this, t, n);
  }
  /**
   * Stops any fading which is applied to this action.
   *
   * @return {AnimationAction} A reference to this animation action.
   */
  stopFading() {
    const e = this._weightInterpolant;
    return e !== null && (this._weightInterpolant = null, this._mixer._takeBackControlInterpolant(e)), this;
  }
  /**
   * Sets the effective time scale of this action.
   *
   * An action has no effect and thus an effective time scale of zero when the
   * action is paused.
   *
   * @param {number} timeScale - The time scale to set.
   * @return {AnimationAction} A reference to this animation action.
   */
  setEffectiveTimeScale(e) {
    return this.timeScale = e, this._effectiveTimeScale = this.paused ? 0 : e, this.stopWarping();
  }
  /**
   * Returns the effective time scale of this action.
   *
   * @return {number} The effective time scale.
   */
  getEffectiveTimeScale() {
    return this._effectiveTimeScale;
  }
  /**
   * Sets the duration for a single loop of this action.
   *
   * @param {number} duration - The duration to set.
   * @return {AnimationAction} A reference to this animation action.
   */
  setDuration(e) {
    return this.timeScale = this._clip.duration / e, this.stopWarping();
  }
  /**
   * Synchronizes this action with the passed other action.
   *
   * @param {AnimationAction} action - The action to sync with.
   * @return {AnimationAction} A reference to this animation action.
   */
  syncWith(e) {
    return this.time = e.time, this.timeScale = e.timeScale, this.stopWarping();
  }
  /**
   * Decelerates this animation's speed to `0` within the passed time interval.
   *
   * @param {number} duration - The duration.
   * @return {AnimationAction} A reference to this animation action.
   */
  halt(e) {
    return this.warp(this._effectiveTimeScale, 0, e);
  }
  /**
   * Changes the playback speed, within the passed time interval, by modifying
   * {@link AnimationAction#timeScale} gradually from `startTimeScale` to
   * `endTimeScale`.
   *
   * @param {number} startTimeScale - The start time scale.
   * @param {number} endTimeScale - The end time scale.
   * @param {number} duration - The duration.
   * @return {AnimationAction} A reference to this animation action.
   */
  warp(e, t, n) {
    const i = this._mixer, r = i.time, a = this.timeScale;
    let o = this._timeScaleInterpolant;
    o === null && (o = i._lendControlInterpolant(), this._timeScaleInterpolant = o);
    const l = o.parameterPositions, c = o.sampleValues;
    return l[0] = r, l[1] = r + n, c[0] = e / a, c[1] = t / a, this;
  }
  /**
   * Stops any scheduled warping which is applied to this action.
   *
   * @return {AnimationAction} A reference to this animation action.
   */
  stopWarping() {
    const e = this._timeScaleInterpolant;
    return e !== null && (this._timeScaleInterpolant = null, this._mixer._takeBackControlInterpolant(e)), this;
  }
  /**
   * Returns the animation mixer of this animation action.
   *
   * @return {AnimationMixer} The animation mixer.
   */
  getMixer() {
    return this._mixer;
  }
  /**
   * Returns the animation clip of this animation action.
   *
   * @return {AnimationClip} The animation clip.
   */
  getClip() {
    return this._clip;
  }
  /**
   * Returns the root object of this animation action.
   *
   * @return {Object3D} The root object.
   */
  getRoot() {
    return this._localRoot || this._mixer._root;
  }
  // Interna
  _update(e, t, n, i) {
    if (!this.enabled) {
      this._updateWeight(e);
      return;
    }
    const r = this._startTime;
    if (r !== null) {
      const l = (e - r) * n;
      l < 0 || n === 0 ? t = 0 : (this._startTime = null, t = n * l);
    }
    t *= this._updateTimeScale(e);
    const a = this._updateTime(t), o = this._updateWeight(e);
    if (o > 0) {
      const l = this._interpolants, c = this._propertyBindings;
      switch (this.blendMode) {
        case Zd:
          for (let u = 0, h = l.length; u !== h; ++u)
            l[u].evaluate(a), c[u].accumulateAdditive(o);
          break;
        case zl:
        default:
          for (let u = 0, h = l.length; u !== h; ++u)
            l[u].evaluate(a), c[u].accumulate(i, o);
      }
    }
  }
  _updateWeight(e) {
    let t = 0;
    if (this.enabled) {
      t = this.weight;
      const n = this._weightInterpolant;
      if (n !== null) {
        const i = n.evaluate(e)[0];
        t *= i, e > n.parameterPositions[1] && (this.stopFading(), i === 0 && (this.enabled = !1));
      }
    }
    return this._effectiveWeight = t, t;
  }
  _updateTimeScale(e) {
    let t = 0;
    if (!this.paused) {
      t = this.timeScale;
      const n = this._timeScaleInterpolant;
      if (n !== null) {
        const i = n.evaluate(e)[0];
        t *= i, e > n.parameterPositions[1] && (this.stopWarping(), t === 0 ? this.paused = !0 : this.timeScale = t);
      }
    }
    return this._effectiveTimeScale = t, t;
  }
  _updateTime(e) {
    const t = this._clip.duration, n = this.loop;
    let i = this.time + e, r = this._loopCount;
    const a = n === Kd;
    if (e === 0)
      return r === -1 ? i : a && (r & 1) === 1 ? t - i : i;
    if (n === Ph) {
      r === -1 && (this._loopCount = 0, this._setEndings(!0, !0, !1));
      e: {
        if (i >= t)
          i = t;
        else if (i < 0)
          i = 0;
        else {
          this.time = i;
          break e;
        }
        this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this.time = i, this._mixer.dispatchEvent({
          type: "finished",
          action: this,
          direction: e < 0 ? -1 : 1
        });
      }
    } else {
      if (r === -1 && (e >= 0 ? (r = 0, this._setEndings(!0, this.repetitions === 0, a)) : this._setEndings(this.repetitions === 0, !0, a)), i >= t || i < 0) {
        const o = Math.floor(i / t);
        i -= t * o, r += Math.abs(o);
        const l = this.repetitions - r;
        if (l <= 0)
          this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, i = e > 0 ? t : 0, this.time = i, this._mixer.dispatchEvent({
            type: "finished",
            action: this,
            direction: e > 0 ? 1 : -1
          });
        else {
          if (l === 1) {
            const c = e < 0;
            this._setEndings(c, !c, a);
          } else
            this._setEndings(!1, !1, a);
          this._loopCount = r, this.time = i, this._mixer.dispatchEvent({
            type: "loop",
            action: this,
            loopDelta: o
          });
        }
      } else
        this.time = i;
      if (a && (r & 1) === 1)
        return t - i;
    }
    return i;
  }
  _setEndings(e, t, n) {
    const i = this._interpolantSettings;
    n ? (i.endingStart = Ts, i.endingEnd = Ts) : (e ? i.endingStart = this.zeroSlopeAtStart ? Ts : Es : i.endingStart = ba, t ? i.endingEnd = this.zeroSlopeAtEnd ? Ts : Es : i.endingEnd = ba);
  }
  _scheduleFading(e, t, n) {
    const i = this._mixer, r = i.time;
    let a = this._weightInterpolant;
    a === null && (a = i._lendControlInterpolant(), this._weightInterpolant = a);
    const o = a.parameterPositions, l = a.sampleValues;
    return o[0] = r, l[0] = t, o[1] = r + e, l[1] = n, this;
  }
}
const Yp = new Float32Array(1);
class jp extends Ui {
  /**
   * Constructs a new animation mixer.
   *
   * @param {Object3D} root - The object whose animations shall be played by this mixer.
   */
  constructor(e) {
    super(), this._root = e, this._initMemoryManager(), this._accuIndex = 0, this.time = 0, this.timeScale = 1;
  }
  _bindAction(e, t) {
    const n = e._localRoot || this._root, i = e._clip.tracks, r = i.length, a = e._propertyBindings, o = e._interpolants, l = n.uuid, c = this._bindingsByRootAndName;
    let u = c[l];
    u === void 0 && (u = {}, c[l] = u);
    for (let h = 0; h !== r; ++h) {
      const d = i[h], f = d.name;
      let m = u[f];
      if (m !== void 0)
        ++m.referenceCount, a[h] = m;
      else {
        if (m = a[h], m !== void 0) {
          m._cacheIndex === null && (++m.referenceCount, this._addInactiveBinding(m, l, f));
          continue;
        }
        const _ = t && t._propertyBindings[h].binding.parsedPath;
        m = new Fp(
          gt.create(n, f, _),
          d.ValueTypeName,
          d.getValueSize()
        ), ++m.referenceCount, this._addInactiveBinding(m, l, f), a[h] = m;
      }
      o[h].resultBuffer = m.buffer;
    }
  }
  _activateAction(e) {
    if (!this._isActiveAction(e)) {
      if (e._cacheIndex === null) {
        const n = (e._localRoot || this._root).uuid, i = e._clip.uuid, r = this._actionsByClip[i];
        this._bindAction(
          e,
          r && r.knownActions[0]
        ), this._addInactiveAction(e, i, n);
      }
      const t = e._propertyBindings;
      for (let n = 0, i = t.length; n !== i; ++n) {
        const r = t[n];
        r.useCount++ === 0 && (this._lendBinding(r), r.saveOriginalState());
      }
      this._lendAction(e);
    }
  }
  _deactivateAction(e) {
    if (this._isActiveAction(e)) {
      const t = e._propertyBindings;
      for (let n = 0, i = t.length; n !== i; ++n) {
        const r = t[n];
        --r.useCount === 0 && (r.restoreOriginalState(), this._takeBackBinding(r));
      }
      this._takeBackAction(e);
    }
  }
  // Memory manager
  _initMemoryManager() {
    this._actions = [], this._nActiveActions = 0, this._actionsByClip = {}, this._bindings = [], this._nActiveBindings = 0, this._bindingsByRootAndName = {}, this._controlInterpolants = [], this._nActiveControlInterpolants = 0;
    const e = this;
    this.stats = {
      actions: {
        get total() {
          return e._actions.length;
        },
        get inUse() {
          return e._nActiveActions;
        }
      },
      bindings: {
        get total() {
          return e._bindings.length;
        },
        get inUse() {
          return e._nActiveBindings;
        }
      },
      controlInterpolants: {
        get total() {
          return e._controlInterpolants.length;
        },
        get inUse() {
          return e._nActiveControlInterpolants;
        }
      }
    };
  }
  // Memory management for AnimationAction objects
  _isActiveAction(e) {
    const t = e._cacheIndex;
    return t !== null && t < this._nActiveActions;
  }
  _addInactiveAction(e, t, n) {
    const i = this._actions, r = this._actionsByClip;
    let a = r[t];
    if (a === void 0)
      a = {
        knownActions: [e],
        actionByRoot: {}
      }, e._byClipCacheIndex = 0, r[t] = a;
    else {
      const o = a.knownActions;
      e._byClipCacheIndex = o.length, o.push(e);
    }
    e._cacheIndex = i.length, i.push(e), a.actionByRoot[n] = e;
  }
  _removeInactiveAction(e) {
    const t = this._actions, n = t[t.length - 1], i = e._cacheIndex;
    n._cacheIndex = i, t[i] = n, t.pop(), e._cacheIndex = null;
    const r = e._clip.uuid, a = this._actionsByClip, o = a[r], l = o.knownActions, c = l[l.length - 1], u = e._byClipCacheIndex;
    c._byClipCacheIndex = u, l[u] = c, l.pop(), e._byClipCacheIndex = null;
    const h = o.actionByRoot, d = (e._localRoot || this._root).uuid;
    delete h[d], l.length === 0 && delete a[r], this._removeInactiveBindingsForAction(e);
  }
  _removeInactiveBindingsForAction(e) {
    const t = e._propertyBindings;
    for (let n = 0, i = t.length; n !== i; ++n) {
      const r = t[n];
      --r.referenceCount === 0 && this._removeInactiveBinding(r);
    }
  }
  _lendAction(e) {
    const t = this._actions, n = e._cacheIndex, i = this._nActiveActions++, r = t[i];
    e._cacheIndex = i, t[i] = e, r._cacheIndex = n, t[n] = r;
  }
  _takeBackAction(e) {
    const t = this._actions, n = e._cacheIndex, i = --this._nActiveActions, r = t[i];
    e._cacheIndex = i, t[i] = e, r._cacheIndex = n, t[n] = r;
  }
  // Memory management for PropertyMixer objects
  _addInactiveBinding(e, t, n) {
    const i = this._bindingsByRootAndName, r = this._bindings;
    let a = i[t];
    a === void 0 && (a = {}, i[t] = a), a[n] = e, e._cacheIndex = r.length, r.push(e);
  }
  _removeInactiveBinding(e) {
    const t = this._bindings, n = e.binding, i = n.rootNode.uuid, r = n.path, a = this._bindingsByRootAndName, o = a[i], l = t[t.length - 1], c = e._cacheIndex;
    l._cacheIndex = c, t[c] = l, t.pop(), delete o[r], Object.keys(o).length === 0 && delete a[i];
  }
  _lendBinding(e) {
    const t = this._bindings, n = e._cacheIndex, i = this._nActiveBindings++, r = t[i];
    e._cacheIndex = i, t[i] = e, r._cacheIndex = n, t[n] = r;
  }
  _takeBackBinding(e) {
    const t = this._bindings, n = e._cacheIndex, i = --this._nActiveBindings, r = t[i];
    e._cacheIndex = i, t[i] = e, r._cacheIndex = n, t[n] = r;
  }
  // Memory management of Interpolants for weight and time scale
  _lendControlInterpolant() {
    const e = this._controlInterpolants, t = this._nActiveControlInterpolants++;
    let n = e[t];
    return n === void 0 && (n = new jh(
      new Float32Array(2),
      new Float32Array(2),
      1,
      Yp
    ), n.__cacheIndex = t, e[t] = n), n;
  }
  _takeBackControlInterpolant(e) {
    const t = this._controlInterpolants, n = e.__cacheIndex, i = --this._nActiveControlInterpolants, r = t[i];
    e.__cacheIndex = i, t[i] = e, r.__cacheIndex = n, t[n] = r;
  }
  /**
   * Returns an instance of {@link AnimationAction} for the passed clip.
   *
   * If an action fitting the clip and root parameters doesn't yet exist, it
   * will be created by this method. Calling this method several times with the
   * same clip and root parameters always returns the same action.
   *
   * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
   * @param {Object3D} [optionalRoot] - An alternative root object.
   * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
   * @return {?AnimationAction} The animation action.
   */
  clipAction(e, t, n) {
    const i = t || this._root, r = i.uuid;
    let a = typeof e == "string" ? Ra.findByName(i, e) : e;
    const o = a !== null ? a.uuid : e, l = this._actionsByClip[o];
    let c = null;
    if (n === void 0 && (a !== null ? n = a.blendMode : n = zl), l !== void 0) {
      const h = l.actionByRoot[r];
      if (h !== void 0 && h.blendMode === n)
        return h;
      c = l.knownActions[0], a === null && (a = c._clip);
    }
    if (a === null) return null;
    const u = new qp(this, a, t, n);
    return this._bindAction(u, c), this._addInactiveAction(u, o, r), u;
  }
  /**
   * Returns an existing animation action for the passed clip.
   *
   * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
   * @param {Object3D} [optionalRoot] - An alternative root object.
   * @return {?AnimationAction} The animation action. Returns `null` if no action was found.
   */
  existingAction(e, t) {
    const n = t || this._root, i = n.uuid, r = typeof e == "string" ? Ra.findByName(n, e) : e, a = r ? r.uuid : e, o = this._actionsByClip[a];
    return o !== void 0 && o.actionByRoot[i] || null;
  }
  /**
   * Deactivates all previously scheduled actions on this mixer.
   *
   * @return {AnimationMixer} A reference to thi animation mixer.
   */
  stopAllAction() {
    const e = this._actions, t = this._nActiveActions;
    for (let n = t - 1; n >= 0; --n)
      e[n].stop();
    return this;
  }
  /**
   * Advances the global mixer time and updates the animation.
   *
   * This is usually done in the render loop by passing the delta
   * time from {@link Clock} or {@link Timer}.
   *
   * @param {number} deltaTime - The delta time in seconds.
   * @return {AnimationMixer} A reference to thi animation mixer.
   */
  update(e) {
    e *= this.timeScale;
    const t = this._actions, n = this._nActiveActions, i = this.time += e, r = Math.sign(e), a = this._accuIndex ^= 1;
    for (let c = 0; c !== n; ++c)
      t[c]._update(i, e, r, a);
    const o = this._bindings, l = this._nActiveBindings;
    for (let c = 0; c !== l; ++c)
      o[c].apply(a);
    return this;
  }
  /**
   * Sets the global mixer to a specific time and updates the animation accordingly.
   *
   * This is useful when you need to jump to an exact time in an animation. The
   * input parameter will be scaled by {@link AnimationMixer#timeScale}
   *
   * @param {number} time - The time to set in seconds.
   * @return {AnimationMixer} A reference to thi animation mixer.
   */
  setTime(e) {
    this.time = 0;
    for (let t = 0; t < this._actions.length; t++)
      this._actions[t].time = 0;
    return this.update(e);
  }
  /**
   * Returns this mixer's root object.
   *
   * @return {Object3D} The mixer's root object.
   */
  getRoot() {
    return this._root;
  }
  /**
   * Deallocates all memory resources for a clip. Before using this method make
   * sure to call {@link AnimationAction#stop} for all related actions.
   *
   * @param {AnimationClip} clip - The clip to uncache.
   */
  uncacheClip(e) {
    const t = this._actions, n = e.uuid, i = this._actionsByClip, r = i[n];
    if (r !== void 0) {
      const a = r.knownActions;
      for (let o = 0, l = a.length; o !== l; ++o) {
        const c = a[o];
        this._deactivateAction(c);
        const u = c._cacheIndex, h = t[t.length - 1];
        c._cacheIndex = null, c._byClipCacheIndex = null, h._cacheIndex = u, t[u] = h, t.pop(), this._removeInactiveBindingsForAction(c);
      }
      delete i[n];
    }
  }
  /**
   * Deallocates all memory resources for a root object. Before using this
   * method make sure to call {@link AnimationAction#stop} for all related
   * actions or alternatively {@link AnimationMixer#stopAllAction} when the
   * mixer operates on a single root.
   *
   * @param {Object3D} root - The root object to uncache.
   */
  uncacheRoot(e) {
    const t = e.uuid, n = this._actionsByClip;
    for (const a in n) {
      const o = n[a].actionByRoot, l = o[t];
      l !== void 0 && (this._deactivateAction(l), this._removeInactiveAction(l));
    }
    const i = this._bindingsByRootAndName, r = i[t];
    if (r !== void 0)
      for (const a in r) {
        const o = r[a];
        o.restoreOriginalState(), this._removeInactiveBinding(o);
      }
  }
  /**
   * Deallocates all memory resources for an action. The action is identified by the
   * given clip and an optional root object. Before using this method make
   * sure to call {@link AnimationAction#stop} to deactivate the action.
   *
   * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
   * @param {Object3D} [optionalRoot] - An alternative root object.
   */
  uncacheAction(e, t) {
    const n = this.existingAction(e, t);
    n !== null && (this._deactivateAction(n), this._removeInactiveAction(n));
  }
}
class bl extends Gh {
  /**
   * Constructs a new instanced interleaved buffer.
   *
   * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
   * @param {number} stride - The number of typed-array elements per vertex.
   * @param {number} [meshPerAttribute=1] - Defines how often a value of this interleaved buffer should be repeated.
   */
  constructor(e, t, n = 1) {
    super(e, t), this.isInstancedInterleavedBuffer = !0, this.meshPerAttribute = n;
  }
  copy(e) {
    return super.copy(e), this.meshPerAttribute = e.meshPerAttribute, this;
  }
  clone(e) {
    const t = super.clone(e);
    return t.meshPerAttribute = this.meshPerAttribute, t;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.isInstancedInterleavedBuffer = !0, t.meshPerAttribute = this.meshPerAttribute, t;
  }
}
class Tr {
  /**
   * Constructs a new spherical.
   *
   * @param {number} [radius=1] - The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
   * @param {number} [phi=0] - The polar angle in radians from the y (up) axis.
   * @param {number} [theta=0] - The equator/azimuthal angle in radians around the y (up) axis.
   */
  constructor(e = 1, t = 0, n = 0) {
    this.radius = e, this.phi = t, this.theta = n;
  }
  /**
   * Sets the spherical components by copying the given values.
   *
   * @param {number} radius - The radius.
   * @param {number} phi - The polar angle.
   * @param {number} theta - The azimuthal angle.
   * @return {Spherical} A reference to this spherical.
   */
  set(e, t, n) {
    return this.radius = e, this.phi = t, this.theta = n, this;
  }
  /**
   * Copies the values of the given spherical to this instance.
   *
   * @param {Spherical} other - The spherical to copy.
   * @return {Spherical} A reference to this spherical.
   */
  copy(e) {
    return this.radius = e.radius, this.phi = e.phi, this.theta = e.theta, this;
  }
  /**
   * Restricts the polar angle [page:.phi phi] to be between `0.000001` and pi -
   * `0.000001`.
   *
   * @return {Spherical} A reference to this spherical.
   */
  makeSafe() {
    return this.phi = Ze(this.phi, 1e-6, Math.PI - 1e-6), this;
  }
  /**
   * Sets the spherical components from the given vector which is assumed to hold
   * Cartesian coordinates.
   *
   * @param {Vector3} v - The vector to set.
   * @return {Spherical} A reference to this spherical.
   */
  setFromVector3(e) {
    return this.setFromCartesianCoords(e.x, e.y, e.z);
  }
  /**
   * Sets the spherical components from the given Cartesian coordinates.
   *
   * @param {number} x - The x value.
   * @param {number} y - The x value.
   * @param {number} z - The x value.
   * @return {Spherical} A reference to this spherical.
   */
  setFromCartesianCoords(e, t, n) {
    return this.radius = Math.sqrt(e * e + t * t + n * n), this.radius === 0 ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(e, n), this.phi = Math.acos(Ze(t / this.radius, -1, 1))), this;
  }
  /**
   * Returns a new spherical with copied values from this instance.
   *
   * @return {Spherical} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
const du = /* @__PURE__ */ new T(), na = /* @__PURE__ */ new T();
class Kp {
  /**
   * Constructs a new line segment.
   *
   * @param {Vector3} [start=(0,0,0)] - Start of the line segment.
   * @param {Vector3} [end=(0,0,0)] - End of the line segment.
   */
  constructor(e = new T(), t = new T()) {
    this.start = e, this.end = t;
  }
  /**
   * Sets the start and end values by copying the given vectors.
   *
   * @param {Vector3} start - The start point.
   * @param {Vector3} end - The end point.
   * @return {Line3} A reference to this line segment.
   */
  set(e, t) {
    return this.start.copy(e), this.end.copy(t), this;
  }
  /**
   * Copies the values of the given line segment to this instance.
   *
   * @param {Line3} line - The line segment to copy.
   * @return {Line3} A reference to this line segment.
   */
  copy(e) {
    return this.start.copy(e.start), this.end.copy(e.end), this;
  }
  /**
   * Returns the center of the line segment.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The center point.
   */
  getCenter(e) {
    return e.addVectors(this.start, this.end).multiplyScalar(0.5);
  }
  /**
   * Returns the delta vector of the line segment's start and end point.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The delta vector.
   */
  delta(e) {
    return e.subVectors(this.end, this.start);
  }
  /**
   * Returns the squared Euclidean distance between the line' start and end point.
   *
   * @return {number} The squared Euclidean distance.
   */
  distanceSq() {
    return this.start.distanceToSquared(this.end);
  }
  /**
   * Returns the Euclidean distance between the line' start and end point.
   *
   * @return {number} The Euclidean distance.
   */
  distance() {
    return this.start.distanceTo(this.end);
  }
  /**
   * Returns a vector at a certain position along the line segment.
   *
   * @param {number} t - A value between `[0,1]` to represent a position along the line segment.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The delta vector.
   */
  at(e, t) {
    return this.delta(t).multiplyScalar(e).add(this.start);
  }
  /**
   * Returns a point parameter based on the closest point as projected on the line segment.
   *
   * @param {Vector3} point - The point for which to return a point parameter.
   * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
   * @return {number} The point parameter.
   */
  closestPointToPointParameter(e, t) {
    du.subVectors(e, this.start), na.subVectors(this.end, this.start);
    const n = na.dot(na);
    let r = na.dot(du) / n;
    return t && (r = Ze(r, 0, 1)), r;
  }
  /**
   * Returns the closets point on the line for a given point.
   *
   * @param {Vector3} point - The point to compute the closest point on the line for.
   * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
   * @param {Vector3} target -  The target vector that is used to store the method's result.
   * @return {Vector3} The closest point on the line.
   */
  closestPointToPoint(e, t, n) {
    const i = this.closestPointToPointParameter(e, t);
    return this.delta(n).multiplyScalar(i).add(this.start);
  }
  /**
   * Applies a 4x4 transformation matrix to this line segment.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @return {Line3} A reference to this line segment.
   */
  applyMatrix4(e) {
    return this.start.applyMatrix4(e), this.end.applyMatrix4(e), this;
  }
  /**
   * Returns `true` if this line segment is equal with the given one.
   *
   * @param {Line3} line - The line segment to test for equality.
   * @return {boolean} Whether this line segment is equal with the given one.
   */
  equals(e) {
    return e.start.equals(this.start) && e.end.equals(this.end);
  }
  /**
   * Returns a new line segment with copied values from this instance.
   *
   * @return {Line3} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
class Zp extends Ui {
  /**
   * Constructs a new controls instance.
   *
   * @param {Object3D} object - The object that is managed by the controls.
   * @param {?HTMLDOMElement} domElement - The HTML element used for event listeners.
   */
  constructor(e, t = null) {
    super(), this.object = e, this.domElement = t, this.enabled = !0, this.state = -1, this.keys = {}, this.mouseButtons = { LEFT: null, MIDDLE: null, RIGHT: null }, this.touches = { ONE: null, TWO: null };
  }
  /**
   * Connects the controls to the DOM. This method has so called "side effects" since
   * it adds the module's event listeners to the DOM.
   *
   * @param {HTMLDOMElement} element - The DOM element to connect to.
   */
  connect(e) {
    if (e === void 0) {
      console.warn("THREE.Controls: connect() now requires an element.");
      return;
    }
    this.domElement !== null && this.disconnect(), this.domElement = e;
  }
  /**
   * Disconnects the controls from the DOM.
   */
  disconnect() {
  }
  /**
   * Call this method if you no longer want use to the controls. It frees all internal
   * resources and removes all event listeners.
   */
  dispose() {
  }
  /**
   * Controls should implement this method if they have to update their internal state
   * per simulation step.
   *
   * @param {number} [delta] - The time delta in seconds.
   */
  update() {
  }
}
function fu(s, e, t, n) {
  const i = $p(n);
  switch (t) {
    // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
    case Eh:
      return s * e;
    case Ah:
      return s * e;
    case wh:
      return s * e * 2;
    case Fl:
      return s * e / i.components * i.byteLength;
    case Ol:
      return s * e / i.components * i.byteLength;
    case Rh:
      return s * e * 2 / i.components * i.byteLength;
    case Bl:
      return s * e * 2 / i.components * i.byteLength;
    case Th:
      return s * e * 3 / i.components * i.byteLength;
    case mn:
      return s * e * 4 / i.components * i.byteLength;
    case kl:
      return s * e * 4 / i.components * i.byteLength;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
    case fa:
    case pa:
      return Math.floor((s + 3) / 4) * Math.floor((e + 3) / 4) * 8;
    case ma:
    case ga:
      return Math.floor((s + 3) / 4) * Math.floor((e + 3) / 4) * 16;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
    case Yo:
    case Ko:
      return Math.max(s, 16) * Math.max(e, 8) / 4;
    case qo:
    case jo:
      return Math.max(s, 8) * Math.max(e, 8) / 2;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
    case Zo:
    case $o:
      return Math.floor((s + 3) / 4) * Math.floor((e + 3) / 4) * 8;
    case Jo:
      return Math.floor((s + 3) / 4) * Math.floor((e + 3) / 4) * 16;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
    case Qo:
      return Math.floor((s + 3) / 4) * Math.floor((e + 3) / 4) * 16;
    case el:
      return Math.floor((s + 4) / 5) * Math.floor((e + 3) / 4) * 16;
    case tl:
      return Math.floor((s + 4) / 5) * Math.floor((e + 4) / 5) * 16;
    case nl:
      return Math.floor((s + 5) / 6) * Math.floor((e + 4) / 5) * 16;
    case il:
      return Math.floor((s + 5) / 6) * Math.floor((e + 5) / 6) * 16;
    case sl:
      return Math.floor((s + 7) / 8) * Math.floor((e + 4) / 5) * 16;
    case rl:
      return Math.floor((s + 7) / 8) * Math.floor((e + 5) / 6) * 16;
    case al:
      return Math.floor((s + 7) / 8) * Math.floor((e + 7) / 8) * 16;
    case ol:
      return Math.floor((s + 9) / 10) * Math.floor((e + 4) / 5) * 16;
    case ll:
      return Math.floor((s + 9) / 10) * Math.floor((e + 5) / 6) * 16;
    case cl:
      return Math.floor((s + 9) / 10) * Math.floor((e + 7) / 8) * 16;
    case ul:
      return Math.floor((s + 9) / 10) * Math.floor((e + 9) / 10) * 16;
    case hl:
      return Math.floor((s + 11) / 12) * Math.floor((e + 9) / 10) * 16;
    case dl:
      return Math.floor((s + 11) / 12) * Math.floor((e + 11) / 12) * 16;
    // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
    case _a:
    case fl:
    case pl:
      return Math.ceil(s / 4) * Math.ceil(e / 4) * 16;
    // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
    case Ch:
    case ml:
      return Math.ceil(s / 4) * Math.ceil(e / 4) * 8;
    case gl:
    case _l:
      return Math.ceil(s / 4) * Math.ceil(e / 4) * 16;
  }
  throw new Error(
    `Unable to determine texture byte length for ${t} format.`
  );
}
function $p(s) {
  switch (s) {
    case _i:
    case Sh:
      return { byteLength: 1, components: 1 };
    case _r:
    case Mh:
    case Wn:
      return { byteLength: 2, components: 1 };
    case Nl:
    case Ul:
      return { byteLength: 2, components: 4 };
    case Ii:
    case Dl:
    case hn:
      return { byteLength: 4, components: 1 };
    case bh:
      return { byteLength: 4, components: 3 };
  }
  throw new Error(`Unknown texture type ${s}.`);
}
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
  revision: "175"
} }));
typeof window < "u" && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = "175");
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
function $h() {
  let s = null, e = !1, t = null, n = null;
  function i(r, a) {
    t(r, a), n = s.requestAnimationFrame(i);
  }
  return {
    start: function() {
      e !== !0 && t !== null && (n = s.requestAnimationFrame(i), e = !0);
    },
    stop: function() {
      s.cancelAnimationFrame(n), e = !1;
    },
    setAnimationLoop: function(r) {
      t = r;
    },
    setContext: function(r) {
      s = r;
    }
  };
}
function Jp(s) {
  const e = /* @__PURE__ */ new WeakMap();
  function t(o, l) {
    const c = o.array, u = o.usage, h = c.byteLength, d = s.createBuffer();
    s.bindBuffer(l, d), s.bufferData(l, c, u), o.onUploadCallback();
    let f;
    if (c instanceof Float32Array)
      f = s.FLOAT;
    else if (c instanceof Uint16Array)
      o.isFloat16BufferAttribute ? f = s.HALF_FLOAT : f = s.UNSIGNED_SHORT;
    else if (c instanceof Int16Array)
      f = s.SHORT;
    else if (c instanceof Uint32Array)
      f = s.UNSIGNED_INT;
    else if (c instanceof Int32Array)
      f = s.INT;
    else if (c instanceof Int8Array)
      f = s.BYTE;
    else if (c instanceof Uint8Array)
      f = s.UNSIGNED_BYTE;
    else if (c instanceof Uint8ClampedArray)
      f = s.UNSIGNED_BYTE;
    else
      throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + c);
    return {
      buffer: d,
      type: f,
      bytesPerElement: c.BYTES_PER_ELEMENT,
      version: o.version,
      size: h
    };
  }
  function n(o, l, c) {
    const u = l.array, h = l.updateRanges;
    if (s.bindBuffer(c, o), h.length === 0)
      s.bufferSubData(c, 0, u);
    else {
      h.sort((f, m) => f.start - m.start);
      let d = 0;
      for (let f = 1; f < h.length; f++) {
        const m = h[d], _ = h[f];
        _.start <= m.start + m.count + 1 ? m.count = Math.max(
          m.count,
          _.start + _.count - m.start
        ) : (++d, h[d] = _);
      }
      h.length = d + 1;
      for (let f = 0, m = h.length; f < m; f++) {
        const _ = h[f];
        s.bufferSubData(
          c,
          _.start * u.BYTES_PER_ELEMENT,
          u,
          _.start,
          _.count
        );
      }
      l.clearUpdateRanges();
    }
    l.onUploadCallback();
  }
  function i(o) {
    return o.isInterleavedBufferAttribute && (o = o.data), e.get(o);
  }
  function r(o) {
    o.isInterleavedBufferAttribute && (o = o.data);
    const l = e.get(o);
    l && (s.deleteBuffer(l.buffer), e.delete(o));
  }
  function a(o, l) {
    if (o.isInterleavedBufferAttribute && (o = o.data), o.isGLBufferAttribute) {
      const u = e.get(o);
      (!u || u.version < o.version) && e.set(o, {
        buffer: o.buffer,
        type: o.type,
        bytesPerElement: o.elementSize,
        version: o.version
      });
      return;
    }
    const c = e.get(o);
    if (c === void 0)
      e.set(o, t(o, l));
    else if (c.version < o.version) {
      if (c.size !== o.array.byteLength)
        throw new Error("THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.");
      n(c.buffer, o, l), c.version = o.version;
    }
  }
  return {
    get: i,
    remove: r,
    update: a
  };
}
var Qp = `#ifdef USE_ALPHAHASH
	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;
#endif`, em = `#ifdef USE_ALPHAHASH
	const float ALPHA_HASH_SCALE = 0.05;
	float hash2D( vec2 value ) {
		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );
	}
	float hash3D( vec3 value ) {
		return hash2D( vec2( hash2D( value.xy ), value.z ) );
	}
	float getAlphaHashThreshold( vec3 position ) {
		float maxDeriv = max(
			length( dFdx( position.xyz ) ),
			length( dFdy( position.xyz ) )
		);
		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );
		vec2 pixScales = vec2(
			exp2( floor( log2( pixScale ) ) ),
			exp2( ceil( log2( pixScale ) ) )
		);
		vec2 alpha = vec2(
			hash3D( floor( pixScales.x * position.xyz ) ),
			hash3D( floor( pixScales.y * position.xyz ) )
		);
		float lerpFactor = fract( log2( pixScale ) );
		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;
		float a = min( lerpFactor, 1.0 - lerpFactor );
		vec3 cases = vec3(
			x * x / ( 2.0 * a * ( 1.0 - a ) ),
			( x - 0.5 * a ) / ( 1.0 - a ),
			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )
		);
		float threshold = ( x < ( 1.0 - a ) )
			? ( ( x < a ) ? cases.x : cases.y )
			: cases.z;
		return clamp( threshold , 1.0e-6, 1.0 );
	}
#endif`, tm = `#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;
#endif`, nm = `#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, im = `#ifdef USE_ALPHATEST
	#ifdef ALPHA_TO_COVERAGE
	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );
	if ( diffuseColor.a == 0.0 ) discard;
	#else
	if ( diffuseColor.a < alphaTest ) discard;
	#endif
#endif`, sm = `#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif`, rm = `#ifdef USE_AOMAP
	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_CLEARCOAT ) 
		clearcoatSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_SHEEN ) 
		sheenSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );
	#endif
#endif`, am = `#ifdef USE_AOMAP
	uniform sampler2D aoMap;
	uniform float aoMapIntensity;
#endif`, om = `#ifdef USE_BATCHING
	#if ! defined( GL_ANGLE_multi_draw )
	#define gl_DrawID _gl_DrawID
	uniform int _gl_DrawID;
	#endif
	uniform highp sampler2D batchingTexture;
	uniform highp usampler2D batchingIdTexture;
	mat4 getBatchingMatrix( const in float i ) {
		int size = textureSize( batchingTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
	float getIndirectIndex( const in int i ) {
		int size = textureSize( batchingIdTexture, 0 ).x;
		int x = i % size;
		int y = i / size;
		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );
	}
#endif
#ifdef USE_BATCHING_COLOR
	uniform sampler2D batchingColorTexture;
	vec3 getBatchingColor( const in float i ) {
		int size = textureSize( batchingColorTexture, 0 ).x;
		int j = int( i );
		int x = j % size;
		int y = j / size;
		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;
	}
#endif`, lm = `#ifdef USE_BATCHING
	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );
#endif`, cm = `vec3 transformed = vec3( position );
#ifdef USE_ALPHAHASH
	vPosition = vec3( position );
#endif`, um = `vec3 objectNormal = vec3( normal );
#ifdef USE_TANGENT
	vec3 objectTangent = vec3( tangent.xyz );
#endif`, hm = `float G_BlinnPhong_Implicit( ) {
	return 0.25;
}
float D_BlinnPhong( const in float shininess, const in float dotNH ) {
	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );
}
vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( specularColor, 1.0, dotVH );
	float G = G_BlinnPhong_Implicit( );
	float D = D_BlinnPhong( shininess, dotNH );
	return F * ( G * D );
} // validated`, dm = `#ifdef USE_IRIDESCENCE
	const mat3 XYZ_TO_REC709 = mat3(
		 3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);
	vec3 Fresnel0ToIor( vec3 fresnel0 ) {
		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );
	}
	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );
	}
	float IorToFresnel0( float transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));
	}
	vec3 evalSensitivity( float OPD, vec3 shift ) {
		float phase = 2.0 * PI * OPD * 1.0e-9;
		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );
		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );
		xyz /= 1.0685e-7;
		vec3 rgb = XYZ_TO_REC709 * xyz;
		return rgb;
	}
	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {
		vec3 I;
		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {
			return vec3( 1.0 );
		}
		float cosTheta2 = sqrt( cosTheta2Sq );
		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
		float R12 = F_Schlick( R0, 1.0, cosTheta1 );
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIOR < outsideIOR ) phi12 = PI;
		float phi21 = PI - phi12;
		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;
		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;
		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;
		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );
		vec3 C0 = R12 + Rs;
		I = C0;
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {
			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;
		}
		return max( I, vec3( 0.0 ) );
	}
#endif`, fm = `#ifdef USE_BUMPMAP
	uniform sampler2D bumpMap;
	uniform float bumpScale;
	vec2 dHdxy_fwd() {
		vec2 dSTdx = dFdx( vBumpMapUv );
		vec2 dSTdy = dFdy( vBumpMapUv );
		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;
		return vec2( dBx, dBy );
	}
	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );
		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );
		vec3 vN = surf_norm;
		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );
		float fDet = dot( vSigmaX, R1 ) * faceDirection;
		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );
	}
#endif`, pm = `#if NUM_CLIPPING_PLANES > 0
	vec4 plane;
	#ifdef ALPHA_TO_COVERAGE
		float distanceToPlane, distanceGradient;
		float clipOpacity = 1.0;
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
			distanceGradient = fwidth( distanceToPlane ) / 2.0;
			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			if ( clipOpacity == 0.0 ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			float unionClipOpacity = 1.0;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
				distanceGradient = fwidth( distanceToPlane ) / 2.0;
				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			}
			#pragma unroll_loop_end
			clipOpacity *= 1.0 - unionClipOpacity;
		#endif
		diffuseColor.a *= clipOpacity;
		if ( diffuseColor.a == 0.0 ) discard;
	#else
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			bool clipped = true;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;
			}
			#pragma unroll_loop_end
			if ( clipped ) discard;
		#endif
	#endif
#endif`, mm = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];
#endif`, gm = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
#endif`, _m = `#if NUM_CLIPPING_PLANES > 0
	vClipPosition = - mvPosition.xyz;
#endif`, xm = `#if defined( USE_COLOR_ALPHA )
	diffuseColor *= vColor;
#elif defined( USE_COLOR )
	diffuseColor.rgb *= vColor;
#endif`, vm = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR )
	varying vec3 vColor;
#endif`, ym = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	varying vec3 vColor;
#endif`, Sm = `#if defined( USE_COLOR_ALPHA )
	vColor = vec4( 1.0 );
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	vColor = vec3( 1.0 );
#endif
#ifdef USE_COLOR
	vColor *= color;
#endif
#ifdef USE_INSTANCING_COLOR
	vColor.xyz *= instanceColor.xyz;
#endif
#ifdef USE_BATCHING_COLOR
	vec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );
	vColor.xyz *= batchingColor.xyz;
#endif`, Mm = `#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6
#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )
float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }
highp float rand( const in vec2 uv ) {
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );
	return fract( sin( sn ) * c );
}
#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif
struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};
struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};
#ifdef USE_ALPHAHASH
	varying vec3 vPosition;
#endif
vec3 transformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );
}
vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );
}
mat3 transposeMat3( const in mat3 m ) {
	mat3 tmp;
	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );
	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );
	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );
	return tmp;
}
bool isPerspectiveMatrix( mat4 m ) {
	return m[ 2 ][ 3 ] == - 1.0;
}
vec2 equirectUv( in vec3 dir ) {
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}
vec3 BRDF_Lambert( const in vec3 diffuseColor ) {
	return RECIPROCAL_PI * diffuseColor;
}
vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
} // validated`, bm = `#ifdef ENVMAP_TYPE_CUBE_UV
	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0
	float getFace( vec3 direction ) {
		vec3 absDirection = abs( direction );
		float face = - 1.0;
		if ( absDirection.x > absDirection.z ) {
			if ( absDirection.x > absDirection.y )
				face = direction.x > 0.0 ? 0.0 : 3.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		} else {
			if ( absDirection.z > absDirection.y )
				face = direction.z > 0.0 ? 2.0 : 5.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		}
		return face;
	}
	vec2 getUV( vec3 direction, float face ) {
		vec2 uv;
		if ( face == 0.0 ) {
			uv = vec2( direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 1.0 ) {
			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );
		} else if ( face == 2.0 ) {
			uv = vec2( - direction.x, direction.y ) / abs( direction.z );
		} else if ( face == 3.0 ) {
			uv = vec2( - direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 4.0 ) {
			uv = vec2( - direction.x, direction.z ) / abs( direction.y );
		} else {
			uv = vec2( direction.x, direction.y ) / abs( direction.z );
		}
		return 0.5 * ( uv + 1.0 );
	}
	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {
		float face = getFace( direction );
		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );
		mipInt = max( mipInt, cubeUV_minMipLevel );
		float faceSize = exp2( mipInt );
		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;
		if ( face > 2.0 ) {
			uv.y += faceSize;
			face -= 3.0;
		}
		uv.x += face * faceSize;
		uv.x += filterInt * 3.0 * cubeUV_minTileSize;
		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );
		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;
		#ifdef texture2DGradEXT
			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;
		#else
			return texture2D( envMap, uv ).rgb;
		#endif
	}
	#define cubeUV_r0 1.0
	#define cubeUV_m0 - 2.0
	#define cubeUV_r1 0.8
	#define cubeUV_m1 - 1.0
	#define cubeUV_r4 0.4
	#define cubeUV_m4 2.0
	#define cubeUV_r5 0.305
	#define cubeUV_m5 3.0
	#define cubeUV_r6 0.21
	#define cubeUV_m6 4.0
	float roughnessToMip( float roughness ) {
		float mip = 0.0;
		if ( roughness >= cubeUV_r1 ) {
			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;
		} else if ( roughness >= cubeUV_r4 ) {
			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;
		} else if ( roughness >= cubeUV_r5 ) {
			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;
		} else if ( roughness >= cubeUV_r6 ) {
			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;
		} else {
			mip = - 2.0 * log2( 1.16 * roughness );		}
		return mip;
	}
	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {
		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );
		float mipF = fract( mip );
		float mipInt = floor( mip );
		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );
		if ( mipF == 0.0 ) {
			return vec4( color0, 1.0 );
		} else {
			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );
			return vec4( mix( color0, color1, mipF ), 1.0 );
		}
	}
#endif`, Em = `vec3 transformedNormal = objectNormal;
#ifdef USE_TANGENT
	vec3 transformedTangent = objectTangent;
#endif
#ifdef USE_BATCHING
	mat3 bm = mat3( batchingMatrix );
	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );
	transformedNormal = bm * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = bm * transformedTangent;
	#endif
#endif
#ifdef USE_INSTANCING
	mat3 im = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );
	transformedNormal = im * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = im * transformedTangent;
	#endif
#endif
transformedNormal = normalMatrix * transformedNormal;
#ifdef FLIP_SIDED
	transformedNormal = - transformedNormal;
#endif
#ifdef USE_TANGENT
	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;
	#ifdef FLIP_SIDED
		transformedTangent = - transformedTangent;
	#endif
#endif`, Tm = `#ifdef USE_DISPLACEMENTMAP
	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;
#endif`, Am = `#ifdef USE_DISPLACEMENTMAP
	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );
#endif`, wm = `#ifdef USE_EMISSIVEMAP
	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );
	#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE
		emissiveColor = sRGBTransferEOTF( emissiveColor );
	#endif
	totalEmissiveRadiance *= emissiveColor.rgb;
#endif`, Rm = `#ifdef USE_EMISSIVEMAP
	uniform sampler2D emissiveMap;
#endif`, Cm = "gl_FragColor = linearToOutputTexel( gl_FragColor );", Pm = `vec4 LinearTransferOETF( in vec4 value ) {
	return value;
}
vec4 sRGBTransferEOTF( in vec4 value ) {
	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );
}
vec4 sRGBTransferOETF( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}`, Lm = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vec3 cameraToFrag;
		if ( isOrthographic ) {
			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToFrag = normalize( vWorldPosition - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vec3 reflectVec = reflect( cameraToFrag, worldNormal );
		#else
			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );
		#endif
	#else
		vec3 reflectVec = vReflect;
	#endif
	#ifdef ENVMAP_TYPE_CUBE
		vec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );
	#else
		vec4 envColor = vec4( 0.0 );
	#endif
	#ifdef ENVMAP_BLENDING_MULTIPLY
		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_MIX )
		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_ADD )
		outgoingLight += envColor.xyz * specularStrength * reflectivity;
	#endif
#endif`, Im = `#ifdef USE_ENVMAP
	uniform float envMapIntensity;
	uniform float flipEnvMap;
	uniform mat3 envMapRotation;
	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
	
#endif`, Dm = `#ifdef USE_ENVMAP
	uniform float reflectivity;
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif
#endif`, Nm = `#ifdef USE_ENVMAP
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;
	#else
		varying vec3 vReflect;
		uniform float refractionRatio;
	#endif
#endif`, Um = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vWorldPosition = worldPosition.xyz;
	#else
		vec3 cameraToVertex;
		if ( isOrthographic ) {
			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vReflect = reflect( cameraToVertex, worldNormal );
		#else
			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );
		#endif
	#endif
#endif`, Fm = `#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
#endif`, Om = `#ifdef USE_FOG
	varying float vFogDepth;
#endif`, Bm = `#ifdef USE_FOG
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif`, km = `#ifdef USE_FOG
	uniform vec3 fogColor;
	varying float vFogDepth;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif`, zm = `#ifdef USE_GRADIENTMAP
	uniform sampler2D gradientMap;
#endif
vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );
	#ifdef USE_GRADIENTMAP
		return vec3( texture2D( gradientMap, coord ).r );
	#else
		vec2 fw = fwidth( coord ) * 0.5;
		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );
	#endif
}`, Hm = `#ifdef USE_LIGHTMAP
	uniform sampler2D lightMap;
	uniform float lightMapIntensity;
#endif`, Vm = `LambertMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularStrength = specularStrength;`, Gm = `varying vec3 vViewPosition;
struct LambertMaterial {
	vec3 diffuseColor;
	float specularStrength;
};
void RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert`, Wm = `uniform bool receiveShadow;
uniform vec3 ambientLightColor;
#if defined( USE_LIGHT_PROBES )
	uniform vec3 lightProbe[ 9 ];
#endif
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {
	float x = normal.x, y = normal.y, z = normal.z;
	vec3 result = shCoefficients[ 0 ] * 0.886227;
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );
	return result;
}
vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {
	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );
	return irradiance;
}
vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {
	vec3 irradiance = ambientLightColor;
	return irradiance;
}
float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
	if ( cutoffDistance > 0.0 ) {
		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
	}
	return distanceFalloff;
}
float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {
	return smoothstep( coneCosine, penumbraCosine, angleCosine );
}
#if NUM_DIR_LIGHTS > 0
	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};
	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {
		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;
	}
#endif
#if NUM_POINT_LIGHTS > 0
	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};
	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];
	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = pointLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float lightDistance = length( lVector );
		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );
	}
#endif
#if NUM_SPOT_LIGHTS > 0
	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};
	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];
	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = spotLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float angleCos = dot( light.direction, spotLight.direction );
		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );
		if ( spotAttenuation > 0.0 ) {
			float lightDistance = length( lVector );
			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );
		} else {
			light.color = vec3( 0.0 );
			light.visible = false;
		}
	}
#endif
#if NUM_RECT_AREA_LIGHTS > 0
	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};
	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;
	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];
#endif
#if NUM_HEMI_LIGHTS > 0
	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};
	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];
	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {
		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );
		return irradiance;
	}
#endif`, Xm = `#ifdef USE_ENVMAP
	vec3 getIBLIrradiance( const in vec3 normal ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );
			return PI * envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 reflectVec = reflect( - viewDir, normal );
			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );
			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );
			return envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	#ifdef USE_ANISOTROPY
		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {
			#ifdef ENVMAP_TYPE_CUBE_UV
				vec3 bentNormal = cross( bitangent, viewDir );
				bentNormal = normalize( cross( bentNormal, bitangent ) );
				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );
				return getIBLRadiance( viewDir, bentNormal, roughness );
			#else
				return vec3( 0.0 );
			#endif
		}
	#endif
#endif`, qm = `ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;`, Ym = `varying vec3 vViewPosition;
struct ToonMaterial {
	vec3 diffuseColor;
};
void RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon`, jm = `BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;`, Km = `varying vec3 vViewPosition;
struct BlinnPhongMaterial {
	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;
};
void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;
}
void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong`, Zm = `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );
vec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );
material.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );
#ifdef IOR
	material.ior = ior;
	#ifdef USE_SPECULAR
		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;
		#ifdef USE_SPECULAR_COLORMAP
			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;
		#endif
		#ifdef USE_SPECULAR_INTENSITYMAP
			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;
		#endif
		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );
	#else
		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;
	#endif
	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );
#else
	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;
#endif
#ifdef USE_CLEARCOAT
	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;
	#ifdef USE_CLEARCOATMAP
		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;
	#endif
	#ifdef USE_CLEARCOAT_ROUGHNESSMAP
		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;
	#endif
	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );
#endif
#ifdef USE_DISPERSION
	material.dispersion = dispersion;
#endif
#ifdef USE_IRIDESCENCE
	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;
	#ifdef USE_IRIDESCENCEMAP
		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;
	#endif
	#ifdef USE_IRIDESCENCE_THICKNESSMAP
		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;
	#else
		material.iridescenceThickness = iridescenceThicknessMaximum;
	#endif
#endif
#ifdef USE_SHEEN
	material.sheenColor = sheenColor;
	#ifdef USE_SHEEN_COLORMAP
		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;
	#endif
	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );
	#ifdef USE_SHEEN_ROUGHNESSMAP
		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;
	#endif
#endif
#ifdef USE_ANISOTROPY
	#ifdef USE_ANISOTROPYMAP
		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );
		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;
		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;
	#else
		vec2 anisotropyV = anisotropyVector;
	#endif
	material.anisotropy = length( anisotropyV );
	if( material.anisotropy == 0.0 ) {
		anisotropyV = vec2( 1.0, 0.0 );
	} else {
		anisotropyV /= material.anisotropy;
		material.anisotropy = saturate( material.anisotropy );
	}
	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );
	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;
	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;
#endif`, $m = `struct PhysicalMaterial {
	vec3 diffuseColor;
	float roughness;
	vec3 specularColor;
	float specularF90;
	float dispersion;
	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif
	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
	#endif
	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif
	#ifdef IOR
		float ior;
	#endif
	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif
	#ifdef USE_ANISOTROPY
		float anisotropy;
		float alphaT;
		vec3 anisotropyT;
		vec3 anisotropyB;
	#endif
};
vec3 clearcoatSpecularDirect = vec3( 0.0 );
vec3 clearcoatSpecularIndirect = vec3( 0.0 );
vec3 sheenSpecularDirect = vec3( 0.0 );
vec3 sheenSpecularIndirect = vec3(0.0 );
vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );
    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {
	float a2 = pow2( alpha );
	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );
	return 0.5 / max( gv + gl, EPSILON );
}
float D_GGX( const in float alpha, const in float dotNH ) {
	float a2 = pow2( alpha );
	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;
	return RECIPROCAL_PI * a2 / pow2( denom );
}
#ifdef USE_ANISOTROPY
	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {
		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );
		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );
		float v = 0.5 / ( gv + gl );
		return saturate(v);
	}
	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {
		float a2 = alphaT * alphaB;
		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );
		highp float v2 = dot( v, v );
		float w2 = a2 / v2;
		return RECIPROCAL_PI * a2 * pow2 ( w2 );
	}
#endif
#ifdef USE_CLEARCOAT
	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {
		vec3 f0 = material.clearcoatF0;
		float f90 = material.clearcoatF90;
		float roughness = material.clearcoatRoughness;
		float alpha = pow2( roughness );
		vec3 halfDir = normalize( lightDir + viewDir );
		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );
		vec3 F = F_Schlick( f0, f90, dotVH );
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
		return F * ( V * D );
	}
#endif
vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {
	vec3 f0 = material.specularColor;
	float f90 = material.specularF90;
	float roughness = material.roughness;
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( f0, f90, dotVH );
	#ifdef USE_IRIDESCENCE
		F = mix( F, material.iridescenceFresnel, material.iridescence );
	#endif
	#ifdef USE_ANISOTROPY
		float dotTL = dot( material.anisotropyT, lightDir );
		float dotTV = dot( material.anisotropyT, viewDir );
		float dotTH = dot( material.anisotropyT, halfDir );
		float dotBL = dot( material.anisotropyB, lightDir );
		float dotBV = dot( material.anisotropyB, viewDir );
		float dotBH = dot( material.anisotropyB, halfDir );
		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );
		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );
	#else
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
	#endif
	return F * ( V * D );
}
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );
	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 );
	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return vec3( result );
}
#if defined( USE_SHEEN )
float D_Charlie( float roughness, float dotNH ) {
	float alpha = pow2( roughness );
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 );
	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );
}
float V_Neubelt( float dotNV, float dotNL ) {
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );
}
vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );
	return sheenColor * ( D * V );
}
#endif
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	float r2 = roughness * roughness;
	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;
	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;
	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );
	return saturate( DG * RECIPROCAL_PI );
}
vec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );
	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );
	vec4 r = roughness * c0 + c1;
	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;
	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;
	return fab;
}
vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	return specularColor * fab.x + specularF90 * fab.y;
}
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	#ifdef USE_IRIDESCENCE
		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );
	#else
		vec3 Fr = specularColor;
	#endif
	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;
	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;
	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );
	singleScatter += FssEss;
	multiScatter += Fms * Ems;
}
#if NUM_RECT_AREA_LIGHTS > 0
	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
		vec3 normal = geometryNormal;
		vec3 viewDir = geometryViewDir;
		vec3 position = geometryPosition;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;
		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;
		vec2 uv = LTC_Uv( normal, viewDir, roughness );
		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );
		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);
		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );
		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );
		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );
	}
#endif
void RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	#ifdef USE_CLEARCOAT
		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );
		vec3 ccIrradiance = dotNLcc * directLight.color;
		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );
	#endif
	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {
	#ifdef USE_CLEARCOAT
		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
	#endif
	vec3 singleScattering = vec3( 0.0 );
	vec3 multiScattering = vec3( 0.0 );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );
	#else
		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );
	#endif
	vec3 totalScattering = singleScattering + multiScattering;
	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );
	reflectedLight.indirectSpecular += radiance * singleScattering;
	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;
	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;
}
#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {
	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );
}`, Jm = `
vec3 geometryPosition = - vViewPosition;
vec3 geometryNormal = normal;
vec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );
vec3 geometryClearcoatNormal = vec3( 0.0 );
#ifdef USE_CLEARCOAT
	geometryClearcoatNormal = clearcoatNormal;
#endif
#ifdef USE_IRIDESCENCE
	float dotNVi = saturate( dot( normal, geometryViewDir ) );
	if ( material.iridescenceThickness == 0.0 ) {
		material.iridescence = 0.0;
	} else {
		material.iridescence = saturate( material.iridescence );
	}
	if ( material.iridescence > 0.0 ) {
		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );
		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );
	}
#endif
IncidentLight directLight;
#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )
	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		pointLight = pointLights[ i ];
		getPointLightInfo( pointLight, geometryPosition, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )
	SpotLight spotLight;
	vec4 spotColor;
	vec3 spotLightCoord;
	bool inSpotLightMap;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		spotLight = spotLights[ i ];
		getSpotLightInfo( spotLight, geometryPosition, directLight );
		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX
		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS
		#else
		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#endif
		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )
			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;
			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );
			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );
			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;
		#endif
		#undef SPOT_LIGHT_MAP_INDEX
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )
	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )
	RectAreaLight rectAreaLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {
		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if defined( RE_IndirectDiffuse )
	vec3 iblIrradiance = vec3( 0.0 );
	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );
	#if defined( USE_LIGHT_PROBES )
		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );
	#endif
	#if ( NUM_HEMI_LIGHTS > 0 )
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );
		}
		#pragma unroll_loop_end
	#endif
#endif
#if defined( RE_IndirectSpecular )
	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );
#endif`, Qm = `#if defined( RE_IndirectDiffuse )
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
		irradiance += lightMapIrradiance;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )
		iblIrradiance += getIBLIrradiance( geometryNormal );
	#endif
#endif
#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	#ifdef USE_ANISOTROPY
		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );
	#else
		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );
	#endif
	#ifdef USE_CLEARCOAT
		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );
	#endif
#endif`, eg = `#if defined( RE_IndirectDiffuse )
	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif
#if defined( RE_IndirectSpecular )
	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif`, tg = `#if defined( USE_LOGDEPTHBUF )
	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
#endif`, ng = `#if defined( USE_LOGDEPTHBUF )
	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, ig = `#ifdef USE_LOGDEPTHBUF
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, sg = `#ifdef USE_LOGDEPTHBUF
	vFragDepth = 1.0 + gl_Position.w;
	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
#endif`, rg = `#ifdef USE_MAP
	vec4 sampledDiffuseColor = texture2D( map, vMapUv );
	#ifdef DECODE_VIDEO_TEXTURE
		sampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );
	#endif
	diffuseColor *= sampledDiffuseColor;
#endif`, ag = `#ifdef USE_MAP
	uniform sampler2D map;
#endif`, og = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	#if defined( USE_POINTS_UV )
		vec2 uv = vUv;
	#else
		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
	#endif
#endif
#ifdef USE_MAP
	diffuseColor *= texture2D( map, uv );
#endif
#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, uv ).g;
#endif`, lg = `#if defined( USE_POINTS_UV )
	varying vec2 vUv;
#else
	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
		uniform mat3 uvTransform;
	#endif
#endif
#ifdef USE_MAP
	uniform sampler2D map;
#endif
#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, cg = `float metalnessFactor = metalness;
#ifdef USE_METALNESSMAP
	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );
	metalnessFactor *= texelMetalness.b;
#endif`, ug = `#ifdef USE_METALNESSMAP
	uniform sampler2D metalnessMap;
#endif`, hg = `#ifdef USE_INSTANCING_MORPH
	float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;
	}
#endif`, dg = `#if defined( USE_MORPHCOLORS )
	vColor *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		#if defined( USE_COLOR_ALPHA )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];
		#elif defined( USE_COLOR )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];
		#endif
	}
#endif`, fg = `#ifdef USE_MORPHNORMALS
	objectNormal *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];
	}
#endif`, pg = `#ifdef USE_MORPHTARGETS
	#ifndef USE_INSTANCING_MORPH
		uniform float morphTargetBaseInfluence;
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	#endif
	uniform sampler2DArray morphTargetsTexture;
	uniform ivec2 morphTargetsTextureSize;
	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {
		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
		int y = texelIndex / morphTargetsTextureSize.x;
		int x = texelIndex - y * morphTargetsTextureSize.x;
		ivec3 morphUV = ivec3( x, y, morphTargetIndex );
		return texelFetch( morphTargetsTexture, morphUV, 0 );
	}
#endif`, mg = `#ifdef USE_MORPHTARGETS
	transformed *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];
	}
#endif`, gg = `float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;
#ifdef FLAT_SHADED
	vec3 fdx = dFdx( vViewPosition );
	vec3 fdy = dFdy( vViewPosition );
	vec3 normal = normalize( cross( fdx, fdy ) );
#else
	vec3 normal = normalize( vNormal );
	#ifdef DOUBLE_SIDED
		normal *= faceDirection;
	#endif
#endif
#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )
	#ifdef USE_TANGENT
		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn = getTangentFrame( - vViewPosition, normal,
		#if defined( USE_NORMALMAP )
			vNormalMapUv
		#elif defined( USE_CLEARCOAT_NORMALMAP )
			vClearcoatNormalMapUv
		#else
			vUv
		#endif
		);
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn[0] *= faceDirection;
		tbn[1] *= faceDirection;
	#endif
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	#ifdef USE_TANGENT
		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn2[0] *= faceDirection;
		tbn2[1] *= faceDirection;
	#endif
#endif
vec3 nonPerturbedNormal = normal;`, _g = `#ifdef USE_NORMALMAP_OBJECTSPACE
	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	#ifdef FLIP_SIDED
		normal = - normal;
	#endif
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	normal = normalize( normalMatrix * normal );
#elif defined( USE_NORMALMAP_TANGENTSPACE )
	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	mapN.xy *= normalScale;
	normal = normalize( tbn * mapN );
#elif defined( USE_BUMPMAP )
	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );
#endif`, xg = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, vg = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, yg = `#ifndef FLAT_SHADED
	vNormal = normalize( transformedNormal );
	#ifdef USE_TANGENT
		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );
	#endif
#endif`, Sg = `#ifdef USE_NORMALMAP
	uniform sampler2D normalMap;
	uniform vec2 normalScale;
#endif
#ifdef USE_NORMALMAP_OBJECTSPACE
	uniform mat3 normalMatrix;
#endif
#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )
	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {
		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( uv.st );
		vec2 st1 = dFdy( uv.st );
		vec3 N = surf_norm;
		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );
		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;
		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );
		return mat3( T * scale, B * scale, N );
	}
#endif`, Mg = `#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal = nonPerturbedNormal;
#endif`, bg = `#ifdef USE_CLEARCOAT_NORMALMAP
	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;
	clearcoatNormal = normalize( tbn2 * clearcoatMapN );
#endif`, Eg = `#ifdef USE_CLEARCOATMAP
	uniform sampler2D clearcoatMap;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform sampler2D clearcoatRoughnessMap;
#endif`, Tg = `#ifdef USE_IRIDESCENCEMAP
	uniform sampler2D iridescenceMap;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform sampler2D iridescenceThicknessMap;
#endif`, Ag = `#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif
#ifdef USE_TRANSMISSION
diffuseColor.a *= material.transmissionAlpha;
#endif
gl_FragColor = vec4( outgoingLight, diffuseColor.a );`, wg = `vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}
vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}
const float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;
const float Inv255 = 1. / 255.;
const vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );
const vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );
const vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );
const vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );
vec4 packDepthToRGBA( const in float v ) {
	if( v <= 0.0 )
		return vec4( 0., 0., 0., 0. );
	if( v >= 1.0 )
		return vec4( 1., 1., 1., 1. );
	float vuf;
	float af = modf( v * PackFactors.a, vuf );
	float bf = modf( vuf * ShiftRight8, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );
}
vec3 packDepthToRGB( const in float v ) {
	if( v <= 0.0 )
		return vec3( 0., 0., 0. );
	if( v >= 1.0 )
		return vec3( 1., 1., 1. );
	float vuf;
	float bf = modf( v * PackFactors.b, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec3( vuf * Inv255, gf * PackUpscale, bf );
}
vec2 packDepthToRG( const in float v ) {
	if( v <= 0.0 )
		return vec2( 0., 0. );
	if( v >= 1.0 )
		return vec2( 1., 1. );
	float vuf;
	float gf = modf( v * 256., vuf );
	return vec2( vuf * Inv255, gf );
}
float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors4 );
}
float unpackRGBToDepth( const in vec3 v ) {
	return dot( v, UnpackFactors3 );
}
float unpackRGToDepth( const in vec2 v ) {
	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;
}
vec4 pack2HalfToRGBA( const in vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}
vec2 unpackRGBATo2Half( const in vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}
float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	return ( viewZ + near ) / ( near - far );
}
float orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return depth * ( near - far ) - near;
}
float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}
float perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return ( near * far ) / ( ( far - near ) * depth - far );
}`, Rg = `#ifdef PREMULTIPLIED_ALPHA
	gl_FragColor.rgb *= gl_FragColor.a;
#endif`, Cg = `vec4 mvPosition = vec4( transformed, 1.0 );
#ifdef USE_BATCHING
	mvPosition = batchingMatrix * mvPosition;
#endif
#ifdef USE_INSTANCING
	mvPosition = instanceMatrix * mvPosition;
#endif
mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;`, Pg = `#ifdef DITHERING
	gl_FragColor.rgb = dithering( gl_FragColor.rgb );
#endif`, Lg = `#ifdef DITHERING
	vec3 dithering( vec3 color ) {
		float grid_position = rand( gl_FragCoord.xy );
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );
		return color + dither_shift_RGB;
	}
#endif`, Ig = `float roughnessFactor = roughness;
#ifdef USE_ROUGHNESSMAP
	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );
	roughnessFactor *= texelRoughness.g;
#endif`, Dg = `#ifdef USE_ROUGHNESSMAP
	uniform sampler2D roughnessMap;
#endif`, Ng = `#if NUM_SPOT_LIGHT_COORDS > 0
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#if NUM_SPOT_LIGHT_MAPS > 0
	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {
		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );
	}
	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {
		return unpackRGBATo2Half( texture2D( shadow, uv ) );
	}
	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){
		float occlusion = 1.0;
		vec2 distribution = texture2DDistribution( shadow, uv );
		float hard_shadow = step( compare , distribution.x );
		if (hard_shadow != 1.0 ) {
			float distance = compare - distribution.x ;
			float variance = max( 0.00000, distribution.y * distribution.y );
			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );
		}
		return occlusion;
	}
	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
		float shadow = 1.0;
		shadowCoord.xyz /= shadowCoord.w;
		shadowCoord.z += shadowBias;
		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
		if ( frustumTest ) {
		#if defined( SHADOWMAP_TYPE_PCF )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx0 = - texelSize.x * shadowRadius;
			float dy0 = - texelSize.y * shadowRadius;
			float dx1 = + texelSize.x * shadowRadius;
			float dy1 = + texelSize.y * shadowRadius;
			float dx2 = dx0 / 2.0;
			float dy2 = dy0 / 2.0;
			float dx3 = dx1 / 2.0;
			float dy3 = dy1 / 2.0;
			shadow = (
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )
			) * ( 1.0 / 17.0 );
		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx = texelSize.x;
			float dy = texelSize.y;
			vec2 uv = shadowCoord.xy;
			vec2 f = fract( uv * shadowMapSize + 0.5 );
			uv -= f * texelSize;
			shadow = (
				texture2DCompare( shadowMap, uv, shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
						  f.x ),
					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
						  f.x ),
					 f.y )
			) * ( 1.0 / 9.0 );
		#elif defined( SHADOWMAP_TYPE_VSM )
			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );
		#else
			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );
		#endif
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
	vec2 cubeToUV( vec3 v, float texelSizeY ) {
		vec3 absV = abs( v );
		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
		absV *= scaleToCube;
		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );
		vec2 planar = v.xy;
		float almostATexel = 1.5 * texelSizeY;
		float almostOne = 1.0 - almostATexel;
		if ( absV.z >= almostOne ) {
			if ( v.z > 0.0 )
				planar.x = 4.0 - v.x;
		} else if ( absV.x >= almostOne ) {
			float signX = sign( v.x );
			planar.x = v.z * signX + 2.0 * signX;
		} else if ( absV.y >= almostOne ) {
			float signY = sign( v.y );
			planar.x = v.x + 2.0 * signY + 2.0;
			planar.y = v.z * signY - 2.0;
		}
		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );
	}
	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		float shadow = 1.0;
		vec3 lightToPosition = shadowCoord.xyz;
		
		float lightToPositionLength = length( lightToPosition );
		if ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {
			float dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );			dp += shadowBias;
			vec3 bd3D = normalize( lightToPosition );
			vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );
			#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )
				vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;
				shadow = (
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )
				) * ( 1.0 / 9.0 );
			#else
				shadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );
			#endif
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
#endif`, Ug = `#if NUM_SPOT_LIGHT_COORDS > 0
	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
#endif`, Fg = `#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )
	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
	vec4 shadowWorldPosition;
#endif
#if defined( USE_SHADOWMAP )
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
#endif
#if NUM_SPOT_LIGHT_COORDS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {
		shadowWorldPosition = worldPosition;
		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;
		#endif
		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
#endif`, Og = `float getShadowMask() {
	float shadow = 1.0;
	#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#endif
	return shadow;
}`, Bg = `#ifdef USE_SKINNING
	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );
#endif`, kg = `#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;
	uniform highp sampler2D boneTexture;
	mat4 getBoneMatrix( const in float i ) {
		int size = textureSize( boneTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
#endif`, zg = `#ifdef USE_SKINNING
	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;
	transformed = ( bindMatrixInverse * skinned ).xyz;
#endif`, Hg = `#ifdef USE_SKINNING
	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;
	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;
	#ifdef USE_TANGENT
		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#endif
#endif`, Vg = `float specularStrength;
#ifdef USE_SPECULARMAP
	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );
	specularStrength = texelSpecular.r;
#else
	specularStrength = 1.0;
#endif`, Gg = `#ifdef USE_SPECULARMAP
	uniform sampler2D specularMap;
#endif`, Wg = `#if defined( TONE_MAPPING )
	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );
#endif`, Xg = `#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
uniform float toneMappingExposure;
vec3 LinearToneMapping( vec3 color ) {
	return saturate( toneMappingExposure * color );
}
vec3 ReinhardToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );
}
vec3 CineonToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );
}
vec3 RRTAndODTFit( vec3 v ) {
	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;
}
vec3 ACESFilmicToneMapping( vec3 color ) {
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);
	color *= toneMappingExposure / 0.6;
	color = ACESInputMat * color;
	color = RRTAndODTFit( color );
	color = ACESOutputMat * color;
	return saturate( color );
}
const mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(
	vec3( 1.6605, - 0.1246, - 0.0182 ),
	vec3( - 0.5876, 1.1329, - 0.1006 ),
	vec3( - 0.0728, - 0.0083, 1.1187 )
);
const mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(
	vec3( 0.6274, 0.0691, 0.0164 ),
	vec3( 0.3293, 0.9195, 0.0880 ),
	vec3( 0.0433, 0.0113, 0.8956 )
);
vec3 agxDefaultContrastApprox( vec3 x ) {
	vec3 x2 = x * x;
	vec3 x4 = x2 * x2;
	return + 15.5 * x4 * x2
		- 40.14 * x4 * x
		+ 31.96 * x4
		- 6.868 * x2 * x
		+ 0.4298 * x2
		+ 0.1191 * x
		- 0.00232;
}
vec3 AgXToneMapping( vec3 color ) {
	const mat3 AgXInsetMatrix = mat3(
		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),
		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),
		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )
	);
	const mat3 AgXOutsetMatrix = mat3(
		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),
		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),
		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )
	);
	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;
	color *= toneMappingExposure;
	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;
	color = AgXInsetMatrix * color;
	color = max( color, 1e-10 );	color = log2( color );
	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );
	color = clamp( color, 0.0, 1.0 );
	color = agxDefaultContrastApprox( color );
	color = AgXOutsetMatrix * color;
	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );
	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;
	color = clamp( color, 0.0, 1.0 );
	return color;
}
vec3 NeutralToneMapping( vec3 color ) {
	const float StartCompression = 0.8 - 0.04;
	const float Desaturation = 0.15;
	color *= toneMappingExposure;
	float x = min( color.r, min( color.g, color.b ) );
	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;
	color -= offset;
	float peak = max( color.r, max( color.g, color.b ) );
	if ( peak < StartCompression ) return color;
	float d = 1. - StartCompression;
	float newPeak = 1. - d * d / ( peak + d - StartCompression );
	color *= newPeak / peak;
	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );
	return mix( color, vec3( newPeak ), g );
}
vec3 CustomToneMapping( vec3 color ) { return color; }`, qg = `#ifdef USE_TRANSMISSION
	material.transmission = transmission;
	material.transmissionAlpha = 1.0;
	material.thickness = thickness;
	material.attenuationDistance = attenuationDistance;
	material.attenuationColor = attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;
	#endif
	#ifdef USE_THICKNESSMAP
		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;
	#endif
	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = inverseTransformDirection( normal, viewMatrix );
	vec4 transmitted = getIBLVolumeRefraction(
		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,
		material.attenuationColor, material.attenuationDistance );
	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );
	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );
#endif`, Yg = `#ifdef USE_TRANSMISSION
	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		uniform sampler2D transmissionMap;
	#endif
	#ifdef USE_THICKNESSMAP
		uniform sampler2D thicknessMap;
	#endif
	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;
	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;
	varying vec3 vWorldPosition;
	float w0( float a ) {
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );
	}
	float w1( float a ) {
		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );
	}
	float w2( float a ){
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );
	}
	float w3( float a ) {
		return ( 1.0 / 6.0 ) * ( a * a * a );
	}
	float g0( float a ) {
		return w0( a ) + w1( a );
	}
	float g1( float a ) {
		return w2( a ) + w3( a );
	}
	float h0( float a ) {
		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );
	}
	float h1( float a ) {
		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );
	}
	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {
		uv = uv * texelSize.zw + 0.5;
		vec2 iuv = floor( uv );
		vec2 fuv = fract( uv );
		float g0x = g0( fuv.x );
		float g1x = g1( fuv.x );
		float h0x = h0( fuv.x );
		float h1x = h1( fuv.x );
		float h0y = h0( fuv.y );
		float h1y = h1( fuv.y );
		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +
			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );
	}
	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {
		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );
		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );
		vec2 fLodSizeInv = 1.0 / fLodSize;
		vec2 cLodSizeInv = 1.0 / cLodSize;
		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );
		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );
		return mix( fSample, cSample, fract( lod ) );
	}
	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		return normalize( refractionVector ) * thickness * modelScale;
	}
	float applyIorToRoughness( const in float roughness, const in float ior ) {
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	}
	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );
	}
	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
		if ( isinf( attenuationDistance ) ) {
			return vec3( 1.0 );
		} else {
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;
		}
	}
	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {
		vec4 transmittedLight;
		vec3 transmittance;
		#ifdef USE_DISPERSION
			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;
			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );
			for ( int i = 0; i < 3; i ++ ) {
				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );
				vec3 refractedRayExit = position + transmissionRay;
				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
				vec2 refractionCoords = ndcPos.xy / ndcPos.w;
				refractionCoords += 1.0;
				refractionCoords /= 2.0;
				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );
				transmittedLight[ i ] = transmissionSample[ i ];
				transmittedLight.a += transmissionSample.a;
				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];
			}
			transmittedLight.a /= 3.0;
		#else
			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
			vec3 refractedRayExit = position + transmissionRay;
			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
			vec2 refractionCoords = ndcPos.xy / ndcPos.w;
			refractionCoords += 1.0;
			refractionCoords /= 2.0;
			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );
		#endif
		vec3 attenuatedColor = transmittance * transmittedLight.rgb;
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;
		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );
	}
#endif`, jg = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_SPECULARMAP
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`, Kg = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	uniform mat3 mapTransform;
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	uniform mat3 alphaMapTransform;
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	uniform mat3 lightMapTransform;
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	uniform mat3 aoMapTransform;
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	uniform mat3 bumpMapTransform;
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	uniform mat3 normalMapTransform;
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_DISPLACEMENTMAP
	uniform mat3 displacementMapTransform;
	varying vec2 vDisplacementMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	uniform mat3 emissiveMapTransform;
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	uniform mat3 metalnessMapTransform;
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	uniform mat3 roughnessMapTransform;
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	uniform mat3 anisotropyMapTransform;
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	uniform mat3 clearcoatMapTransform;
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform mat3 clearcoatNormalMapTransform;
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform mat3 clearcoatRoughnessMapTransform;
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	uniform mat3 sheenColorMapTransform;
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	uniform mat3 sheenRoughnessMapTransform;
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	uniform mat3 iridescenceMapTransform;
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform mat3 iridescenceThicknessMapTransform;
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SPECULARMAP
	uniform mat3 specularMapTransform;
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	uniform mat3 specularColorMapTransform;
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	uniform mat3 specularIntensityMapTransform;
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`, Zg = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	vUv = vec3( uv, 1 ).xy;
#endif
#ifdef USE_MAP
	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ALPHAMAP
	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_LIGHTMAP
	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_AOMAP
	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_BUMPMAP
	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_NORMALMAP
	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_DISPLACEMENTMAP
	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_EMISSIVEMAP
	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_METALNESSMAP
	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ROUGHNESSMAP
	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ANISOTROPYMAP
	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOATMAP
	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCEMAP
	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_COLORMAP
	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULARMAP
	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_COLORMAP
	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_TRANSMISSIONMAP
	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_THICKNESSMAP
	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;
#endif`, $g = `#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0
	vec4 worldPosition = vec4( transformed, 1.0 );
	#ifdef USE_BATCHING
		worldPosition = batchingMatrix * worldPosition;
	#endif
	#ifdef USE_INSTANCING
		worldPosition = instanceMatrix * worldPosition;
	#endif
	worldPosition = modelMatrix * worldPosition;
#endif`;
const Jg = `varying vec2 vUv;
uniform mat3 uvTransform;
void main() {
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	gl_Position = vec4( position.xy, 1.0, 1.0 );
}`, Qg = `uniform sampler2D t2D;
uniform float backgroundIntensity;
varying vec2 vUv;
void main() {
	vec4 texColor = texture2D( t2D, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, e_ = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, t_ = `#ifdef ENVMAP_TYPE_CUBE
	uniform samplerCube envMap;
#elif defined( ENVMAP_TYPE_CUBE_UV )
	uniform sampler2D envMap;
#endif
uniform float flipEnvMap;
uniform float backgroundBlurriness;
uniform float backgroundIntensity;
uniform mat3 backgroundRotation;
varying vec3 vWorldDirection;
#include <cube_uv_reflection_fragment>
void main() {
	#ifdef ENVMAP_TYPE_CUBE
		vec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );
	#elif defined( ENVMAP_TYPE_CUBE_UV )
		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );
	#else
		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, n_ = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, i_ = `uniform samplerCube tCube;
uniform float tFlip;
uniform float opacity;
varying vec3 vWorldDirection;
void main() {
	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );
	gl_FragColor = texColor;
	gl_FragColor.a *= opacity;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, s_ = `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
varying vec2 vHighPrecisionZW;
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vHighPrecisionZW = gl_Position.zw;
}`, r_ = `#if DEPTH_PACKING == 3200
	uniform float opacity;
#endif
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
varying vec2 vHighPrecisionZW;
void main() {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#if DEPTH_PACKING == 3200
		diffuseColor.a = opacity;
	#endif
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <logdepthbuf_fragment>
	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;
	#if DEPTH_PACKING == 3200
		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );
	#elif DEPTH_PACKING == 3201
		gl_FragColor = packDepthToRGBA( fragCoordZ );
	#elif DEPTH_PACKING == 3202
		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );
	#elif DEPTH_PACKING == 3203
		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );
	#endif
}`, a_ = `#define DISTANCE
varying vec3 vWorldPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	vWorldPosition = worldPosition.xyz;
}`, o_ = `#define DISTANCE
uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <clipping_planes_pars_fragment>
void main () {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist );
	gl_FragColor = packDepthToRGBA( dist );
}`, l_ = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
}`, c_ = `uniform sampler2D tEquirect;
varying vec3 vWorldDirection;
#include <common>
void main() {
	vec3 direction = normalize( vWorldDirection );
	vec2 sampleUV = equirectUv( direction );
	gl_FragColor = texture2D( tEquirect, sampleUV );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, u_ = `uniform float scale;
attribute float lineDistance;
varying float vLineDistance;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	vLineDistance = scale * lineDistance;
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, h_ = `uniform vec3 diffuse;
uniform float opacity;
uniform float dashSize;
uniform float totalSize;
varying float vLineDistance;
#include <common>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	if ( mod( vLineDistance, totalSize ) > dashSize ) {
		discard;
	}
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, d_ = `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}`, f_ = `uniform vec3 diffuse;
uniform float opacity;
#ifndef FLAT_SHADED
	varying vec3 vNormal;
#endif
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;
	#else
		reflectedLight.indirectDiffuse += vec3( 1.0 );
	#endif
	#include <aomap_fragment>
	reflectedLight.indirectDiffuse *= diffuseColor.rgb;
	vec3 outgoingLight = reflectedLight.indirectDiffuse;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, p_ = `#define LAMBERT
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, m_ = `#define LAMBERT
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, g_ = `#define MATCAP
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
	vViewPosition = - mvPosition.xyz;
}`, __ = `#define MATCAP
uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
	#ifdef USE_MATCAP
		vec4 matcapColor = texture2D( matcap, uv );
	#else
		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );
	#endif
	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, x_ = `#define NORMAL
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	vViewPosition = - mvPosition.xyz;
#endif
}`, v_ = `#define NORMAL
uniform float opacity;
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <packing>
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	gl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );
	#ifdef OPAQUE
		gl_FragColor.a = 1.0;
	#endif
}`, y_ = `#define PHONG
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, S_ = `#define PHONG
uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, M_ = `#define STANDARD
varying vec3 vViewPosition;
#ifdef USE_TRANSMISSION
	varying vec3 vWorldPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
#ifdef USE_TRANSMISSION
	vWorldPosition = worldPosition.xyz;
#endif
}`, b_ = `#define STANDARD
#ifdef PHYSICAL
	#define IOR
	#define USE_SPECULAR
#endif
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
#ifdef IOR
	uniform float ior;
#endif
#ifdef USE_SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;
	#ifdef USE_SPECULAR_COLORMAP
		uniform sampler2D specularColorMap;
	#endif
	#ifdef USE_SPECULAR_INTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
#endif
#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif
#ifdef USE_DISPERSION
	uniform float dispersion;
#endif
#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif
#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;
	#ifdef USE_SHEEN_COLORMAP
		uniform sampler2D sheenColorMap;
	#endif
	#ifdef USE_SHEEN_ROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif
#ifdef USE_ANISOTROPY
	uniform vec2 anisotropyVector;
	#ifdef USE_ANISOTROPYMAP
		uniform sampler2D anisotropyMap;
	#endif
#endif
varying vec3 vViewPosition;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;
	#include <transmission_fragment>
	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
	#ifdef USE_SHEEN
		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );
		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;
	#endif
	#ifdef USE_CLEARCOAT
		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );
		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );
		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;
	#endif
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, E_ = `#define TOON
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, T_ = `#define TOON
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, A_ = `uniform float size;
uniform float scale;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
#ifdef USE_POINTS_UV
	varying vec2 vUv;
	uniform mat3 uvTransform;
#endif
void main() {
	#ifdef USE_POINTS_UV
		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	#endif
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	gl_PointSize = size;
	#ifdef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
	#endif
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>
}`, w_ = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, R_ = `#include <common>
#include <batching_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <shadowmap_pars_vertex>
void main() {
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, C_ = `uniform vec3 color;
uniform float opacity;
#include <common>
#include <packing>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <logdepthbuf_pars_fragment>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
void main() {
	#include <logdepthbuf_fragment>
	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`, P_ = `uniform float rotation;
uniform vec2 center;
#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	vec4 mvPosition = modelViewMatrix[ 3 ];
	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );
	#ifndef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) scale *= - mvPosition.z;
	#endif
	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;
	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
	mvPosition.xy += rotatedPosition;
	gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, L_ = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`, $e = {
  alphahash_fragment: Qp,
  alphahash_pars_fragment: em,
  alphamap_fragment: tm,
  alphamap_pars_fragment: nm,
  alphatest_fragment: im,
  alphatest_pars_fragment: sm,
  aomap_fragment: rm,
  aomap_pars_fragment: am,
  batching_pars_vertex: om,
  batching_vertex: lm,
  begin_vertex: cm,
  beginnormal_vertex: um,
  bsdfs: hm,
  iridescence_fragment: dm,
  bumpmap_pars_fragment: fm,
  clipping_planes_fragment: pm,
  clipping_planes_pars_fragment: mm,
  clipping_planes_pars_vertex: gm,
  clipping_planes_vertex: _m,
  color_fragment: xm,
  color_pars_fragment: vm,
  color_pars_vertex: ym,
  color_vertex: Sm,
  common: Mm,
  cube_uv_reflection_fragment: bm,
  defaultnormal_vertex: Em,
  displacementmap_pars_vertex: Tm,
  displacementmap_vertex: Am,
  emissivemap_fragment: wm,
  emissivemap_pars_fragment: Rm,
  colorspace_fragment: Cm,
  colorspace_pars_fragment: Pm,
  envmap_fragment: Lm,
  envmap_common_pars_fragment: Im,
  envmap_pars_fragment: Dm,
  envmap_pars_vertex: Nm,
  envmap_physical_pars_fragment: Xm,
  envmap_vertex: Um,
  fog_vertex: Fm,
  fog_pars_vertex: Om,
  fog_fragment: Bm,
  fog_pars_fragment: km,
  gradientmap_pars_fragment: zm,
  lightmap_pars_fragment: Hm,
  lights_lambert_fragment: Vm,
  lights_lambert_pars_fragment: Gm,
  lights_pars_begin: Wm,
  lights_toon_fragment: qm,
  lights_toon_pars_fragment: Ym,
  lights_phong_fragment: jm,
  lights_phong_pars_fragment: Km,
  lights_physical_fragment: Zm,
  lights_physical_pars_fragment: $m,
  lights_fragment_begin: Jm,
  lights_fragment_maps: Qm,
  lights_fragment_end: eg,
  logdepthbuf_fragment: tg,
  logdepthbuf_pars_fragment: ng,
  logdepthbuf_pars_vertex: ig,
  logdepthbuf_vertex: sg,
  map_fragment: rg,
  map_pars_fragment: ag,
  map_particle_fragment: og,
  map_particle_pars_fragment: lg,
  metalnessmap_fragment: cg,
  metalnessmap_pars_fragment: ug,
  morphinstance_vertex: hg,
  morphcolor_vertex: dg,
  morphnormal_vertex: fg,
  morphtarget_pars_vertex: pg,
  morphtarget_vertex: mg,
  normal_fragment_begin: gg,
  normal_fragment_maps: _g,
  normal_pars_fragment: xg,
  normal_pars_vertex: vg,
  normal_vertex: yg,
  normalmap_pars_fragment: Sg,
  clearcoat_normal_fragment_begin: Mg,
  clearcoat_normal_fragment_maps: bg,
  clearcoat_pars_fragment: Eg,
  iridescence_pars_fragment: Tg,
  opaque_fragment: Ag,
  packing: wg,
  premultiplied_alpha_fragment: Rg,
  project_vertex: Cg,
  dithering_fragment: Pg,
  dithering_pars_fragment: Lg,
  roughnessmap_fragment: Ig,
  roughnessmap_pars_fragment: Dg,
  shadowmap_pars_fragment: Ng,
  shadowmap_pars_vertex: Ug,
  shadowmap_vertex: Fg,
  shadowmask_pars_fragment: Og,
  skinbase_vertex: Bg,
  skinning_pars_vertex: kg,
  skinning_vertex: zg,
  skinnormal_vertex: Hg,
  specularmap_fragment: Vg,
  specularmap_pars_fragment: Gg,
  tonemapping_fragment: Wg,
  tonemapping_pars_fragment: Xg,
  transmission_fragment: qg,
  transmission_pars_fragment: Yg,
  uv_pars_fragment: jg,
  uv_pars_vertex: Kg,
  uv_vertex: Zg,
  worldpos_vertex: $g,
  background_vert: Jg,
  background_frag: Qg,
  backgroundCube_vert: e_,
  backgroundCube_frag: t_,
  cube_vert: n_,
  cube_frag: i_,
  depth_vert: s_,
  depth_frag: r_,
  distanceRGBA_vert: a_,
  distanceRGBA_frag: o_,
  equirect_vert: l_,
  equirect_frag: c_,
  linedashed_vert: u_,
  linedashed_frag: h_,
  meshbasic_vert: d_,
  meshbasic_frag: f_,
  meshlambert_vert: p_,
  meshlambert_frag: m_,
  meshmatcap_vert: g_,
  meshmatcap_frag: __,
  meshnormal_vert: x_,
  meshnormal_frag: v_,
  meshphong_vert: y_,
  meshphong_frag: S_,
  meshphysical_vert: M_,
  meshphysical_frag: b_,
  meshtoon_vert: E_,
  meshtoon_frag: T_,
  points_vert: A_,
  points_frag: w_,
  shadow_vert: R_,
  shadow_frag: C_,
  sprite_vert: P_,
  sprite_frag: L_
}, pe = {
  common: {
    diffuse: { value: /* @__PURE__ */ new He(16777215) },
    opacity: { value: 1 },
    map: { value: null },
    mapTransform: { value: /* @__PURE__ */ new Ke() },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Ke() },
    alphaTest: { value: 0 }
  },
  specularmap: {
    specularMap: { value: null },
    specularMapTransform: { value: /* @__PURE__ */ new Ke() }
  },
  envmap: {
    envMap: { value: null },
    envMapRotation: { value: /* @__PURE__ */ new Ke() },
    flipEnvMap: { value: -1 },
    reflectivity: { value: 1 },
    // basic, lambert, phong
    ior: { value: 1.5 },
    // physical
    refractionRatio: { value: 0.98 }
    // basic, lambert, phong
  },
  aomap: {
    aoMap: { value: null },
    aoMapIntensity: { value: 1 },
    aoMapTransform: { value: /* @__PURE__ */ new Ke() }
  },
  lightmap: {
    lightMap: { value: null },
    lightMapIntensity: { value: 1 },
    lightMapTransform: { value: /* @__PURE__ */ new Ke() }
  },
  bumpmap: {
    bumpMap: { value: null },
    bumpMapTransform: { value: /* @__PURE__ */ new Ke() },
    bumpScale: { value: 1 }
  },
  normalmap: {
    normalMap: { value: null },
    normalMapTransform: { value: /* @__PURE__ */ new Ke() },
    normalScale: { value: /* @__PURE__ */ new ze(1, 1) }
  },
  displacementmap: {
    displacementMap: { value: null },
    displacementMapTransform: { value: /* @__PURE__ */ new Ke() },
    displacementScale: { value: 1 },
    displacementBias: { value: 0 }
  },
  emissivemap: {
    emissiveMap: { value: null },
    emissiveMapTransform: { value: /* @__PURE__ */ new Ke() }
  },
  metalnessmap: {
    metalnessMap: { value: null },
    metalnessMapTransform: { value: /* @__PURE__ */ new Ke() }
  },
  roughnessmap: {
    roughnessMap: { value: null },
    roughnessMapTransform: { value: /* @__PURE__ */ new Ke() }
  },
  gradientmap: {
    gradientMap: { value: null }
  },
  fog: {
    fogDensity: { value: 25e-5 },
    fogNear: { value: 1 },
    fogFar: { value: 2e3 },
    fogColor: { value: /* @__PURE__ */ new He(16777215) }
  },
  lights: {
    ambientLightColor: { value: [] },
    lightProbe: { value: [] },
    directionalLights: { value: [], properties: {
      direction: {},
      color: {}
    } },
    directionalLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    directionalShadowMap: { value: [] },
    directionalShadowMatrix: { value: [] },
    spotLights: { value: [], properties: {
      color: {},
      position: {},
      direction: {},
      distance: {},
      coneCos: {},
      penumbraCos: {},
      decay: {}
    } },
    spotLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    spotLightMap: { value: [] },
    spotShadowMap: { value: [] },
    spotLightMatrix: { value: [] },
    pointLights: { value: [], properties: {
      color: {},
      position: {},
      decay: {},
      distance: {}
    } },
    pointLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {},
      shadowCameraNear: {},
      shadowCameraFar: {}
    } },
    pointShadowMap: { value: [] },
    pointShadowMatrix: { value: [] },
    hemisphereLights: { value: [], properties: {
      direction: {},
      skyColor: {},
      groundColor: {}
    } },
    // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
    rectAreaLights: { value: [], properties: {
      color: {},
      position: {},
      width: {},
      height: {}
    } },
    ltc_1: { value: null },
    ltc_2: { value: null }
  },
  points: {
    diffuse: { value: /* @__PURE__ */ new He(16777215) },
    opacity: { value: 1 },
    size: { value: 1 },
    scale: { value: 1 },
    map: { value: null },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Ke() },
    alphaTest: { value: 0 },
    uvTransform: { value: /* @__PURE__ */ new Ke() }
  },
  sprite: {
    diffuse: { value: /* @__PURE__ */ new He(16777215) },
    opacity: { value: 1 },
    center: { value: /* @__PURE__ */ new ze(0.5, 0.5) },
    rotation: { value: 0 },
    map: { value: null },
    mapTransform: { value: /* @__PURE__ */ new Ke() },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Ke() },
    alphaTest: { value: 0 }
  }
}, cn = {
  basic: {
    uniforms: /* @__PURE__ */ sn([
      pe.common,
      pe.specularmap,
      pe.envmap,
      pe.aomap,
      pe.lightmap,
      pe.fog
    ]),
    vertexShader: $e.meshbasic_vert,
    fragmentShader: $e.meshbasic_frag
  },
  lambert: {
    uniforms: /* @__PURE__ */ sn([
      pe.common,
      pe.specularmap,
      pe.envmap,
      pe.aomap,
      pe.lightmap,
      pe.emissivemap,
      pe.bumpmap,
      pe.normalmap,
      pe.displacementmap,
      pe.fog,
      pe.lights,
      {
        emissive: { value: /* @__PURE__ */ new He(0) }
      }
    ]),
    vertexShader: $e.meshlambert_vert,
    fragmentShader: $e.meshlambert_frag
  },
  phong: {
    uniforms: /* @__PURE__ */ sn([
      pe.common,
      pe.specularmap,
      pe.envmap,
      pe.aomap,
      pe.lightmap,
      pe.emissivemap,
      pe.bumpmap,
      pe.normalmap,
      pe.displacementmap,
      pe.fog,
      pe.lights,
      {
        emissive: { value: /* @__PURE__ */ new He(0) },
        specular: { value: /* @__PURE__ */ new He(1118481) },
        shininess: { value: 30 }
      }
    ]),
    vertexShader: $e.meshphong_vert,
    fragmentShader: $e.meshphong_frag
  },
  standard: {
    uniforms: /* @__PURE__ */ sn([
      pe.common,
      pe.envmap,
      pe.aomap,
      pe.lightmap,
      pe.emissivemap,
      pe.bumpmap,
      pe.normalmap,
      pe.displacementmap,
      pe.roughnessmap,
      pe.metalnessmap,
      pe.fog,
      pe.lights,
      {
        emissive: { value: /* @__PURE__ */ new He(0) },
        roughness: { value: 1 },
        metalness: { value: 0 },
        envMapIntensity: { value: 1 }
      }
    ]),
    vertexShader: $e.meshphysical_vert,
    fragmentShader: $e.meshphysical_frag
  },
  toon: {
    uniforms: /* @__PURE__ */ sn([
      pe.common,
      pe.aomap,
      pe.lightmap,
      pe.emissivemap,
      pe.bumpmap,
      pe.normalmap,
      pe.displacementmap,
      pe.gradientmap,
      pe.fog,
      pe.lights,
      {
        emissive: { value: /* @__PURE__ */ new He(0) }
      }
    ]),
    vertexShader: $e.meshtoon_vert,
    fragmentShader: $e.meshtoon_frag
  },
  matcap: {
    uniforms: /* @__PURE__ */ sn([
      pe.common,
      pe.bumpmap,
      pe.normalmap,
      pe.displacementmap,
      pe.fog,
      {
        matcap: { value: null }
      }
    ]),
    vertexShader: $e.meshmatcap_vert,
    fragmentShader: $e.meshmatcap_frag
  },
  points: {
    uniforms: /* @__PURE__ */ sn([
      pe.points,
      pe.fog
    ]),
    vertexShader: $e.points_vert,
    fragmentShader: $e.points_frag
  },
  dashed: {
    uniforms: /* @__PURE__ */ sn([
      pe.common,
      pe.fog,
      {
        scale: { value: 1 },
        dashSize: { value: 1 },
        totalSize: { value: 2 }
      }
    ]),
    vertexShader: $e.linedashed_vert,
    fragmentShader: $e.linedashed_frag
  },
  depth: {
    uniforms: /* @__PURE__ */ sn([
      pe.common,
      pe.displacementmap
    ]),
    vertexShader: $e.depth_vert,
    fragmentShader: $e.depth_frag
  },
  normal: {
    uniforms: /* @__PURE__ */ sn([
      pe.common,
      pe.bumpmap,
      pe.normalmap,
      pe.displacementmap,
      {
        opacity: { value: 1 }
      }
    ]),
    vertexShader: $e.meshnormal_vert,
    fragmentShader: $e.meshnormal_frag
  },
  sprite: {
    uniforms: /* @__PURE__ */ sn([
      pe.sprite,
      pe.fog
    ]),
    vertexShader: $e.sprite_vert,
    fragmentShader: $e.sprite_frag
  },
  background: {
    uniforms: {
      uvTransform: { value: /* @__PURE__ */ new Ke() },
      t2D: { value: null },
      backgroundIntensity: { value: 1 }
    },
    vertexShader: $e.background_vert,
    fragmentShader: $e.background_frag
  },
  backgroundCube: {
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 },
      backgroundBlurriness: { value: 0 },
      backgroundIntensity: { value: 1 },
      backgroundRotation: { value: /* @__PURE__ */ new Ke() }
    },
    vertexShader: $e.backgroundCube_vert,
    fragmentShader: $e.backgroundCube_frag
  },
  cube: {
    uniforms: {
      tCube: { value: null },
      tFlip: { value: -1 },
      opacity: { value: 1 }
    },
    vertexShader: $e.cube_vert,
    fragmentShader: $e.cube_frag
  },
  equirect: {
    uniforms: {
      tEquirect: { value: null }
    },
    vertexShader: $e.equirect_vert,
    fragmentShader: $e.equirect_frag
  },
  distanceRGBA: {
    uniforms: /* @__PURE__ */ sn([
      pe.common,
      pe.displacementmap,
      {
        referencePosition: { value: /* @__PURE__ */ new T() },
        nearDistance: { value: 1 },
        farDistance: { value: 1e3 }
      }
    ]),
    vertexShader: $e.distanceRGBA_vert,
    fragmentShader: $e.distanceRGBA_frag
  },
  shadow: {
    uniforms: /* @__PURE__ */ sn([
      pe.lights,
      pe.fog,
      {
        color: { value: /* @__PURE__ */ new He(0) },
        opacity: { value: 1 }
      }
    ]),
    vertexShader: $e.shadow_vert,
    fragmentShader: $e.shadow_frag
  }
};
cn.physical = {
  uniforms: /* @__PURE__ */ sn([
    cn.standard.uniforms,
    {
      clearcoat: { value: 0 },
      clearcoatMap: { value: null },
      clearcoatMapTransform: { value: /* @__PURE__ */ new Ke() },
      clearcoatNormalMap: { value: null },
      clearcoatNormalMapTransform: { value: /* @__PURE__ */ new Ke() },
      clearcoatNormalScale: { value: /* @__PURE__ */ new ze(1, 1) },
      clearcoatRoughness: { value: 0 },
      clearcoatRoughnessMap: { value: null },
      clearcoatRoughnessMapTransform: { value: /* @__PURE__ */ new Ke() },
      dispersion: { value: 0 },
      iridescence: { value: 0 },
      iridescenceMap: { value: null },
      iridescenceMapTransform: { value: /* @__PURE__ */ new Ke() },
      iridescenceIOR: { value: 1.3 },
      iridescenceThicknessMinimum: { value: 100 },
      iridescenceThicknessMaximum: { value: 400 },
      iridescenceThicknessMap: { value: null },
      iridescenceThicknessMapTransform: { value: /* @__PURE__ */ new Ke() },
      sheen: { value: 0 },
      sheenColor: { value: /* @__PURE__ */ new He(0) },
      sheenColorMap: { value: null },
      sheenColorMapTransform: { value: /* @__PURE__ */ new Ke() },
      sheenRoughness: { value: 1 },
      sheenRoughnessMap: { value: null },
      sheenRoughnessMapTransform: { value: /* @__PURE__ */ new Ke() },
      transmission: { value: 0 },
      transmissionMap: { value: null },
      transmissionMapTransform: { value: /* @__PURE__ */ new Ke() },
      transmissionSamplerSize: { value: /* @__PURE__ */ new ze() },
      transmissionSamplerMap: { value: null },
      thickness: { value: 0 },
      thicknessMap: { value: null },
      thicknessMapTransform: { value: /* @__PURE__ */ new Ke() },
      attenuationDistance: { value: 0 },
      attenuationColor: { value: /* @__PURE__ */ new He(0) },
      specularColor: { value: /* @__PURE__ */ new He(1, 1, 1) },
      specularColorMap: { value: null },
      specularColorMapTransform: { value: /* @__PURE__ */ new Ke() },
      specularIntensity: { value: 1 },
      specularIntensityMap: { value: null },
      specularIntensityMapTransform: { value: /* @__PURE__ */ new Ke() },
      anisotropyVector: { value: /* @__PURE__ */ new ze() },
      anisotropyMap: { value: null },
      anisotropyMapTransform: { value: /* @__PURE__ */ new Ke() }
    }
  ]),
  vertexShader: $e.meshphysical_vert,
  fragmentShader: $e.meshphysical_frag
};
const ia = { r: 0, b: 0, g: 0 }, Gi = /* @__PURE__ */ new Yn(), I_ = /* @__PURE__ */ new Ye();
function D_(s, e, t, n, i, r, a) {
  const o = new He(0);
  let l = r === !0 ? 0 : 1, c, u, h = null, d = 0, f = null;
  function m(S) {
    let x = S.isScene === !0 ? S.background : null;
    return x && x.isTexture && (x = (S.backgroundBlurriness > 0 ? t : e).get(x)), x;
  }
  function _(S) {
    let x = !1;
    const R = m(S);
    R === null ? p(o, l) : R && R.isColor && (p(R, 1), x = !0);
    const w = s.xr.getEnvironmentBlendMode();
    w === "additive" ? n.buffers.color.setClear(0, 0, 0, 1, a) : w === "alpha-blend" && n.buffers.color.setClear(0, 0, 0, 0, a), (s.autoClear || x) && (n.buffers.depth.setTest(!0), n.buffers.depth.setMask(!0), n.buffers.color.setMask(!0), s.clear(s.autoClearColor, s.autoClearDepth, s.autoClearStencil));
  }
  function g(S, x) {
    const R = m(x);
    R && (R.isCubeTexture || R.mapping === Pa) ? (u === void 0 && (u = new xt(
      new Vs(1, 1, 1),
      new jn({
        name: "BackgroundCubeMaterial",
        uniforms: Bs(cn.backgroundCube.uniforms),
        vertexShader: cn.backgroundCube.vertexShader,
        fragmentShader: cn.backgroundCube.fragmentShader,
        side: an,
        depthTest: !1,
        depthWrite: !1,
        fog: !1,
        allowOverride: !1
      })
    ), u.geometry.deleteAttribute("normal"), u.geometry.deleteAttribute("uv"), u.onBeforeRender = function(w, C, P) {
      this.matrixWorld.copyPosition(P.matrixWorld);
    }, Object.defineProperty(u.material, "envMap", {
      get: function() {
        return this.uniforms.envMap.value;
      }
    }), i.update(u)), Gi.copy(x.backgroundRotation), Gi.x *= -1, Gi.y *= -1, Gi.z *= -1, R.isCubeTexture && R.isRenderTargetTexture === !1 && (Gi.y *= -1, Gi.z *= -1), u.material.uniforms.envMap.value = R, u.material.uniforms.flipEnvMap.value = R.isCubeTexture && R.isRenderTargetTexture === !1 ? -1 : 1, u.material.uniforms.backgroundBlurriness.value = x.backgroundBlurriness, u.material.uniforms.backgroundIntensity.value = x.backgroundIntensity, u.material.uniforms.backgroundRotation.value.setFromMatrix4(I_.makeRotationFromEuler(Gi)), u.material.toneMapped = ot.getTransfer(R.colorSpace) !== vt, (h !== R || d !== R.version || f !== s.toneMapping) && (u.material.needsUpdate = !0, h = R, d = R.version, f = s.toneMapping), u.layers.enableAll(), S.unshift(u, u.geometry, u.material, 0, 0, null)) : R && R.isTexture && (c === void 0 && (c = new xt(
      new Gs(2, 2),
      new jn({
        name: "BackgroundMaterial",
        uniforms: Bs(cn.background.uniforms),
        vertexShader: cn.background.vertexShader,
        fragmentShader: cn.background.fragmentShader,
        side: gi,
        depthTest: !1,
        depthWrite: !1,
        fog: !1,
        allowOverride: !1
      })
    ), c.geometry.deleteAttribute("normal"), Object.defineProperty(c.material, "map", {
      get: function() {
        return this.uniforms.t2D.value;
      }
    }), i.update(c)), c.material.uniforms.t2D.value = R, c.material.uniforms.backgroundIntensity.value = x.backgroundIntensity, c.material.toneMapped = ot.getTransfer(R.colorSpace) !== vt, R.matrixAutoUpdate === !0 && R.updateMatrix(), c.material.uniforms.uvTransform.value.copy(R.matrix), (h !== R || d !== R.version || f !== s.toneMapping) && (c.material.needsUpdate = !0, h = R, d = R.version, f = s.toneMapping), c.layers.enableAll(), S.unshift(c, c.geometry, c.material, 0, 0, null));
  }
  function p(S, x) {
    S.getRGB(ia, zh(s)), n.buffers.color.setClear(ia.r, ia.g, ia.b, x, a);
  }
  function M() {
    u !== void 0 && (u.geometry.dispose(), u.material.dispose(), u = void 0), c !== void 0 && (c.geometry.dispose(), c.material.dispose(), c = void 0);
  }
  return {
    getClearColor: function() {
      return o;
    },
    setClearColor: function(S, x = 1) {
      o.set(S), l = x, p(o, l);
    },
    getClearAlpha: function() {
      return l;
    },
    setClearAlpha: function(S) {
      l = S, p(o, l);
    },
    render: _,
    addToRenderList: g,
    dispose: M
  };
}
function N_(s, e) {
  const t = s.getParameter(s.MAX_VERTEX_ATTRIBS), n = {}, i = d(null);
  let r = i, a = !1;
  function o(y, L, O, U, N) {
    let Y = !1;
    const G = h(U, O, L);
    r !== G && (r = G, c(r.object)), Y = f(y, U, O, N), Y && m(y, U, O, N), N !== null && e.update(N, s.ELEMENT_ARRAY_BUFFER), (Y || a) && (a = !1, x(y, L, O, U), N !== null && s.bindBuffer(s.ELEMENT_ARRAY_BUFFER, e.get(N).buffer));
  }
  function l() {
    return s.createVertexArray();
  }
  function c(y) {
    return s.bindVertexArray(y);
  }
  function u(y) {
    return s.deleteVertexArray(y);
  }
  function h(y, L, O) {
    const U = O.wireframe === !0;
    let N = n[y.id];
    N === void 0 && (N = {}, n[y.id] = N);
    let Y = N[L.id];
    Y === void 0 && (Y = {}, N[L.id] = Y);
    let G = Y[U];
    return G === void 0 && (G = d(l()), Y[U] = G), G;
  }
  function d(y) {
    const L = [], O = [], U = [];
    for (let N = 0; N < t; N++)
      L[N] = 0, O[N] = 0, U[N] = 0;
    return {
      // for backward compatibility on non-VAO support browser
      geometry: null,
      program: null,
      wireframe: !1,
      newAttributes: L,
      enabledAttributes: O,
      attributeDivisors: U,
      object: y,
      attributes: {},
      index: null
    };
  }
  function f(y, L, O, U) {
    const N = r.attributes, Y = L.attributes;
    let G = 0;
    const ne = O.getAttributes();
    for (const B in ne)
      if (ne[B].location >= 0) {
        const Q = N[B];
        let xe = Y[B];
        if (xe === void 0 && (B === "instanceMatrix" && y.instanceMatrix && (xe = y.instanceMatrix), B === "instanceColor" && y.instanceColor && (xe = y.instanceColor)), Q === void 0 || Q.attribute !== xe || xe && Q.data !== xe.data) return !0;
        G++;
      }
    return r.attributesNum !== G || r.index !== U;
  }
  function m(y, L, O, U) {
    const N = {}, Y = L.attributes;
    let G = 0;
    const ne = O.getAttributes();
    for (const B in ne)
      if (ne[B].location >= 0) {
        let Q = Y[B];
        Q === void 0 && (B === "instanceMatrix" && y.instanceMatrix && (Q = y.instanceMatrix), B === "instanceColor" && y.instanceColor && (Q = y.instanceColor));
        const xe = {};
        xe.attribute = Q, Q && Q.data && (xe.data = Q.data), N[B] = xe, G++;
      }
    r.attributes = N, r.attributesNum = G, r.index = U;
  }
  function _() {
    const y = r.newAttributes;
    for (let L = 0, O = y.length; L < O; L++)
      y[L] = 0;
  }
  function g(y) {
    p(y, 0);
  }
  function p(y, L) {
    const O = r.newAttributes, U = r.enabledAttributes, N = r.attributeDivisors;
    O[y] = 1, U[y] === 0 && (s.enableVertexAttribArray(y), U[y] = 1), N[y] !== L && (s.vertexAttribDivisor(y, L), N[y] = L);
  }
  function M() {
    const y = r.newAttributes, L = r.enabledAttributes;
    for (let O = 0, U = L.length; O < U; O++)
      L[O] !== y[O] && (s.disableVertexAttribArray(O), L[O] = 0);
  }
  function S(y, L, O, U, N, Y, G) {
    G === !0 ? s.vertexAttribIPointer(y, L, O, N, Y) : s.vertexAttribPointer(y, L, O, U, N, Y);
  }
  function x(y, L, O, U) {
    _();
    const N = U.attributes, Y = O.getAttributes(), G = L.defaultAttributeValues;
    for (const ne in Y) {
      const B = Y[ne];
      if (B.location >= 0) {
        let Z = N[ne];
        if (Z === void 0 && (ne === "instanceMatrix" && y.instanceMatrix && (Z = y.instanceMatrix), ne === "instanceColor" && y.instanceColor && (Z = y.instanceColor)), Z !== void 0) {
          const Q = Z.normalized, xe = Z.itemSize, ye = e.get(Z);
          if (ye === void 0) continue;
          const ce = ye.buffer, V = ye.type, se = ye.bytesPerElement, re = V === s.INT || V === s.UNSIGNED_INT || Z.gpuType === Dl;
          if (Z.isInterleavedBufferAttribute) {
            const X = Z.data, de = X.stride, be = Z.offset;
            if (X.isInstancedInterleavedBuffer) {
              for (let Le = 0; Le < B.locationSize; Le++)
                p(B.location + Le, X.meshPerAttribute);
              y.isInstancedMesh !== !0 && U._maxInstanceCount === void 0 && (U._maxInstanceCount = X.meshPerAttribute * X.count);
            } else
              for (let Le = 0; Le < B.locationSize; Le++)
                g(B.location + Le);
            s.bindBuffer(s.ARRAY_BUFFER, ce);
            for (let Le = 0; Le < B.locationSize; Le++)
              S(
                B.location + Le,
                xe / B.locationSize,
                V,
                Q,
                de * se,
                (be + xe / B.locationSize * Le) * se,
                re
              );
          } else {
            if (Z.isInstancedBufferAttribute) {
              for (let X = 0; X < B.locationSize; X++)
                p(B.location + X, Z.meshPerAttribute);
              y.isInstancedMesh !== !0 && U._maxInstanceCount === void 0 && (U._maxInstanceCount = Z.meshPerAttribute * Z.count);
            } else
              for (let X = 0; X < B.locationSize; X++)
                g(B.location + X);
            s.bindBuffer(s.ARRAY_BUFFER, ce);
            for (let X = 0; X < B.locationSize; X++)
              S(
                B.location + X,
                xe / B.locationSize,
                V,
                Q,
                xe * se,
                xe / B.locationSize * X * se,
                re
              );
          }
        } else if (G !== void 0) {
          const Q = G[ne];
          if (Q !== void 0)
            switch (Q.length) {
              case 2:
                s.vertexAttrib2fv(B.location, Q);
                break;
              case 3:
                s.vertexAttrib3fv(B.location, Q);
                break;
              case 4:
                s.vertexAttrib4fv(B.location, Q);
                break;
              default:
                s.vertexAttrib1fv(B.location, Q);
            }
        }
      }
    }
    M();
  }
  function R() {
    P();
    for (const y in n) {
      const L = n[y];
      for (const O in L) {
        const U = L[O];
        for (const N in U)
          u(U[N].object), delete U[N];
        delete L[O];
      }
      delete n[y];
    }
  }
  function w(y) {
    if (n[y.id] === void 0) return;
    const L = n[y.id];
    for (const O in L) {
      const U = L[O];
      for (const N in U)
        u(U[N].object), delete U[N];
      delete L[O];
    }
    delete n[y.id];
  }
  function C(y) {
    for (const L in n) {
      const O = n[L];
      if (O[y.id] === void 0) continue;
      const U = O[y.id];
      for (const N in U)
        u(U[N].object), delete U[N];
      delete O[y.id];
    }
  }
  function P() {
    b(), a = !0, r !== i && (r = i, c(r.object));
  }
  function b() {
    i.geometry = null, i.program = null, i.wireframe = !1;
  }
  return {
    setup: o,
    reset: P,
    resetDefaultState: b,
    dispose: R,
    releaseStatesOfGeometry: w,
    releaseStatesOfProgram: C,
    initAttributes: _,
    enableAttribute: g,
    disableUnusedAttributes: M
  };
}
function U_(s, e, t) {
  let n;
  function i(c) {
    n = c;
  }
  function r(c, u) {
    s.drawArrays(n, c, u), t.update(u, n, 1);
  }
  function a(c, u, h) {
    h !== 0 && (s.drawArraysInstanced(n, c, u, h), t.update(u, n, h));
  }
  function o(c, u, h) {
    if (h === 0) return;
    e.get("WEBGL_multi_draw").multiDrawArraysWEBGL(n, c, 0, u, 0, h);
    let f = 0;
    for (let m = 0; m < h; m++)
      f += u[m];
    t.update(f, n, 1);
  }
  function l(c, u, h, d) {
    if (h === 0) return;
    const f = e.get("WEBGL_multi_draw");
    if (f === null)
      for (let m = 0; m < c.length; m++)
        a(c[m], u[m], d[m]);
    else {
      f.multiDrawArraysInstancedWEBGL(n, c, 0, u, 0, d, 0, h);
      let m = 0;
      for (let _ = 0; _ < h; _++)
        m += u[_] * d[_];
      t.update(m, n, 1);
    }
  }
  this.setMode = i, this.render = r, this.renderInstances = a, this.renderMultiDraw = o, this.renderMultiDrawInstances = l;
}
function F_(s, e, t, n) {
  let i;
  function r() {
    if (i !== void 0) return i;
    if (e.has("EXT_texture_filter_anisotropic") === !0) {
      const C = e.get("EXT_texture_filter_anisotropic");
      i = s.getParameter(C.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    } else
      i = 0;
    return i;
  }
  function a(C) {
    return !(C !== mn && n.convert(C) !== s.getParameter(s.IMPLEMENTATION_COLOR_READ_FORMAT));
  }
  function o(C) {
    const P = C === Wn && (e.has("EXT_color_buffer_half_float") || e.has("EXT_color_buffer_float"));
    return !(C !== _i && n.convert(C) !== s.getParameter(s.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
    C !== hn && !P);
  }
  function l(C) {
    if (C === "highp") {
      if (s.getShaderPrecisionFormat(s.VERTEX_SHADER, s.HIGH_FLOAT).precision > 0 && s.getShaderPrecisionFormat(s.FRAGMENT_SHADER, s.HIGH_FLOAT).precision > 0)
        return "highp";
      C = "mediump";
    }
    return C === "mediump" && s.getShaderPrecisionFormat(s.VERTEX_SHADER, s.MEDIUM_FLOAT).precision > 0 && s.getShaderPrecisionFormat(s.FRAGMENT_SHADER, s.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
  }
  let c = t.precision !== void 0 ? t.precision : "highp";
  const u = l(c);
  u !== c && (console.warn("THREE.WebGLRenderer:", c, "not supported, using", u, "instead."), c = u);
  const h = t.logarithmicDepthBuffer === !0, d = t.reverseDepthBuffer === !0 && e.has("EXT_clip_control"), f = s.getParameter(s.MAX_TEXTURE_IMAGE_UNITS), m = s.getParameter(s.MAX_VERTEX_TEXTURE_IMAGE_UNITS), _ = s.getParameter(s.MAX_TEXTURE_SIZE), g = s.getParameter(s.MAX_CUBE_MAP_TEXTURE_SIZE), p = s.getParameter(s.MAX_VERTEX_ATTRIBS), M = s.getParameter(s.MAX_VERTEX_UNIFORM_VECTORS), S = s.getParameter(s.MAX_VARYING_VECTORS), x = s.getParameter(s.MAX_FRAGMENT_UNIFORM_VECTORS), R = m > 0, w = s.getParameter(s.MAX_SAMPLES);
  return {
    isWebGL2: !0,
    // keeping this for backwards compatibility
    getMaxAnisotropy: r,
    getMaxPrecision: l,
    textureFormatReadable: a,
    textureTypeReadable: o,
    precision: c,
    logarithmicDepthBuffer: h,
    reverseDepthBuffer: d,
    maxTextures: f,
    maxVertexTextures: m,
    maxTextureSize: _,
    maxCubemapSize: g,
    maxAttributes: p,
    maxVertexUniforms: M,
    maxVaryings: S,
    maxFragmentUniforms: x,
    vertexTextures: R,
    maxSamples: w
  };
}
function O_(s) {
  const e = this;
  let t = null, n = 0, i = !1, r = !1;
  const a = new wi(), o = new Ke(), l = { value: null, needsUpdate: !1 };
  this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function(h, d) {
    const f = h.length !== 0 || d || // enable state of previous frame - the clipping code has to
    // run another frame in order to reset the state:
    n !== 0 || i;
    return i = d, n = h.length, f;
  }, this.beginShadows = function() {
    r = !0, u(null);
  }, this.endShadows = function() {
    r = !1;
  }, this.setGlobalState = function(h, d) {
    t = u(h, d, 0);
  }, this.setState = function(h, d, f) {
    const m = h.clippingPlanes, _ = h.clipIntersection, g = h.clipShadows, p = s.get(h);
    if (!i || m === null || m.length === 0 || r && !g)
      r ? u(null) : c();
    else {
      const M = r ? 0 : n, S = M * 4;
      let x = p.clippingState || null;
      l.value = x, x = u(m, d, S, f);
      for (let R = 0; R !== S; ++R)
        x[R] = t[R];
      p.clippingState = x, this.numIntersection = _ ? this.numPlanes : 0, this.numPlanes += M;
    }
  };
  function c() {
    l.value !== t && (l.value = t, l.needsUpdate = n > 0), e.numPlanes = n, e.numIntersection = 0;
  }
  function u(h, d, f, m) {
    const _ = h !== null ? h.length : 0;
    let g = null;
    if (_ !== 0) {
      if (g = l.value, m !== !0 || g === null) {
        const p = f + _ * 4, M = d.matrixWorldInverse;
        o.getNormalMatrix(M), (g === null || g.length < p) && (g = new Float32Array(p));
        for (let S = 0, x = f; S !== _; ++S, x += 4)
          a.copy(h[S]).applyMatrix4(M, o), a.normal.toArray(g, x), g[x + 3] = a.constant;
      }
      l.value = g, l.needsUpdate = !0;
    }
    return e.numPlanes = _, e.numIntersection = 0, g;
  }
}
function B_(s) {
  let e = /* @__PURE__ */ new WeakMap();
  function t(a, o) {
    return o === Sa ? a.mapping = Ns : o === Xo && (a.mapping = Us), a;
  }
  function n(a) {
    if (a && a.isTexture) {
      const o = a.mapping;
      if (o === Sa || o === Xo)
        if (e.has(a)) {
          const l = e.get(a).texture;
          return t(l, a.mapping);
        } else {
          const l = a.image;
          if (l && l.height > 0) {
            const c = new Qf(l.height);
            return c.fromEquirectangularTexture(s, a), e.set(a, c), a.addEventListener("dispose", i), t(c.texture, a.mapping);
          } else
            return null;
        }
    }
    return a;
  }
  function i(a) {
    const o = a.target;
    o.removeEventListener("dispose", i);
    const l = e.get(o);
    l !== void 0 && (e.delete(o), l.dispose());
  }
  function r() {
    e = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: n,
    dispose: r
  };
}
const As = 4, pu = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582], Ki = 20, ho = /* @__PURE__ */ new Ia(), mu = /* @__PURE__ */ new He();
let fo = null, po = 0, mo = 0, go = !1;
const Yi = (1 + Math.sqrt(5)) / 2, gs = 1 / Yi, gu = [
  /* @__PURE__ */ new T(-Yi, gs, 0),
  /* @__PURE__ */ new T(Yi, gs, 0),
  /* @__PURE__ */ new T(-gs, 0, Yi),
  /* @__PURE__ */ new T(gs, 0, Yi),
  /* @__PURE__ */ new T(0, Yi, -gs),
  /* @__PURE__ */ new T(0, Yi, gs),
  /* @__PURE__ */ new T(-1, 1, -1),
  /* @__PURE__ */ new T(1, 1, -1),
  /* @__PURE__ */ new T(-1, 1, 1),
  /* @__PURE__ */ new T(1, 1, 1)
], k_ = /* @__PURE__ */ new T();
class El {
  /**
   * Constructs a new PMREM generator.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   */
  constructor(e) {
    this._renderer = e, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
  }
  /**
   * Generates a PMREM from a supplied Scene, which can be faster than using an
   * image if networking bandwidth is low. Optional sigma specifies a blur radius
   * in radians to be applied to the scene before PMREM generation. Optional near
   * and far planes ensure the scene is rendered in its entirety.
   *
   * @param {Scene} scene - The scene to be captured.
   * @param {number} [sigma=0] - The blur radius in radians.
   * @param {number} [near=0.1] - The near plane distance.
   * @param {number} [far=100] - The far plane distance.
   * @param {Object} [options={}] - The configuration options.
   * @param {number} [options.size=256] - The texture size of the PMREM.
   * @param {Vector3} [options.renderTarget=origin] - The position of the internal cube camera that renders the scene.
   * @return {WebGLRenderTarget} The resulting PMREM.
   */
  fromScene(e, t = 0, n = 0.1, i = 100, r = {}) {
    const {
      size: a = 256,
      position: o = k_
    } = r;
    fo = this._renderer.getRenderTarget(), po = this._renderer.getActiveCubeFace(), mo = this._renderer.getActiveMipmapLevel(), go = this._renderer.xr.enabled, this._renderer.xr.enabled = !1, this._setSize(a);
    const l = this._allocateTargets();
    return l.depthBuffer = !0, this._sceneToCubeUV(e, n, i, l, o), t > 0 && this._blur(l, 0, 0, t), this._applyPMREM(l), this._cleanup(l), l;
  }
  /**
   * Generates a PMREM from an equirectangular texture, which can be either LDR
   * or HDR. The ideal input image size is 1k (1024 x 512),
   * as this matches best with the 256 x 256 cubemap output.
   *
   * @param {Texture} equirectangular - The equirectangular texture to be converted.
   * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
   * @return {WebGLRenderTarget} The resulting PMREM.
   */
  fromEquirectangular(e, t = null) {
    return this._fromTexture(e, t);
  }
  /**
   * Generates a PMREM from an cubemap texture, which can be either LDR
   * or HDR. The ideal input cube size is 256 x 256,
   * as this matches best with the 256 x 256 cubemap output.
   *
   * @param {Texture} cubemap - The cubemap texture to be converted.
   * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
   * @return {WebGLRenderTarget} The resulting PMREM.
   */
  fromCubemap(e, t = null) {
    return this._fromTexture(e, t);
  }
  /**
   * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileCubemapShader() {
    this._cubemapMaterial === null && (this._cubemapMaterial = vu(), this._compileMaterial(this._cubemapMaterial));
  }
  /**
   * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileEquirectangularShader() {
    this._equirectMaterial === null && (this._equirectMaterial = xu(), this._compileMaterial(this._equirectMaterial));
  }
  /**
   * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
   * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
   * one of them will cause any others to also become unusable.
   */
  dispose() {
    this._dispose(), this._cubemapMaterial !== null && this._cubemapMaterial.dispose(), this._equirectMaterial !== null && this._equirectMaterial.dispose();
  }
  // private interface
  _setSize(e) {
    this._lodMax = Math.floor(Math.log2(e)), this._cubeSize = Math.pow(2, this._lodMax);
  }
  _dispose() {
    this._blurMaterial !== null && this._blurMaterial.dispose(), this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
    for (let e = 0; e < this._lodPlanes.length; e++)
      this._lodPlanes[e].dispose();
  }
  _cleanup(e) {
    this._renderer.setRenderTarget(fo, po, mo), this._renderer.xr.enabled = go, e.scissorTest = !1, sa(e, 0, 0, e.width, e.height);
  }
  _fromTexture(e, t) {
    e.mapping === Ns || e.mapping === Us ? this._setSize(e.image.length === 0 ? 16 : e.image[0].width || e.image[0].image.width) : this._setSize(e.image.width / 4), fo = this._renderer.getRenderTarget(), po = this._renderer.getActiveCubeFace(), mo = this._renderer.getActiveMipmapLevel(), go = this._renderer.xr.enabled, this._renderer.xr.enabled = !1;
    const n = t || this._allocateTargets();
    return this._textureToCubeUV(e, n), this._applyPMREM(n), this._cleanup(n), n;
  }
  _allocateTargets() {
    const e = 3 * Math.max(this._cubeSize, 112), t = 4 * this._cubeSize, n = {
      magFilter: Vt,
      minFilter: Vt,
      generateMipmaps: !1,
      type: Wn,
      format: mn,
      colorSpace: Zt,
      depthBuffer: !1
    }, i = _u(e, t, n);
    if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== e || this._pingPongRenderTarget.height !== t) {
      this._pingPongRenderTarget !== null && this._dispose(), this._pingPongRenderTarget = _u(e, t, n);
      const { _lodMax: r } = this;
      ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = z_(r)), this._blurMaterial = H_(r, e, t);
    }
    return i;
  }
  _compileMaterial(e) {
    const t = new xt(this._lodPlanes[0], e);
    this._renderer.compile(t, ho);
  }
  _sceneToCubeUV(e, t, n, i, r) {
    const l = new rn(90, 1, t, n), c = [1, -1, 1, 1, 1, 1], u = [1, 1, 1, -1, -1, -1], h = this._renderer, d = h.autoClear, f = h.toneMapping;
    h.getClearColor(mu), h.toneMapping = Li, h.autoClear = !1;
    const m = new hi({
      name: "PMREM.Background",
      side: an,
      depthWrite: !1,
      depthTest: !1
    }), _ = new xt(new Vs(), m);
    let g = !1;
    const p = e.background;
    p ? p.isColor && (m.color.copy(p), e.background = null, g = !0) : (m.color.copy(mu), g = !0);
    for (let M = 0; M < 6; M++) {
      const S = M % 3;
      S === 0 ? (l.up.set(0, c[M], 0), l.position.set(r.x, r.y, r.z), l.lookAt(r.x + u[M], r.y, r.z)) : S === 1 ? (l.up.set(0, 0, c[M]), l.position.set(r.x, r.y, r.z), l.lookAt(r.x, r.y + u[M], r.z)) : (l.up.set(0, c[M], 0), l.position.set(r.x, r.y, r.z), l.lookAt(r.x, r.y, r.z + u[M]));
      const x = this._cubeSize;
      sa(i, S * x, M > 2 ? x : 0, x, x), h.setRenderTarget(i), g && h.render(_, l), h.render(e, l);
    }
    _.geometry.dispose(), _.material.dispose(), h.toneMapping = f, h.autoClear = d, e.background = p;
  }
  _textureToCubeUV(e, t) {
    const n = this._renderer, i = e.mapping === Ns || e.mapping === Us;
    i ? (this._cubemapMaterial === null && (this._cubemapMaterial = vu()), this._cubemapMaterial.uniforms.flipEnvMap.value = e.isRenderTargetTexture === !1 ? -1 : 1) : this._equirectMaterial === null && (this._equirectMaterial = xu());
    const r = i ? this._cubemapMaterial : this._equirectMaterial, a = new xt(this._lodPlanes[0], r), o = r.uniforms;
    o.envMap.value = e;
    const l = this._cubeSize;
    sa(t, 0, 0, 3 * l, 2 * l), n.setRenderTarget(t), n.render(a, ho);
  }
  _applyPMREM(e) {
    const t = this._renderer, n = t.autoClear;
    t.autoClear = !1;
    const i = this._lodPlanes.length;
    for (let r = 1; r < i; r++) {
      const a = Math.sqrt(this._sigmas[r] * this._sigmas[r] - this._sigmas[r - 1] * this._sigmas[r - 1]), o = gu[(i - r - 1) % gu.length];
      this._blur(e, r - 1, r, a, o);
    }
    t.autoClear = n;
  }
  /**
   * This is a two-pass Gaussian blur for a cubemap. Normally this is done
   * vertically and horizontally, but this breaks down on a cube. Here we apply
   * the blur latitudinally (around the poles), and then longitudinally (towards
   * the poles) to approximate the orthogonally-separable blur. It is least
   * accurate at the poles, but still does a decent job.
   *
   * @private
   * @param {WebGLRenderTarget} cubeUVRenderTarget
   * @param {number} lodIn
   * @param {number} lodOut
   * @param {number} sigma
   * @param {Vector3} [poleAxis]
   */
  _blur(e, t, n, i, r) {
    const a = this._pingPongRenderTarget;
    this._halfBlur(
      e,
      a,
      t,
      n,
      i,
      "latitudinal",
      r
    ), this._halfBlur(
      a,
      e,
      n,
      n,
      i,
      "longitudinal",
      r
    );
  }
  _halfBlur(e, t, n, i, r, a, o) {
    const l = this._renderer, c = this._blurMaterial;
    a !== "latitudinal" && a !== "longitudinal" && console.error(
      "blur direction must be either latitudinal or longitudinal!"
    );
    const u = 3, h = new xt(this._lodPlanes[i], c), d = c.uniforms, f = this._sizeLods[n] - 1, m = isFinite(r) ? Math.PI / (2 * f) : 2 * Math.PI / (2 * Ki - 1), _ = r / m, g = isFinite(r) ? 1 + Math.floor(u * _) : Ki;
    g > Ki && console.warn(`sigmaRadians, ${r}, is too large and will clip, as it requested ${g} samples when the maximum is set to ${Ki}`);
    const p = [];
    let M = 0;
    for (let C = 0; C < Ki; ++C) {
      const P = C / _, b = Math.exp(-P * P / 2);
      p.push(b), C === 0 ? M += b : C < g && (M += 2 * b);
    }
    for (let C = 0; C < p.length; C++)
      p[C] = p[C] / M;
    d.envMap.value = e.texture, d.samples.value = g, d.weights.value = p, d.latitudinal.value = a === "latitudinal", o && (d.poleAxis.value = o);
    const { _lodMax: S } = this;
    d.dTheta.value = m, d.mipInt.value = S - n;
    const x = this._sizeLods[i], R = 3 * x * (i > S - As ? i - S + As : 0), w = 4 * (this._cubeSize - x);
    sa(t, R, w, 3 * x, 2 * x), l.setRenderTarget(t), l.render(h, ho);
  }
}
function z_(s) {
  const e = [], t = [], n = [];
  let i = s;
  const r = s - As + 1 + pu.length;
  for (let a = 0; a < r; a++) {
    const o = Math.pow(2, i);
    t.push(o);
    let l = 1 / o;
    a > s - As ? l = pu[a - s + As - 1] : a === 0 && (l = 0), n.push(l);
    const c = 1 / (o - 2), u = -c, h = 1 + c, d = [u, u, h, u, h, h, u, u, h, h, u, h], f = 6, m = 6, _ = 3, g = 2, p = 1, M = new Float32Array(_ * m * f), S = new Float32Array(g * m * f), x = new Float32Array(p * m * f);
    for (let w = 0; w < f; w++) {
      const C = w % 3 * 2 / 3 - 1, P = w > 2 ? 0 : -1, b = [
        C,
        P,
        0,
        C + 2 / 3,
        P,
        0,
        C + 2 / 3,
        P + 1,
        0,
        C,
        P,
        0,
        C + 2 / 3,
        P + 1,
        0,
        C,
        P + 1,
        0
      ];
      M.set(b, _ * m * w), S.set(d, g * m * w);
      const y = [w, w, w, w, w, w];
      x.set(y, p * m * w);
    }
    const R = new _n();
    R.setAttribute("position", new Kt(M, _)), R.setAttribute("uv", new Kt(S, g)), R.setAttribute("faceIndex", new Kt(x, p)), e.push(R), i > As && i--;
  }
  return { lodPlanes: e, sizeLods: t, sigmas: n };
}
function _u(s, e, t) {
  const n = new Di(s, e, t);
  return n.texture.mapping = Pa, n.texture.name = "PMREM.cubeUv", n.scissorTest = !0, n;
}
function sa(s, e, t, n, i) {
  s.viewport.set(e, t, n, i), s.scissor.set(e, t, n, i);
}
function H_(s, e, t) {
  const n = new Float32Array(Ki), i = new T(0, 1, 0);
  return new jn({
    name: "SphericalGaussianBlur",
    defines: {
      n: Ki,
      CUBEUV_TEXEL_WIDTH: 1 / e,
      CUBEUV_TEXEL_HEIGHT: 1 / t,
      CUBEUV_MAX_MIP: `${s}.0`
    },
    uniforms: {
      envMap: { value: null },
      samples: { value: 1 },
      weights: { value: n },
      latitudinal: { value: !1 },
      dTheta: { value: 0 },
      mipInt: { value: 0 },
      poleAxis: { value: i }
    },
    vertexShader: ec(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`
    ),
    blending: Pi,
    depthTest: !1,
    depthWrite: !1
  });
}
function xu() {
  return new jn({
    name: "EquirectangularToCubeUV",
    uniforms: {
      envMap: { value: null }
    },
    vertexShader: ec(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`
    ),
    blending: Pi,
    depthTest: !1,
    depthWrite: !1
  });
}
function vu() {
  return new jn({
    name: "CubemapToCubeUV",
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 }
    },
    vertexShader: ec(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`
    ),
    blending: Pi,
    depthTest: !1,
    depthWrite: !1
  });
}
function ec() {
  return (
    /* glsl */
    `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`
  );
}
function V_(s) {
  let e = /* @__PURE__ */ new WeakMap(), t = null;
  function n(o) {
    if (o && o.isTexture) {
      const l = o.mapping, c = l === Sa || l === Xo, u = l === Ns || l === Us;
      if (c || u) {
        let h = e.get(o);
        const d = h !== void 0 ? h.texture.pmremVersion : 0;
        if (o.isRenderTargetTexture && o.pmremVersion !== d)
          return t === null && (t = new El(s)), h = c ? t.fromEquirectangular(o, h) : t.fromCubemap(o, h), h.texture.pmremVersion = o.pmremVersion, e.set(o, h), h.texture;
        if (h !== void 0)
          return h.texture;
        {
          const f = o.image;
          return c && f && f.height > 0 || u && f && i(f) ? (t === null && (t = new El(s)), h = c ? t.fromEquirectangular(o) : t.fromCubemap(o), h.texture.pmremVersion = o.pmremVersion, e.set(o, h), o.addEventListener("dispose", r), h.texture) : null;
        }
      }
    }
    return o;
  }
  function i(o) {
    let l = 0;
    const c = 6;
    for (let u = 0; u < c; u++)
      o[u] !== void 0 && l++;
    return l === c;
  }
  function r(o) {
    const l = o.target;
    l.removeEventListener("dispose", r);
    const c = e.get(l);
    c !== void 0 && (e.delete(l), c.dispose());
  }
  function a() {
    e = /* @__PURE__ */ new WeakMap(), t !== null && (t.dispose(), t = null);
  }
  return {
    get: n,
    dispose: a
  };
}
function G_(s) {
  const e = {};
  function t(n) {
    if (e[n] !== void 0)
      return e[n];
    let i;
    switch (n) {
      case "WEBGL_depth_texture":
        i = s.getExtension("WEBGL_depth_texture") || s.getExtension("MOZ_WEBGL_depth_texture") || s.getExtension("WEBKIT_WEBGL_depth_texture");
        break;
      case "EXT_texture_filter_anisotropic":
        i = s.getExtension("EXT_texture_filter_anisotropic") || s.getExtension("MOZ_EXT_texture_filter_anisotropic") || s.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
        break;
      case "WEBGL_compressed_texture_s3tc":
        i = s.getExtension("WEBGL_compressed_texture_s3tc") || s.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || s.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
        break;
      case "WEBGL_compressed_texture_pvrtc":
        i = s.getExtension("WEBGL_compressed_texture_pvrtc") || s.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
        break;
      default:
        i = s.getExtension(n);
    }
    return e[n] = i, i;
  }
  return {
    has: function(n) {
      return t(n) !== null;
    },
    init: function() {
      t("EXT_color_buffer_float"), t("WEBGL_clip_cull_distance"), t("OES_texture_float_linear"), t("EXT_color_buffer_half_float"), t("WEBGL_multisampled_render_to_texture"), t("WEBGL_render_shared_exponent");
    },
    get: function(n) {
      const i = t(n);
      return i === null && xa("THREE.WebGLRenderer: " + n + " extension not supported."), i;
    }
  };
}
function W_(s, e, t, n) {
  const i = {}, r = /* @__PURE__ */ new WeakMap();
  function a(h) {
    const d = h.target;
    d.index !== null && e.remove(d.index);
    for (const m in d.attributes)
      e.remove(d.attributes[m]);
    d.removeEventListener("dispose", a), delete i[d.id];
    const f = r.get(d);
    f && (e.remove(f), r.delete(d)), n.releaseStatesOfGeometry(d), d.isInstancedBufferGeometry === !0 && delete d._maxInstanceCount, t.memory.geometries--;
  }
  function o(h, d) {
    return i[d.id] === !0 || (d.addEventListener("dispose", a), i[d.id] = !0, t.memory.geometries++), d;
  }
  function l(h) {
    const d = h.attributes;
    for (const f in d)
      e.update(d[f], s.ARRAY_BUFFER);
  }
  function c(h) {
    const d = [], f = h.index, m = h.attributes.position;
    let _ = 0;
    if (f !== null) {
      const M = f.array;
      _ = f.version;
      for (let S = 0, x = M.length; S < x; S += 3) {
        const R = M[S + 0], w = M[S + 1], C = M[S + 2];
        d.push(R, w, w, C, C, R);
      }
    } else if (m !== void 0) {
      const M = m.array;
      _ = m.version;
      for (let S = 0, x = M.length / 3 - 1; S < x; S += 3) {
        const R = S + 0, w = S + 1, C = S + 2;
        d.push(R, w, w, C, C, R);
      }
    } else
      return;
    const g = new (Nh(d) ? kh : Bh)(d, 1);
    g.version = _;
    const p = r.get(h);
    p && e.remove(p), r.set(h, g);
  }
  function u(h) {
    const d = r.get(h);
    if (d) {
      const f = h.index;
      f !== null && d.version < f.version && c(h);
    } else
      c(h);
    return r.get(h);
  }
  return {
    get: o,
    update: l,
    getWireframeAttribute: u
  };
}
function X_(s, e, t) {
  let n;
  function i(d) {
    n = d;
  }
  let r, a;
  function o(d) {
    r = d.type, a = d.bytesPerElement;
  }
  function l(d, f) {
    s.drawElements(n, f, r, d * a), t.update(f, n, 1);
  }
  function c(d, f, m) {
    m !== 0 && (s.drawElementsInstanced(n, f, r, d * a, m), t.update(f, n, m));
  }
  function u(d, f, m) {
    if (m === 0) return;
    e.get("WEBGL_multi_draw").multiDrawElementsWEBGL(n, f, 0, r, d, 0, m);
    let g = 0;
    for (let p = 0; p < m; p++)
      g += f[p];
    t.update(g, n, 1);
  }
  function h(d, f, m, _) {
    if (m === 0) return;
    const g = e.get("WEBGL_multi_draw");
    if (g === null)
      for (let p = 0; p < d.length; p++)
        c(d[p] / a, f[p], _[p]);
    else {
      g.multiDrawElementsInstancedWEBGL(n, f, 0, r, d, 0, _, 0, m);
      let p = 0;
      for (let M = 0; M < m; M++)
        p += f[M] * _[M];
      t.update(p, n, 1);
    }
  }
  this.setMode = i, this.setIndex = o, this.render = l, this.renderInstances = c, this.renderMultiDraw = u, this.renderMultiDrawInstances = h;
}
function q_(s) {
  const e = {
    geometries: 0,
    textures: 0
  }, t = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };
  function n(r, a, o) {
    switch (t.calls++, a) {
      case s.TRIANGLES:
        t.triangles += o * (r / 3);
        break;
      case s.LINES:
        t.lines += o * (r / 2);
        break;
      case s.LINE_STRIP:
        t.lines += o * (r - 1);
        break;
      case s.LINE_LOOP:
        t.lines += o * r;
        break;
      case s.POINTS:
        t.points += o * r;
        break;
      default:
        console.error("THREE.WebGLInfo: Unknown draw mode:", a);
        break;
    }
  }
  function i() {
    t.calls = 0, t.triangles = 0, t.points = 0, t.lines = 0;
  }
  return {
    memory: e,
    render: t,
    programs: null,
    autoReset: !0,
    reset: i,
    update: n
  };
}
function Y_(s, e, t) {
  const n = /* @__PURE__ */ new WeakMap(), i = new at();
  function r(a, o, l) {
    const c = a.morphTargetInfluences, u = o.morphAttributes.position || o.morphAttributes.normal || o.morphAttributes.color, h = u !== void 0 ? u.length : 0;
    let d = n.get(o);
    if (d === void 0 || d.count !== h) {
      let b = function() {
        C.dispose(), n.delete(o), o.removeEventListener("dispose", b);
      };
      d !== void 0 && d.texture.dispose();
      const f = o.morphAttributes.position !== void 0, m = o.morphAttributes.normal !== void 0, _ = o.morphAttributes.color !== void 0, g = o.morphAttributes.position || [], p = o.morphAttributes.normal || [], M = o.morphAttributes.color || [];
      let S = 0;
      f === !0 && (S = 1), m === !0 && (S = 2), _ === !0 && (S = 3);
      let x = o.attributes.position.count * S, R = 1;
      x > e.maxTextureSize && (R = Math.ceil(x / e.maxTextureSize), x = e.maxTextureSize);
      const w = new Float32Array(x * R * 4 * h), C = new Uh(w, x, R, h);
      C.type = hn, C.needsUpdate = !0;
      const P = S * 4;
      for (let y = 0; y < h; y++) {
        const L = g[y], O = p[y], U = M[y], N = x * R * 4 * y;
        for (let Y = 0; Y < L.count; Y++) {
          const G = Y * P;
          f === !0 && (i.fromBufferAttribute(L, Y), w[N + G + 0] = i.x, w[N + G + 1] = i.y, w[N + G + 2] = i.z, w[N + G + 3] = 0), m === !0 && (i.fromBufferAttribute(O, Y), w[N + G + 4] = i.x, w[N + G + 5] = i.y, w[N + G + 6] = i.z, w[N + G + 7] = 0), _ === !0 && (i.fromBufferAttribute(U, Y), w[N + G + 8] = i.x, w[N + G + 9] = i.y, w[N + G + 10] = i.z, w[N + G + 11] = U.itemSize === 4 ? i.w : 1);
        }
      }
      d = {
        count: h,
        texture: C,
        size: new ze(x, R)
      }, n.set(o, d), o.addEventListener("dispose", b);
    }
    if (a.isInstancedMesh === !0 && a.morphTexture !== null)
      l.getUniforms().setValue(s, "morphTexture", a.morphTexture, t);
    else {
      let f = 0;
      for (let _ = 0; _ < c.length; _++)
        f += c[_];
      const m = o.morphTargetsRelative ? 1 : 1 - f;
      l.getUniforms().setValue(s, "morphTargetBaseInfluence", m), l.getUniforms().setValue(s, "morphTargetInfluences", c);
    }
    l.getUniforms().setValue(s, "morphTargetsTexture", d.texture, t), l.getUniforms().setValue(s, "morphTargetsTextureSize", d.size);
  }
  return {
    update: r
  };
}
function j_(s, e, t, n) {
  let i = /* @__PURE__ */ new WeakMap();
  function r(l) {
    const c = n.render.frame, u = l.geometry, h = e.get(l, u);
    if (i.get(h) !== c && (e.update(h), i.set(h, c)), l.isInstancedMesh && (l.hasEventListener("dispose", o) === !1 && l.addEventListener("dispose", o), i.get(l) !== c && (t.update(l.instanceMatrix, s.ARRAY_BUFFER), l.instanceColor !== null && t.update(l.instanceColor, s.ARRAY_BUFFER), i.set(l, c))), l.isSkinnedMesh) {
      const d = l.skeleton;
      i.get(d) !== c && (d.update(), i.set(d, c));
    }
    return h;
  }
  function a() {
    i = /* @__PURE__ */ new WeakMap();
  }
  function o(l) {
    const c = l.target;
    c.removeEventListener("dispose", o), t.remove(c.instanceMatrix), c.instanceColor !== null && t.remove(c.instanceColor);
  }
  return {
    update: r,
    dispose: a
  };
}
const Jh = /* @__PURE__ */ new Gt(), yu = /* @__PURE__ */ new Zl(1, 1), Qh = /* @__PURE__ */ new Uh(), ed = /* @__PURE__ */ new Nf(), td = /* @__PURE__ */ new Vh(), Su = [], Mu = [], bu = new Float32Array(16), Eu = new Float32Array(9), Tu = new Float32Array(4);
function qs(s, e, t) {
  const n = s[0];
  if (n <= 0 || n > 0) return s;
  const i = e * t;
  let r = Su[i];
  if (r === void 0 && (r = new Float32Array(i), Su[i] = r), e !== 0) {
    n.toArray(r, 0);
    for (let a = 1, o = 0; a !== e; ++a)
      o += t, s[a].toArray(r, o);
  }
  return r;
}
function kt(s, e) {
  if (s.length !== e.length) return !1;
  for (let t = 0, n = s.length; t < n; t++)
    if (s[t] !== e[t]) return !1;
  return !0;
}
function zt(s, e) {
  for (let t = 0, n = e.length; t < n; t++)
    s[t] = e[t];
}
function Da(s, e) {
  let t = Mu[e];
  t === void 0 && (t = new Int32Array(e), Mu[e] = t);
  for (let n = 0; n !== e; ++n)
    t[n] = s.allocateTextureUnit();
  return t;
}
function K_(s, e) {
  const t = this.cache;
  t[0] !== e && (s.uniform1f(this.addr, e), t[0] = e);
}
function Z_(s, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y) && (s.uniform2f(this.addr, e.x, e.y), t[0] = e.x, t[1] = e.y);
  else {
    if (kt(t, e)) return;
    s.uniform2fv(this.addr, e), zt(t, e);
  }
}
function $_(s, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) && (s.uniform3f(this.addr, e.x, e.y, e.z), t[0] = e.x, t[1] = e.y, t[2] = e.z);
  else if (e.r !== void 0)
    (t[0] !== e.r || t[1] !== e.g || t[2] !== e.b) && (s.uniform3f(this.addr, e.r, e.g, e.b), t[0] = e.r, t[1] = e.g, t[2] = e.b);
  else {
    if (kt(t, e)) return;
    s.uniform3fv(this.addr, e), zt(t, e);
  }
}
function J_(s, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) && (s.uniform4f(this.addr, e.x, e.y, e.z, e.w), t[0] = e.x, t[1] = e.y, t[2] = e.z, t[3] = e.w);
  else {
    if (kt(t, e)) return;
    s.uniform4fv(this.addr, e), zt(t, e);
  }
}
function Q_(s, e) {
  const t = this.cache, n = e.elements;
  if (n === void 0) {
    if (kt(t, e)) return;
    s.uniformMatrix2fv(this.addr, !1, e), zt(t, e);
  } else {
    if (kt(t, n)) return;
    Tu.set(n), s.uniformMatrix2fv(this.addr, !1, Tu), zt(t, n);
  }
}
function e0(s, e) {
  const t = this.cache, n = e.elements;
  if (n === void 0) {
    if (kt(t, e)) return;
    s.uniformMatrix3fv(this.addr, !1, e), zt(t, e);
  } else {
    if (kt(t, n)) return;
    Eu.set(n), s.uniformMatrix3fv(this.addr, !1, Eu), zt(t, n);
  }
}
function t0(s, e) {
  const t = this.cache, n = e.elements;
  if (n === void 0) {
    if (kt(t, e)) return;
    s.uniformMatrix4fv(this.addr, !1, e), zt(t, e);
  } else {
    if (kt(t, n)) return;
    bu.set(n), s.uniformMatrix4fv(this.addr, !1, bu), zt(t, n);
  }
}
function n0(s, e) {
  const t = this.cache;
  t[0] !== e && (s.uniform1i(this.addr, e), t[0] = e);
}
function i0(s, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y) && (s.uniform2i(this.addr, e.x, e.y), t[0] = e.x, t[1] = e.y);
  else {
    if (kt(t, e)) return;
    s.uniform2iv(this.addr, e), zt(t, e);
  }
}
function s0(s, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) && (s.uniform3i(this.addr, e.x, e.y, e.z), t[0] = e.x, t[1] = e.y, t[2] = e.z);
  else {
    if (kt(t, e)) return;
    s.uniform3iv(this.addr, e), zt(t, e);
  }
}
function r0(s, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) && (s.uniform4i(this.addr, e.x, e.y, e.z, e.w), t[0] = e.x, t[1] = e.y, t[2] = e.z, t[3] = e.w);
  else {
    if (kt(t, e)) return;
    s.uniform4iv(this.addr, e), zt(t, e);
  }
}
function a0(s, e) {
  const t = this.cache;
  t[0] !== e && (s.uniform1ui(this.addr, e), t[0] = e);
}
function o0(s, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y) && (s.uniform2ui(this.addr, e.x, e.y), t[0] = e.x, t[1] = e.y);
  else {
    if (kt(t, e)) return;
    s.uniform2uiv(this.addr, e), zt(t, e);
  }
}
function l0(s, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) && (s.uniform3ui(this.addr, e.x, e.y, e.z), t[0] = e.x, t[1] = e.y, t[2] = e.z);
  else {
    if (kt(t, e)) return;
    s.uniform3uiv(this.addr, e), zt(t, e);
  }
}
function c0(s, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) && (s.uniform4ui(this.addr, e.x, e.y, e.z, e.w), t[0] = e.x, t[1] = e.y, t[2] = e.z, t[3] = e.w);
  else {
    if (kt(t, e)) return;
    s.uniform4uiv(this.addr, e), zt(t, e);
  }
}
function u0(s, e, t) {
  const n = this.cache, i = t.allocateTextureUnit();
  n[0] !== i && (s.uniform1i(this.addr, i), n[0] = i);
  let r;
  this.type === s.SAMPLER_2D_SHADOW ? (yu.compareFunction = Dh, r = yu) : r = Jh, t.setTexture2D(e || r, i);
}
function h0(s, e, t) {
  const n = this.cache, i = t.allocateTextureUnit();
  n[0] !== i && (s.uniform1i(this.addr, i), n[0] = i), t.setTexture3D(e || ed, i);
}
function d0(s, e, t) {
  const n = this.cache, i = t.allocateTextureUnit();
  n[0] !== i && (s.uniform1i(this.addr, i), n[0] = i), t.setTextureCube(e || td, i);
}
function f0(s, e, t) {
  const n = this.cache, i = t.allocateTextureUnit();
  n[0] !== i && (s.uniform1i(this.addr, i), n[0] = i), t.setTexture2DArray(e || Qh, i);
}
function p0(s) {
  switch (s) {
    case 5126:
      return K_;
    // FLOAT
    case 35664:
      return Z_;
    // _VEC2
    case 35665:
      return $_;
    // _VEC3
    case 35666:
      return J_;
    // _VEC4
    case 35674:
      return Q_;
    // _MAT2
    case 35675:
      return e0;
    // _MAT3
    case 35676:
      return t0;
    // _MAT4
    case 5124:
    case 35670:
      return n0;
    // INT, BOOL
    case 35667:
    case 35671:
      return i0;
    // _VEC2
    case 35668:
    case 35672:
      return s0;
    // _VEC3
    case 35669:
    case 35673:
      return r0;
    // _VEC4
    case 5125:
      return a0;
    // UINT
    case 36294:
      return o0;
    // _VEC2
    case 36295:
      return l0;
    // _VEC3
    case 36296:
      return c0;
    // _VEC4
    case 35678:
    // SAMPLER_2D
    case 36198:
    // SAMPLER_EXTERNAL_OES
    case 36298:
    // INT_SAMPLER_2D
    case 36306:
    // UNSIGNED_INT_SAMPLER_2D
    case 35682:
      return u0;
    case 35679:
    // SAMPLER_3D
    case 36299:
    // INT_SAMPLER_3D
    case 36307:
      return h0;
    case 35680:
    // SAMPLER_CUBE
    case 36300:
    // INT_SAMPLER_CUBE
    case 36308:
    // UNSIGNED_INT_SAMPLER_CUBE
    case 36293:
      return d0;
    case 36289:
    // SAMPLER_2D_ARRAY
    case 36303:
    // INT_SAMPLER_2D_ARRAY
    case 36311:
    // UNSIGNED_INT_SAMPLER_2D_ARRAY
    case 36292:
      return f0;
  }
}
function m0(s, e) {
  s.uniform1fv(this.addr, e);
}
function g0(s, e) {
  const t = qs(e, this.size, 2);
  s.uniform2fv(this.addr, t);
}
function _0(s, e) {
  const t = qs(e, this.size, 3);
  s.uniform3fv(this.addr, t);
}
function x0(s, e) {
  const t = qs(e, this.size, 4);
  s.uniform4fv(this.addr, t);
}
function v0(s, e) {
  const t = qs(e, this.size, 4);
  s.uniformMatrix2fv(this.addr, !1, t);
}
function y0(s, e) {
  const t = qs(e, this.size, 9);
  s.uniformMatrix3fv(this.addr, !1, t);
}
function S0(s, e) {
  const t = qs(e, this.size, 16);
  s.uniformMatrix4fv(this.addr, !1, t);
}
function M0(s, e) {
  s.uniform1iv(this.addr, e);
}
function b0(s, e) {
  s.uniform2iv(this.addr, e);
}
function E0(s, e) {
  s.uniform3iv(this.addr, e);
}
function T0(s, e) {
  s.uniform4iv(this.addr, e);
}
function A0(s, e) {
  s.uniform1uiv(this.addr, e);
}
function w0(s, e) {
  s.uniform2uiv(this.addr, e);
}
function R0(s, e) {
  s.uniform3uiv(this.addr, e);
}
function C0(s, e) {
  s.uniform4uiv(this.addr, e);
}
function P0(s, e, t) {
  const n = this.cache, i = e.length, r = Da(t, i);
  kt(n, r) || (s.uniform1iv(this.addr, r), zt(n, r));
  for (let a = 0; a !== i; ++a)
    t.setTexture2D(e[a] || Jh, r[a]);
}
function L0(s, e, t) {
  const n = this.cache, i = e.length, r = Da(t, i);
  kt(n, r) || (s.uniform1iv(this.addr, r), zt(n, r));
  for (let a = 0; a !== i; ++a)
    t.setTexture3D(e[a] || ed, r[a]);
}
function I0(s, e, t) {
  const n = this.cache, i = e.length, r = Da(t, i);
  kt(n, r) || (s.uniform1iv(this.addr, r), zt(n, r));
  for (let a = 0; a !== i; ++a)
    t.setTextureCube(e[a] || td, r[a]);
}
function D0(s, e, t) {
  const n = this.cache, i = e.length, r = Da(t, i);
  kt(n, r) || (s.uniform1iv(this.addr, r), zt(n, r));
  for (let a = 0; a !== i; ++a)
    t.setTexture2DArray(e[a] || Qh, r[a]);
}
function N0(s) {
  switch (s) {
    case 5126:
      return m0;
    // FLOAT
    case 35664:
      return g0;
    // _VEC2
    case 35665:
      return _0;
    // _VEC3
    case 35666:
      return x0;
    // _VEC4
    case 35674:
      return v0;
    // _MAT2
    case 35675:
      return y0;
    // _MAT3
    case 35676:
      return S0;
    // _MAT4
    case 5124:
    case 35670:
      return M0;
    // INT, BOOL
    case 35667:
    case 35671:
      return b0;
    // _VEC2
    case 35668:
    case 35672:
      return E0;
    // _VEC3
    case 35669:
    case 35673:
      return T0;
    // _VEC4
    case 5125:
      return A0;
    // UINT
    case 36294:
      return w0;
    // _VEC2
    case 36295:
      return R0;
    // _VEC3
    case 36296:
      return C0;
    // _VEC4
    case 35678:
    // SAMPLER_2D
    case 36198:
    // SAMPLER_EXTERNAL_OES
    case 36298:
    // INT_SAMPLER_2D
    case 36306:
    // UNSIGNED_INT_SAMPLER_2D
    case 35682:
      return P0;
    case 35679:
    // SAMPLER_3D
    case 36299:
    // INT_SAMPLER_3D
    case 36307:
      return L0;
    case 35680:
    // SAMPLER_CUBE
    case 36300:
    // INT_SAMPLER_CUBE
    case 36308:
    // UNSIGNED_INT_SAMPLER_CUBE
    case 36293:
      return I0;
    case 36289:
    // SAMPLER_2D_ARRAY
    case 36303:
    // INT_SAMPLER_2D_ARRAY
    case 36311:
    // UNSIGNED_INT_SAMPLER_2D_ARRAY
    case 36292:
      return D0;
  }
}
class U0 {
  constructor(e, t, n) {
    this.id = e, this.addr = n, this.cache = [], this.type = t.type, this.setValue = p0(t.type);
  }
}
class F0 {
  constructor(e, t, n) {
    this.id = e, this.addr = n, this.cache = [], this.type = t.type, this.size = t.size, this.setValue = N0(t.type);
  }
}
class O0 {
  constructor(e) {
    this.id = e, this.seq = [], this.map = {};
  }
  setValue(e, t, n) {
    const i = this.seq;
    for (let r = 0, a = i.length; r !== a; ++r) {
      const o = i[r];
      o.setValue(e, t[o.id], n);
    }
  }
}
const _o = /(\w+)(\])?(\[|\.)?/g;
function Au(s, e) {
  s.seq.push(e), s.map[e.id] = e;
}
function B0(s, e, t) {
  const n = s.name, i = n.length;
  for (_o.lastIndex = 0; ; ) {
    const r = _o.exec(n), a = _o.lastIndex;
    let o = r[1];
    const l = r[2] === "]", c = r[3];
    if (l && (o = o | 0), c === void 0 || c === "[" && a + 2 === i) {
      Au(t, c === void 0 ? new U0(o, s, e) : new F0(o, s, e));
      break;
    } else {
      let h = t.map[o];
      h === void 0 && (h = new O0(o), Au(t, h)), t = h;
    }
  }
}
class va {
  constructor(e, t) {
    this.seq = [], this.map = {};
    const n = e.getProgramParameter(t, e.ACTIVE_UNIFORMS);
    for (let i = 0; i < n; ++i) {
      const r = e.getActiveUniform(t, i), a = e.getUniformLocation(t, r.name);
      B0(r, a, this);
    }
  }
  setValue(e, t, n, i) {
    const r = this.map[t];
    r !== void 0 && r.setValue(e, n, i);
  }
  setOptional(e, t, n) {
    const i = t[n];
    i !== void 0 && this.setValue(e, n, i);
  }
  static upload(e, t, n, i) {
    for (let r = 0, a = t.length; r !== a; ++r) {
      const o = t[r], l = n[o.id];
      l.needsUpdate !== !1 && o.setValue(e, l.value, i);
    }
  }
  static seqWithValue(e, t) {
    const n = [];
    for (let i = 0, r = e.length; i !== r; ++i) {
      const a = e[i];
      a.id in t && n.push(a);
    }
    return n;
  }
}
function wu(s, e, t) {
  const n = s.createShader(e);
  return s.shaderSource(n, t), s.compileShader(n), n;
}
const k0 = 37297;
let z0 = 0;
function H0(s, e) {
  const t = s.split(`
`), n = [], i = Math.max(e - 6, 0), r = Math.min(e + 6, t.length);
  for (let a = i; a < r; a++) {
    const o = a + 1;
    n.push(`${o === e ? ">" : " "} ${o}: ${t[a]}`);
  }
  return n.join(`
`);
}
const Ru = /* @__PURE__ */ new Ke();
function V0(s) {
  ot._getMatrix(Ru, ot.workingColorSpace, s);
  const e = `mat3( ${Ru.elements.map((t) => t.toFixed(4))} )`;
  switch (ot.getTransfer(s)) {
    case Ea:
      return [e, "LinearTransferOETF"];
    case vt:
      return [e, "sRGBTransferOETF"];
    default:
      return console.warn("THREE.WebGLProgram: Unsupported color space: ", s), [e, "LinearTransferOETF"];
  }
}
function Cu(s, e, t) {
  const n = s.getShaderParameter(e, s.COMPILE_STATUS), i = s.getShaderInfoLog(e).trim();
  if (n && i === "") return "";
  const r = /ERROR: 0:(\d+)/.exec(i);
  if (r) {
    const a = parseInt(r[1]);
    return t.toUpperCase() + `

` + i + `

` + H0(s.getShaderSource(e), a);
  } else
    return i;
}
function G0(s, e) {
  const t = V0(e);
  return [
    `vec4 ${s}( vec4 value ) {`,
    `	return ${t[1]}( vec4( value.rgb * ${t[0]}, value.a ) );`,
    "}"
  ].join(`
`);
}
function W0(s, e) {
  let t;
  switch (e) {
    case Hd:
      t = "Linear";
      break;
    case Vd:
      t = "Reinhard";
      break;
    case Gd:
      t = "Cineon";
      break;
    case xh:
      t = "ACESFilmic";
      break;
    case Xd:
      t = "AgX";
      break;
    case qd:
      t = "Neutral";
      break;
    case Wd:
      t = "Custom";
      break;
    default:
      console.warn("THREE.WebGLProgram: Unsupported toneMapping:", e), t = "Linear";
  }
  return "vec3 " + s + "( vec3 color ) { return " + t + "ToneMapping( color ); }";
}
const ra = /* @__PURE__ */ new T();
function X0() {
  ot.getLuminanceCoefficients(ra);
  const s = ra.x.toFixed(4), e = ra.y.toFixed(4), t = ra.z.toFixed(4);
  return [
    "float luminance( const in vec3 rgb ) {",
    `	const vec3 weights = vec3( ${s}, ${e}, ${t} );`,
    "	return dot( weights, rgb );",
    "}"
  ].join(`
`);
}
function q0(s) {
  return [
    s.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "",
    s.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""
  ].filter(hr).join(`
`);
}
function Y0(s) {
  const e = [];
  for (const t in s) {
    const n = s[t];
    n !== !1 && e.push("#define " + t + " " + n);
  }
  return e.join(`
`);
}
function j0(s, e) {
  const t = {}, n = s.getProgramParameter(e, s.ACTIVE_ATTRIBUTES);
  for (let i = 0; i < n; i++) {
    const r = s.getActiveAttrib(e, i), a = r.name;
    let o = 1;
    r.type === s.FLOAT_MAT2 && (o = 2), r.type === s.FLOAT_MAT3 && (o = 3), r.type === s.FLOAT_MAT4 && (o = 4), t[a] = {
      type: r.type,
      location: s.getAttribLocation(e, a),
      locationSize: o
    };
  }
  return t;
}
function hr(s) {
  return s !== "";
}
function Pu(s, e) {
  const t = e.numSpotLightShadows + e.numSpotLightMaps - e.numSpotLightShadowsWithMaps;
  return s.replace(/NUM_DIR_LIGHTS/g, e.numDirLights).replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, e.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, t).replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, e.numPointLights).replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, e.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows);
}
function Lu(s, e) {
  return s.replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection);
}
const K0 = /^[ \t]*#include +<([\w\d./]+)>/gm;
function Tl(s) {
  return s.replace(K0, $0);
}
const Z0 = /* @__PURE__ */ new Map();
function $0(s, e) {
  let t = $e[e];
  if (t === void 0) {
    const n = Z0.get(e);
    if (n !== void 0)
      t = $e[n], console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', e, n);
    else
      throw new Error("Can not resolve #include <" + e + ">");
  }
  return Tl(t);
}
const J0 = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function Iu(s) {
  return s.replace(J0, Q0);
}
function Q0(s, e, t, n) {
  let i = "";
  for (let r = parseInt(e); r < parseInt(t); r++)
    i += n.replace(/\[\s*i\s*\]/g, "[ " + r + " ]").replace(/UNROLLED_LOOP_INDEX/g, r);
  return i;
}
function Du(s) {
  let e = `precision ${s.precision} float;
	precision ${s.precision} int;
	precision ${s.precision} sampler2D;
	precision ${s.precision} samplerCube;
	precision ${s.precision} sampler3D;
	precision ${s.precision} sampler2DArray;
	precision ${s.precision} sampler2DShadow;
	precision ${s.precision} samplerCubeShadow;
	precision ${s.precision} sampler2DArrayShadow;
	precision ${s.precision} isampler2D;
	precision ${s.precision} isampler3D;
	precision ${s.precision} isamplerCube;
	precision ${s.precision} isampler2DArray;
	precision ${s.precision} usampler2D;
	precision ${s.precision} usampler3D;
	precision ${s.precision} usamplerCube;
	precision ${s.precision} usampler2DArray;
	`;
  return s.precision === "highp" ? e += `
#define HIGH_PRECISION` : s.precision === "mediump" ? e += `
#define MEDIUM_PRECISION` : s.precision === "lowp" && (e += `
#define LOW_PRECISION`), e;
}
function ex(s) {
  let e = "SHADOWMAP_TYPE_BASIC";
  return s.shadowMapType === gh ? e = "SHADOWMAP_TYPE_PCF" : s.shadowMapType === yd ? e = "SHADOWMAP_TYPE_PCF_SOFT" : s.shadowMapType === oi && (e = "SHADOWMAP_TYPE_VSM"), e;
}
function tx(s) {
  let e = "ENVMAP_TYPE_CUBE";
  if (s.envMap)
    switch (s.envMapMode) {
      case Ns:
      case Us:
        e = "ENVMAP_TYPE_CUBE";
        break;
      case Pa:
        e = "ENVMAP_TYPE_CUBE_UV";
        break;
    }
  return e;
}
function nx(s) {
  let e = "ENVMAP_MODE_REFLECTION";
  if (s.envMap)
    switch (s.envMapMode) {
      case Us:
        e = "ENVMAP_MODE_REFRACTION";
        break;
    }
  return e;
}
function ix(s) {
  let e = "ENVMAP_BLENDING_NONE";
  if (s.envMap)
    switch (s.combine) {
      case _h:
        e = "ENVMAP_BLENDING_MULTIPLY";
        break;
      case kd:
        e = "ENVMAP_BLENDING_MIX";
        break;
      case zd:
        e = "ENVMAP_BLENDING_ADD";
        break;
    }
  return e;
}
function sx(s) {
  const e = s.envMapCubeUVHeight;
  if (e === null) return null;
  const t = Math.log2(e) - 2, n = 1 / e;
  return { texelWidth: 1 / (3 * Math.max(Math.pow(2, t), 112)), texelHeight: n, maxMip: t };
}
function rx(s, e, t, n) {
  const i = s.getContext(), r = t.defines;
  let a = t.vertexShader, o = t.fragmentShader;
  const l = ex(t), c = tx(t), u = nx(t), h = ix(t), d = sx(t), f = q0(t), m = Y0(r), _ = i.createProgram();
  let g, p, M = t.glslVersion ? "#version " + t.glslVersion + `
` : "";
  t.isRawShaderMaterial ? (g = [
    "#define SHADER_TYPE " + t.shaderType,
    "#define SHADER_NAME " + t.shaderName,
    m
  ].filter(hr).join(`
`), g.length > 0 && (g += `
`), p = [
    "#define SHADER_TYPE " + t.shaderType,
    "#define SHADER_NAME " + t.shaderName,
    m
  ].filter(hr).join(`
`), p.length > 0 && (p += `
`)) : (g = [
    Du(t),
    "#define SHADER_TYPE " + t.shaderType,
    "#define SHADER_NAME " + t.shaderName,
    m,
    t.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
    t.batching ? "#define USE_BATCHING" : "",
    t.batchingColor ? "#define USE_BATCHING_COLOR" : "",
    t.instancing ? "#define USE_INSTANCING" : "",
    t.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
    t.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
    t.useFog && t.fog ? "#define USE_FOG" : "",
    t.useFog && t.fogExp2 ? "#define FOG_EXP2" : "",
    t.map ? "#define USE_MAP" : "",
    t.envMap ? "#define USE_ENVMAP" : "",
    t.envMap ? "#define " + u : "",
    t.lightMap ? "#define USE_LIGHTMAP" : "",
    t.aoMap ? "#define USE_AOMAP" : "",
    t.bumpMap ? "#define USE_BUMPMAP" : "",
    t.normalMap ? "#define USE_NORMALMAP" : "",
    t.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
    t.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
    t.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
    t.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
    t.anisotropy ? "#define USE_ANISOTROPY" : "",
    t.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
    t.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
    t.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
    t.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
    t.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
    t.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
    t.specularMap ? "#define USE_SPECULARMAP" : "",
    t.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
    t.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
    t.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
    t.metalnessMap ? "#define USE_METALNESSMAP" : "",
    t.alphaMap ? "#define USE_ALPHAMAP" : "",
    t.alphaHash ? "#define USE_ALPHAHASH" : "",
    t.transmission ? "#define USE_TRANSMISSION" : "",
    t.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
    t.thicknessMap ? "#define USE_THICKNESSMAP" : "",
    t.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
    t.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
    //
    t.mapUv ? "#define MAP_UV " + t.mapUv : "",
    t.alphaMapUv ? "#define ALPHAMAP_UV " + t.alphaMapUv : "",
    t.lightMapUv ? "#define LIGHTMAP_UV " + t.lightMapUv : "",
    t.aoMapUv ? "#define AOMAP_UV " + t.aoMapUv : "",
    t.emissiveMapUv ? "#define EMISSIVEMAP_UV " + t.emissiveMapUv : "",
    t.bumpMapUv ? "#define BUMPMAP_UV " + t.bumpMapUv : "",
    t.normalMapUv ? "#define NORMALMAP_UV " + t.normalMapUv : "",
    t.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + t.displacementMapUv : "",
    t.metalnessMapUv ? "#define METALNESSMAP_UV " + t.metalnessMapUv : "",
    t.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + t.roughnessMapUv : "",
    t.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + t.anisotropyMapUv : "",
    t.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + t.clearcoatMapUv : "",
    t.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + t.clearcoatNormalMapUv : "",
    t.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + t.clearcoatRoughnessMapUv : "",
    t.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + t.iridescenceMapUv : "",
    t.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + t.iridescenceThicknessMapUv : "",
    t.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + t.sheenColorMapUv : "",
    t.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + t.sheenRoughnessMapUv : "",
    t.specularMapUv ? "#define SPECULARMAP_UV " + t.specularMapUv : "",
    t.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + t.specularColorMapUv : "",
    t.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + t.specularIntensityMapUv : "",
    t.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + t.transmissionMapUv : "",
    t.thicknessMapUv ? "#define THICKNESSMAP_UV " + t.thicknessMapUv : "",
    //
    t.vertexTangents && t.flatShading === !1 ? "#define USE_TANGENT" : "",
    t.vertexColors ? "#define USE_COLOR" : "",
    t.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
    t.vertexUv1s ? "#define USE_UV1" : "",
    t.vertexUv2s ? "#define USE_UV2" : "",
    t.vertexUv3s ? "#define USE_UV3" : "",
    t.pointsUvs ? "#define USE_POINTS_UV" : "",
    t.flatShading ? "#define FLAT_SHADED" : "",
    t.skinning ? "#define USE_SKINNING" : "",
    t.morphTargets ? "#define USE_MORPHTARGETS" : "",
    t.morphNormals && t.flatShading === !1 ? "#define USE_MORPHNORMALS" : "",
    t.morphColors ? "#define USE_MORPHCOLORS" : "",
    t.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + t.morphTextureStride : "",
    t.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + t.morphTargetsCount : "",
    t.doubleSided ? "#define DOUBLE_SIDED" : "",
    t.flipSided ? "#define FLIP_SIDED" : "",
    t.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
    t.shadowMapEnabled ? "#define " + l : "",
    t.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
    t.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
    t.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
    t.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
    "uniform mat4 modelMatrix;",
    "uniform mat4 modelViewMatrix;",
    "uniform mat4 projectionMatrix;",
    "uniform mat4 viewMatrix;",
    "uniform mat3 normalMatrix;",
    "uniform vec3 cameraPosition;",
    "uniform bool isOrthographic;",
    "#ifdef USE_INSTANCING",
    "	attribute mat4 instanceMatrix;",
    "#endif",
    "#ifdef USE_INSTANCING_COLOR",
    "	attribute vec3 instanceColor;",
    "#endif",
    "#ifdef USE_INSTANCING_MORPH",
    "	uniform sampler2D morphTexture;",
    "#endif",
    "attribute vec3 position;",
    "attribute vec3 normal;",
    "attribute vec2 uv;",
    "#ifdef USE_UV1",
    "	attribute vec2 uv1;",
    "#endif",
    "#ifdef USE_UV2",
    "	attribute vec2 uv2;",
    "#endif",
    "#ifdef USE_UV3",
    "	attribute vec2 uv3;",
    "#endif",
    "#ifdef USE_TANGENT",
    "	attribute vec4 tangent;",
    "#endif",
    "#if defined( USE_COLOR_ALPHA )",
    "	attribute vec4 color;",
    "#elif defined( USE_COLOR )",
    "	attribute vec3 color;",
    "#endif",
    "#ifdef USE_SKINNING",
    "	attribute vec4 skinIndex;",
    "	attribute vec4 skinWeight;",
    "#endif",
    `
`
  ].filter(hr).join(`
`), p = [
    Du(t),
    "#define SHADER_TYPE " + t.shaderType,
    "#define SHADER_NAME " + t.shaderName,
    m,
    t.useFog && t.fog ? "#define USE_FOG" : "",
    t.useFog && t.fogExp2 ? "#define FOG_EXP2" : "",
    t.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
    t.map ? "#define USE_MAP" : "",
    t.matcap ? "#define USE_MATCAP" : "",
    t.envMap ? "#define USE_ENVMAP" : "",
    t.envMap ? "#define " + c : "",
    t.envMap ? "#define " + u : "",
    t.envMap ? "#define " + h : "",
    d ? "#define CUBEUV_TEXEL_WIDTH " + d.texelWidth : "",
    d ? "#define CUBEUV_TEXEL_HEIGHT " + d.texelHeight : "",
    d ? "#define CUBEUV_MAX_MIP " + d.maxMip + ".0" : "",
    t.lightMap ? "#define USE_LIGHTMAP" : "",
    t.aoMap ? "#define USE_AOMAP" : "",
    t.bumpMap ? "#define USE_BUMPMAP" : "",
    t.normalMap ? "#define USE_NORMALMAP" : "",
    t.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
    t.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
    t.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
    t.anisotropy ? "#define USE_ANISOTROPY" : "",
    t.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
    t.clearcoat ? "#define USE_CLEARCOAT" : "",
    t.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
    t.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
    t.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
    t.dispersion ? "#define USE_DISPERSION" : "",
    t.iridescence ? "#define USE_IRIDESCENCE" : "",
    t.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
    t.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
    t.specularMap ? "#define USE_SPECULARMAP" : "",
    t.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
    t.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
    t.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
    t.metalnessMap ? "#define USE_METALNESSMAP" : "",
    t.alphaMap ? "#define USE_ALPHAMAP" : "",
    t.alphaTest ? "#define USE_ALPHATEST" : "",
    t.alphaHash ? "#define USE_ALPHAHASH" : "",
    t.sheen ? "#define USE_SHEEN" : "",
    t.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
    t.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
    t.transmission ? "#define USE_TRANSMISSION" : "",
    t.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
    t.thicknessMap ? "#define USE_THICKNESSMAP" : "",
    t.vertexTangents && t.flatShading === !1 ? "#define USE_TANGENT" : "",
    t.vertexColors || t.instancingColor || t.batchingColor ? "#define USE_COLOR" : "",
    t.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
    t.vertexUv1s ? "#define USE_UV1" : "",
    t.vertexUv2s ? "#define USE_UV2" : "",
    t.vertexUv3s ? "#define USE_UV3" : "",
    t.pointsUvs ? "#define USE_POINTS_UV" : "",
    t.gradientMap ? "#define USE_GRADIENTMAP" : "",
    t.flatShading ? "#define FLAT_SHADED" : "",
    t.doubleSided ? "#define DOUBLE_SIDED" : "",
    t.flipSided ? "#define FLIP_SIDED" : "",
    t.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
    t.shadowMapEnabled ? "#define " + l : "",
    t.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
    t.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
    t.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
    t.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
    t.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
    t.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
    "uniform mat4 viewMatrix;",
    "uniform vec3 cameraPosition;",
    "uniform bool isOrthographic;",
    t.toneMapping !== Li ? "#define TONE_MAPPING" : "",
    t.toneMapping !== Li ? $e.tonemapping_pars_fragment : "",
    // this code is required here because it is used by the toneMapping() function defined below
    t.toneMapping !== Li ? W0("toneMapping", t.toneMapping) : "",
    t.dithering ? "#define DITHERING" : "",
    t.opaque ? "#define OPAQUE" : "",
    $e.colorspace_pars_fragment,
    // this code is required here because it is used by the various encoding/decoding function defined below
    G0("linearToOutputTexel", t.outputColorSpace),
    X0(),
    t.useDepthPacking ? "#define DEPTH_PACKING " + t.depthPacking : "",
    `
`
  ].filter(hr).join(`
`)), a = Tl(a), a = Pu(a, t), a = Lu(a, t), o = Tl(o), o = Pu(o, t), o = Lu(o, t), a = Iu(a), o = Iu(o), t.isRawShaderMaterial !== !0 && (M = `#version 300 es
`, g = [
    f,
    "#define attribute in",
    "#define varying out",
    "#define texture2D texture"
  ].join(`
`) + `
` + g, p = [
    "#define varying in",
    t.glslVersion === wc ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
    t.glslVersion === wc ? "" : "#define gl_FragColor pc_fragColor",
    "#define gl_FragDepthEXT gl_FragDepth",
    "#define texture2D texture",
    "#define textureCube texture",
    "#define texture2DProj textureProj",
    "#define texture2DLodEXT textureLod",
    "#define texture2DProjLodEXT textureProjLod",
    "#define textureCubeLodEXT textureLod",
    "#define texture2DGradEXT textureGrad",
    "#define texture2DProjGradEXT textureProjGrad",
    "#define textureCubeGradEXT textureGrad"
  ].join(`
`) + `
` + p);
  const S = M + g + a, x = M + p + o, R = wu(i, i.VERTEX_SHADER, S), w = wu(i, i.FRAGMENT_SHADER, x);
  i.attachShader(_, R), i.attachShader(_, w), t.index0AttributeName !== void 0 ? i.bindAttribLocation(_, 0, t.index0AttributeName) : t.morphTargets === !0 && i.bindAttribLocation(_, 0, "position"), i.linkProgram(_);
  function C(L) {
    if (s.debug.checkShaderErrors) {
      const O = i.getProgramInfoLog(_).trim(), U = i.getShaderInfoLog(R).trim(), N = i.getShaderInfoLog(w).trim();
      let Y = !0, G = !0;
      if (i.getProgramParameter(_, i.LINK_STATUS) === !1)
        if (Y = !1, typeof s.debug.onShaderError == "function")
          s.debug.onShaderError(i, _, R, w);
        else {
          const ne = Cu(i, R, "vertex"), B = Cu(i, w, "fragment");
          console.error(
            "THREE.WebGLProgram: Shader Error " + i.getError() + " - VALIDATE_STATUS " + i.getProgramParameter(_, i.VALIDATE_STATUS) + `

Material Name: ` + L.name + `
Material Type: ` + L.type + `

Program Info Log: ` + O + `
` + ne + `
` + B
          );
        }
      else O !== "" ? console.warn("THREE.WebGLProgram: Program Info Log:", O) : (U === "" || N === "") && (G = !1);
      G && (L.diagnostics = {
        runnable: Y,
        programLog: O,
        vertexShader: {
          log: U,
          prefix: g
        },
        fragmentShader: {
          log: N,
          prefix: p
        }
      });
    }
    i.deleteShader(R), i.deleteShader(w), P = new va(i, _), b = j0(i, _);
  }
  let P;
  this.getUniforms = function() {
    return P === void 0 && C(this), P;
  };
  let b;
  this.getAttributes = function() {
    return b === void 0 && C(this), b;
  };
  let y = t.rendererExtensionParallelShaderCompile === !1;
  return this.isReady = function() {
    return y === !1 && (y = i.getProgramParameter(_, k0)), y;
  }, this.destroy = function() {
    n.releaseStatesOfProgram(this), i.deleteProgram(_), this.program = void 0;
  }, this.type = t.shaderType, this.name = t.shaderName, this.id = z0++, this.cacheKey = e, this.usedTimes = 1, this.program = _, this.vertexShader = R, this.fragmentShader = w, this;
}
let ax = 0;
class ox {
  constructor() {
    this.shaderCache = /* @__PURE__ */ new Map(), this.materialCache = /* @__PURE__ */ new Map();
  }
  update(e) {
    const t = e.vertexShader, n = e.fragmentShader, i = this._getShaderStage(t), r = this._getShaderStage(n), a = this._getShaderCacheForMaterial(e);
    return a.has(i) === !1 && (a.add(i), i.usedTimes++), a.has(r) === !1 && (a.add(r), r.usedTimes++), this;
  }
  remove(e) {
    const t = this.materialCache.get(e);
    for (const n of t)
      n.usedTimes--, n.usedTimes === 0 && this.shaderCache.delete(n.code);
    return this.materialCache.delete(e), this;
  }
  getVertexShaderID(e) {
    return this._getShaderStage(e.vertexShader).id;
  }
  getFragmentShaderID(e) {
    return this._getShaderStage(e.fragmentShader).id;
  }
  dispose() {
    this.shaderCache.clear(), this.materialCache.clear();
  }
  _getShaderCacheForMaterial(e) {
    const t = this.materialCache;
    let n = t.get(e);
    return n === void 0 && (n = /* @__PURE__ */ new Set(), t.set(e, n)), n;
  }
  _getShaderStage(e) {
    const t = this.shaderCache;
    let n = t.get(e);
    return n === void 0 && (n = new lx(e), t.set(e, n)), n;
  }
}
class lx {
  constructor(e) {
    this.id = ax++, this.code = e, this.usedTimes = 0;
  }
}
function cx(s, e, t, n, i, r, a) {
  const o = new Fh(), l = new ox(), c = /* @__PURE__ */ new Set(), u = [], h = i.logarithmicDepthBuffer, d = i.vertexTextures;
  let f = i.precision;
  const m = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distanceRGBA",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite"
  };
  function _(b) {
    return c.add(b), b === 0 ? "uv" : `uv${b}`;
  }
  function g(b, y, L, O, U) {
    const N = O.fog, Y = U.geometry, G = b.isMeshStandardMaterial ? O.environment : null, ne = (b.isMeshStandardMaterial ? t : e).get(b.envMap || G), B = ne && ne.mapping === Pa ? ne.image.height : null, Z = m[b.type];
    b.precision !== null && (f = i.getMaxPrecision(b.precision), f !== b.precision && console.warn("THREE.WebGLProgram.getParameters:", b.precision, "not supported, using", f, "instead."));
    const Q = Y.morphAttributes.position || Y.morphAttributes.normal || Y.morphAttributes.color, xe = Q !== void 0 ? Q.length : 0;
    let ye = 0;
    Y.morphAttributes.position !== void 0 && (ye = 1), Y.morphAttributes.normal !== void 0 && (ye = 2), Y.morphAttributes.color !== void 0 && (ye = 3);
    let ce, V, se, re;
    if (Z) {
      const ct = cn[Z];
      ce = ct.vertexShader, V = ct.fragmentShader;
    } else
      ce = b.vertexShader, V = b.fragmentShader, l.update(b), se = l.getVertexShaderID(b), re = l.getFragmentShaderID(b);
    const X = s.getRenderTarget(), de = s.state.buffers.depth.getReversed(), be = U.isInstancedMesh === !0, Le = U.isBatchedMesh === !0, Be = !!b.map, nt = !!b.matcap, De = !!ne, I = !!b.aoMap, Ue = !!b.lightMap, Xe = !!b.bumpMap, Fe = !!b.normalMap, Ae = !!b.displacementMap, it = !!b.emissiveMap, Re = !!b.metalnessMap, A = !!b.roughnessMap, v = b.anisotropy > 0, H = b.clearcoat > 0, te = b.dispersion > 0, oe = b.iridescence > 0, ee = b.sheen > 0, Pe = b.transmission > 0, me = v && !!b.anisotropyMap, _e = H && !!b.clearcoatMap, W = H && !!b.clearcoatNormalMap, J = H && !!b.clearcoatRoughnessMap, le = oe && !!b.iridescenceMap, ve = oe && !!b.iridescenceThicknessMap, Te = ee && !!b.sheenColorMap, he = ee && !!b.sheenRoughnessMap, qe = !!b.specularMap, Ve = !!b.specularColorMap, lt = !!b.specularIntensityMap, F = Pe && !!b.transmissionMap, ge = Pe && !!b.thicknessMap, $ = !!b.gradientMap, ie = !!b.alphaMap, Me = b.alphaTest > 0, fe = !!b.alphaHash, Ge = !!b.extensions;
    let St = Li;
    b.toneMapped && (X === null || X.isXRRenderTarget === !0) && (St = s.toneMapping);
    const Qe = {
      shaderID: Z,
      shaderType: b.type,
      shaderName: b.name,
      vertexShader: ce,
      fragmentShader: V,
      defines: b.defines,
      customVertexShaderID: se,
      customFragmentShaderID: re,
      isRawShaderMaterial: b.isRawShaderMaterial === !0,
      glslVersion: b.glslVersion,
      precision: f,
      batching: Le,
      batchingColor: Le && U._colorsTexture !== null,
      instancing: be,
      instancingColor: be && U.instanceColor !== null,
      instancingMorph: be && U.morphTexture !== null,
      supportsVertexTextures: d,
      outputColorSpace: X === null ? s.outputColorSpace : X.isXRRenderTarget === !0 ? X.texture.colorSpace : Zt,
      alphaToCoverage: !!b.alphaToCoverage,
      map: Be,
      matcap: nt,
      envMap: De,
      envMapMode: De && ne.mapping,
      envMapCubeUVHeight: B,
      aoMap: I,
      lightMap: Ue,
      bumpMap: Xe,
      normalMap: Fe,
      displacementMap: d && Ae,
      emissiveMap: it,
      normalMapObjectSpace: Fe && b.normalMapType === ef,
      normalMapTangentSpace: Fe && b.normalMapType === Ih,
      metalnessMap: Re,
      roughnessMap: A,
      anisotropy: v,
      anisotropyMap: me,
      clearcoat: H,
      clearcoatMap: _e,
      clearcoatNormalMap: W,
      clearcoatRoughnessMap: J,
      dispersion: te,
      iridescence: oe,
      iridescenceMap: le,
      iridescenceThicknessMap: ve,
      sheen: ee,
      sheenColorMap: Te,
      sheenRoughnessMap: he,
      specularMap: qe,
      specularColorMap: Ve,
      specularIntensityMap: lt,
      transmission: Pe,
      transmissionMap: F,
      thicknessMap: ge,
      gradientMap: $,
      opaque: b.transparent === !1 && b.blending === Ps && b.alphaToCoverage === !1,
      alphaMap: ie,
      alphaTest: Me,
      alphaHash: fe,
      combine: b.combine,
      //
      mapUv: Be && _(b.map.channel),
      aoMapUv: I && _(b.aoMap.channel),
      lightMapUv: Ue && _(b.lightMap.channel),
      bumpMapUv: Xe && _(b.bumpMap.channel),
      normalMapUv: Fe && _(b.normalMap.channel),
      displacementMapUv: Ae && _(b.displacementMap.channel),
      emissiveMapUv: it && _(b.emissiveMap.channel),
      metalnessMapUv: Re && _(b.metalnessMap.channel),
      roughnessMapUv: A && _(b.roughnessMap.channel),
      anisotropyMapUv: me && _(b.anisotropyMap.channel),
      clearcoatMapUv: _e && _(b.clearcoatMap.channel),
      clearcoatNormalMapUv: W && _(b.clearcoatNormalMap.channel),
      clearcoatRoughnessMapUv: J && _(b.clearcoatRoughnessMap.channel),
      iridescenceMapUv: le && _(b.iridescenceMap.channel),
      iridescenceThicknessMapUv: ve && _(b.iridescenceThicknessMap.channel),
      sheenColorMapUv: Te && _(b.sheenColorMap.channel),
      sheenRoughnessMapUv: he && _(b.sheenRoughnessMap.channel),
      specularMapUv: qe && _(b.specularMap.channel),
      specularColorMapUv: Ve && _(b.specularColorMap.channel),
      specularIntensityMapUv: lt && _(b.specularIntensityMap.channel),
      transmissionMapUv: F && _(b.transmissionMap.channel),
      thicknessMapUv: ge && _(b.thicknessMap.channel),
      alphaMapUv: ie && _(b.alphaMap.channel),
      //
      vertexTangents: !!Y.attributes.tangent && (Fe || v),
      vertexColors: b.vertexColors,
      vertexAlphas: b.vertexColors === !0 && !!Y.attributes.color && Y.attributes.color.itemSize === 4,
      pointsUvs: U.isPoints === !0 && !!Y.attributes.uv && (Be || ie),
      fog: !!N,
      useFog: b.fog === !0,
      fogExp2: !!N && N.isFogExp2,
      flatShading: b.flatShading === !0,
      sizeAttenuation: b.sizeAttenuation === !0,
      logarithmicDepthBuffer: h,
      reverseDepthBuffer: de,
      skinning: U.isSkinnedMesh === !0,
      morphTargets: Y.morphAttributes.position !== void 0,
      morphNormals: Y.morphAttributes.normal !== void 0,
      morphColors: Y.morphAttributes.color !== void 0,
      morphTargetsCount: xe,
      morphTextureStride: ye,
      numDirLights: y.directional.length,
      numPointLights: y.point.length,
      numSpotLights: y.spot.length,
      numSpotLightMaps: y.spotLightMap.length,
      numRectAreaLights: y.rectArea.length,
      numHemiLights: y.hemi.length,
      numDirLightShadows: y.directionalShadowMap.length,
      numPointLightShadows: y.pointShadowMap.length,
      numSpotLightShadows: y.spotShadowMap.length,
      numSpotLightShadowsWithMaps: y.numSpotLightShadowsWithMaps,
      numLightProbes: y.numLightProbes,
      numClippingPlanes: a.numPlanes,
      numClipIntersection: a.numIntersection,
      dithering: b.dithering,
      shadowMapEnabled: s.shadowMap.enabled && L.length > 0,
      shadowMapType: s.shadowMap.type,
      toneMapping: St,
      decodeVideoTexture: Be && b.map.isVideoTexture === !0 && ot.getTransfer(b.map.colorSpace) === vt,
      decodeVideoTextureEmissive: it && b.emissiveMap.isVideoTexture === !0 && ot.getTransfer(b.emissiveMap.colorSpace) === vt,
      premultipliedAlpha: b.premultipliedAlpha,
      doubleSided: b.side === In,
      flipSided: b.side === an,
      useDepthPacking: b.depthPacking >= 0,
      depthPacking: b.depthPacking || 0,
      index0AttributeName: b.index0AttributeName,
      extensionClipCullDistance: Ge && b.extensions.clipCullDistance === !0 && n.has("WEBGL_clip_cull_distance"),
      extensionMultiDraw: (Ge && b.extensions.multiDraw === !0 || Le) && n.has("WEBGL_multi_draw"),
      rendererExtensionParallelShaderCompile: n.has("KHR_parallel_shader_compile"),
      customProgramCacheKey: b.customProgramCacheKey()
    };
    return Qe.vertexUv1s = c.has(1), Qe.vertexUv2s = c.has(2), Qe.vertexUv3s = c.has(3), c.clear(), Qe;
  }
  function p(b) {
    const y = [];
    if (b.shaderID ? y.push(b.shaderID) : (y.push(b.customVertexShaderID), y.push(b.customFragmentShaderID)), b.defines !== void 0)
      for (const L in b.defines)
        y.push(L), y.push(b.defines[L]);
    return b.isRawShaderMaterial === !1 && (M(y, b), S(y, b), y.push(s.outputColorSpace)), y.push(b.customProgramCacheKey), y.join();
  }
  function M(b, y) {
    b.push(y.precision), b.push(y.outputColorSpace), b.push(y.envMapMode), b.push(y.envMapCubeUVHeight), b.push(y.mapUv), b.push(y.alphaMapUv), b.push(y.lightMapUv), b.push(y.aoMapUv), b.push(y.bumpMapUv), b.push(y.normalMapUv), b.push(y.displacementMapUv), b.push(y.emissiveMapUv), b.push(y.metalnessMapUv), b.push(y.roughnessMapUv), b.push(y.anisotropyMapUv), b.push(y.clearcoatMapUv), b.push(y.clearcoatNormalMapUv), b.push(y.clearcoatRoughnessMapUv), b.push(y.iridescenceMapUv), b.push(y.iridescenceThicknessMapUv), b.push(y.sheenColorMapUv), b.push(y.sheenRoughnessMapUv), b.push(y.specularMapUv), b.push(y.specularColorMapUv), b.push(y.specularIntensityMapUv), b.push(y.transmissionMapUv), b.push(y.thicknessMapUv), b.push(y.combine), b.push(y.fogExp2), b.push(y.sizeAttenuation), b.push(y.morphTargetsCount), b.push(y.morphAttributeCount), b.push(y.numDirLights), b.push(y.numPointLights), b.push(y.numSpotLights), b.push(y.numSpotLightMaps), b.push(y.numHemiLights), b.push(y.numRectAreaLights), b.push(y.numDirLightShadows), b.push(y.numPointLightShadows), b.push(y.numSpotLightShadows), b.push(y.numSpotLightShadowsWithMaps), b.push(y.numLightProbes), b.push(y.shadowMapType), b.push(y.toneMapping), b.push(y.numClippingPlanes), b.push(y.numClipIntersection), b.push(y.depthPacking);
  }
  function S(b, y) {
    o.disableAll(), y.supportsVertexTextures && o.enable(0), y.instancing && o.enable(1), y.instancingColor && o.enable(2), y.instancingMorph && o.enable(3), y.matcap && o.enable(4), y.envMap && o.enable(5), y.normalMapObjectSpace && o.enable(6), y.normalMapTangentSpace && o.enable(7), y.clearcoat && o.enable(8), y.iridescence && o.enable(9), y.alphaTest && o.enable(10), y.vertexColors && o.enable(11), y.vertexAlphas && o.enable(12), y.vertexUv1s && o.enable(13), y.vertexUv2s && o.enable(14), y.vertexUv3s && o.enable(15), y.vertexTangents && o.enable(16), y.anisotropy && o.enable(17), y.alphaHash && o.enable(18), y.batching && o.enable(19), y.dispersion && o.enable(20), y.batchingColor && o.enable(21), b.push(o.mask), o.disableAll(), y.fog && o.enable(0), y.useFog && o.enable(1), y.flatShading && o.enable(2), y.logarithmicDepthBuffer && o.enable(3), y.reverseDepthBuffer && o.enable(4), y.skinning && o.enable(5), y.morphTargets && o.enable(6), y.morphNormals && o.enable(7), y.morphColors && o.enable(8), y.premultipliedAlpha && o.enable(9), y.shadowMapEnabled && o.enable(10), y.doubleSided && o.enable(11), y.flipSided && o.enable(12), y.useDepthPacking && o.enable(13), y.dithering && o.enable(14), y.transmission && o.enable(15), y.sheen && o.enable(16), y.opaque && o.enable(17), y.pointsUvs && o.enable(18), y.decodeVideoTexture && o.enable(19), y.decodeVideoTextureEmissive && o.enable(20), y.alphaToCoverage && o.enable(21), b.push(o.mask);
  }
  function x(b) {
    const y = m[b.type];
    let L;
    if (y) {
      const O = cn[y];
      L = Wl.clone(O.uniforms);
    } else
      L = b.uniforms;
    return L;
  }
  function R(b, y) {
    let L;
    for (let O = 0, U = u.length; O < U; O++) {
      const N = u[O];
      if (N.cacheKey === y) {
        L = N, ++L.usedTimes;
        break;
      }
    }
    return L === void 0 && (L = new rx(s, y, b, r), u.push(L)), L;
  }
  function w(b) {
    if (--b.usedTimes === 0) {
      const y = u.indexOf(b);
      u[y] = u[u.length - 1], u.pop(), b.destroy();
    }
  }
  function C(b) {
    l.remove(b);
  }
  function P() {
    l.dispose();
  }
  return {
    getParameters: g,
    getProgramCacheKey: p,
    getUniforms: x,
    acquireProgram: R,
    releaseProgram: w,
    releaseShaderCache: C,
    // Exposed for resource monitoring & error feedback via renderer.info:
    programs: u,
    dispose: P
  };
}
function ux() {
  let s = /* @__PURE__ */ new WeakMap();
  function e(a) {
    return s.has(a);
  }
  function t(a) {
    let o = s.get(a);
    return o === void 0 && (o = {}, s.set(a, o)), o;
  }
  function n(a) {
    s.delete(a);
  }
  function i(a, o, l) {
    s.get(a)[o] = l;
  }
  function r() {
    s = /* @__PURE__ */ new WeakMap();
  }
  return {
    has: e,
    get: t,
    remove: n,
    update: i,
    dispose: r
  };
}
function hx(s, e) {
  return s.groupOrder !== e.groupOrder ? s.groupOrder - e.groupOrder : s.renderOrder !== e.renderOrder ? s.renderOrder - e.renderOrder : s.material.id !== e.material.id ? s.material.id - e.material.id : s.z !== e.z ? s.z - e.z : s.id - e.id;
}
function Nu(s, e) {
  return s.groupOrder !== e.groupOrder ? s.groupOrder - e.groupOrder : s.renderOrder !== e.renderOrder ? s.renderOrder - e.renderOrder : s.z !== e.z ? e.z - s.z : s.id - e.id;
}
function Uu() {
  const s = [];
  let e = 0;
  const t = [], n = [], i = [];
  function r() {
    e = 0, t.length = 0, n.length = 0, i.length = 0;
  }
  function a(h, d, f, m, _, g) {
    let p = s[e];
    return p === void 0 ? (p = {
      id: h.id,
      object: h,
      geometry: d,
      material: f,
      groupOrder: m,
      renderOrder: h.renderOrder,
      z: _,
      group: g
    }, s[e] = p) : (p.id = h.id, p.object = h, p.geometry = d, p.material = f, p.groupOrder = m, p.renderOrder = h.renderOrder, p.z = _, p.group = g), e++, p;
  }
  function o(h, d, f, m, _, g) {
    const p = a(h, d, f, m, _, g);
    f.transmission > 0 ? n.push(p) : f.transparent === !0 ? i.push(p) : t.push(p);
  }
  function l(h, d, f, m, _, g) {
    const p = a(h, d, f, m, _, g);
    f.transmission > 0 ? n.unshift(p) : f.transparent === !0 ? i.unshift(p) : t.unshift(p);
  }
  function c(h, d) {
    t.length > 1 && t.sort(h || hx), n.length > 1 && n.sort(d || Nu), i.length > 1 && i.sort(d || Nu);
  }
  function u() {
    for (let h = e, d = s.length; h < d; h++) {
      const f = s[h];
      if (f.id === null) break;
      f.id = null, f.object = null, f.geometry = null, f.material = null, f.group = null;
    }
  }
  return {
    opaque: t,
    transmissive: n,
    transparent: i,
    init: r,
    push: o,
    unshift: l,
    finish: u,
    sort: c
  };
}
function dx() {
  let s = /* @__PURE__ */ new WeakMap();
  function e(n, i) {
    const r = s.get(n);
    let a;
    return r === void 0 ? (a = new Uu(), s.set(n, [a])) : i >= r.length ? (a = new Uu(), r.push(a)) : a = r[i], a;
  }
  function t() {
    s = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: e,
    dispose: t
  };
}
function fx() {
  const s = {};
  return {
    get: function(e) {
      if (s[e.id] !== void 0)
        return s[e.id];
      let t;
      switch (e.type) {
        case "DirectionalLight":
          t = {
            direction: new T(),
            color: new He()
          };
          break;
        case "SpotLight":
          t = {
            position: new T(),
            direction: new T(),
            color: new He(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;
        case "PointLight":
          t = {
            position: new T(),
            color: new He(),
            distance: 0,
            decay: 0
          };
          break;
        case "HemisphereLight":
          t = {
            direction: new T(),
            skyColor: new He(),
            groundColor: new He()
          };
          break;
        case "RectAreaLight":
          t = {
            color: new He(),
            position: new T(),
            halfWidth: new T(),
            halfHeight: new T()
          };
          break;
      }
      return s[e.id] = t, t;
    }
  };
}
function px() {
  const s = {};
  return {
    get: function(e) {
      if (s[e.id] !== void 0)
        return s[e.id];
      let t;
      switch (e.type) {
        case "DirectionalLight":
          t = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new ze()
          };
          break;
        case "SpotLight":
          t = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new ze()
          };
          break;
        case "PointLight":
          t = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new ze(),
            shadowCameraNear: 1,
            shadowCameraFar: 1e3
          };
          break;
      }
      return s[e.id] = t, t;
    }
  };
}
let mx = 0;
function gx(s, e) {
  return (e.castShadow ? 2 : 0) - (s.castShadow ? 2 : 0) + (e.map ? 1 : 0) - (s.map ? 1 : 0);
}
function _x(s) {
  const e = new fx(), t = px(), n = {
    version: 0,
    hash: {
      directionalLength: -1,
      pointLength: -1,
      spotLength: -1,
      rectAreaLength: -1,
      hemiLength: -1,
      numDirectionalShadows: -1,
      numPointShadows: -1,
      numSpotShadows: -1,
      numSpotMaps: -1,
      numLightProbes: -1
    },
    ambient: [0, 0, 0],
    probe: [],
    directional: [],
    directionalShadow: [],
    directionalShadowMap: [],
    directionalShadowMatrix: [],
    spot: [],
    spotLightMap: [],
    spotShadow: [],
    spotShadowMap: [],
    spotLightMatrix: [],
    rectArea: [],
    rectAreaLTC1: null,
    rectAreaLTC2: null,
    point: [],
    pointShadow: [],
    pointShadowMap: [],
    pointShadowMatrix: [],
    hemi: [],
    numSpotLightShadowsWithMaps: 0,
    numLightProbes: 0
  };
  for (let c = 0; c < 9; c++) n.probe.push(new T());
  const i = new T(), r = new Ye(), a = new Ye();
  function o(c) {
    let u = 0, h = 0, d = 0;
    for (let b = 0; b < 9; b++) n.probe[b].set(0, 0, 0);
    let f = 0, m = 0, _ = 0, g = 0, p = 0, M = 0, S = 0, x = 0, R = 0, w = 0, C = 0;
    c.sort(gx);
    for (let b = 0, y = c.length; b < y; b++) {
      const L = c[b], O = L.color, U = L.intensity, N = L.distance, Y = L.shadow && L.shadow.map ? L.shadow.map.texture : null;
      if (L.isAmbientLight)
        u += O.r * U, h += O.g * U, d += O.b * U;
      else if (L.isLightProbe) {
        for (let G = 0; G < 9; G++)
          n.probe[G].addScaledVector(L.sh.coefficients[G], U);
        C++;
      } else if (L.isDirectionalLight) {
        const G = e.get(L);
        if (G.color.copy(L.color).multiplyScalar(L.intensity), L.castShadow) {
          const ne = L.shadow, B = t.get(L);
          B.shadowIntensity = ne.intensity, B.shadowBias = ne.bias, B.shadowNormalBias = ne.normalBias, B.shadowRadius = ne.radius, B.shadowMapSize = ne.mapSize, n.directionalShadow[f] = B, n.directionalShadowMap[f] = Y, n.directionalShadowMatrix[f] = L.shadow.matrix, M++;
        }
        n.directional[f] = G, f++;
      } else if (L.isSpotLight) {
        const G = e.get(L);
        G.position.setFromMatrixPosition(L.matrixWorld), G.color.copy(O).multiplyScalar(U), G.distance = N, G.coneCos = Math.cos(L.angle), G.penumbraCos = Math.cos(L.angle * (1 - L.penumbra)), G.decay = L.decay, n.spot[_] = G;
        const ne = L.shadow;
        if (L.map && (n.spotLightMap[R] = L.map, R++, ne.updateMatrices(L), L.castShadow && w++), n.spotLightMatrix[_] = ne.matrix, L.castShadow) {
          const B = t.get(L);
          B.shadowIntensity = ne.intensity, B.shadowBias = ne.bias, B.shadowNormalBias = ne.normalBias, B.shadowRadius = ne.radius, B.shadowMapSize = ne.mapSize, n.spotShadow[_] = B, n.spotShadowMap[_] = Y, x++;
        }
        _++;
      } else if (L.isRectAreaLight) {
        const G = e.get(L);
        G.color.copy(O).multiplyScalar(U), G.halfWidth.set(L.width * 0.5, 0, 0), G.halfHeight.set(0, L.height * 0.5, 0), n.rectArea[g] = G, g++;
      } else if (L.isPointLight) {
        const G = e.get(L);
        if (G.color.copy(L.color).multiplyScalar(L.intensity), G.distance = L.distance, G.decay = L.decay, L.castShadow) {
          const ne = L.shadow, B = t.get(L);
          B.shadowIntensity = ne.intensity, B.shadowBias = ne.bias, B.shadowNormalBias = ne.normalBias, B.shadowRadius = ne.radius, B.shadowMapSize = ne.mapSize, B.shadowCameraNear = ne.camera.near, B.shadowCameraFar = ne.camera.far, n.pointShadow[m] = B, n.pointShadowMap[m] = Y, n.pointShadowMatrix[m] = L.shadow.matrix, S++;
        }
        n.point[m] = G, m++;
      } else if (L.isHemisphereLight) {
        const G = e.get(L);
        G.skyColor.copy(L.color).multiplyScalar(U), G.groundColor.copy(L.groundColor).multiplyScalar(U), n.hemi[p] = G, p++;
      }
    }
    g > 0 && (s.has("OES_texture_float_linear") === !0 ? (n.rectAreaLTC1 = pe.LTC_FLOAT_1, n.rectAreaLTC2 = pe.LTC_FLOAT_2) : (n.rectAreaLTC1 = pe.LTC_HALF_1, n.rectAreaLTC2 = pe.LTC_HALF_2)), n.ambient[0] = u, n.ambient[1] = h, n.ambient[2] = d;
    const P = n.hash;
    (P.directionalLength !== f || P.pointLength !== m || P.spotLength !== _ || P.rectAreaLength !== g || P.hemiLength !== p || P.numDirectionalShadows !== M || P.numPointShadows !== S || P.numSpotShadows !== x || P.numSpotMaps !== R || P.numLightProbes !== C) && (n.directional.length = f, n.spot.length = _, n.rectArea.length = g, n.point.length = m, n.hemi.length = p, n.directionalShadow.length = M, n.directionalShadowMap.length = M, n.pointShadow.length = S, n.pointShadowMap.length = S, n.spotShadow.length = x, n.spotShadowMap.length = x, n.directionalShadowMatrix.length = M, n.pointShadowMatrix.length = S, n.spotLightMatrix.length = x + R - w, n.spotLightMap.length = R, n.numSpotLightShadowsWithMaps = w, n.numLightProbes = C, P.directionalLength = f, P.pointLength = m, P.spotLength = _, P.rectAreaLength = g, P.hemiLength = p, P.numDirectionalShadows = M, P.numPointShadows = S, P.numSpotShadows = x, P.numSpotMaps = R, P.numLightProbes = C, n.version = mx++);
  }
  function l(c, u) {
    let h = 0, d = 0, f = 0, m = 0, _ = 0;
    const g = u.matrixWorldInverse;
    for (let p = 0, M = c.length; p < M; p++) {
      const S = c[p];
      if (S.isDirectionalLight) {
        const x = n.directional[h];
        x.direction.setFromMatrixPosition(S.matrixWorld), i.setFromMatrixPosition(S.target.matrixWorld), x.direction.sub(i), x.direction.transformDirection(g), h++;
      } else if (S.isSpotLight) {
        const x = n.spot[f];
        x.position.setFromMatrixPosition(S.matrixWorld), x.position.applyMatrix4(g), x.direction.setFromMatrixPosition(S.matrixWorld), i.setFromMatrixPosition(S.target.matrixWorld), x.direction.sub(i), x.direction.transformDirection(g), f++;
      } else if (S.isRectAreaLight) {
        const x = n.rectArea[m];
        x.position.setFromMatrixPosition(S.matrixWorld), x.position.applyMatrix4(g), a.identity(), r.copy(S.matrixWorld), r.premultiply(g), a.extractRotation(r), x.halfWidth.set(S.width * 0.5, 0, 0), x.halfHeight.set(0, S.height * 0.5, 0), x.halfWidth.applyMatrix4(a), x.halfHeight.applyMatrix4(a), m++;
      } else if (S.isPointLight) {
        const x = n.point[d];
        x.position.setFromMatrixPosition(S.matrixWorld), x.position.applyMatrix4(g), d++;
      } else if (S.isHemisphereLight) {
        const x = n.hemi[_];
        x.direction.setFromMatrixPosition(S.matrixWorld), x.direction.transformDirection(g), _++;
      }
    }
  }
  return {
    setup: o,
    setupView: l,
    state: n
  };
}
function Fu(s) {
  const e = new _x(s), t = [], n = [];
  function i(u) {
    c.camera = u, t.length = 0, n.length = 0;
  }
  function r(u) {
    t.push(u);
  }
  function a(u) {
    n.push(u);
  }
  function o() {
    e.setup(t);
  }
  function l(u) {
    e.setupView(t, u);
  }
  const c = {
    lightsArray: t,
    shadowsArray: n,
    camera: null,
    lights: e,
    transmissionRenderTarget: {}
  };
  return {
    init: i,
    state: c,
    setupLights: o,
    setupLightsView: l,
    pushLight: r,
    pushShadow: a
  };
}
function xx(s) {
  let e = /* @__PURE__ */ new WeakMap();
  function t(i, r = 0) {
    const a = e.get(i);
    let o;
    return a === void 0 ? (o = new Fu(s), e.set(i, [o])) : r >= a.length ? (o = new Fu(s), a.push(o)) : o = a[r], o;
  }
  function n() {
    e = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: t,
    dispose: n
  };
}
const vx = `void main() {
	gl_Position = vec4( position, 1.0 );
}`, yx = `uniform sampler2D shadow_pass;
uniform vec2 resolution;
uniform float radius;
#include <packing>
void main() {
	const float samples = float( VSM_SAMPLES );
	float mean = 0.0;
	float squared_mean = 0.0;
	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );
	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;
	for ( float i = 0.0; i < samples; i ++ ) {
		float uvOffset = uvStart + i * uvStride;
		#ifdef HORIZONTAL_PASS
			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );
			mean += distribution.x;
			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;
		#else
			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );
			mean += depth;
			squared_mean += depth * depth;
		#endif
	}
	mean = mean / samples;
	squared_mean = squared_mean / samples;
	float std_dev = sqrt( squared_mean - mean * mean );
	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );
}`;
function Sx(s, e, t) {
  let n = new jl();
  const i = new ze(), r = new ze(), a = new at(), o = new dp({ depthPacking: Qd }), l = new fp(), c = {}, u = t.maxTextureSize, h = { [gi]: an, [an]: gi, [In]: In }, d = new jn({
    defines: {
      VSM_SAMPLES: 8
    },
    uniforms: {
      shadow_pass: { value: null },
      resolution: { value: new ze() },
      radius: { value: 4 }
    },
    vertexShader: vx,
    fragmentShader: yx
  }), f = d.clone();
  f.defines.HORIZONTAL_PASS = 1;
  const m = new _n();
  m.setAttribute(
    "position",
    new Kt(
      new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]),
      3
    )
  );
  const _ = new xt(m, d), g = this;
  this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = gh;
  let p = this.type;
  this.render = function(w, C, P) {
    if (g.enabled === !1 || g.autoUpdate === !1 && g.needsUpdate === !1 || w.length === 0) return;
    const b = s.getRenderTarget(), y = s.getActiveCubeFace(), L = s.getActiveMipmapLevel(), O = s.state;
    O.setBlending(Pi), O.buffers.color.setClear(1, 1, 1, 1), O.buffers.depth.setTest(!0), O.setScissorTest(!1);
    const U = p !== oi && this.type === oi, N = p === oi && this.type !== oi;
    for (let Y = 0, G = w.length; Y < G; Y++) {
      const ne = w[Y], B = ne.shadow;
      if (B === void 0) {
        console.warn("THREE.WebGLShadowMap:", ne, "has no shadow.");
        continue;
      }
      if (B.autoUpdate === !1 && B.needsUpdate === !1) continue;
      i.copy(B.mapSize);
      const Z = B.getFrameExtents();
      if (i.multiply(Z), r.copy(B.mapSize), (i.x > u || i.y > u) && (i.x > u && (r.x = Math.floor(u / Z.x), i.x = r.x * Z.x, B.mapSize.x = r.x), i.y > u && (r.y = Math.floor(u / Z.y), i.y = r.y * Z.y, B.mapSize.y = r.y)), B.map === null || U === !0 || N === !0) {
        const xe = this.type !== oi ? { minFilter: en, magFilter: en } : {};
        B.map !== null && B.map.dispose(), B.map = new Di(i.x, i.y, xe), B.map.texture.name = ne.name + ".shadowMap", B.camera.updateProjectionMatrix();
      }
      s.setRenderTarget(B.map), s.clear();
      const Q = B.getViewportCount();
      for (let xe = 0; xe < Q; xe++) {
        const ye = B.getViewport(xe);
        a.set(
          r.x * ye.x,
          r.y * ye.y,
          r.x * ye.z,
          r.y * ye.w
        ), O.viewport(a), B.updateMatrices(ne, xe), n = B.getFrustum(), x(C, P, B.camera, ne, this.type);
      }
      B.isPointLightShadow !== !0 && this.type === oi && M(B, P), B.needsUpdate = !1;
    }
    p = this.type, g.needsUpdate = !1, s.setRenderTarget(b, y, L);
  };
  function M(w, C) {
    const P = e.update(_);
    d.defines.VSM_SAMPLES !== w.blurSamples && (d.defines.VSM_SAMPLES = w.blurSamples, f.defines.VSM_SAMPLES = w.blurSamples, d.needsUpdate = !0, f.needsUpdate = !0), w.mapPass === null && (w.mapPass = new Di(i.x, i.y)), d.uniforms.shadow_pass.value = w.map.texture, d.uniforms.resolution.value = w.mapSize, d.uniforms.radius.value = w.radius, s.setRenderTarget(w.mapPass), s.clear(), s.renderBufferDirect(C, null, P, d, _, null), f.uniforms.shadow_pass.value = w.mapPass.texture, f.uniforms.resolution.value = w.mapSize, f.uniforms.radius.value = w.radius, s.setRenderTarget(w.map), s.clear(), s.renderBufferDirect(C, null, P, f, _, null);
  }
  function S(w, C, P, b) {
    let y = null;
    const L = P.isPointLight === !0 ? w.customDistanceMaterial : w.customDepthMaterial;
    if (L !== void 0)
      y = L;
    else if (y = P.isPointLight === !0 ? l : o, s.localClippingEnabled && C.clipShadows === !0 && Array.isArray(C.clippingPlanes) && C.clippingPlanes.length !== 0 || C.displacementMap && C.displacementScale !== 0 || C.alphaMap && C.alphaTest > 0 || C.map && C.alphaTest > 0) {
      const O = y.uuid, U = C.uuid;
      let N = c[O];
      N === void 0 && (N = {}, c[O] = N);
      let Y = N[U];
      Y === void 0 && (Y = y.clone(), N[U] = Y, C.addEventListener("dispose", R)), y = Y;
    }
    if (y.visible = C.visible, y.wireframe = C.wireframe, b === oi ? y.side = C.shadowSide !== null ? C.shadowSide : C.side : y.side = C.shadowSide !== null ? C.shadowSide : h[C.side], y.alphaMap = C.alphaMap, y.alphaTest = C.alphaTest, y.map = C.map, y.clipShadows = C.clipShadows, y.clippingPlanes = C.clippingPlanes, y.clipIntersection = C.clipIntersection, y.displacementMap = C.displacementMap, y.displacementScale = C.displacementScale, y.displacementBias = C.displacementBias, y.wireframeLinewidth = C.wireframeLinewidth, y.linewidth = C.linewidth, P.isPointLight === !0 && y.isMeshDistanceMaterial === !0) {
      const O = s.properties.get(y);
      O.light = P;
    }
    return y;
  }
  function x(w, C, P, b, y) {
    if (w.visible === !1) return;
    if (w.layers.test(C.layers) && (w.isMesh || w.isLine || w.isPoints) && (w.castShadow || w.receiveShadow && y === oi) && (!w.frustumCulled || n.intersectsObject(w))) {
      w.modelViewMatrix.multiplyMatrices(P.matrixWorldInverse, w.matrixWorld);
      const U = e.update(w), N = w.material;
      if (Array.isArray(N)) {
        const Y = U.groups;
        for (let G = 0, ne = Y.length; G < ne; G++) {
          const B = Y[G], Z = N[B.materialIndex];
          if (Z && Z.visible) {
            const Q = S(w, Z, b, y);
            w.onBeforeShadow(s, w, C, P, U, Q, B), s.renderBufferDirect(P, null, U, Q, w, B), w.onAfterShadow(s, w, C, P, U, Q, B);
          }
        }
      } else if (N.visible) {
        const Y = S(w, N, b, y);
        w.onBeforeShadow(s, w, C, P, U, Y, null), s.renderBufferDirect(P, null, U, Y, w, null), w.onAfterShadow(s, w, C, P, U, Y, null);
      }
    }
    const O = w.children;
    for (let U = 0, N = O.length; U < N; U++)
      x(O[U], C, P, b, y);
  }
  function R(w) {
    w.target.removeEventListener("dispose", R);
    for (const P in c) {
      const b = c[P], y = w.target.uuid;
      y in b && (b[y].dispose(), delete b[y]);
    }
  }
}
const Mx = {
  [Bo]: ko,
  [zo]: Go,
  [Ho]: Wo,
  [Ds]: Vo,
  [ko]: Bo,
  [Go]: zo,
  [Wo]: Ho,
  [Vo]: Ds
};
function bx(s, e) {
  function t() {
    let F = !1;
    const ge = new at();
    let $ = null;
    const ie = new at(0, 0, 0, 0);
    return {
      setMask: function(Me) {
        $ !== Me && !F && (s.colorMask(Me, Me, Me, Me), $ = Me);
      },
      setLocked: function(Me) {
        F = Me;
      },
      setClear: function(Me, fe, Ge, St, Qe) {
        Qe === !0 && (Me *= St, fe *= St, Ge *= St), ge.set(Me, fe, Ge, St), ie.equals(ge) === !1 && (s.clearColor(Me, fe, Ge, St), ie.copy(ge));
      },
      reset: function() {
        F = !1, $ = null, ie.set(-1, 0, 0, 0);
      }
    };
  }
  function n() {
    let F = !1, ge = !1, $ = null, ie = null, Me = null;
    return {
      setReversed: function(fe) {
        if (ge !== fe) {
          const Ge = e.get("EXT_clip_control");
          fe ? Ge.clipControlEXT(Ge.LOWER_LEFT_EXT, Ge.ZERO_TO_ONE_EXT) : Ge.clipControlEXT(Ge.LOWER_LEFT_EXT, Ge.NEGATIVE_ONE_TO_ONE_EXT), ge = fe;
          const St = Me;
          Me = null, this.setClear(St);
        }
      },
      getReversed: function() {
        return ge;
      },
      setTest: function(fe) {
        fe ? X(s.DEPTH_TEST) : de(s.DEPTH_TEST);
      },
      setMask: function(fe) {
        $ !== fe && !F && (s.depthMask(fe), $ = fe);
      },
      setFunc: function(fe) {
        if (ge && (fe = Mx[fe]), ie !== fe) {
          switch (fe) {
            case Bo:
              s.depthFunc(s.NEVER);
              break;
            case ko:
              s.depthFunc(s.ALWAYS);
              break;
            case zo:
              s.depthFunc(s.LESS);
              break;
            case Ds:
              s.depthFunc(s.LEQUAL);
              break;
            case Ho:
              s.depthFunc(s.EQUAL);
              break;
            case Vo:
              s.depthFunc(s.GEQUAL);
              break;
            case Go:
              s.depthFunc(s.GREATER);
              break;
            case Wo:
              s.depthFunc(s.NOTEQUAL);
              break;
            default:
              s.depthFunc(s.LEQUAL);
          }
          ie = fe;
        }
      },
      setLocked: function(fe) {
        F = fe;
      },
      setClear: function(fe) {
        Me !== fe && (ge && (fe = 1 - fe), s.clearDepth(fe), Me = fe);
      },
      reset: function() {
        F = !1, $ = null, ie = null, Me = null, ge = !1;
      }
    };
  }
  function i() {
    let F = !1, ge = null, $ = null, ie = null, Me = null, fe = null, Ge = null, St = null, Qe = null;
    return {
      setTest: function(ct) {
        F || (ct ? X(s.STENCIL_TEST) : de(s.STENCIL_TEST));
      },
      setMask: function(ct) {
        ge !== ct && !F && (s.stencilMask(ct), ge = ct);
      },
      setFunc: function(ct, Pt, It) {
        ($ !== ct || ie !== Pt || Me !== It) && (s.stencilFunc(ct, Pt, It), $ = ct, ie = Pt, Me = It);
      },
      setOp: function(ct, Pt, It) {
        (fe !== ct || Ge !== Pt || St !== It) && (s.stencilOp(ct, Pt, It), fe = ct, Ge = Pt, St = It);
      },
      setLocked: function(ct) {
        F = ct;
      },
      setClear: function(ct) {
        Qe !== ct && (s.clearStencil(ct), Qe = ct);
      },
      reset: function() {
        F = !1, ge = null, $ = null, ie = null, Me = null, fe = null, Ge = null, St = null, Qe = null;
      }
    };
  }
  const r = new t(), a = new n(), o = new i(), l = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap();
  let u = {}, h = {}, d = /* @__PURE__ */ new WeakMap(), f = [], m = null, _ = !1, g = null, p = null, M = null, S = null, x = null, R = null, w = null, C = new He(0, 0, 0), P = 0, b = !1, y = null, L = null, O = null, U = null, N = null;
  const Y = s.getParameter(s.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
  let G = !1, ne = 0;
  const B = s.getParameter(s.VERSION);
  B.indexOf("WebGL") !== -1 ? (ne = parseFloat(/^WebGL (\d)/.exec(B)[1]), G = ne >= 1) : B.indexOf("OpenGL ES") !== -1 && (ne = parseFloat(/^OpenGL ES (\d)/.exec(B)[1]), G = ne >= 2);
  let Z = null, Q = {};
  const xe = s.getParameter(s.SCISSOR_BOX), ye = s.getParameter(s.VIEWPORT), ce = new at().fromArray(xe), V = new at().fromArray(ye);
  function se(F, ge, $, ie) {
    const Me = new Uint8Array(4), fe = s.createTexture();
    s.bindTexture(F, fe), s.texParameteri(F, s.TEXTURE_MIN_FILTER, s.NEAREST), s.texParameteri(F, s.TEXTURE_MAG_FILTER, s.NEAREST);
    for (let Ge = 0; Ge < $; Ge++)
      F === s.TEXTURE_3D || F === s.TEXTURE_2D_ARRAY ? s.texImage3D(ge, 0, s.RGBA, 1, 1, ie, 0, s.RGBA, s.UNSIGNED_BYTE, Me) : s.texImage2D(ge + Ge, 0, s.RGBA, 1, 1, 0, s.RGBA, s.UNSIGNED_BYTE, Me);
    return fe;
  }
  const re = {};
  re[s.TEXTURE_2D] = se(s.TEXTURE_2D, s.TEXTURE_2D, 1), re[s.TEXTURE_CUBE_MAP] = se(s.TEXTURE_CUBE_MAP, s.TEXTURE_CUBE_MAP_POSITIVE_X, 6), re[s.TEXTURE_2D_ARRAY] = se(s.TEXTURE_2D_ARRAY, s.TEXTURE_2D_ARRAY, 1, 1), re[s.TEXTURE_3D] = se(s.TEXTURE_3D, s.TEXTURE_3D, 1, 1), r.setClear(0, 0, 0, 1), a.setClear(1), o.setClear(0), X(s.DEPTH_TEST), a.setFunc(Ds), Xe(!1), Fe(Sc), X(s.CULL_FACE), I(Pi);
  function X(F) {
    u[F] !== !0 && (s.enable(F), u[F] = !0);
  }
  function de(F) {
    u[F] !== !1 && (s.disable(F), u[F] = !1);
  }
  function be(F, ge) {
    return h[F] !== ge ? (s.bindFramebuffer(F, ge), h[F] = ge, F === s.DRAW_FRAMEBUFFER && (h[s.FRAMEBUFFER] = ge), F === s.FRAMEBUFFER && (h[s.DRAW_FRAMEBUFFER] = ge), !0) : !1;
  }
  function Le(F, ge) {
    let $ = f, ie = !1;
    if (F) {
      $ = d.get(ge), $ === void 0 && ($ = [], d.set(ge, $));
      const Me = F.textures;
      if ($.length !== Me.length || $[0] !== s.COLOR_ATTACHMENT0) {
        for (let fe = 0, Ge = Me.length; fe < Ge; fe++)
          $[fe] = s.COLOR_ATTACHMENT0 + fe;
        $.length = Me.length, ie = !0;
      }
    } else
      $[0] !== s.BACK && ($[0] = s.BACK, ie = !0);
    ie && s.drawBuffers($);
  }
  function Be(F) {
    return m !== F ? (s.useProgram(F), m = F, !0) : !1;
  }
  const nt = {
    [ji]: s.FUNC_ADD,
    [Md]: s.FUNC_SUBTRACT,
    [bd]: s.FUNC_REVERSE_SUBTRACT
  };
  nt[Ed] = s.MIN, nt[Td] = s.MAX;
  const De = {
    [Ad]: s.ZERO,
    [wd]: s.ONE,
    [Rd]: s.SRC_COLOR,
    [Fo]: s.SRC_ALPHA,
    [Nd]: s.SRC_ALPHA_SATURATE,
    [Id]: s.DST_COLOR,
    [Pd]: s.DST_ALPHA,
    [Cd]: s.ONE_MINUS_SRC_COLOR,
    [Oo]: s.ONE_MINUS_SRC_ALPHA,
    [Dd]: s.ONE_MINUS_DST_COLOR,
    [Ld]: s.ONE_MINUS_DST_ALPHA,
    [Ud]: s.CONSTANT_COLOR,
    [Fd]: s.ONE_MINUS_CONSTANT_COLOR,
    [Od]: s.CONSTANT_ALPHA,
    [Bd]: s.ONE_MINUS_CONSTANT_ALPHA
  };
  function I(F, ge, $, ie, Me, fe, Ge, St, Qe, ct) {
    if (F === Pi) {
      _ === !0 && (de(s.BLEND), _ = !1);
      return;
    }
    if (_ === !1 && (X(s.BLEND), _ = !0), F !== Sd) {
      if (F !== g || ct !== b) {
        if ((p !== ji || x !== ji) && (s.blendEquation(s.FUNC_ADD), p = ji, x = ji), ct)
          switch (F) {
            case Ps:
              s.blendFuncSeparate(s.ONE, s.ONE_MINUS_SRC_ALPHA, s.ONE, s.ONE_MINUS_SRC_ALPHA);
              break;
            case Mc:
              s.blendFunc(s.ONE, s.ONE);
              break;
            case bc:
              s.blendFuncSeparate(s.ZERO, s.ONE_MINUS_SRC_COLOR, s.ZERO, s.ONE);
              break;
            case Ec:
              s.blendFuncSeparate(s.ZERO, s.SRC_COLOR, s.ZERO, s.SRC_ALPHA);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", F);
              break;
          }
        else
          switch (F) {
            case Ps:
              s.blendFuncSeparate(s.SRC_ALPHA, s.ONE_MINUS_SRC_ALPHA, s.ONE, s.ONE_MINUS_SRC_ALPHA);
              break;
            case Mc:
              s.blendFunc(s.SRC_ALPHA, s.ONE);
              break;
            case bc:
              s.blendFuncSeparate(s.ZERO, s.ONE_MINUS_SRC_COLOR, s.ZERO, s.ONE);
              break;
            case Ec:
              s.blendFunc(s.ZERO, s.SRC_COLOR);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", F);
              break;
          }
        M = null, S = null, R = null, w = null, C.set(0, 0, 0), P = 0, g = F, b = ct;
      }
      return;
    }
    Me = Me || ge, fe = fe || $, Ge = Ge || ie, (ge !== p || Me !== x) && (s.blendEquationSeparate(nt[ge], nt[Me]), p = ge, x = Me), ($ !== M || ie !== S || fe !== R || Ge !== w) && (s.blendFuncSeparate(De[$], De[ie], De[fe], De[Ge]), M = $, S = ie, R = fe, w = Ge), (St.equals(C) === !1 || Qe !== P) && (s.blendColor(St.r, St.g, St.b, Qe), C.copy(St), P = Qe), g = F, b = !1;
  }
  function Ue(F, ge) {
    F.side === In ? de(s.CULL_FACE) : X(s.CULL_FACE);
    let $ = F.side === an;
    ge && ($ = !$), Xe($), F.blending === Ps && F.transparent === !1 ? I(Pi) : I(F.blending, F.blendEquation, F.blendSrc, F.blendDst, F.blendEquationAlpha, F.blendSrcAlpha, F.blendDstAlpha, F.blendColor, F.blendAlpha, F.premultipliedAlpha), a.setFunc(F.depthFunc), a.setTest(F.depthTest), a.setMask(F.depthWrite), r.setMask(F.colorWrite);
    const ie = F.stencilWrite;
    o.setTest(ie), ie && (o.setMask(F.stencilWriteMask), o.setFunc(F.stencilFunc, F.stencilRef, F.stencilFuncMask), o.setOp(F.stencilFail, F.stencilZFail, F.stencilZPass)), it(F.polygonOffset, F.polygonOffsetFactor, F.polygonOffsetUnits), F.alphaToCoverage === !0 ? X(s.SAMPLE_ALPHA_TO_COVERAGE) : de(s.SAMPLE_ALPHA_TO_COVERAGE);
  }
  function Xe(F) {
    y !== F && (F ? s.frontFace(s.CW) : s.frontFace(s.CCW), y = F);
  }
  function Fe(F) {
    F !== xd ? (X(s.CULL_FACE), F !== L && (F === Sc ? s.cullFace(s.BACK) : F === vd ? s.cullFace(s.FRONT) : s.cullFace(s.FRONT_AND_BACK))) : de(s.CULL_FACE), L = F;
  }
  function Ae(F) {
    F !== O && (G && s.lineWidth(F), O = F);
  }
  function it(F, ge, $) {
    F ? (X(s.POLYGON_OFFSET_FILL), (U !== ge || N !== $) && (s.polygonOffset(ge, $), U = ge, N = $)) : de(s.POLYGON_OFFSET_FILL);
  }
  function Re(F) {
    F ? X(s.SCISSOR_TEST) : de(s.SCISSOR_TEST);
  }
  function A(F) {
    F === void 0 && (F = s.TEXTURE0 + Y - 1), Z !== F && (s.activeTexture(F), Z = F);
  }
  function v(F, ge, $) {
    $ === void 0 && (Z === null ? $ = s.TEXTURE0 + Y - 1 : $ = Z);
    let ie = Q[$];
    ie === void 0 && (ie = { type: void 0, texture: void 0 }, Q[$] = ie), (ie.type !== F || ie.texture !== ge) && (Z !== $ && (s.activeTexture($), Z = $), s.bindTexture(F, ge || re[F]), ie.type = F, ie.texture = ge);
  }
  function H() {
    const F = Q[Z];
    F !== void 0 && F.type !== void 0 && (s.bindTexture(F.type, null), F.type = void 0, F.texture = void 0);
  }
  function te() {
    try {
      s.compressedTexImage2D(...arguments);
    } catch (F) {
      console.error("THREE.WebGLState:", F);
    }
  }
  function oe() {
    try {
      s.compressedTexImage3D(...arguments);
    } catch (F) {
      console.error("THREE.WebGLState:", F);
    }
  }
  function ee() {
    try {
      s.texSubImage2D(...arguments);
    } catch (F) {
      console.error("THREE.WebGLState:", F);
    }
  }
  function Pe() {
    try {
      s.texSubImage3D(...arguments);
    } catch (F) {
      console.error("THREE.WebGLState:", F);
    }
  }
  function me() {
    try {
      s.compressedTexSubImage2D(...arguments);
    } catch (F) {
      console.error("THREE.WebGLState:", F);
    }
  }
  function _e() {
    try {
      s.compressedTexSubImage3D(...arguments);
    } catch (F) {
      console.error("THREE.WebGLState:", F);
    }
  }
  function W() {
    try {
      s.texStorage2D(...arguments);
    } catch (F) {
      console.error("THREE.WebGLState:", F);
    }
  }
  function J() {
    try {
      s.texStorage3D(...arguments);
    } catch (F) {
      console.error("THREE.WebGLState:", F);
    }
  }
  function le() {
    try {
      s.texImage2D(...arguments);
    } catch (F) {
      console.error("THREE.WebGLState:", F);
    }
  }
  function ve() {
    try {
      s.texImage3D(...arguments);
    } catch (F) {
      console.error("THREE.WebGLState:", F);
    }
  }
  function Te(F) {
    ce.equals(F) === !1 && (s.scissor(F.x, F.y, F.z, F.w), ce.copy(F));
  }
  function he(F) {
    V.equals(F) === !1 && (s.viewport(F.x, F.y, F.z, F.w), V.copy(F));
  }
  function qe(F, ge) {
    let $ = c.get(ge);
    $ === void 0 && ($ = /* @__PURE__ */ new WeakMap(), c.set(ge, $));
    let ie = $.get(F);
    ie === void 0 && (ie = s.getUniformBlockIndex(ge, F.name), $.set(F, ie));
  }
  function Ve(F, ge) {
    const ie = c.get(ge).get(F);
    l.get(ge) !== ie && (s.uniformBlockBinding(ge, ie, F.__bindingPointIndex), l.set(ge, ie));
  }
  function lt() {
    s.disable(s.BLEND), s.disable(s.CULL_FACE), s.disable(s.DEPTH_TEST), s.disable(s.POLYGON_OFFSET_FILL), s.disable(s.SCISSOR_TEST), s.disable(s.STENCIL_TEST), s.disable(s.SAMPLE_ALPHA_TO_COVERAGE), s.blendEquation(s.FUNC_ADD), s.blendFunc(s.ONE, s.ZERO), s.blendFuncSeparate(s.ONE, s.ZERO, s.ONE, s.ZERO), s.blendColor(0, 0, 0, 0), s.colorMask(!0, !0, !0, !0), s.clearColor(0, 0, 0, 0), s.depthMask(!0), s.depthFunc(s.LESS), a.setReversed(!1), s.clearDepth(1), s.stencilMask(4294967295), s.stencilFunc(s.ALWAYS, 0, 4294967295), s.stencilOp(s.KEEP, s.KEEP, s.KEEP), s.clearStencil(0), s.cullFace(s.BACK), s.frontFace(s.CCW), s.polygonOffset(0, 0), s.activeTexture(s.TEXTURE0), s.bindFramebuffer(s.FRAMEBUFFER, null), s.bindFramebuffer(s.DRAW_FRAMEBUFFER, null), s.bindFramebuffer(s.READ_FRAMEBUFFER, null), s.useProgram(null), s.lineWidth(1), s.scissor(0, 0, s.canvas.width, s.canvas.height), s.viewport(0, 0, s.canvas.width, s.canvas.height), u = {}, Z = null, Q = {}, h = {}, d = /* @__PURE__ */ new WeakMap(), f = [], m = null, _ = !1, g = null, p = null, M = null, S = null, x = null, R = null, w = null, C = new He(0, 0, 0), P = 0, b = !1, y = null, L = null, O = null, U = null, N = null, ce.set(0, 0, s.canvas.width, s.canvas.height), V.set(0, 0, s.canvas.width, s.canvas.height), r.reset(), a.reset(), o.reset();
  }
  return {
    buffers: {
      color: r,
      depth: a,
      stencil: o
    },
    enable: X,
    disable: de,
    bindFramebuffer: be,
    drawBuffers: Le,
    useProgram: Be,
    setBlending: I,
    setMaterial: Ue,
    setFlipSided: Xe,
    setCullFace: Fe,
    setLineWidth: Ae,
    setPolygonOffset: it,
    setScissorTest: Re,
    activeTexture: A,
    bindTexture: v,
    unbindTexture: H,
    compressedTexImage2D: te,
    compressedTexImage3D: oe,
    texImage2D: le,
    texImage3D: ve,
    updateUBOMapping: qe,
    uniformBlockBinding: Ve,
    texStorage2D: W,
    texStorage3D: J,
    texSubImage2D: ee,
    texSubImage3D: Pe,
    compressedTexSubImage2D: me,
    compressedTexSubImage3D: _e,
    scissor: Te,
    viewport: he,
    reset: lt
  };
}
function Ex(s, e, t, n, i, r, a) {
  const o = e.has("WEBGL_multisampled_render_to_texture") ? e.get("WEBGL_multisampled_render_to_texture") : null, l = typeof navigator > "u" ? !1 : /OculusBrowser/g.test(navigator.userAgent), c = new ze(), u = /* @__PURE__ */ new WeakMap();
  let h;
  const d = /* @__PURE__ */ new WeakMap();
  let f = !1;
  try {
    f = typeof OffscreenCanvas < "u" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
  } catch {
  }
  function m(A, v) {
    return f ? (
      // eslint-disable-next-line compat/compat
      new OffscreenCanvas(A, v)
    ) : br("canvas");
  }
  function _(A, v, H) {
    let te = 1;
    const oe = Re(A);
    if ((oe.width > H || oe.height > H) && (te = H / Math.max(oe.width, oe.height)), te < 1)
      if (typeof HTMLImageElement < "u" && A instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && A instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && A instanceof ImageBitmap || typeof VideoFrame < "u" && A instanceof VideoFrame) {
        const ee = Math.floor(te * oe.width), Pe = Math.floor(te * oe.height);
        h === void 0 && (h = m(ee, Pe));
        const me = v ? m(ee, Pe) : h;
        return me.width = ee, me.height = Pe, me.getContext("2d").drawImage(A, 0, 0, ee, Pe), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + oe.width + "x" + oe.height + ") to (" + ee + "x" + Pe + ")."), me;
      } else
        return "data" in A && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + oe.width + "x" + oe.height + ")."), A;
    return A;
  }
  function g(A) {
    return A.generateMipmaps;
  }
  function p(A) {
    s.generateMipmap(A);
  }
  function M(A) {
    return A.isWebGLCubeRenderTarget ? s.TEXTURE_CUBE_MAP : A.isWebGL3DRenderTarget ? s.TEXTURE_3D : A.isWebGLArrayRenderTarget || A.isCompressedArrayTexture ? s.TEXTURE_2D_ARRAY : s.TEXTURE_2D;
  }
  function S(A, v, H, te, oe = !1) {
    if (A !== null) {
      if (s[A] !== void 0) return s[A];
      console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + A + "'");
    }
    let ee = v;
    if (v === s.RED && (H === s.FLOAT && (ee = s.R32F), H === s.HALF_FLOAT && (ee = s.R16F), H === s.UNSIGNED_BYTE && (ee = s.R8)), v === s.RED_INTEGER && (H === s.UNSIGNED_BYTE && (ee = s.R8UI), H === s.UNSIGNED_SHORT && (ee = s.R16UI), H === s.UNSIGNED_INT && (ee = s.R32UI), H === s.BYTE && (ee = s.R8I), H === s.SHORT && (ee = s.R16I), H === s.INT && (ee = s.R32I)), v === s.RG && (H === s.FLOAT && (ee = s.RG32F), H === s.HALF_FLOAT && (ee = s.RG16F), H === s.UNSIGNED_BYTE && (ee = s.RG8)), v === s.RG_INTEGER && (H === s.UNSIGNED_BYTE && (ee = s.RG8UI), H === s.UNSIGNED_SHORT && (ee = s.RG16UI), H === s.UNSIGNED_INT && (ee = s.RG32UI), H === s.BYTE && (ee = s.RG8I), H === s.SHORT && (ee = s.RG16I), H === s.INT && (ee = s.RG32I)), v === s.RGB_INTEGER && (H === s.UNSIGNED_BYTE && (ee = s.RGB8UI), H === s.UNSIGNED_SHORT && (ee = s.RGB16UI), H === s.UNSIGNED_INT && (ee = s.RGB32UI), H === s.BYTE && (ee = s.RGB8I), H === s.SHORT && (ee = s.RGB16I), H === s.INT && (ee = s.RGB32I)), v === s.RGBA_INTEGER && (H === s.UNSIGNED_BYTE && (ee = s.RGBA8UI), H === s.UNSIGNED_SHORT && (ee = s.RGBA16UI), H === s.UNSIGNED_INT && (ee = s.RGBA32UI), H === s.BYTE && (ee = s.RGBA8I), H === s.SHORT && (ee = s.RGBA16I), H === s.INT && (ee = s.RGBA32I)), v === s.RGB && H === s.UNSIGNED_INT_5_9_9_9_REV && (ee = s.RGB9_E5), v === s.RGBA) {
      const Pe = oe ? Ea : ot.getTransfer(te);
      H === s.FLOAT && (ee = s.RGBA32F), H === s.HALF_FLOAT && (ee = s.RGBA16F), H === s.UNSIGNED_BYTE && (ee = Pe === vt ? s.SRGB8_ALPHA8 : s.RGBA8), H === s.UNSIGNED_SHORT_4_4_4_4 && (ee = s.RGBA4), H === s.UNSIGNED_SHORT_5_5_5_1 && (ee = s.RGB5_A1);
    }
    return (ee === s.R16F || ee === s.R32F || ee === s.RG16F || ee === s.RG32F || ee === s.RGBA16F || ee === s.RGBA32F) && e.get("EXT_color_buffer_float"), ee;
  }
  function x(A, v) {
    let H;
    return A ? v === null || v === Ii || v === xr ? H = s.DEPTH24_STENCIL8 : v === hn ? H = s.DEPTH32F_STENCIL8 : v === _r && (H = s.DEPTH24_STENCIL8, console.warn("DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.")) : v === null || v === Ii || v === xr ? H = s.DEPTH_COMPONENT24 : v === hn ? H = s.DEPTH_COMPONENT32F : v === _r && (H = s.DEPTH_COMPONENT16), H;
  }
  function R(A, v) {
    return g(A) === !0 || A.isFramebufferTexture && A.minFilter !== en && A.minFilter !== Vt ? Math.log2(Math.max(v.width, v.height)) + 1 : A.mipmaps !== void 0 && A.mipmaps.length > 0 ? A.mipmaps.length : A.isCompressedTexture && Array.isArray(A.image) ? v.mipmaps.length : 1;
  }
  function w(A) {
    const v = A.target;
    v.removeEventListener("dispose", w), P(v), v.isVideoTexture && u.delete(v);
  }
  function C(A) {
    const v = A.target;
    v.removeEventListener("dispose", C), y(v);
  }
  function P(A) {
    const v = n.get(A);
    if (v.__webglInit === void 0) return;
    const H = A.source, te = d.get(H);
    if (te) {
      const oe = te[v.__cacheKey];
      oe.usedTimes--, oe.usedTimes === 0 && b(A), Object.keys(te).length === 0 && d.delete(H);
    }
    n.remove(A);
  }
  function b(A) {
    const v = n.get(A);
    s.deleteTexture(v.__webglTexture);
    const H = A.source, te = d.get(H);
    delete te[v.__cacheKey], a.memory.textures--;
  }
  function y(A) {
    const v = n.get(A);
    if (A.depthTexture && (A.depthTexture.dispose(), n.remove(A.depthTexture)), A.isWebGLCubeRenderTarget)
      for (let te = 0; te < 6; te++) {
        if (Array.isArray(v.__webglFramebuffer[te]))
          for (let oe = 0; oe < v.__webglFramebuffer[te].length; oe++) s.deleteFramebuffer(v.__webglFramebuffer[te][oe]);
        else
          s.deleteFramebuffer(v.__webglFramebuffer[te]);
        v.__webglDepthbuffer && s.deleteRenderbuffer(v.__webglDepthbuffer[te]);
      }
    else {
      if (Array.isArray(v.__webglFramebuffer))
        for (let te = 0; te < v.__webglFramebuffer.length; te++) s.deleteFramebuffer(v.__webglFramebuffer[te]);
      else
        s.deleteFramebuffer(v.__webglFramebuffer);
      if (v.__webglDepthbuffer && s.deleteRenderbuffer(v.__webglDepthbuffer), v.__webglMultisampledFramebuffer && s.deleteFramebuffer(v.__webglMultisampledFramebuffer), v.__webglColorRenderbuffer)
        for (let te = 0; te < v.__webglColorRenderbuffer.length; te++)
          v.__webglColorRenderbuffer[te] && s.deleteRenderbuffer(v.__webglColorRenderbuffer[te]);
      v.__webglDepthRenderbuffer && s.deleteRenderbuffer(v.__webglDepthRenderbuffer);
    }
    const H = A.textures;
    for (let te = 0, oe = H.length; te < oe; te++) {
      const ee = n.get(H[te]);
      ee.__webglTexture && (s.deleteTexture(ee.__webglTexture), a.memory.textures--), n.remove(H[te]);
    }
    n.remove(A);
  }
  let L = 0;
  function O() {
    L = 0;
  }
  function U() {
    const A = L;
    return A >= i.maxTextures && console.warn("THREE.WebGLTextures: Trying to use " + A + " texture units while this GPU supports only " + i.maxTextures), L += 1, A;
  }
  function N(A) {
    const v = [];
    return v.push(A.wrapS), v.push(A.wrapT), v.push(A.wrapR || 0), v.push(A.magFilter), v.push(A.minFilter), v.push(A.anisotropy), v.push(A.internalFormat), v.push(A.format), v.push(A.type), v.push(A.generateMipmaps), v.push(A.premultiplyAlpha), v.push(A.flipY), v.push(A.unpackAlignment), v.push(A.colorSpace), v.join();
  }
  function Y(A, v) {
    const H = n.get(A);
    if (A.isVideoTexture && Ae(A), A.isRenderTargetTexture === !1 && A.version > 0 && H.__version !== A.version) {
      const te = A.image;
      if (te === null)
        console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
      else if (te.complete === !1)
        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
      else {
        V(H, A, v);
        return;
      }
    }
    t.bindTexture(s.TEXTURE_2D, H.__webglTexture, s.TEXTURE0 + v);
  }
  function G(A, v) {
    const H = n.get(A);
    if (A.version > 0 && H.__version !== A.version) {
      V(H, A, v);
      return;
    }
    t.bindTexture(s.TEXTURE_2D_ARRAY, H.__webglTexture, s.TEXTURE0 + v);
  }
  function ne(A, v) {
    const H = n.get(A);
    if (A.version > 0 && H.__version !== A.version) {
      V(H, A, v);
      return;
    }
    t.bindTexture(s.TEXTURE_3D, H.__webglTexture, s.TEXTURE0 + v);
  }
  function B(A, v) {
    const H = n.get(A);
    if (A.version > 0 && H.__version !== A.version) {
      se(H, A, v);
      return;
    }
    t.bindTexture(s.TEXTURE_CUBE_MAP, H.__webglTexture, s.TEXTURE0 + v);
  }
  const Z = {
    [Fs]: s.REPEAT,
    [Vn]: s.CLAMP_TO_EDGE,
    [Ma]: s.MIRRORED_REPEAT
  }, Q = {
    [en]: s.NEAREST,
    [yh]: s.NEAREST_MIPMAP_NEAREST,
    [ur]: s.NEAREST_MIPMAP_LINEAR,
    [Vt]: s.LINEAR,
    [da]: s.LINEAR_MIPMAP_NEAREST,
    [Gn]: s.LINEAR_MIPMAP_LINEAR
  }, xe = {
    [tf]: s.NEVER,
    [lf]: s.ALWAYS,
    [nf]: s.LESS,
    [Dh]: s.LEQUAL,
    [sf]: s.EQUAL,
    [of]: s.GEQUAL,
    [rf]: s.GREATER,
    [af]: s.NOTEQUAL
  };
  function ye(A, v) {
    if (v.type === hn && e.has("OES_texture_float_linear") === !1 && (v.magFilter === Vt || v.magFilter === da || v.magFilter === ur || v.magFilter === Gn || v.minFilter === Vt || v.minFilter === da || v.minFilter === ur || v.minFilter === Gn) && console.warn("THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device."), s.texParameteri(A, s.TEXTURE_WRAP_S, Z[v.wrapS]), s.texParameteri(A, s.TEXTURE_WRAP_T, Z[v.wrapT]), (A === s.TEXTURE_3D || A === s.TEXTURE_2D_ARRAY) && s.texParameteri(A, s.TEXTURE_WRAP_R, Z[v.wrapR]), s.texParameteri(A, s.TEXTURE_MAG_FILTER, Q[v.magFilter]), s.texParameteri(A, s.TEXTURE_MIN_FILTER, Q[v.minFilter]), v.compareFunction && (s.texParameteri(A, s.TEXTURE_COMPARE_MODE, s.COMPARE_REF_TO_TEXTURE), s.texParameteri(A, s.TEXTURE_COMPARE_FUNC, xe[v.compareFunction])), e.has("EXT_texture_filter_anisotropic") === !0) {
      if (v.magFilter === en || v.minFilter !== ur && v.minFilter !== Gn || v.type === hn && e.has("OES_texture_float_linear") === !1) return;
      if (v.anisotropy > 1 || n.get(v).__currentAnisotropy) {
        const H = e.get("EXT_texture_filter_anisotropic");
        s.texParameterf(A, H.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(v.anisotropy, i.getMaxAnisotropy())), n.get(v).__currentAnisotropy = v.anisotropy;
      }
    }
  }
  function ce(A, v) {
    let H = !1;
    A.__webglInit === void 0 && (A.__webglInit = !0, v.addEventListener("dispose", w));
    const te = v.source;
    let oe = d.get(te);
    oe === void 0 && (oe = {}, d.set(te, oe));
    const ee = N(v);
    if (ee !== A.__cacheKey) {
      oe[ee] === void 0 && (oe[ee] = {
        texture: s.createTexture(),
        usedTimes: 0
      }, a.memory.textures++, H = !0), oe[ee].usedTimes++;
      const Pe = oe[A.__cacheKey];
      Pe !== void 0 && (oe[A.__cacheKey].usedTimes--, Pe.usedTimes === 0 && b(v)), A.__cacheKey = ee, A.__webglTexture = oe[ee].texture;
    }
    return H;
  }
  function V(A, v, H) {
    let te = s.TEXTURE_2D;
    (v.isDataArrayTexture || v.isCompressedArrayTexture) && (te = s.TEXTURE_2D_ARRAY), v.isData3DTexture && (te = s.TEXTURE_3D);
    const oe = ce(A, v), ee = v.source;
    t.bindTexture(te, A.__webglTexture, s.TEXTURE0 + H);
    const Pe = n.get(ee);
    if (ee.version !== Pe.__version || oe === !0) {
      t.activeTexture(s.TEXTURE0 + H);
      const me = ot.getPrimaries(ot.workingColorSpace), _e = v.colorSpace === Ri ? null : ot.getPrimaries(v.colorSpace), W = v.colorSpace === Ri || me === _e ? s.NONE : s.BROWSER_DEFAULT_WEBGL;
      s.pixelStorei(s.UNPACK_FLIP_Y_WEBGL, v.flipY), s.pixelStorei(s.UNPACK_PREMULTIPLY_ALPHA_WEBGL, v.premultiplyAlpha), s.pixelStorei(s.UNPACK_ALIGNMENT, v.unpackAlignment), s.pixelStorei(s.UNPACK_COLORSPACE_CONVERSION_WEBGL, W);
      let J = _(v.image, !1, i.maxTextureSize);
      J = it(v, J);
      const le = r.convert(v.format, v.colorSpace), ve = r.convert(v.type);
      let Te = S(v.internalFormat, le, ve, v.colorSpace, v.isVideoTexture);
      ye(te, v);
      let he;
      const qe = v.mipmaps, Ve = v.isVideoTexture !== !0, lt = Pe.__version === void 0 || oe === !0, F = ee.dataReady, ge = R(v, J);
      if (v.isDepthTexture)
        Te = x(v.format === yr, v.type), lt && (Ve ? t.texStorage2D(s.TEXTURE_2D, 1, Te, J.width, J.height) : t.texImage2D(s.TEXTURE_2D, 0, Te, J.width, J.height, 0, le, ve, null));
      else if (v.isDataTexture)
        if (qe.length > 0) {
          Ve && lt && t.texStorage2D(s.TEXTURE_2D, ge, Te, qe[0].width, qe[0].height);
          for (let $ = 0, ie = qe.length; $ < ie; $++)
            he = qe[$], Ve ? F && t.texSubImage2D(s.TEXTURE_2D, $, 0, 0, he.width, he.height, le, ve, he.data) : t.texImage2D(s.TEXTURE_2D, $, Te, he.width, he.height, 0, le, ve, he.data);
          v.generateMipmaps = !1;
        } else
          Ve ? (lt && t.texStorage2D(s.TEXTURE_2D, ge, Te, J.width, J.height), F && t.texSubImage2D(s.TEXTURE_2D, 0, 0, 0, J.width, J.height, le, ve, J.data)) : t.texImage2D(s.TEXTURE_2D, 0, Te, J.width, J.height, 0, le, ve, J.data);
      else if (v.isCompressedTexture)
        if (v.isCompressedArrayTexture) {
          Ve && lt && t.texStorage3D(s.TEXTURE_2D_ARRAY, ge, Te, qe[0].width, qe[0].height, J.depth);
          for (let $ = 0, ie = qe.length; $ < ie; $++)
            if (he = qe[$], v.format !== mn)
              if (le !== null)
                if (Ve) {
                  if (F)
                    if (v.layerUpdates.size > 0) {
                      const Me = fu(he.width, he.height, v.format, v.type);
                      for (const fe of v.layerUpdates) {
                        const Ge = he.data.subarray(
                          fe * Me / he.data.BYTES_PER_ELEMENT,
                          (fe + 1) * Me / he.data.BYTES_PER_ELEMENT
                        );
                        t.compressedTexSubImage3D(s.TEXTURE_2D_ARRAY, $, 0, 0, fe, he.width, he.height, 1, le, Ge);
                      }
                      v.clearLayerUpdates();
                    } else
                      t.compressedTexSubImage3D(s.TEXTURE_2D_ARRAY, $, 0, 0, 0, he.width, he.height, J.depth, le, he.data);
                } else
                  t.compressedTexImage3D(s.TEXTURE_2D_ARRAY, $, Te, he.width, he.height, J.depth, 0, he.data, 0, 0);
              else
                console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
            else
              Ve ? F && t.texSubImage3D(s.TEXTURE_2D_ARRAY, $, 0, 0, 0, he.width, he.height, J.depth, le, ve, he.data) : t.texImage3D(s.TEXTURE_2D_ARRAY, $, Te, he.width, he.height, J.depth, 0, le, ve, he.data);
        } else {
          Ve && lt && t.texStorage2D(s.TEXTURE_2D, ge, Te, qe[0].width, qe[0].height);
          for (let $ = 0, ie = qe.length; $ < ie; $++)
            he = qe[$], v.format !== mn ? le !== null ? Ve ? F && t.compressedTexSubImage2D(s.TEXTURE_2D, $, 0, 0, he.width, he.height, le, he.data) : t.compressedTexImage2D(s.TEXTURE_2D, $, Te, he.width, he.height, 0, he.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : Ve ? F && t.texSubImage2D(s.TEXTURE_2D, $, 0, 0, he.width, he.height, le, ve, he.data) : t.texImage2D(s.TEXTURE_2D, $, Te, he.width, he.height, 0, le, ve, he.data);
        }
      else if (v.isDataArrayTexture)
        if (Ve) {
          if (lt && t.texStorage3D(s.TEXTURE_2D_ARRAY, ge, Te, J.width, J.height, J.depth), F)
            if (v.layerUpdates.size > 0) {
              const $ = fu(J.width, J.height, v.format, v.type);
              for (const ie of v.layerUpdates) {
                const Me = J.data.subarray(
                  ie * $ / J.data.BYTES_PER_ELEMENT,
                  (ie + 1) * $ / J.data.BYTES_PER_ELEMENT
                );
                t.texSubImage3D(s.TEXTURE_2D_ARRAY, 0, 0, 0, ie, J.width, J.height, 1, le, ve, Me);
              }
              v.clearLayerUpdates();
            } else
              t.texSubImage3D(s.TEXTURE_2D_ARRAY, 0, 0, 0, 0, J.width, J.height, J.depth, le, ve, J.data);
        } else
          t.texImage3D(s.TEXTURE_2D_ARRAY, 0, Te, J.width, J.height, J.depth, 0, le, ve, J.data);
      else if (v.isData3DTexture)
        Ve ? (lt && t.texStorage3D(s.TEXTURE_3D, ge, Te, J.width, J.height, J.depth), F && t.texSubImage3D(s.TEXTURE_3D, 0, 0, 0, 0, J.width, J.height, J.depth, le, ve, J.data)) : t.texImage3D(s.TEXTURE_3D, 0, Te, J.width, J.height, J.depth, 0, le, ve, J.data);
      else if (v.isFramebufferTexture) {
        if (lt)
          if (Ve)
            t.texStorage2D(s.TEXTURE_2D, ge, Te, J.width, J.height);
          else {
            let $ = J.width, ie = J.height;
            for (let Me = 0; Me < ge; Me++)
              t.texImage2D(s.TEXTURE_2D, Me, Te, $, ie, 0, le, ve, null), $ >>= 1, ie >>= 1;
          }
      } else if (qe.length > 0) {
        if (Ve && lt) {
          const $ = Re(qe[0]);
          t.texStorage2D(s.TEXTURE_2D, ge, Te, $.width, $.height);
        }
        for (let $ = 0, ie = qe.length; $ < ie; $++)
          he = qe[$], Ve ? F && t.texSubImage2D(s.TEXTURE_2D, $, 0, 0, le, ve, he) : t.texImage2D(s.TEXTURE_2D, $, Te, le, ve, he);
        v.generateMipmaps = !1;
      } else if (Ve) {
        if (lt) {
          const $ = Re(J);
          t.texStorage2D(s.TEXTURE_2D, ge, Te, $.width, $.height);
        }
        F && t.texSubImage2D(s.TEXTURE_2D, 0, 0, 0, le, ve, J);
      } else
        t.texImage2D(s.TEXTURE_2D, 0, Te, le, ve, J);
      g(v) && p(te), Pe.__version = ee.version, v.onUpdate && v.onUpdate(v);
    }
    A.__version = v.version;
  }
  function se(A, v, H) {
    if (v.image.length !== 6) return;
    const te = ce(A, v), oe = v.source;
    t.bindTexture(s.TEXTURE_CUBE_MAP, A.__webglTexture, s.TEXTURE0 + H);
    const ee = n.get(oe);
    if (oe.version !== ee.__version || te === !0) {
      t.activeTexture(s.TEXTURE0 + H);
      const Pe = ot.getPrimaries(ot.workingColorSpace), me = v.colorSpace === Ri ? null : ot.getPrimaries(v.colorSpace), _e = v.colorSpace === Ri || Pe === me ? s.NONE : s.BROWSER_DEFAULT_WEBGL;
      s.pixelStorei(s.UNPACK_FLIP_Y_WEBGL, v.flipY), s.pixelStorei(s.UNPACK_PREMULTIPLY_ALPHA_WEBGL, v.premultiplyAlpha), s.pixelStorei(s.UNPACK_ALIGNMENT, v.unpackAlignment), s.pixelStorei(s.UNPACK_COLORSPACE_CONVERSION_WEBGL, _e);
      const W = v.isCompressedTexture || v.image[0].isCompressedTexture, J = v.image[0] && v.image[0].isDataTexture, le = [];
      for (let ie = 0; ie < 6; ie++)
        !W && !J ? le[ie] = _(v.image[ie], !0, i.maxCubemapSize) : le[ie] = J ? v.image[ie].image : v.image[ie], le[ie] = it(v, le[ie]);
      const ve = le[0], Te = r.convert(v.format, v.colorSpace), he = r.convert(v.type), qe = S(v.internalFormat, Te, he, v.colorSpace), Ve = v.isVideoTexture !== !0, lt = ee.__version === void 0 || te === !0, F = oe.dataReady;
      let ge = R(v, ve);
      ye(s.TEXTURE_CUBE_MAP, v);
      let $;
      if (W) {
        Ve && lt && t.texStorage2D(s.TEXTURE_CUBE_MAP, ge, qe, ve.width, ve.height);
        for (let ie = 0; ie < 6; ie++) {
          $ = le[ie].mipmaps;
          for (let Me = 0; Me < $.length; Me++) {
            const fe = $[Me];
            v.format !== mn ? Te !== null ? Ve ? F && t.compressedTexSubImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + ie, Me, 0, 0, fe.width, fe.height, Te, fe.data) : t.compressedTexImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + ie, Me, qe, fe.width, fe.height, 0, fe.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : Ve ? F && t.texSubImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + ie, Me, 0, 0, fe.width, fe.height, Te, he, fe.data) : t.texImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + ie, Me, qe, fe.width, fe.height, 0, Te, he, fe.data);
          }
        }
      } else {
        if ($ = v.mipmaps, Ve && lt) {
          $.length > 0 && ge++;
          const ie = Re(le[0]);
          t.texStorage2D(s.TEXTURE_CUBE_MAP, ge, qe, ie.width, ie.height);
        }
        for (let ie = 0; ie < 6; ie++)
          if (J) {
            Ve ? F && t.texSubImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + ie, 0, 0, 0, le[ie].width, le[ie].height, Te, he, le[ie].data) : t.texImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + ie, 0, qe, le[ie].width, le[ie].height, 0, Te, he, le[ie].data);
            for (let Me = 0; Me < $.length; Me++) {
              const Ge = $[Me].image[ie].image;
              Ve ? F && t.texSubImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + ie, Me + 1, 0, 0, Ge.width, Ge.height, Te, he, Ge.data) : t.texImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + ie, Me + 1, qe, Ge.width, Ge.height, 0, Te, he, Ge.data);
            }
          } else {
            Ve ? F && t.texSubImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + ie, 0, 0, 0, Te, he, le[ie]) : t.texImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + ie, 0, qe, Te, he, le[ie]);
            for (let Me = 0; Me < $.length; Me++) {
              const fe = $[Me];
              Ve ? F && t.texSubImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + ie, Me + 1, 0, 0, Te, he, fe.image[ie]) : t.texImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + ie, Me + 1, qe, Te, he, fe.image[ie]);
            }
          }
      }
      g(v) && p(s.TEXTURE_CUBE_MAP), ee.__version = oe.version, v.onUpdate && v.onUpdate(v);
    }
    A.__version = v.version;
  }
  function re(A, v, H, te, oe, ee) {
    const Pe = r.convert(H.format, H.colorSpace), me = r.convert(H.type), _e = S(H.internalFormat, Pe, me, H.colorSpace), W = n.get(v), J = n.get(H);
    if (J.__renderTarget = v, !W.__hasExternalTextures) {
      const le = Math.max(1, v.width >> ee), ve = Math.max(1, v.height >> ee);
      oe === s.TEXTURE_3D || oe === s.TEXTURE_2D_ARRAY ? t.texImage3D(oe, ee, _e, le, ve, v.depth, 0, Pe, me, null) : t.texImage2D(oe, ee, _e, le, ve, 0, Pe, me, null);
    }
    t.bindFramebuffer(s.FRAMEBUFFER, A), Fe(v) ? o.framebufferTexture2DMultisampleEXT(s.FRAMEBUFFER, te, oe, J.__webglTexture, 0, Xe(v)) : (oe === s.TEXTURE_2D || oe >= s.TEXTURE_CUBE_MAP_POSITIVE_X && oe <= s.TEXTURE_CUBE_MAP_NEGATIVE_Z) && s.framebufferTexture2D(s.FRAMEBUFFER, te, oe, J.__webglTexture, ee), t.bindFramebuffer(s.FRAMEBUFFER, null);
  }
  function X(A, v, H) {
    if (s.bindRenderbuffer(s.RENDERBUFFER, A), v.depthBuffer) {
      const te = v.depthTexture, oe = te && te.isDepthTexture ? te.type : null, ee = x(v.stencilBuffer, oe), Pe = v.stencilBuffer ? s.DEPTH_STENCIL_ATTACHMENT : s.DEPTH_ATTACHMENT, me = Xe(v);
      Fe(v) ? o.renderbufferStorageMultisampleEXT(s.RENDERBUFFER, me, ee, v.width, v.height) : H ? s.renderbufferStorageMultisample(s.RENDERBUFFER, me, ee, v.width, v.height) : s.renderbufferStorage(s.RENDERBUFFER, ee, v.width, v.height), s.framebufferRenderbuffer(s.FRAMEBUFFER, Pe, s.RENDERBUFFER, A);
    } else {
      const te = v.textures;
      for (let oe = 0; oe < te.length; oe++) {
        const ee = te[oe], Pe = r.convert(ee.format, ee.colorSpace), me = r.convert(ee.type), _e = S(ee.internalFormat, Pe, me, ee.colorSpace), W = Xe(v);
        H && Fe(v) === !1 ? s.renderbufferStorageMultisample(s.RENDERBUFFER, W, _e, v.width, v.height) : Fe(v) ? o.renderbufferStorageMultisampleEXT(s.RENDERBUFFER, W, _e, v.width, v.height) : s.renderbufferStorage(s.RENDERBUFFER, _e, v.width, v.height);
      }
    }
    s.bindRenderbuffer(s.RENDERBUFFER, null);
  }
  function de(A, v) {
    if (v && v.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
    if (t.bindFramebuffer(s.FRAMEBUFFER, A), !(v.depthTexture && v.depthTexture.isDepthTexture))
      throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
    const te = n.get(v.depthTexture);
    te.__renderTarget = v, (!te.__webglTexture || v.depthTexture.image.width !== v.width || v.depthTexture.image.height !== v.height) && (v.depthTexture.image.width = v.width, v.depthTexture.image.height = v.height, v.depthTexture.needsUpdate = !0), Y(v.depthTexture, 0);
    const oe = te.__webglTexture, ee = Xe(v);
    if (v.depthTexture.format === vr)
      Fe(v) ? o.framebufferTexture2DMultisampleEXT(s.FRAMEBUFFER, s.DEPTH_ATTACHMENT, s.TEXTURE_2D, oe, 0, ee) : s.framebufferTexture2D(s.FRAMEBUFFER, s.DEPTH_ATTACHMENT, s.TEXTURE_2D, oe, 0);
    else if (v.depthTexture.format === yr)
      Fe(v) ? o.framebufferTexture2DMultisampleEXT(s.FRAMEBUFFER, s.DEPTH_STENCIL_ATTACHMENT, s.TEXTURE_2D, oe, 0, ee) : s.framebufferTexture2D(s.FRAMEBUFFER, s.DEPTH_STENCIL_ATTACHMENT, s.TEXTURE_2D, oe, 0);
    else
      throw new Error("Unknown depthTexture format");
  }
  function be(A) {
    const v = n.get(A), H = A.isWebGLCubeRenderTarget === !0;
    if (v.__boundDepthTexture !== A.depthTexture) {
      const te = A.depthTexture;
      if (v.__depthDisposeCallback && v.__depthDisposeCallback(), te) {
        const oe = () => {
          delete v.__boundDepthTexture, delete v.__depthDisposeCallback, te.removeEventListener("dispose", oe);
        };
        te.addEventListener("dispose", oe), v.__depthDisposeCallback = oe;
      }
      v.__boundDepthTexture = te;
    }
    if (A.depthTexture && !v.__autoAllocateDepthBuffer) {
      if (H) throw new Error("target.depthTexture not supported in Cube render targets");
      de(v.__webglFramebuffer, A);
    } else if (H) {
      v.__webglDepthbuffer = [];
      for (let te = 0; te < 6; te++)
        if (t.bindFramebuffer(s.FRAMEBUFFER, v.__webglFramebuffer[te]), v.__webglDepthbuffer[te] === void 0)
          v.__webglDepthbuffer[te] = s.createRenderbuffer(), X(v.__webglDepthbuffer[te], A, !1);
        else {
          const oe = A.stencilBuffer ? s.DEPTH_STENCIL_ATTACHMENT : s.DEPTH_ATTACHMENT, ee = v.__webglDepthbuffer[te];
          s.bindRenderbuffer(s.RENDERBUFFER, ee), s.framebufferRenderbuffer(s.FRAMEBUFFER, oe, s.RENDERBUFFER, ee);
        }
    } else if (t.bindFramebuffer(s.FRAMEBUFFER, v.__webglFramebuffer), v.__webglDepthbuffer === void 0)
      v.__webglDepthbuffer = s.createRenderbuffer(), X(v.__webglDepthbuffer, A, !1);
    else {
      const te = A.stencilBuffer ? s.DEPTH_STENCIL_ATTACHMENT : s.DEPTH_ATTACHMENT, oe = v.__webglDepthbuffer;
      s.bindRenderbuffer(s.RENDERBUFFER, oe), s.framebufferRenderbuffer(s.FRAMEBUFFER, te, s.RENDERBUFFER, oe);
    }
    t.bindFramebuffer(s.FRAMEBUFFER, null);
  }
  function Le(A, v, H) {
    const te = n.get(A);
    v !== void 0 && re(te.__webglFramebuffer, A, A.texture, s.COLOR_ATTACHMENT0, s.TEXTURE_2D, 0), H !== void 0 && be(A);
  }
  function Be(A) {
    const v = A.texture, H = n.get(A), te = n.get(v);
    A.addEventListener("dispose", C);
    const oe = A.textures, ee = A.isWebGLCubeRenderTarget === !0, Pe = oe.length > 1;
    if (Pe || (te.__webglTexture === void 0 && (te.__webglTexture = s.createTexture()), te.__version = v.version, a.memory.textures++), ee) {
      H.__webglFramebuffer = [];
      for (let me = 0; me < 6; me++)
        if (v.mipmaps && v.mipmaps.length > 0) {
          H.__webglFramebuffer[me] = [];
          for (let _e = 0; _e < v.mipmaps.length; _e++)
            H.__webglFramebuffer[me][_e] = s.createFramebuffer();
        } else
          H.__webglFramebuffer[me] = s.createFramebuffer();
    } else {
      if (v.mipmaps && v.mipmaps.length > 0) {
        H.__webglFramebuffer = [];
        for (let me = 0; me < v.mipmaps.length; me++)
          H.__webglFramebuffer[me] = s.createFramebuffer();
      } else
        H.__webglFramebuffer = s.createFramebuffer();
      if (Pe)
        for (let me = 0, _e = oe.length; me < _e; me++) {
          const W = n.get(oe[me]);
          W.__webglTexture === void 0 && (W.__webglTexture = s.createTexture(), a.memory.textures++);
        }
      if (A.samples > 0 && Fe(A) === !1) {
        H.__webglMultisampledFramebuffer = s.createFramebuffer(), H.__webglColorRenderbuffer = [], t.bindFramebuffer(s.FRAMEBUFFER, H.__webglMultisampledFramebuffer);
        for (let me = 0; me < oe.length; me++) {
          const _e = oe[me];
          H.__webglColorRenderbuffer[me] = s.createRenderbuffer(), s.bindRenderbuffer(s.RENDERBUFFER, H.__webglColorRenderbuffer[me]);
          const W = r.convert(_e.format, _e.colorSpace), J = r.convert(_e.type), le = S(_e.internalFormat, W, J, _e.colorSpace, A.isXRRenderTarget === !0), ve = Xe(A);
          s.renderbufferStorageMultisample(s.RENDERBUFFER, ve, le, A.width, A.height), s.framebufferRenderbuffer(s.FRAMEBUFFER, s.COLOR_ATTACHMENT0 + me, s.RENDERBUFFER, H.__webglColorRenderbuffer[me]);
        }
        s.bindRenderbuffer(s.RENDERBUFFER, null), A.depthBuffer && (H.__webglDepthRenderbuffer = s.createRenderbuffer(), X(H.__webglDepthRenderbuffer, A, !0)), t.bindFramebuffer(s.FRAMEBUFFER, null);
      }
    }
    if (ee) {
      t.bindTexture(s.TEXTURE_CUBE_MAP, te.__webglTexture), ye(s.TEXTURE_CUBE_MAP, v);
      for (let me = 0; me < 6; me++)
        if (v.mipmaps && v.mipmaps.length > 0)
          for (let _e = 0; _e < v.mipmaps.length; _e++)
            re(H.__webglFramebuffer[me][_e], A, v, s.COLOR_ATTACHMENT0, s.TEXTURE_CUBE_MAP_POSITIVE_X + me, _e);
        else
          re(H.__webglFramebuffer[me], A, v, s.COLOR_ATTACHMENT0, s.TEXTURE_CUBE_MAP_POSITIVE_X + me, 0);
      g(v) && p(s.TEXTURE_CUBE_MAP), t.unbindTexture();
    } else if (Pe) {
      for (let me = 0, _e = oe.length; me < _e; me++) {
        const W = oe[me], J = n.get(W);
        t.bindTexture(s.TEXTURE_2D, J.__webglTexture), ye(s.TEXTURE_2D, W), re(H.__webglFramebuffer, A, W, s.COLOR_ATTACHMENT0 + me, s.TEXTURE_2D, 0), g(W) && p(s.TEXTURE_2D);
      }
      t.unbindTexture();
    } else {
      let me = s.TEXTURE_2D;
      if ((A.isWebGL3DRenderTarget || A.isWebGLArrayRenderTarget) && (me = A.isWebGL3DRenderTarget ? s.TEXTURE_3D : s.TEXTURE_2D_ARRAY), t.bindTexture(me, te.__webglTexture), ye(me, v), v.mipmaps && v.mipmaps.length > 0)
        for (let _e = 0; _e < v.mipmaps.length; _e++)
          re(H.__webglFramebuffer[_e], A, v, s.COLOR_ATTACHMENT0, me, _e);
      else
        re(H.__webglFramebuffer, A, v, s.COLOR_ATTACHMENT0, me, 0);
      g(v) && p(me), t.unbindTexture();
    }
    A.depthBuffer && be(A);
  }
  function nt(A) {
    const v = A.textures;
    for (let H = 0, te = v.length; H < te; H++) {
      const oe = v[H];
      if (g(oe)) {
        const ee = M(A), Pe = n.get(oe).__webglTexture;
        t.bindTexture(ee, Pe), p(ee), t.unbindTexture();
      }
    }
  }
  const De = [], I = [];
  function Ue(A) {
    if (A.samples > 0) {
      if (Fe(A) === !1) {
        const v = A.textures, H = A.width, te = A.height;
        let oe = s.COLOR_BUFFER_BIT;
        const ee = A.stencilBuffer ? s.DEPTH_STENCIL_ATTACHMENT : s.DEPTH_ATTACHMENT, Pe = n.get(A), me = v.length > 1;
        if (me)
          for (let _e = 0; _e < v.length; _e++)
            t.bindFramebuffer(s.FRAMEBUFFER, Pe.__webglMultisampledFramebuffer), s.framebufferRenderbuffer(s.FRAMEBUFFER, s.COLOR_ATTACHMENT0 + _e, s.RENDERBUFFER, null), t.bindFramebuffer(s.FRAMEBUFFER, Pe.__webglFramebuffer), s.framebufferTexture2D(s.DRAW_FRAMEBUFFER, s.COLOR_ATTACHMENT0 + _e, s.TEXTURE_2D, null, 0);
        t.bindFramebuffer(s.READ_FRAMEBUFFER, Pe.__webglMultisampledFramebuffer), t.bindFramebuffer(s.DRAW_FRAMEBUFFER, Pe.__webglFramebuffer);
        for (let _e = 0; _e < v.length; _e++) {
          if (A.resolveDepthBuffer && (A.depthBuffer && (oe |= s.DEPTH_BUFFER_BIT), A.stencilBuffer && A.resolveStencilBuffer && (oe |= s.STENCIL_BUFFER_BIT)), me) {
            s.framebufferRenderbuffer(s.READ_FRAMEBUFFER, s.COLOR_ATTACHMENT0, s.RENDERBUFFER, Pe.__webglColorRenderbuffer[_e]);
            const W = n.get(v[_e]).__webglTexture;
            s.framebufferTexture2D(s.DRAW_FRAMEBUFFER, s.COLOR_ATTACHMENT0, s.TEXTURE_2D, W, 0);
          }
          s.blitFramebuffer(0, 0, H, te, 0, 0, H, te, oe, s.NEAREST), l === !0 && (De.length = 0, I.length = 0, De.push(s.COLOR_ATTACHMENT0 + _e), A.depthBuffer && A.resolveDepthBuffer === !1 && (De.push(ee), I.push(ee), s.invalidateFramebuffer(s.DRAW_FRAMEBUFFER, I)), s.invalidateFramebuffer(s.READ_FRAMEBUFFER, De));
        }
        if (t.bindFramebuffer(s.READ_FRAMEBUFFER, null), t.bindFramebuffer(s.DRAW_FRAMEBUFFER, null), me)
          for (let _e = 0; _e < v.length; _e++) {
            t.bindFramebuffer(s.FRAMEBUFFER, Pe.__webglMultisampledFramebuffer), s.framebufferRenderbuffer(s.FRAMEBUFFER, s.COLOR_ATTACHMENT0 + _e, s.RENDERBUFFER, Pe.__webglColorRenderbuffer[_e]);
            const W = n.get(v[_e]).__webglTexture;
            t.bindFramebuffer(s.FRAMEBUFFER, Pe.__webglFramebuffer), s.framebufferTexture2D(s.DRAW_FRAMEBUFFER, s.COLOR_ATTACHMENT0 + _e, s.TEXTURE_2D, W, 0);
          }
        t.bindFramebuffer(s.DRAW_FRAMEBUFFER, Pe.__webglMultisampledFramebuffer);
      } else if (A.depthBuffer && A.resolveDepthBuffer === !1 && l) {
        const v = A.stencilBuffer ? s.DEPTH_STENCIL_ATTACHMENT : s.DEPTH_ATTACHMENT;
        s.invalidateFramebuffer(s.DRAW_FRAMEBUFFER, [v]);
      }
    }
  }
  function Xe(A) {
    return Math.min(i.maxSamples, A.samples);
  }
  function Fe(A) {
    const v = n.get(A);
    return A.samples > 0 && e.has("WEBGL_multisampled_render_to_texture") === !0 && v.__useRenderToTexture !== !1;
  }
  function Ae(A) {
    const v = a.render.frame;
    u.get(A) !== v && (u.set(A, v), A.update());
  }
  function it(A, v) {
    const H = A.colorSpace, te = A.format, oe = A.type;
    return A.isCompressedTexture === !0 || A.isVideoTexture === !0 || H !== Zt && H !== Ri && (ot.getTransfer(H) === vt ? (te !== mn || oe !== _i) && console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture color space:", H)), v;
  }
  function Re(A) {
    return typeof HTMLImageElement < "u" && A instanceof HTMLImageElement ? (c.width = A.naturalWidth || A.width, c.height = A.naturalHeight || A.height) : typeof VideoFrame < "u" && A instanceof VideoFrame ? (c.width = A.displayWidth, c.height = A.displayHeight) : (c.width = A.width, c.height = A.height), c;
  }
  this.allocateTextureUnit = U, this.resetTextureUnits = O, this.setTexture2D = Y, this.setTexture2DArray = G, this.setTexture3D = ne, this.setTextureCube = B, this.rebindTextures = Le, this.setupRenderTarget = Be, this.updateRenderTargetMipmap = nt, this.updateMultisampleRenderTarget = Ue, this.setupDepthRenderbuffer = be, this.setupFrameBufferTexture = re, this.useMultisampledRTT = Fe;
}
function Tx(s, e) {
  function t(n, i = Ri) {
    let r;
    const a = ot.getTransfer(i);
    if (n === _i) return s.UNSIGNED_BYTE;
    if (n === Nl) return s.UNSIGNED_SHORT_4_4_4_4;
    if (n === Ul) return s.UNSIGNED_SHORT_5_5_5_1;
    if (n === bh) return s.UNSIGNED_INT_5_9_9_9_REV;
    if (n === Sh) return s.BYTE;
    if (n === Mh) return s.SHORT;
    if (n === _r) return s.UNSIGNED_SHORT;
    if (n === Dl) return s.INT;
    if (n === Ii) return s.UNSIGNED_INT;
    if (n === hn) return s.FLOAT;
    if (n === Wn) return s.HALF_FLOAT;
    if (n === Eh) return s.ALPHA;
    if (n === Th) return s.RGB;
    if (n === mn) return s.RGBA;
    if (n === Ah) return s.LUMINANCE;
    if (n === wh) return s.LUMINANCE_ALPHA;
    if (n === vr) return s.DEPTH_COMPONENT;
    if (n === yr) return s.DEPTH_STENCIL;
    if (n === Fl) return s.RED;
    if (n === Ol) return s.RED_INTEGER;
    if (n === Rh) return s.RG;
    if (n === Bl) return s.RG_INTEGER;
    if (n === kl) return s.RGBA_INTEGER;
    if (n === fa || n === pa || n === ma || n === ga)
      if (a === vt)
        if (r = e.get("WEBGL_compressed_texture_s3tc_srgb"), r !== null) {
          if (n === fa) return r.COMPRESSED_SRGB_S3TC_DXT1_EXT;
          if (n === pa) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
          if (n === ma) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
          if (n === ga) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
        } else
          return null;
      else if (r = e.get("WEBGL_compressed_texture_s3tc"), r !== null) {
        if (n === fa) return r.COMPRESSED_RGB_S3TC_DXT1_EXT;
        if (n === pa) return r.COMPRESSED_RGBA_S3TC_DXT1_EXT;
        if (n === ma) return r.COMPRESSED_RGBA_S3TC_DXT3_EXT;
        if (n === ga) return r.COMPRESSED_RGBA_S3TC_DXT5_EXT;
      } else
        return null;
    if (n === qo || n === Yo || n === jo || n === Ko)
      if (r = e.get("WEBGL_compressed_texture_pvrtc"), r !== null) {
        if (n === qo) return r.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (n === Yo) return r.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (n === jo) return r.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (n === Ko) return r.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      } else
        return null;
    if (n === Zo || n === $o || n === Jo)
      if (r = e.get("WEBGL_compressed_texture_etc"), r !== null) {
        if (n === Zo || n === $o) return a === vt ? r.COMPRESSED_SRGB8_ETC2 : r.COMPRESSED_RGB8_ETC2;
        if (n === Jo) return a === vt ? r.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : r.COMPRESSED_RGBA8_ETC2_EAC;
      } else
        return null;
    if (n === Qo || n === el || n === tl || n === nl || n === il || n === sl || n === rl || n === al || n === ol || n === ll || n === cl || n === ul || n === hl || n === dl)
      if (r = e.get("WEBGL_compressed_texture_astc"), r !== null) {
        if (n === Qo) return a === vt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : r.COMPRESSED_RGBA_ASTC_4x4_KHR;
        if (n === el) return a === vt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : r.COMPRESSED_RGBA_ASTC_5x4_KHR;
        if (n === tl) return a === vt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : r.COMPRESSED_RGBA_ASTC_5x5_KHR;
        if (n === nl) return a === vt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : r.COMPRESSED_RGBA_ASTC_6x5_KHR;
        if (n === il) return a === vt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : r.COMPRESSED_RGBA_ASTC_6x6_KHR;
        if (n === sl) return a === vt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : r.COMPRESSED_RGBA_ASTC_8x5_KHR;
        if (n === rl) return a === vt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : r.COMPRESSED_RGBA_ASTC_8x6_KHR;
        if (n === al) return a === vt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : r.COMPRESSED_RGBA_ASTC_8x8_KHR;
        if (n === ol) return a === vt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : r.COMPRESSED_RGBA_ASTC_10x5_KHR;
        if (n === ll) return a === vt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : r.COMPRESSED_RGBA_ASTC_10x6_KHR;
        if (n === cl) return a === vt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : r.COMPRESSED_RGBA_ASTC_10x8_KHR;
        if (n === ul) return a === vt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : r.COMPRESSED_RGBA_ASTC_10x10_KHR;
        if (n === hl) return a === vt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : r.COMPRESSED_RGBA_ASTC_12x10_KHR;
        if (n === dl) return a === vt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : r.COMPRESSED_RGBA_ASTC_12x12_KHR;
      } else
        return null;
    if (n === _a || n === fl || n === pl)
      if (r = e.get("EXT_texture_compression_bptc"), r !== null) {
        if (n === _a) return a === vt ? r.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : r.COMPRESSED_RGBA_BPTC_UNORM_EXT;
        if (n === fl) return r.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
        if (n === pl) return r.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
      } else
        return null;
    if (n === Ch || n === ml || n === gl || n === _l)
      if (r = e.get("EXT_texture_compression_rgtc"), r !== null) {
        if (n === _a) return r.COMPRESSED_RED_RGTC1_EXT;
        if (n === ml) return r.COMPRESSED_SIGNED_RED_RGTC1_EXT;
        if (n === gl) return r.COMPRESSED_RED_GREEN_RGTC2_EXT;
        if (n === _l) return r.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
      } else
        return null;
    return n === xr ? s.UNSIGNED_INT_24_8 : s[n] !== void 0 ? s[n] : null;
  }
  return { convert: t };
}
const Ax = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`, wx = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
class Rx {
  /**
   * Constructs a new depth sensing module.
   */
  constructor() {
    this.texture = null, this.mesh = null, this.depthNear = 0, this.depthFar = 0;
  }
  /**
   * Inits the depth sensing module
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {XRWebGLDepthInformation} depthData - The XR depth data.
   * @param {XRRenderState} renderState - The XR render state.
   */
  init(e, t, n) {
    if (this.texture === null) {
      const i = new Gt(), r = e.properties.get(i);
      r.__webglTexture = t.texture, (t.depthNear !== n.depthNear || t.depthFar !== n.depthFar) && (this.depthNear = t.depthNear, this.depthFar = t.depthFar), this.texture = i;
    }
  }
  /**
   * Returns a plane mesh that visualizes the depth texture.
   *
   * @param {ArrayCamera} cameraXR - The XR camera.
   * @return {?Mesh} The plane mesh.
   */
  getMesh(e) {
    if (this.texture !== null && this.mesh === null) {
      const t = e.cameras[0].viewport, n = new jn({
        vertexShader: Ax,
        fragmentShader: wx,
        uniforms: {
          depthColor: { value: this.texture },
          depthWidth: { value: t.z },
          depthHeight: { value: t.w }
        }
      });
      this.mesh = new xt(new Gs(20, 20), n);
    }
    return this.mesh;
  }
  /**
   * Resets the module
   */
  reset() {
    this.texture = null, this.mesh = null;
  }
  /**
   * Returns a texture representing the depth of the user's environment.
   *
   * @return {?Texture} The depth texture.
   */
  getDepthTexture() {
    return this.texture;
  }
}
class Cx extends Ui {
  /**
   * Constructs a new WebGL renderer.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGL2RenderingContext} gl - The rendering context.
   */
  constructor(e, t) {
    super();
    const n = this;
    let i = null, r = 1, a = null, o = "local-floor", l = 1, c = null, u = null, h = null, d = null, f = null, m = null;
    const _ = new Rx(), g = t.getContextAttributes();
    let p = null, M = null;
    const S = [], x = [], R = new ze();
    let w = null;
    const C = new rn();
    C.viewport = new at();
    const P = new rn();
    P.viewport = new at();
    const b = [C, P], y = new Np();
    let L = null, O = null;
    this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(V) {
      let se = S[V];
      return se === void 0 && (se = new so(), S[V] = se), se.getTargetRaySpace();
    }, this.getControllerGrip = function(V) {
      let se = S[V];
      return se === void 0 && (se = new so(), S[V] = se), se.getGripSpace();
    }, this.getHand = function(V) {
      let se = S[V];
      return se === void 0 && (se = new so(), S[V] = se), se.getHandSpace();
    };
    function U(V) {
      const se = x.indexOf(V.inputSource);
      if (se === -1)
        return;
      const re = S[se];
      re !== void 0 && (re.update(V.inputSource, V.frame, c || a), re.dispatchEvent({ type: V.type, data: V.inputSource }));
    }
    function N() {
      i.removeEventListener("select", U), i.removeEventListener("selectstart", U), i.removeEventListener("selectend", U), i.removeEventListener("squeeze", U), i.removeEventListener("squeezestart", U), i.removeEventListener("squeezeend", U), i.removeEventListener("end", N), i.removeEventListener("inputsourceschange", Y);
      for (let V = 0; V < S.length; V++) {
        const se = x[V];
        se !== null && (x[V] = null, S[V].disconnect(se));
      }
      L = null, O = null, _.reset(), e.setRenderTarget(p), f = null, d = null, h = null, i = null, M = null, ce.stop(), n.isPresenting = !1, e.setPixelRatio(w), e.setSize(R.width, R.height, !1), n.dispatchEvent({ type: "sessionend" });
    }
    this.setFramebufferScaleFactor = function(V) {
      r = V, n.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
    }, this.setReferenceSpaceType = function(V) {
      o = V, n.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
    }, this.getReferenceSpace = function() {
      return c || a;
    }, this.setReferenceSpace = function(V) {
      c = V;
    }, this.getBaseLayer = function() {
      return d !== null ? d : f;
    }, this.getBinding = function() {
      return h;
    }, this.getFrame = function() {
      return m;
    }, this.getSession = function() {
      return i;
    }, this.setSession = async function(V) {
      if (i = V, i !== null) {
        if (p = e.getRenderTarget(), i.addEventListener("select", U), i.addEventListener("selectstart", U), i.addEventListener("selectend", U), i.addEventListener("squeeze", U), i.addEventListener("squeezestart", U), i.addEventListener("squeezeend", U), i.addEventListener("end", N), i.addEventListener("inputsourceschange", Y), g.xrCompatible !== !0 && await t.makeXRCompatible(), w = e.getPixelRatio(), e.getSize(R), typeof XRWebGLBinding < "u" && "createProjectionLayer" in XRWebGLBinding.prototype) {
          let re = null, X = null, de = null;
          g.depth && (de = g.stencil ? t.DEPTH24_STENCIL8 : t.DEPTH_COMPONENT24, re = g.stencil ? yr : vr, X = g.stencil ? xr : Ii);
          const be = {
            colorFormat: t.RGBA8,
            depthFormat: de,
            scaleFactor: r
          };
          h = new XRWebGLBinding(i, t), d = h.createProjectionLayer(be), i.updateRenderState({ layers: [d] }), e.setPixelRatio(1), e.setSize(d.textureWidth, d.textureHeight, !1), M = new Di(
            d.textureWidth,
            d.textureHeight,
            {
              format: mn,
              type: _i,
              depthTexture: new Zl(d.textureWidth, d.textureHeight, X, void 0, void 0, void 0, void 0, void 0, void 0, re),
              stencilBuffer: g.stencil,
              colorSpace: e.outputColorSpace,
              samples: g.antialias ? 4 : 0,
              resolveDepthBuffer: d.ignoreDepthValues === !1,
              resolveStencilBuffer: d.ignoreDepthValues === !1
            }
          );
        } else {
          const re = {
            antialias: g.antialias,
            alpha: !0,
            depth: g.depth,
            stencil: g.stencil,
            framebufferScaleFactor: r
          };
          f = new XRWebGLLayer(i, t, re), i.updateRenderState({ baseLayer: f }), e.setPixelRatio(1), e.setSize(f.framebufferWidth, f.framebufferHeight, !1), M = new Di(
            f.framebufferWidth,
            f.framebufferHeight,
            {
              format: mn,
              type: _i,
              colorSpace: e.outputColorSpace,
              stencilBuffer: g.stencil,
              resolveDepthBuffer: f.ignoreDepthValues === !1,
              resolveStencilBuffer: f.ignoreDepthValues === !1
            }
          );
        }
        M.isXRRenderTarget = !0, this.setFoveation(l), c = null, a = await i.requestReferenceSpace(o), ce.setContext(i), ce.start(), n.isPresenting = !0, n.dispatchEvent({ type: "sessionstart" });
      }
    }, this.getEnvironmentBlendMode = function() {
      if (i !== null)
        return i.environmentBlendMode;
    }, this.getDepthTexture = function() {
      return _.getDepthTexture();
    };
    function Y(V) {
      for (let se = 0; se < V.removed.length; se++) {
        const re = V.removed[se], X = x.indexOf(re);
        X >= 0 && (x[X] = null, S[X].disconnect(re));
      }
      for (let se = 0; se < V.added.length; se++) {
        const re = V.added[se];
        let X = x.indexOf(re);
        if (X === -1) {
          for (let be = 0; be < S.length; be++)
            if (be >= x.length) {
              x.push(re), X = be;
              break;
            } else if (x[be] === null) {
              x[be] = re, X = be;
              break;
            }
          if (X === -1) break;
        }
        const de = S[X];
        de && de.connect(re);
      }
    }
    const G = new T(), ne = new T();
    function B(V, se, re) {
      G.setFromMatrixPosition(se.matrixWorld), ne.setFromMatrixPosition(re.matrixWorld);
      const X = G.distanceTo(ne), de = se.projectionMatrix.elements, be = re.projectionMatrix.elements, Le = de[14] / (de[10] - 1), Be = de[14] / (de[10] + 1), nt = (de[9] + 1) / de[5], De = (de[9] - 1) / de[5], I = (de[8] - 1) / de[0], Ue = (be[8] + 1) / be[0], Xe = Le * I, Fe = Le * Ue, Ae = X / (-I + Ue), it = Ae * -I;
      if (se.matrixWorld.decompose(V.position, V.quaternion, V.scale), V.translateX(it), V.translateZ(Ae), V.matrixWorld.compose(V.position, V.quaternion, V.scale), V.matrixWorldInverse.copy(V.matrixWorld).invert(), de[10] === -1)
        V.projectionMatrix.copy(se.projectionMatrix), V.projectionMatrixInverse.copy(se.projectionMatrixInverse);
      else {
        const Re = Le + Ae, A = Be + Ae, v = Xe - it, H = Fe + (X - it), te = nt * Be / A * Re, oe = De * Be / A * Re;
        V.projectionMatrix.makePerspective(v, H, te, oe, Re, A), V.projectionMatrixInverse.copy(V.projectionMatrix).invert();
      }
    }
    function Z(V, se) {
      se === null ? V.matrixWorld.copy(V.matrix) : V.matrixWorld.multiplyMatrices(se.matrixWorld, V.matrix), V.matrixWorldInverse.copy(V.matrixWorld).invert();
    }
    this.updateCamera = function(V) {
      if (i === null) return;
      let se = V.near, re = V.far;
      _.texture !== null && (_.depthNear > 0 && (se = _.depthNear), _.depthFar > 0 && (re = _.depthFar)), y.near = P.near = C.near = se, y.far = P.far = C.far = re, (L !== y.near || O !== y.far) && (i.updateRenderState({
        depthNear: y.near,
        depthFar: y.far
      }), L = y.near, O = y.far), C.layers.mask = V.layers.mask | 2, P.layers.mask = V.layers.mask | 4, y.layers.mask = C.layers.mask | P.layers.mask;
      const X = V.parent, de = y.cameras;
      Z(y, X);
      for (let be = 0; be < de.length; be++)
        Z(de[be], X);
      de.length === 2 ? B(y, C, P) : y.projectionMatrix.copy(C.projectionMatrix), Q(V, y, X);
    };
    function Q(V, se, re) {
      re === null ? V.matrix.copy(se.matrixWorld) : (V.matrix.copy(re.matrixWorld), V.matrix.invert(), V.matrix.multiply(se.matrixWorld)), V.matrix.decompose(V.position, V.quaternion, V.scale), V.updateMatrixWorld(!0), V.projectionMatrix.copy(se.projectionMatrix), V.projectionMatrixInverse.copy(se.projectionMatrixInverse), V.isPerspectiveCamera && (V.fov = Os * 2 * Math.atan(1 / V.projectionMatrix.elements[5]), V.zoom = 1);
    }
    this.getCamera = function() {
      return y;
    }, this.getFoveation = function() {
      if (!(d === null && f === null))
        return l;
    }, this.setFoveation = function(V) {
      l = V, d !== null && (d.fixedFoveation = V), f !== null && f.fixedFoveation !== void 0 && (f.fixedFoveation = V);
    }, this.hasDepthSensing = function() {
      return _.texture !== null;
    }, this.getDepthSensingMesh = function() {
      return _.getMesh(y);
    };
    let xe = null;
    function ye(V, se) {
      if (u = se.getViewerPose(c || a), m = se, u !== null) {
        const re = u.views;
        f !== null && (e.setRenderTargetFramebuffer(M, f.framebuffer), e.setRenderTarget(M));
        let X = !1;
        re.length !== y.cameras.length && (y.cameras.length = 0, X = !0);
        for (let Le = 0; Le < re.length; Le++) {
          const Be = re[Le];
          let nt = null;
          if (f !== null)
            nt = f.getViewport(Be);
          else {
            const I = h.getViewSubImage(d, Be);
            nt = I.viewport, Le === 0 && (e.setRenderTargetTextures(
              M,
              I.colorTexture,
              I.depthStencilTexture
            ), e.setRenderTarget(M));
          }
          let De = b[Le];
          De === void 0 && (De = new rn(), De.layers.enable(Le), De.viewport = new at(), b[Le] = De), De.matrix.fromArray(Be.transform.matrix), De.matrix.decompose(De.position, De.quaternion, De.scale), De.projectionMatrix.fromArray(Be.projectionMatrix), De.projectionMatrixInverse.copy(De.projectionMatrix).invert(), De.viewport.set(nt.x, nt.y, nt.width, nt.height), Le === 0 && (y.matrix.copy(De.matrix), y.matrix.decompose(y.position, y.quaternion, y.scale)), X === !0 && y.cameras.push(De);
        }
        const de = i.enabledFeatures;
        if (de && de.includes("depth-sensing") && i.depthUsage == "gpu-optimized" && h) {
          const Le = h.getDepthInformation(re[0]);
          Le && Le.isValid && Le.texture && _.init(e, Le, i.renderState);
        }
      }
      for (let re = 0; re < S.length; re++) {
        const X = x[re], de = S[re];
        X !== null && de !== void 0 && de.update(X, se, c || a);
      }
      xe && xe(V, se), se.detectedPlanes && n.dispatchEvent({ type: "planesdetected", data: se }), m = null;
    }
    const ce = new $h();
    ce.setAnimationLoop(ye), this.setAnimationLoop = function(V) {
      xe = V;
    }, this.dispose = function() {
    };
  }
}
const Wi = /* @__PURE__ */ new Yn(), Px = /* @__PURE__ */ new Ye();
function Lx(s, e) {
  function t(g, p) {
    g.matrixAutoUpdate === !0 && g.updateMatrix(), p.value.copy(g.matrix);
  }
  function n(g, p) {
    p.color.getRGB(g.fogColor.value, zh(s)), p.isFog ? (g.fogNear.value = p.near, g.fogFar.value = p.far) : p.isFogExp2 && (g.fogDensity.value = p.density);
  }
  function i(g, p, M, S, x) {
    p.isMeshBasicMaterial || p.isMeshLambertMaterial ? r(g, p) : p.isMeshToonMaterial ? (r(g, p), h(g, p)) : p.isMeshPhongMaterial ? (r(g, p), u(g, p)) : p.isMeshStandardMaterial ? (r(g, p), d(g, p), p.isMeshPhysicalMaterial && f(g, p, x)) : p.isMeshMatcapMaterial ? (r(g, p), m(g, p)) : p.isMeshDepthMaterial ? r(g, p) : p.isMeshDistanceMaterial ? (r(g, p), _(g, p)) : p.isMeshNormalMaterial ? r(g, p) : p.isLineBasicMaterial ? (a(g, p), p.isLineDashedMaterial && o(g, p)) : p.isPointsMaterial ? l(g, p, M, S) : p.isSpriteMaterial ? c(g, p) : p.isShadowMaterial ? (g.color.value.copy(p.color), g.opacity.value = p.opacity) : p.isShaderMaterial && (p.uniformsNeedUpdate = !1);
  }
  function r(g, p) {
    g.opacity.value = p.opacity, p.color && g.diffuse.value.copy(p.color), p.emissive && g.emissive.value.copy(p.emissive).multiplyScalar(p.emissiveIntensity), p.map && (g.map.value = p.map, t(p.map, g.mapTransform)), p.alphaMap && (g.alphaMap.value = p.alphaMap, t(p.alphaMap, g.alphaMapTransform)), p.bumpMap && (g.bumpMap.value = p.bumpMap, t(p.bumpMap, g.bumpMapTransform), g.bumpScale.value = p.bumpScale, p.side === an && (g.bumpScale.value *= -1)), p.normalMap && (g.normalMap.value = p.normalMap, t(p.normalMap, g.normalMapTransform), g.normalScale.value.copy(p.normalScale), p.side === an && g.normalScale.value.negate()), p.displacementMap && (g.displacementMap.value = p.displacementMap, t(p.displacementMap, g.displacementMapTransform), g.displacementScale.value = p.displacementScale, g.displacementBias.value = p.displacementBias), p.emissiveMap && (g.emissiveMap.value = p.emissiveMap, t(p.emissiveMap, g.emissiveMapTransform)), p.specularMap && (g.specularMap.value = p.specularMap, t(p.specularMap, g.specularMapTransform)), p.alphaTest > 0 && (g.alphaTest.value = p.alphaTest);
    const M = e.get(p), S = M.envMap, x = M.envMapRotation;
    S && (g.envMap.value = S, Wi.copy(x), Wi.x *= -1, Wi.y *= -1, Wi.z *= -1, S.isCubeTexture && S.isRenderTargetTexture === !1 && (Wi.y *= -1, Wi.z *= -1), g.envMapRotation.value.setFromMatrix4(Px.makeRotationFromEuler(Wi)), g.flipEnvMap.value = S.isCubeTexture && S.isRenderTargetTexture === !1 ? -1 : 1, g.reflectivity.value = p.reflectivity, g.ior.value = p.ior, g.refractionRatio.value = p.refractionRatio), p.lightMap && (g.lightMap.value = p.lightMap, g.lightMapIntensity.value = p.lightMapIntensity, t(p.lightMap, g.lightMapTransform)), p.aoMap && (g.aoMap.value = p.aoMap, g.aoMapIntensity.value = p.aoMapIntensity, t(p.aoMap, g.aoMapTransform));
  }
  function a(g, p) {
    g.diffuse.value.copy(p.color), g.opacity.value = p.opacity, p.map && (g.map.value = p.map, t(p.map, g.mapTransform));
  }
  function o(g, p) {
    g.dashSize.value = p.dashSize, g.totalSize.value = p.dashSize + p.gapSize, g.scale.value = p.scale;
  }
  function l(g, p, M, S) {
    g.diffuse.value.copy(p.color), g.opacity.value = p.opacity, g.size.value = p.size * M, g.scale.value = S * 0.5, p.map && (g.map.value = p.map, t(p.map, g.uvTransform)), p.alphaMap && (g.alphaMap.value = p.alphaMap, t(p.alphaMap, g.alphaMapTransform)), p.alphaTest > 0 && (g.alphaTest.value = p.alphaTest);
  }
  function c(g, p) {
    g.diffuse.value.copy(p.color), g.opacity.value = p.opacity, g.rotation.value = p.rotation, p.map && (g.map.value = p.map, t(p.map, g.mapTransform)), p.alphaMap && (g.alphaMap.value = p.alphaMap, t(p.alphaMap, g.alphaMapTransform)), p.alphaTest > 0 && (g.alphaTest.value = p.alphaTest);
  }
  function u(g, p) {
    g.specular.value.copy(p.specular), g.shininess.value = Math.max(p.shininess, 1e-4);
  }
  function h(g, p) {
    p.gradientMap && (g.gradientMap.value = p.gradientMap);
  }
  function d(g, p) {
    g.metalness.value = p.metalness, p.metalnessMap && (g.metalnessMap.value = p.metalnessMap, t(p.metalnessMap, g.metalnessMapTransform)), g.roughness.value = p.roughness, p.roughnessMap && (g.roughnessMap.value = p.roughnessMap, t(p.roughnessMap, g.roughnessMapTransform)), p.envMap && (g.envMapIntensity.value = p.envMapIntensity);
  }
  function f(g, p, M) {
    g.ior.value = p.ior, p.sheen > 0 && (g.sheenColor.value.copy(p.sheenColor).multiplyScalar(p.sheen), g.sheenRoughness.value = p.sheenRoughness, p.sheenColorMap && (g.sheenColorMap.value = p.sheenColorMap, t(p.sheenColorMap, g.sheenColorMapTransform)), p.sheenRoughnessMap && (g.sheenRoughnessMap.value = p.sheenRoughnessMap, t(p.sheenRoughnessMap, g.sheenRoughnessMapTransform))), p.clearcoat > 0 && (g.clearcoat.value = p.clearcoat, g.clearcoatRoughness.value = p.clearcoatRoughness, p.clearcoatMap && (g.clearcoatMap.value = p.clearcoatMap, t(p.clearcoatMap, g.clearcoatMapTransform)), p.clearcoatRoughnessMap && (g.clearcoatRoughnessMap.value = p.clearcoatRoughnessMap, t(p.clearcoatRoughnessMap, g.clearcoatRoughnessMapTransform)), p.clearcoatNormalMap && (g.clearcoatNormalMap.value = p.clearcoatNormalMap, t(p.clearcoatNormalMap, g.clearcoatNormalMapTransform), g.clearcoatNormalScale.value.copy(p.clearcoatNormalScale), p.side === an && g.clearcoatNormalScale.value.negate())), p.dispersion > 0 && (g.dispersion.value = p.dispersion), p.iridescence > 0 && (g.iridescence.value = p.iridescence, g.iridescenceIOR.value = p.iridescenceIOR, g.iridescenceThicknessMinimum.value = p.iridescenceThicknessRange[0], g.iridescenceThicknessMaximum.value = p.iridescenceThicknessRange[1], p.iridescenceMap && (g.iridescenceMap.value = p.iridescenceMap, t(p.iridescenceMap, g.iridescenceMapTransform)), p.iridescenceThicknessMap && (g.iridescenceThicknessMap.value = p.iridescenceThicknessMap, t(p.iridescenceThicknessMap, g.iridescenceThicknessMapTransform))), p.transmission > 0 && (g.transmission.value = p.transmission, g.transmissionSamplerMap.value = M.texture, g.transmissionSamplerSize.value.set(M.width, M.height), p.transmissionMap && (g.transmissionMap.value = p.transmissionMap, t(p.transmissionMap, g.transmissionMapTransform)), g.thickness.value = p.thickness, p.thicknessMap && (g.thicknessMap.value = p.thicknessMap, t(p.thicknessMap, g.thicknessMapTransform)), g.attenuationDistance.value = p.attenuationDistance, g.attenuationColor.value.copy(p.attenuationColor)), p.anisotropy > 0 && (g.anisotropyVector.value.set(p.anisotropy * Math.cos(p.anisotropyRotation), p.anisotropy * Math.sin(p.anisotropyRotation)), p.anisotropyMap && (g.anisotropyMap.value = p.anisotropyMap, t(p.anisotropyMap, g.anisotropyMapTransform))), g.specularIntensity.value = p.specularIntensity, g.specularColor.value.copy(p.specularColor), p.specularColorMap && (g.specularColorMap.value = p.specularColorMap, t(p.specularColorMap, g.specularColorMapTransform)), p.specularIntensityMap && (g.specularIntensityMap.value = p.specularIntensityMap, t(p.specularIntensityMap, g.specularIntensityMapTransform));
  }
  function m(g, p) {
    p.matcap && (g.matcap.value = p.matcap);
  }
  function _(g, p) {
    const M = e.get(p).light;
    g.referencePosition.value.setFromMatrixPosition(M.matrixWorld), g.nearDistance.value = M.shadow.camera.near, g.farDistance.value = M.shadow.camera.far;
  }
  return {
    refreshFogUniforms: n,
    refreshMaterialUniforms: i
  };
}
function Ix(s, e, t, n) {
  let i = {}, r = {}, a = [];
  const o = s.getParameter(s.MAX_UNIFORM_BUFFER_BINDINGS);
  function l(M, S) {
    const x = S.program;
    n.uniformBlockBinding(M, x);
  }
  function c(M, S) {
    let x = i[M.id];
    x === void 0 && (m(M), x = u(M), i[M.id] = x, M.addEventListener("dispose", g));
    const R = S.program;
    n.updateUBOMapping(M, R);
    const w = e.render.frame;
    r[M.id] !== w && (d(M), r[M.id] = w);
  }
  function u(M) {
    const S = h();
    M.__bindingPointIndex = S;
    const x = s.createBuffer(), R = M.__size, w = M.usage;
    return s.bindBuffer(s.UNIFORM_BUFFER, x), s.bufferData(s.UNIFORM_BUFFER, R, w), s.bindBuffer(s.UNIFORM_BUFFER, null), s.bindBufferBase(s.UNIFORM_BUFFER, S, x), x;
  }
  function h() {
    for (let M = 0; M < o; M++)
      if (a.indexOf(M) === -1)
        return a.push(M), M;
    return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
  }
  function d(M) {
    const S = i[M.id], x = M.uniforms, R = M.__cache;
    s.bindBuffer(s.UNIFORM_BUFFER, S);
    for (let w = 0, C = x.length; w < C; w++) {
      const P = Array.isArray(x[w]) ? x[w] : [x[w]];
      for (let b = 0, y = P.length; b < y; b++) {
        const L = P[b];
        if (f(L, w, b, R) === !0) {
          const O = L.__offset, U = Array.isArray(L.value) ? L.value : [L.value];
          let N = 0;
          for (let Y = 0; Y < U.length; Y++) {
            const G = U[Y], ne = _(G);
            typeof G == "number" || typeof G == "boolean" ? (L.__data[0] = G, s.bufferSubData(s.UNIFORM_BUFFER, O + N, L.__data)) : G.isMatrix3 ? (L.__data[0] = G.elements[0], L.__data[1] = G.elements[1], L.__data[2] = G.elements[2], L.__data[3] = 0, L.__data[4] = G.elements[3], L.__data[5] = G.elements[4], L.__data[6] = G.elements[5], L.__data[7] = 0, L.__data[8] = G.elements[6], L.__data[9] = G.elements[7], L.__data[10] = G.elements[8], L.__data[11] = 0) : (G.toArray(L.__data, N), N += ne.storage / Float32Array.BYTES_PER_ELEMENT);
          }
          s.bufferSubData(s.UNIFORM_BUFFER, O, L.__data);
        }
      }
    }
    s.bindBuffer(s.UNIFORM_BUFFER, null);
  }
  function f(M, S, x, R) {
    const w = M.value, C = S + "_" + x;
    if (R[C] === void 0)
      return typeof w == "number" || typeof w == "boolean" ? R[C] = w : R[C] = w.clone(), !0;
    {
      const P = R[C];
      if (typeof w == "number" || typeof w == "boolean") {
        if (P !== w)
          return R[C] = w, !0;
      } else if (P.equals(w) === !1)
        return P.copy(w), !0;
    }
    return !1;
  }
  function m(M) {
    const S = M.uniforms;
    let x = 0;
    const R = 16;
    for (let C = 0, P = S.length; C < P; C++) {
      const b = Array.isArray(S[C]) ? S[C] : [S[C]];
      for (let y = 0, L = b.length; y < L; y++) {
        const O = b[y], U = Array.isArray(O.value) ? O.value : [O.value];
        for (let N = 0, Y = U.length; N < Y; N++) {
          const G = U[N], ne = _(G), B = x % R, Z = B % ne.boundary, Q = B + Z;
          x += Z, Q !== 0 && R - Q < ne.storage && (x += R - Q), O.__data = new Float32Array(ne.storage / Float32Array.BYTES_PER_ELEMENT), O.__offset = x, x += ne.storage;
        }
      }
    }
    const w = x % R;
    return w > 0 && (x += R - w), M.__size = x, M.__cache = {}, this;
  }
  function _(M) {
    const S = {
      boundary: 0,
      // bytes
      storage: 0
      // bytes
    };
    return typeof M == "number" || typeof M == "boolean" ? (S.boundary = 4, S.storage = 4) : M.isVector2 ? (S.boundary = 8, S.storage = 8) : M.isVector3 || M.isColor ? (S.boundary = 16, S.storage = 12) : M.isVector4 ? (S.boundary = 16, S.storage = 16) : M.isMatrix3 ? (S.boundary = 48, S.storage = 48) : M.isMatrix4 ? (S.boundary = 64, S.storage = 64) : M.isTexture ? console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.") : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", M), S;
  }
  function g(M) {
    const S = M.target;
    S.removeEventListener("dispose", g);
    const x = a.indexOf(S.__bindingPointIndex);
    a.splice(x, 1), s.deleteBuffer(i[S.id]), delete i[S.id], delete r[S.id];
  }
  function p() {
    for (const M in i)
      s.deleteBuffer(i[M]);
    a = [], i = {}, r = {};
  }
  return {
    bind: l,
    update: c,
    dispose: p
  };
}
class Dx {
  /**
   * Constructs a new WebGL renderer.
   *
   * @param {WebGLRenderer~Options} [parameters] - The configuration parameter.
   */
  constructor(e = {}) {
    const {
      canvas: t = Tf(),
      context: n = null,
      depth: i = !0,
      stencil: r = !1,
      alpha: a = !1,
      antialias: o = !1,
      premultipliedAlpha: l = !0,
      preserveDrawingBuffer: c = !1,
      powerPreference: u = "default",
      failIfMajorPerformanceCaveat: h = !1,
      reverseDepthBuffer: d = !1
    } = e;
    this.isWebGLRenderer = !0;
    let f;
    if (n !== null) {
      if (typeof WebGLRenderingContext < "u" && n instanceof WebGLRenderingContext)
        throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
      f = n.getContextAttributes().alpha;
    } else
      f = a;
    const m = new Uint32Array(4), _ = new Int32Array(4);
    let g = null, p = null;
    const M = [], S = [];
    this.domElement = t, this.debug = {
      /**
       * Enables error checking and reporting when shader programs are being compiled.
       * @type {boolean}
       */
      checkShaderErrors: !0,
      /**
       * Callback for custom error reporting.
       * @type {?Function}
       */
      onShaderError: null
    }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.toneMapping = Li, this.toneMappingExposure = 1, this.transmissionResolutionScale = 1;
    const x = this;
    let R = !1;
    this._outputColorSpace = Dt;
    let w = 0, C = 0, P = null, b = -1, y = null;
    const L = new at(), O = new at();
    let U = null;
    const N = new He(0);
    let Y = 0, G = t.width, ne = t.height, B = 1, Z = null, Q = null;
    const xe = new at(0, 0, G, ne), ye = new at(0, 0, G, ne);
    let ce = !1;
    const V = new jl();
    let se = !1, re = !1;
    const X = new Ye(), de = new Ye(), be = new T(), Le = new at(), Be = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: !0 };
    let nt = !1;
    function De() {
      return P === null ? B : 1;
    }
    let I = n;
    function Ue(E, k) {
      return t.getContext(E, k);
    }
    try {
      const E = {
        alpha: !0,
        depth: i,
        stencil: r,
        antialias: o,
        premultipliedAlpha: l,
        preserveDrawingBuffer: c,
        powerPreference: u,
        failIfMajorPerformanceCaveat: h
      };
      if ("setAttribute" in t && t.setAttribute("data-engine", "three.js r175"), t.addEventListener("webglcontextlost", ie, !1), t.addEventListener("webglcontextrestored", Me, !1), t.addEventListener("webglcontextcreationerror", fe, !1), I === null) {
        const k = "webgl2";
        if (I = Ue(k, E), I === null)
          throw Ue(k) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
      }
    } catch (E) {
      throw console.error("THREE.WebGLRenderer: " + E.message), E;
    }
    let Xe, Fe, Ae, it, Re, A, v, H, te, oe, ee, Pe, me, _e, W, J, le, ve, Te, he, qe, Ve, lt, F;
    function ge() {
      Xe = new G_(I), Xe.init(), Ve = new Tx(I, Xe), Fe = new F_(I, Xe, e, Ve), Ae = new bx(I, Xe), Fe.reverseDepthBuffer && d && Ae.buffers.depth.setReversed(!0), it = new q_(I), Re = new ux(), A = new Ex(I, Xe, Ae, Re, Fe, Ve, it), v = new B_(x), H = new V_(x), te = new Jp(I), lt = new N_(I, te), oe = new W_(I, te, it, lt), ee = new j_(I, oe, te, it), Te = new Y_(I, Fe, A), J = new O_(Re), Pe = new cx(x, v, H, Xe, Fe, lt, J), me = new Lx(x, Re), _e = new dx(), W = new xx(Xe), ve = new D_(x, v, H, Ae, ee, f, l), le = new Sx(x, ee, Fe), F = new Ix(I, it, Fe, Ae), he = new U_(I, Xe, it), qe = new X_(I, Xe, it), it.programs = Pe.programs, x.capabilities = Fe, x.extensions = Xe, x.properties = Re, x.renderLists = _e, x.shadowMap = le, x.state = Ae, x.info = it;
    }
    ge();
    const $ = new Cx(x, I);
    this.xr = $, this.getContext = function() {
      return I;
    }, this.getContextAttributes = function() {
      return I.getContextAttributes();
    }, this.forceContextLoss = function() {
      const E = Xe.get("WEBGL_lose_context");
      E && E.loseContext();
    }, this.forceContextRestore = function() {
      const E = Xe.get("WEBGL_lose_context");
      E && E.restoreContext();
    }, this.getPixelRatio = function() {
      return B;
    }, this.setPixelRatio = function(E) {
      E !== void 0 && (B = E, this.setSize(G, ne, !1));
    }, this.getSize = function(E) {
      return E.set(G, ne);
    }, this.setSize = function(E, k, q = !0) {
      if ($.isPresenting) {
        console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
        return;
      }
      G = E, ne = k, t.width = Math.floor(E * B), t.height = Math.floor(k * B), q === !0 && (t.style.width = E + "px", t.style.height = k + "px"), this.setViewport(0, 0, E, k);
    }, this.getDrawingBufferSize = function(E) {
      return E.set(G * B, ne * B).floor();
    }, this.setDrawingBufferSize = function(E, k, q) {
      G = E, ne = k, B = q, t.width = Math.floor(E * q), t.height = Math.floor(k * q), this.setViewport(0, 0, E, k);
    }, this.getCurrentViewport = function(E) {
      return E.copy(L);
    }, this.getViewport = function(E) {
      return E.copy(xe);
    }, this.setViewport = function(E, k, q, j) {
      E.isVector4 ? xe.set(E.x, E.y, E.z, E.w) : xe.set(E, k, q, j), Ae.viewport(L.copy(xe).multiplyScalar(B).round());
    }, this.getScissor = function(E) {
      return E.copy(ye);
    }, this.setScissor = function(E, k, q, j) {
      E.isVector4 ? ye.set(E.x, E.y, E.z, E.w) : ye.set(E, k, q, j), Ae.scissor(O.copy(ye).multiplyScalar(B).round());
    }, this.getScissorTest = function() {
      return ce;
    }, this.setScissorTest = function(E) {
      Ae.setScissorTest(ce = E);
    }, this.setOpaqueSort = function(E) {
      Z = E;
    }, this.setTransparentSort = function(E) {
      Q = E;
    }, this.getClearColor = function(E) {
      return E.copy(ve.getClearColor());
    }, this.setClearColor = function() {
      ve.setClearColor(...arguments);
    }, this.getClearAlpha = function() {
      return ve.getClearAlpha();
    }, this.setClearAlpha = function() {
      ve.setClearAlpha(...arguments);
    }, this.clear = function(E = !0, k = !0, q = !0) {
      let j = 0;
      if (E) {
        let z = !1;
        if (P !== null) {
          const ue = P.texture.format;
          z = ue === kl || ue === Bl || ue === Ol;
        }
        if (z) {
          const ue = P.texture.type, Se = ue === _i || ue === Ii || ue === _r || ue === xr || ue === Nl || ue === Ul, we = ve.getClearColor(), Ce = ve.getClearAlpha(), We = we.r, ke = we.g, Ie = we.b;
          Se ? (m[0] = We, m[1] = ke, m[2] = Ie, m[3] = Ce, I.clearBufferuiv(I.COLOR, 0, m)) : (_[0] = We, _[1] = ke, _[2] = Ie, _[3] = Ce, I.clearBufferiv(I.COLOR, 0, _));
        } else
          j |= I.COLOR_BUFFER_BIT;
      }
      k && (j |= I.DEPTH_BUFFER_BIT), q && (j |= I.STENCIL_BUFFER_BIT, this.state.buffers.stencil.setMask(4294967295)), I.clear(j);
    }, this.clearColor = function() {
      this.clear(!0, !1, !1);
    }, this.clearDepth = function() {
      this.clear(!1, !0, !1);
    }, this.clearStencil = function() {
      this.clear(!1, !1, !0);
    }, this.dispose = function() {
      t.removeEventListener("webglcontextlost", ie, !1), t.removeEventListener("webglcontextrestored", Me, !1), t.removeEventListener("webglcontextcreationerror", fe, !1), ve.dispose(), _e.dispose(), W.dispose(), Re.dispose(), v.dispose(), H.dispose(), ee.dispose(), lt.dispose(), F.dispose(), Pe.dispose(), $.dispose(), $.removeEventListener("sessionstart", Ys), $.removeEventListener("sessionend", En), $n.stop();
    };
    function ie(E) {
      E.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), R = !0;
    }
    function Me() {
      console.log("THREE.WebGLRenderer: Context Restored."), R = !1;
      const E = it.autoReset, k = le.enabled, q = le.autoUpdate, j = le.needsUpdate, z = le.type;
      ge(), it.autoReset = E, le.enabled = k, le.autoUpdate = q, le.needsUpdate = j, le.type = z;
    }
    function fe(E) {
      console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", E.statusMessage);
    }
    function Ge(E) {
      const k = E.target;
      k.removeEventListener("dispose", Ge), St(k);
    }
    function St(E) {
      Qe(E), Re.remove(E);
    }
    function Qe(E) {
      const k = Re.get(E).programs;
      k !== void 0 && (k.forEach(function(q) {
        Pe.releaseProgram(q);
      }), E.isShaderMaterial && Pe.releaseShaderCache(E));
    }
    this.renderBufferDirect = function(E, k, q, j, z, ue) {
      k === null && (k = Be);
      const Se = z.isMesh && z.matrixWorld.determinant() < 0, we = Zs(E, k, q, j, z);
      Ae.setMaterial(j, Se);
      let Ce = q.index, We = 1;
      if (j.wireframe === !0) {
        if (Ce = oe.getWireframeAttribute(q), Ce === void 0) return;
        We = 2;
      }
      const ke = q.drawRange, Ie = q.attributes.position;
      let st = ke.start * We, ut = (ke.start + ke.count) * We;
      ue !== null && (st = Math.max(st, ue.start * We), ut = Math.min(ut, (ue.start + ue.count) * We)), Ce !== null ? (st = Math.max(st, 0), ut = Math.min(ut, Ce.count)) : Ie != null && (st = Math.max(st, 0), ut = Math.min(ut, Ie.count));
      const Rt = ut - st;
      if (Rt < 0 || Rt === 1 / 0) return;
      lt.setup(z, j, we, q, Ce);
      let At, Oe = he;
      if (Ce !== null && (At = te.get(Ce), Oe = qe, Oe.setIndex(At)), z.isMesh)
        j.wireframe === !0 ? (Ae.setLineWidth(j.wireframeLinewidth * De()), Oe.setMode(I.LINES)) : Oe.setMode(I.TRIANGLES);
      else if (z.isLine) {
        let Ne = j.linewidth;
        Ne === void 0 && (Ne = 1), Ae.setLineWidth(Ne * De()), z.isLineSegments ? Oe.setMode(I.LINES) : z.isLineLoop ? Oe.setMode(I.LINE_LOOP) : Oe.setMode(I.LINE_STRIP);
      } else z.isPoints ? Oe.setMode(I.POINTS) : z.isSprite && Oe.setMode(I.TRIANGLES);
      if (z.isBatchedMesh)
        if (z._multiDrawInstances !== null)
          xa("THREE.WebGLRenderer: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection."), Oe.renderMultiDrawInstances(z._multiDrawStarts, z._multiDrawCounts, z._multiDrawCount, z._multiDrawInstances);
        else if (Xe.get("WEBGL_multi_draw"))
          Oe.renderMultiDraw(z._multiDrawStarts, z._multiDrawCounts, z._multiDrawCount);
        else {
          const Ne = z._multiDrawStarts, Lt = z._multiDrawCounts, ht = z._multiDrawCount, $t = Ce ? te.get(Ce).bytesPerElement : 1, ei = Re.get(j).currentProgram.getUniforms();
          for (let Wt = 0; Wt < ht; Wt++)
            ei.setValue(I, "_gl_DrawID", Wt), Oe.render(Ne[Wt] / $t, Lt[Wt]);
        }
      else if (z.isInstancedMesh)
        Oe.renderInstances(st, Rt, z.count);
      else if (q.isInstancedBufferGeometry) {
        const Ne = q._maxInstanceCount !== void 0 ? q._maxInstanceCount : 1 / 0, Lt = Math.min(q.instanceCount, Ne);
        Oe.renderInstances(st, Rt, Lt);
      } else
        Oe.render(st, Rt);
    };
    function ct(E, k, q) {
      E.transparent === !0 && E.side === In && E.forceSinglePass === !1 ? (E.side = an, E.needsUpdate = !0, Tn(E, k, q), E.side = gi, E.needsUpdate = !0, Tn(E, k, q), E.side = In) : Tn(E, k, q);
    }
    this.compile = function(E, k, q = null) {
      q === null && (q = E), p = W.get(q), p.init(k), S.push(p), q.traverseVisible(function(z) {
        z.isLight && z.layers.test(k.layers) && (p.pushLight(z), z.castShadow && p.pushShadow(z));
      }), E !== q && E.traverseVisible(function(z) {
        z.isLight && z.layers.test(k.layers) && (p.pushLight(z), z.castShadow && p.pushShadow(z));
      }), p.setupLights();
      const j = /* @__PURE__ */ new Set();
      return E.traverse(function(z) {
        if (!(z.isMesh || z.isPoints || z.isLine || z.isSprite))
          return;
        const ue = z.material;
        if (ue)
          if (Array.isArray(ue))
            for (let Se = 0; Se < ue.length; Se++) {
              const we = ue[Se];
              ct(we, q, z), j.add(we);
            }
          else
            ct(ue, q, z), j.add(ue);
      }), p = S.pop(), j;
    }, this.compileAsync = function(E, k, q = null) {
      const j = this.compile(E, k, q);
      return new Promise((z) => {
        function ue() {
          if (j.forEach(function(Se) {
            Re.get(Se).currentProgram.isReady() && j.delete(Se);
          }), j.size === 0) {
            z(E);
            return;
          }
          setTimeout(ue, 10);
        }
        Xe.get("KHR_parallel_shader_compile") !== null ? ue() : setTimeout(ue, 10);
      });
    };
    let Pt = null;
    function It(E) {
      Pt && Pt(E);
    }
    function Ys() {
      $n.stop();
    }
    function En() {
      $n.start();
    }
    const $n = new $h();
    $n.setAnimationLoop(It), typeof self < "u" && $n.setContext(self), this.setAnimationLoop = function(E) {
      Pt = E, $.setAnimationLoop(E), E === null ? $n.stop() : $n.start();
    }, $.addEventListener("sessionstart", Ys), $.addEventListener("sessionend", En), this.render = function(E, k) {
      if (k !== void 0 && k.isCamera !== !0) {
        console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
        return;
      }
      if (R === !0) return;
      if (E.matrixWorldAutoUpdate === !0 && E.updateMatrixWorld(), k.parent === null && k.matrixWorldAutoUpdate === !0 && k.updateMatrixWorld(), $.enabled === !0 && $.isPresenting === !0 && ($.cameraAutoUpdate === !0 && $.updateCamera(k), k = $.getCamera()), E.isScene === !0 && E.onBeforeRender(x, E, k, P), p = W.get(E, S.length), p.init(k), S.push(p), de.multiplyMatrices(k.projectionMatrix, k.matrixWorldInverse), V.setFromProjectionMatrix(de), re = this.localClippingEnabled, se = J.init(this.clippingPlanes, re), g = _e.get(E, M.length), g.init(), M.push(g), $.enabled === !0 && $.isPresenting === !0) {
        const ue = x.xr.getDepthSensingMesh();
        ue !== null && $i(ue, k, -1 / 0, x.sortObjects);
      }
      $i(E, k, 0, x.sortObjects), g.finish(), x.sortObjects === !0 && g.sort(Z, Q), nt = $.enabled === !1 || $.isPresenting === !1 || $.hasDepthSensing() === !1, nt && ve.addToRenderList(g, E), this.info.render.frame++, se === !0 && J.beginShadows();
      const q = p.state.shadowsArray;
      le.render(q, E, k), se === !0 && J.endShadows(), this.info.autoReset === !0 && this.info.reset();
      const j = g.opaque, z = g.transmissive;
      if (p.setupLights(), k.isArrayCamera) {
        const ue = k.cameras;
        if (z.length > 0)
          for (let Se = 0, we = ue.length; Se < we; Se++) {
            const Ce = ue[Se];
            Ji(j, z, E, Ce);
          }
        nt && ve.render(E);
        for (let Se = 0, we = ue.length; Se < we; Se++) {
          const Ce = ue[Se];
          js(g, E, Ce, Ce.viewport);
        }
      } else
        z.length > 0 && Ji(j, z, E, k), nt && ve.render(E), js(g, E, k);
      P !== null && C === 0 && (A.updateMultisampleRenderTarget(P), A.updateRenderTargetMipmap(P)), E.isScene === !0 && E.onAfterRender(x, E, k), lt.resetDefaultState(), b = -1, y = null, S.pop(), S.length > 0 ? (p = S[S.length - 1], se === !0 && J.setGlobalState(x.clippingPlanes, p.state.camera)) : p = null, M.pop(), M.length > 0 ? g = M[M.length - 1] : g = null;
    };
    function $i(E, k, q, j) {
      if (E.visible === !1) return;
      if (E.layers.test(k.layers)) {
        if (E.isGroup)
          q = E.renderOrder;
        else if (E.isLOD)
          E.autoUpdate === !0 && E.update(k);
        else if (E.isLight)
          p.pushLight(E), E.castShadow && p.pushShadow(E);
        else if (E.isSprite) {
          if (!E.frustumCulled || V.intersectsSprite(E)) {
            j && Le.setFromMatrixPosition(E.matrixWorld).applyMatrix4(de);
            const Se = ee.update(E), we = E.material;
            we.visible && g.push(E, Se, we, q, Le.z, null);
          }
        } else if ((E.isMesh || E.isLine || E.isPoints) && (!E.frustumCulled || V.intersectsObject(E))) {
          const Se = ee.update(E), we = E.material;
          if (j && (E.boundingSphere !== void 0 ? (E.boundingSphere === null && E.computeBoundingSphere(), Le.copy(E.boundingSphere.center)) : (Se.boundingSphere === null && Se.computeBoundingSphere(), Le.copy(Se.boundingSphere.center)), Le.applyMatrix4(E.matrixWorld).applyMatrix4(de)), Array.isArray(we)) {
            const Ce = Se.groups;
            for (let We = 0, ke = Ce.length; We < ke; We++) {
              const Ie = Ce[We], st = we[Ie.materialIndex];
              st && st.visible && g.push(E, Se, st, q, Le.z, Ie);
            }
          } else we.visible && g.push(E, Se, we, q, Le.z, null);
        }
      }
      const ue = E.children;
      for (let Se = 0, we = ue.length; Se < we; Se++)
        $i(ue[Se], k, q, j);
    }
    function js(E, k, q, j) {
      const z = E.opaque, ue = E.transmissive, Se = E.transparent;
      p.setupLightsView(q), se === !0 && J.setGlobalState(x.clippingPlanes, q), j && Ae.viewport(L.copy(j)), z.length > 0 && Qi(z, k, q), ue.length > 0 && Qi(ue, k, q), Se.length > 0 && Qi(Se, k, q), Ae.buffers.depth.setTest(!0), Ae.buffers.depth.setMask(!0), Ae.buffers.color.setMask(!0), Ae.setPolygonOffset(!1);
    }
    function Ji(E, k, q, j) {
      if ((q.isScene === !0 ? q.overrideMaterial : null) !== null)
        return;
      p.state.transmissionRenderTarget[j.id] === void 0 && (p.state.transmissionRenderTarget[j.id] = new Di(1, 1, {
        generateMipmaps: !0,
        type: Xe.has("EXT_color_buffer_half_float") || Xe.has("EXT_color_buffer_float") ? Wn : _i,
        minFilter: Gn,
        samples: 4,
        stencilBuffer: r,
        resolveDepthBuffer: !1,
        resolveStencilBuffer: !1,
        colorSpace: ot.workingColorSpace
      }));
      const ue = p.state.transmissionRenderTarget[j.id], Se = j.viewport || L;
      ue.setSize(Se.z * x.transmissionResolutionScale, Se.w * x.transmissionResolutionScale);
      const we = x.getRenderTarget();
      x.setRenderTarget(ue), x.getClearColor(N), Y = x.getClearAlpha(), Y < 1 && x.setClearColor(16777215, 0.5), x.clear(), nt && ve.render(q);
      const Ce = x.toneMapping;
      x.toneMapping = Li;
      const We = j.viewport;
      if (j.viewport !== void 0 && (j.viewport = void 0), p.setupLightsView(j), se === !0 && J.setGlobalState(x.clippingPlanes, j), Qi(E, q, j), A.updateMultisampleRenderTarget(ue), A.updateRenderTargetMipmap(ue), Xe.has("WEBGL_multisampled_render_to_texture") === !1) {
        let ke = !1;
        for (let Ie = 0, st = k.length; Ie < st; Ie++) {
          const ut = k[Ie], Rt = ut.object, At = ut.geometry, Oe = ut.material, Ne = ut.group;
          if (Oe.side === In && Rt.layers.test(j.layers)) {
            const Lt = Oe.side;
            Oe.side = an, Oe.needsUpdate = !0, Ks(Rt, q, j, At, Oe, Ne), Oe.side = Lt, Oe.needsUpdate = !0, ke = !0;
          }
        }
        ke === !0 && (A.updateMultisampleRenderTarget(ue), A.updateRenderTargetMipmap(ue));
      }
      x.setRenderTarget(we), x.setClearColor(N, Y), We !== void 0 && (j.viewport = We), x.toneMapping = Ce;
    }
    function Qi(E, k, q) {
      const j = k.isScene === !0 ? k.overrideMaterial : null;
      for (let z = 0, ue = E.length; z < ue; z++) {
        const Se = E[z], we = Se.object, Ce = Se.geometry, We = Se.group;
        let ke = Se.material;
        ke.allowOverride === !0 && j !== null && (ke = j), we.layers.test(q.layers) && Ks(we, k, q, Ce, ke, We);
      }
    }
    function Ks(E, k, q, j, z, ue) {
      E.onBeforeRender(x, k, q, j, z, ue), E.modelViewMatrix.multiplyMatrices(q.matrixWorldInverse, E.matrixWorld), E.normalMatrix.getNormalMatrix(E.modelViewMatrix), z.onBeforeRender(x, k, q, j, E, ue), z.transparent === !0 && z.side === In && z.forceSinglePass === !1 ? (z.side = an, z.needsUpdate = !0, x.renderBufferDirect(q, k, j, z, E, ue), z.side = gi, z.needsUpdate = !0, x.renderBufferDirect(q, k, j, z, E, ue), z.side = In) : x.renderBufferDirect(q, k, j, z, E, ue), E.onAfterRender(x, k, q, j, z, ue);
    }
    function Tn(E, k, q) {
      k.isScene !== !0 && (k = Be);
      const j = Re.get(E), z = p.state.lights, ue = p.state.shadowsArray, Se = z.state.version, we = Pe.getParameters(E, z.state, ue, k, q), Ce = Pe.getProgramCacheKey(we);
      let We = j.programs;
      j.environment = E.isMeshStandardMaterial ? k.environment : null, j.fog = k.fog, j.envMap = (E.isMeshStandardMaterial ? H : v).get(E.envMap || j.environment), j.envMapRotation = j.environment !== null && E.envMap === null ? k.environmentRotation : E.envMapRotation, We === void 0 && (E.addEventListener("dispose", Ge), We = /* @__PURE__ */ new Map(), j.programs = We);
      let ke = We.get(Ce);
      if (ke !== void 0) {
        if (j.currentProgram === ke && j.lightsStateVersion === Se)
          return Qn(E, we), ke;
      } else
        we.uniforms = Pe.getUniforms(E), E.onBeforeCompile(we, x), ke = Pe.acquireProgram(we, Ce), We.set(Ce, ke), j.uniforms = we.uniforms;
      const Ie = j.uniforms;
      return (!E.isShaderMaterial && !E.isRawShaderMaterial || E.clipping === !0) && (Ie.clippingPlanes = J.uniform), Qn(E, we), j.needsLights = Js(E), j.lightsStateVersion = Se, j.needsLights && (Ie.ambientLightColor.value = z.state.ambient, Ie.lightProbe.value = z.state.probe, Ie.directionalLights.value = z.state.directional, Ie.directionalLightShadows.value = z.state.directionalShadow, Ie.spotLights.value = z.state.spot, Ie.spotLightShadows.value = z.state.spotShadow, Ie.rectAreaLights.value = z.state.rectArea, Ie.ltc_1.value = z.state.rectAreaLTC1, Ie.ltc_2.value = z.state.rectAreaLTC2, Ie.pointLights.value = z.state.point, Ie.pointLightShadows.value = z.state.pointShadow, Ie.hemisphereLights.value = z.state.hemi, Ie.directionalShadowMap.value = z.state.directionalShadowMap, Ie.directionalShadowMatrix.value = z.state.directionalShadowMatrix, Ie.spotShadowMap.value = z.state.spotShadowMap, Ie.spotLightMatrix.value = z.state.spotLightMatrix, Ie.spotLightMap.value = z.state.spotLightMap, Ie.pointShadowMap.value = z.state.pointShadowMap, Ie.pointShadowMatrix.value = z.state.pointShadowMatrix), j.currentProgram = ke, j.uniformsList = null, ke;
    }
    function Jn(E) {
      if (E.uniformsList === null) {
        const k = E.currentProgram.getUniforms();
        E.uniformsList = va.seqWithValue(k.seq, E.uniforms);
      }
      return E.uniformsList;
    }
    function Qn(E, k) {
      const q = Re.get(E);
      q.outputColorSpace = k.outputColorSpace, q.batching = k.batching, q.batchingColor = k.batchingColor, q.instancing = k.instancing, q.instancingColor = k.instancingColor, q.instancingMorph = k.instancingMorph, q.skinning = k.skinning, q.morphTargets = k.morphTargets, q.morphNormals = k.morphNormals, q.morphColors = k.morphColors, q.morphTargetsCount = k.morphTargetsCount, q.numClippingPlanes = k.numClippingPlanes, q.numIntersection = k.numClipIntersection, q.vertexAlphas = k.vertexAlphas, q.vertexTangents = k.vertexTangents, q.toneMapping = k.toneMapping;
    }
    function Zs(E, k, q, j, z) {
      k.isScene !== !0 && (k = Be), A.resetTextureUnits();
      const ue = k.fog, Se = j.isMeshStandardMaterial ? k.environment : null, we = P === null ? x.outputColorSpace : P.isXRRenderTarget === !0 ? P.texture.colorSpace : Zt, Ce = (j.isMeshStandardMaterial ? H : v).get(j.envMap || Se), We = j.vertexColors === !0 && !!q.attributes.color && q.attributes.color.itemSize === 4, ke = !!q.attributes.tangent && (!!j.normalMap || j.anisotropy > 0), Ie = !!q.morphAttributes.position, st = !!q.morphAttributes.normal, ut = !!q.morphAttributes.color;
      let Rt = Li;
      j.toneMapped && (P === null || P.isXRRenderTarget === !0) && (Rt = x.toneMapping);
      const At = q.morphAttributes.position || q.morphAttributes.normal || q.morphAttributes.color, Oe = At !== void 0 ? At.length : 0, Ne = Re.get(j), Lt = p.state.lights;
      if (se === !0 && (re === !0 || E !== y)) {
        const Ut = E === y && j.id === b;
        J.setState(j, E, Ut);
      }
      let ht = !1;
      j.version === Ne.__version ? (Ne.needsLights && Ne.lightsStateVersion !== Lt.state.version || Ne.outputColorSpace !== we || z.isBatchedMesh && Ne.batching === !1 || !z.isBatchedMesh && Ne.batching === !0 || z.isBatchedMesh && Ne.batchingColor === !0 && z.colorTexture === null || z.isBatchedMesh && Ne.batchingColor === !1 && z.colorTexture !== null || z.isInstancedMesh && Ne.instancing === !1 || !z.isInstancedMesh && Ne.instancing === !0 || z.isSkinnedMesh && Ne.skinning === !1 || !z.isSkinnedMesh && Ne.skinning === !0 || z.isInstancedMesh && Ne.instancingColor === !0 && z.instanceColor === null || z.isInstancedMesh && Ne.instancingColor === !1 && z.instanceColor !== null || z.isInstancedMesh && Ne.instancingMorph === !0 && z.morphTexture === null || z.isInstancedMesh && Ne.instancingMorph === !1 && z.morphTexture !== null || Ne.envMap !== Ce || j.fog === !0 && Ne.fog !== ue || Ne.numClippingPlanes !== void 0 && (Ne.numClippingPlanes !== J.numPlanes || Ne.numIntersection !== J.numIntersection) || Ne.vertexAlphas !== We || Ne.vertexTangents !== ke || Ne.morphTargets !== Ie || Ne.morphNormals !== st || Ne.morphColors !== ut || Ne.toneMapping !== Rt || Ne.morphTargetsCount !== Oe) && (ht = !0) : (ht = !0, Ne.__version = j.version);
      let $t = Ne.currentProgram;
      ht === !0 && ($t = Tn(j, k, z));
      let ei = !1, Wt = !1, Bi = !1;
      const Et = $t.getUniforms(), on = Ne.uniforms;
      if (Ae.useProgram($t.program) && (ei = !0, Wt = !0, Bi = !0), j.id !== b && (b = j.id, Wt = !0), ei || y !== E) {
        Ae.buffers.depth.getReversed() ? (X.copy(E.projectionMatrix), wf(X), Rf(X), Et.setValue(I, "projectionMatrix", X)) : Et.setValue(I, "projectionMatrix", E.projectionMatrix), Et.setValue(I, "viewMatrix", E.matrixWorldInverse);
        const Xt = Et.map.cameraPosition;
        Xt !== void 0 && Xt.setValue(I, be.setFromMatrixPosition(E.matrixWorld)), Fe.logarithmicDepthBuffer && Et.setValue(
          I,
          "logDepthBufFC",
          2 / (Math.log(E.far + 1) / Math.LN2)
        ), (j.isMeshPhongMaterial || j.isMeshToonMaterial || j.isMeshLambertMaterial || j.isMeshBasicMaterial || j.isMeshStandardMaterial || j.isShaderMaterial) && Et.setValue(I, "isOrthographic", E.isOrthographicCamera === !0), y !== E && (y = E, Wt = !0, Bi = !0);
      }
      if (z.isSkinnedMesh) {
        Et.setOptional(I, z, "bindMatrix"), Et.setOptional(I, z, "bindMatrixInverse");
        const Ut = z.skeleton;
        Ut && (Ut.boneTexture === null && Ut.computeBoneTexture(), Et.setValue(I, "boneTexture", Ut.boneTexture, A));
      }
      z.isBatchedMesh && (Et.setOptional(I, z, "batchingTexture"), Et.setValue(I, "batchingTexture", z._matricesTexture, A), Et.setOptional(I, z, "batchingIdTexture"), Et.setValue(I, "batchingIdTexture", z._indirectTexture, A), Et.setOptional(I, z, "batchingColorTexture"), z._colorsTexture !== null && Et.setValue(I, "batchingColorTexture", z._colorsTexture, A));
      const tn = q.morphAttributes;
      if ((tn.position !== void 0 || tn.normal !== void 0 || tn.color !== void 0) && Te.update(z, q, $t), (Wt || Ne.receiveShadow !== z.receiveShadow) && (Ne.receiveShadow = z.receiveShadow, Et.setValue(I, "receiveShadow", z.receiveShadow)), j.isMeshGouraudMaterial && j.envMap !== null && (on.envMap.value = Ce, on.flipEnvMap.value = Ce.isCubeTexture && Ce.isRenderTargetTexture === !1 ? -1 : 1), j.isMeshStandardMaterial && j.envMap === null && k.environment !== null && (on.envMapIntensity.value = k.environmentIntensity), Wt && (Et.setValue(I, "toneMappingExposure", x.toneMappingExposure), Ne.needsLights && $s(on, Bi), ue && j.fog === !0 && me.refreshFogUniforms(on, ue), me.refreshMaterialUniforms(on, j, B, ne, p.state.transmissionRenderTarget[E.id]), va.upload(I, Jn(Ne), on, A)), j.isShaderMaterial && j.uniformsNeedUpdate === !0 && (va.upload(I, Jn(Ne), on, A), j.uniformsNeedUpdate = !1), j.isSpriteMaterial && Et.setValue(I, "center", z.center), Et.setValue(I, "modelViewMatrix", z.modelViewMatrix), Et.setValue(I, "normalMatrix", z.normalMatrix), Et.setValue(I, "modelMatrix", z.matrixWorld), j.isShaderMaterial || j.isRawShaderMaterial) {
        const Ut = j.uniformsGroups;
        for (let Xt = 0, es = Ut.length; Xt < es; Xt++) {
          const On = Ut[Xt];
          F.update(On, $t), F.bind(On, $t);
        }
      }
      return $t;
    }
    function $s(E, k) {
      E.ambientLightColor.needsUpdate = k, E.lightProbe.needsUpdate = k, E.directionalLights.needsUpdate = k, E.directionalLightShadows.needsUpdate = k, E.pointLights.needsUpdate = k, E.pointLightShadows.needsUpdate = k, E.spotLights.needsUpdate = k, E.spotLightShadows.needsUpdate = k, E.rectAreaLights.needsUpdate = k, E.hemisphereLights.needsUpdate = k;
    }
    function Js(E) {
      return E.isMeshLambertMaterial || E.isMeshToonMaterial || E.isMeshPhongMaterial || E.isMeshStandardMaterial || E.isShadowMaterial || E.isShaderMaterial && E.lights === !0;
    }
    this.getActiveCubeFace = function() {
      return w;
    }, this.getActiveMipmapLevel = function() {
      return C;
    }, this.getRenderTarget = function() {
      return P;
    }, this.setRenderTargetTextures = function(E, k, q) {
      const j = Re.get(E);
      j.__autoAllocateDepthBuffer = E.resolveDepthBuffer === !1, j.__autoAllocateDepthBuffer === !1 && (j.__useRenderToTexture = !1), Re.get(E.texture).__webglTexture = k, Re.get(E.depthTexture).__webglTexture = j.__autoAllocateDepthBuffer ? void 0 : q, j.__hasExternalTextures = !0;
    }, this.setRenderTargetFramebuffer = function(E, k) {
      const q = Re.get(E);
      q.__webglFramebuffer = k, q.__useDefaultFramebuffer = k === void 0;
    };
    const Ua = I.createFramebuffer();
    this.setRenderTarget = function(E, k = 0, q = 0) {
      P = E, w = k, C = q;
      let j = !0, z = null, ue = !1, Se = !1;
      if (E) {
        const Ce = Re.get(E);
        if (Ce.__useDefaultFramebuffer !== void 0)
          Ae.bindFramebuffer(I.FRAMEBUFFER, null), j = !1;
        else if (Ce.__webglFramebuffer === void 0)
          A.setupRenderTarget(E);
        else if (Ce.__hasExternalTextures)
          A.rebindTextures(E, Re.get(E.texture).__webglTexture, Re.get(E.depthTexture).__webglTexture);
        else if (E.depthBuffer) {
          const Ie = E.depthTexture;
          if (Ce.__boundDepthTexture !== Ie) {
            if (Ie !== null && Re.has(Ie) && (E.width !== Ie.image.width || E.height !== Ie.image.height))
              throw new Error("WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.");
            A.setupDepthRenderbuffer(E);
          }
        }
        const We = E.texture;
        (We.isData3DTexture || We.isDataArrayTexture || We.isCompressedArrayTexture) && (Se = !0);
        const ke = Re.get(E).__webglFramebuffer;
        E.isWebGLCubeRenderTarget ? (Array.isArray(ke[k]) ? z = ke[k][q] : z = ke[k], ue = !0) : E.samples > 0 && A.useMultisampledRTT(E) === !1 ? z = Re.get(E).__webglMultisampledFramebuffer : Array.isArray(ke) ? z = ke[q] : z = ke, L.copy(E.viewport), O.copy(E.scissor), U = E.scissorTest;
      } else
        L.copy(xe).multiplyScalar(B).floor(), O.copy(ye).multiplyScalar(B).floor(), U = ce;
      if (q !== 0 && (z = Ua), Ae.bindFramebuffer(I.FRAMEBUFFER, z) && j && Ae.drawBuffers(E, z), Ae.viewport(L), Ae.scissor(O), Ae.setScissorTest(U), ue) {
        const Ce = Re.get(E.texture);
        I.framebufferTexture2D(I.FRAMEBUFFER, I.COLOR_ATTACHMENT0, I.TEXTURE_CUBE_MAP_POSITIVE_X + k, Ce.__webglTexture, q);
      } else if (Se) {
        const Ce = Re.get(E.texture), We = k;
        I.framebufferTextureLayer(I.FRAMEBUFFER, I.COLOR_ATTACHMENT0, Ce.__webglTexture, q, We);
      } else if (E !== null && q !== 0) {
        const Ce = Re.get(E.texture);
        I.framebufferTexture2D(I.FRAMEBUFFER, I.COLOR_ATTACHMENT0, I.TEXTURE_2D, Ce.__webglTexture, q);
      }
      b = -1;
    }, this.readRenderTargetPixels = function(E, k, q, j, z, ue, Se) {
      if (!(E && E.isWebGLRenderTarget)) {
        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
        return;
      }
      let we = Re.get(E).__webglFramebuffer;
      if (E.isWebGLCubeRenderTarget && Se !== void 0 && (we = we[Se]), we) {
        Ae.bindFramebuffer(I.FRAMEBUFFER, we);
        try {
          const Ce = E.texture, We = Ce.format, ke = Ce.type;
          if (!Fe.textureFormatReadable(We)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
            return;
          }
          if (!Fe.textureTypeReadable(ke)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
            return;
          }
          k >= 0 && k <= E.width - j && q >= 0 && q <= E.height - z && I.readPixels(k, q, j, z, Ve.convert(We), Ve.convert(ke), ue);
        } finally {
          const Ce = P !== null ? Re.get(P).__webglFramebuffer : null;
          Ae.bindFramebuffer(I.FRAMEBUFFER, Ce);
        }
      }
    }, this.readRenderTargetPixelsAsync = async function(E, k, q, j, z, ue, Se) {
      if (!(E && E.isWebGLRenderTarget))
        throw new Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
      let we = Re.get(E).__webglFramebuffer;
      if (E.isWebGLCubeRenderTarget && Se !== void 0 && (we = we[Se]), we)
        if (k >= 0 && k <= E.width - j && q >= 0 && q <= E.height - z) {
          Ae.bindFramebuffer(I.FRAMEBUFFER, we);
          const Ce = E.texture, We = Ce.format, ke = Ce.type;
          if (!Fe.textureFormatReadable(We))
            throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.");
          if (!Fe.textureTypeReadable(ke))
            throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.");
          const Ie = I.createBuffer();
          I.bindBuffer(I.PIXEL_PACK_BUFFER, Ie), I.bufferData(I.PIXEL_PACK_BUFFER, ue.byteLength, I.STREAM_READ), I.readPixels(k, q, j, z, Ve.convert(We), Ve.convert(ke), 0);
          const st = P !== null ? Re.get(P).__webglFramebuffer : null;
          Ae.bindFramebuffer(I.FRAMEBUFFER, st);
          const ut = I.fenceSync(I.SYNC_GPU_COMMANDS_COMPLETE, 0);
          return I.flush(), await Af(I, ut, 4), I.bindBuffer(I.PIXEL_PACK_BUFFER, Ie), I.getBufferSubData(I.PIXEL_PACK_BUFFER, 0, ue), I.deleteBuffer(Ie), I.deleteSync(ut), ue;
        } else
          throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.");
    }, this.copyFramebufferToTexture = function(E, k = null, q = 0) {
      const j = Math.pow(2, -q), z = Math.floor(E.image.width * j), ue = Math.floor(E.image.height * j), Se = k !== null ? k.x : 0, we = k !== null ? k.y : 0;
      A.setTexture2D(E, 0), I.copyTexSubImage2D(I.TEXTURE_2D, q, 0, 0, Se, we, z, ue), Ae.unbindTexture();
    };
    const Oi = I.createFramebuffer(), Fa = I.createFramebuffer();
    this.copyTextureToTexture = function(E, k, q = null, j = null, z = 0, ue = null) {
      ue === null && (z !== 0 ? (xa("WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels."), ue = z, z = 0) : ue = 0);
      let Se, we, Ce, We, ke, Ie, st, ut, Rt;
      const At = E.isCompressedTexture ? E.mipmaps[ue] : E.image;
      if (q !== null)
        Se = q.max.x - q.min.x, we = q.max.y - q.min.y, Ce = q.isBox3 ? q.max.z - q.min.z : 1, We = q.min.x, ke = q.min.y, Ie = q.isBox3 ? q.min.z : 0;
      else {
        const tn = Math.pow(2, -z);
        Se = Math.floor(At.width * tn), we = Math.floor(At.height * tn), E.isDataArrayTexture ? Ce = At.depth : E.isData3DTexture ? Ce = Math.floor(At.depth * tn) : Ce = 1, We = 0, ke = 0, Ie = 0;
      }
      j !== null ? (st = j.x, ut = j.y, Rt = j.z) : (st = 0, ut = 0, Rt = 0);
      const Oe = Ve.convert(k.format), Ne = Ve.convert(k.type);
      let Lt;
      k.isData3DTexture ? (A.setTexture3D(k, 0), Lt = I.TEXTURE_3D) : k.isDataArrayTexture || k.isCompressedArrayTexture ? (A.setTexture2DArray(k, 0), Lt = I.TEXTURE_2D_ARRAY) : (A.setTexture2D(k, 0), Lt = I.TEXTURE_2D), I.pixelStorei(I.UNPACK_FLIP_Y_WEBGL, k.flipY), I.pixelStorei(I.UNPACK_PREMULTIPLY_ALPHA_WEBGL, k.premultiplyAlpha), I.pixelStorei(I.UNPACK_ALIGNMENT, k.unpackAlignment);
      const ht = I.getParameter(I.UNPACK_ROW_LENGTH), $t = I.getParameter(I.UNPACK_IMAGE_HEIGHT), ei = I.getParameter(I.UNPACK_SKIP_PIXELS), Wt = I.getParameter(I.UNPACK_SKIP_ROWS), Bi = I.getParameter(I.UNPACK_SKIP_IMAGES);
      I.pixelStorei(I.UNPACK_ROW_LENGTH, At.width), I.pixelStorei(I.UNPACK_IMAGE_HEIGHT, At.height), I.pixelStorei(I.UNPACK_SKIP_PIXELS, We), I.pixelStorei(I.UNPACK_SKIP_ROWS, ke), I.pixelStorei(I.UNPACK_SKIP_IMAGES, Ie);
      const Et = E.isDataArrayTexture || E.isData3DTexture, on = k.isDataArrayTexture || k.isData3DTexture;
      if (E.isDepthTexture) {
        const tn = Re.get(E), Ut = Re.get(k), Xt = Re.get(tn.__renderTarget), es = Re.get(Ut.__renderTarget);
        Ae.bindFramebuffer(I.READ_FRAMEBUFFER, Xt.__webglFramebuffer), Ae.bindFramebuffer(I.DRAW_FRAMEBUFFER, es.__webglFramebuffer);
        for (let On = 0; On < Ce; On++)
          Et && (I.framebufferTextureLayer(I.READ_FRAMEBUFFER, I.COLOR_ATTACHMENT0, Re.get(E).__webglTexture, z, Ie + On), I.framebufferTextureLayer(I.DRAW_FRAMEBUFFER, I.COLOR_ATTACHMENT0, Re.get(k).__webglTexture, ue, Rt + On)), I.blitFramebuffer(We, ke, Se, we, st, ut, Se, we, I.DEPTH_BUFFER_BIT, I.NEAREST);
        Ae.bindFramebuffer(I.READ_FRAMEBUFFER, null), Ae.bindFramebuffer(I.DRAW_FRAMEBUFFER, null);
      } else if (z !== 0 || E.isRenderTargetTexture || Re.has(E)) {
        const tn = Re.get(E), Ut = Re.get(k);
        Ae.bindFramebuffer(I.READ_FRAMEBUFFER, Oi), Ae.bindFramebuffer(I.DRAW_FRAMEBUFFER, Fa);
        for (let Xt = 0; Xt < Ce; Xt++)
          Et ? I.framebufferTextureLayer(I.READ_FRAMEBUFFER, I.COLOR_ATTACHMENT0, tn.__webglTexture, z, Ie + Xt) : I.framebufferTexture2D(I.READ_FRAMEBUFFER, I.COLOR_ATTACHMENT0, I.TEXTURE_2D, tn.__webglTexture, z), on ? I.framebufferTextureLayer(I.DRAW_FRAMEBUFFER, I.COLOR_ATTACHMENT0, Ut.__webglTexture, ue, Rt + Xt) : I.framebufferTexture2D(I.DRAW_FRAMEBUFFER, I.COLOR_ATTACHMENT0, I.TEXTURE_2D, Ut.__webglTexture, ue), z !== 0 ? I.blitFramebuffer(We, ke, Se, we, st, ut, Se, we, I.COLOR_BUFFER_BIT, I.NEAREST) : on ? I.copyTexSubImage3D(Lt, ue, st, ut, Rt + Xt, We, ke, Se, we) : I.copyTexSubImage2D(Lt, ue, st, ut, We, ke, Se, we);
        Ae.bindFramebuffer(I.READ_FRAMEBUFFER, null), Ae.bindFramebuffer(I.DRAW_FRAMEBUFFER, null);
      } else
        on ? E.isDataTexture || E.isData3DTexture ? I.texSubImage3D(Lt, ue, st, ut, Rt, Se, we, Ce, Oe, Ne, At.data) : k.isCompressedArrayTexture ? I.compressedTexSubImage3D(Lt, ue, st, ut, Rt, Se, we, Ce, Oe, At.data) : I.texSubImage3D(Lt, ue, st, ut, Rt, Se, we, Ce, Oe, Ne, At) : E.isDataTexture ? I.texSubImage2D(I.TEXTURE_2D, ue, st, ut, Se, we, Oe, Ne, At.data) : E.isCompressedTexture ? I.compressedTexSubImage2D(I.TEXTURE_2D, ue, st, ut, At.width, At.height, Oe, At.data) : I.texSubImage2D(I.TEXTURE_2D, ue, st, ut, Se, we, Oe, Ne, At);
      I.pixelStorei(I.UNPACK_ROW_LENGTH, ht), I.pixelStorei(I.UNPACK_IMAGE_HEIGHT, $t), I.pixelStorei(I.UNPACK_SKIP_PIXELS, ei), I.pixelStorei(I.UNPACK_SKIP_ROWS, Wt), I.pixelStorei(I.UNPACK_SKIP_IMAGES, Bi), ue === 0 && k.generateMipmaps && I.generateMipmap(Lt), Ae.unbindTexture();
    }, this.copyTextureToTexture3D = function(E, k, q = null, j = null, z = 0) {
      return xa('WebGLRenderer: copyTextureToTexture3D function has been deprecated. Use "copyTextureToTexture" instead.'), this.copyTextureToTexture(E, k, q, j, z);
    }, this.initRenderTarget = function(E) {
      Re.get(E).__webglFramebuffer === void 0 && A.setupRenderTarget(E);
    }, this.initTexture = function(E) {
      E.isCubeTexture ? A.setTextureCube(E, 0) : E.isData3DTexture ? A.setTexture3D(E, 0) : E.isDataArrayTexture || E.isCompressedArrayTexture ? A.setTexture2DArray(E, 0) : A.setTexture2D(E, 0), Ae.unbindTexture();
    }, this.resetState = function() {
      w = 0, C = 0, P = null, Ae.reset(), lt.reset();
    }, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
  }
  /**
   * Defines the coordinate system of the renderer.
   *
   * In `WebGLRenderer`, the value is always `WebGLCoordinateSystem`.
   *
   * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
   * @default WebGLCoordinateSystem
   * @readonly
   */
  get coordinateSystem() {
    return ui;
  }
  /**
   * Defines the output color space of the renderer.
   *
   * @type {SRGBColorSpace|LinearSRGBColorSpace}
   * @default SRGBColorSpace
   */
  get outputColorSpace() {
    return this._outputColorSpace;
  }
  set outputColorSpace(e) {
    this._outputColorSpace = e;
    const t = this.getContext();
    t.drawingBufferColorSpace = ot._getDrawingBufferColorSpace(e), t.unpackColorSpace = ot._getUnpackColorSpace();
  }
}
const Ou = { type: "change" }, tc = { type: "start" }, nd = { type: "end" }, aa = new Ar(), Bu = new wi(), Nx = Math.cos(70 * Vl.DEG2RAD), Bt = new T(), ln = 2 * Math.PI, yt = {
  NONE: -1,
  ROTATE: 0,
  DOLLY: 1,
  PAN: 2,
  TOUCH_ROTATE: 3,
  TOUCH_PAN: 4,
  TOUCH_DOLLY_PAN: 5,
  TOUCH_DOLLY_ROTATE: 6
}, xo = 1e-6;
class Ux extends Zp {
  /**
   * Constructs a new controls instance.
   *
   * @param {Object3D} object - The object that is managed by the controls.
   * @param {?HTMLDOMElement} domElement - The HTML element used for event listeners.
   */
  constructor(e, t = null) {
    super(e, t), this.state = yt.NONE, this.target = new T(), this.cursor = new T(), this.minDistance = 0, this.maxDistance = 1 / 0, this.minZoom = 0, this.maxZoom = 1 / 0, this.minTargetRadius = 0, this.maxTargetRadius = 1 / 0, this.minPolarAngle = 0, this.maxPolarAngle = Math.PI, this.minAzimuthAngle = -1 / 0, this.maxAzimuthAngle = 1 / 0, this.enableDamping = !1, this.dampingFactor = 0.05, this.enableZoom = !0, this.zoomSpeed = 1, this.enableRotate = !0, this.rotateSpeed = 1, this.keyRotateSpeed = 1, this.enablePan = !0, this.panSpeed = 1, this.screenSpacePanning = !0, this.keyPanSpeed = 7, this.zoomToCursor = !1, this.autoRotate = !1, this.autoRotateSpeed = 2, this.keys = { LEFT: "ArrowLeft", UP: "ArrowUp", RIGHT: "ArrowRight", BOTTOM: "ArrowDown" }, this.mouseButtons = { LEFT: Cs.ROTATE, MIDDLE: Cs.DOLLY, RIGHT: Cs.PAN }, this.touches = { ONE: bs.ROTATE, TWO: bs.DOLLY_PAN }, this.target0 = this.target.clone(), this.position0 = this.object.position.clone(), this.zoom0 = this.object.zoom, this._domElementKeyEvents = null, this._lastPosition = new T(), this._lastQuaternion = new gn(), this._lastTargetPosition = new T(), this._quat = new gn().setFromUnitVectors(e.up, new T(0, 1, 0)), this._quatInverse = this._quat.clone().invert(), this._spherical = new Tr(), this._sphericalDelta = new Tr(), this._scale = 1, this._panOffset = new T(), this._rotateStart = new ze(), this._rotateEnd = new ze(), this._rotateDelta = new ze(), this._panStart = new ze(), this._panEnd = new ze(), this._panDelta = new ze(), this._dollyStart = new ze(), this._dollyEnd = new ze(), this._dollyDelta = new ze(), this._dollyDirection = new T(), this._mouse = new ze(), this._performCursorZoom = !1, this._pointers = [], this._pointerPositions = {}, this._controlActive = !1, this._onPointerMove = Ox.bind(this), this._onPointerDown = Fx.bind(this), this._onPointerUp = Bx.bind(this), this._onContextMenu = Xx.bind(this), this._onMouseWheel = Hx.bind(this), this._onKeyDown = Vx.bind(this), this._onTouchStart = Gx.bind(this), this._onTouchMove = Wx.bind(this), this._onMouseDown = kx.bind(this), this._onMouseMove = zx.bind(this), this._interceptControlDown = qx.bind(this), this._interceptControlUp = Yx.bind(this), this.domElement !== null && this.connect(this.domElement), this.update();
  }
  connect(e) {
    super.connect(e), this.domElement.addEventListener("pointerdown", this._onPointerDown), this.domElement.addEventListener("pointercancel", this._onPointerUp), this.domElement.addEventListener("contextmenu", this._onContextMenu), this.domElement.addEventListener("wheel", this._onMouseWheel, { passive: !1 }), this.domElement.getRootNode().addEventListener("keydown", this._interceptControlDown, { passive: !0, capture: !0 }), this.domElement.style.touchAction = "none";
  }
  disconnect() {
    this.domElement.removeEventListener("pointerdown", this._onPointerDown), this.domElement.removeEventListener("pointermove", this._onPointerMove), this.domElement.removeEventListener("pointerup", this._onPointerUp), this.domElement.removeEventListener("pointercancel", this._onPointerUp), this.domElement.removeEventListener("wheel", this._onMouseWheel), this.domElement.removeEventListener("contextmenu", this._onContextMenu), this.stopListenToKeyEvents(), this.domElement.getRootNode().removeEventListener("keydown", this._interceptControlDown, { capture: !0 }), this.domElement.style.touchAction = "auto";
  }
  dispose() {
    this.disconnect();
  }
  /**
   * Get the current vertical rotation, in radians.
   *
   * @return {number} The current vertical rotation, in radians.
   */
  getPolarAngle() {
    return this._spherical.phi;
  }
  /**
   * Get the current horizontal rotation, in radians.
   *
   * @return {number} The current horizontal rotation, in radians.
   */
  getAzimuthalAngle() {
    return this._spherical.theta;
  }
  /**
   * Returns the distance from the camera to the target.
   *
   * @return {number} The distance from the camera to the target.
   */
  getDistance() {
    return this.object.position.distanceTo(this.target);
  }
  /**
   * Adds key event listeners to the given DOM element.
   * `window` is a recommended argument for using this method.
   *
   * @param {HTMLDOMElement} domElement - The DOM element
   */
  listenToKeyEvents(e) {
    e.addEventListener("keydown", this._onKeyDown), this._domElementKeyEvents = e;
  }
  /**
   * Removes the key event listener previously defined with `listenToKeyEvents()`.
   */
  stopListenToKeyEvents() {
    this._domElementKeyEvents !== null && (this._domElementKeyEvents.removeEventListener("keydown", this._onKeyDown), this._domElementKeyEvents = null);
  }
  /**
   * Save the current state of the controls. This can later be recovered with `reset()`.
   */
  saveState() {
    this.target0.copy(this.target), this.position0.copy(this.object.position), this.zoom0 = this.object.zoom;
  }
  /**
   * Reset the controls to their state from either the last time the `saveState()`
   * was called, or the initial state.
   */
  reset() {
    this.target.copy(this.target0), this.object.position.copy(this.position0), this.object.zoom = this.zoom0, this.object.updateProjectionMatrix(), this.dispatchEvent(Ou), this.update(), this.state = yt.NONE;
  }
  update(e = null) {
    const t = this.object.position;
    Bt.copy(t).sub(this.target), Bt.applyQuaternion(this._quat), this._spherical.setFromVector3(Bt), this.autoRotate && this.state === yt.NONE && this._rotateLeft(this._getAutoRotationAngle(e)), this.enableDamping ? (this._spherical.theta += this._sphericalDelta.theta * this.dampingFactor, this._spherical.phi += this._sphericalDelta.phi * this.dampingFactor) : (this._spherical.theta += this._sphericalDelta.theta, this._spherical.phi += this._sphericalDelta.phi);
    let n = this.minAzimuthAngle, i = this.maxAzimuthAngle;
    isFinite(n) && isFinite(i) && (n < -Math.PI ? n += ln : n > Math.PI && (n -= ln), i < -Math.PI ? i += ln : i > Math.PI && (i -= ln), n <= i ? this._spherical.theta = Math.max(n, Math.min(i, this._spherical.theta)) : this._spherical.theta = this._spherical.theta > (n + i) / 2 ? Math.max(n, this._spherical.theta) : Math.min(i, this._spherical.theta)), this._spherical.phi = Math.max(this.minPolarAngle, Math.min(this.maxPolarAngle, this._spherical.phi)), this._spherical.makeSafe(), this.enableDamping === !0 ? this.target.addScaledVector(this._panOffset, this.dampingFactor) : this.target.add(this._panOffset), this.target.sub(this.cursor), this.target.clampLength(this.minTargetRadius, this.maxTargetRadius), this.target.add(this.cursor);
    let r = !1;
    if (this.zoomToCursor && this._performCursorZoom || this.object.isOrthographicCamera)
      this._spherical.radius = this._clampDistance(this._spherical.radius);
    else {
      const a = this._spherical.radius;
      this._spherical.radius = this._clampDistance(this._spherical.radius * this._scale), r = a != this._spherical.radius;
    }
    if (Bt.setFromSpherical(this._spherical), Bt.applyQuaternion(this._quatInverse), t.copy(this.target).add(Bt), this.object.lookAt(this.target), this.enableDamping === !0 ? (this._sphericalDelta.theta *= 1 - this.dampingFactor, this._sphericalDelta.phi *= 1 - this.dampingFactor, this._panOffset.multiplyScalar(1 - this.dampingFactor)) : (this._sphericalDelta.set(0, 0, 0), this._panOffset.set(0, 0, 0)), this.zoomToCursor && this._performCursorZoom) {
      let a = null;
      if (this.object.isPerspectiveCamera) {
        const o = Bt.length();
        a = this._clampDistance(o * this._scale);
        const l = o - a;
        this.object.position.addScaledVector(this._dollyDirection, l), this.object.updateMatrixWorld(), r = !!l;
      } else if (this.object.isOrthographicCamera) {
        const o = new T(this._mouse.x, this._mouse.y, 0);
        o.unproject(this.object);
        const l = this.object.zoom;
        this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale)), this.object.updateProjectionMatrix(), r = l !== this.object.zoom;
        const c = new T(this._mouse.x, this._mouse.y, 0);
        c.unproject(this.object), this.object.position.sub(c).add(o), this.object.updateMatrixWorld(), a = Bt.length();
      } else
        console.warn("WARNING: OrbitControls.js encountered an unknown camera type - zoom to cursor disabled."), this.zoomToCursor = !1;
      a !== null && (this.screenSpacePanning ? this.target.set(0, 0, -1).transformDirection(this.object.matrix).multiplyScalar(a).add(this.object.position) : (aa.origin.copy(this.object.position), aa.direction.set(0, 0, -1).transformDirection(this.object.matrix), Math.abs(this.object.up.dot(aa.direction)) < Nx ? this.object.lookAt(this.target) : (Bu.setFromNormalAndCoplanarPoint(this.object.up, this.target), aa.intersectPlane(Bu, this.target))));
    } else if (this.object.isOrthographicCamera) {
      const a = this.object.zoom;
      this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale)), a !== this.object.zoom && (this.object.updateProjectionMatrix(), r = !0);
    }
    return this._scale = 1, this._performCursorZoom = !1, r || this._lastPosition.distanceToSquared(this.object.position) > xo || 8 * (1 - this._lastQuaternion.dot(this.object.quaternion)) > xo || this._lastTargetPosition.distanceToSquared(this.target) > xo ? (this.dispatchEvent(Ou), this._lastPosition.copy(this.object.position), this._lastQuaternion.copy(this.object.quaternion), this._lastTargetPosition.copy(this.target), !0) : !1;
  }
  _getAutoRotationAngle(e) {
    return e !== null ? ln / 60 * this.autoRotateSpeed * e : ln / 60 / 60 * this.autoRotateSpeed;
  }
  _getZoomScale(e) {
    const t = Math.abs(e * 0.01);
    return Math.pow(0.95, this.zoomSpeed * t);
  }
  _rotateLeft(e) {
    this._sphericalDelta.theta -= e;
  }
  _rotateUp(e) {
    this._sphericalDelta.phi -= e;
  }
  _panLeft(e, t) {
    Bt.setFromMatrixColumn(t, 0), Bt.multiplyScalar(-e), this._panOffset.add(Bt);
  }
  _panUp(e, t) {
    this.screenSpacePanning === !0 ? Bt.setFromMatrixColumn(t, 1) : (Bt.setFromMatrixColumn(t, 0), Bt.crossVectors(this.object.up, Bt)), Bt.multiplyScalar(e), this._panOffset.add(Bt);
  }
  // deltaX and deltaY are in pixels; right and down are positive
  _pan(e, t) {
    const n = this.domElement;
    if (this.object.isPerspectiveCamera) {
      const i = this.object.position;
      Bt.copy(i).sub(this.target);
      let r = Bt.length();
      r *= Math.tan(this.object.fov / 2 * Math.PI / 180), this._panLeft(2 * e * r / n.clientHeight, this.object.matrix), this._panUp(2 * t * r / n.clientHeight, this.object.matrix);
    } else this.object.isOrthographicCamera ? (this._panLeft(e * (this.object.right - this.object.left) / this.object.zoom / n.clientWidth, this.object.matrix), this._panUp(t * (this.object.top - this.object.bottom) / this.object.zoom / n.clientHeight, this.object.matrix)) : (console.warn("WARNING: OrbitControls.js encountered an unknown camera type - pan disabled."), this.enablePan = !1);
  }
  _dollyOut(e) {
    this.object.isPerspectiveCamera || this.object.isOrthographicCamera ? this._scale /= e : (console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled."), this.enableZoom = !1);
  }
  _dollyIn(e) {
    this.object.isPerspectiveCamera || this.object.isOrthographicCamera ? this._scale *= e : (console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled."), this.enableZoom = !1);
  }
  _updateZoomParameters(e, t) {
    if (!this.zoomToCursor)
      return;
    this._performCursorZoom = !0;
    const n = this.domElement.getBoundingClientRect(), i = e - n.left, r = t - n.top, a = n.width, o = n.height;
    this._mouse.x = i / a * 2 - 1, this._mouse.y = -(r / o) * 2 + 1, this._dollyDirection.set(this._mouse.x, this._mouse.y, 1).unproject(this.object).sub(this.object.position).normalize();
  }
  _clampDistance(e) {
    return Math.max(this.minDistance, Math.min(this.maxDistance, e));
  }
  //
  // event callbacks - update the object state
  //
  _handleMouseDownRotate(e) {
    this._rotateStart.set(e.clientX, e.clientY);
  }
  _handleMouseDownDolly(e) {
    this._updateZoomParameters(e.clientX, e.clientX), this._dollyStart.set(e.clientX, e.clientY);
  }
  _handleMouseDownPan(e) {
    this._panStart.set(e.clientX, e.clientY);
  }
  _handleMouseMoveRotate(e) {
    this._rotateEnd.set(e.clientX, e.clientY), this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
    const t = this.domElement;
    this._rotateLeft(ln * this._rotateDelta.x / t.clientHeight), this._rotateUp(ln * this._rotateDelta.y / t.clientHeight), this._rotateStart.copy(this._rotateEnd), this.update();
  }
  _handleMouseMoveDolly(e) {
    this._dollyEnd.set(e.clientX, e.clientY), this._dollyDelta.subVectors(this._dollyEnd, this._dollyStart), this._dollyDelta.y > 0 ? this._dollyOut(this._getZoomScale(this._dollyDelta.y)) : this._dollyDelta.y < 0 && this._dollyIn(this._getZoomScale(this._dollyDelta.y)), this._dollyStart.copy(this._dollyEnd), this.update();
  }
  _handleMouseMovePan(e) {
    this._panEnd.set(e.clientX, e.clientY), this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed), this._pan(this._panDelta.x, this._panDelta.y), this._panStart.copy(this._panEnd), this.update();
  }
  _handleMouseWheel(e) {
    this._updateZoomParameters(e.clientX, e.clientY), e.deltaY < 0 ? this._dollyIn(this._getZoomScale(e.deltaY)) : e.deltaY > 0 && this._dollyOut(this._getZoomScale(e.deltaY)), this.update();
  }
  _handleKeyDown(e) {
    let t = !1;
    switch (e.code) {
      case this.keys.UP:
        e.ctrlKey || e.metaKey || e.shiftKey ? this.enableRotate && this._rotateUp(ln * this.keyRotateSpeed / this.domElement.clientHeight) : this.enablePan && this._pan(0, this.keyPanSpeed), t = !0;
        break;
      case this.keys.BOTTOM:
        e.ctrlKey || e.metaKey || e.shiftKey ? this.enableRotate && this._rotateUp(-ln * this.keyRotateSpeed / this.domElement.clientHeight) : this.enablePan && this._pan(0, -this.keyPanSpeed), t = !0;
        break;
      case this.keys.LEFT:
        e.ctrlKey || e.metaKey || e.shiftKey ? this.enableRotate && this._rotateLeft(ln * this.keyRotateSpeed / this.domElement.clientHeight) : this.enablePan && this._pan(this.keyPanSpeed, 0), t = !0;
        break;
      case this.keys.RIGHT:
        e.ctrlKey || e.metaKey || e.shiftKey ? this.enableRotate && this._rotateLeft(-ln * this.keyRotateSpeed / this.domElement.clientHeight) : this.enablePan && this._pan(-this.keyPanSpeed, 0), t = !0;
        break;
    }
    t && (e.preventDefault(), this.update());
  }
  _handleTouchStartRotate(e) {
    if (this._pointers.length === 1)
      this._rotateStart.set(e.pageX, e.pageY);
    else {
      const t = this._getSecondPointerPosition(e), n = 0.5 * (e.pageX + t.x), i = 0.5 * (e.pageY + t.y);
      this._rotateStart.set(n, i);
    }
  }
  _handleTouchStartPan(e) {
    if (this._pointers.length === 1)
      this._panStart.set(e.pageX, e.pageY);
    else {
      const t = this._getSecondPointerPosition(e), n = 0.5 * (e.pageX + t.x), i = 0.5 * (e.pageY + t.y);
      this._panStart.set(n, i);
    }
  }
  _handleTouchStartDolly(e) {
    const t = this._getSecondPointerPosition(e), n = e.pageX - t.x, i = e.pageY - t.y, r = Math.sqrt(n * n + i * i);
    this._dollyStart.set(0, r);
  }
  _handleTouchStartDollyPan(e) {
    this.enableZoom && this._handleTouchStartDolly(e), this.enablePan && this._handleTouchStartPan(e);
  }
  _handleTouchStartDollyRotate(e) {
    this.enableZoom && this._handleTouchStartDolly(e), this.enableRotate && this._handleTouchStartRotate(e);
  }
  _handleTouchMoveRotate(e) {
    if (this._pointers.length == 1)
      this._rotateEnd.set(e.pageX, e.pageY);
    else {
      const n = this._getSecondPointerPosition(e), i = 0.5 * (e.pageX + n.x), r = 0.5 * (e.pageY + n.y);
      this._rotateEnd.set(i, r);
    }
    this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
    const t = this.domElement;
    this._rotateLeft(ln * this._rotateDelta.x / t.clientHeight), this._rotateUp(ln * this._rotateDelta.y / t.clientHeight), this._rotateStart.copy(this._rotateEnd);
  }
  _handleTouchMovePan(e) {
    if (this._pointers.length === 1)
      this._panEnd.set(e.pageX, e.pageY);
    else {
      const t = this._getSecondPointerPosition(e), n = 0.5 * (e.pageX + t.x), i = 0.5 * (e.pageY + t.y);
      this._panEnd.set(n, i);
    }
    this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed), this._pan(this._panDelta.x, this._panDelta.y), this._panStart.copy(this._panEnd);
  }
  _handleTouchMoveDolly(e) {
    const t = this._getSecondPointerPosition(e), n = e.pageX - t.x, i = e.pageY - t.y, r = Math.sqrt(n * n + i * i);
    this._dollyEnd.set(0, r), this._dollyDelta.set(0, Math.pow(this._dollyEnd.y / this._dollyStart.y, this.zoomSpeed)), this._dollyOut(this._dollyDelta.y), this._dollyStart.copy(this._dollyEnd);
    const a = (e.pageX + t.x) * 0.5, o = (e.pageY + t.y) * 0.5;
    this._updateZoomParameters(a, o);
  }
  _handleTouchMoveDollyPan(e) {
    this.enableZoom && this._handleTouchMoveDolly(e), this.enablePan && this._handleTouchMovePan(e);
  }
  _handleTouchMoveDollyRotate(e) {
    this.enableZoom && this._handleTouchMoveDolly(e), this.enableRotate && this._handleTouchMoveRotate(e);
  }
  // pointers
  _addPointer(e) {
    this._pointers.push(e.pointerId);
  }
  _removePointer(e) {
    delete this._pointerPositions[e.pointerId];
    for (let t = 0; t < this._pointers.length; t++)
      if (this._pointers[t] == e.pointerId) {
        this._pointers.splice(t, 1);
        return;
      }
  }
  _isTrackingPointer(e) {
    for (let t = 0; t < this._pointers.length; t++)
      if (this._pointers[t] == e.pointerId) return !0;
    return !1;
  }
  _trackPointer(e) {
    let t = this._pointerPositions[e.pointerId];
    t === void 0 && (t = new ze(), this._pointerPositions[e.pointerId] = t), t.set(e.pageX, e.pageY);
  }
  _getSecondPointerPosition(e) {
    const t = e.pointerId === this._pointers[0] ? this._pointers[1] : this._pointers[0];
    return this._pointerPositions[t];
  }
  //
  _customWheelEvent(e) {
    const t = e.deltaMode, n = {
      clientX: e.clientX,
      clientY: e.clientY,
      deltaY: e.deltaY
    };
    switch (t) {
      case 1:
        n.deltaY *= 16;
        break;
      case 2:
        n.deltaY *= 100;
        break;
    }
    return e.ctrlKey && !this._controlActive && (n.deltaY *= 10), n;
  }
}
function Fx(s) {
  this.enabled !== !1 && (this._pointers.length === 0 && (this.domElement.setPointerCapture(s.pointerId), this.domElement.addEventListener("pointermove", this._onPointerMove), this.domElement.addEventListener("pointerup", this._onPointerUp)), !this._isTrackingPointer(s) && (this._addPointer(s), s.pointerType === "touch" ? this._onTouchStart(s) : this._onMouseDown(s)));
}
function Ox(s) {
  this.enabled !== !1 && (s.pointerType === "touch" ? this._onTouchMove(s) : this._onMouseMove(s));
}
function Bx(s) {
  switch (this._removePointer(s), this._pointers.length) {
    case 0:
      this.domElement.releasePointerCapture(s.pointerId), this.domElement.removeEventListener("pointermove", this._onPointerMove), this.domElement.removeEventListener("pointerup", this._onPointerUp), this.dispatchEvent(nd), this.state = yt.NONE;
      break;
    case 1:
      const e = this._pointers[0], t = this._pointerPositions[e];
      this._onTouchStart({ pointerId: e, pageX: t.x, pageY: t.y });
      break;
  }
}
function kx(s) {
  let e;
  switch (s.button) {
    case 0:
      e = this.mouseButtons.LEFT;
      break;
    case 1:
      e = this.mouseButtons.MIDDLE;
      break;
    case 2:
      e = this.mouseButtons.RIGHT;
      break;
    default:
      e = -1;
  }
  switch (e) {
    case Cs.DOLLY:
      if (this.enableZoom === !1) return;
      this._handleMouseDownDolly(s), this.state = yt.DOLLY;
      break;
    case Cs.ROTATE:
      if (s.ctrlKey || s.metaKey || s.shiftKey) {
        if (this.enablePan === !1) return;
        this._handleMouseDownPan(s), this.state = yt.PAN;
      } else {
        if (this.enableRotate === !1) return;
        this._handleMouseDownRotate(s), this.state = yt.ROTATE;
      }
      break;
    case Cs.PAN:
      if (s.ctrlKey || s.metaKey || s.shiftKey) {
        if (this.enableRotate === !1) return;
        this._handleMouseDownRotate(s), this.state = yt.ROTATE;
      } else {
        if (this.enablePan === !1) return;
        this._handleMouseDownPan(s), this.state = yt.PAN;
      }
      break;
    default:
      this.state = yt.NONE;
  }
  this.state !== yt.NONE && this.dispatchEvent(tc);
}
function zx(s) {
  switch (this.state) {
    case yt.ROTATE:
      if (this.enableRotate === !1) return;
      this._handleMouseMoveRotate(s);
      break;
    case yt.DOLLY:
      if (this.enableZoom === !1) return;
      this._handleMouseMoveDolly(s);
      break;
    case yt.PAN:
      if (this.enablePan === !1) return;
      this._handleMouseMovePan(s);
      break;
  }
}
function Hx(s) {
  this.enabled === !1 || this.enableZoom === !1 || this.state !== yt.NONE || (s.preventDefault(), this.dispatchEvent(tc), this._handleMouseWheel(this._customWheelEvent(s)), this.dispatchEvent(nd));
}
function Vx(s) {
  this.enabled !== !1 && this._handleKeyDown(s);
}
function Gx(s) {
  switch (this._trackPointer(s), this._pointers.length) {
    case 1:
      switch (this.touches.ONE) {
        case bs.ROTATE:
          if (this.enableRotate === !1) return;
          this._handleTouchStartRotate(s), this.state = yt.TOUCH_ROTATE;
          break;
        case bs.PAN:
          if (this.enablePan === !1) return;
          this._handleTouchStartPan(s), this.state = yt.TOUCH_PAN;
          break;
        default:
          this.state = yt.NONE;
      }
      break;
    case 2:
      switch (this.touches.TWO) {
        case bs.DOLLY_PAN:
          if (this.enableZoom === !1 && this.enablePan === !1) return;
          this._handleTouchStartDollyPan(s), this.state = yt.TOUCH_DOLLY_PAN;
          break;
        case bs.DOLLY_ROTATE:
          if (this.enableZoom === !1 && this.enableRotate === !1) return;
          this._handleTouchStartDollyRotate(s), this.state = yt.TOUCH_DOLLY_ROTATE;
          break;
        default:
          this.state = yt.NONE;
      }
      break;
    default:
      this.state = yt.NONE;
  }
  this.state !== yt.NONE && this.dispatchEvent(tc);
}
function Wx(s) {
  switch (this._trackPointer(s), this.state) {
    case yt.TOUCH_ROTATE:
      if (this.enableRotate === !1) return;
      this._handleTouchMoveRotate(s), this.update();
      break;
    case yt.TOUCH_PAN:
      if (this.enablePan === !1) return;
      this._handleTouchMovePan(s), this.update();
      break;
    case yt.TOUCH_DOLLY_PAN:
      if (this.enableZoom === !1 && this.enablePan === !1) return;
      this._handleTouchMoveDollyPan(s), this.update();
      break;
    case yt.TOUCH_DOLLY_ROTATE:
      if (this.enableZoom === !1 && this.enableRotate === !1) return;
      this._handleTouchMoveDollyRotate(s), this.update();
      break;
    default:
      this.state = yt.NONE;
  }
}
function Xx(s) {
  this.enabled !== !1 && s.preventDefault();
}
function qx(s) {
  s.key === "Control" && (this._controlActive = !0, this.domElement.getRootNode().addEventListener("keyup", this._interceptControlUp, { passive: !0, capture: !0 }));
}
function Yx(s) {
  s.key === "Control" && (this._controlActive = !1, this.domElement.getRootNode().removeEventListener("keyup", this._interceptControlUp, { passive: !0, capture: !0 }));
}
function ku(s, e) {
  if (e === $d)
    return console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles."), s;
  if (e === xl || e === Lh) {
    let t = s.getIndex();
    if (t === null) {
      const a = [], o = s.getAttribute("position");
      if (o !== void 0) {
        for (let l = 0; l < o.count; l++)
          a.push(l);
        s.setIndex(a), t = s.getIndex();
      } else
        return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible."), s;
    }
    const n = t.count - 2, i = [];
    if (e === xl)
      for (let a = 1; a <= n; a++)
        i.push(t.getX(0)), i.push(t.getX(a)), i.push(t.getX(a + 1));
    else
      for (let a = 0; a < n; a++)
        a % 2 === 0 ? (i.push(t.getX(a)), i.push(t.getX(a + 1)), i.push(t.getX(a + 2))) : (i.push(t.getX(a + 2)), i.push(t.getX(a + 1)), i.push(t.getX(a)));
    i.length / 3 !== n && console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
    const r = s.clone();
    return r.setIndex(i), r.clearGroups(), r;
  } else
    return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", e), s;
}
class zu extends Fi {
  /**
   * Constructs a new glTF loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(e) {
    super(e), this.dracoLoader = null, this.ktx2Loader = null, this.meshoptDecoder = null, this.pluginCallbacks = [], this.register(function(t) {
      return new Jx(t);
    }), this.register(function(t) {
      return new Qx(t);
    }), this.register(function(t) {
      return new lv(t);
    }), this.register(function(t) {
      return new cv(t);
    }), this.register(function(t) {
      return new uv(t);
    }), this.register(function(t) {
      return new tv(t);
    }), this.register(function(t) {
      return new nv(t);
    }), this.register(function(t) {
      return new iv(t);
    }), this.register(function(t) {
      return new sv(t);
    }), this.register(function(t) {
      return new $x(t);
    }), this.register(function(t) {
      return new rv(t);
    }), this.register(function(t) {
      return new ev(t);
    }), this.register(function(t) {
      return new ov(t);
    }), this.register(function(t) {
      return new av(t);
    }), this.register(function(t) {
      return new Kx(t);
    }), this.register(function(t) {
      return new hv(t);
    }), this.register(function(t) {
      return new dv(t);
    });
  }
  /**
   * Starts loading from the given URL and passes the loaded glTF asset
   * to the `onLoad()` callback.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(GLTFLoader~LoadObject)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
   * @param {onErrorCallback} onError - Executed when errors occur.
   */
  load(e, t, n, i) {
    const r = this;
    let a;
    if (this.resourcePath !== "")
      a = this.resourcePath;
    else if (this.path !== "") {
      const c = gr.extractUrlBase(e);
      a = gr.resolveURL(c, this.path);
    } else
      a = gr.extractUrlBase(e);
    this.manager.itemStart(e);
    const o = function(c) {
      i ? i(c) : console.error(c), r.manager.itemError(e), r.manager.itemEnd(e);
    }, l = new Er(this.manager);
    l.setPath(this.path), l.setResponseType("arraybuffer"), l.setRequestHeader(this.requestHeader), l.setWithCredentials(this.withCredentials), l.load(e, function(c) {
      try {
        r.parse(c, a, function(u) {
          t(u), r.manager.itemEnd(e);
        }, o);
      } catch (u) {
        o(u);
      }
    }, n, o);
  }
  /**
   * Sets the given Draco loader to this loader. Required for decoding assets
   * compressed with the `KHR_draco_mesh_compression` extension.
   *
   * @param {DRACOLoader} dracoLoader - The Draco loader to set.
   * @return {GLTFLoader} A reference to this loader.
   */
  setDRACOLoader(e) {
    return this.dracoLoader = e, this;
  }
  /**
   * Sets the given KTX2 loader to this loader. Required for loading KTX2
   * compressed textures.
   *
   * @param {KTX2Loader} ktx2Loader - The KTX2 loader to set.
   * @return {GLTFLoader} A reference to this loader.
   */
  setKTX2Loader(e) {
    return this.ktx2Loader = e, this;
  }
  /**
   * Sets the given meshopt decoder. Required for decoding assets
   * compressed with the `EXT_meshopt_compression` extension.
   *
   * @param {Object} meshoptDecoder - The meshopt decoder to set.
   * @return {GLTFLoader} A reference to this loader.
   */
  setMeshoptDecoder(e) {
    return this.meshoptDecoder = e, this;
  }
  /**
   * Registers a plugin callback. This API is internally used to implement the various
   * glTF extensions but can also used by third-party code to add additional logic
   * to the loader.
   *
   * @param {function(parser:GLTFParser)} callback - The callback function to register.
   * @return {GLTFLoader} A reference to this loader.
   */
  register(e) {
    return this.pluginCallbacks.indexOf(e) === -1 && this.pluginCallbacks.push(e), this;
  }
  /**
   * Unregisters a plugin callback.
   *
   * @param {Function} callback - The callback function to unregister.
   * @return {GLTFLoader} A reference to this loader.
   */
  unregister(e) {
    return this.pluginCallbacks.indexOf(e) !== -1 && this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(e), 1), this;
  }
  /**
   * Parses the given FBX data and returns the resulting group.
   *
   * @param {string|ArrayBuffer} data - The raw glTF data.
   * @param {string} path - The URL base path.
   * @param {function(GLTFLoader~LoadObject)} onLoad - Executed when the loading process has been finished.
   * @param {onErrorCallback} onError - Executed when errors occur.
   */
  parse(e, t, n, i) {
    let r;
    const a = {}, o = {}, l = new TextDecoder();
    if (typeof e == "string")
      r = JSON.parse(e);
    else if (e instanceof ArrayBuffer)
      if (l.decode(new Uint8Array(e, 0, 4)) === id) {
        try {
          a[rt.KHR_BINARY_GLTF] = new fv(e);
        } catch (h) {
          i && i(h);
          return;
        }
        r = JSON.parse(a[rt.KHR_BINARY_GLTF].content);
      } else
        r = JSON.parse(l.decode(e));
    else
      r = e;
    if (r.asset === void 0 || r.asset.version[0] < 2) {
      i && i(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."));
      return;
    }
    const c = new Av(r, {
      path: t || this.resourcePath || "",
      crossOrigin: this.crossOrigin,
      requestHeader: this.requestHeader,
      manager: this.manager,
      ktx2Loader: this.ktx2Loader,
      meshoptDecoder: this.meshoptDecoder
    });
    c.fileLoader.setRequestHeader(this.requestHeader);
    for (let u = 0; u < this.pluginCallbacks.length; u++) {
      const h = this.pluginCallbacks[u](c);
      h.name || console.error("THREE.GLTFLoader: Invalid plugin found: missing name"), o[h.name] = h, a[h.name] = !0;
    }
    if (r.extensionsUsed)
      for (let u = 0; u < r.extensionsUsed.length; ++u) {
        const h = r.extensionsUsed[u], d = r.extensionsRequired || [];
        switch (h) {
          case rt.KHR_MATERIALS_UNLIT:
            a[h] = new Zx();
            break;
          case rt.KHR_DRACO_MESH_COMPRESSION:
            a[h] = new pv(r, this.dracoLoader);
            break;
          case rt.KHR_TEXTURE_TRANSFORM:
            a[h] = new mv();
            break;
          case rt.KHR_MESH_QUANTIZATION:
            a[h] = new gv();
            break;
          default:
            d.indexOf(h) >= 0 && o[h] === void 0 && console.warn('THREE.GLTFLoader: Unknown extension "' + h + '".');
        }
      }
    c.setExtensions(a), c.setPlugins(o), c.parse(n, i);
  }
  /**
   * Async version of {@link GLTFLoader#parse}.
   *
   * @async
   * @param {string|ArrayBuffer} data - The raw glTF data.
   * @param {string} path - The URL base path.
   * @return {Promise<GLTFLoader~LoadObject>} A Promise that resolves with the loaded glTF when the parsing has been finished.
   */
  parseAsync(e, t) {
    const n = this;
    return new Promise(function(i, r) {
      n.parse(e, t, i, r);
    });
  }
}
function jx() {
  let s = {};
  return {
    get: function(e) {
      return s[e];
    },
    add: function(e, t) {
      s[e] = t;
    },
    remove: function(e) {
      delete s[e];
    },
    removeAll: function() {
      s = {};
    }
  };
}
const rt = {
  KHR_BINARY_GLTF: "KHR_binary_glTF",
  KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
  KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
  KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
  KHR_MATERIALS_DISPERSION: "KHR_materials_dispersion",
  KHR_MATERIALS_IOR: "KHR_materials_ior",
  KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
  KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
  KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
  KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
  KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
  KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
  KHR_MATERIALS_VOLUME: "KHR_materials_volume",
  KHR_TEXTURE_BASISU: "KHR_texture_basisu",
  KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
  KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
  KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
  EXT_MATERIALS_BUMP: "EXT_materials_bump",
  EXT_TEXTURE_WEBP: "EXT_texture_webp",
  EXT_TEXTURE_AVIF: "EXT_texture_avif",
  EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
  EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
};
class Kx {
  constructor(e) {
    this.parser = e, this.name = rt.KHR_LIGHTS_PUNCTUAL, this.cache = { refs: {}, uses: {} };
  }
  _markDefs() {
    const e = this.parser, t = this.parser.json.nodes || [];
    for (let n = 0, i = t.length; n < i; n++) {
      const r = t[n];
      r.extensions && r.extensions[this.name] && r.extensions[this.name].light !== void 0 && e._addNodeRef(this.cache, r.extensions[this.name].light);
    }
  }
  _loadLight(e) {
    const t = this.parser, n = "light:" + e;
    let i = t.cache.get(n);
    if (i) return i;
    const r = t.json, l = ((r.extensions && r.extensions[this.name] || {}).lights || [])[e];
    let c;
    const u = new He(16777215);
    l.color !== void 0 && u.setRGB(l.color[0], l.color[1], l.color[2], Zt);
    const h = l.range !== void 0 ? l.range : 0;
    switch (l.type) {
      case "directional":
        c = new Ml(u), c.target.position.set(0, 0, -1), c.add(c.target);
        break;
      case "point":
        c = new Zh(u), c.distance = h;
        break;
      case "spot":
        c = new Cp(u), c.distance = h, l.spot = l.spot || {}, l.spot.innerConeAngle = l.spot.innerConeAngle !== void 0 ? l.spot.innerConeAngle : 0, l.spot.outerConeAngle = l.spot.outerConeAngle !== void 0 ? l.spot.outerConeAngle : Math.PI / 4, c.angle = l.spot.outerConeAngle, c.penumbra = 1 - l.spot.innerConeAngle / l.spot.outerConeAngle, c.target.position.set(0, 0, -1), c.add(c.target);
        break;
      default:
        throw new Error("THREE.GLTFLoader: Unexpected light type: " + l.type);
    }
    return c.position.set(0, 0, 0), li(c, l), l.intensity !== void 0 && (c.intensity = l.intensity), c.name = t.createUniqueName(l.name || "light_" + e), i = Promise.resolve(c), t.cache.add(n, i), i;
  }
  getDependency(e, t) {
    if (e === "light")
      return this._loadLight(t);
  }
  createNodeAttachment(e) {
    const t = this, n = this.parser, r = n.json.nodes[e], o = (r.extensions && r.extensions[this.name] || {}).light;
    return o === void 0 ? null : this._loadLight(o).then(function(l) {
      return n._getNodeRef(t.cache, o, l);
    });
  }
}
class Zx {
  constructor() {
    this.name = rt.KHR_MATERIALS_UNLIT;
  }
  getMaterialType() {
    return hi;
  }
  extendParams(e, t, n) {
    const i = [];
    e.color = new He(1, 1, 1), e.opacity = 1;
    const r = t.pbrMetallicRoughness;
    if (r) {
      if (Array.isArray(r.baseColorFactor)) {
        const a = r.baseColorFactor;
        e.color.setRGB(a[0], a[1], a[2], Zt), e.opacity = a[3];
      }
      r.baseColorTexture !== void 0 && i.push(n.assignTexture(e, "map", r.baseColorTexture, Dt));
    }
    return Promise.all(i);
  }
}
class $x {
  constructor(e) {
    this.parser = e, this.name = rt.KHR_MATERIALS_EMISSIVE_STRENGTH;
  }
  extendMaterialParams(e, t) {
    const i = this.parser.json.materials[e];
    if (!i.extensions || !i.extensions[this.name])
      return Promise.resolve();
    const r = i.extensions[this.name].emissiveStrength;
    return r !== void 0 && (t.emissiveIntensity = r), Promise.resolve();
  }
}
class Jx {
  constructor(e) {
    this.parser = e, this.name = rt.KHR_MATERIALS_CLEARCOAT;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : Zn;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, i = n.json.materials[e];
    if (!i.extensions || !i.extensions[this.name])
      return Promise.resolve();
    const r = [], a = i.extensions[this.name];
    if (a.clearcoatFactor !== void 0 && (t.clearcoat = a.clearcoatFactor), a.clearcoatTexture !== void 0 && r.push(n.assignTexture(t, "clearcoatMap", a.clearcoatTexture)), a.clearcoatRoughnessFactor !== void 0 && (t.clearcoatRoughness = a.clearcoatRoughnessFactor), a.clearcoatRoughnessTexture !== void 0 && r.push(n.assignTexture(t, "clearcoatRoughnessMap", a.clearcoatRoughnessTexture)), a.clearcoatNormalTexture !== void 0 && (r.push(n.assignTexture(t, "clearcoatNormalMap", a.clearcoatNormalTexture)), a.clearcoatNormalTexture.scale !== void 0)) {
      const o = a.clearcoatNormalTexture.scale;
      t.clearcoatNormalScale = new ze(o, o);
    }
    return Promise.all(r);
  }
}
class Qx {
  constructor(e) {
    this.parser = e, this.name = rt.KHR_MATERIALS_DISPERSION;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : Zn;
  }
  extendMaterialParams(e, t) {
    const i = this.parser.json.materials[e];
    if (!i.extensions || !i.extensions[this.name])
      return Promise.resolve();
    const r = i.extensions[this.name];
    return t.dispersion = r.dispersion !== void 0 ? r.dispersion : 0, Promise.resolve();
  }
}
class ev {
  constructor(e) {
    this.parser = e, this.name = rt.KHR_MATERIALS_IRIDESCENCE;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : Zn;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, i = n.json.materials[e];
    if (!i.extensions || !i.extensions[this.name])
      return Promise.resolve();
    const r = [], a = i.extensions[this.name];
    return a.iridescenceFactor !== void 0 && (t.iridescence = a.iridescenceFactor), a.iridescenceTexture !== void 0 && r.push(n.assignTexture(t, "iridescenceMap", a.iridescenceTexture)), a.iridescenceIor !== void 0 && (t.iridescenceIOR = a.iridescenceIor), t.iridescenceThicknessRange === void 0 && (t.iridescenceThicknessRange = [100, 400]), a.iridescenceThicknessMinimum !== void 0 && (t.iridescenceThicknessRange[0] = a.iridescenceThicknessMinimum), a.iridescenceThicknessMaximum !== void 0 && (t.iridescenceThicknessRange[1] = a.iridescenceThicknessMaximum), a.iridescenceThicknessTexture !== void 0 && r.push(n.assignTexture(t, "iridescenceThicknessMap", a.iridescenceThicknessTexture)), Promise.all(r);
  }
}
class tv {
  constructor(e) {
    this.parser = e, this.name = rt.KHR_MATERIALS_SHEEN;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : Zn;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, i = n.json.materials[e];
    if (!i.extensions || !i.extensions[this.name])
      return Promise.resolve();
    const r = [];
    t.sheenColor = new He(0, 0, 0), t.sheenRoughness = 0, t.sheen = 1;
    const a = i.extensions[this.name];
    if (a.sheenColorFactor !== void 0) {
      const o = a.sheenColorFactor;
      t.sheenColor.setRGB(o[0], o[1], o[2], Zt);
    }
    return a.sheenRoughnessFactor !== void 0 && (t.sheenRoughness = a.sheenRoughnessFactor), a.sheenColorTexture !== void 0 && r.push(n.assignTexture(t, "sheenColorMap", a.sheenColorTexture, Dt)), a.sheenRoughnessTexture !== void 0 && r.push(n.assignTexture(t, "sheenRoughnessMap", a.sheenRoughnessTexture)), Promise.all(r);
  }
}
class nv {
  constructor(e) {
    this.parser = e, this.name = rt.KHR_MATERIALS_TRANSMISSION;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : Zn;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, i = n.json.materials[e];
    if (!i.extensions || !i.extensions[this.name])
      return Promise.resolve();
    const r = [], a = i.extensions[this.name];
    return a.transmissionFactor !== void 0 && (t.transmission = a.transmissionFactor), a.transmissionTexture !== void 0 && r.push(n.assignTexture(t, "transmissionMap", a.transmissionTexture)), Promise.all(r);
  }
}
class iv {
  constructor(e) {
    this.parser = e, this.name = rt.KHR_MATERIALS_VOLUME;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : Zn;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, i = n.json.materials[e];
    if (!i.extensions || !i.extensions[this.name])
      return Promise.resolve();
    const r = [], a = i.extensions[this.name];
    t.thickness = a.thicknessFactor !== void 0 ? a.thicknessFactor : 0, a.thicknessTexture !== void 0 && r.push(n.assignTexture(t, "thicknessMap", a.thicknessTexture)), t.attenuationDistance = a.attenuationDistance || 1 / 0;
    const o = a.attenuationColor || [1, 1, 1];
    return t.attenuationColor = new He().setRGB(o[0], o[1], o[2], Zt), Promise.all(r);
  }
}
class sv {
  constructor(e) {
    this.parser = e, this.name = rt.KHR_MATERIALS_IOR;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : Zn;
  }
  extendMaterialParams(e, t) {
    const i = this.parser.json.materials[e];
    if (!i.extensions || !i.extensions[this.name])
      return Promise.resolve();
    const r = i.extensions[this.name];
    return t.ior = r.ior !== void 0 ? r.ior : 1.5, Promise.resolve();
  }
}
class rv {
  constructor(e) {
    this.parser = e, this.name = rt.KHR_MATERIALS_SPECULAR;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : Zn;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, i = n.json.materials[e];
    if (!i.extensions || !i.extensions[this.name])
      return Promise.resolve();
    const r = [], a = i.extensions[this.name];
    t.specularIntensity = a.specularFactor !== void 0 ? a.specularFactor : 1, a.specularTexture !== void 0 && r.push(n.assignTexture(t, "specularIntensityMap", a.specularTexture));
    const o = a.specularColorFactor || [1, 1, 1];
    return t.specularColor = new He().setRGB(o[0], o[1], o[2], Zt), a.specularColorTexture !== void 0 && r.push(n.assignTexture(t, "specularColorMap", a.specularColorTexture, Dt)), Promise.all(r);
  }
}
class av {
  constructor(e) {
    this.parser = e, this.name = rt.EXT_MATERIALS_BUMP;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : Zn;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, i = n.json.materials[e];
    if (!i.extensions || !i.extensions[this.name])
      return Promise.resolve();
    const r = [], a = i.extensions[this.name];
    return t.bumpScale = a.bumpFactor !== void 0 ? a.bumpFactor : 1, a.bumpTexture !== void 0 && r.push(n.assignTexture(t, "bumpMap", a.bumpTexture)), Promise.all(r);
  }
}
class ov {
  constructor(e) {
    this.parser = e, this.name = rt.KHR_MATERIALS_ANISOTROPY;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : Zn;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, i = n.json.materials[e];
    if (!i.extensions || !i.extensions[this.name])
      return Promise.resolve();
    const r = [], a = i.extensions[this.name];
    return a.anisotropyStrength !== void 0 && (t.anisotropy = a.anisotropyStrength), a.anisotropyRotation !== void 0 && (t.anisotropyRotation = a.anisotropyRotation), a.anisotropyTexture !== void 0 && r.push(n.assignTexture(t, "anisotropyMap", a.anisotropyTexture)), Promise.all(r);
  }
}
class lv {
  constructor(e) {
    this.parser = e, this.name = rt.KHR_TEXTURE_BASISU;
  }
  loadTexture(e) {
    const t = this.parser, n = t.json, i = n.textures[e];
    if (!i.extensions || !i.extensions[this.name])
      return null;
    const r = i.extensions[this.name], a = t.options.ktx2Loader;
    if (!a) {
      if (n.extensionsRequired && n.extensionsRequired.indexOf(this.name) >= 0)
        throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
      return null;
    }
    return t.loadTextureImage(e, r.source, a);
  }
}
class cv {
  constructor(e) {
    this.parser = e, this.name = rt.EXT_TEXTURE_WEBP, this.isSupported = null;
  }
  loadTexture(e) {
    const t = this.name, n = this.parser, i = n.json, r = i.textures[e];
    if (!r.extensions || !r.extensions[t])
      return null;
    const a = r.extensions[t], o = i.images[a.source];
    let l = n.textureLoader;
    if (o.uri) {
      const c = n.options.manager.getHandler(o.uri);
      c !== null && (l = c);
    }
    return this.detectSupport().then(function(c) {
      if (c) return n.loadTextureImage(e, a.source, l);
      if (i.extensionsRequired && i.extensionsRequired.indexOf(t) >= 0)
        throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
      return n.loadTexture(e);
    });
  }
  detectSupport() {
    return this.isSupported || (this.isSupported = new Promise(function(e) {
      const t = new Image();
      t.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA", t.onload = t.onerror = function() {
        e(t.height === 1);
      };
    })), this.isSupported;
  }
}
class uv {
  constructor(e) {
    this.parser = e, this.name = rt.EXT_TEXTURE_AVIF, this.isSupported = null;
  }
  loadTexture(e) {
    const t = this.name, n = this.parser, i = n.json, r = i.textures[e];
    if (!r.extensions || !r.extensions[t])
      return null;
    const a = r.extensions[t], o = i.images[a.source];
    let l = n.textureLoader;
    if (o.uri) {
      const c = n.options.manager.getHandler(o.uri);
      c !== null && (l = c);
    }
    return this.detectSupport().then(function(c) {
      if (c) return n.loadTextureImage(e, a.source, l);
      if (i.extensionsRequired && i.extensionsRequired.indexOf(t) >= 0)
        throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.");
      return n.loadTexture(e);
    });
  }
  detectSupport() {
    return this.isSupported || (this.isSupported = new Promise(function(e) {
      const t = new Image();
      t.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=", t.onload = t.onerror = function() {
        e(t.height === 1);
      };
    })), this.isSupported;
  }
}
class hv {
  constructor(e) {
    this.name = rt.EXT_MESHOPT_COMPRESSION, this.parser = e;
  }
  loadBufferView(e) {
    const t = this.parser.json, n = t.bufferViews[e];
    if (n.extensions && n.extensions[this.name]) {
      const i = n.extensions[this.name], r = this.parser.getDependency("buffer", i.buffer), a = this.parser.options.meshoptDecoder;
      if (!a || !a.supported) {
        if (t.extensionsRequired && t.extensionsRequired.indexOf(this.name) >= 0)
          throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
        return null;
      }
      return r.then(function(o) {
        const l = i.byteOffset || 0, c = i.byteLength || 0, u = i.count, h = i.byteStride, d = new Uint8Array(o, l, c);
        return a.decodeGltfBufferAsync ? a.decodeGltfBufferAsync(u, h, d, i.mode, i.filter).then(function(f) {
          return f.buffer;
        }) : a.ready.then(function() {
          const f = new ArrayBuffer(u * h);
          return a.decodeGltfBuffer(new Uint8Array(f), u, h, d, i.mode, i.filter), f;
        });
      });
    } else
      return null;
  }
}
class dv {
  constructor(e) {
    this.name = rt.EXT_MESH_GPU_INSTANCING, this.parser = e;
  }
  createNodeMesh(e) {
    const t = this.parser.json, n = t.nodes[e];
    if (!n.extensions || !n.extensions[this.name] || n.mesh === void 0)
      return null;
    const i = t.meshes[n.mesh];
    for (const c of i.primitives)
      if (c.mode !== yn.TRIANGLES && c.mode !== yn.TRIANGLE_STRIP && c.mode !== yn.TRIANGLE_FAN && c.mode !== void 0)
        return null;
    const a = n.extensions[this.name].attributes, o = [], l = {};
    for (const c in a)
      o.push(this.parser.getDependency("accessor", a[c]).then((u) => (l[c] = u, l[c])));
    return o.length < 1 ? null : (o.push(this.parser.createNodeMesh(e)), Promise.all(o).then((c) => {
      const u = c.pop(), h = u.isGroup ? u.children : [u], d = c[0].count, f = [];
      for (const m of h) {
        const _ = new Ye(), g = new T(), p = new gn(), M = new T(1, 1, 1), S = new rp(m.geometry, m.material, d);
        for (let x = 0; x < d; x++)
          l.TRANSLATION && g.fromBufferAttribute(l.TRANSLATION, x), l.ROTATION && p.fromBufferAttribute(l.ROTATION, x), l.SCALE && M.fromBufferAttribute(l.SCALE, x), S.setMatrixAt(x, _.compose(g, p, M));
        for (const x in l)
          if (x === "_COLOR_0") {
            const R = l[x];
            S.instanceColor = new yl(R.array, R.itemSize, R.normalized);
          } else x !== "TRANSLATION" && x !== "ROTATION" && x !== "SCALE" && m.geometry.setAttribute(x, l[x]);
        bt.prototype.copy.call(S, m), this.parser.assignFinalMaterial(S), f.push(S);
      }
      return u.isGroup ? (u.clear(), u.add(...f), u) : f[0];
    }));
  }
}
const id = "glTF", or = 12, Hu = { JSON: 1313821514, BIN: 5130562 };
class fv {
  constructor(e) {
    this.name = rt.KHR_BINARY_GLTF, this.content = null, this.body = null;
    const t = new DataView(e, 0, or), n = new TextDecoder();
    if (this.header = {
      magic: n.decode(new Uint8Array(e.slice(0, 4))),
      version: t.getUint32(4, !0),
      length: t.getUint32(8, !0)
    }, this.header.magic !== id)
      throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
    if (this.header.version < 2)
      throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
    const i = this.header.length - or, r = new DataView(e, or);
    let a = 0;
    for (; a < i; ) {
      const o = r.getUint32(a, !0);
      a += 4;
      const l = r.getUint32(a, !0);
      if (a += 4, l === Hu.JSON) {
        const c = new Uint8Array(e, or + a, o);
        this.content = n.decode(c);
      } else if (l === Hu.BIN) {
        const c = or + a;
        this.body = e.slice(c, c + o);
      }
      a += o;
    }
    if (this.content === null)
      throw new Error("THREE.GLTFLoader: JSON content not found.");
  }
}
class pv {
  constructor(e, t) {
    if (!t)
      throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
    this.name = rt.KHR_DRACO_MESH_COMPRESSION, this.json = e, this.dracoLoader = t, this.dracoLoader.preload();
  }
  decodePrimitive(e, t) {
    const n = this.json, i = this.dracoLoader, r = e.extensions[this.name].bufferView, a = e.extensions[this.name].attributes, o = {}, l = {}, c = {};
    for (const u in a) {
      const h = Al[u] || u.toLowerCase();
      o[h] = a[u];
    }
    for (const u in e.attributes) {
      const h = Al[u] || u.toLowerCase();
      if (a[u] !== void 0) {
        const d = n.accessors[e.attributes[u]], f = Is[d.componentType];
        c[h] = f.name, l[h] = d.normalized === !0;
      }
    }
    return t.getDependency("bufferView", r).then(function(u) {
      return new Promise(function(h, d) {
        i.decodeDracoFile(u, function(f) {
          for (const m in f.attributes) {
            const _ = f.attributes[m], g = l[m];
            g !== void 0 && (_.normalized = g);
          }
          h(f);
        }, o, c, Zt, d);
      });
    });
  }
}
class mv {
  constructor() {
    this.name = rt.KHR_TEXTURE_TRANSFORM;
  }
  extendTexture(e, t) {
    return (t.texCoord === void 0 || t.texCoord === e.channel) && t.offset === void 0 && t.rotation === void 0 && t.scale === void 0 || (e = e.clone(), t.texCoord !== void 0 && (e.channel = t.texCoord), t.offset !== void 0 && e.offset.fromArray(t.offset), t.rotation !== void 0 && (e.rotation = t.rotation), t.scale !== void 0 && e.repeat.fromArray(t.scale), e.needsUpdate = !0), e;
  }
}
class gv {
  constructor() {
    this.name = rt.KHR_MESH_QUANTIZATION;
  }
}
class sd extends wr {
  constructor(e, t, n, i) {
    super(e, t, n, i);
  }
  copySampleValue_(e) {
    const t = this.resultBuffer, n = this.sampleValues, i = this.valueSize, r = e * i * 3 + i;
    for (let a = 0; a !== i; a++)
      t[a] = n[r + a];
    return t;
  }
  interpolate_(e, t, n, i) {
    const r = this.resultBuffer, a = this.sampleValues, o = this.valueSize, l = o * 2, c = o * 3, u = i - t, h = (n - t) / u, d = h * h, f = d * h, m = e * c, _ = m - c, g = -2 * f + 3 * d, p = f - d, M = 1 - g, S = p - d + h;
    for (let x = 0; x !== o; x++) {
      const R = a[_ + x + o], w = a[_ + x + l] * u, C = a[m + x + o], P = a[m + x] * u;
      r[x] = M * R + S * w + g * C + p * P;
    }
    return r;
  }
}
const _v = new gn();
class xv extends sd {
  interpolate_(e, t, n, i) {
    const r = super.interpolate_(e, t, n, i);
    return _v.fromArray(r).normalize().toArray(r), r;
  }
}
const yn = {
  POINTS: 0,
  LINES: 1,
  LINE_LOOP: 2,
  LINE_STRIP: 3,
  TRIANGLES: 4,
  TRIANGLE_STRIP: 5,
  TRIANGLE_FAN: 6
}, Is = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
}, Vu = {
  9728: en,
  9729: Vt,
  9984: yh,
  9985: da,
  9986: ur,
  9987: Gn
}, Gu = {
  33071: Vn,
  33648: Ma,
  10497: Fs
}, vo = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
}, Al = {
  POSITION: "position",
  NORMAL: "normal",
  TANGENT: "tangent",
  TEXCOORD_0: "uv",
  TEXCOORD_1: "uv1",
  TEXCOORD_2: "uv2",
  TEXCOORD_3: "uv3",
  COLOR_0: "color",
  WEIGHTS_0: "skinWeight",
  JOINTS_0: "skinIndex"
}, Ti = {
  scale: "scale",
  translation: "position",
  rotation: "quaternion",
  weights: "morphTargetInfluences"
}, vv = {
  CUBICSPLINE: void 0,
  // We use a custom interpolant (GLTFCubicSplineInterpolation) for CUBICSPLINE tracks. Each
  // keyframe track will be initialized with a default interpolation type, then modified.
  LINEAR: Mr,
  STEP: Sr
}, yo = {
  OPAQUE: "OPAQUE",
  MASK: "MASK",
  BLEND: "BLEND"
};
function yv(s) {
  return s.DefaultMaterial === void 0 && (s.DefaultMaterial = new Kn({
    color: 16777215,
    emissive: 0,
    metalness: 1,
    roughness: 1,
    transparent: !1,
    depthTest: !0,
    side: gi
  })), s.DefaultMaterial;
}
function Xi(s, e, t) {
  for (const n in t.extensions)
    s[n] === void 0 && (e.userData.gltfExtensions = e.userData.gltfExtensions || {}, e.userData.gltfExtensions[n] = t.extensions[n]);
}
function li(s, e) {
  e.extras !== void 0 && (typeof e.extras == "object" ? Object.assign(s.userData, e.extras) : console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + e.extras));
}
function Sv(s, e, t) {
  let n = !1, i = !1, r = !1;
  for (let c = 0, u = e.length; c < u; c++) {
    const h = e[c];
    if (h.POSITION !== void 0 && (n = !0), h.NORMAL !== void 0 && (i = !0), h.COLOR_0 !== void 0 && (r = !0), n && i && r) break;
  }
  if (!n && !i && !r) return Promise.resolve(s);
  const a = [], o = [], l = [];
  for (let c = 0, u = e.length; c < u; c++) {
    const h = e[c];
    if (n) {
      const d = h.POSITION !== void 0 ? t.getDependency("accessor", h.POSITION) : s.attributes.position;
      a.push(d);
    }
    if (i) {
      const d = h.NORMAL !== void 0 ? t.getDependency("accessor", h.NORMAL) : s.attributes.normal;
      o.push(d);
    }
    if (r) {
      const d = h.COLOR_0 !== void 0 ? t.getDependency("accessor", h.COLOR_0) : s.attributes.color;
      l.push(d);
    }
  }
  return Promise.all([
    Promise.all(a),
    Promise.all(o),
    Promise.all(l)
  ]).then(function(c) {
    const u = c[0], h = c[1], d = c[2];
    return n && (s.morphAttributes.position = u), i && (s.morphAttributes.normal = h), r && (s.morphAttributes.color = d), s.morphTargetsRelative = !0, s;
  });
}
function Mv(s, e) {
  if (s.updateMorphTargets(), e.weights !== void 0)
    for (let t = 0, n = e.weights.length; t < n; t++)
      s.morphTargetInfluences[t] = e.weights[t];
  if (e.extras && Array.isArray(e.extras.targetNames)) {
    const t = e.extras.targetNames;
    if (s.morphTargetInfluences.length === t.length) {
      s.morphTargetDictionary = {};
      for (let n = 0, i = t.length; n < i; n++)
        s.morphTargetDictionary[t[n]] = n;
    } else
      console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
  }
}
function bv(s) {
  let e;
  const t = s.extensions && s.extensions[rt.KHR_DRACO_MESH_COMPRESSION];
  if (t ? e = "draco:" + t.bufferView + ":" + t.indices + ":" + So(t.attributes) : e = s.indices + ":" + So(s.attributes) + ":" + s.mode, s.targets !== void 0)
    for (let n = 0, i = s.targets.length; n < i; n++)
      e += ":" + So(s.targets[n]);
  return e;
}
function So(s) {
  let e = "";
  const t = Object.keys(s).sort();
  for (let n = 0, i = t.length; n < i; n++)
    e += t[n] + ":" + s[t[n]] + ";";
  return e;
}
function wl(s) {
  switch (s) {
    case Int8Array:
      return 1 / 127;
    case Uint8Array:
      return 1 / 255;
    case Int16Array:
      return 1 / 32767;
    case Uint16Array:
      return 1 / 65535;
    default:
      throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
  }
}
function Ev(s) {
  return s.search(/\.jpe?g($|\?)/i) > 0 || s.search(/^data\:image\/jpeg/) === 0 ? "image/jpeg" : s.search(/\.webp($|\?)/i) > 0 || s.search(/^data\:image\/webp/) === 0 ? "image/webp" : s.search(/\.ktx2($|\?)/i) > 0 || s.search(/^data\:image\/ktx2/) === 0 ? "image/ktx2" : "image/png";
}
const Tv = new Ye();
class Av {
  constructor(e = {}, t = {}) {
    this.json = e, this.extensions = {}, this.plugins = {}, this.options = t, this.cache = new jx(), this.associations = /* @__PURE__ */ new Map(), this.primitiveCache = {}, this.nodeCache = {}, this.meshCache = { refs: {}, uses: {} }, this.cameraCache = { refs: {}, uses: {} }, this.lightCache = { refs: {}, uses: {} }, this.sourceCache = {}, this.textureCache = {}, this.nodeNamesUsed = {};
    let n = !1, i = -1, r = !1, a = -1;
    if (typeof navigator < "u") {
      const o = navigator.userAgent;
      n = /^((?!chrome|android).)*safari/i.test(o) === !0;
      const l = o.match(/Version\/(\d+)/);
      i = n && l ? parseInt(l[1], 10) : -1, r = o.indexOf("Firefox") > -1, a = r ? o.match(/Firefox\/([0-9]+)\./)[1] : -1;
    }
    typeof createImageBitmap > "u" || n && i < 17 || r && a < 98 ? this.textureLoader = new Ap(this.options.manager) : this.textureLoader = new Dp(this.options.manager), this.textureLoader.setCrossOrigin(this.options.crossOrigin), this.textureLoader.setRequestHeader(this.options.requestHeader), this.fileLoader = new Er(this.options.manager), this.fileLoader.setResponseType("arraybuffer"), this.options.crossOrigin === "use-credentials" && this.fileLoader.setWithCredentials(!0);
  }
  setExtensions(e) {
    this.extensions = e;
  }
  setPlugins(e) {
    this.plugins = e;
  }
  parse(e, t) {
    const n = this, i = this.json, r = this.extensions;
    this.cache.removeAll(), this.nodeCache = {}, this._invokeAll(function(a) {
      return a._markDefs && a._markDefs();
    }), Promise.all(this._invokeAll(function(a) {
      return a.beforeRoot && a.beforeRoot();
    })).then(function() {
      return Promise.all([
        n.getDependencies("scene"),
        n.getDependencies("animation"),
        n.getDependencies("camera")
      ]);
    }).then(function(a) {
      const o = {
        scene: a[0][i.scene || 0],
        scenes: a[0],
        animations: a[1],
        cameras: a[2],
        asset: i.asset,
        parser: n,
        userData: {}
      };
      return Xi(r, o, i), li(o, i), Promise.all(n._invokeAll(function(l) {
        return l.afterRoot && l.afterRoot(o);
      })).then(function() {
        for (const l of o.scenes)
          l.updateMatrixWorld();
        e(o);
      });
    }).catch(t);
  }
  /**
   * Marks the special nodes/meshes in json for efficient parse.
   *
   * @private
   */
  _markDefs() {
    const e = this.json.nodes || [], t = this.json.skins || [], n = this.json.meshes || [];
    for (let i = 0, r = t.length; i < r; i++) {
      const a = t[i].joints;
      for (let o = 0, l = a.length; o < l; o++)
        e[a[o]].isBone = !0;
    }
    for (let i = 0, r = e.length; i < r; i++) {
      const a = e[i];
      a.mesh !== void 0 && (this._addNodeRef(this.meshCache, a.mesh), a.skin !== void 0 && (n[a.mesh].isSkinnedMesh = !0)), a.camera !== void 0 && this._addNodeRef(this.cameraCache, a.camera);
    }
  }
  /**
   * Counts references to shared node / Object3D resources. These resources
   * can be reused, or "instantiated", at multiple nodes in the scene
   * hierarchy. Mesh, Camera, and Light instances are instantiated and must
   * be marked. Non-scenegraph resources (like Materials, Geometries, and
   * Textures) can be reused directly and are not marked here.
   *
   * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
   *
   * @private
   * @param {Object} cache
   * @param {Object3D} index
   */
  _addNodeRef(e, t) {
    t !== void 0 && (e.refs[t] === void 0 && (e.refs[t] = e.uses[t] = 0), e.refs[t]++);
  }
  /**
   * Returns a reference to a shared resource, cloning it if necessary.
   *
   * @private
   * @param {Object} cache
   * @param {number} index
   * @param {Object} object
   * @return {Object}
   */
  _getNodeRef(e, t, n) {
    if (e.refs[t] <= 1) return n;
    const i = n.clone(), r = (a, o) => {
      const l = this.associations.get(a);
      l != null && this.associations.set(o, l);
      for (const [c, u] of a.children.entries())
        r(u, o.children[c]);
    };
    return r(n, i), i.name += "_instance_" + e.uses[t]++, i;
  }
  _invokeOne(e) {
    const t = Object.values(this.plugins);
    t.push(this);
    for (let n = 0; n < t.length; n++) {
      const i = e(t[n]);
      if (i) return i;
    }
    return null;
  }
  _invokeAll(e) {
    const t = Object.values(this.plugins);
    t.unshift(this);
    const n = [];
    for (let i = 0; i < t.length; i++) {
      const r = e(t[i]);
      r && n.push(r);
    }
    return n;
  }
  /**
   * Requests the specified dependency asynchronously, with caching.
   *
   * @private
   * @param {string} type
   * @param {number} index
   * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
   */
  getDependency(e, t) {
    const n = e + ":" + t;
    let i = this.cache.get(n);
    if (!i) {
      switch (e) {
        case "scene":
          i = this.loadScene(t);
          break;
        case "node":
          i = this._invokeOne(function(r) {
            return r.loadNode && r.loadNode(t);
          });
          break;
        case "mesh":
          i = this._invokeOne(function(r) {
            return r.loadMesh && r.loadMesh(t);
          });
          break;
        case "accessor":
          i = this.loadAccessor(t);
          break;
        case "bufferView":
          i = this._invokeOne(function(r) {
            return r.loadBufferView && r.loadBufferView(t);
          });
          break;
        case "buffer":
          i = this.loadBuffer(t);
          break;
        case "material":
          i = this._invokeOne(function(r) {
            return r.loadMaterial && r.loadMaterial(t);
          });
          break;
        case "texture":
          i = this._invokeOne(function(r) {
            return r.loadTexture && r.loadTexture(t);
          });
          break;
        case "skin":
          i = this.loadSkin(t);
          break;
        case "animation":
          i = this._invokeOne(function(r) {
            return r.loadAnimation && r.loadAnimation(t);
          });
          break;
        case "camera":
          i = this.loadCamera(t);
          break;
        default:
          if (i = this._invokeOne(function(r) {
            return r != this && r.getDependency && r.getDependency(e, t);
          }), !i)
            throw new Error("Unknown type: " + e);
          break;
      }
      this.cache.add(n, i);
    }
    return i;
  }
  /**
   * Requests all dependencies of the specified type asynchronously, with caching.
   *
   * @private
   * @param {string} type
   * @return {Promise<Array<Object>>}
   */
  getDependencies(e) {
    let t = this.cache.get(e);
    if (!t) {
      const n = this, i = this.json[e + (e === "mesh" ? "es" : "s")] || [];
      t = Promise.all(i.map(function(r, a) {
        return n.getDependency(e, a);
      })), this.cache.add(e, t);
    }
    return t;
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   *
   * @private
   * @param {number} bufferIndex
   * @return {Promise<ArrayBuffer>}
   */
  loadBuffer(e) {
    const t = this.json.buffers[e], n = this.fileLoader;
    if (t.type && t.type !== "arraybuffer")
      throw new Error("THREE.GLTFLoader: " + t.type + " buffer type is not supported.");
    if (t.uri === void 0 && e === 0)
      return Promise.resolve(this.extensions[rt.KHR_BINARY_GLTF].body);
    const i = this.options;
    return new Promise(function(r, a) {
      n.load(gr.resolveURL(t.uri, i.path), r, void 0, function() {
        a(new Error('THREE.GLTFLoader: Failed to load buffer "' + t.uri + '".'));
      });
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   *
   * @private
   * @param {number} bufferViewIndex
   * @return {Promise<ArrayBuffer>}
   */
  loadBufferView(e) {
    const t = this.json.bufferViews[e];
    return this.getDependency("buffer", t.buffer).then(function(n) {
      const i = t.byteLength || 0, r = t.byteOffset || 0;
      return n.slice(r, r + i);
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
   *
   * @private
   * @param {number} accessorIndex
   * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
   */
  loadAccessor(e) {
    const t = this, n = this.json, i = this.json.accessors[e];
    if (i.bufferView === void 0 && i.sparse === void 0) {
      const a = vo[i.type], o = Is[i.componentType], l = i.normalized === !0, c = new o(i.count * a);
      return Promise.resolve(new Kt(c, a, l));
    }
    const r = [];
    return i.bufferView !== void 0 ? r.push(this.getDependency("bufferView", i.bufferView)) : r.push(null), i.sparse !== void 0 && (r.push(this.getDependency("bufferView", i.sparse.indices.bufferView)), r.push(this.getDependency("bufferView", i.sparse.values.bufferView))), Promise.all(r).then(function(a) {
      const o = a[0], l = vo[i.type], c = Is[i.componentType], u = c.BYTES_PER_ELEMENT, h = u * l, d = i.byteOffset || 0, f = i.bufferView !== void 0 ? n.bufferViews[i.bufferView].byteStride : void 0, m = i.normalized === !0;
      let _, g;
      if (f && f !== h) {
        const p = Math.floor(d / f), M = "InterleavedBuffer:" + i.bufferView + ":" + i.componentType + ":" + p + ":" + i.count;
        let S = t.cache.get(M);
        S || (_ = new c(o, p * f, i.count * f / u), S = new Gh(_, f / u), t.cache.add(M, S)), g = new di(S, l, d % f / u, m);
      } else
        o === null ? _ = new c(i.count * l) : _ = new c(o, d, i.count * l), g = new Kt(_, l, m);
      if (i.sparse !== void 0) {
        const p = vo.SCALAR, M = Is[i.sparse.indices.componentType], S = i.sparse.indices.byteOffset || 0, x = i.sparse.values.byteOffset || 0, R = new M(a[1], S, i.sparse.count * p), w = new c(a[2], x, i.sparse.count * l);
        o !== null && (g = new Kt(g.array.slice(), g.itemSize, g.normalized)), g.normalized = !1;
        for (let C = 0, P = R.length; C < P; C++) {
          const b = R[C];
          if (g.setX(b, w[C * l]), l >= 2 && g.setY(b, w[C * l + 1]), l >= 3 && g.setZ(b, w[C * l + 2]), l >= 4 && g.setW(b, w[C * l + 3]), l >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
        }
        g.normalized = m;
      }
      return g;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
   *
   * @private
   * @param {number} textureIndex
   * @return {Promise<THREE.Texture|null>}
   */
  loadTexture(e) {
    const t = this.json, n = this.options, r = t.textures[e].source, a = t.images[r];
    let o = this.textureLoader;
    if (a.uri) {
      const l = n.manager.getHandler(a.uri);
      l !== null && (o = l);
    }
    return this.loadTextureImage(e, r, o);
  }
  loadTextureImage(e, t, n) {
    const i = this, r = this.json, a = r.textures[e], o = r.images[t], l = (o.uri || o.bufferView) + ":" + a.sampler;
    if (this.textureCache[l])
      return this.textureCache[l];
    const c = this.loadImageSource(t, n).then(function(u) {
      u.flipY = !1, u.name = a.name || o.name || "", u.name === "" && typeof o.uri == "string" && o.uri.startsWith("data:image/") === !1 && (u.name = o.uri);
      const d = (r.samplers || {})[a.sampler] || {};
      return u.magFilter = Vu[d.magFilter] || Vt, u.minFilter = Vu[d.minFilter] || Gn, u.wrapS = Gu[d.wrapS] || Fs, u.wrapT = Gu[d.wrapT] || Fs, u.generateMipmaps = !u.isCompressedTexture && u.minFilter !== en && u.minFilter !== Vt, i.associations.set(u, { textures: e }), u;
    }).catch(function() {
      return null;
    });
    return this.textureCache[l] = c, c;
  }
  loadImageSource(e, t) {
    const n = this, i = this.json, r = this.options;
    if (this.sourceCache[e] !== void 0)
      return this.sourceCache[e].then((h) => h.clone());
    const a = i.images[e], o = self.URL || self.webkitURL;
    let l = a.uri || "", c = !1;
    if (a.bufferView !== void 0)
      l = n.getDependency("bufferView", a.bufferView).then(function(h) {
        c = !0;
        const d = new Blob([h], { type: a.mimeType });
        return l = o.createObjectURL(d), l;
      });
    else if (a.uri === void 0)
      throw new Error("THREE.GLTFLoader: Image " + e + " is missing URI and bufferView");
    const u = Promise.resolve(l).then(function(h) {
      return new Promise(function(d, f) {
        let m = d;
        t.isImageBitmapLoader === !0 && (m = function(_) {
          const g = new Gt(_);
          g.needsUpdate = !0, d(g);
        }), t.load(gr.resolveURL(h, r.path), m, void 0, f);
      });
    }).then(function(h) {
      return c === !0 && o.revokeObjectURL(l), li(h, a), h.userData.mimeType = a.mimeType || Ev(a.uri), h;
    }).catch(function(h) {
      throw console.error("THREE.GLTFLoader: Couldn't load texture", l), h;
    });
    return this.sourceCache[e] = u, u;
  }
  /**
   * Asynchronously assigns a texture to the given material parameters.
   *
   * @private
   * @param {Object} materialParams
   * @param {string} mapName
   * @param {Object} mapDef
   * @param {string} [colorSpace]
   * @return {Promise<Texture>}
   */
  assignTexture(e, t, n, i) {
    const r = this;
    return this.getDependency("texture", n.index).then(function(a) {
      if (!a) return null;
      if (n.texCoord !== void 0 && n.texCoord > 0 && (a = a.clone(), a.channel = n.texCoord), r.extensions[rt.KHR_TEXTURE_TRANSFORM]) {
        const o = n.extensions !== void 0 ? n.extensions[rt.KHR_TEXTURE_TRANSFORM] : void 0;
        if (o) {
          const l = r.associations.get(a);
          a = r.extensions[rt.KHR_TEXTURE_TRANSFORM].extendTexture(a, o), r.associations.set(a, l);
        }
      }
      return i !== void 0 && (a.colorSpace = i), e[t] = a, a;
    });
  }
  /**
   * Assigns final material to a Mesh, Line, or Points instance. The instance
   * already has a material (generated from the glTF material options alone)
   * but reuse of the same glTF material may require multiple threejs materials
   * to accommodate different primitive types, defines, etc. New materials will
   * be created if necessary, and reused from a cache.
   *
   * @private
   * @param {Object3D} mesh Mesh, Line, or Points instance.
   */
  assignFinalMaterial(e) {
    const t = e.geometry;
    let n = e.material;
    const i = t.attributes.tangent === void 0, r = t.attributes.color !== void 0, a = t.attributes.normal === void 0;
    if (e.isPoints) {
      const o = "PointsMaterial:" + n.uuid;
      let l = this.cache.get(o);
      l || (l = new qh(), qn.prototype.copy.call(l, n), l.color.copy(n.color), l.map = n.map, l.sizeAttenuation = !1, this.cache.add(o, l)), n = l;
    } else if (e.isLine) {
      const o = "LineBasicMaterial:" + n.uuid;
      let l = this.cache.get(o);
      l || (l = new Xh(), qn.prototype.copy.call(l, n), l.color.copy(n.color), l.map = n.map, this.cache.add(o, l)), n = l;
    }
    if (i || r || a) {
      let o = "ClonedMaterial:" + n.uuid + ":";
      i && (o += "derivative-tangents:"), r && (o += "vertex-colors:"), a && (o += "flat-shading:");
      let l = this.cache.get(o);
      l || (l = n.clone(), r && (l.vertexColors = !0), a && (l.flatShading = !0), i && (l.normalScale && (l.normalScale.y *= -1), l.clearcoatNormalScale && (l.clearcoatNormalScale.y *= -1)), this.cache.add(o, l), this.associations.set(l, this.associations.get(n))), n = l;
    }
    e.material = n;
  }
  getMaterialType() {
    return Kn;
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
   *
   * @private
   * @param {number} materialIndex
   * @return {Promise<Material>}
   */
  loadMaterial(e) {
    const t = this, n = this.json, i = this.extensions, r = n.materials[e];
    let a;
    const o = {}, l = r.extensions || {}, c = [];
    if (l[rt.KHR_MATERIALS_UNLIT]) {
      const h = i[rt.KHR_MATERIALS_UNLIT];
      a = h.getMaterialType(), c.push(h.extendParams(o, r, t));
    } else {
      const h = r.pbrMetallicRoughness || {};
      if (o.color = new He(1, 1, 1), o.opacity = 1, Array.isArray(h.baseColorFactor)) {
        const d = h.baseColorFactor;
        o.color.setRGB(d[0], d[1], d[2], Zt), o.opacity = d[3];
      }
      h.baseColorTexture !== void 0 && c.push(t.assignTexture(o, "map", h.baseColorTexture, Dt)), o.metalness = h.metallicFactor !== void 0 ? h.metallicFactor : 1, o.roughness = h.roughnessFactor !== void 0 ? h.roughnessFactor : 1, h.metallicRoughnessTexture !== void 0 && (c.push(t.assignTexture(o, "metalnessMap", h.metallicRoughnessTexture)), c.push(t.assignTexture(o, "roughnessMap", h.metallicRoughnessTexture))), a = this._invokeOne(function(d) {
        return d.getMaterialType && d.getMaterialType(e);
      }), c.push(Promise.all(this._invokeAll(function(d) {
        return d.extendMaterialParams && d.extendMaterialParams(e, o);
      })));
    }
    r.doubleSided === !0 && (o.side = In);
    const u = r.alphaMode || yo.OPAQUE;
    if (u === yo.BLEND ? (o.transparent = !0, o.depthWrite = !1) : (o.transparent = !1, u === yo.MASK && (o.alphaTest = r.alphaCutoff !== void 0 ? r.alphaCutoff : 0.5)), r.normalTexture !== void 0 && a !== hi && (c.push(t.assignTexture(o, "normalMap", r.normalTexture)), o.normalScale = new ze(1, 1), r.normalTexture.scale !== void 0)) {
      const h = r.normalTexture.scale;
      o.normalScale.set(h, h);
    }
    if (r.occlusionTexture !== void 0 && a !== hi && (c.push(t.assignTexture(o, "aoMap", r.occlusionTexture)), r.occlusionTexture.strength !== void 0 && (o.aoMapIntensity = r.occlusionTexture.strength)), r.emissiveFactor !== void 0 && a !== hi) {
      const h = r.emissiveFactor;
      o.emissive = new He().setRGB(h[0], h[1], h[2], Zt);
    }
    return r.emissiveTexture !== void 0 && a !== hi && c.push(t.assignTexture(o, "emissiveMap", r.emissiveTexture, Dt)), Promise.all(c).then(function() {
      const h = new a(o);
      return r.name && (h.name = r.name), li(h, r), t.associations.set(h, { materials: e }), r.extensions && Xi(i, h, r), h;
    });
  }
  /**
   * When Object3D instances are targeted by animation, they need unique names.
   *
   * @private
   * @param {string} originalName
   * @return {string}
   */
  createUniqueName(e) {
    const t = gt.sanitizeNodeName(e || "");
    return t in this.nodeNamesUsed ? t + "_" + ++this.nodeNamesUsed[t] : (this.nodeNamesUsed[t] = 0, t);
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
   *
   * Creates BufferGeometries from primitives.
   *
   * @private
   * @param {Array<GLTF.Primitive>} primitives
   * @return {Promise<Array<BufferGeometry>>}
   */
  loadGeometries(e) {
    const t = this, n = this.extensions, i = this.primitiveCache;
    function r(o) {
      return n[rt.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(o, t).then(function(l) {
        return Wu(l, o, t);
      });
    }
    const a = [];
    for (let o = 0, l = e.length; o < l; o++) {
      const c = e[o], u = bv(c), h = i[u];
      if (h)
        a.push(h.promise);
      else {
        let d;
        c.extensions && c.extensions[rt.KHR_DRACO_MESH_COMPRESSION] ? d = r(c) : d = Wu(new _n(), c, t), i[u] = { primitive: c, promise: d }, a.push(d);
      }
    }
    return Promise.all(a);
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
   *
   * @private
   * @param {number} meshIndex
   * @return {Promise<Group|Mesh|SkinnedMesh|Line|Points>}
   */
  loadMesh(e) {
    const t = this, n = this.json, i = this.extensions, r = n.meshes[e], a = r.primitives, o = [];
    for (let l = 0, c = a.length; l < c; l++) {
      const u = a[l].material === void 0 ? yv(this.cache) : this.getDependency("material", a[l].material);
      o.push(u);
    }
    return o.push(t.loadGeometries(a)), Promise.all(o).then(function(l) {
      const c = l.slice(0, l.length - 1), u = l[l.length - 1], h = [];
      for (let f = 0, m = u.length; f < m; f++) {
        const _ = u[f], g = a[f];
        let p;
        const M = c[f];
        if (g.mode === yn.TRIANGLES || g.mode === yn.TRIANGLE_STRIP || g.mode === yn.TRIANGLE_FAN || g.mode === void 0)
          p = r.isSkinnedMesh === !0 ? new np(_, M) : new xt(_, M), p.isSkinnedMesh === !0 && p.normalizeSkinWeights(), g.mode === yn.TRIANGLE_STRIP ? p.geometry = ku(p.geometry, Lh) : g.mode === yn.TRIANGLE_FAN && (p.geometry = ku(p.geometry, xl));
        else if (g.mode === yn.LINES)
          p = new lp(_, M);
        else if (g.mode === yn.LINE_STRIP)
          p = new Kl(_, M);
        else if (g.mode === yn.LINE_LOOP)
          p = new cp(_, M);
        else if (g.mode === yn.POINTS)
          p = new up(_, M);
        else
          throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + g.mode);
        Object.keys(p.geometry.morphAttributes).length > 0 && Mv(p, r), p.name = t.createUniqueName(r.name || "mesh_" + e), li(p, r), g.extensions && Xi(i, p, g), t.assignFinalMaterial(p), h.push(p);
      }
      for (let f = 0, m = h.length; f < m; f++)
        t.associations.set(h[f], {
          meshes: e,
          primitives: f
        });
      if (h.length === 1)
        return r.extensions && Xi(i, h[0], r), h[0];
      const d = new Xn();
      r.extensions && Xi(i, d, r), t.associations.set(d, { meshes: e });
      for (let f = 0, m = h.length; f < m; f++)
        d.add(h[f]);
      return d;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
   *
   * @private
   * @param {number} cameraIndex
   * @return {Promise<THREE.Camera>}
   */
  loadCamera(e) {
    let t;
    const n = this.json.cameras[e], i = n[n.type];
    if (!i) {
      console.warn("THREE.GLTFLoader: Missing camera parameters.");
      return;
    }
    return n.type === "perspective" ? t = new rn(Vl.radToDeg(i.yfov), i.aspectRatio || 1, i.znear || 1, i.zfar || 2e6) : n.type === "orthographic" && (t = new Ia(-i.xmag, i.xmag, i.ymag, -i.ymag, i.znear, i.zfar)), n.name && (t.name = this.createUniqueName(n.name)), li(t, n), Promise.resolve(t);
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
   *
   * @private
   * @param {number} skinIndex
   * @return {Promise<Skeleton>}
   */
  loadSkin(e) {
    const t = this.json.skins[e], n = [];
    for (let i = 0, r = t.joints.length; i < r; i++)
      n.push(this._loadNodeShallow(t.joints[i]));
    return t.inverseBindMatrices !== void 0 ? n.push(this.getDependency("accessor", t.inverseBindMatrices)) : n.push(null), Promise.all(n).then(function(i) {
      const r = i.pop(), a = i, o = [], l = [];
      for (let c = 0, u = a.length; c < u; c++) {
        const h = a[c];
        if (h) {
          o.push(h);
          const d = new Ye();
          r !== null && d.fromArray(r.array, c * 16), l.push(d);
        } else
          console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', t.joints[c]);
      }
      return new Yl(o, l);
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
   *
   * @private
   * @param {number} animationIndex
   * @return {Promise<AnimationClip>}
   */
  loadAnimation(e) {
    const t = this.json, n = this, i = t.animations[e], r = i.name ? i.name : "animation_" + e, a = [], o = [], l = [], c = [], u = [];
    for (let h = 0, d = i.channels.length; h < d; h++) {
      const f = i.channels[h], m = i.samplers[f.sampler], _ = f.target, g = _.node, p = i.parameters !== void 0 ? i.parameters[m.input] : m.input, M = i.parameters !== void 0 ? i.parameters[m.output] : m.output;
      _.node !== void 0 && (a.push(this.getDependency("node", g)), o.push(this.getDependency("accessor", p)), l.push(this.getDependency("accessor", M)), c.push(m), u.push(_));
    }
    return Promise.all([
      Promise.all(a),
      Promise.all(o),
      Promise.all(l),
      Promise.all(c),
      Promise.all(u)
    ]).then(function(h) {
      const d = h[0], f = h[1], m = h[2], _ = h[3], g = h[4], p = [];
      for (let M = 0, S = d.length; M < S; M++) {
        const x = d[M], R = f[M], w = m[M], C = _[M], P = g[M];
        if (x === void 0) continue;
        x.updateMatrix && x.updateMatrix();
        const b = n._createAnimationTracks(x, R, w, C, P);
        if (b)
          for (let y = 0; y < b.length; y++)
            p.push(b[y]);
      }
      return new Ra(r, void 0, p);
    });
  }
  createNodeMesh(e) {
    const t = this.json, n = this, i = t.nodes[e];
    return i.mesh === void 0 ? null : n.getDependency("mesh", i.mesh).then(function(r) {
      const a = n._getNodeRef(n.meshCache, i.mesh, r);
      return i.weights !== void 0 && a.traverse(function(o) {
        if (o.isMesh)
          for (let l = 0, c = i.weights.length; l < c; l++)
            o.morphTargetInfluences[l] = i.weights[l];
      }), a;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
   *
   * @private
   * @param {number} nodeIndex
   * @return {Promise<Object3D>}
   */
  loadNode(e) {
    const t = this.json, n = this, i = t.nodes[e], r = n._loadNodeShallow(e), a = [], o = i.children || [];
    for (let c = 0, u = o.length; c < u; c++)
      a.push(n.getDependency("node", o[c]));
    const l = i.skin === void 0 ? Promise.resolve(null) : n.getDependency("skin", i.skin);
    return Promise.all([
      r,
      Promise.all(a),
      l
    ]).then(function(c) {
      const u = c[0], h = c[1], d = c[2];
      d !== null && u.traverse(function(f) {
        f.isSkinnedMesh && f.bind(d, Tv);
      });
      for (let f = 0, m = h.length; f < m; f++)
        u.add(h[f]);
      return u;
    });
  }
  // ._loadNodeShallow() parses a single node.
  // skin and child nodes are created and added in .loadNode() (no '_' prefix).
  _loadNodeShallow(e) {
    const t = this.json, n = this.extensions, i = this;
    if (this.nodeCache[e] !== void 0)
      return this.nodeCache[e];
    const r = t.nodes[e], a = r.name ? i.createUniqueName(r.name) : "", o = [], l = i._invokeOne(function(c) {
      return c.createNodeMesh && c.createNodeMesh(e);
    });
    return l && o.push(l), r.camera !== void 0 && o.push(i.getDependency("camera", r.camera).then(function(c) {
      return i._getNodeRef(i.cameraCache, r.camera, c);
    })), i._invokeAll(function(c) {
      return c.createNodeAttachment && c.createNodeAttachment(e);
    }).forEach(function(c) {
      o.push(c);
    }), this.nodeCache[e] = Promise.all(o).then(function(c) {
      let u;
      if (r.isBone === !0 ? u = new Wh() : c.length > 1 ? u = new Xn() : c.length === 1 ? u = c[0] : u = new bt(), u !== c[0])
        for (let h = 0, d = c.length; h < d; h++)
          u.add(c[h]);
      if (r.name && (u.userData.name = r.name, u.name = a), li(u, r), r.extensions && Xi(n, u, r), r.matrix !== void 0) {
        const h = new Ye();
        h.fromArray(r.matrix), u.applyMatrix4(h);
      } else
        r.translation !== void 0 && u.position.fromArray(r.translation), r.rotation !== void 0 && u.quaternion.fromArray(r.rotation), r.scale !== void 0 && u.scale.fromArray(r.scale);
      return i.associations.has(u) || i.associations.set(u, {}), i.associations.get(u).nodes = e, u;
    }), this.nodeCache[e];
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
   *
   * @private
   * @param {number} sceneIndex
   * @return {Promise<Group>}
   */
  loadScene(e) {
    const t = this.extensions, n = this.json.scenes[e], i = this, r = new Xn();
    n.name && (r.name = i.createUniqueName(n.name)), li(r, n), n.extensions && Xi(t, r, n);
    const a = n.nodes || [], o = [];
    for (let l = 0, c = a.length; l < c; l++)
      o.push(i.getDependency("node", a[l]));
    return Promise.all(o).then(function(l) {
      for (let u = 0, h = l.length; u < h; u++)
        r.add(l[u]);
      const c = (u) => {
        const h = /* @__PURE__ */ new Map();
        for (const [d, f] of i.associations)
          (d instanceof qn || d instanceof Gt) && h.set(d, f);
        return u.traverse((d) => {
          const f = i.associations.get(d);
          f != null && h.set(d, f);
        }), h;
      };
      return i.associations = c(r), r;
    });
  }
  _createAnimationTracks(e, t, n, i, r) {
    const a = [], o = e.name ? e.name : e.uuid, l = [];
    Ti[r.path] === Ti.weights ? e.traverse(function(d) {
      d.morphTargetInfluences && l.push(d.name ? d.name : d.uuid);
    }) : l.push(o);
    let c;
    switch (Ti[r.path]) {
      case Ti.weights:
        c = ks;
        break;
      case Ti.rotation:
        c = zs;
        break;
      case Ti.translation:
      case Ti.scale:
        c = Hs;
        break;
      default:
        switch (n.itemSize) {
          case 1:
            c = ks;
            break;
          case 2:
          case 3:
          default:
            c = Hs;
            break;
        }
        break;
    }
    const u = i.interpolation !== void 0 ? vv[i.interpolation] : Mr, h = this._getArrayFromAccessor(n);
    for (let d = 0, f = l.length; d < f; d++) {
      const m = new c(
        l[d] + "." + Ti[r.path],
        t.array,
        h,
        u
      );
      i.interpolation === "CUBICSPLINE" && this._createCubicSplineTrackInterpolant(m), a.push(m);
    }
    return a;
  }
  _getArrayFromAccessor(e) {
    let t = e.array;
    if (e.normalized) {
      const n = wl(t.constructor), i = new Float32Array(t.length);
      for (let r = 0, a = t.length; r < a; r++)
        i[r] = t[r] * n;
      t = i;
    }
    return t;
  }
  _createCubicSplineTrackInterpolant(e) {
    e.createInterpolant = function(n) {
      const i = this instanceof zs ? xv : sd;
      return new i(this.times, this.values, this.getValueSize() / 3, n);
    }, e.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = !0;
  }
}
function wv(s, e, t) {
  const n = e.attributes, i = new Mt();
  if (n.POSITION !== void 0) {
    const o = t.json.accessors[n.POSITION], l = o.min, c = o.max;
    if (l !== void 0 && c !== void 0) {
      if (i.set(
        new T(l[0], l[1], l[2]),
        new T(c[0], c[1], c[2])
      ), o.normalized) {
        const u = wl(Is[o.componentType]);
        i.min.multiplyScalar(u), i.max.multiplyScalar(u);
      }
    } else {
      console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
      return;
    }
  } else
    return;
  const r = e.targets;
  if (r !== void 0) {
    const o = new T(), l = new T();
    for (let c = 0, u = r.length; c < u; c++) {
      const h = r[c];
      if (h.POSITION !== void 0) {
        const d = t.json.accessors[h.POSITION], f = d.min, m = d.max;
        if (f !== void 0 && m !== void 0) {
          if (l.setX(Math.max(Math.abs(f[0]), Math.abs(m[0]))), l.setY(Math.max(Math.abs(f[1]), Math.abs(m[1]))), l.setZ(Math.max(Math.abs(f[2]), Math.abs(m[2]))), d.normalized) {
            const _ = wl(Is[d.componentType]);
            l.multiplyScalar(_);
          }
          o.max(l);
        } else
          console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
      }
    }
    i.expandByVector(o);
  }
  s.boundingBox = i;
  const a = new Mn();
  i.getCenter(a.center), a.radius = i.min.distanceTo(i.max) / 2, s.boundingSphere = a;
}
function Wu(s, e, t) {
  const n = e.attributes, i = [];
  function r(a, o) {
    return t.getDependency("accessor", a).then(function(l) {
      s.setAttribute(o, l);
    });
  }
  for (const a in n) {
    const o = Al[a] || a.toLowerCase();
    o in s.attributes || i.push(r(n[a], o));
  }
  if (e.indices !== void 0 && !s.index) {
    const a = t.getDependency("accessor", e.indices).then(function(o) {
      s.setIndex(o);
    });
    i.push(a);
  }
  return ot.workingColorSpace !== Zt && "COLOR_0" in n && console.warn(`THREE.GLTFLoader: Converting vertex colors from "srgb-linear" to "${ot.workingColorSpace}" not supported.`), li(s, e), wv(s, e, t), Promise.all(i).then(function() {
    return e.targets !== void 0 ? Sv(s, e.targets, t) : s;
  });
}
const Mo = /* @__PURE__ */ new WeakMap();
class Rv extends Fi {
  /**
   * Constructs a new Draco loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(e) {
    super(e), this.decoderPath = "", this.decoderConfig = {}, this.decoderBinary = null, this.decoderPending = null, this.workerLimit = 4, this.workerPool = [], this.workerNextTaskID = 1, this.workerSourceURL = "", this.defaultAttributeIDs = {
      position: "POSITION",
      normal: "NORMAL",
      color: "COLOR",
      uv: "TEX_COORD"
    }, this.defaultAttributeTypes = {
      position: "Float32Array",
      normal: "Float32Array",
      color: "Float32Array",
      uv: "Float32Array"
    };
  }
  /**
   * Provides configuration for the decoder libraries. Configuration cannot be changed after decoding begins.
   *
   * @param {string} path - The decoder path.
   * @return {DRACOLoader} A reference to this loader.
   */
  setDecoderPath(e) {
    return this.decoderPath = e, this;
  }
  /**
   * Provides configuration for the decoder libraries. Configuration cannot be changed after decoding begins.
   *
   * @param {{type:('js'|'wasm')}} config - The decoder config.
   * @return {DRACOLoader} A reference to this loader.
   */
  setDecoderConfig(e) {
    return this.decoderConfig = e, this;
  }
  /**
   * Sets the maximum number of Web Workers to be used during decoding.
   * A lower limit may be preferable if workers are also for other tasks in the application.
   *
   * @param {number} workerLimit - The worker limit.
   * @return {DRACOLoader} A reference to this loader.
   */
  setWorkerLimit(e) {
    return this.workerLimit = e, this;
  }
  /**
   * Starts loading from the given URL and passes the loaded Draco asset
   * to the `onLoad()` callback.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(BufferGeometry)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
   * @param {onErrorCallback} onError - Executed when errors occur.
   */
  load(e, t, n, i) {
    const r = new Er(this.manager);
    r.setPath(this.path), r.setResponseType("arraybuffer"), r.setRequestHeader(this.requestHeader), r.setWithCredentials(this.withCredentials), r.load(e, (a) => {
      this.parse(a, t, i);
    }, n, i);
  }
  /**
   * Parses the given Draco data.
   *
   * @param {ArrayBuffer} buffer - The raw Draco data as an array buffer.
   * @param {function(BufferGeometry)} onLoad - Executed when the loading/parsing process has been finished.
   * @param {onErrorCallback} onError - Executed when errors occur.
   */
  parse(e, t, n = () => {
  }) {
    this.decodeDracoFile(e, t, null, null, Dt, n).catch(n);
  }
  //
  decodeDracoFile(e, t, n, i, r = Zt, a = () => {
  }) {
    const o = {
      attributeIDs: n || this.defaultAttributeIDs,
      attributeTypes: i || this.defaultAttributeTypes,
      useUniqueIDs: !!n,
      vertexColorSpace: r
    };
    return this.decodeGeometry(e, o).then(t).catch(a);
  }
  decodeGeometry(e, t) {
    const n = JSON.stringify(t);
    if (Mo.has(e)) {
      const l = Mo.get(e);
      if (l.key === n)
        return l.promise;
      if (e.byteLength === 0)
        throw new Error(
          "THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred."
        );
    }
    let i;
    const r = this.workerNextTaskID++, a = e.byteLength, o = this._getWorker(r, a).then((l) => (i = l, new Promise((c, u) => {
      i._callbacks[r] = { resolve: c, reject: u }, i.postMessage({ type: "decode", id: r, taskConfig: t, buffer: e }, [e]);
    }))).then((l) => this._createGeometry(l.geometry));
    return o.catch(() => !0).then(() => {
      i && r && this._releaseTask(i, r);
    }), Mo.set(e, {
      key: n,
      promise: o
    }), o;
  }
  _createGeometry(e) {
    const t = new _n();
    e.index && t.setIndex(new Kt(e.index.array, 1));
    for (let n = 0; n < e.attributes.length; n++) {
      const i = e.attributes[n], r = i.name, a = i.array, o = i.itemSize, l = new Kt(a, o);
      r === "color" && (this._assignVertexColorSpace(l, i.vertexColorSpace), l.normalized = !(a instanceof Float32Array)), t.setAttribute(r, l);
    }
    return t;
  }
  _assignVertexColorSpace(e, t) {
    if (t !== Dt) return;
    const n = new He();
    for (let i = 0, r = e.count; i < r; i++)
      n.fromBufferAttribute(e, i), ot.toWorkingColorSpace(n, Dt), e.setXYZ(i, n.r, n.g, n.b);
  }
  _loadLibrary(e, t) {
    const n = new Er(this.manager);
    return n.setPath(this.decoderPath), n.setResponseType(t), n.setWithCredentials(this.withCredentials), new Promise((i, r) => {
      n.load(e, i, void 0, r);
    });
  }
  preload() {
    return this._initDecoder(), this;
  }
  _initDecoder() {
    if (this.decoderPending) return this.decoderPending;
    const e = typeof WebAssembly != "object" || this.decoderConfig.type === "js", t = [];
    return e ? t.push(this._loadLibrary("draco_decoder.js", "text")) : (t.push(this._loadLibrary("draco_wasm_wrapper.js", "text")), t.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"))), this.decoderPending = Promise.all(t).then((n) => {
      const i = n[0];
      e || (this.decoderConfig.wasmBinary = n[1]);
      const r = Cv.toString(), a = [
        "/* draco decoder */",
        i,
        "",
        "/* worker */",
        r.substring(r.indexOf("{") + 1, r.lastIndexOf("}"))
      ].join(`
`);
      this.workerSourceURL = URL.createObjectURL(new Blob([a]));
    }), this.decoderPending;
  }
  _getWorker(e, t) {
    return this._initDecoder().then(() => {
      if (this.workerPool.length < this.workerLimit) {
        const i = new Worker(this.workerSourceURL);
        i._callbacks = {}, i._taskCosts = {}, i._taskLoad = 0, i.postMessage({ type: "init", decoderConfig: this.decoderConfig }), i.onmessage = function(r) {
          const a = r.data;
          switch (a.type) {
            case "decode":
              i._callbacks[a.id].resolve(a);
              break;
            case "error":
              i._callbacks[a.id].reject(a);
              break;
            default:
              console.error('THREE.DRACOLoader: Unexpected message, "' + a.type + '"');
          }
        }, this.workerPool.push(i);
      } else
        this.workerPool.sort(function(i, r) {
          return i._taskLoad > r._taskLoad ? -1 : 1;
        });
      const n = this.workerPool[this.workerPool.length - 1];
      return n._taskCosts[e] = t, n._taskLoad += t, n;
    });
  }
  _releaseTask(e, t) {
    e._taskLoad -= e._taskCosts[t], delete e._callbacks[t], delete e._taskCosts[t];
  }
  debug() {
    console.log("Task load: ", this.workerPool.map((e) => e._taskLoad));
  }
  dispose() {
    for (let e = 0; e < this.workerPool.length; ++e)
      this.workerPool[e].terminate();
    return this.workerPool.length = 0, this.workerSourceURL !== "" && URL.revokeObjectURL(this.workerSourceURL), this;
  }
}
function Cv() {
  let s, e;
  onmessage = function(a) {
    const o = a.data;
    switch (o.type) {
      case "init":
        s = o.decoderConfig, e = new Promise(function(u) {
          s.onModuleLoaded = function(h) {
            u({ draco: h });
          }, DracoDecoderModule(s);
        });
        break;
      case "decode":
        const l = o.buffer, c = o.taskConfig;
        e.then((u) => {
          const h = u.draco, d = new h.Decoder();
          try {
            const f = t(h, d, new Int8Array(l), c), m = f.attributes.map((_) => _.array.buffer);
            f.index && m.push(f.index.array.buffer), self.postMessage({ type: "decode", id: o.id, geometry: f }, m);
          } catch (f) {
            console.error(f), self.postMessage({ type: "error", id: o.id, error: f.message });
          } finally {
            h.destroy(d);
          }
        });
        break;
    }
  };
  function t(a, o, l, c) {
    const u = c.attributeIDs, h = c.attributeTypes;
    let d, f;
    const m = o.GetEncodedGeometryType(l);
    if (m === a.TRIANGULAR_MESH)
      d = new a.Mesh(), f = o.DecodeArrayToMesh(l, l.byteLength, d);
    else if (m === a.POINT_CLOUD)
      d = new a.PointCloud(), f = o.DecodeArrayToPointCloud(l, l.byteLength, d);
    else
      throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
    if (!f.ok() || d.ptr === 0)
      throw new Error("THREE.DRACOLoader: Decoding failed: " + f.error_msg());
    const _ = { index: null, attributes: [] };
    for (const g in u) {
      const p = self[h[g]];
      let M, S;
      if (c.useUniqueIDs)
        S = u[g], M = o.GetAttributeByUniqueId(d, S);
      else {
        if (S = o.GetAttributeId(d, a[u[g]]), S === -1) continue;
        M = o.GetAttribute(d, S);
      }
      const x = i(a, o, d, g, p, M);
      g === "color" && (x.vertexColorSpace = c.vertexColorSpace), _.attributes.push(x);
    }
    return m === a.TRIANGULAR_MESH && (_.index = n(a, o, d)), a.destroy(d), _;
  }
  function n(a, o, l) {
    const u = l.num_faces() * 3, h = u * 4, d = a._malloc(h);
    o.GetTrianglesUInt32Array(l, h, d);
    const f = new Uint32Array(a.HEAPF32.buffer, d, u).slice();
    return a._free(d), { array: f, itemSize: 1 };
  }
  function i(a, o, l, c, u, h) {
    const d = h.num_components(), m = l.num_points() * d, _ = m * u.BYTES_PER_ELEMENT, g = r(a, u), p = a._malloc(_);
    o.GetAttributeDataArrayForAllPoints(l, h, g, _, p);
    const M = new u(a.HEAPF32.buffer, p, m).slice();
    return a._free(p), {
      name: c,
      array: M,
      itemSize: d
    };
  }
  function r(a, o) {
    switch (o) {
      case Float32Array:
        return a.DT_FLOAT32;
      case Int8Array:
        return a.DT_INT8;
      case Int16Array:
        return a.DT_INT16;
      case Int32Array:
        return a.DT_INT32;
      case Uint8Array:
        return a.DT_UINT8;
      case Uint16Array:
        return a.DT_UINT16;
      case Uint32Array:
        return a.DT_UINT32;
    }
  }
}
class Pv extends Tp {
  /**
   * Constructs a new RGBE loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(e) {
    super(e), this.type = Wn;
  }
  /**
   * Parses the given RGBE texture data.
   *
   * @param {ArrayBuffer} buffer - The raw texture data.
   * @return {DataTextureLoader~TexData} An object representing the parsed texture data.
   */
  parse(e) {
    const a = function(P, b) {
      switch (P) {
        case 1:
          throw new Error("THREE.RGBELoader: Read Error: " + (b || ""));
        case 2:
          throw new Error("THREE.RGBELoader: Write Error: " + (b || ""));
        case 3:
          throw new Error("THREE.RGBELoader: Bad File Format: " + (b || ""));
        default:
        case 4:
          throw new Error("THREE.RGBELoader: Memory Error: " + (b || ""));
      }
    }, h = function(P, b, y) {
      b = b || 1024;
      let O = P.pos, U = -1, N = 0, Y = "", G = String.fromCharCode.apply(null, new Uint16Array(P.subarray(O, O + 128)));
      for (; 0 > (U = G.indexOf(`
`)) && N < b && O < P.byteLength; )
        Y += G, N += G.length, O += 128, G += String.fromCharCode.apply(null, new Uint16Array(P.subarray(O, O + 128)));
      return -1 < U ? (P.pos += N + U + 1, Y + G.slice(0, U)) : !1;
    }, d = function(P) {
      const b = /^#\?(\S+)/, y = /^\s*GAMMA\s*=\s*(\d+(\.\d+)?)\s*$/, L = /^\s*EXPOSURE\s*=\s*(\d+(\.\d+)?)\s*$/, O = /^\s*FORMAT=(\S+)\s*$/, U = /^\s*\-Y\s+(\d+)\s+\+X\s+(\d+)\s*$/, N = {
        valid: 0,
        /* indicate which fields are valid */
        string: "",
        /* the actual header string */
        comments: "",
        /* comments found in header */
        programtype: "RGBE",
        /* listed at beginning of file to identify it after "#?". defaults to "RGBE" */
        format: "",
        /* RGBE format, default 32-bit_rle_rgbe */
        gamma: 1,
        /* image has already been gamma corrected with given gamma. defaults to 1.0 (no correction) */
        exposure: 1,
        /* a value of 1.0 in an image corresponds to <exposure> watts/steradian/m^2. defaults to 1.0 */
        width: 0,
        height: 0
        /* image dimensions, width/height */
      };
      let Y, G;
      for ((P.pos >= P.byteLength || !(Y = h(P))) && a(1, "no header found"), (G = Y.match(b)) || a(3, "bad initial token"), N.valid |= 1, N.programtype = G[1], N.string += Y + `
`; Y = h(P), Y !== !1; ) {
        if (N.string += Y + `
`, Y.charAt(0) === "#") {
          N.comments += Y + `
`;
          continue;
        }
        if ((G = Y.match(y)) && (N.gamma = parseFloat(G[1])), (G = Y.match(L)) && (N.exposure = parseFloat(G[1])), (G = Y.match(O)) && (N.valid |= 2, N.format = G[1]), (G = Y.match(U)) && (N.valid |= 4, N.height = parseInt(G[1], 10), N.width = parseInt(G[2], 10)), N.valid & 2 && N.valid & 4) break;
      }
      return N.valid & 2 || a(3, "missing format specifier"), N.valid & 4 || a(3, "missing image size specifier"), N;
    }, f = function(P, b, y) {
      const L = b;
      if (
        // run length encoding is not allowed so read flat
        L < 8 || L > 32767 || // this file is not run length encoded
        P[0] !== 2 || P[1] !== 2 || P[2] & 128
      )
        return new Uint8Array(P);
      L !== (P[2] << 8 | P[3]) && a(3, "wrong scanline width");
      const O = new Uint8Array(4 * b * y);
      O.length || a(4, "unable to allocate buffer space");
      let U = 0, N = 0;
      const Y = 4 * L, G = new Uint8Array(4), ne = new Uint8Array(Y);
      let B = y;
      for (; B > 0 && N < P.byteLength; ) {
        N + 4 > P.byteLength && a(1), G[0] = P[N++], G[1] = P[N++], G[2] = P[N++], G[3] = P[N++], (G[0] != 2 || G[1] != 2 || (G[2] << 8 | G[3]) != L) && a(3, "bad rgbe scanline format");
        let Z = 0, Q;
        for (; Z < Y && N < P.byteLength; ) {
          Q = P[N++];
          const ye = Q > 128;
          if (ye && (Q -= 128), (Q === 0 || Z + Q > Y) && a(3, "bad scanline data"), ye) {
            const ce = P[N++];
            for (let V = 0; V < Q; V++)
              ne[Z++] = ce;
          } else
            ne.set(P.subarray(N, N + Q), Z), Z += Q, N += Q;
        }
        const xe = L;
        for (let ye = 0; ye < xe; ye++) {
          let ce = 0;
          O[U] = ne[ye + ce], ce += L, O[U + 1] = ne[ye + ce], ce += L, O[U + 2] = ne[ye + ce], ce += L, O[U + 3] = ne[ye + ce], U += 4;
        }
        B--;
      }
      return O;
    }, m = function(P, b, y, L) {
      const O = P[b + 3], U = Math.pow(2, O - 128) / 255;
      y[L + 0] = P[b + 0] * U, y[L + 1] = P[b + 1] * U, y[L + 2] = P[b + 2] * U, y[L + 3] = 1;
    }, _ = function(P, b, y, L) {
      const O = P[b + 3], U = Math.pow(2, O - 128) / 255;
      y[L + 0] = kr.toHalfFloat(Math.min(P[b + 0] * U, 65504)), y[L + 1] = kr.toHalfFloat(Math.min(P[b + 1] * U, 65504)), y[L + 2] = kr.toHalfFloat(Math.min(P[b + 2] * U, 65504)), y[L + 3] = kr.toHalfFloat(1);
    }, g = new Uint8Array(e);
    g.pos = 0;
    const p = d(g), M = p.width, S = p.height, x = f(g.subarray(g.pos), M, S);
    let R, w, C;
    switch (this.type) {
      case hn:
        C = x.length / 4;
        const P = new Float32Array(C * 4);
        for (let y = 0; y < C; y++)
          m(x, y * 4, P, y * 4);
        R = P, w = hn;
        break;
      case Wn:
        C = x.length / 4;
        const b = new Uint16Array(C * 4);
        for (let y = 0; y < C; y++)
          _(x, y * 4, b, y * 4);
        R = b, w = Wn;
        break;
      default:
        throw new Error("THREE.RGBELoader: Unsupported type: " + this.type);
    }
    return {
      width: M,
      height: S,
      data: R,
      header: p.string,
      gamma: p.gamma,
      exposure: p.exposure,
      type: w
    };
  }
  /**
   * Sets the texture type.
   *
   * @param {(HalfFloatType|FloatType)} value - The texture type to set.
   * @return {RGBELoader} A reference to this loader.
   */
  setDataType(e) {
    return this.type = e, this;
  }
  load(e, t, n, i) {
    function r(a, o) {
      switch (a.type) {
        case hn:
        case Wn:
          a.colorSpace = Zt, a.minFilter = Vt, a.magFilter = Vt, a.generateMipmaps = !1, a.flipY = !0;
          break;
      }
      t && t(a, o);
    }
    return super.load(e, r, n, i);
  }
}
const Lv = "Bathtub_Overflow_Material", rd = 0.8, Iv = 0.9, dr = {
  matte_white: { color: 16052974, roughness: 0.92, metalness: 0.02, envMapIntensity: 0.35 },
  glossy_white: { color: 16316146, roughness: 0, metalness: 0.06, envMapIntensity: 1.15 },
  matte_black: { color: 1710618, roughness: 0.9, metalness: 0.03, envMapIntensity: 0.3 },
  glossy_black: { color: 2236962, roughness: 0, metalness: 0.1, envMapIntensity: 1.1 },
  matte_grey: { color: 9079432, roughness: 0.9, metalness: 0.02, envMapIntensity: 0.35 },
  glossy_grey: { color: 10132120, roughness: 0, metalness: 0.08, envMapIntensity: 1.1 }
}, nc = {
  color: 12105912,
  roughness: 0.7,
  metalness: 1,
  envMapIntensity: 0.8
}, Xu = {
  ...nc,
  roughness: 0.4
}, qu = {
  chrome: { color: 15592941, roughness: 0.08, metalness: 0.98, envMapIntensity: 1.65 },
  brushed_steel: { ...nc },
  brushed_copper: { color: 12088115, roughness: 0.34, metalness: 0.9, envMapIntensity: 1.15 },
  matte_black: { color: 1842204, roughness: 0.75, metalness: 0.55, envMapIntensity: 0.45 },
  brushed_nickel: { color: 12104874, roughness: 0.38, metalness: 0.88, envMapIntensity: 1.1 },
  // Lower roughness than faucet gold — shinier basin / drain gold finishes.
  brushed_gold: { color: 13216098, roughness: 0.18, metalness: 0.9, envMapIntensity: 1.15 },
  // #DABA9D — shared rose gold for metal-basin category (do not duplicate).
  brushed_rose_gold: { color: 14334621, roughness: 0.18, metalness: 0.88, envMapIntensity: 1.1 },
  matte_white: { color: 15789802, roughness: 0.88, metalness: 0.05, envMapIntensity: 0.35 },
  glossy_white: { color: 16316146, roughness: 0, metalness: 0.12, envMapIntensity: 1.2 },
  glossy_black: { color: 2236962, roughness: 0, metalness: 0.2, envMapIntensity: 1.1 },
  matte_grey: { color: 9079432, roughness: 0.88, metalness: 0.05, envMapIntensity: 0.35 },
  glossy_grey: { color: 10132120, roughness: 0, metalness: 0.1, envMapIntensity: 1.1 }
}, Dv = new Kn({
  color: 2763306,
  metalness: 0.1,
  roughness: 0.85,
  envMapIntensity: 0.55,
  name: "Faucet_Black"
}), Nv = new Kn({
  color: 16777215,
  metalness: 1,
  roughness: 0.2,
  envMapIntensity: 1.5,
  name: "Faucet_Chrome"
}), Uv = new Kn({
  color: 14334844,
  metalness: 1,
  roughness: 0.35,
  envMapIntensity: 1,
  name: "Faucet_Gold"
}), Fv = new Kn({
  color: 12105912,
  metalness: 1,
  roughness: 0.7,
  envMapIntensity: 0.8,
  name: "Faucet_BrushedSteel"
}), ad = {
  black: Dv,
  chrome: Nv,
  gold: Uv,
  brushedSteel: Fv
};
function ic(s) {
  return {
    black: "black",
    matte_black: "black",
    chrome: "chrome",
    glossy_chrome: "chrome",
    polished_chrome: "chrome",
    gold: "gold",
    brushed_gold: "gold",
    brushedSteel: "brushedSteel",
    brushed_steel: "brushedSteel",
    brushed_nickel: "brushedSteel"
  }[String(s || "").trim()] || String(s || "").trim();
}
function Ov(s, e) {
  const t = ic(e), n = ad[t];
  return !(s != null && s.isMesh) || !n ? !1 : (s.material = n, n.needsUpdate = !0, !0);
}
const Bv = 0.2, od = {
  bathtub: {
    glbMaterials: ["Bathtub_Material"],
    meshNames: ["Bathtub-BW-03-XL"],
    presetGroup: "stone",
    defaultPreset: "matte_white"
  },
  drainCap: {
    glbMaterials: ["Drain-Cap-Material"],
    meshNames: ["Cap-Tub"],
    presetGroup: "metal",
    defaultPreset: "chrome"
  },
  faucet: {
    glbMaterials: ["Faucet_Material"],
    meshNames: ["Faucet-AT-01", "Faucet-AT-02"],
    presetGroup: "metal",
    defaultPreset: "chrome"
  }
}, kv = {
  glossy_white: dr.glossy_white,
  matte_white: dr.matte_white,
  // Slightly lighter than bathtub black so the basin reads clearly in studio light.
  matte_black: { color: 3026478, roughness: 0.9, metalness: 0.03, envMapIntensity: 0.4 },
  glossy_black: { color: 3684408, roughness: 0, metalness: 0.1, envMapIntensity: 1.15 },
  matte_grey: dr.matte_grey,
  glossy_grey: dr.glossy_grey
}, zv = {
  chrome: "chrome",
  glossy_chrome: "chrome",
  polished_chrome: "chrome",
  brushed_steel: "brushedSteel",
  brushedSteel: "brushedSteel",
  brushed_nickel: "brushedSteel",
  gold: "gold",
  brushed_gold: "gold",
  black: "black",
  matte_black: "black"
};
function Hv(s = "UB-04-M") {
  return {
    sink: {
      glbMaterials: ["Sink_Material"],
      meshNames: [s],
      presetGroup: "sink",
      defaultPreset: "matte_white"
    },
    faucet: {
      glbMaterials: ["Glossy_Chrome"],
      meshNames: ["Wall_Mounted_Faucet", "Vanity_Faucet"],
      presetGroup: "metal",
      defaultPreset: "chrome"
    },
    countertop: {
      meshNames: ["Vanity", "Vanity_Cutout"],
      mode: "nativeGlb",
      defaultPreset: "Light_Stone",
      nativePresets: {
        Light_Stone: "Light_Stone",
        Dark_Stone: "Dark_Stone"
      }
    }
  };
}
const ld = Hv("UB-04-M");
function ws(s) {
  return !s || s.presetGroup !== "metal" || (s.meshNames || []).some((t) => /faucet/i.test(String(t))) ? !1 : s.matchMode === "mesh" || Array.isArray(s.allowedPresets) && s.allowedPresets.length > 0;
}
function fr(s) {
  const e = {
    steel: "brushed_steel",
    brushedSteel: "brushed_steel",
    brushed_steel: "brushed_steel",
    gold: "brushed_gold",
    brushed_gold: "brushed_gold",
    rose_gold: "brushed_rose_gold",
    roseGold: "brushed_rose_gold",
    brushed_rose: "brushed_rose_gold",
    brushed_rose_gold: "brushed_rose_gold"
  }, t = String(s || "").trim();
  return e[t] || t;
}
function Rl(s, e) {
  return `${e}_${s}`;
}
function dn(s) {
  return String(s || "").toLowerCase().replace(/[\u2010-\u2015\u2212\uFE58\uFE63\uFF0D]/g, "-").replace(/[\s_]+/g, "-").replace(/\.\d+$/g, "").replace(/-+/g, "-").replace(/^-|-$/g, "");
}
function Cl(s, e) {
  const t = dn(s), n = dn(e);
  return !t || !n ? !1 : !!(t === n || t.includes(n) || n.includes(t));
}
function Vv(s, e = rd) {
  const t = new He(s), n = { h: 0, s: 0, l: 0 };
  return t.getHSL(n), t.setHSL(n.h, n.s, Math.max(0, n.l * e)), t.getHex();
}
function cd(s) {
  return dn(s == null ? void 0 : s.name) === dn(Lv);
}
function Gv(s, e, t) {
  return e === "black" && t === "matte" ? s : Vv(s, e === "black" ? Iv : rd);
}
function ud(s, e, t) {
  var l, c, u;
  let n = String(s || "").trim();
  ((t == null ? void 0 : t.presetGroup) === "metal" || e === "metal") && (n = fr(n));
  const i = t == null ? void 0 : t.allowedPresets;
  Array.isArray(i) && i.length && !i.includes(n) && (n = t.defaultPreset || i[0]);
  const r = (t == null ? void 0 : t.presetGroup) || e;
  let a = null;
  return r === "metal" ? a = qu[n] : r === "sink" ? a = kv[n] : a = dr[n], a || (a = qu[n] || null), a ? ((l = t == null ? void 0 : t.meshNames) == null ? void 0 : l.includes("Cap-Tub")) || ((c = t == null ? void 0 : t.meshNames) == null ? void 0 : c.includes("Drain_Cap")) || ((u = t == null ? void 0 : t.glbMaterials) == null ? void 0 : u.includes("Drain-Cap-Material")) ? n === "brushed_steel" ? {
    ...ws(t) ? Xu : nc
  } : n === "brushed_gold" || n === "brushed_rose_gold" ? { ...a } : { ...a, roughness: Bv } : n === "brushed_steel" && ws(t) ? { ...Xu } : a : (console.warn("[bf-3d-configurator] Unknown material preset", {
    presetKey: n,
    presetGroup: r
  }), null);
}
function Ca(s, e, t) {
  var i, r, a;
  if (!s || !e) return;
  s.color && s.color.setHex(e.color), typeof s.roughness == "number" && (s.roughness = e.roughness), typeof s.metalness == "number" && (s.metalness = e.metalness), typeof e.envMapIntensity == "number" && "envMapIntensity" in s && (s.envMapIntensity = e.envMapIntensity), (((i = t == null ? void 0 : t.meshNames) == null ? void 0 : i.includes("Cap-Tub")) || ((r = t == null ? void 0 : t.meshNames) == null ? void 0 : r.includes("Drain_Cap")) || ((a = t == null ? void 0 : t.glbMaterials) == null ? void 0 : a.includes("Drain-Cap-Material"))) && "envMap" in s && (s.envMap = null), typeof s.clearcoat == "number" && (e.roughness === 0 ? (s.clearcoat = s.isMeshPhysicalMaterial ? 0.15 : 0, s.clearcoatRoughness = 0) : (s.clearcoat = 0, s.clearcoatRoughness = 0.3)), s.needsUpdate = !0;
}
function Wv(s, e, t = "white", n = "matte") {
  if (!s || !e) return;
  const i = {
    ...e,
    color: Gv(e.color, t, n)
  };
  s.traverse((r) => {
    if (!r.isMesh || !r.material) return;
    (Array.isArray(r.material) ? r.material : [r.material]).forEach((o) => {
      cd(o) && Ca(o, i, null);
    });
  });
}
function Yu(s, e, t) {
  const n = dn(e.name), i = dn(s.name), r = t.glbMaterials || (t.glbMaterial ? [t.glbMaterial] : []);
  for (const o of r)
    if (dn(o) === n) return !0;
  const a = t.meshNames || [];
  for (const o of a)
    if (Cl(o, i) || Cl(o, s.name)) return !0;
  return !1;
}
function Xv(s) {
  return !s || s.presetGroup !== "metal" || (s.glbMaterials || (s.glbMaterial ? [s.glbMaterial] : [])).length ? !1 : s.matchMode === "mesh" ? !0 : Array.isArray(s.meshNames) && s.meshNames.length > 0;
}
function hd(s) {
  const e = [], t = /* @__PURE__ */ new Set(), n = (i) => {
    const r = String(i || "").trim();
    if (!r) return;
    const a = dn(r);
    t.has(a) || (t.add(a), e.push(r));
  };
  return (s || []).forEach((i) => {
    n(i);
    const a = String(i || "").match(/ES[-_\s]?WB[-_\s]?\d+/i);
    if (a) {
      const o = a[0].toUpperCase().replace(/[\s_]+/g, "-").replace(/^ESWB/i, "ES-WB"), l = o.match(/ES-WB-?\d+/i);
      if (l) {
        const c = l[0].toUpperCase().replace(/ES-WB(\d)/, "ES-WB-$1");
        n(c);
      }
      n(o);
    }
  }), e;
}
function dd(s, e) {
  const t = hd(e);
  if (!t.length || !s) return [];
  const n = [], i = /* @__PURE__ */ new Set();
  return s.traverse((r) => {
    !(r != null && r.name) || i.has(r) || t.some((a) => Cl(r.name, a)) && (i.add(r), n.push(r));
  }), n;
}
function qv(s) {
  if (!s) return null;
  const e = /drain|faucet|vanity|pipe|overflow|empty|locator|extra|ceiling|light|hotspot|cap-tub|wall.mounted|plane004/i;
  let t = null, n = 0;
  const i = new T(), r = new Mt(), a = dd(s, ["ES-WB-01", "ES-WB-400", "ES-WB-600", "ES-UB-01-M", "ES-UB-01", "ES-UB-02", "ES-UB-03", "ES-UB-04-M", "ES-UB-04-L", "ES-UB-04-XL", "ES-UB-04"]);
  if (a.length) {
    let o = 0;
    if (a[0].traverse((l) => {
      Pl(l) && l.material && (o += 1);
    }), o > 0) return a[0];
  }
  return s.traverse((o) => {
    if (!Pl(o) || !o.material || e.test(String(o.name || ""))) return;
    let l = o.parent;
    for (; l && l !== s; ) {
      if (e.test(String(l.name || ""))) return;
      l = l.parent;
    }
    if (r.setFromObject(o), r.isEmpty()) return;
    r.getSize(i);
    const c = Math.max(0, i.x) * Math.max(0, i.z);
    c > n && (n = c, t = o);
  }), t;
}
function Yv(s) {
  if (!s) return null;
  let e = null, t = -1;
  return s.traverse((n) => {
    const i = dn(n.name);
    if (!i || i.includes("empty") || i.includes("locator") || i.includes("pipe") || i.includes("cast"))
      return;
    let r = -1;
    i === "drain-cap" || i === "draincap" ? r = 3 : i.includes("drain") && i.includes("cap") || i.includes("drain-cap") ? r = 2 : (i === "cap" || i.includes("cap") && !i.includes("bathtub")) && (r = 1), r > t && (t = r, e = n);
  }), e;
}
function jv(s) {
  return ((s == null ? void 0 : s.meshNames) || []).some((t) => /drain|cap-tub|cap/i.test(String(t))) || ((s == null ? void 0 : s.glbMaterials) || []).some((t) => /drain.?cap/i.test(String(t)));
}
function Pl(s) {
  return !!(s && (s.isMesh === !0 || s.type === "Mesh" || s.geometry && s.material != null));
}
function Kv(s, e, t) {
  if (!s || !e) return 0;
  let n = 0;
  const i = dn(s.name), r = i.includes("drain") || i.includes("cap") || i.includes("pipe") || i.includes("faucet");
  return s.traverse((a) => {
    if (!Pl(a) || !a.material) return;
    if (!r) {
      let c = a;
      for (; c && c !== s; ) {
        const u = dn(c.name);
        if (u.includes("drain") || u.includes("faucet") || u.includes("vanity") || u.includes("pipe") || u.includes("overflow") || u === "extra")
          return;
        c = c.parent;
      }
    }
    const l = (Array.isArray(a.material) ? a.material : [a.material]).map((c) => {
      const u = c.clone();
      return Ca(u, e, t), u;
    });
    a.material = l.length === 1 ? l[0] : l, n += 1;
  }), n;
}
function Zv(s, e, t) {
  const n = e.meshNames || [];
  let i = dd(s, n), r = i.length ? "name" : null;
  if (!i.length)
    if (jv(e)) {
      const o = Yv(s);
      o && (i = [o], r = "drain-fallback");
    } else {
      const o = qv(s);
      o && (i = [o], r = "largest-basin-fallback");
    }
  let a = 0;
  if (i.forEach((o) => {
    a += Kv(o, t, e);
  }), a === 0) {
    const o = [], l = [];
    s.traverse((c) => {
      c.name && (o.push(c.name), c.isMesh && l.push(c.name));
    }), console.warn("[bf-3d-configurator] Metal mesh slot matched 0 meshes", {
      meshNames: n,
      resolvedMeshNames: hd(n),
      availableMeshes: o.slice(0, 120),
      meshOnly: l.slice(0, 80)
    });
  } else r && r !== "name" && console.info("[bf-3d-configurator] Metal mesh slot used fallback match", {
    meshNames: n,
    matchStrategy: r,
    matched: i.map((o) => o.name),
    painted: a
  });
  return a;
}
function Rs(s, e, t) {
  if (!s || !e) return;
  const n = ic(t);
  if (e.presetGroup === "metal" && (e.meshNames || []).some((o) => /faucet/i.test(String(o))) && ad[n]) {
    const o = (e.meshNames || []).map(dn);
    s.traverse((l) => {
      if (!l.isMesh) return;
      let c = !1, u = l;
      for (; u; ) {
        if (o.includes(dn(u.name))) {
          c = !0;
          break;
        }
        u = u.parent;
      }
      c || (c = (Array.isArray(l.material) ? l.material : [l.material]).some((d) => Yu(l, d, e))), c && Ov(l, n);
    });
    return;
  }
  const r = ud(t, e.presetGroup, e);
  if (!r) return;
  if (Xv(e)) {
    Zv(s, e, r);
    return;
  }
  let a = !1;
  s.traverse((o) => {
    if (!o.isMesh || !o.material) return;
    (Array.isArray(o.material) ? o.material : [o.material]).forEach((c) => {
      Yu(o, c, e) && (Ca(c, r, e), a = !0);
    });
  }), !(a || e.presetGroup !== "stone") && s.traverse((o) => {
    if (!o.isMesh || !o.material) return;
    const l = dn(o.name);
    if (l.includes("cap-tub") || l.includes("drain") || l.includes("faucet"))
      return;
    (Array.isArray(o.material) ? o.material : [o.material]).forEach((u) => {
      cd(u) || Ca(u, r, e);
    });
  });
}
function $v(s, e, t, n) {
  const i = n || od.bathtub, r = Rl(e, t), a = ud(r, i.presetGroup, i);
  Rs(s, i, r), Wv(s, a, e, t);
}
function Jv(s, e, t) {
  const n = t || ld.sink;
  Rs(s, n, e);
}
function bo(s) {
  return {
    white_gloss: "glossy_white",
    white_glossy: "glossy_white",
    glossy_white: "glossy_white",
    white_matte: "matte_white",
    matte_white: "matte_white",
    black: "matte_black",
    matte_black: "matte_black",
    glossy_black: "glossy_black",
    gray: "matte_grey",
    grey: "matte_grey",
    matte_grey: "matte_grey",
    glossy_grey: "glossy_grey"
  }[s] || s;
}
function ju(s) {
  return zv[s] || ic(s) || "chrome";
}
const Qv = {
  clip: "Drain-Cap-Animation",
  mesh: "Cap-Tub",
  fps: 24,
  openStartFrame: 1,
  openEndFrame: 24,
  closeStartFrame: 25,
  closeEndFrame: 48
};
function ey(s, e) {
  let t = null;
  return s.traverse((n) => {
    !t && n.name === e && (t = n);
  }), t;
}
function oa(s, e) {
  return (s - 1) / e;
}
function ty({ modelRoot: s, gltf: e, config: t = {} }) {
  const n = { ...Qv, ...t }, i = (e == null ? void 0 : e.animations) || [], r = Ra.findByName(i, n.clip) || i.find((w) => w.name === n.clip);
  if (!r)
    return console.warn("[bf-3d-configurator] Drain animation clip not found:", n.clip), {
      state: "closed",
      playOpen() {
        return !1;
      },
      playClose() {
        return !1;
      },
      reset() {
      },
      update() {
      },
      dispose() {
      },
      isOpen() {
        return !1;
      }
    };
  const a = ey(s, n.mesh) || s, o = new jp(a), l = o.clipAction(r);
  l.setLoop(Ph, 1), l.clampWhenFinished = !0;
  let c = "closed", u = null;
  const h = oa(n.openStartFrame, n.fps), d = Math.min(
    oa(n.openEndFrame, n.fps) + 1 / n.fps,
    r.duration
  ), f = Math.min(oa(n.closeStartFrame, n.fps), r.duration), m = Math.min(
    oa(n.closeEndFrame, n.fps) + 1 / n.fps,
    r.duration
  ), _ = Math.min(m, r.duration);
  function g(w, C, P) {
    return u ? !1 : (l.enabled = !0, l.paused = !1, l.time = w, l.play(), u = {
      endTime: C,
      onComplete: () => {
        l.time = C, l.paused = !0, u = null, c = P;
      }
    }, !0);
  }
  function p() {
    return c === "opening" || c === "open" ? !1 : (c = "opening", g(h, d, "open"));
  }
  function M() {
    return c === "closed" || c === "closing" ? !1 : (c = "closing", g(f, m, "closed"));
  }
  function S() {
    u = null, c = "closed", l.stop(), l.time = _, o.update(0);
  }
  function x(w) {
    if (u && (o.update(w), l.time >= u.endTime)) {
      l.time = u.endTime;
      const C = u.onComplete;
      C && C();
    }
  }
  function R() {
    o.stopAllAction(), o.uncacheRoot(a);
  }
  return l.time = _, c = "closed", o.update(0), {
    get state() {
      return c;
    },
    playOpen: p,
    playClose: M,
    reset: S,
    update: x,
    dispose: R,
    isOpen() {
      return c === "open" || c === "opening";
    }
  };
}
const Ku = new T(), Ai = new T(), ny = 450, iy = 450, lr = 460;
function Ll(s) {
  return String(s || "").toLowerCase().replace(/[\s_.]+/g, "-");
}
function Zu(s, e) {
  if (!s || !e) return null;
  let t = null, n = null;
  const i = Ll(e);
  return s.traverse((r) => {
    if (r != null && r.name) {
      if (r.name === e) {
        t = r;
        return;
      }
      if (!n) {
        const a = Ll(r.name);
        (a === i || a.endsWith(i) || a.includes(i) || a.length >= 4 && i.includes(a)) && (n = r);
      }
    }
  }), t || n;
}
const Bn = new Mt(), qi = new T();
function sy(s, e) {
  const t = e.pinNode || e.focusMesh || e.node;
  let n = Zu(s, t);
  if (!n && e.node && t !== e.node && (n = Zu(s, e.node)), !n) return null;
  if (!(e.anchorAt === "bbox-center" || e.anchorAt === "bbox-top-front" || !e.anchorAt && !!(e.focusMesh || e.pinNode) || Ll(e.node) === "extra" && !!(e.focusMesh || e.pinNode)) && (!e.anchorAt || e.anchorAt === "origin"))
    return { anchor: n, virtual: !1 };
  switch (Bn.setFromObject(n), e.anchorAt || "bbox-center") {
    case "bbox-top-front":
      qi.set(
        (Bn.min.x + Bn.max.x) * 0.5,
        Bn.max.y - (Bn.max.y - Bn.min.y) * 0.06,
        Bn.max.z - (Bn.max.z - Bn.min.z) * 0.12
      );
      break;
    case "bbox-center":
    default:
      Bn.getCenter(qi);
      break;
  }
  Array.isArray(e.anchorOffset) && e.anchorOffset.length >= 3 && (qi.x += Number(e.anchorOffset[0]) || 0, qi.y += Number(e.anchorOffset[1]) || 0, qi.z += Number(e.anchorOffset[2]) || 0);
  const a = new bt();
  return a.name = `bf-hotspot-anchor-${e.id || e.node}`, s.worldToLocal(qi), a.position.copy(qi), s.add(a), { anchor: a, virtual: !0 };
}
function ry({
  modelRoot: s,
  mount: e,
  viewport: t = e,
  camera: n,
  config: i,
  getPinsVisible: r,
  onMeasurementsState: a,
  onDismiss: o,
  onFocus: l,
  onPopupChange: c,
  onLayoutChange: u
}) {
  var _e;
  const h = Array.isArray(i.hotspots) ? i.hotspots : [], d = ((_e = i.toolbar) == null ? void 0 : _e.measurements) || null, f = e.querySelector("[data-bf-3d-hotspots]"), m = e.querySelector("[data-bf-3d-hotspot-modal]");
  if (!f)
    return {
      update() {
      },
      setVisible() {
      },
      dismiss() {
      },
      openMeasurements() {
      },
      hideIconsForInteraction() {
      },
      scheduleIconsReveal() {
      },
      setMeasurementsMode() {
      },
      dispose() {
      }
    };
  const _ = [], g = [];
  let p = !0, M = !0, S = !1, x = null, R = -1, w = null;
  const C = m == null ? void 0 : m.querySelector("[data-bf-3d-hotspot-step]"), P = m == null ? void 0 : m.querySelector("[data-bf-3d-hotspot-prev]"), b = m == null ? void 0 : m.querySelector("[data-bf-3d-hotspot-next]"), y = m == null ? void 0 : m.querySelector("[data-bf-3d-hotspot-modal-note]"), L = m == null ? void 0 : m.querySelector("[data-bf-3d-hotspot-expand]"), O = m == null ? void 0 : m.querySelector("[data-bf-3d-hotspot-expand-body]"), U = m == null ? void 0 : m.querySelector("[data-bf-3d-hotspot-expand-toggle]"), N = m == null ? void 0 : m.querySelector("[data-bf-3d-hotspot-expand-label]"), Y = m == null ? void 0 : m.querySelector("[data-bf-3d-hotspot-mobile-expand]"), G = m == null ? void 0 : m.querySelector("[data-bf-3d-hotspot-mobile-expand-label]"), ne = m == null ? void 0 : m.querySelector(".bf-3d-hotspot-popup__body"), B = m == null ? void 0 : m.querySelector("[data-bf-3d-hotspot-modal-video]");
  let Z = null, Q = null, xe = null, ye = 0;
  function ce() {
    u == null || u(), requestAnimationFrame(() => u == null ? void 0 : u());
  }
  function V(W = lr) {
    ce(), [80, 160, 260, W].forEach((le) => {
      setTimeout(() => u == null ? void 0 : u(), le);
    });
  }
  function se() {
    B && (B.pause(), B.removeAttribute("src"), B.load(), B.hidden = !0, delete B.dataset.bf3dHotspotId);
  }
  function re(W, { preservePlayback: J = !1 } = {}) {
    const le = m == null ? void 0 : m.querySelector("[data-bf-3d-hotspot-modal-img]"), ve = String((W == null ? void 0 : W.id) || "").toLowerCase();
    if (!(J && (W != null && W.video) && B && B.dataset.bf3dHotspotId === ve && B.getAttribute("src") === W.video && !B.hidden)) {
      if (se(), W != null && W.video && B) {
        le && (le.removeAttribute("src"), le.hidden = !0), B.src = W.video, B.hidden = !1, B.muted = !0, B.playsInline = !0, B.setAttribute("playsinline", ""), B.setAttribute("webkit-playsinline", ""), B.dataset.bf3dHotspotId = ve;
        const Te = ve !== "material" && ve !== "stone_resin" && ve !== "stainless_steel" && W.loop !== !1;
        B.loop = Te, Te ? B.setAttribute("loop", "") : B.removeAttribute("loop"), B.setAttribute("aria-label", W.title || W.label || "Hotspot video"), B.style.removeProperty("object-fit"), B.style.removeProperty("object-position"), B.style.removeProperty("transform");
        const he = B.play();
        he != null && he.catch && he.catch(() => {
        });
        return;
      }
      B && (B.style.removeProperty("object-fit"), B.style.removeProperty("object-position"), B.style.removeProperty("transform")), le && (W != null && W.image ? (le.src = W.image, le.alt = W.title || W.label || "", le.hidden = !1) : (le.removeAttribute("src"), le.hidden = !0));
    }
  }
  function X() {
    !ne || !e.classList.contains("bf-3d-hotspot-popup-open") || (ne.classList.add("is-updating"), requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        ne.classList.remove("is-updating");
      });
    }));
  }
  function de() {
    return typeof window < "u" && window.matchMedia("(max-width: 989px)").matches;
  }
  function be(W) {
    e.classList.toggle("bf-3d-hotspot-card-expanded", W), Y == null || Y.setAttribute("aria-expanded", W ? "true" : "false"), Y == null || Y.setAttribute(
      "aria-label",
      W ? "Collapse details" : "Expand details"
    ), G && (G.textContent = W ? "Collapse" : "Expand", G.hidden = !0), Be(W), N && (N.textContent = W ? (U == null ? void 0 : U.dataset.collapseLabel) || "Show less" : (U == null ? void 0 : U.dataset.expandLabel) || "Learn more"), ne && (ne.scrollTop = 0, de() && !W && e.classList.contains("bf-3d-hotspot-has-media") ? ne.style.overflowY = "hidden" : ne.style.overflowY = ""), V();
  }
  function Le() {
    if (!m) return;
    m.setAttribute("aria-hidden", "true"), Ue(!1), x = null, R = -1, Be(!1), be(!1), e.classList.remove("bf-3d-hotspot-has-media", "bf-3d-hotspot-locked-media-frame"), delete e.dataset.hotspotId, L && (L.hidden = !0), a == null || a(!1), it(), Ae(), e.classList.remove("bf-3d-hotspot-popup-open", "bf-3d-hotspot-popup-closing"), c == null || c(null), Q && (clearTimeout(Q), Q = null);
    const W = typeof window < "u" && window.matchMedia("(max-width: 989px)").matches;
    V(lr), W ? xe = setTimeout(() => {
      xe = null, o == null || o({ restoreCamera: !0 });
    }, lr) : o == null || o({ restoreCamera: !0 }), p && De() && !S && I(!0), se();
  }
  function Be(W) {
    !U || !O || (U.setAttribute("aria-expanded", W ? "true" : "false"), O.hidden = !W, m == null || m.classList.toggle("bf-3d-hotspot-popup--expanded", W));
  }
  function nt(W) {
    if (!O || !L) return;
    const J = Array.isArray(W.sections) ? W.sections : [];
    if (!W.expandable || J.length === 0) {
      L.hidden = !0, O.innerHTML = "", Be(!1);
      return;
    }
    O.innerHTML = J.map(
      (le) => `
          <section class="bf-3d-hotspot-popup__expand-section">
            <h4 class="bf-3d-hotspot-popup__expand-section-title">${le.title || ""}</h4>
            <ul class="bf-3d-hotspot-popup__expand-list">
              ${(le.items || []).map((ve) => `<li>${ve}</li>`).join("")}
            </ul>
          </section>`
    ).join(""), L.hidden = !1, Be(!1), N && (N.textContent = W.expandLabel || "Learn more"), U && (U.dataset.expandLabel = W.expandLabel || "Learn more", U.dataset.collapseLabel = W.collapseLabel || "Show less");
  }
  U && U.addEventListener("click", () => {
    const J = !(U.getAttribute("aria-expanded") === "true");
    Be(J), N && (N.textContent = J ? U.dataset.collapseLabel || "Show less" : U.dataset.expandLabel || "Learn more");
  }), Y == null || Y.addEventListener("click", () => {
    const W = Y.getAttribute("aria-expanded") === "true";
    be(!W);
  });
  function De() {
    return (r == null ? void 0 : r()) !== !1;
  }
  function I(W) {
    S && W || (M = W, f.classList.toggle("bf-3d-hotspots--icons-hidden", !W));
  }
  function Ue(W) {
    if (S = W, e.classList.toggle("bf-3d-measurements-active", W), W) {
      w && (clearTimeout(w), w = null), M = !1, f.classList.add("bf-3d-hotspots--icons-hidden"), _.forEach(({ el: J }) => {
        J.hidden = !0;
      });
      return;
    }
    f.classList.remove("bf-3d-hotspots--icons-hidden"), p && De() && (M = !0);
  }
  function Xe() {
    w && (clearTimeout(w), w = null), I(!1);
  }
  function Fe(W = ny) {
    w && clearTimeout(w), w = setTimeout(() => {
      w = null, p && De() && !S && I(!0);
    }, W);
  }
  function Ae() {
    _.forEach(({ def: W, el: J }) => {
      const le = W.id === x;
      J.classList.toggle("bf-3d-hotspot--active", le), le ? J.setAttribute("aria-current", "true") : J.removeAttribute("aria-current");
    });
  }
  function it() {
    const W = x === (d == null ? void 0 : d.id);
    if (m == null || m.classList.toggle("bf-3d-hotspot-popup--toolbar", W), !C) return;
    const J = _.length, le = R >= 0 ? R + 1 : 0;
    C.textContent = J > 0 && !W ? `${le} / ${J}` : "", P && (P.disabled = R <= 0 || W), b && (b.disabled = R < 0 || R >= J - 1 || W);
  }
  function Re(W, J, { focusCamera: le = !0, toolbarAction: ve = !1 } = {}) {
    if (!m) return;
    const Te = String(W.id || "").toLowerCase(), he = Te === "drain_cap" || Te === "ramp_drain" || Te === "ramp_drain_2" || Te === "overflow" || Te === "material" || Te === "stone_resin" || Te === "stainless_steel" || Te === "wall_bracket";
    if (he && x === W.id && e.classList.contains("bf-3d-hotspot-popup-open"))
      return;
    e.classList.contains("bf-3d-hotspot-popup-open") && X(), be(!1);
    const lt = m.querySelector("[data-bf-3d-hotspot-modal-label]"), F = m.querySelector("[data-bf-3d-hotspot-modal-title]"), ge = m.querySelector("[data-bf-3d-hotspot-modal-text]"), $ = m.querySelector("[data-bf-3d-hotspot-modal-measurements]"), ie = !!(W.video || W.image), Me = he;
    e.classList.toggle("bf-3d-hotspot-has-media", ie), e.classList.toggle("bf-3d-hotspot-locked-media-frame", Me), e.dataset.hotspotId = W.id || "", re(W), lt && (lt.textContent = W.label || ""), F && (F.textContent = W.title || W.label || "");
    const fe = Array.isArray(W.measurements) ? W.measurements : [];
    if ($ && (fe.length > 0 ? ($.innerHTML = fe.map((Qe) => {
      const ct = Qe.value != null && String(Qe.value).trim() !== "" ? Qe.value : Qe.measurement_value != null ? Qe.measurement_value : "";
      let Pt = Qe.unit == null || Qe.unit === "" ? "in" : String(Qe.unit);
      (Pt === "in" || Pt === '"' || Pt === "″" || Pt === "â€³" || /â.?³/.test(Pt)) && (Pt = '"');
      const It = Qe.metric != null && String(Qe.metric).trim() !== "" ? ` <span class="bf-3d-hotspot-popup__measurement-metric">(${Qe.metric})</span>` : "";
      return `
              <div class="bf-3d-hotspot-popup__measurement">
                <span class="bf-3d-hotspot-popup__measurement-label">${Qe.label || ""}</span>
                <span class="bf-3d-hotspot-popup__measurement-data">
                  <span class="bf-3d-hotspot-popup__measurement-value">${ct}</span>
                  <span class="bf-3d-hotspot-popup__measurement-unit">${Pt}</span>${It}
                </span>
              </div>`;
    }).join(""), $.hidden = !1, $.removeAttribute("hidden")) : ($.innerHTML = "", $.hidden = !0)), ge) {
      ge.textContent = W.text || "";
      const Qe = !!W.text && (fe.length === 0 || ve);
      ge.hidden = !Qe, Qe && ge.removeAttribute("hidden");
    }
    y && (y.textContent = W.note || "", y.hidden = !W.note || fe.length > 0), nt(W), x = W.id, R = ve ? -1 : _.findIndex((Qe) => Qe.def.id === W.id), ve ? Ue(!0) : S && Ue(!1), a == null || a(ve), it(), Ae(), m.setAttribute("aria-hidden", "false"), e.classList.add("bf-3d-hotspot-popup-open"), c == null || c(W), xe && (clearTimeout(xe), xe = null);
    const Ge = typeof window < "u" && window.matchMedia("(max-width: 989px)").matches, Wd = e.classList.contains("bf-3d-configurator--with-dock");
    le && (Q && (clearTimeout(Q), Q = null), Ge ? Q = setTimeout(() => {
      Q = null, l == null || l(J, W);
    }, lr) : (l == null || l(J, W), ve && Wd && (Q = setTimeout(() => {
      Q = null, l == null || l(J, W);
    }, lr)))), V(), Ge && t && requestAnimationFrame(() => {
      t.scrollIntoView({ block: "nearest", behavior: "smooth" });
    });
  }
  function A() {
    !m || !e.classList.contains("bf-3d-hotspot-popup-open") || (Z && (clearTimeout(Z), Z = null), e.classList.add("bf-3d-hotspot-popup-closing"), Z = setTimeout(() => {
      Z = null, Le();
    }, iy));
  }
  function v() {
    if (d) {
      if (x === d.id) {
        A();
        return;
      }
      x === "drain_cap" && (o == null || o({ restoreCamera: !1 })), Re(d, null, { focusCamera: !0, toolbarAction: !0 });
    }
  }
  function H(W) {
    if (R < 0) return;
    const J = R + W, le = _[J];
    if (!le) return;
    x === (d == null ? void 0 : d.id) && (o == null || o({ restoreCamera: !1 }), a == null || a(!1)), x === "drain_cap" && !le.def.animation && (o == null || o({ restoreCamera: !1 })), Re(le.def, le.anchor, { focusCamera: !0 });
  }
  function te(W, J, le) {
    le.preventDefault(), le.stopPropagation();
    const ve = performance.now();
    if (ve - ye < 400) return;
    ye = ve, x === (d == null ? void 0 : d.id) && (o == null || o({ restoreCamera: !1 }), a == null || a(!1)), x && x !== W.id && x === "drain_cap" && !W.animation && (o == null || o({ restoreCamera: !1 })), Re(W, J, { focusCamera: !0 });
  }
  h.forEach((W) => {
    const J = sy(s, W);
    if (!J) {
      console.warn("[bf-3d-configurator] Hotspot anchor not found:", W.focusMesh || W.node);
      return;
    }
    const { anchor: le, virtual: ve } = J;
    ve && g.push(le);
    const Te = W.label || W.title || "Feature", he = document.createElement("button");
    he.type = "button", he.className = "bf-3d-hotspot", he.dataset.bf3dHotspot = W.id || W.node, he.setAttribute("aria-label", Te), he.innerHTML = `<span class="bf-3d-hotspot__pin" aria-hidden="true"><span class="bf-3d-hotspot__ripple"></span><span class="bf-3d-hotspot__ripple bf-3d-hotspot__ripple--2"></span><span class="bf-3d-hotspot__ring"></span><span class="bf-3d-hotspot__dot"></span></span><span class="bf-3d-hotspot__label">${Te}</span>`, he.addEventListener("click", (qe) => te(W, le, qe)), he.addEventListener("pointerdown", (qe) => {
      qe.pointerType !== "touch" && qe.stopPropagation();
    }), f.appendChild(he), _.push({ def: W, anchor: le, el: he });
  }), m && (m.querySelectorAll("[data-bf-3d-hotspot-close]").forEach((W) => {
    W.addEventListener("click", A);
  }), P == null || P.addEventListener("click", () => H(-1)), b == null || b.addEventListener("click", () => H(1)));
  function oe() {
    if (!p) return;
    if (e.classList.contains("bf-3d-hotspot-popup-open") || S) {
      _.forEach(({ el: ve }) => {
        ve.hidden = !0;
      });
      return;
    }
    if (!M || !De()) {
      _.forEach(({ el: ve }) => {
        ve.hidden = !0;
      });
      return;
    }
    const J = t.clientWidth, le = t.clientHeight;
    !J || !le || _.forEach(({ def: ve, anchor: Te, el: he }) => {
      Te.getWorldPosition(Ku), Ai.copy(Ku).project(n);
      const qe = Ai.z > 1, Ve = Ai.x < -1.05 || Ai.x > 1.05 || Ai.y < -1.05 || Ai.y > 1.05;
      if (qe || Ve) {
        he.hidden = !0, he.classList.toggle("bf-3d-hotspot--active", !1);
        return;
      }
      const lt = (Ai.x + 1) / 2 * J, F = (-Ai.y + 1) / 2 * le;
      he.style.left = `${lt}px`, he.style.top = `${F}px`, he.classList.toggle("bf-3d-hotspot--active", ve.id === x), he.hidden = !1;
    });
  }
  function ee(W) {
    p = W, f.hidden = !W, W ? (f.removeAttribute("hidden"), De() && !S && I(!0)) : A();
  }
  oe(), it();
  function Pe() {
    A();
  }
  function me() {
    w && clearTimeout(w), Z && clearTimeout(Z), _.forEach(({ el: W }) => W.remove()), g.forEach((W) => W.remove()), g.length = 0, m && (m.setAttribute("aria-hidden", "true"), se(), e.classList.remove(
      "bf-3d-hotspot-popup-open",
      "bf-3d-hotspot-popup-closing",
      "bf-3d-measurements-active",
      "bf-3d-hotspot-card-expanded",
      "bf-3d-hotspot-has-media",
      "bf-3d-hotspot-locked-media-frame"
    )), c == null || c(null);
  }
  return {
    update: oe,
    setVisible: ee,
    dismiss: Pe,
    openMeasurements: v,
    closePopup: A,
    hideIconsForInteraction: Xe,
    scheduleIconsReveal: Fe,
    setMeasurementsMode: Ue,
    dispose: me
  };
}
const cr = new T();
function ay(s) {
  return 1 - (1 - s) ** 3;
}
function $u(s, e, t) {
  let n = e - s;
  for (; n > Math.PI; ) n -= Math.PI * 2;
  for (; n < -Math.PI; ) n += Math.PI * 2;
  return s + n * t;
}
function oy(s, e, t) {
  cr.set(e[0], e[1], e[2]), cr.lengthSq() < 1e-6 && cr.set(0, 0.2, 1), cr.normalize().multiplyScalar(t);
  const n = new Tr().setFromVector3(cr);
  return {
    target: s.clone(),
    spherical: n,
    radius: n.radius
  };
}
function ly({ getOrbitState: s, setOrbitState: e, minDistance: t, maxDistance: n }) {
  let i = null, r = null;
  function a(d, f, m, _) {
    i = {
      startTime: performance.now(),
      duration: m,
      from: d,
      to: f,
      onComplete: _
    };
  }
  function o(d, f = {}) {
    const m = s();
    r || (r = {
      target: m.target.clone(),
      spherical: m.spherical.clone(),
      radius: m.radius
    });
    const _ = typeof f.zoomOutScale == "number" ? f.zoomOutScale : 1.08, g = f.zoomOut ? Math.min(
      n,
      Math.max(s().radius * _, f.distance ?? 2.8)
    ) : Math.max(
      0.14,
      t * 0.18,
      Math.min(n, f.distance ?? 0.37)
    ), p = Array.isArray(f.direction) ? f.direction : [0.05, 0.3, 1], M = oy(d, p, g), S = f.duration ?? 850;
    if (S <= 0) {
      e({ target: M.target, spherical: M.spherical }), typeof f.onComplete == "function" && f.onComplete();
      return;
    }
    a(
      {
        target: m.target.clone(),
        spherical: m.spherical.clone(),
        radius: m.radius
      },
      M,
      S,
      f.onComplete
    );
  }
  function l(d) {
    if (!r || i) return;
    const f = s();
    a(
      {
        target: f.target.clone(),
        spherical: f.spherical.clone(),
        radius: f.radius
      },
      {
        target: r.target.clone(),
        spherical: r.spherical.clone(),
        radius: r.radius
      },
      700,
      () => {
        r = null, typeof d == "function" && d();
      }
    );
  }
  function c() {
    if (!i) return !1;
    const d = performance.now() - i.startTime, f = Math.min(1, d / i.duration), m = ay(f), { from: _, to: g } = i, p = new T().lerpVectors(_.target, g.target, m), M = new Tr(
      _.radius + (g.radius - _.radius) * m,
      $u(_.spherical.phi, g.spherical.phi, m),
      $u(_.spherical.theta, g.spherical.theta, m)
    );
    if (e({ target: p, spherical: M }), f >= 1) {
      const S = i.onComplete;
      i = null, S && S();
    }
    return !0;
  }
  function u() {
    return i !== null;
  }
  function h() {
    r = null, i = null;
  }
  return {
    focusOn: o,
    restore: l,
    update: c,
    isAnimating: u,
    resetSavedView: h
  };
}
class sc extends bt {
  /**
   * Constructs a new CSS2D object.
   *
   * @param {DOMElement} [element] - The DOM element.
   */
  constructor(e = document.createElement("div")) {
    super(), this.isCSS2DObject = !0, this.element = e, this.element.style.position = "absolute", this.element.style.userSelect = "none", this.element.setAttribute("draggable", !1), this.center = new ze(0.5, 0.5), this.addEventListener("removed", function() {
      this.traverse(function(t) {
        t.element instanceof t.element.ownerDocument.defaultView.Element && t.element.parentNode !== null && t.element.remove();
      });
    });
  }
  copy(e, t) {
    return super.copy(e, t), this.element = e.element.cloneNode(!0), this.center = e.center, this;
  }
}
const _s = new T(), Ju = new Ye(), Qu = new Ye(), eh = new T(), th = new T();
class cy {
  /**
   * Constructs a new CSS2D renderer.
   *
   * @param {CSS2DRenderer~Parameters} [parameters] - The parameters.
   */
  constructor(e = {}) {
    const t = this;
    let n, i, r, a;
    const o = {
      objects: /* @__PURE__ */ new WeakMap()
    }, l = e.element !== void 0 ? e.element : document.createElement("div");
    l.style.overflow = "hidden", this.domElement = l, this.getSize = function() {
      return {
        width: n,
        height: i
      };
    }, this.render = function(m, _) {
      m.matrixWorldAutoUpdate === !0 && m.updateMatrixWorld(), _.parent === null && _.matrixWorldAutoUpdate === !0 && _.updateMatrixWorld(), Ju.copy(_.matrixWorldInverse), Qu.multiplyMatrices(_.projectionMatrix, Ju), u(m, m, _), f(m);
    }, this.setSize = function(m, _) {
      n = m, i = _, r = n / 2, a = i / 2, l.style.width = m + "px", l.style.height = _ + "px";
    };
    function c(m) {
      m.isCSS2DObject && (m.element.style.display = "none");
      for (let _ = 0, g = m.children.length; _ < g; _++)
        c(m.children[_]);
    }
    function u(m, _, g) {
      if (m.visible === !1) {
        c(m);
        return;
      }
      if (m.isCSS2DObject) {
        _s.setFromMatrixPosition(m.matrixWorld), _s.applyMatrix4(Qu);
        const p = _s.z >= -1 && _s.z <= 1 && m.layers.test(g.layers) === !0, M = m.element;
        M.style.display = p === !0 ? "" : "none", p === !0 && (m.onBeforeRender(t, _, g), M.style.transform = "translate(" + -100 * m.center.x + "%," + -100 * m.center.y + "%)translate(" + (_s.x * r + r) + "px," + (-_s.y * a + a) + "px)", M.parentNode !== l && l.appendChild(M), m.onAfterRender(t, _, g));
        const S = {
          distanceToCameraSquared: h(g, m)
        };
        o.objects.set(m, S);
      }
      for (let p = 0, M = m.children.length; p < M; p++)
        u(m.children[p], _, g);
    }
    function h(m, _) {
      return eh.setFromMatrixPosition(m.matrixWorld), th.setFromMatrixPosition(_.matrixWorld), eh.distanceToSquared(th);
    }
    function d(m) {
      const _ = [];
      return m.traverseVisible(function(g) {
        g.isCSS2DObject && _.push(g);
      }), _;
    }
    function f(m) {
      const _ = d(m).sort(function(p, M) {
        if (p.renderOrder !== M.renderOrder)
          return M.renderOrder - p.renderOrder;
        const S = o.objects.get(p).distanceToCameraSquared, x = o.objects.get(M).distanceToCameraSquared;
        return S - x;
      }), g = _.length;
      for (let p = 0, M = _.length; p < M; p++)
        _[p].element.style.zIndex = g - p;
    }
  }
}
const nh = new Mt(), la = new T();
class fd extends Ip {
  /**
   * Constructs a new line segments geometry.
   */
  constructor() {
    super(), this.isLineSegmentsGeometry = !0, this.type = "LineSegmentsGeometry";
    const e = [-1, 2, 0, 1, 2, 0, -1, 1, 0, 1, 1, 0, -1, 0, 0, 1, 0, 0, -1, -1, 0, 1, -1, 0], t = [-1, 2, 1, 2, -1, 1, 1, 1, -1, -1, 1, -1, -1, -2, 1, -2], n = [0, 2, 1, 2, 3, 1, 2, 4, 3, 4, 5, 3, 4, 6, 5, 6, 7, 5];
    this.setIndex(n), this.setAttribute("position", new Sn(e, 3)), this.setAttribute("uv", new Sn(t, 2));
  }
  /**
   * Applies the given 4x4 transformation matrix to the geometry.
   *
   * @param {Matrix4} matrix - The matrix to apply.
   * @return {LineSegmentsGeometry} A reference to this instance.
   */
  applyMatrix4(e) {
    const t = this.attributes.instanceStart, n = this.attributes.instanceEnd;
    return t !== void 0 && (t.applyMatrix4(e), n.applyMatrix4(e), t.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
  }
  /**
   * Sets the given line positions for this geometry. The length must be a multiple of six since
   * each line segment is defined by a start end vertex in the pattern `(xyz xyz)`.
   *
   * @param {Float32Array|Array<number>} array - The position data to set.
   * @return {LineSegmentsGeometry} A reference to this geometry.
   */
  setPositions(e) {
    let t;
    e instanceof Float32Array ? t = e : Array.isArray(e) && (t = new Float32Array(e));
    const n = new bl(t, 6, 1);
    return this.setAttribute("instanceStart", new di(n, 3, 0)), this.setAttribute("instanceEnd", new di(n, 3, 3)), this.instanceCount = this.attributes.instanceStart.count, this.computeBoundingBox(), this.computeBoundingSphere(), this;
  }
  /**
   * Sets the given line colors for this geometry. The length must be a multiple of six since
   * each line segment is defined by a start end color in the pattern `(rgb rgb)`.
   *
   * @param {Float32Array|Array<number>} array - The position data to set.
   * @return {LineSegmentsGeometry} A reference to this geometry.
   */
  setColors(e) {
    let t;
    e instanceof Float32Array ? t = e : Array.isArray(e) && (t = new Float32Array(e));
    const n = new bl(t, 6, 1);
    return this.setAttribute("instanceColorStart", new di(n, 3, 0)), this.setAttribute("instanceColorEnd", new di(n, 3, 3)), this;
  }
  /**
   * Setups this line segments geometry from the given wireframe geometry.
   *
   * @param {WireframeGeometry} geometry - The geometry that should be used as a data source for this geometry.
   * @return {LineSegmentsGeometry} A reference to this geometry.
   */
  fromWireframeGeometry(e) {
    return this.setPositions(e.attributes.position.array), this;
  }
  /**
   * Setups this line segments geometry from the given edges geometry.
   *
   * @param {EdgesGeometry} geometry - The geometry that should be used as a data source for this geometry.
   * @return {LineSegmentsGeometry} A reference to this geometry.
   */
  fromEdgesGeometry(e) {
    return this.setPositions(e.attributes.position.array), this;
  }
  /**
   * Setups this line segments geometry from the given mesh.
   *
   * @param {Mesh} mesh - The mesh geometry that should be used as a data source for this geometry.
   * @return {LineSegmentsGeometry} A reference to this geometry.
   */
  fromMesh(e) {
    return this.fromWireframeGeometry(new hp(e.geometry)), this;
  }
  /**
   * Setups this line segments geometry from the given line segments.
   *
   * @param {LineSegments} lineSegments - The line segments that should be used as a data source for this geometry.
   * Assumes the source geometry is not using indices.
   * @return {LineSegmentsGeometry} A reference to this geometry.
   */
  fromLineSegments(e) {
    const t = e.geometry;
    return this.setPositions(t.attributes.position.array), this;
  }
  computeBoundingBox() {
    this.boundingBox === null && (this.boundingBox = new Mt());
    const e = this.attributes.instanceStart, t = this.attributes.instanceEnd;
    e !== void 0 && t !== void 0 && (this.boundingBox.setFromBufferAttribute(e), nh.setFromBufferAttribute(t), this.boundingBox.union(nh));
  }
  computeBoundingSphere() {
    this.boundingSphere === null && (this.boundingSphere = new Mn()), this.boundingBox === null && this.computeBoundingBox();
    const e = this.attributes.instanceStart, t = this.attributes.instanceEnd;
    if (e !== void 0 && t !== void 0) {
      const n = this.boundingSphere.center;
      this.boundingBox.getCenter(n);
      let i = 0;
      for (let r = 0, a = e.count; r < a; r++)
        la.fromBufferAttribute(e, r), i = Math.max(i, n.distanceToSquared(la)), la.fromBufferAttribute(t, r), i = Math.max(i, n.distanceToSquared(la));
      this.boundingSphere.radius = Math.sqrt(i), isNaN(this.boundingSphere.radius) && console.error("THREE.LineSegmentsGeometry.computeBoundingSphere(): Computed radius is NaN. The instanced position data is likely to have NaN values.", this);
    }
  }
  toJSON() {
  }
}
pe.line = {
  worldUnits: { value: 1 },
  linewidth: { value: 1 },
  resolution: { value: new ze(1, 1) },
  dashOffset: { value: 0 },
  dashScale: { value: 1 },
  dashSize: { value: 1 },
  gapSize: { value: 1 }
  // todo FIX - maybe change to totalSize
};
cn.line = {
  uniforms: Wl.merge([
    pe.common,
    pe.fog,
    pe.line
  ]),
  vertexShader: (
    /* glsl */
    `
		#include <common>
		#include <color_pars_vertex>
		#include <fog_pars_vertex>
		#include <logdepthbuf_pars_vertex>
		#include <clipping_planes_pars_vertex>

		uniform float linewidth;
		uniform vec2 resolution;

		attribute vec3 instanceStart;
		attribute vec3 instanceEnd;

		attribute vec3 instanceColorStart;
		attribute vec3 instanceColorEnd;

		#ifdef WORLD_UNITS

			varying vec4 worldPos;
			varying vec3 worldStart;
			varying vec3 worldEnd;

			#ifdef USE_DASH

				varying vec2 vUv;

			#endif

		#else

			varying vec2 vUv;

		#endif

		#ifdef USE_DASH

			uniform float dashScale;
			attribute float instanceDistanceStart;
			attribute float instanceDistanceEnd;
			varying float vLineDistance;

		#endif

		void trimSegment( const in vec4 start, inout vec4 end ) {

			// trim end segment so it terminates between the camera plane and the near plane

			// conservative estimate of the near plane
			float a = projectionMatrix[ 2 ][ 2 ]; // 3nd entry in 3th column
			float b = projectionMatrix[ 3 ][ 2 ]; // 3nd entry in 4th column
			float nearEstimate = - 0.5 * b / a;

			float alpha = ( nearEstimate - start.z ) / ( end.z - start.z );

			end.xyz = mix( start.xyz, end.xyz, alpha );

		}

		void main() {

			#ifdef USE_COLOR

				vColor.xyz = ( position.y < 0.5 ) ? instanceColorStart : instanceColorEnd;

			#endif

			#ifdef USE_DASH

				vLineDistance = ( position.y < 0.5 ) ? dashScale * instanceDistanceStart : dashScale * instanceDistanceEnd;
				vUv = uv;

			#endif

			float aspect = resolution.x / resolution.y;

			// camera space
			vec4 start = modelViewMatrix * vec4( instanceStart, 1.0 );
			vec4 end = modelViewMatrix * vec4( instanceEnd, 1.0 );

			#ifdef WORLD_UNITS

				worldStart = start.xyz;
				worldEnd = end.xyz;

			#else

				vUv = uv;

			#endif

			// special case for perspective projection, and segments that terminate either in, or behind, the camera plane
			// clearly the gpu firmware has a way of addressing this issue when projecting into ndc space
			// but we need to perform ndc-space calculations in the shader, so we must address this issue directly
			// perhaps there is a more elegant solution -- WestLangley

			bool perspective = ( projectionMatrix[ 2 ][ 3 ] == - 1.0 ); // 4th entry in the 3rd column

			if ( perspective ) {

				if ( start.z < 0.0 && end.z >= 0.0 ) {

					trimSegment( start, end );

				} else if ( end.z < 0.0 && start.z >= 0.0 ) {

					trimSegment( end, start );

				}

			}

			// clip space
			vec4 clipStart = projectionMatrix * start;
			vec4 clipEnd = projectionMatrix * end;

			// ndc space
			vec3 ndcStart = clipStart.xyz / clipStart.w;
			vec3 ndcEnd = clipEnd.xyz / clipEnd.w;

			// direction
			vec2 dir = ndcEnd.xy - ndcStart.xy;

			// account for clip-space aspect ratio
			dir.x *= aspect;
			dir = normalize( dir );

			#ifdef WORLD_UNITS

				vec3 worldDir = normalize( end.xyz - start.xyz );
				vec3 tmpFwd = normalize( mix( start.xyz, end.xyz, 0.5 ) );
				vec3 worldUp = normalize( cross( worldDir, tmpFwd ) );
				vec3 worldFwd = cross( worldDir, worldUp );
				worldPos = position.y < 0.5 ? start: end;

				// height offset
				float hw = linewidth * 0.5;
				worldPos.xyz += position.x < 0.0 ? hw * worldUp : - hw * worldUp;

				// don't extend the line if we're rendering dashes because we
				// won't be rendering the endcaps
				#ifndef USE_DASH

					// cap extension
					worldPos.xyz += position.y < 0.5 ? - hw * worldDir : hw * worldDir;

					// add width to the box
					worldPos.xyz += worldFwd * hw;

					// endcaps
					if ( position.y > 1.0 || position.y < 0.0 ) {

						worldPos.xyz -= worldFwd * 2.0 * hw;

					}

				#endif

				// project the worldpos
				vec4 clip = projectionMatrix * worldPos;

				// shift the depth of the projected points so the line
				// segments overlap neatly
				vec3 clipPose = ( position.y < 0.5 ) ? ndcStart : ndcEnd;
				clip.z = clipPose.z * clip.w;

			#else

				vec2 offset = vec2( dir.y, - dir.x );
				// undo aspect ratio adjustment
				dir.x /= aspect;
				offset.x /= aspect;

				// sign flip
				if ( position.x < 0.0 ) offset *= - 1.0;

				// endcaps
				if ( position.y < 0.0 ) {

					offset += - dir;

				} else if ( position.y > 1.0 ) {

					offset += dir;

				}

				// adjust for linewidth
				offset *= linewidth;

				// adjust for clip-space to screen-space conversion // maybe resolution should be based on viewport ...
				offset /= resolution.y;

				// select end
				vec4 clip = ( position.y < 0.5 ) ? clipStart : clipEnd;

				// back to clip space
				offset *= clip.w;

				clip.xy += offset;

			#endif

			gl_Position = clip;

			vec4 mvPosition = ( position.y < 0.5 ) ? start : end; // this is an approximation

			#include <logdepthbuf_vertex>
			#include <clipping_planes_vertex>
			#include <fog_vertex>

		}
		`
  ),
  fragmentShader: (
    /* glsl */
    `
		uniform vec3 diffuse;
		uniform float opacity;
		uniform float linewidth;

		#ifdef USE_DASH

			uniform float dashOffset;
			uniform float dashSize;
			uniform float gapSize;

		#endif

		varying float vLineDistance;

		#ifdef WORLD_UNITS

			varying vec4 worldPos;
			varying vec3 worldStart;
			varying vec3 worldEnd;

			#ifdef USE_DASH

				varying vec2 vUv;

			#endif

		#else

			varying vec2 vUv;

		#endif

		#include <common>
		#include <color_pars_fragment>
		#include <fog_pars_fragment>
		#include <logdepthbuf_pars_fragment>
		#include <clipping_planes_pars_fragment>

		vec2 closestLineToLine(vec3 p1, vec3 p2, vec3 p3, vec3 p4) {

			float mua;
			float mub;

			vec3 p13 = p1 - p3;
			vec3 p43 = p4 - p3;

			vec3 p21 = p2 - p1;

			float d1343 = dot( p13, p43 );
			float d4321 = dot( p43, p21 );
			float d1321 = dot( p13, p21 );
			float d4343 = dot( p43, p43 );
			float d2121 = dot( p21, p21 );

			float denom = d2121 * d4343 - d4321 * d4321;

			float numer = d1343 * d4321 - d1321 * d4343;

			mua = numer / denom;
			mua = clamp( mua, 0.0, 1.0 );
			mub = ( d1343 + d4321 * ( mua ) ) / d4343;
			mub = clamp( mub, 0.0, 1.0 );

			return vec2( mua, mub );

		}

		void main() {

			#include <clipping_planes_fragment>

			#ifdef USE_DASH

				if ( vUv.y < - 1.0 || vUv.y > 1.0 ) discard; // discard endcaps

				if ( mod( vLineDistance + dashOffset, dashSize + gapSize ) > dashSize ) discard; // todo - FIX

			#endif

			float alpha = opacity;

			#ifdef WORLD_UNITS

				// Find the closest points on the view ray and the line segment
				vec3 rayEnd = normalize( worldPos.xyz ) * 1e5;
				vec3 lineDir = worldEnd - worldStart;
				vec2 params = closestLineToLine( worldStart, worldEnd, vec3( 0.0, 0.0, 0.0 ), rayEnd );

				vec3 p1 = worldStart + lineDir * params.x;
				vec3 p2 = rayEnd * params.y;
				vec3 delta = p1 - p2;
				float len = length( delta );
				float norm = len / linewidth;

				#ifndef USE_DASH

					#ifdef USE_ALPHA_TO_COVERAGE

						float dnorm = fwidth( norm );
						alpha = 1.0 - smoothstep( 0.5 - dnorm, 0.5 + dnorm, norm );

					#else

						if ( norm > 0.5 ) {

							discard;

						}

					#endif

				#endif

			#else

				#ifdef USE_ALPHA_TO_COVERAGE

					// artifacts appear on some hardware if a derivative is taken within a conditional
					float a = vUv.x;
					float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
					float len2 = a * a + b * b;
					float dlen = fwidth( len2 );

					if ( abs( vUv.y ) > 1.0 ) {

						alpha = 1.0 - smoothstep( 1.0 - dlen, 1.0 + dlen, len2 );

					}

				#else

					if ( abs( vUv.y ) > 1.0 ) {

						float a = vUv.x;
						float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
						float len2 = a * a + b * b;

						if ( len2 > 1.0 ) discard;

					}

				#endif

			#endif

			vec4 diffuseColor = vec4( diffuse, alpha );

			#include <logdepthbuf_fragment>
			#include <color_fragment>

			gl_FragColor = vec4( diffuseColor.rgb, alpha );

			#include <tonemapping_fragment>
			#include <colorspace_fragment>
			#include <fog_fragment>
			#include <premultiplied_alpha_fragment>

		}
		`
  )
};
class rc extends jn {
  /**
   * Constructs a new line segments geometry.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super({
      type: "LineMaterial",
      uniforms: Wl.clone(cn.line.uniforms),
      vertexShader: cn.line.vertexShader,
      fragmentShader: cn.line.fragmentShader,
      clipping: !0
      // required for clipping support
    }), this.isLineMaterial = !0, this.setValues(e);
  }
  /**
   * The material's color.
   *
   * @type {Color}
   * @default (1,1,1)
   */
  get color() {
    return this.uniforms.diffuse.value;
  }
  set color(e) {
    this.uniforms.diffuse.value = e;
  }
  /**
   * Whether the material's sizes (width, dash gaps) are in world units.
   *
   * @type {boolean}
   * @default false
   */
  get worldUnits() {
    return "WORLD_UNITS" in this.defines;
  }
  set worldUnits(e) {
    e === !0 ? this.defines.WORLD_UNITS = "" : delete this.defines.WORLD_UNITS;
  }
  /**
   * Controls line thickness in CSS pixel units when `worldUnits` is `false` (default),
   * or in world units when `worldUnits` is `true`.
   *
   * @type {number}
   * @default 1
   */
  get linewidth() {
    return this.uniforms.linewidth.value;
  }
  set linewidth(e) {
    this.uniforms.linewidth && (this.uniforms.linewidth.value = e);
  }
  /**
   * Whether the line is dashed, or solid.
   *
   * @type {boolean}
   * @default false
   */
  get dashed() {
    return "USE_DASH" in this.defines;
  }
  set dashed(e) {
    e === !0 !== this.dashed && (this.needsUpdate = !0), e === !0 ? this.defines.USE_DASH = "" : delete this.defines.USE_DASH;
  }
  /**
   * The scale of the dashes and gaps.
   *
   * @type {number}
   * @default 1
   */
  get dashScale() {
    return this.uniforms.dashScale.value;
  }
  set dashScale(e) {
    this.uniforms.dashScale.value = e;
  }
  /**
   * The size of the dash.
   *
   * @type {number}
   * @default 1
   */
  get dashSize() {
    return this.uniforms.dashSize.value;
  }
  set dashSize(e) {
    this.uniforms.dashSize.value = e;
  }
  /**
   * Where in the dash cycle the dash starts.
   *
   * @type {number}
   * @default 0
   */
  get dashOffset() {
    return this.uniforms.dashOffset.value;
  }
  set dashOffset(e) {
    this.uniforms.dashOffset.value = e;
  }
  /**
   * The size of the gap.
   *
   * @type {number}
   * @default 0
   */
  get gapSize() {
    return this.uniforms.gapSize.value;
  }
  set gapSize(e) {
    this.uniforms.gapSize.value = e;
  }
  /**
   * The opacity.
   *
   * @type {number}
   * @default 1
   */
  get opacity() {
    return this.uniforms.opacity.value;
  }
  set opacity(e) {
    this.uniforms && (this.uniforms.opacity.value = e);
  }
  /**
   * The size of the viewport, in screen pixels. This must be kept updated to make
   * screen-space rendering accurate.The `LineSegments2.onBeforeRender` callback
   * performs the update for visible objects.
   *
   * @type {Vector2}
   */
  get resolution() {
    return this.uniforms.resolution.value;
  }
  set resolution(e) {
    this.uniforms.resolution.value.copy(e);
  }
  /**
   * Whether to use alphaToCoverage or not. When enabled, this can improve the
   * anti-aliasing of line edges when using MSAA.
   *
   * @type {boolean}
   */
  get alphaToCoverage() {
    return "USE_ALPHA_TO_COVERAGE" in this.defines;
  }
  set alphaToCoverage(e) {
    this.defines && (e === !0 !== this.alphaToCoverage && (this.needsUpdate = !0), e === !0 ? this.defines.USE_ALPHA_TO_COVERAGE = "" : delete this.defines.USE_ALPHA_TO_COVERAGE);
  }
}
const Eo = new at(), ih = new T(), sh = new T(), qt = new at(), Yt = new at(), kn = new at(), To = new T(), Ao = new Ye(), jt = new Kp(), rh = new T(), ca = new Mt(), ua = new Mn(), zn = new at();
let Hn, Zi;
function ah(s, e, t) {
  return zn.set(0, 0, -e, 1).applyMatrix4(s.projectionMatrix), zn.multiplyScalar(1 / zn.w), zn.x = Zi / t.width, zn.y = Zi / t.height, zn.applyMatrix4(s.projectionMatrixInverse), zn.multiplyScalar(1 / zn.w), Math.abs(Math.max(zn.x, zn.y));
}
function uy(s, e) {
  const t = s.matrixWorld, n = s.geometry, i = n.attributes.instanceStart, r = n.attributes.instanceEnd, a = Math.min(n.instanceCount, i.count);
  for (let o = 0, l = a; o < l; o++) {
    jt.start.fromBufferAttribute(i, o), jt.end.fromBufferAttribute(r, o), jt.applyMatrix4(t);
    const c = new T(), u = new T();
    Hn.distanceSqToSegment(jt.start, jt.end, u, c), u.distanceTo(c) < Zi * 0.5 && e.push({
      point: u,
      pointOnLine: c,
      distance: Hn.origin.distanceTo(u),
      object: s,
      face: null,
      faceIndex: o,
      uv: null,
      uv1: null
    });
  }
}
function hy(s, e, t) {
  const n = e.projectionMatrix, r = s.material.resolution, a = s.matrixWorld, o = s.geometry, l = o.attributes.instanceStart, c = o.attributes.instanceEnd, u = Math.min(o.instanceCount, l.count), h = -e.near;
  Hn.at(1, kn), kn.w = 1, kn.applyMatrix4(e.matrixWorldInverse), kn.applyMatrix4(n), kn.multiplyScalar(1 / kn.w), kn.x *= r.x / 2, kn.y *= r.y / 2, kn.z = 0, To.copy(kn), Ao.multiplyMatrices(e.matrixWorldInverse, a);
  for (let d = 0, f = u; d < f; d++) {
    if (qt.fromBufferAttribute(l, d), Yt.fromBufferAttribute(c, d), qt.w = 1, Yt.w = 1, qt.applyMatrix4(Ao), Yt.applyMatrix4(Ao), qt.z > h && Yt.z > h)
      continue;
    if (qt.z > h) {
      const S = qt.z - Yt.z, x = (qt.z - h) / S;
      qt.lerp(Yt, x);
    } else if (Yt.z > h) {
      const S = Yt.z - qt.z, x = (Yt.z - h) / S;
      Yt.lerp(qt, x);
    }
    qt.applyMatrix4(n), Yt.applyMatrix4(n), qt.multiplyScalar(1 / qt.w), Yt.multiplyScalar(1 / Yt.w), qt.x *= r.x / 2, qt.y *= r.y / 2, Yt.x *= r.x / 2, Yt.y *= r.y / 2, jt.start.copy(qt), jt.start.z = 0, jt.end.copy(Yt), jt.end.z = 0;
    const _ = jt.closestPointToPointParameter(To, !0);
    jt.at(_, rh);
    const g = Vl.lerp(qt.z, Yt.z, _), p = g >= -1 && g <= 1, M = To.distanceTo(rh) < Zi * 0.5;
    if (p && M) {
      jt.start.fromBufferAttribute(l, d), jt.end.fromBufferAttribute(c, d), jt.start.applyMatrix4(a), jt.end.applyMatrix4(a);
      const S = new T(), x = new T();
      Hn.distanceSqToSegment(jt.start, jt.end, x, S), t.push({
        point: x,
        pointOnLine: S,
        distance: Hn.origin.distanceTo(x),
        object: s,
        face: null,
        faceIndex: d,
        uv: null,
        uv1: null
      });
    }
  }
}
class dy extends xt {
  /**
   * Constructs a new wide line.
   *
   * @param {LineSegmentsGeometry} [geometry] - The line geometry.
   * @param {LineMaterial} [material] - The line material.
   */
  constructor(e = new fd(), t = new rc({ color: Math.random() * 16777215 })) {
    super(e, t), this.isLineSegments2 = !0, this.type = "LineSegments2";
  }
  /**
   * Computes an array of distance values which are necessary for rendering dashed lines.
   * For each vertex in the geometry, the method calculates the cumulative length from the
   * current point to the very beginning of the line.
   *
   * @return {LineSegments2} A reference to this instance.
   */
  computeLineDistances() {
    const e = this.geometry, t = e.attributes.instanceStart, n = e.attributes.instanceEnd, i = new Float32Array(2 * t.count);
    for (let a = 0, o = 0, l = t.count; a < l; a++, o += 2)
      ih.fromBufferAttribute(t, a), sh.fromBufferAttribute(n, a), i[o] = o === 0 ? 0 : i[o - 1], i[o + 1] = i[o] + ih.distanceTo(sh);
    const r = new bl(i, 2, 1);
    return e.setAttribute("instanceDistanceStart", new di(r, 1, 0)), e.setAttribute("instanceDistanceEnd", new di(r, 1, 1)), this;
  }
  /**
   * Computes intersection points between a casted ray and this instance.
   *
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - The target array that holds the intersection points.
   */
  raycast(e, t) {
    const n = this.material.worldUnits, i = e.camera;
    i === null && !n && console.error('LineSegments2: "Raycaster.camera" needs to be set in order to raycast against LineSegments2 while worldUnits is set to false.');
    const r = e.params.Line2 !== void 0 && e.params.Line2.threshold || 0;
    Hn = e.ray;
    const a = this.matrixWorld, o = this.geometry, l = this.material;
    Zi = l.linewidth + r, o.boundingSphere === null && o.computeBoundingSphere(), ua.copy(o.boundingSphere).applyMatrix4(a);
    let c;
    if (n)
      c = Zi * 0.5;
    else {
      const h = Math.max(i.near, ua.distanceToPoint(Hn.origin));
      c = ah(i, h, l.resolution);
    }
    if (ua.radius += c, Hn.intersectsSphere(ua) === !1)
      return;
    o.boundingBox === null && o.computeBoundingBox(), ca.copy(o.boundingBox).applyMatrix4(a);
    let u;
    if (n)
      u = Zi * 0.5;
    else {
      const h = Math.max(i.near, ca.distanceToPoint(Hn.origin));
      u = ah(i, h, l.resolution);
    }
    ca.expandByScalar(u), Hn.intersectsBox(ca) !== !1 && (n ? uy(this, t) : hy(this, i, t));
  }
  onBeforeRender(e) {
    const t = this.material.uniforms;
    t && t.resolution && (e.getViewport(Eo), this.material.uniforms.resolution.value.set(Eo.z, Eo.w));
  }
}
class pd extends fd {
  /**
   * Constructs a new line geometry.
   */
  constructor() {
    super(), this.isLineGeometry = !0, this.type = "LineGeometry";
  }
  /**
   * Sets the given line positions for this geometry.
   *
   * @param {Float32Array|Array<number>} array - The position data to set.
   * @return {LineGeometry} A reference to this geometry.
   */
  setPositions(e) {
    const t = e.length - 3, n = new Float32Array(2 * t);
    for (let i = 0; i < t; i += 3)
      n[2 * i] = e[i], n[2 * i + 1] = e[i + 1], n[2 * i + 2] = e[i + 2], n[2 * i + 3] = e[i + 3], n[2 * i + 4] = e[i + 4], n[2 * i + 5] = e[i + 5];
    return super.setPositions(n), this;
  }
  /**
   * Sets the given line colors for this geometry.
   *
   * @param {Float32Array|Array<number>} array - The position data to set.
   * @return {LineGeometry} A reference to this geometry.
   */
  setColors(e) {
    const t = e.length - 3, n = new Float32Array(2 * t);
    for (let i = 0; i < t; i += 3)
      n[2 * i] = e[i], n[2 * i + 1] = e[i + 1], n[2 * i + 2] = e[i + 2], n[2 * i + 3] = e[i + 3], n[2 * i + 4] = e[i + 4], n[2 * i + 5] = e[i + 5];
    return super.setColors(n), this;
  }
  /**
   * Setups this line segments geometry from the given sequence of points.
   *
   * @param {Array<Vector3|Vector2>} points - An array of points in 2D or 3D space.
   * @return {LineGeometry} A reference to this geometry.
   */
  setFromPoints(e) {
    const t = e.length - 1, n = new Float32Array(6 * t);
    for (let i = 0; i < t; i++)
      n[6 * i] = e[i].x, n[6 * i + 1] = e[i].y, n[6 * i + 2] = e[i].z || 0, n[6 * i + 3] = e[i + 1].x, n[6 * i + 4] = e[i + 1].y, n[6 * i + 5] = e[i + 1].z || 0;
    return super.setPositions(n), this;
  }
  /**
   * Setups this line segments geometry from the given line.
   *
   * @param {Line} line - The line that should be used as a data source for this geometry.
   * @return {LineGeometry} A reference to this geometry.
   */
  fromLine(e) {
    const t = e.geometry;
    return this.setPositions(t.attributes.position.array), this;
  }
}
class fy extends dy {
  /**
   * Constructs a new wide line.
   *
   * @param {LineGeometry} [geometry] - The line geometry.
   * @param {LineMaterial} [material] - The line material.
   */
  constructor(e = new pd(), t = new rc({ color: Math.random() * 16777215 })) {
    super(e, t), this.isLine2 = !0, this.type = "Line2";
  }
}
const wo = new Mt(), xs = new T(), vs = new T(), ys = new T(), Ln = new T(), Ss = new T(), Ro = new T(), Co = new T(), Po = new T(), Nt = 5921368, py = 1118481, my = 0.9, gy = 0.07, _y = 0.045, xy = 3, Rr = 1200;
function vy(s) {
  if (!s) return "";
  if (s.unit === "°" || s.unit === "deg") return `${s.value ?? ""}°`;
  const e = String(s.unit || ""), t = e === "in" || e === '"' || e === "″" || e === "â€³" || /â.?³/.test(e) ? '"' : e || '"';
  return `${s.value ?? ""}${t}`;
}
function Je(s, e, t = {}) {
  if (!Array.isArray(s)) return "";
  const n = t.exclude || [], i = s.find((r) => {
    const a = String(r.label || "").toLowerCase();
    return n.some((o) => a.includes(o)) ? !1 : e.some((o) => a.includes(o));
  });
  return vy(i);
}
function yy() {
  var s;
  return typeof window > "u" ? 1 : (s = window.matchMedia) != null && s.call(window, "(max-width: 989px)").matches ? 0.6 : 1;
}
function pi(s, e, t = {}) {
  const { dashed: n = !1, lineWidth: i = 2.4 } = t;
  if (!s || s.length < 2) return null;
  const r = [];
  s.forEach((c) => {
    r.push(c.x, c.y, c.z);
  });
  const a = new pd();
  a.setPositions(r);
  const o = new rc({
    color: e,
    linewidth: i * yy(),
    dashed: n,
    dashScale: n ? xy : 1,
    dashSize: n ? gy : 1,
    gapSize: n ? _y : 0,
    depthTest: !1,
    depthWrite: !1,
    transparent: !0,
    opacity: my,
    worldUnits: !1
  }), l = new fy(a, o);
  return l.computeLineDistances(), l.renderOrder = Rr, l.frustumCulled = !1, l.userData.lineMaterial = o, l;
}
function mi(s, e) {
  e && s.add(e);
}
function oh(s, e, t, n, i = Nt, r = 2.4) {
  Ln.copy(t).normalize(), Math.abs(Ln.y) > 0.85 ? Ss.set(1, 0, 0) : (Math.abs(Ln.x) > 0.85, Ss.set(0, 1, 0)), Ss.cross(Ln).normalize().multiplyScalar(n * 0.42), Ro.copy(e).add(Ln.clone().multiplyScalar(n)), mi(s, pi([e, Ro.clone().add(Ss)], i, { lineWidth: r })), mi(s, pi([e, Ro.clone().sub(Ss)], i, { lineWidth: r }));
}
function lh(s) {
  return /es[-_\s]?(wb|ub)/i.test(String(s || ""));
}
function Pn(s, e, t, n, i = {}) {
  un(s, e, t, n, {
    dashed: !0,
    color: py,
    lineWidth: 1.6,
    labelClass: i.labelClass || ""
  });
}
function un(s, e, t, n, i = {}) {
  const {
    dashed: r = !1,
    color: a = Nt,
    labelClass: o = "",
    lineWidth: l = 2.8,
    labelAlong: c = 0,
    labelPerp: u = null,
    labelNudgeYPx: h = 0,
    labelNudgeXPx: d = 0
  } = i, f = e.distanceTo(t), m = Math.min(0.022, f * 0.04), _ = m * 0.35;
  if (xs.copy(e), vs.copy(t), Ln.subVectors(vs, xs).normalize(), xs.addScaledVector(Ln, _), vs.addScaledVector(Ln, -_), mi(s, pi([xs, vs], a, { dashed: r, lineWidth: l })), oh(s, xs, Ln, m, a, l), oh(s, vs, Ln.clone().negate(), m, a, l), !n) return;
  ys.addVectors(xs, vs).multiplyScalar(0.5), c && ys.addScaledVector(Ln, f * c), Array.isArray(u) && u.length >= 3 && (ys.x += u[0], ys.y += u[1], ys.z += u[2]);
  const g = document.createElement("div");
  g.className = `bf-3d-measurement-label${o ? ` ${o}` : ""}`, g.textContent = n;
  const p = new sc(g);
  p.position.copy(ys), p.userData.lineStart = e.clone(), p.userData.lineEnd = t.clone(), (h || d || o.includes("nudge-up")) && (p.userData.labelNudgeYPx = h || (o.includes("nudge-up") ? 5 : 0), p.userData.labelNudgeXPx = d || 0), p.renderOrder = Rr + 1, s.add(p);
}
function Ct(s) {
  const e = Number.parseFloat(String(s || "").replace(/[^0-9.]/g, ""));
  return Number.isFinite(e) ? e : null;
}
function Sy(s) {
  const e = String(s || "").toLowerCase();
  return e === "drain_pipe" || e.includes("drain_pipe");
}
function My(s, e) {
  const t = [e, s == null ? void 0 : s.parent, s].filter(Boolean);
  for (let n = 0; n < t.length; n += 1) {
    let i = null;
    if (t[n].traverse((r) => {
      i || Sy(r.name) && (i = r);
    }), i) {
      if (i.visible === !1) return null;
      const r = new Mt().setFromObject(i);
      if (Number.isFinite(r.min.y) && r.max.y > r.min.y) return r;
    }
  }
  return null;
}
function Lo(s) {
  const e = new Mt();
  if (!(s != null && s.isMesh)) return e;
  s.updateWorldMatrix(!0, !1);
  const t = s.geometry;
  return t && (t.boundingBox || t.computeBoundingBox(), t.boundingBox && !t.boundingBox.isEmpty()) ? (e.copy(t.boundingBox).applyMatrix4(s.matrixWorld), e) : e.setFromObject(s, !0);
}
function by(s, e) {
  const t = /vanity|faucet|extra|wall_mounted|drain_|ceiling|light|hotspot|empty|locator|armature|helper|collision/i, n = new Mt(), i = new T(), r = (m, _) => {
    let g = m;
    for (; g; ) {
      if (t.test(String(g.name || ""))) return !0;
      if (g === _) break;
      g = g.parent;
    }
    return !1;
  }, a = (m) => (Array.isArray(m.material) ? m.material : [m.material]).some((g) => /sink[_-]?material/i.test(String((g == null ? void 0 : g.name) || ""))), o = (m) => (n.copy(Lo(m)), n.isEmpty() ? 0 : (n.getSize(i), i.x * i.z)), l = [];
  s && l.push(s), e && e !== s && l.push(e);
  let c = null, u = 0, h = null, d = 0;
  for (const m of l)
    if (m.traverse((_) => {
      if (!_.isMesh || r(_, m)) return;
      const g = o(_);
      g <= 0 || (a(_) && g > u && (u = g, c = _), g > d && (d = g, h = _));
    }), c) break;
  const f = c || h;
  return f ? Lo(f) : s != null && s.isMesh ? Lo(s) : new Mt().setFromObject(s || new bt(), !0);
}
function Na(s = {}, e = "") {
  return s.productFamily === "sink";
}
function Io(s, e, t, n, i, r = "", a = {}) {
  if (/BW-06-S|BW-08-S/i.test(String(r || ""))) {
    if (!!Je(i, [
      "inside length 1",
      "inside length1",
      "interior length 1",
      "inside length left"
    ]) || !!Je(i, [
      "inside length 2",
      "inside length2",
      "interior length 2",
      "inside length right"
    ])) {
      ch(s, e, t, n, i, r);
      return;
    }
    if (/BW-08-S/i.test(String(r || "")) && (!!Je(i, [
      "inside height left",
      "interior height left"
    ]) || !!Je(i, [
      "inside height right",
      "interior height right"
    ]))) {
      ch(s, e, t, n, i, r);
      return;
    }
  }
  if (/BW-09/i.test(String(r || ""))) {
    Ey(s, e, t, n, i);
    return;
  }
  const o = t.x - e.x, l = t.z - e.z, c = t.y - e.y, u = (e.x + t.x) * 0.5, h = (e.z + t.z) * 0.5, d = Na(a, r), f = d ? e.y + c * 0.55 : e.y + c * 0.24, m = d ? Je(i, [
    "interior basin length",
    "basin length",
    "inside length",
    "interior length"
  ]) : Je(i, ["inside length", "interior length"]), _ = d ? Je(i, [
    "interior basin width",
    "basin width",
    "inside width",
    "interior width"
  ]) : Je(i, ["inside width", "interior width"]);
  if (!m && !_) return;
  const g = Ct(
    Je(i, ["overall length", "length"], {
      exclude: d ? ["inside", "interior", "basin"] : ["inside", "interior"]
    })
  ) || null, p = Ct(
    d ? Je(i, ["overall width", "width"], {
      exclude: ["inside", "interior", "basin"]
    }) : Je(i, ["width", "depth"], {
      exclude: ["inside", "interior"]
    })
  ) || null, M = Ct(m), S = Ct(_), wt04PartialDeck = /WT[-_]?04[-_]?[AB]/i.test(String(r || "")) || /WT[-_]?04[-_]?[AB]/i.test(String(a.sizeKey || "")) || (a.meshNames || []).some((nm) => /WT[-_]?04[-_]?[AB]/i.test(String(nm || ""))) || /WT[-_]?05[-_]?[AB]/i.test(String(r || "")) || /WT[-_]?05[-_]?[AB]/i.test(String(a.sizeKey || "")) || (a.meshNames || []).some((nm) => /WT[-_]?05[-_]?[AB]/i.test(String(nm || ""))), wt04Ramp = wt04PartialDeck || d && !!Je(i, ["ramp angle"], { exclude: ["overflow"] }) && !!m && !/WT[-_]?04[-_]?[CDEFG]/i.test(String(r || "")) && !/WT[-_]?04[-_]?[CDEFG]/i.test(String(a.sizeKey || "")) && !(a.meshNames || []).some((nm) => /WT[-_]?04[-_]?[CDEFG]/i.test(String(nm || "")));
  if (d && wt04PartialDeck && g && M) {
    const wt04IsB = /WT[-_]?04[-_]?B/i.test(String(r || "")) || /WT[-_]?04[-_]?B/i.test(String(a.sizeKey || "")) || (a.meshNames || []).some((nm) => /WT[-_]?04[-_]?B/i.test(String(nm || ""))) || /WT[-_]?05[-_]?B/i.test(String(r || "")) || /WT[-_]?05[-_]?B/i.test(String(a.sizeKey || "")) || (a.meshNames || []).some((nm) => /WT[-_]?05[-_]?B/i.test(String(nm || ""))), isWt05 = /WT[-_]?05/i.test(String(r || "")) || /WT[-_]?05/i.test(String(a.sizeKey || "")) || (a.meshNames || []).some((nm) => /WT[-_]?05/i.test(String(nm || ""))), lenRatio = Math.min(0.92, Math.max(0.48, M / g)), widthRatio = p && S ? Math.min(0.92, Math.max(0.48, S / p)) : 0.78, baseLenSpan = o * lenRatio, lenSpan = isWt05 ? baseLenSpan * 0.88 : baseLenSpan, lenInset = isWt05 ? (baseLenSpan - lenSpan) * 0.5 : 0, widthSpan = l * widthRatio, lenShiftX = o * 0.09, widthShiftZ = l * (isWt05 ? -0.04 : 0.04), lenStartX = wt04IsB ? t.x - lenSpan - lenShiftX - lenInset : e.x + lenShiftX + lenInset, lenEndX = wt04IsB ? t.x - lenShiftX - lenInset : e.x + lenSpan + lenShiftX + lenInset, widthCenterX = wt04IsB ? t.x - lenSpan * 0.5 - lenShiftX * 0.75 - lenInset : e.x + lenSpan * 0.5 + lenShiftX * 0.75 + lenInset, widthCenterZ = h + widthShiftZ;
    m && un(
      s,
      new T(lenStartX, f, widthCenterZ),
      new T(lenEndX, f, widthCenterZ),
      m,
      { color: Nt, lineWidth: 2.2, labelAlong: 0.22 }
    ), _ && un(
      s,
      new T(widthCenterX, f, widthCenterZ - widthSpan * 0.5),
      new T(widthCenterX, f, widthCenterZ + widthSpan * 0.5),
      _,
      { color: Nt, lineWidth: 2.2, labelAlong: -0.22 }
    );
    return;
  }
  const wt04Centered = /WT[-_]?04[-_]?[DEFG]/i.test(String(r || "")) || /WT[-_]?04[-_]?[DEFG]/i.test(String(a.sizeKey || "")) || (a.meshNames || []).some((nm) => /WT[-_]?04[-_]?[DEFG]/i.test(String(nm || "")));
  const wt06l = /WT[-_]?06/i.test(String(r || "")) || /WT[-_]?06/i.test(String(a.sizeKey || "")) || (a.meshNames || []).some((nm) => /WT[-_]?06/i.test(String(nm || "")));
  if (d && wt04Centered && g && M) {
    const lenRatio = Math.min(0.7, Math.max(0.48, M / g)) * 0.88, widthRatio = (p && S ? Math.min(0.84, Math.max(0.48, S / p)) : 0.72) * 0.88, lenSpan = o * lenRatio, widthSpan = l * widthRatio, widthCenterZ = h + l * 0.08;
    m && un(
      s,
      new T(u - lenSpan * 0.5, f, widthCenterZ),
      new T(u + lenSpan * 0.5, f, widthCenterZ),
      m,
      { color: Nt, lineWidth: 2.2, labelAlong: 0.22 }
    ), _ && un(
      s,
      new T(u, f, widthCenterZ - widthSpan * 0.5),
      new T(u, f, widthCenterZ + widthSpan * 0.5),
      _,
      { color: Nt, lineWidth: 2.2, labelAlong: -0.22 }
    );
    return;
  }
  if (d && wt06l && g && M) {
    const lenRatio = 0.84, widthRatio = (p && S ? Math.min(0.7, Math.max(0.48, S / p)) : 0.62) * 0.88, lenSpan = o * lenRatio, widthSpan = l * widthRatio, widthCenterZ = h + l * 0.05;
    m && un(
      s,
      new T(u - lenSpan * 0.5, f, h),
      new T(u + lenSpan * 0.5, f, h),
      m,
      { color: Nt, lineWidth: 2.2, labelAlong: 0.22 }
    ), _ && un(
      s,
      new T(u, f, widthCenterZ - widthSpan * 0.5),
      new T(u, f, widthCenterZ + widthSpan * 0.5),
      _,
      { color: Nt, lineWidth: 2.2, labelAlong: -0.22 }
    );
    return;
  }
  const wt03 = /WT[-_]?03/i.test(String(r || "")) || /WT[-_]?03/i.test(String(a.sizeKey || "")) || (a.meshNames || []).some((nm) => /WT[-_]?03/i.test(String(nm || "")));
  if (d && wt03 && g && M) {
    const lenRatio = Math.min(0.78, Math.max(0.48, M / g)) * 0.88, widthRatio = (p && S ? Math.min(0.84, Math.max(0.48, S / p)) : 0.72) * 0.88, lenSpan = o * lenRatio, widthSpan = l * widthRatio;
    m && un(
      s,
      new T(u - lenSpan * 0.5, f, h),
      new T(u + lenSpan * 0.5, f, h),
      m,
      { color: Nt, lineWidth: 2.2, labelAlong: 0.22 }
    ), _ && un(
      s,
      new T(u, f, h - widthSpan * 0.5),
      new T(u, f, h + widthSpan * 0.5),
      _,
      { color: Nt, lineWidth: 2.2, labelAlong: -0.22 }
    );
    return;
  }
  const wt01m = /WT[-_]?01[-_]?M/i.test(String(r || "")) || /WT[-_]?01[-_]?M/i.test(String(a.sizeKey || "")) || (a.meshNames || []).some((nm) => /WT[-_]?01[-_]?M/i.test(String(nm || ""))) || (/WT[-_]?01/i.test(String(r || "")) || /WT[-_]?01/i.test(String(a.sizeKey || "")) || (a.meshNames || []).some((nm) => /WT[-_]?01/i.test(String(nm || "")))) && !/WT[-_]?01[-_]?L/i.test(String(r || "")) && !/WT[-_]?01[-_]?L/i.test(String(a.sizeKey || "")) && !(a.meshNames || []).some((nm) => /WT[-_]?01[-_]?L/i.test(String(nm || ""))) && !/WT[-_]?01[-_]?XL/i.test(String(r || "")) && !/WT[-_]?01[-_]?XL/i.test(String(a.sizeKey || "")) && !(a.meshNames || []).some((nm) => /WT[-_]?01[-_]?XL/i.test(String(nm || "")));
  if (d && wt01m && g && M) {
    const lenRatio = Math.min(0.88, Math.max(0.48, M / g)) * 0.9, widthRatio = (p && S ? Math.min(0.78, Math.max(0.45, S / p)) : 0.68) * 0.94, lenSpan = o * lenRatio, widthSpan = l * widthRatio, lineCenterZ = h + l * 0.06;
    m && un(
      s,
      new T(u - lenSpan * 0.5, f, lineCenterZ),
      new T(u + lenSpan * 0.5, f, lineCenterZ),
      m,
      { color: Nt, lineWidth: 2.2, labelAlong: 0.22 }
    ), _ && un(
      s,
      new T(u, f, lineCenterZ - widthSpan * 0.5),
      new T(u, f, lineCenterZ + widthSpan * 0.5),
      _,
      { color: Nt, lineWidth: 2.2, labelAlong: -0.22 }
    );
    return;
  }
  const wt02 = /WT[-_]?02/i.test(String(r || "")) || /WT[-_]?02/i.test(String(a.sizeKey || "")) || (a.meshNames || []).some((nm) => /WT[-_]?02/i.test(String(nm || "")));
  if (d && wt02 && g && M) {
    const wt02A = /WT[-_]?02[-_]?A/i.test(String(r || "")) || /WT[-_]?02[-_]?A/i.test(String(a.sizeKey || "")) || (a.meshNames || []).some((nm) => /WT[-_]?02[-_]?A/i.test(String(nm || ""))), wt02B = /WT[-_]?02[-_]?B/i.test(String(r || "")) || /WT[-_]?02[-_]?B/i.test(String(a.sizeKey || "")) || (a.meshNames || []).some((nm) => /WT[-_]?02[-_]?B/i.test(String(nm || ""))), wt02D = /WT[-_]?02[-_]?D/i.test(String(r || "")) || /WT[-_]?02[-_]?D/i.test(String(a.sizeKey || "")) || (a.meshNames || []).some((nm) => /WT[-_]?02[-_]?D/i.test(String(nm || ""))), wt02E = /WT[-_]?02[-_]?E/i.test(String(r || "")) || /WT[-_]?02[-_]?E/i.test(String(a.sizeKey || "")) || (a.meshNames || []).some((nm) => /WT[-_]?02[-_]?E/i.test(String(nm || ""))), wt02Left = wt02A || wt02E, wt02Right = wt02B || wt02D, lenRatio = Math.min(0.62, Math.max(0.35, M / g)) * 0.82, widthRatio = (p && S ? Math.min(0.62, Math.max(0.35, S / p)) : 0.55) * 0.82, lenSpan = o * lenRatio, widthSpan = l * widthRatio, lenShiftX = o * 0.14, lenCenterX = wt02Left ? e.x + lenSpan * 0.5 + lenShiftX : wt02Right ? t.x - lenSpan * 0.5 - lenShiftX : u, widthCenterX = wt02Left || wt02Right ? lenCenterX : u;
    m && un(
      s,
      new T(lenCenterX - lenSpan * 0.5, f, h),
      new T(lenCenterX + lenSpan * 0.5, f, h),
      m,
      { color: Nt, lineWidth: 2.2, labelAlong: 0.22 }
    ), _ && un(
      s,
      new T(widthCenterX, f, h - widthSpan * 0.5),
      new T(widthCenterX, f, h + widthSpan * 0.5),
      _,
      { color: Nt, lineWidth: 2.2, labelAlong: -0.22 }
    );
    return;
  }
  let x = 0.84, R = 0.84;
  d && wt04Ramp && g && p && M && S ? (x = Math.min(
    0.78,
    Math.max(0.48, M / g)
  ), R = Math.min(
    0.78,
    Math.max(0.48, S / p)
  )) : d ? (x = 0.84, R = 0.8) : (g && M && (x = Math.min(
    0.84,
    Math.max(0.55, (M + 3.5) / g)
  )), p && S && (R = Math.min(
    0.84,
    Math.max(0.55, (S + 3.5) / p)
  )));
  const w = o * x, C = l * R;
  m && un(
    s,
    new T(u - w * 0.5, f, h),
    new T(u + w * 0.5, f, h),
    m,
    { color: Nt, lineWidth: 2.2, labelAlong: 0.22 }
  ), _ && un(
    s,
    new T(u, f, h - C * 0.5),
    new T(u, f, h + C * 0.5),
    _,
    { color: Nt, lineWidth: 2.2, labelAlong: -0.22 }
  );
}
function Ey(s, e, t, n, i) {
  const r = t.x - e.x, a = t.z - e.z, o = t.y - e.y, l = (e.x + t.x) * 0.5, c = (e.z + t.z) * 0.5, u = e.y + o * 0.24, h = Je(i, [
    "inside length",
    "interior length"
  ]), d = Je(i, [
    "inside width left",
    "interior width left"
  ]), f = Je(i, [
    "inside width right",
    "interior width right"
  ]);
  if (!h && !d && !f) return;
  const m = Ct(
    Je(i, ["length"], { exclude: ["inside", "interior"] })
  ) || null, _ = Ct(
    Je(i, ["width left"], { exclude: ["inside", "interior"] })
  ) || null, g = Ct(
    Je(i, ["width right"], { exclude: ["inside", "interior"] })
  ) || null, p = Ct(h), M = Ct(d), S = Ct(f), x = 3.5, R = 2.5, w = Math.max(_ || 0, g || 0) || null;
  if (h) {
    let L = 0.84;
    m && p && (L = Math.min(
      0.84,
      Math.max(0.55, (p + x) / m)
    ));
    const O = r * L;
    un(
      s,
      new T(l - O * 0.5, u, c),
      new T(l + O * 0.5, u, c),
      h,
      { color: Nt, lineWidth: 2.2, labelAlong: 0.22 }
    );
  }
  const C = (L, O, U, N, Y, G = {}) => {
    if (!L) return;
    const { spanShrinkZ: ne = 0, zOffset: B = 0, labelClass: Z = "" } = G;
    let Q = 0.68;
    const xe = U || w;
    xe && O && (Q = Math.min(
      0.76,
      Math.max(0.48, (O + R) / xe)
    ));
    let ye = a * Q - ne;
    ye = Math.max(ye, a * 0.27);
    const ce = e.x + r * N, V = c + B, se = { color: Nt, lineWidth: 2.2, labelAlong: Y };
    Z && (se.labelClass = Z), un(
      s,
      new T(ce, u, V - ye * 0.5),
      new T(ce, u, V + ye * 0.5),
      L,
      se
    );
  }, P = "bf-3d-measurement-label--interior-sm", b = a * 0.04, y = a * 0.022;
  C(d, M, _, 0.15, -0.22, {
    spanShrinkZ: y,
    zOffset: b,
    labelClass: P
  }), C(f, S, g, 0.85, 0.22, {
    spanShrinkZ: y,
    zOffset: b,
    labelClass: P
  });
}
function Ty(s, e, t, n, i, r) {
  const a = t.x - e.x, o = t.z - e.z, l = Je(r, ["width left"], {
    exclude: ["inside", "interior"]
  }), c = Je(r, ["width right"], {
    exclude: ["inside", "interior"]
  }), u = Ct(l), h = Ct(c), d = Math.max(u || 0, h || 0) || null, f = (m, _, g) => {
    if (!m) return;
    let p = 0.84;
    d && _ && (p = Math.min(0.88, Math.max(0.55, _ / d)));
    const M = o * p, S = e.z + (o - M) * 0.5, x = e.x + a * g;
    Pn(
      s,
      new T(x, n, S),
      new T(x, n, S + M),
      m
    );
  };
  f(l, u, 0.08), f(c, h, 0.92);
}
function ch(s, e, t, n, i, r = "") {
  const a = /BW-08-S/i.test(String(r || "")), o = t.x - e.x, l = t.z - e.z, c = t.y - e.y, u = (e.z + t.z) * 0.5, h = e.y + c * 0.24, d = Je(i, [
    "inside length 1",
    "inside length1",
    "interior length 1",
    "inside length left"
  ]) || "", f = Je(i, [
    "inside length 2",
    "inside length2",
    "interior length 2",
    "inside length right"
  ]) || "", m = Je(i, ["inside length", "interior length"]) || "", _ = Je(i, ["inside width", "interior width"]) || "", g = Je(i, [
    "inside height left",
    "interior height left"
  ]) || "", p = Je(i, [
    "inside height right",
    "interior height right"
  ]) || "", M = Ct(
    Je(i, ["length"], { exclude: ["inside", "interior"] })
  ) || null, S = Ct(
    Je(i, ["width", "depth"], {
      exclude: ["inside", "interior"]
    })
  ) || null, x = Ct(
    Je(i, ["height"], { exclude: ["inside", "interior"] })
  ) || null, R = Ct(d), w = Ct(f), C = Ct(_), P = Ct(g), b = Ct(p), y = M && R ? Math.min(0.68, Math.max(0.4, R / M + 0.08)) : 0.55, L = o * 0.07, O = o * 0.02;
  let U = o * (y - 0.07 * 2), N = o * (1 - y - 0.07 * 2);
  M && R && (U = Math.min(U, o * Math.max(0.22, Math.min(0.58, R / M)))), M && w && (N = Math.min(N, o * Math.max(0.18, Math.min(0.45, w / M))));
  const Y = e.x + L + U * 0.5, G = t.x - L - N * 0.5, ne = Math.min(Y + U * 0.5, e.x + o * y - O), B = ne - U, Z = Math.max(G - N * 0.5, e.x + o * y + O), Q = Z + N;
  if (d && un(
    s,
    new T(B, h, u),
    new T(ne, h, u),
    d,
    { color: Nt, lineWidth: 2.2, labelAlong: 0.15 }
  ), f && un(
    s,
    new T(Z, h, u),
    new T(Q, h, u),
    f,
    { color: Nt, lineWidth: 2.2, labelAlong: -0.15 }
  ), !d && !f && m) {
    const ye = Ct(m);
    let ce = 0.78;
    M && ye && (ce = Math.min(0.9, Math.max(0.55, ye / M)));
    const V = o * ce, se = e.x + (o - V) * 0.5;
    un(
      s,
      new T(se, h, u),
      new T(se + V, h, u),
      m,
      { color: Nt, lineWidth: 2.2, labelAlong: 0.12 }
    );
  }
  if (_) {
    let ye = 0.72;
    S && C && (ye = Math.min(0.84, Math.max(0.5, (C + 3.5) / S)));
    const ce = l * ye, V = a ? (Z + Q) * 0.5 : (B + ne) * 0.5;
    un(
      s,
      new T(V, h, u - ce * 0.5),
      new T(V, h, u + ce * 0.5),
      _,
      { color: Nt, lineWidth: 2.2, labelAlong: -0.22 }
    );
  }
  const xe = (ye, ce, V, se = {}) => {
    if (!ye) return;
    const {
      labelNudgePx: re = 0,
      labelNudgeXPx: X = 0,
      taller: de = !1,
      lineNudgeY: be = 0,
      lineNudgeX: Le = 0,
      zOffset: Be = 0,
      clearLumbar: nt = !1,
      heightSpanScale: De = 1,
      topFactorCap: I = 0.72
    } = se;
    let Ue = de ? 0.82 : 0.55;
    x && ce && (Ue = Math.min(
      de ? 0.99 : 0.82,
      Math.max(de ? 0.62 : 0.35, ce / x)
    ));
    let Xe = nt ? Math.min(I, 0.14 + Ue * 0.7) : de ? 0.02 + Ue * 0.96 : 0.12 + Ue * 0.7, Fe = nt ? 0.1 : de ? 0.02 : 0.12;
    if (De > 1) {
      const H = (Xe + Fe) * 0.5, te = (Xe - Fe) * 0.5 * De;
      Xe = Math.min(I, H + te), Fe = Math.max(0.04, H - te);
    }
    const Ae = e.y + c * Xe + be, it = e.y + c * Fe + be, Re = V + Le, A = u + Be, v = { color: Nt, lineWidth: 2.2 };
    (re || X) && (v.labelClass = "bf-3d-measurement-label--nudge-up", v.labelNudgeYPx = re, v.labelNudgeXPx = X), un(
      s,
      new T(Re, it, A),
      new T(Re, Ae, A),
      ye,
      v
    );
  };
  if (a) {
    const ye = (ce, V, se = {}) => {
      if (!ce) return;
      const {
        labelNudgePx: re = 0,
        labelNudgeXPx: X = 0,
        lineNudgeY: de = 0
      } = se, be = e.y + c * 0.05 + de, Le = e.y + c * 0.86 + de, Be = V, nt = u, De = { color: Nt, lineWidth: 2.2 };
      (re || X) && (De.labelClass = "bf-3d-measurement-label--nudge-up", De.labelNudgeYPx = re, De.labelNudgeXPx = X), un(
        s,
        new T(Be, be, nt),
        new T(Be, Le, nt),
        ce,
        De
      );
    };
    ye(g, B + (ne - B) * 0.5, {
      labelNudgePx: 72,
      labelNudgeXPx: 6,
      lineNudgeY: c * 0.14
    }), ye(p, Z + (Q - Z) * 0.5, {
      labelNudgePx: 8,
      labelNudgeXPx: -6
    });
  } else
    xe(g, P, (B + ne) * 0.5), xe(p, b, (Z + Q) * 0.5);
}
function Do(s, e, t, n, i, r = "", a = {}) {
  const o = String(r || "");
  if (Na(a, o)) return;
  const l = /BW-06-S|BW-08-S/i.test(o), c = Je(i, ["overflow", "distance to overflow"]);
  if (l && !c) return;
  const u = c || '18.2"', h = t.x - e.x, d = t.y - e.y, f = t.z - e.z, m = (e.x + t.x) * 0.5, _ = (e.z + t.z) * 0.5, g = e.y + d * 0.28, p = e.y + d * 0.86;
  if (/BW-06-(L|XL)/i.test(o)) {
    const R = t.x - h * 0.08, w = _ + f * 0.22;
    un(
      s,
      new T(R, g, w),
      new T(R, p, w),
      u,
      { color: Nt, lineWidth: 2.2 }
    );
    return;
  }
  if (l) {
    const R = t.x - h * 0.1, w = _;
    un(
      s,
      new T(R, g, w),
      new T(R, p, w),
      u,
      { color: Nt, lineWidth: 2.2 }
    );
    return;
  }
  const S = /BW-01-S/i.test(o) ? m + h * 0.14 : m, x = e.z + f * 0.1;
  un(
    s,
    new T(S, g, x),
    new T(S, p, x),
    u,
    { color: Nt, lineWidth: 2.2 }
  );
}
function No(s, e, t, n, i, r) {
  const a = Number.isFinite(Number(t)) ? Math.abs(Number(t)) : 28;
  if (a < 0.05) return;
  const o = a * Math.PI / 180, l = r || 0.12, c = i ? 1 : -1, u = e.clone().add(new T(0, -l, 0)), h = e.clone().add(
    new T(c * Math.sin(o) * l, -Math.cos(o) * l, 0)
  );
  mi(
    s,
    pi([e, u], Nt, { lineWidth: 2, dashed: !0 })
  ), mi(s, pi([e, h], Nt, { lineWidth: 2.2 }));
  const d = l * 0.58, f = Math.max(28, Math.round(a * 0.75)), m = [];
  for (let S = 0; S <= f; S += 1) {
    const x = o * (S / f);
    m.push(
      e.clone().add(
        new T(c * Math.sin(x) * d, -Math.cos(x) * d, 0)
      )
    );
  }
  mi(s, pi(m, Nt, { lineWidth: 2.2 }));
  const _ = o * Math.min(0.4, 0.55), g = e.clone().add(
    new T(
      c * Math.sin(_) * d * 1.65,
      -Math.cos(_) * d * 1.65 + l * 0.06,
      0
    )
  ), p = document.createElement("div");
  p.className = "bf-3d-measurement-label", p.textContent = n;
  const M = new sc(p);
  M.position.copy(g), M.renderOrder = Rr + 1, s.add(M);
}
function Ay(s, e, t, n, i, r, a) {
  const o = Number.isFinite(Number(t)) ? Math.abs(Number(t)) : 14;
  if (o < 0.05) return;
  const l = o * Math.PI / 180, c = r || 0.14, u = 1, h = (a || new T(1, 0, 0)).clone().normalize(), d = e.clone().add(h.clone().multiplyScalar(u * c)), f = e.clone().add(h.clone().multiplyScalar(u * Math.cos(l) * c)).add(new T(0, -Math.sin(l) * c, 0));
  mi(s, pi([e, d], Nt, { lineWidth: 2.2 })), mi(s, pi([e, f], Nt, { lineWidth: 2.2 }));
  const m = c * 0.52, _ = Math.max(20, Math.round(o * 1.2)), g = [];
  for (let R = 0; R <= _; R += 1) {
    const w = l * (R / _);
    g.push(
      e.clone().add(h.clone().multiplyScalar(u * Math.cos(w) * m)).add(new T(0, -Math.sin(w) * m, 0))
    );
  }
  mi(s, pi(g, Nt, { lineWidth: 2.2 }));
  const p = l * 0.45, M = e.clone().add(h.clone().multiplyScalar(u * Math.cos(p) * m * 1.55)).add(new T(0, -Math.sin(p) * m * 1.55, 0)), S = document.createElement("div");
  S.className = "bf-3d-measurement-label", S.textContent = n;
  const x = new sc(S);
  x.position.copy(M), x.renderOrder = Rr + 1, s.add(x);
}
function Uo(s, e, t, n, i = "", r = {}) {
  const a = t.x - e.x, o = t.y - e.y, l = t.z - e.z, c = (e.z + t.z) * 0.5, u = e.y + o * 0.88, h = o * 0.36;
  if (Na(r, i)) {
    const M = Je(n, ["ramp angle", "ramp"], {
      exclude: ["overflow"]
    });
    if (!M) return;
    const S = Number.parseFloat(String(M).replace("°", "")) || 14, isUb02 = /UB[-_]?02\b/i.test([i, r.sizeKey].filter(Boolean).join(" ")), wt05Probe = [i, r.sizeKey].filter(Boolean).join(" "), wt05Mesh = (r.meshNames || []).some((nm) => /WT[-_]?05/i.test(String(nm || ""))), overallLenIn = Ct(Je(n, ["overall length", "length"], { exclude: ["inside", "interior", "basin"] })), intBasinLenIn = Ct(Je(n, ["interior basin length"])), isWt05 = /WT[-_]?05[-_]?[AB]/i.test(wt05Probe) || wt05Mesh || /WT[-_]?05/i.test(wt05Probe) || overallLenIn > 46 && overallLenIn < 48 && intBasinLenIn > 23 && intBasinLenIn < 24 && !!Je(n, ["interior basin width"]) && !!Je(n, ["ramp angle"], { exclude: ["overflow"] }), isWt04 = !isWt05 && (/WT[-_]?04/i.test(wt05Probe) || (r.meshNames || []).some((nm) => /WT[-_]?04/i.test(String(nm || ""))) || !!Je(n, ["ramp angle"], { exclude: ["overflow"] }) && !!Je(n, ["interior basin length"])), wt04IsB = /WT[-_]?04[-_]?B/i.test(wt05Probe) || /WT[-_]?05[-_]?B/i.test(wt05Probe) || (r.meshNames || []).some((nm) => /WT[-_]?04[-_]?B/i.test(String(nm || "")) || /WT[-_]?05[-_]?B/i.test(String(nm || "")));
    let x;
    if (isWt05) {
      const g = overallLenIn, p = Ct(Je(n, ["overall width", "width"], { exclude: ["inside", "interior", "basin"] })), intLen = intBasinLenIn, intW = Ct(Je(n, ["interior basin width"])), lenRatio = g && intLen ? Math.min(0.92, Math.max(0.48, intLen / g)) : 0.5, widthRatio = p && intW ? Math.min(0.92, Math.max(0.48, intW / p)) : 0.78, baseLenSpan = a * lenRatio, lenSpan = baseLenSpan * 0.88, lenInset = (baseLenSpan - lenSpan) * 0.5, widthSpan = Math.abs(l) * widthRatio, lenShiftX = a * 0.09, widthShiftZ = l * -0.04, widthCenterZ = c + widthShiftZ, lenStartX = wt04IsB ? t.x - lenSpan - lenShiftX - lenInset : e.x + lenShiftX + lenInset, lenEndX = wt04IsB ? t.x - lenShiftX - lenInset : e.x + lenSpan + lenShiftX + lenInset, rampX = wt04IsB ? lenStartX - lenSpan * 0.04 : lenEndX + lenSpan * 0.04, rampZ = wt04IsB ? widthCenterZ + widthSpan * 0.14 : widthCenterZ - widthSpan * 0.14;
      x = new T(rampX, t.y - o * 0.08, rampZ);
    } else {
      x = isWt04 ? new T(
        wt04IsB ? e.x + a * 0.32 : t.x - a * 0.32,
        t.y - o * 0.08,
        t.z - l * 0.03
      ) : new T(
        t.x - a * (isUb02 ? 0.34 : 0.2),
        t.y - o * 0.08,
        t.z - l * (isUb02 ? 0.22 : 0.04)
      );
    }
    Ay(
      s,
      x,
      S,
      String(M).includes("°") ? M : `${S}°`,
      !0,
      Math.max(0.06, isWt05 ? Math.abs(l) * 0.22 : a * 0.14),
      isWt05 ? new T(wt04IsB ? 1 : -1, 0, 0) : new T(0, 0, -1)
    );
    return;
  }
  const f = Je(n, [
    "lumbar angle left",
    "lumbar left"
  ]), m = Je(n, [
    "lumbar angle right",
    "lumbar right"
  ]);
  if (f || m) {
    const M = /BW-08-S/i.test(String(i || "")), S = M ? 0.05 : 0.12, x = c, R = M ? o * 0.28 : h;
    if (f) {
      const w = Number.parseFloat(f.replace("°", "")) || 0, C = new T(e.x + a * S, u, x);
      No(
        s,
        C,
        w,
        f.includes("°") ? f : `${w}°`,
        !0,
        R
      );
    }
    if (m) {
      const w = Number.parseFloat(m.replace("°", "")) || 0, C = new T(t.x - a * S, u, x);
      No(
        s,
        C,
        w,
        m.includes("°") ? m : `${w}°`,
        !1,
        R
      );
    }
    return;
  }
  const _ = Je(n, ["lumbar", "lumbar angle"], {
    exclude: ["left", "right"]
  });
  if (!_) return;
  const g = Number.parseFloat(_.replace("°", "")) || 28, p = new T(t.x - a * 0.14, u, c);
  No(
    s,
    p,
    g,
    _.includes("°") ? _ : `${g}°`,
    !1,
    h
  );
}
function wy(s, e, t, n) {
  !s || !t || !n || s.traverse((i) => {
    var m;
    if ((m = i.userData) != null && m.lineMaterial && i.userData.lineMaterial.resolution.set(t, n), !i.isCSS2DObject || !i.element) return;
    const { lineStart: r, lineEnd: a } = i.userData;
    if (!r || !a) return;
    Co.copy(r).project(e), Po.copy(a).project(e);
    const o = (Po.x - Co.x) * t * 0.5, l = -(Po.y - Co.y) * n * 0.5;
    let c = Math.atan2(l, o) * 180 / Math.PI;
    c > 90 && (c -= 180), c < -90 && (c += 180);
    const u = Number(i.userData.labelNudgeYPx) || 0, h = Number(i.userData.labelNudgeXPx) || 0, d = [];
    h && d.push(`translateX(${h}px)`), u && d.push(`translateY(-${u}px)`);
    const f = d.length ? ` ${d.join(" ")}` : "";
    i.element.style.transform = `translate(-50%, -50%)${f} rotate(${c.toFixed(2)}deg)`;
  });
}
function Ry({ scene: s, mount: e }) {
  let t = null, n = null, i = [], r = {};
  const a = new cy();
  a.domElement.className = "bf-3d-measurement-labels", a.domElement.style.pointerEvents = "none", e.appendChild(a.domElement);
  function o() {
    t && (s.remove(t), t.traverse((d) => {
      d.geometry && d.geometry.dispose(), d.material && d.material.dispose(), d.element && d.element.remove();
    }), t = null), n = null, a.domElement.style.display = "none";
  }
  function l(d, f = [], m = {}) {
    if (!d || n === d && t && !m.force) return;
    o(), n = d, i = f, r = { productFamily: m.productFamily, modelRoot: m.modelRoot, sizeKey: m.sizeKey, meshNames: m.meshNames };
    const _ = Na(m, d.name);
    wo.setFromObject(d);
    let g = wo.min.clone(), p = wo.max.clone(), M = p.x - g.x, S = p.y - g.y, x = p.z - g.z;
    if (t = new Xn(), t.name = "bf-measurements-overlay", t.renderOrder = Rr, _) {
      const C = Je(f, ["length"], {
        exclude: ["inside", "interior", "basin"]
      }) || '70.8"', P = Je(f, ["width"], {
        exclude: ["inside", "interior", "basin"]
      }) || '35.4"', b = Je(f, ["overall height", "height"], {
        exclude: ["inside", "interior", "basin", "drain", "pipe"]
      }) || '6"';
      let y = Je(f, ["drain pipe", "pipe height"], {
        exclude: ["inside", "interior", "basin", "overall"]
      });
      const L = by(d, m.modelRoot), O = L.min.clone(), U = L.max.clone(), N = Math.max(1e-6, U.x - O.x), Y = Math.max(1e-6, U.z - O.z), G = Math.max(1e-6, U.y - O.y);
      g.x = O.x, p.x = U.x, g.z = O.z, p.z = U.z, M = N, x = Y;
      let ne = Ct(b), B = Ct(y);
      y || (y = '5"', B = 5), ne || (ne = 6);
      const Z = My(d, m.modelRoot), Q = N * 0.02, xe = Y * 0.02, ye = O.x + Q, ce = U.x - Q, V = O.z + xe, se = U.z - xe, re = Math.max(0.055, Math.min(N, Y) * 0.09);
      let He = /UB[-_]?(01|02|03|05)\b/i.test([d.name, m.sizeKey].concat(m.meshNames || []).join(" "));
      if (!He && m.modelRoot && typeof m.modelRoot.traverse == "function") {
        m.modelRoot.traverse((Ue) => {
          He || (He = /UB[-_]?(01|02|03|05)\b/i.test(String(Ue.name || "")));
        });
      }
      let ubBot = O.y, ubTop = U.y;
      if (He && ne) {
        const lengthIn = Ct(C), widthIn = Ct(P), meshH = Math.max(1e-6, U.y - O.y);
        let hw = meshH;
        if (lengthIn > 0 && widthIn > 0) {
          const hwLong = Math.max(N, Y) * (ne / Math.max(lengthIn, widthIn)), hwShort = Math.min(N, Y) * (ne / Math.min(lengthIn, widthIn));
          hw = Math.min(hwLong, hwShort);
        } else if (lengthIn > 0) hw = N * (ne / lengthIn);
        ubTop = O.y + hw, ubBot = O.y;
      }
      if (Z && ne && B) {
        y = y || '5"';
        const X = Math.max(8e-3, Math.min(M, x) * 0.014), de = U.y;
        let be = Z.max.y, Le = Z.min.y;
        const Be = O.y + G * 0.55;
        be > Be && (be = Math.min(be, O.y + G * 0.2)), Le > be && (Le = be - G * 0.85);
        const nt = Z.getCenter(new T()), De = O.x - X, I = Math.min(Math.max(nt.z, V), se), Ue = Math.min(Z.max.x, U.x) + X, Xe = I, Fe = lh(d.name) || lh(m.sizeKey) || (m.meshNames || []).some((nm) => lh(nm));
        let Ae = Fe || He ? O.y : be, ut = de;
        if (He) {
          Ae = ubBot, ut = ubTop;
        }
        Pn(
          t,
          new T(ye, de, U.z + re),
          new T(ce, de, U.z + re),
          C
        ), Pn(
          t,
          new T(U.x + re, de, V),
          new T(U.x + re, de, se),
          P
        ), Pn(
          t,
          new T(De, Ae, I),
          new T(De, ut, I),
          b,
          Fe ? { labelClass: "bf-3d-measurement-label--eswb-height" } : void 0
        ), Pn(
          t,
          new T(Ue, Le, Xe),
          new T(Ue, be, Xe),
          y
        ), g.y = Fe || He ? Ae : Math.min(be, O.y), p.y = de, S = p.y - g.y;
        try {
          Io(t, g, p, de, f, d.name, m), Do(t, g, p, de, f, d.name, m), Uo(t, g, p, f, d.name, m);
        } catch (it) {
          console.error("[bf-3d-configurator] Measurement interior overlay failed", it);
        }
      } else {
        if (ne && M > 0) {
          const be = M * 0.3047232097511427 * 1.08;
          S > be * 1.25 && (g.y = p.y - be, S = be);
        }
        const X = U.y;
        p.y = X;
        const de = lh(d.name);
        let ut = X;
        if (de || He) {
          g.y = O.y;
          S = Math.max(1e-6, X - g.y);
        }
        if (He) {
          g.y = ubBot, ut = ubTop, S = Math.max(1e-6, ut - g.y);
        }
        Pn(
          t,
          new T(ye, X, U.z + re),
          new T(ce, X, U.z + re),
          C
        ), Pn(
          t,
          new T(U.x + re, X, V),
          new T(U.x + re, X, se),
          P
        ), Pn(
          t,
          new T(ye - re, g.y, V - re * 0.35),
          new T(ye - re, ut, V - re * 0.35),
          b,
          de ? { labelClass: "bf-3d-measurement-label--eswb-height" } : void 0
        );
        try {
          Io(t, g, p, X, f, d.name, m), Do(t, g, p, X, f, d.name, m), Uo(t, g, p, f, d.name, m);
        } catch (be) {
          console.error("[bf-3d-configurator] Measurement interior overlay failed", be);
        }
      }
    } else {
      const C = Math.max(0.06, M * 0.045), P = g.y + S * 0.04, b = Je(f, ["length"], { exclude: ["inside", "interior"] }) || '70.8"', y = Je(f, ["width", "depth"], {
        exclude: ["inside", "interior"]
      }) || '35.4"', L = Je(f, ["height"], { exclude: ["inside", "interior"] }) || '24.4"';
      Pn(
        t,
        new T(g.x, P, p.z + C),
        new T(p.x, P, p.z + C),
        b
      ), /BW-09/i.test(String(d.name || "")) ? Ty(t, g, p, P, C, f) : Pn(
        t,
        new T(g.x - C, P, g.z),
        new T(g.x - C, P, p.z),
        y
      ), Pn(
        t,
        new T(g.x - C, g.y, p.z + C * 0.35),
        new T(g.x - C, p.y, p.z + C * 0.35),
        L
      );
      try {
        Io(t, g, p, P, f, d.name, m), Do(t, g, p, P, f, d.name, m), Uo(t, g, p, f, d.name, m);
      } catch (O) {
        console.error("[bf-3d-configurator] Measurement interior overlay failed", O);
      }
    }
    s.add(t), a.domElement.style.display = "";
    const R = e.clientWidth, w = e.clientHeight;
    R && w && t.traverse((C) => {
      var P;
      (P = C.userData) != null && P.lineMaterial && C.userData.lineMaterial.resolution.set(R, w);
    });
  }
  function c() {
    n && l(n, i, { ...r, force: !0 });
  }
  function u(d) {
    if (!t) return;
    const f = e.clientWidth, m = e.clientHeight;
    !f || !m || (wy(t, d, f, m), a.setSize(f, m), a.render(s, d));
  }
  function h() {
    o(), a.domElement.remove();
  }
  return {
    show: l,
    hide: o,
    refresh: c,
    render: u,
    dispose: h,
    isVisible: () => !!t
  };
}
function Cy({
  mount: s,
  measurementsDef: e,
  onMeasurementsClick: t,
  onPinsVisibilityChange: n,
  onTransparencyChange: i
}) {
  const r = s.querySelector("[data-bf-3d-toolbar]"), a = s.querySelector("[data-bf-3d-toolbar-measurements]"), o = s.querySelector("[data-bf-3d-toolbar-hotspots-toggle]"), transparencyButtons = Array.from(s.querySelectorAll("[data-bf-3d-toolbar-transparency]")), l = transparencyButtons[0] || null, c = s.querySelector("[data-bf-3d-vanity-trigger]"), u = s.querySelector("[data-bf-3d-faucet-trigger]"), h = s.querySelector("[data-bf-3d-vanity-panel]"), d = s.querySelector("[data-bf-3d-faucet-panel]"), f = s.querySelector("[data-bf-3d-toolbar-vanity]"), m = s.querySelector("[data-bf-3d-toolbar-faucet]"), _ = s.querySelector("[data-bf-3d-vanity-display]"), g = s.querySelector("[data-bf-3d-sink-options]");
  if (!r)
    return {
      setVisible() {
      },
      setMeasurementsActive() {
      },
      arePinsVisible: () => !0,
      isTransparencyEnabled: () => !1,
      syncTransparencyWithVanity() {
      },
      dispose() {
      }
    };
  let p = !0, M = !1, S = !1;
  function x() {
    if (s.classList.toggle("bf-3d-hotspots--pins-hidden", !p), o) {
      o.classList.toggle("bf-3d-toolbar-btn--pins-hidden", !p), o.setAttribute("aria-pressed", p ? "true" : "false"), o.setAttribute("aria-label", p ? "Hide hotspots" : "Show hotspots"), o.title = "Hotspot";
      const N = o.querySelector(".bf-3d-toolbar-btn__tip");
      N && (N.textContent = "Hotspot");
    }
    n == null || n(p);
  }
  function R() {
    if (!transparencyButtons.length) return;
    const N = M;
    transparencyButtons.forEach((btn) => {
      btn.hidden = !N, btn.setAttribute("aria-hidden", N ? "false" : "true"), btn.setAttribute("aria-checked", S ? "true" : "false"), btn.classList.toggle("is-on", N && S), btn.title = S ? "Transparence on" : "Transparence off", btn.setAttribute(
        "aria-label",
        S ? "Cabinet transparence on" : "Cabinet transparence off"
      );
    });
    s.querySelectorAll("[data-bf-3d-vanity-transparency-row]").forEach((Y) => {
      Y.hidden = !N;
    });
  }
  function w(N) {
    const Y = !!N;
    if (Y === M) {
      R();
      return;
    }
    M = Y, S = M, R(), i == null || i(S);
  }
  function C(N) {
    a == null || a.classList.toggle("is-active", N), o && (o.hidden = N, o.setAttribute("aria-hidden", N ? "true" : "false"));
  }
  function P(N) {
    s.classList.toggle("bf-3d-toolbar-hidden", !N), N && r.removeAttribute("hidden");
  }
  function b() {
    p = !p, x();
  }
  function y(N) {
    N.preventDefault(), N.stopPropagation(), e && (t == null || t());
  }
  function L(N) {
    N.preventDefault(), N.stopPropagation(), M && (S = !S, R(), i == null || i(S));
  }
  function O(N) {
    N.stopPropagation();
  }
  a == null || a.addEventListener("click", y), a == null || a.addEventListener("pointerdown", O), o == null || o.addEventListener("click", (N) => {
    N.preventDefault(), N.stopPropagation(), b();
  }), o == null || o.addEventListener("pointerdown", O), transparencyButtons.forEach((btn) => {
    btn.addEventListener("click", L), btn.addEventListener("pointerdown", O);
  }), [c, u, h, d, f, m, _, g].forEach((N) => {
    N == null || N.addEventListener("pointerdown", O);
  }), e || a == null || a.setAttribute("hidden", ""), x(), R();
  function U() {
    a == null || a.removeEventListener("click", y), transparencyButtons.forEach((btn) => btn.removeEventListener("click", L));
  }
  return {
    setVisible: P,
    setMeasurementsActive: C,
    arePinsVisible: () => p,
    isTransparencyEnabled: () => S,
    syncTransparencyWithVanity: w,
    dispose: U
  };
}
function uh(s) {
  return String(s || "").toLowerCase().replace(/[\s_]+/g, "-");
}
function Py(s, e) {
  if (!s || !e) return null;
  const t = uh(e);
  let n = null;
  return s.traverse((i) => {
    n || uh(i.name) === t && (n = i);
  }), n;
}
function ha(s, e, t) {
  (e || []).forEach((n) => {
    const i = Py(s, n);
    i && (i.visible = t);
  });
}
function Ly(s, e, t = {}) {
  const n = { ...t };
  function i(r, a) {
    if (!s || !e[r]) return;
    n[r] = a;
    const o = e[r], l = o[a] || o;
    if (l.show || l.hide) {
      ha(s, l.hide || [], !1), ha(s, l.show || [], !0);
      return;
    }
    if (o.on && o.off) {
      const u = a === "on" || a === "true" || a === !0 ? o.on : o.off;
      ha(s, u.hide || [], !1), ha(s, u.show || [], !0);
    }
  }
  return Object.keys(e).forEach((r) => {
    const a = n[r];
    a != null && i(r, String(a));
  }), {
    applyState: i,
    getState(r) {
      return n[r];
    }
  };
}
function Ni(s) {
  return String(s || "").toLowerCase().replace(/[\s_]+/g, "-").replace(/\.\d+$/, "");
}
const Iy = {
  "light-stone": { color: 15262422, roughness: 0.82, metalness: 0.02 },
  "dark-stone": { color: 5920336, roughness: 0.82, metalness: 0.02 },
  "oak-wood": { color: 11569512, roughness: 0.75, metalness: 0 }
};
function Dy(s) {
  const e = /* @__PURE__ */ new Map();
  return s == null || s.traverse((t) => {
    if (!t.isMesh || !t.material) return;
    (Array.isArray(t.material) ? t.material : [t.material]).forEach((i) => {
      i != null && i.name && e.set(Ni(i.name), i);
    });
  }), e;
}
function Ny(s, e) {
  if (!s || !(e != null && e.length)) return [];
  const t = new Set(e.map((r) => Ni(r))), n = [];
  s.traverse((r) => {
    t.has(Ni(r.name)) && n.push(r);
  });
  const i = /* @__PURE__ */ new Set();
  return n.forEach((r) => {
    r.isMesh && i.add(
      /** @type {import('three').Mesh} */
      r
    ), r.traverse((a) => {
      a.isMesh && i.add(
        /** @type {import('three').Mesh} */
        a
      );
    });
  }), Array.from(i);
}
function Uy(s) {
  const e = /* @__PURE__ */ new Set(), t = (s == null ? void 0 : s.nativePresets) || {};
  return Object.keys(t).forEach((n) => {
    e.add(Ni(n)), e.add(Ni(t[n]));
  }), e;
}
function Fy(s, e) {
  const t = Ni(e), n = s.get(t);
  if (n) return n;
  const i = Iy[t];
  if (!i) return null;
  const r = new Kn({
    color: i.color,
    roughness: i.roughness,
    metalness: i.metalness,
    name: e
  });
  return s.set(t, r), r;
}
function Oy(s, e, t, n) {
  if (!s || !e || !n) return;
  const r = (e.nativePresets || {})[n] || n, a = Fy(t, r);
  if (!a) {
    console.warn("[bf-3d-configurator] Native material not found:", r);
    return;
  }
  const o = e.meshNames || [], l = Uy(e), c = Ny(s, o);
  if (!c.length) {
    console.warn("[bf-3d-configurator] No meshes matched for native slot:", o);
    return;
  }
  let u = 0;
  c.forEach((h) => {
    var _;
    if (!h.material) return;
    if (Array.isArray(h.material)) {
      let g = !1;
      h.material = h.material.map((p) => {
        if (p != null && p.name && l.has(Ni(p.name))) {
          g = !0;
          const M = a.clone();
          return M.name = r, M.needsUpdate = !0, M;
        }
        return p;
      }), g && (u += 1);
      return;
    }
    const d = (_ = h.material) == null ? void 0 : _.name;
    if (!(d && l.has(Ni(d)))) return;
    const m = a.clone();
    m.name = r, m.needsUpdate = !0, h.material = m, u += 1;
  }), u === 0 && console.warn(
    "[bf-3d-configurator] No Light_Stone/Dark_Stone materials on vanity meshes — countertop tint skipped (cabinet wood preserved)"
  );
}
function By(s, e) {
  const t = Dy(s);
  let n = e.defaultPreset || e.defaultNative || "Light_Stone";
  function i(r) {
    r && (n = r), Oy(s, e, t, n);
  }
  return i(n), {
    apply: i,
    getPreset() {
      return n;
    }
  };
}
const hh = 0.35;
class ky {
  constructor(e, t, n, i, r, a = 1) {
    Object.assign(this, { renderer: e, scene: t, camera: n, layerObject: i, restObject: r, opacity: a }), i.traverse((o) => {
      o.isMesh && (Array.isArray(o.material) ? o.material : [o.material]).forEach((l) => {
        l.transparent = !1, l.opacity = 1, l.depthWrite = !0;
      });
    }), this.compositeScene = new Xl(), this.compositeCamera = new Ia(-1, 1, 1, -1, 0, 1), this.mat = new jn({
      uniforms: {
        tLayer: {},
        tLayerDepth: {},
        tBaseDepth: {},
        opacity: { value: a }
      },
      vertexShader: "varying vec2 vUv; void main(){ vUv = uv; gl_Position = vec4(position.xy,0.,1.); }",
      fragmentShader: `
        uniform sampler2D tLayer, tLayerDepth, tBaseDepth;
        uniform float opacity;
        varying vec2 vUv;
        void main() {
          vec4 layer = texture2D(tLayer, vUv);
          float ld = texture2D(tLayerDepth, vUv).r;
          float bd = texture2D(tBaseDepth, vUv).r;
          float eps = 0.00005;

          // No vanity here, or rest (sink/etc.) is closer — keep canvas pixel as-is.
          if (layer.a < 0.001 || ld > bd + eps) discard;

          // Vanity in front: fade over the already-correct canvas (sink stays unchanged).
          gl_FragColor = vec4(layer.rgb, clamp(layer.a * opacity, 0.0, 1.0));
        }
      `,
      transparent: !0,
      depthTest: !1,
      depthWrite: !1,
      // Vanity layer RT is linear; tone-map only the overlay pixels.
      toneMapped: !0
    }), this.compositeScene.add(new xt(new Gs(2, 2), this.mat)), this.resize(...e.getSize(new ze()).toArray());
  }
  _target(e, t) {
    const n = new Zl(e, t);
    return n.type = Ii, n.minFilter = n.magFilter = en, new Di(e, t, {
      format: mn,
      type: Wn,
      depthTexture: n
    });
  }
  resize(e, t) {
    var a, o;
    const n = this.renderer.getPixelRatio(), i = Math.max(1, e * n | 0), r = Math.max(1, t * n | 0);
    this.baseRT && this.baseRT.width === i && this.baseRT.height === r || ((a = this.baseRT) == null || a.dispose(), (o = this.layerRT) == null || o.dispose(), this.baseRT = this._target(i, r), this.layerRT = this._target(i, r), Object.assign(this.mat.uniforms.tLayer, { value: this.layerRT.texture }), Object.assign(this.mat.uniforms.tLayerDepth, { value: this.layerRT.depthTexture }), Object.assign(this.mat.uniforms.tBaseDepth, { value: this.baseRT.depthTexture }));
  }
  render() {
    const { renderer: e, scene: t, camera: n, layerObject: i, restObject: r } = this;
    this.mat.uniforms.opacity.value = this.opacity;
    const a = e.getClearColor(new He()), o = e.getClearAlpha(), l = t.background, c = e.autoClear;
    i.visible = !1, r.visible = !0, t.background = l, e.setRenderTarget(null), e.autoClear = !0, e.render(t, n), t.background = null, e.setRenderTarget(this.baseRT), e.setClearColor(0, 0), e.clear(!0, !0, !0), e.render(t, n), i.visible = !0, r.visible = !1, e.setRenderTarget(this.layerRT), e.setClearColor(0, 0), e.clear(!0, !0, !0), e.render(t, n), r.visible = !0, t.background = l, e.setRenderTarget(null), e.autoClear = !1, e.render(this.compositeScene, this.compositeCamera), e.autoClear = c, e.setClearColor(a, o);
  }
  dispose() {
    var e, t, n;
    (e = this.baseRT) == null || e.dispose(), (t = this.layerRT) == null || t.dispose(), (n = this.mat) == null || n.dispose(), this.baseRT = null, this.layerRT = null;
  }
}
const dh = new T();
function zy(s) {
  return s ? new Mt().setFromObject(s).getCenter(new T()) : new T(0, 0, 0);
}
function Hy(s, e, t, n = {}) {
  !s || !t || (dh.copy(zy(e)), s.focusOn(dh, {
    distance: t.distance ?? 0.35,
    direction: t.direction || [0, 0.2, 1],
    duration: n.duration ?? t.duration ?? 720
  }));
}
function Vy({ presets: s = [], modelRoot: e, cameraFocus: t }) {
  const n = new Map(s.map((o) => [o.id, o]));
  function i(o, l = {}) {
    const c = n.get(o);
    !c || !t || Hy(t, e, c, l);
  }
  function r(o) {
    return n.get(o) || null;
  }
  function a() {
    var o;
    return n.has("default") ? "default" : n.has("angle") ? "angle" : ((o = s[0]) == null ? void 0 : o.id) || null;
  }
  return {
    applyPreset: i,
    getPreset: r,
    getDefaultPresetId: a,
    getPresets() {
      return s;
    }
  };
}
function Gy({
  steps: s = [],
  hotspots: e = [],
  cameraPresets: t,
  hotspotsController: n,
  mount: i
}) {
  let r = -1;
  const a = new Map(e.map((h) => [h.id, h]));
  function o(h) {
    if (i.querySelectorAll("[data-bf-3d-tour-step]").forEach((d) => {
      d.classList.toggle("is-active", Number(d.dataset.bf3dTourStep) === h);
    }), i.querySelectorAll("[data-bf-3d-hotspot]").forEach((d) => {
      d.classList.remove("is-tour-active");
    }), h >= 0 && h < s.length) {
      const d = s[h], f = d.hotspotId || d.id;
      if (f) {
        const m = i.querySelector(`[data-bf3d-hotspot="${f}"]`);
        m == null || m.classList.add("is-tour-active");
      }
    }
  }
  function l(h) {
    if (!s.length) return;
    const d = Math.max(0, Math.min(s.length - 1, h));
    r = d;
    const f = s[d];
    o(d), f.cameraPreset && t && t.applyPreset(f.cameraPreset);
    const m = f.hotspotId || f.id;
    if (m && (n != null && n.openById))
      n.openById(m);
    else if (m) {
      const _ = a.get(m), g = i.querySelector(`[data-bf3d-hotspot="${m}"]`);
      g == null || g.click(), _ && (n != null && n.focusById) && n.focusById(m);
    }
  }
  function c() {
    l(r < 0 ? 0 : r + 1);
  }
  function u() {
    l(r <= 0 ? 0 : r - 1);
  }
  return {
    goToStep: l,
    nextStep: c,
    prevStep: u,
    getCurrentIndex() {
      return r;
    },
    getStepCount() {
      return s.length;
    }
  };
}
class Wy extends Xl {
  constructor() {
    super();
    const e = new Vs();
    e.deleteAttribute("uv");
    const t = new Kn({ side: an }), n = new Kn(), i = new Zh(16777215, 900, 28, 2);
    i.position.set(0.418, 16.199, 0.3), this.add(i);
    const r = new xt(e, t);
    r.position.set(-0.757, 13.219, 0.717), r.scale.set(31.713, 28.305, 28.591), this.add(r);
    const a = new xt(e, n);
    a.position.set(-10.906, 2.009, 1.846), a.rotation.set(0, -0.195, 0), a.scale.set(2.328, 7.905, 4.651), this.add(a);
    const o = new xt(e, n);
    o.position.set(-5.607, -0.754, -0.758), o.rotation.set(0, 0.994, 0), o.scale.set(1.97, 1.534, 3.955), this.add(o);
    const l = new xt(e, n);
    l.position.set(6.167, 0.857, 7.803), l.rotation.set(0, 0.561, 0), l.scale.set(3.927, 6.285, 3.687), this.add(l);
    const c = new xt(e, n);
    c.position.set(-2.017, 0.018, 6.124), c.rotation.set(0, 0.333, 0), c.scale.set(2.002, 4.566, 2.064), this.add(c);
    const u = new xt(e, n);
    u.position.set(2.291, -0.756, -2.621), u.rotation.set(0, -0.286, 0), u.scale.set(1.546, 1.552, 1.496), this.add(u);
    const h = new xt(e, n);
    h.position.set(-2.193, -0.369, -5.547), h.rotation.set(0, 0.516, 0), h.scale.set(3.875, 3.487, 2.986), this.add(h);
    const d = new xt(e, Ms(50));
    d.position.set(-16.116, 14.37, 8.208), d.scale.set(0.1, 2.428, 2.739), this.add(d);
    const f = new xt(e, Ms(50));
    f.position.set(-16.109, 18.021, -8.207), f.scale.set(0.1, 2.425, 2.751), this.add(f);
    const m = new xt(e, Ms(17));
    m.position.set(14.904, 12.198, -1.832), m.scale.set(0.15, 4.265, 6.331), this.add(m);
    const _ = new xt(e, Ms(43));
    _.position.set(-0.462, 8.89, 14.52), _.scale.set(4.38, 5.441, 0.088), this.add(_);
    const g = new xt(e, Ms(20));
    g.position.set(3.235, 11.486, -12.541), g.scale.set(2.5, 2, 0.1), this.add(g);
    const p = new xt(e, Ms(100));
    p.position.set(0, 20, 0), p.scale.set(1, 0.1, 1), this.add(p);
  }
  /**
   * Frees internal resources. This method should be called
   * when the environment is no longer required.
   */
  dispose() {
    const e = /* @__PURE__ */ new Set();
    this.traverse((t) => {
      t.isMesh && (e.add(t.geometry), e.add(t.material));
    });
    for (const t of e)
      t.dispose();
  }
}
function Ms(s) {
  const e = new hi();
  return e.color.setScalar(s), e;
}
const Xy = 16777215;
function qy(s, e, t = {}) {
  const n = t.color ?? Xy, i = t.sizeMultiplier ?? 2.5, r = t.heightFactor ?? 0.35, a = t.heightOffset ?? 0.12, o = t.debugVisible === !0, l = new Mt().setFromObject(e), c = l.getSize(new T()), u = Math.max(c.x, c.y, c.z, 0.01), h = u * i, d = new Gs(h, h), f = new hi({
    color: n,
    side: In,
    depthWrite: !1,
    depthTest: !1,
    toneMapped: !1
  }), m = new xt(d, f);
  return m.name = "bf-studio-ceiling", m.rotation.x = Math.PI / 2, m.position.set(0, l.max.y + u * r + a, 0), m.visible = o, m.userData.bfDebugVisible = o, m.castShadow = !1, m.receiveShadow = !1, m.frustumCulled = !1, m.renderOrder = -10, s.add(m), m;
}
function fh(s) {
  var t;
  if (!s) return;
  (t = s.geometry) == null || t.dispose();
  const e = s.material;
  Array.isArray(e) ? e.forEach((n) => n == null ? void 0 : n.dispose()) : e == null || e.dispose(), s.removeFromParent();
}
const Yy = "https://www.gstatic.com/draco/versioned/decoders/1.5.7/", jy = window.__bf3dHdrUrl || "https://dl.polyhaven.org/file/ph-assets/HDRIs/hdr/1k/studio_small_09_1k.hdr", Ky = 9e4;
function Zy(s) {
  return s.querySelector("[data-bf-3d-viewport]") || s.querySelector(".bf-3d-configurator__viewer") || s.querySelector(".bf-3d-configurator__stage") || s;
}
function ya(s) {
  if (!s || typeof s != "string") return s;
  const e = s.trim();
  return e.startsWith("//") ? `https:${e}` : e;
}
function $y(s, e) {
  return new Promise((t, n) => {
    s.parse(
      e,
      "",
      (i) => t(i),
      (i) => n(i || new Error("GLTF parse failed"))
    );
  });
}
async function Jy(s) {
  const e = ya(s), t = new AbortController(), n = setTimeout(() => t.abort(), Ky);
  try {
    const i = await fetch(e, {
      mode: "cors",
      credentials: "omit",
      signal: t.signal
    });
    if (!i.ok)
      throw new Error(`HTTP ${i.status} loading model from ${e}`);
    if ((i.headers.get("content-type") || "").includes("text/html"))
      throw new Error(`Model URL returned HTML instead of GLB (${e})`);
    return await i.arrayBuffer();
  } finally {
    clearTimeout(n);
  }
}
async function ph(s, e) {
  const t = await Jy(e);
  return $y(s, t);
}
async function Qy(s, e) {
  const t = new El(s);
  t.compileEquirectangularShader();
  try {
    const n = await new Pv().loadAsync(jy);
    n.mapping = Sa;
    const i = t.fromEquirectangular(n).texture;
    e.environment = i, n.dispose();
  } catch (n) {
    console.warn("[bf-3d-configurator] HDRI failed, using RoomEnvironment fallback", n);
    try {
      const i = new Wy();
      e.environment = t.fromScene(i, 0.04).texture, i.dispose();
    } catch (i) {
      console.warn("[bf-3d-configurator] RoomEnvironment fallback failed", i);
    }
  } finally {
    t.dispose();
  }
}
function eS(s, e) {
  var On, ac, oc, lc, cc, uc, hc, dc, fc;
  const t = Zy(s), n = s.querySelector("[data-bf-3d-canvas]"), i = s.querySelector("[data-bf-3d-poster]"), r = s.querySelector("[data-bf-3d-error]");
  if (!n) return null;
  let a = !1, o = null, l = !1, c = null, u = null, h = null, d = null, f = null, m = null, _ = null, g = null, p = null, M = null, S = null, x = null, R = null, w = !1, C = !1, P = 0;
  const b = 1.5, y = 420, L = new Up(), O = new T(), U = new T(), N = new T(), Y = new Mt(), G = new T(), ne = new T();
  let B = null;
  const Z = e.productFamily === "sink" || s.classList.contains("bf-3d-configurator--sink") || s.dataset.productFamily === "sink" ? "sink" : "bathtub", Q = Z === "sink" ? {
    ...ld,
    ...e.materialSlots || {}
  } : {
    ...od,
    ...e.materialSlots || {}
  };
  Z === "sink" && ((ac = (On = Q.sink) == null ? void 0 : On.meshNames) != null && ac.length) && (Q.sink.meshNames = Q.sink.meshNames.map((D) => {
    const K = String(D || "").match(/ES[-_\s]?WB[-_\s]?(\d+)/i);
    return K ? `ES-WB-${K[1]}` : D;
  })), Z === "sink" && Q.drainCap && !((oc = Q.drainCap.meshNames) != null && oc.length) && (Q.drainCap.meshNames = ["Drain_Cap"]);
  const xe = e.defaultVisibility || {}, ye = ws(Q.sink), ce = Z === "sink" ? {
    sink: {
      colour: e.defaultColour || "white",
      finish: e.defaultFinish || "glossy",
      preset: ye ? fr(
        e.defaultBasinFinish || ((lc = Q.sink) == null ? void 0 : lc.defaultPreset) || "brushed_steel"
      ) : bo(
        e.defaultSinkColour || Rl(e.defaultColour || "white", e.defaultFinish || "glossy")
      )
    },
    faucet: {
      preset: ju(
        e.defaultFaucet || e.defaultHardware || ((cc = Q.faucet) == null ? void 0 : cc.defaultPreset) || "chrome"
      )
    },
    countertop: { preset: e.defaultCountertop || ((uc = Q.countertop) == null ? void 0 : uc.defaultPreset) || "Light_Stone" },
    ...Q.drainCap ? {
      drainCap: {
        preset: ye ? fr(
          e.defaultDrainCap || Q.drainCap.defaultPreset || "brushed_steel"
        ) : e.defaultDrainCap || Q.drainCap.defaultPreset || "chrome"
      }
    } : {}
  } : {
    bathtub: {
      colour: e.defaultColour || "white",
      finish: e.defaultFinish || "matte"
    },
    drainCap: { preset: e.defaultDrainCap || ((hc = Q.drainCap) == null ? void 0 : hc.defaultPreset) || "chrome" },
    faucet: { preset: e.defaultFaucet || ((dc = Q.faucet) == null ? void 0 : dc.defaultPreset) || "chrome" }
  }, V = new Dx({
    canvas: n,
    antialias: !0,
    alpha: !1,
    preserveDrawingBuffer: !0,
    powerPreference: "high-performance"
  });
  V.setClearColor(16250611, 1), V.outputColorSpace = Dt, V.toneMapping = xh, V.toneMappingExposure = 1.12, V.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  const se = new Xl();
  se.background = new He(16119025), d = Ry({ scene: se, mount: t }), f = Cy({
    mount: s,
    measurementsDef: (fc = e.toolbar) == null ? void 0 : fc.measurements,
    onMeasurementsClick: () => {
      var D;
      return (D = u == null ? void 0 : u.openMeasurements) == null ? void 0 : D.call(u);
    },
    onPinsVisibilityChange: () => {
      var D;
      return (D = u == null ? void 0 : u.update) == null ? void 0 : D.call(u);
    },
    onTransparencyChange: (D) => {
      w = !!D, S && (S.visible = !0), x && (x.visible = !0), l && Oe();
    }
  });
  const re = new rn(36, 1, 0.1, 100), X = new Ux(re, n);
  X.enableDamping = !1, X.enablePan = !1, X.enableRotate = !1, X.rotateSpeed = Z === "sink" ? 1.05 : 0.65, X.minDistance = 0.22, X.maxDistance = 6, Z === "sink" ? (X.minPolarAngle = 0, X.maxPolarAngle = Math.PI) : (X.minPolarAngle = 0.28, X.maxPolarAngle = Math.PI / 2 - 0.14), X.target.set(0, 0, 0), X.update(), X.disconnect();
  const de = new T(), be = new Tr(), Le = 1e-4;
  function Be() {
    de.copy(re.position).sub(X.target), be.setFromVector3(de);
  }
  function nt() {
    Z === "sink" ? be.phi = Math.max(
      Le,
      Math.min(Math.PI - Le, be.phi)
    ) : be.phi = Math.max(
      X.minPolarAngle + 1e-3,
      Math.min(X.maxPolarAngle - 1e-3, be.phi)
    ), be.makeSafe(), de.setFromSpherical(be), re.position.copy(X.target).add(de), re.lookAt(X.target), Z !== "sink" && X.update();
  }
  function De() {
    return Be(), {
      target: X.target.clone(),
      spherical: be.clone(),
      radius: be.radius
    };
  }
  function I({ target: D, spherical: K }) {
    X.target.copy(D), be.copy(K), nt();
  }
  h = ly({
    getOrbitState: De,
    setOrbitState: I,
    minDistance: X.minDistance,
    maxDistance: X.maxDistance
  });
  const Ue = t;
  Ue.style.touchAction = "none", n.style.touchAction = "none";
  function Xe() {
    return Z === "sink" && window.matchMedia("(max-width: 989px)").matches;
  }
  function Fe() {
    const D = Xe() ? "pan-y" : "none";
    Ue.style.touchAction = D, n.style.touchAction = D;
  }
  Fe(), window.addEventListener("resize", Fe, { passive: !0 });
  let Ae = null, it = 0, Re = 0, A = !1, v = null, H = null, te = 0, oe = 0, ee = 0, Pe = 0, me = !1, _e = !1, W = !1, J = 0, le = 0, ve = null, Te = null;
  function he(D) {
    return D instanceof Element && !!D.closest(".bf-3d-hotspot");
  }
  function qe(D) {
    Be();
    const K = Math.max(
      X.minDistance,
      Math.min(X.maxDistance, D)
    );
    de.copy(re.position).sub(X.target).normalize().multiplyScalar(K), re.position.copy(X.target).add(de), Be(), X.update();
  }
  function Ve(D) {
    return !!(!D || !Ue.contains(D) || D.closest("[data-bf-3d-toolbar]") || D.closest(".bf-3d-toolbar-btn") || D.closest(".bf-3d-toolbar-switch") || D.closest("[data-bf-3d-hotspot-modal]") || D.closest(".bf-3d-configurator__dock") || D.closest("[data-bf-3d-sink-options]") || D.closest(".bf-3d-viewer-views") || D.closest(".bf-3d-viewer-bottom-bar") || D.closest("[data-bf-3d-scene-style-panel]") || D.closest("[data-bf-3d-scene-style-trigger]") || D.closest("[data-bf-3d-tour-nav]") || D.closest("[data-bf-3d-camera-presets]"));
  }
  function lt(D) {
    if (D.length < 2) return 0;
    const K = D[1].clientX - D[0].clientX, ae = D[1].clientY - D[0].clientY;
    return Math.hypot(K, ae);
  }
  function F() {
    Ae = null, A = !1;
  }
  function ge() {
    H = null, _e = !1, W = !1, J = 0, me = !1, ve = null, Te = null;
  }
  function $() {
    var D;
    (D = u == null ? void 0 : u.hideIconsForInteraction) == null || D.call(u), Z === "sink" && s.dispatchEvent(new CustomEvent("bf3d:camera-user-change", { bubbles: !0 }));
  }
  function ie() {
    var D;
    s.classList.contains("bf-3d-hotspot-popup-open") || s.classList.contains("bf-3d-measurements-active") || (D = u == null ? void 0 : u.scheduleIconsReveal) == null || D.call(u);
  }
  function Me(D) {
    return D.pointerType !== "mouse" || D.button === 0;
  }
  function fe() {
    c != null && c.isOpen() && c.playClose(), u == null || u.dismiss();
  }
  function Ge(D) {
    if (h != null && h.isAnimating()) return;
    const K = D.touches.length;
    if (K >= 2) {
      if (Ve(D.target)) return;
      D.preventDefault(), F(), Te = null, W = !0, _e = !0, H = null, J = lt(D.touches), Be(), le = be.radius, $();
      return;
    }
    if (K === 1) {
      if (Ve(D.target)) return;
      const ae = D.touches[0];
      H = ae.identifier, te = ae.clientX, oe = ae.clientY, ee = ae.clientX, Pe = ae.clientY, _e = !1, me = !1, W = !1, ve = D.target, Te = D.target instanceof Element ? D.target.closest(".bf-3d-hotspot") : null, Be();
    }
  }
  function St(D) {
    if (h != null && h.isAnimating()) return;
    if (W && D.touches.length >= 2) {
      D.preventDefault();
      const wt = lt(D.touches);
      J > 0 && wt > 0 && qe(le / (wt / J)), l && Oe();
      return;
    }
    if (H == null) return;
    const K = Array.from(D.touches).find((wt) => wt.identifier === H);
    if (!K) return;
    const ae = K.clientX - te, Ee = K.clientY - oe, et = K.clientX - ee, tt = K.clientY - Pe;
    if (Xe() && !_e && !W && Math.abs(tt) > 12 && Math.abs(tt) > Math.abs(et) * 1.25) {
      me = !0, H = null;
      return;
    }
    if (me || ((Math.abs(ae) > 4 || Math.abs(Ee) > 4) && (_e || $(), _e = !0, Te = null, D.preventDefault()), !_e)) return;
    te = K.clientX, oe = K.clientY;
    const je = Z === "sink" ? 75e-4 : 5e-3;
    be.theta -= ae * je * X.rotateSpeed, be.phi -= Ee * je * X.rotateSpeed, nt(), l && Oe();
  }
  function Qe(D) {
    const K = W;
    if (W && D.touches.length < 2 && (W = !1, J = 0, D.touches.length === 1)) {
      const Ee = D.touches[0];
      H = Ee.identifier, te = Ee.clientX, oe = Ee.clientY, _e = !1;
    }
    if (D.touches.length > 0) {
      H != null && !Array.from(D.touches).some((Ee) => Ee.identifier === H) && (H = null);
      return;
    }
    const ae = _e || K;
    !ae && Te instanceof HTMLElement ? Te.click() : !ae && ve && !he(ve) && fe(), ge(), ie();
  }
  function ct(D) {
    D.pointerType !== "touch" && Me(D) && (h != null && h.isAnimating() || he(D.target) || Ve(D.target) || (Ae = D.pointerId, it = D.clientX, Re = D.clientY, A = !1, Be(), Ue.setPointerCapture(D.pointerId), D.stopPropagation()));
  }
  function Pt(D) {
    if (D.pointerType === "touch" || Ae === null || D.pointerId !== Ae || h != null && h.isAnimating()) return;
    if (D.buttons === 0) {
      It(D);
      return;
    }
    const K = D.clientX - it, ae = D.clientY - Re;
    (Math.abs(K) > 4 || Math.abs(ae) > 4) && (A || $(), A = !0), it = D.clientX, Re = D.clientY;
    const Ee = Z === "sink" ? 75e-4 : 5e-3;
    be.theta -= K * Ee * X.rotateSpeed, be.phi -= ae * Ee * X.rotateSpeed, nt(), l && Oe(), D.stopPropagation();
  }
  function It(D) {
    if ((D == null ? void 0 : D.pointerType) === "touch" || D && D.pointerId !== Ae) return;
    const K = Ae, ae = A;
    if (Ae = null, A = !1, K != null)
      try {
        Ue.releasePointerCapture(K);
      } catch {
      }
    ae || fe(), ie();
  }
  function Ys(D) {
    if (h != null && h.isAnimating()) return;
    D.preventDefault(), D.stopPropagation(), Be();
    const K = re.position.distanceTo(X.target), ae = Math.max(
      X.minDistance,
      Math.min(X.maxDistance, K + D.deltaY * 2e-3 * K)
    );
    de.copy(re.position).sub(X.target).normalize().multiplyScalar(ae), re.position.copy(X.target).add(de), Be(), X.update(), $(), v && clearTimeout(v), v = setTimeout(() => {
      v = null, ie();
    }, 450), l && Oe();
  }
  const En = { passive: !1, capture: !0 };
  Ue.addEventListener("touchstart", Ge, En), Ue.addEventListener("touchmove", St, En), Ue.addEventListener("touchend", Qe, En), Ue.addEventListener("touchcancel", Qe, En), Ue.addEventListener("pointerdown", ct, !0), Ue.addEventListener("pointermove", Pt, !0), Ue.addEventListener("pointerup", It), Ue.addEventListener("pointercancel", It), window.addEventListener("pointerup", It), window.addEventListener("pointercancel", It), Ue.addEventListener("wheel", Ys, { passive: !1, capture: !0 });
  const $n = new wp(16777215, 15262940, 0.35);
  se.add($n);
  const $i = new Ml(16777215, 0.55);
  $i.position.set(2.5, 4, 3), se.add($i);
  const js = new Ml(16777215, 0.22);
  js.position.set(-2, 1.5, -1), se.add(js), Qy(V, se);
  const Ji = new zu(), Qi = new zu(), Ks = new Rv();
  Ks.setDecoderPath(Yy), Ji.setDRACOLoader(Ks);
  let Tn = 0, Jn = 0, Qn = 0;
  function Zs() {
    const D = Math.max(1, Math.floor(t.clientWidth)), K = Math.max(1, Math.floor(t.clientHeight || Math.round(D * 0.75)));
    if (!D || !K) return !1;
    const ae = V.getPixelRatio(), Ee = Math.floor(D * ae), et = Math.floor(K * ae);
    return Tn === D && Jn === K && V.domElement.width === Ee && V.domElement.height === et ? !1 : (Tn = D, Jn = K, V.setSize(D, K, !1), re.aspect = D / K, re.updateProjectionMatrix(), !0);
  }
  function $s({ force: D = !1 } = {}) {
    !D && !Zs() || (D && Zs(), R && Tn && Jn && R.resize(Tn, Jn), l && Oe());
  }
  function Js({ force: D = !1 } = {}) {
    Qn && cancelAnimationFrame(Qn), Qn = requestAnimationFrame(() => {
      Qn = 0, $s({ force: D });
    });
  }
  function Ua(D) {
    var mc, gc, _c, xc, vc;
    const K = new Mt().setFromObject(D), ae = K.getSize(new T()), Ee = K.getCenter(new T()), tt = 1.22 / (Math.max(ae.x, ae.y, ae.z) || 1);
    D.position.sub(Ee), D.scale.setScalar(tt);
    const je = new Mt().setFromObject(D);
    je.getSize(new T());
    const wt = je.getCenter(new T());
    D.position.sub(wt);
    const Tt = new Mt().setFromObject(D).getSize(new T()), ft = re.fov * Math.PI / 180, xn = re.aspect || 1, An = Z === "sink" ? 0.48 : 0.45, mt = Tt.y * An / Math.tan(ft / 2), dt = Tt.x * An / Math.tan(ft / 2) / xn, Ft = typeof window < "u" && ((mc = window.matchMedia) == null ? void 0 : mc.call(window, "(max-width: 989px)").matches), pc = (((_c = (gc = e == null ? void 0 : e.materialSlots) == null ? void 0 : gc.bathtub) == null ? void 0 : _c.meshNames) || []).some(
      (Pr) => /BW-06-(S|L|XL)|BW-08-S|BW-07/i.test(String(Pr || ""))
    );
    let ts = Ft ? 1.14 : 1.06;
    Ft && pc && (ts = 1.32), Z === "sink" && (ts = Ft ? 1.32 : 1.22);
    let xi = Math.max(mt, dt) * ts;
    if (Z === "sink") {
      const Pr = ((vc = (xc = e == null ? void 0 : e.materialSlots) == null ? void 0 : xc.sink) == null ? void 0 : vc.meshNames) || [], gd = String((e == null ? void 0 : e.sizeKey) || "").toUpperCase(), yc = Pr.some((Oa) => /WT[-_]?0[12]/i.test(String(Oa || ""))) || /WT[-_]?02/i.test(gd), _d = /UB-04-(XL|XXL|40)\b/.test(gd) || Pr.some((Oa) => /UB-04-(XL|XXL)\b/i.test(String(Oa || "")));
      xi = yc ? 2.65 : 1.45, !yc && Ft && _d && (xi = 1.67);
    }
    X.target.set(0, Z === "sink" ? Tt.y * 0.02 : 0, 0), re.position.set(
      Z === "sink" ? xi * 0.18 : 0,
      Tt.y * (Z === "sink" ? 0.1 : 0.04),
      xi
    ), re.lookAt(X.target), X.update(), Be();
  }
  function Oi() {
    if (o) {
      if (Z === "sink") {
        Jv(o, ce.sink.preset, Q.sink);
        const D = Q.faucet || Q.hardware;
        D && Rs(o, D, ce.faucet.preset), Q.drainCap && ce.drainCap && Rs(o, Q.drainCap, ce.drainCap.preset), g == null || g.apply(ce.countertop.preset);
        return;
      }
      $v(
        o,
        ce.bathtub.colour,
        ce.bathtub.finish,
        Q.bathtub
      ), Rs(o, Q.drainCap, ce.drainCap.preset), Rs(o, Q.faucet, ce.faucet.preset);
    }
  }
  function Fa() {
    var K, ae, Ee, et, tt, je, wt;
    if (!o) return;
    if (Z !== "sink") {
      var bfTubPresets = e.cameraPresets;
      if (bfTubPresets != null && bfTubPresets.length && h) {
        p = Vy({ presets: bfTubPresets, modelRoot: o, cameraFocus: h });
        var bfTubDefault = p.getDefaultPresetId();
        if (bfTubDefault) { p.applyPreset(bfTubDefault, { duration: 0 }); if (h.resetSavedView) h.resetSavedView(); }
      }
      return;
    }
    const D = {
      vanity: xe.vanity === !0 ? "on" : "off",
      faucetStyle: xe.faucetStyle || (xe.wallFaucet === !0 ? "wall" : "none"),
      ...(K = e.visibilityGroups) != null && K.drainType ? { drainType: xe.drainType || "cast" } : {},
      tailPiece: xe.tailPiece === !1 ? "off" : "on",
      extra: "off"
    };
    if (e.visibilityGroups && (_ = Ly(
      o,
      e.visibilityGroups,
      D
    )), ((ae = Q.countertop) == null ? void 0 : ae.mode) === "nativeGlb" && (g = By(o, Q.countertop)), Z === "sink" && S && x && !R) {
      const pt = Number(e.vanityCabinetOpacity ?? hh);
      R = new ky(
        V,
        se,
        re,
        S,
        x,
        Number.isFinite(pt) ? pt : hh
      ), Tn && Jn && R.resize(Tn, Jn);
    }
    if ((Ee = e.cameraPresets) != null && Ee.length && h) {
      let pt = e.cameraPresets;
      const Tt = ((tt = (et = e == null ? void 0 : e.materialSlots) == null ? void 0 : et.sink) == null ? void 0 : tt.meshNames) || [], ft = String((e == null ? void 0 : e.sizeKey) || "").toUpperCase(), xn = /UB-04-(XL|XXL|40)\b/.test(ft) || Tt.some((dt) => /UB-04-(XL|XXL)\b/i.test(String(dt || ""))), An = typeof window < "u" && ((je = window.matchMedia) == null ? void 0 : je.call(window, "(max-width: 989px)").matches), wt01XlCam = /WT[-_]?01[-_]?XL/i.test(ft) || Tt.some((dt) => /WT[-_]?01[-_]?XL/i.test(String(dt || ""))), wt01LCam = !wt01XlCam && (/WT[-_]?01[-_]?L(?:\b|$|[^A-Z])/i.test(ft) || Tt.some((dt) => /WT[-_]?01[-_]?L(?:\b|$|[^A-Z])/i.test(String(dt || ""))));
      Z === "sink" && xn && An && (pt = pt.map((dt) => ({
        ...dt,
        distance: (dt.distance ?? 1.45) * 1.15
      }))), Z === "sink" && An && wt01XlCam && (pt = pt.map((dt) => ({
        ...dt,
        distance: (dt.distance ?? 3) * 1.22
      }))), Z === "sink" && An && wt01LCam && (pt = pt.map((dt) => ({
        ...dt,
        distance: (dt.distance ?? 3) * 1.05
      }))), p = Vy({
        presets: pt,
        modelRoot: o,
        cameraFocus: h
      });
      const mt = p.getDefaultPresetId();
      mt && (p.applyPreset(mt, { duration: 0 }), (wt = h.resetSavedView) == null || wt.call(h));
    }
  }
  function E() {
    var D;
    !((D = e.tourSteps) != null && D.length) || Z !== "sink" || (M = Gy({
      steps: e.tourSteps,
      hotspots: e.hotspots || [],
      cameraPresets: p,
      mount: s
    }));
  }
  function k() {
    var D;
    !o || ((D = e.studioCeiling) == null ? void 0 : D.enabled) === !1 || (fh(m), m = null, m = qy(se, o, e.studioCeiling || {}));
  }
  function q(D, K) {
    if (Z === "sink") {
      if (ws(Q.sink))
        return;
      D && (ce.sink.colour = D), K && (ce.sink.finish = K);
      const ae = Rl(ce.sink.colour, ce.sink.finish);
      ce.sink.preset = bo(ae), Oi(), l && Oe();
      return;
    }
    D && (ce.bathtub.colour = D), K && (ce.bathtub.finish = K), Oi(), l && Oe();
  }
  function j(D, K) {
    if (Z === "sink") {
      if (D === "sink")
        if (ws(Q.sink))
          ce.sink.preset = fr(K);
        else {
          ce.sink.preset = bo(K);
          const ae = String(ce.sink.preset || "").split("_");
          ae.length >= 2 && (ce.sink.finish = ae[0], ce.sink.colour = ae.slice(1).join("_"));
        }
      (D === "faucet" || D === "hardware") && (ce.faucet.preset = ju(K)), D === "drainCap" && ce.drainCap && (ce.drainCap.preset = ws(Q.drainCap) ? fr(K) : K), D === "countertop" && (ce.countertop.preset = K, g == null || g.apply(K)), D !== "countertop" ? Oi() : l && Oe();
      return;
    }
    D !== "bathtub" && (D === "drainCap" && (ce.drainCap.preset = K), D === "faucet" && (ce.faucet.preset = K), Oi(), l && Oe());
  }
  function z() {
    P && (cancelAnimationFrame(P), P = 0);
  }
  function ue(D, K = y) {
    z(), Be();
    const ae = re.position.distanceTo(X.target), Ee = performance.now(), et = (tt) => {
      if (a) {
        P = 0;
        return;
      }
      const je = Math.min(1, (tt - Ee) / Math.max(1, K)), wt = 1 - (1 - je) ** 3;
      qe(ae + (D - ae) * wt), l && Oe(), je < 1 ? P = requestAnimationFrame(et) : P = 0;
    };
    P = requestAnimationFrame(et);
  }
  function Se(D) {
    if (Z !== "sink" || !l) return;
    Be();
    const K = re.position.distanceTo(X.target);
    D && !C ? (C = !0, qe(K * b)) : !D && C && (C = !1, ue(K / b));
  }
  function we() {
    var Ee, et;
    if (Z !== "sink" || !R || !S || !x)
      return;
    const D = ((Ee = _ == null ? void 0 : _.getState) == null ? void 0 : Ee.call(_, "vanity")) || "off", K = ((et = _ == null ? void 0 : _.getState) == null ? void 0 : et.call(_, "faucetStyle")) || "none", ae = w;
    _ == null || _.applyState("vanity", "on"), K === "none" && (_ == null || _.applyState("faucetStyle", "vanity")), S.visible = !0, x.visible = !0, w = !0;
    try {
      R.render(), R.render();
    } catch {
    }
    _ == null || _.applyState("vanity", D), _ == null || _.applyState("faucetStyle", K), w = ae, S.visible = !0, x.visible = !0, V.setRenderTarget(null), V.render(se, re);
  }
  function Ce() {
    if (Z !== "sink" || !R) return;
    const D = () => {
      var Ee, et;
      if (a || !R || !S || !x) return;
      if (w) {
        try {
          R.render();
        } catch {
        }
        return;
      }
      const K = ((Ee = _ == null ? void 0 : _.getState) == null ? void 0 : Ee.call(_, "vanity")) || "off", ae = ((et = _ == null ? void 0 : _.getState) == null ? void 0 : et.call(_, "faucetStyle")) || "none";
      _ == null || _.applyState("vanity", "on"), ae === "none" && (_ == null || _.applyState("faucetStyle", "vanity")), S.visible = !0, x.visible = !0, w = !0;
      try {
        R.render();
      } catch {
      }
      _ == null || _.applyState("vanity", K), _ == null || _.applyState("faucetStyle", ae), w = !1, S.visible = !0, x.visible = !0, V.setRenderTarget(null), V.render(se, re);
    };
    typeof requestIdleCallback == "function" ? requestIdleCallback(D, { timeout: 1200 }) : setTimeout(D, 0);
  }
  function We(D, K) {
    var ae, Ee, et;
    if (_ == null || _.applyState(D, K), D === "vanity" && Z === "sink") {
      const tt = K === "on" || K === "true" || K === !0;
      Se(tt), (ae = f == null ? void 0 : f.syncTransparencyWithVanity) == null || ae.call(f, tt);
    }
    D === "tailPiece" && Z === "sink" && ((Ee = d == null ? void 0 : d.isVisible) != null && Ee.call(d)) && ((et = d.refresh) == null || et.call(d)), l && Oe();
  }
  function ke(D) {
    p == null || p.applyPreset(D);
  }
  function Ie(D) {
    const K = Math.max(0.05, D), ae = Math.min(0.1, Math.max(8e-3, K * 0.12)), Ee = Math.max(50, K * 40);
    (Math.abs(re.near - ae) > 5e-4 || Math.abs(re.far - Ee) > 0.5) && (re.near = ae, re.far = Ee, re.updateProjectionMatrix());
  }
  function st() {
    Be(), Ie(re.position.distanceTo(X.target));
  }
  function ut(D = {}) {
    z();
    let K = D.distance;
    if (D.zoomOut) {
      Be();
      const Ee = typeof D.zoomOutScale == "number" ? D.zoomOutScale : 1.08;
      K = Math.min(
        X.maxDistance,
        Math.max(be.radius * Ee, D.distance ?? 2.8)
      );
    } else K == null ? K = Math.max(
      0.14,
      X.minDistance * 0.18,
      Math.min(X.maxDistance, 0.37)
    ) : K = Math.max(
      0.14,
      X.minDistance * 0.18,
      Math.min(X.maxDistance, K)
    );
    Ie(K);
    const ae = D.onComplete;
    return D.onComplete = () => {
      st(), typeof ae == "function" && ae();
    }, D;
  }
  function Rt() {
    if (h != null && h.isAnimating() || st(), R && w) {
      R.render();
      return;
    }
    S && (S.visible = !0), x && (x.visible = !0), V.setRenderTarget(null), V.autoClear = !0, V.render(se, re);
  }
  function At() {
    s.classList.add("is-ready"), i && window.setTimeout(() => {
      i.hidden = !0;
    }, 420), f == null || f.setVisible(!0), $s({ force: !0 }), X.update(), Rt();
  }
  function Oe() {
    var D;
    if (!a)
      try {
        Zs();
        const K = L.getDelta(), ae = Lt();
        l && (!Ut || ae) && (h == null || h.update(), c == null || c.update(K), u == null || u.update()), X.update(), Rt(), (D = d == null ? void 0 : d.isVisible) != null && D.call(d) && d.render(re);
      } catch (K) {
        console.error("[bf-3d-configurator] Render error", K);
      }
  }
  function Ne(D) {
    const K = [], ae = [];
    D.traverse((Ee) => {
      if (Ee.isMesh) {
        const et = Array.isArray(Ee.material) ? Ee.material : [Ee.material];
        K.push({
          mesh: Ee.name,
          materials: et.map((tt) => tt == null ? void 0 : tt.name).filter(Boolean)
        });
      } else Ee.name && /empty/i.test(Ee.name) && ae.push(Ee.name);
    }), console.info("[bf-3d-configurator] Model nodes", { meshes: K, anchors: ae });
  }
  function Lt() {
    return !!document.querySelector(".product-information.bf-3d-media-active[data-bf-3d-hybrid-product]");
  }
  function ht(D) {
    s.classList.add("has-error"), i && (i.hidden = !1), r && (r.hidden = !1, D && (r.textContent = D));
  }
  function $t(D, K) {
    if (!D || !K) return null;
    const ae = String(K), Ee = ae.toLowerCase();
    let et = null, tt = null;
    return D.traverse((je) => {
      je != null && je.name && (!et && je.name === ae ? et = je : (!tt && je.name.toLowerCase() === Ee || !tt && je.name.toLowerCase().includes(Ee.replace(/^bathtub-/, "")) && /bathtub/i.test(je.name)) && (tt = je));
    }), et || tt;
  }
  function ei(D) {
    var wt, pt;
    if (Z === "sink") {
      const Tt = /vanity|faucet|extra|wall_mounted|drain_|ceiling|light|hotspot|empty|locator/i;
      let ft = null, xn = 0;
      const An = new T(), mt = new Mt();
      if (o == null || o.traverse((Ft) => {
        if (!Ft.isMesh || !Ft.material || Tt.test(String(Ft.name || "")) || !(Array.isArray(Ft.material) ? Ft.material : [Ft.material]).some((xi) => /sink[_-]?material/i.test(String((xi == null ? void 0 : xi.name) || "")))) return;
        mt.setFromObject(Ft, !0), mt.getSize(An);
        const ts = An.x * An.z;
        ts > xn && (xn = ts, ft = Ft);
      }), ft) return ft;
      const dt = ((pt = (wt = e == null ? void 0 : e.materialSlots) == null ? void 0 : wt.sink) == null ? void 0 : pt.meshNames) || [];
      for (const Ft of dt) {
        const Cr = $t(o, Ft);
        if (Cr) return Cr;
      }
    }
    const K = $t(o, D);
    if (K) return K;
    const ae = Z === "sink" ? /vanity|faucet|extra|wall_mounted|drain_/i : null;
    let Ee = null, et = 0;
    const tt = new T(), je = new Mt();
    return o == null || o.traverse((Tt) => {
      if (!Tt.isMesh || ae && ae.test(String(Tt.name || ""))) return;
      je.setFromObject(Tt), je.getSize(tt);
      const ft = tt.x * tt.y * tt.z;
      ft > et && (et = ft, Ee = Tt);
    }), Ee || o;
  }
  function Wt(D) {
    var et, tt;
    const K = ((tt = (et = e == null ? void 0 : e.materialSlots) == null ? void 0 : et.bathtub) == null ? void 0 : tt.meshNames) || [];
    let ae = null;
    for (const je of K)
      if (ae = $t(o, je), ae) break;
    ae = ae || ei(K[0] || ""), Y.setFromObject(ae), Y.getCenter(ne), Y.getSize(G), U.set(
      ne.x,
      Y.min.y + G.y * 0.36,
      ne.z
    ), N.copy(U).sub(D), N.lengthSq() < 1e-6 ? N.set(0, 0.22, 0.97) : N.normalize();
    const Ee = [N.x, N.y, N.z];
    return {
      overview: { distance: 0.1, direction: Ee, duration: 820 },
      detail: { distance: 0.038, direction: Ee, duration: 680 }
    };
  }
  function Bi(D) {
    if (!(!o || a))
      try {
        c == null || c.dispose(), u == null || u.dispose(), e.drainAnimation && (c = ty({
          modelRoot: o,
          gltf: D,
          config: e.drainAnimation || {}
        })), u = ry({
          modelRoot: o,
          mount: s,
          viewport: t,
          camera: re,
          config: e,
          getPinsVisible: () => {
            var K;
            return ((K = f == null ? void 0 : f.arePinsVisible) == null ? void 0 : K.call(f)) ?? !0;
          },
          onMeasurementsState: (K) => {
            var ae;
            return (ae = f == null ? void 0 : f.setMeasurementsActive) == null ? void 0 : ae.call(f, K);
          },
          onDismiss(K = {}) {
            d == null || d.hide(), c != null && c.isOpen() && c.playClose(), K.restoreCamera && (z(), h == null || h.restore(() => st()));
          },
          onPopupChange(K) {
            if (K != null && K.showDimensionLines && o) {
              const ae = K.focusMesh || K.node, Ee = ei(ae);
              if (Ee) {
                d == null || d.show(Ee, K.measurements, { productFamily: Z, modelRoot: o, sizeKey: e.sizeKey, meshNames: ((e.materialSlots || {}).sink || {}).meshNames });
                return;
              }
            }
            d == null || d.hide();
          },
          onLayoutChange() {
            Js({ force: !0 });
          },
          onFocus(K, ae) {
            var xn, An;
            let Ee = K;
            if (ae.focusMesh && o) {
              const mt = $t(o, ae.focusMesh);
              mt && (Ee = mt);
            }
            Ee ? Ee.getWorldPosition(O) : O.set(0, 0, 0);
            const et = ((An = (xn = e == null ? void 0 : e.materialSlots) == null ? void 0 : xn.bathtub) == null ? void 0 : An.meshNames) || [], tt = et.some(
              (mt) => /BW-06-(S|L|XL)|BW-08-S|BW-12/i.test(String(mt || ""))
            ), je = et.some((mt) => /BW-09/i.test(String(mt || ""))), wt = ae.id === "measurements" || !!ae.showDimensionLines, pt = t.clientWidth <= 989, Wd = s.classList.contains("bf-3d-configurator--with-dock"), Tt = (mt = {}) => {
              const dt = { ...mt };
              if (dt.distance == null) return dt;
              if (wt && (Z === "sink" || Wd))
                return pt ? dt.distance = Math.max(dt.distance * 1.18, 1.05) : dt.distance = Math.max(dt.distance * 1.4, 1.9), dt;
              const Ft = String(ae.id || "").toLowerCase();
              return Z === "sink" && pt && Ft === "stone_resin" ? (dt.distance = Math.max(dt.distance * 0.55, 0.16), dt) : Z === "sink" && pt && Ft === "wall_bracket" ? (dt.distance = Math.max(dt.distance * 0.88, 0.7), dt) : (pt && (dt.zoomOut ? dt.distance = Math.max(dt.distance * 1.35, 3.8) : dt.distance = Math.max(dt.distance * 2.2, 0.26)), dt);
            };
            let ft = Tt({ ...ae.focus || {} });
            const wt02MeshList = ((An = (xn = e == null ? void 0 : e.materialSlots) == null ? void 0 : xn.sink) == null ? void 0 : An.meshNames) || [], wt02Overflow = ae.id === "overflow" && (/WT[-_]?02/i.test(String((e == null ? void 0 : e.sizeKey) || "")) || wt02MeshList.some((mt) => /WT[-_]?02/i.test(String(mt || "")))), wt01Overflow = ae.id === "overflow" && (/WT[-_]?01/i.test(String((e == null ? void 0 : e.sizeKey) || "")) || wt02MeshList.some((mt) => /WT[-_]?01/i.test(String(mt || "")))), wt02Bracket = ae.id === "wall_bracket" && (/WT[-_]?02/i.test(String((e == null ? void 0 : e.sizeKey) || "")) || wt02MeshList.some((mt) => /WT[-_]?02/i.test(String(mt || "")))), wt02B = /WT[-_]?02[-_]?B/i.test(String((e == null ? void 0 : e.sizeKey) || "")) || wt02MeshList.some((mt) => /WT[-_]?02[-_]?B/i.test(String(mt || ""))), wt02C = /WT[-_]?02[-_]?C/i.test(String((e == null ? void 0 : e.sizeKey) || "")) || wt02MeshList.some((mt) => /WT[-_]?02[-_]?C/i.test(String(mt || ""))), wt02D = /WT[-_]?02[-_]?D/i.test(String((e == null ? void 0 : e.sizeKey) || "")) || wt02MeshList.some((mt) => /WT[-_]?02[-_]?D/i.test(String(mt || "")));
            wt02Overflow && (ft = Tt({ distance: 0.085, direction: wt02B || wt02C || wt02D ? [0.56, 0.55, 0.68] : [-0.38, 0.48, 0.78], duration: 720 })), wt01Overflow && (O.x += 0.07, ft = Tt({ distance: 0.2, direction: [-0.48, 0.38, 0.78], duration: 720 })), wt02Bracket && (ft = Tt({ distance: 1.2, direction: [-0.78, -0.35, 0.52], duration: 720 }));
            if (!(wt && Wd) && wt && ae.focusMode === "zoom-out")
              ft = { ...ae.focus || {}, zoomOut: !0 };
            else if (!(wt && Wd) && ae.focusMode === "zoom-out")
              ft.zoomOut = !0, ft = Tt(ft);
            if (tt && ae.id === "overflow" && !ae._overflowDetailOnly) {
              const mt = Tt({
                distance: 0.14,
                direction: [-0.42, 0.72, 0.48],
                duration: 820
              }), dt = Tt({
                distance: 0.048,
                direction: [-0.92, 0.28, 0.18],
                duration: 680
              });
              ft = {
                ...mt,
                onComplete: () => {
                  h == null || h.focusOn(O, ut({ ...dt }));
                }
              };
            } else if (tt && ae.id === "overflow" && ae._overflowDetailOnly)
              ft = Tt({
                distance: 0.048,
                direction: [-0.92, 0.28, 0.18],
                duration: 680,
                ...ae.focus || {}
              });
            else if (je && ae.id === "overflow" && !ae._overflowDetailOnly) {
              const mt = Wt(O), dt = Tt(mt.overview), Ft = Tt(mt.detail);
              ft = {
                ...dt,
                onComplete: () => {
                  h == null || h.focusOn(O, ut({ ...Ft }));
                }
              };
            } else if (je && ae.id === "overflow" && ae._overflowDetailOnly) {
              const mt = Wt(O);
              ft = Tt({
                ...mt.detail,
                ...ae.focus || {}
              });
            }
            if (ae.id === "overflow" && B && !ae._overflowDetailOnly)
              ft = { ...B };
            else if (ae.id === "overflow" && !ae._overflowDetailOnly) {
              const mt = { ...ft };
              if (delete mt.onComplete, tt || je) {
                const dt = ft.onComplete;
                ft.onComplete = () => {
                  dt == null || dt(), B = { ...Tt(je ? Wt(O).detail : {
                    distance: 0.048,
                    direction: [-0.92, 0.28, 0.18],
                    duration: 680
                  }) }, delete B.onComplete;
                };
              } else
                B = mt;
            }
            if (ae.animation) {
              const mt = ft.onComplete;
              ft.onComplete = () => {
                mt == null || mt(), c == null || c.playOpen();
              };
            }
            h == null || h.focusOn(O, ut(ft));
          }
        }), Lt() && (u.setVisible(!0), f == null || f.setVisible(!0));
      } catch (K) {
        console.error("[bf-3d-configurator] Hotspot setup failed", K);
      }
  }
  async function Et(D) {
    const K = ya(D);
    let ae = null, Ee = null;
    const et = [
      { label: "draco-fetch", run: () => ph(Ji, K) },
      { label: "plain-fetch", run: () => ph(Qi, K) },
      { label: "draco-loadAsync", run: () => Ji.loadAsync(K) }
    ];
    for (const je of et)
      try {
        ae = await je.run();
        break;
      } catch (wt) {
        Ee = wt, console.warn(`[bf-3d-configurator] ${je.label} failed for`, K, wt);
      }
    if (!ae)
      throw Ee || new Error(`Could not load model from ${K}`);
    if (a) return null;
    if (o = ae.scene, S = null, x = null, R == null || R.dispose(), R = null, Z === "sink") {
      S = new Xn(), S.name = "VanityLayer", x = new Xn(), x.name = "RestLayer", [...o.children].forEach((pt) => {
        x.add(pt);
      }), o.add(S, x);
      let je = null;
      x.traverse((pt) => {
        !je && pt.name === "Vanity" && (je = pt);
      }), je ? S.attach(je) : console.warn(
        '[bf-3d-configurator] No object named "Vanity" found for TransparentLayer split — cabinet will stay opaque'
      );
      const wt = [];
      S.traverse((pt) => {
        if (!pt.isMesh || !pt.material) return;
        (Array.isArray(pt.material) ? pt.material : [pt.material]).forEach((ft) => {
          const xn = String((ft == null ? void 0 : ft.name) || "").toLowerCase().replace(/[\s_]+/g, "-").replace(/\.\d+$/, "");
          (xn === "light-stone" || xn === "dark-stone") && wt.push({ mesh: pt.name || "(unnamed)", material: ft.name });
        });
      }), wt.length ? console.warn(
        "[bf-3d-configurator] Vanity layer mesh(es) also carry stone materials — countertop may fade with the cabinet. Split wood vs stone in Blender.",
        wt
      ) : console.info("[bf-3d-configurator] Vanity/rest layer split", {
        vanityChildren: S.children.map((pt) => pt.name),
        restChildren: x.children.map((pt) => pt.name)
      });
    }
    se.add(o), B = null, Ua(o), Ne(o), k(), Oi(), Fa(), l = !0, we(), At(), Bi(ae), E(), Ut = !1;
    const tt = Lt();
    return f == null || f.setVisible(!0), u == null || u.setVisible(tt || !document.querySelector("[data-bf-3d-hybrid-gallery]")), n.style.pointerEvents = "auto", Oe(), s.dispatchEvent(new CustomEvent("bf3d:ready", { bubbles: !0 })), Ce(), o;
  }
  async function on() {
    const D = ya(e.modelUrl), K = ya(e.modelUrlFallback);
    if (!D && !K) {
      ht("3D model could not load."), console.error("[bf-3d-configurator] No model URL configured");
      return;
    }
    const ae = [D, K].filter(Boolean);
    let Ee = null;
    for (const tt of ae)
      try {
        await Et(tt);
        return;
      } catch (je) {
        Ee = je, console.warn("[bf-3d-configurator] Model load failed, trying next URL", tt, je);
      }
    const et = (Ee == null ? void 0 : Ee.message) || "Unknown error";
    ht("3D model could not load. Please refresh the page."), console.error("[bf-3d-configurator] All model URLs failed", { urls: ae, message: et, lastError: Ee }), s.dispatchEvent(new CustomEvent("bf3d:error", { bubbles: !0, detail: { message: et } }));
  }
  let tn = 0, Ut = !1;
  function Xt() {
    a || (tn = requestAnimationFrame(Xt), l && Oe());
  }
  const es = new ResizeObserver(() => Js());
  return es.observe(t), $s({ force: !0 }), Xt(), on(), {
    setConfiguration(D, K) {
      q(D, K);
    },
    setSlotPreset(D, K) {
      j(D, K);
    },
    setVisibilityGroup(D, K) {
      We(D, K);
    },
    setVanityTransparency(D) {
      w = !!D, S && (S.visible = !0), x && (x.visible = !0), l && Oe();
    },
    syncTransparencyWithVanity(D) {
      var K;
      (K = f == null ? void 0 : f.syncTransparencyWithVanity) == null || K.call(f, !!D);
    },
    setCameraPreset(D) {
      ke(D);
    },
    goToTourStep(D) {
      M == null || M.goToStep(D);
    },
    nextTourStep() {
      M == null || M.nextStep();
    },
    prevTourStep() {
      M == null || M.prevStep();
    },
    getConfiguration() {
      return Z === "sink" ? {
        colour: ce.sink.colour,
        finish: ce.sink.finish,
        sinkColour: ce.sink.preset,
        faucet: ce.faucet.preset,
        countertop: ce.countertop.preset,
        ...ce.drainCap ? { drainCap: ce.drainCap.preset } : {}
      } : {
        colour: ce.bathtub.colour,
        finish: ce.bathtub.finish,
        drainCap: ce.drainCap.preset,
        faucet: ce.faucet.preset
      };
    },
    pause() {
      Ut = !0;
    },
    resume() {
      a || (Ut = !1, L.getDelta(), Js({ force: !0 }), f == null || f.setVisible(!0), (Lt() || !document.querySelector("[data-bf-3d-hybrid-gallery]")) && (u == null || u.setVisible(!0)), n.style.pointerEvents = "auto", Oe());
    },
    setHotspotsVisible(D) {
      if (f == null || f.setVisible(D), D) {
        u == null || u.setVisible(!0);
        return;
      }
      if (u == null || u.setVisible(!1), l)
        try {
          c == null || c.reset();
        } catch (K) {
          console.warn("[bf-3d-configurator] Drain reset failed", K);
        }
    },
    dispose() {
      a = !0, P && cancelAnimationFrame(P), P = 0, u == null || u.dispose(), f == null || f.dispose(), d == null || d.dispose(), c == null || c.dispose(), R == null || R.dispose(), R = null, fh(m), m = null, cancelAnimationFrame(tn), Qn && cancelAnimationFrame(Qn), es.disconnect(), Ue.removeEventListener("touchstart", Ge, En), Ue.removeEventListener("touchmove", St, En), Ue.removeEventListener("touchend", Qe, En), Ue.removeEventListener("touchcancel", Qe, En), Ue.removeEventListener("pointerdown", ct, !0), Ue.removeEventListener("pointermove", Pt, !0), Ue.removeEventListener("pointerup", It), Ue.removeEventListener("pointercancel", It), Ue.removeEventListener("wheel", Ys, { capture: !0 }), window.removeEventListener("pointerup", It), window.removeEventListener("pointercancel", It), X.dispose(), V.dispose(), se.traverse((D) => {
        var K;
        D.isMesh && ((K = D.geometry) == null || K.dispose(), (Array.isArray(D.material) ? D.material : [D.material]).forEach((Ee) => Ee == null ? void 0 : Ee.dispose()));
      });
    }
  };
}
const Il = /* @__PURE__ */ new WeakMap();
function tS(s) {
  const e = s.querySelector("[data-bf-3d-config]");
  if (!e) return {};
  try {
    const t = String(e.textContent || "{}").replace(/^\uFEFF/, "").trim();
    return JSON.parse(t || "{}");
  } catch (t) {
    return console.error("[bf-3d-configurator] Invalid data-bf-3d-config JSON", t), {};
  }
}
function nS() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
function iS(s, e) {
  if (!("IntersectionObserver" in window)) return;
  const t = s.querySelector("[data-bf-3d-viewport]") || s, n = new IntersectionObserver(
    (i) => {
      i.forEach((r) => {
        r.isIntersecting && e.resume();
      });
    },
    { threshold: 0.05 }
  );
  n.observe(t), s._bf3dVisibilityObserver = n;
}
function md(s) {
  if (Il.has(s) || s.dataset.bf3dInit === "true") return;
  s.dataset.bf3dInit = "true";
  const e = tS(s);
  if (nS()) {
    s.classList.add("is-static");
    return;
  }
  const t = eS(s, e);
  t && (Il.set(s, t), iS(s, t), document.querySelector(".product-information.bf-3d-media-active[data-bf-3d-hybrid-product]") && (t.resume(), t.setHotspotsVisible(!0)), s.addEventListener("bf3d:ready", () => {
    var n, i, r, a;
    if (t.resume(), document.querySelector("[data-bf-3d-hybrid-gallery]")) {
      const o = document.querySelector(".product-information[data-bf-3d-hybrid-product]"), l = o == null ? void 0 : o.classList.contains("bf-3d-media-active");
      t.setHotspotsVisible(l !== !1);
    } else
      t.setHotspotsVisible(!0);
    if (e.productFamily === "sink") {
      const o = (n = e.materialSlots) == null ? void 0 : n.sink, l = (o == null ? void 0 : o.presetGroup) === "metal";
      l ? t.setSlotPreset(
        "sink",
        e.defaultBasinFinish || o.defaultPreset || "brushed_steel"
      ) : t.setConfiguration(e.defaultColour || "white", e.defaultFinish || "glossy"), t.setSlotPreset("faucet", e.defaultFaucet || e.defaultHardware || "chrome"), t.setSlotPreset("countertop", e.defaultCountertop || "Light_Stone"), (e.defaultDrainCap || (i = e.materialSlots) != null && i.drainCap) && t.setSlotPreset(
        "drainCap",
        e.defaultDrainCap || ((r = e.materialSlots.drainCap) == null ? void 0 : r.defaultPreset) || (l ? "brushed_steel" : "chrome")
      );
      const c = e.defaultVisibility || {};
      t.setVisibilityGroup("vanity", c.vanity === !0 ? "on" : "off"), t.setVisibilityGroup(
        "faucetStyle",
        c.faucetStyle || (c.wallFaucet === !0 ? "wall" : "none")
      ), (c.drainType != null || (a = e.visibilityGroups) != null && a.drainType) && t.setVisibilityGroup("drainType", c.drainType || "cast"), t.setVisibilityGroup("tailPiece", c.tailPiece === !1 ? "off" : "on"), t.setVisibilityGroup("extra", "off");
    } else
      t.setConfiguration(e.defaultColour || "white", e.defaultFinish || "matte"), t.setSlotPreset("drainCap", e.defaultDrainCap || "chrome");
  }));
}
function sS() {
  document.querySelectorAll("[data-bf-3d-configurator]").forEach(md);
}
function mh() {
  document.querySelectorAll("[data-bf-3d-configurator]:not([data-bf3d-init])").forEach((s) => {
    md(s);
  });
}
function bn(s) {
  document.querySelectorAll("[data-bf-3d-configurator]").forEach((e) => {
    const t = Il.get(e);
    t && s(t, e);
  });
}
function rS(s, e) {
  bn((t) => t.setConfiguration(s, e));
}
function aS(s, e) {
  bn((t) => t.setSlotPreset(s, e));
}
function oS(s, e) {
  bn((t) => t.setVisibilityGroup(s, e));
}
function lS(s) {
  bn((e) => {
    var t;
    return (t = e.setVanityTransparency) == null ? void 0 : t.call(e, s);
  });
}
function cS(s) {
  bn((e) => {
    var t;
    return (t = e.syncTransparencyWithVanity) == null ? void 0 : t.call(e, s);
  });
}
function uS(s) {
  bn((e) => e.setCameraPreset(s));
}
function hS(s) {
  bn((e) => e.goToTourStep(s));
}
function dS() {
  bn((s) => s.nextTourStep());
}
function fS() {
  bn((s) => s.prevTourStep());
}
function pS() {
  bn((s) => s.pause());
}
function mS() {
  bn((s) => s.resume());
}
function gS(s) {
  bn((e) => {
    var t;
    return (t = e.setHotspotsVisible) == null ? void 0 : t.call(e, s);
  });
}
window.BadeloftConfigurator = {
  init: sS,
  setConfiguration: rS,
  setSlotPreset: aS,
  setVisibilityGroup: oS,
  setVanityTransparency: lS,
  syncTransparencyWithVanity: cS,
  setCameraPreset: uS,
  goToTourStep: hS,
  nextTourStep: dS,
  prevTourStep: fS,
  pause: pS,
  resume: mS,
  setHotspotsVisible: gS
};
document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", mh) : mh();
export {
  hS as goToTourStep,
  dS as nextTourStep,
  fS as prevTourStep,
  uS as setCameraPreset,
  rS as setConfiguration,
  aS as setSlotPreset,
  oS as setVisibilityGroup
};
